webpackJsonp([4],{

/***/ "+TPz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_mobile_Header__ = __webpack_require__("Ucjp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_mobile_Footer__ = __webpack_require__("SN8v");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



// import dateFormat from 'dateformat'

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'SuccessRequest',
  props: ['sample'],
  components: {
    HeaderVue: __WEBPACK_IMPORTED_MODULE_1__components_mobile_Header__["a" /* default */],
    FooterVue: __WEBPACK_IMPORTED_MODULE_2__components_mobile_Footer__["a" /* default */]
  },
  beforeCreate: function beforeCreate() {
    if (!this.$localStorage.get('loggedIn') || this.$localStorage.get('loggedIn') === null) {
      this.$router.push({ path: '/' });
    }
  },
  data: function data() {
    return {
      requestDetails: {},
      s3BucketUrl: '',
      appointmentDate: '',
      appointmentStartTime: '',
      appointmentEndTime: ''
    };
  },

  methods: {
    gomyResult: function gomyResult() {
      this.$router.push({ path: '/myresult' });
    },
    getRequestDetails: function getRequestDetails(requestId) {
      try {
        this.requestDetails = '';
        var data = {
          'requestId': requestId
        };
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(this.$GET('patient/getRequestById', data)).then(function (res) {
          this.requestDetails = {};
          if (res.response_code === 0) {
            this.requestDetails = res.response;
            this.s3BucketUrl = res.response.Lab.logo && res.response.Lab.logo.length > 0 ? this.$s3BucketUrl + res.response.Lab.logo : '';
            // if (res.response.appointmentDate) {
            //   var fromAppointment = (res.response.appointmentDate).split(' ')
            //   this.appointmentDate = res.response.appointmentDate ? dateFormat(fromAppointment[0]+'T'+fromAppointment[1], 'dd/mm/yyyy') : ''
            //   this.appointmentStartTime = res.response.appointmentDate ? dateFormat(fromAppointment[0]+'T'+fromAppointment[1], 'hh:MM') : ''
            // } else {
            //   this.appointmentDate = ''
            //   this.appointmentStartTime = ''
            // }

            // if (res.response.appointmentToDateTime) {
            //   var toAppointment = (res.response.appointmentToDateTime).split(' ')
            //   this.appointmentEndTime = res.response.appointmentToDateTime ? dateFormat(toAppointment[0] + 'T' + toAppointment[1], 'hh:MMtt') : ''
            // } else {
            //   this.appointmentEndTime = ''
            // }
            this.appointmentDate = '';
            this.appointmentStartTime = '';
            this.appointmentEndTime = '';
            if (res.response.appointmentDateDisp) {
              this.appointmentDate = res.response.appointmentDateDisp;
            }
            if (res.response.appointmentFromTime) {
              this.appointmentStartTime = res.response.appointmentFromTime;
            }
            if (res.response.appointmentToTime) {
              this.appointmentEndTime = res.response.appointmentToTime;
            }
            this.clearRequestSessions();
          }
          this.$hidePageLoading();
        }.bind(this)).catch(function (err) {
          console.log(err);
        });
      } catch (e) {
        console.log(e);
      }
    },
    clearRequestSessions: function clearRequestSessions() {
      this.$localStorage.remove('pincode');
      this.$localStorage.remove('location');
      this.$localStorage.remove('st');
      this.$localStorage.remove('sl');
      this.$localStorage.remove('ct');
      this.$localStorage.remove('sa');
      this.$localStorage.remove('sm');
      this.$localStorage.remove('cou');
    },
    goHome: function goHome() {
      this.$router.push({ path: '/' });
    }
  },
  created: function created() {
    if (global.successId > 0) {
      this.getRequestDetails(global.successId);
      if (location.hostname === 'labotist.com') {
        gtag('event', 'conversion', {
          'send_to': 'AW-820857956/RXvTCLWFt3sQ5Ji1hwM',
          'value': this.requestDetails.totalPaidCost,
          'currency': 'INR',
          'transaction_id': ''
        });
      } else if (location.hostname === 'stage.labotist.com') {
        gtag('event', 'conversion', {
          'send_to': 'AW-819702604/tIrbCLnhwXsQzNbuhgM',
          'value': this.requestDetails.totalPaidCost,
          'currency': 'INR',
          'transaction_id': ''
        });
        console.log(gtag);
      }
    } else {
      this.$router.push({ path: '/' });
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("DuR2")))

/***/ }),

/***/ "/+i8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 0:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "22mO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2WCr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2kof":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 4:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "4M1+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "4Vh3":
/***/ (function(module, exports) {

module.exports = {"modp1":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a63a3620ffffffffffffffff"},"modp2":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece65381ffffffffffffffff"},"modp5":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca237327ffffffffffffffff"},"modp14":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aacaa68ffffffffffffffff"},"modp15":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a93ad2caffffffffffffffff"},"modp16":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c934063199ffffffffffffffff"},"modp17":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c93402849236c3fab4d27c7026c1d4dcb2602646dec9751e763dba37bdf8ff9406ad9e530ee5db382f413001aeb06a53ed9027d831179727b0865a8918da3edbebcf9b14ed44ce6cbaced4bb1bdb7f1447e6cc254b332051512bd7af426fb8f401378cd2bf5983ca01c64b92ecf032ea15d1721d03f482d7ce6e74fef6d55e702f46980c82b5a84031900b1c9e59e7c97fbec7e8f323a97a7e36cc88be0f1d45b7ff585ac54bd407b22b4154aacc8f6d7ebf48e1d814cc5ed20f8037e0a79715eef29be32806a1d58bb7c5da76f550aa3d8a1fbff0eb19ccb1a313d55cda56c9ec2ef29632387fe8d76e3c0468043e8f663f4860ee12bf2d5b0b7474d6e694f91e6dcc4024ffffffffffffffff"},"modp18":{"gen":"02","prime":"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"}}

/***/ }),

/***/ "4gyR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 5:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "5MS7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 6:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "64pn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_web_Header__ = __webpack_require__("sSzK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_web_Footer__ = __webpack_require__("uTOX");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'SuccessRequest',
  props: ['sample'],
  components: {
    HeaderVue: __WEBPACK_IMPORTED_MODULE_1__components_web_Header__["a" /* default */],
    FooterVue: __WEBPACK_IMPORTED_MODULE_2__components_web_Footer__["a" /* default */]
  },
  beforeCreate: function beforeCreate() {
    if (!this.$localStorage.get('loggedIn') || this.$localStorage.get('loggedIn') === null) {
      this.$router.push({ path: '/' });
    }
  },
  data: function data() {
    return {
      requestDetails: {},
      s3BucketUrl: '',
      appointmentDate: '',
      appointmentStartTime: '',
      appointmentEndTime: ''
    };
  },

  methods: {
    getRequestDetails: function getRequestDetails(requestId) {
      try {
        this.requestDetails = {};
        var data = {
          'requestId': requestId
        };
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(this.$GET('patient/getRequestById', data)).then(function (res) {
          this.requestDetails = {};
          this.$hidePageLoading();
          if (res.response_code === 0) {
            this.requestDetails = res.response;
            this.s3BucketUrl = res.response.Lab.logo && res.response.Lab.logo.length > 0 ? this.$s3BucketUrl + res.response.Lab.logo : '';
            this.appointmentDate = '';
            this.appointmentStartTime = '';
            this.appointmentEndTime = '';
            if (res.response.appointmentDateDisp) {
              this.appointmentDate = res.response.appointmentDateDisp;
            }
            if (res.response.appointmentFromTime) {
              this.appointmentStartTime = res.response.appointmentFromTime;
            }
            if (res.response.appointmentToTime) {
              this.appointmentEndTime = res.response.appointmentToTime;
            }
            if (location.hostname === 'labotist.com') {
              gtag('event', 'conversion', {
                'send_to': 'AW-820857956/RXvTCLWFt3sQ5Ji1hwM',
                'value': this.requestDetails.totalPaidCost,
                'currency': 'INR',
                'transaction_id': this.requestDetails.paymentId
              });
            } else if (location.hostname === 'stage.labotist.com') {
              gtag('event', 'conversion', {
                'send_to': 'AW-819702604/tIrbCLnhwXsQzNbuhgM',
                'value': this.requestDetails.totalPaidCost,
                'currency': 'INR',
                'transaction_id': this.requestDetails.paymentId
              });
            }
            this.clearRequestSessions();
          }
        }.bind(this)).catch(function (err) {
          console.log(err);
        });
      } catch (e) {
        console.log(e);
      }
    },
    clearRequestSessions: function clearRequestSessions() {
      this.$localStorage.remove('pincode');
      this.$localStorage.remove('location');
      this.$localStorage.remove('st');
      this.$localStorage.remove('sl');
      this.$localStorage.remove('ct');
      this.$localStorage.remove('sa');
      this.$localStorage.remove('sm');
      this.$localStorage.remove('cou');
    },
    goHome: function goHome() {
      this.$router.push({ path: '/' });
    },
    getProfile: function getProfile() {
      try {
        if (this.$localStorage.get('loggedIn') && this.$localStorage.get('access_token') && this.$localStorage.get('access_token') !== null) {
          var data = {};
          __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(this.$GET('patient/getProfile', data)).then(function (res) {
            if (res.response_code === 0) {
              var userDetails = {
                'username': res.response.Patient.firstName + ' ' + res.response.Patient.lastName,
                'firstName': res.response.Patient.firstName,
                'lastName': res.response.Patient.lastName,
                'photo': res.response.Patient.photo,
                'dob': res.response.Patient.dob,
                'phone1': res.response.Patient.phone1,
                'phone2': res.response.Patient.phone2,
                'sex': res.response.Patient.sex,
                'email': res.response.email,
                'credits': res.response.Patient.creditPoint
              };
              this.$localStorage.set('profile', userDetails, 0);
            }
          }.bind(this)).catch(function (err) {
            console.error(err);
          });
        }
      } catch (e) {
        console.error('method:getProfile', e);
      }
    }
  },
  created: function created() {
    if (global.successId > 0) {
      this.getRequestDetails(global.successId);
    } else {
      this.$router.push({ path: '/' });
    }
    this.getProfile();
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("DuR2")))

/***/ }),

/***/ "6ZSt":
/***/ (function(module, exports) {

module.exports = {"aes-128-ecb":{"cipher":"AES","key":128,"iv":0,"mode":"ECB","type":"block"},"aes-192-ecb":{"cipher":"AES","key":192,"iv":0,"mode":"ECB","type":"block"},"aes-256-ecb":{"cipher":"AES","key":256,"iv":0,"mode":"ECB","type":"block"},"aes-128-cbc":{"cipher":"AES","key":128,"iv":16,"mode":"CBC","type":"block"},"aes-192-cbc":{"cipher":"AES","key":192,"iv":16,"mode":"CBC","type":"block"},"aes-256-cbc":{"cipher":"AES","key":256,"iv":16,"mode":"CBC","type":"block"},"aes128":{"cipher":"AES","key":128,"iv":16,"mode":"CBC","type":"block"},"aes192":{"cipher":"AES","key":192,"iv":16,"mode":"CBC","type":"block"},"aes256":{"cipher":"AES","key":256,"iv":16,"mode":"CBC","type":"block"},"aes-128-cfb":{"cipher":"AES","key":128,"iv":16,"mode":"CFB","type":"stream"},"aes-192-cfb":{"cipher":"AES","key":192,"iv":16,"mode":"CFB","type":"stream"},"aes-256-cfb":{"cipher":"AES","key":256,"iv":16,"mode":"CFB","type":"stream"},"aes-128-cfb8":{"cipher":"AES","key":128,"iv":16,"mode":"CFB8","type":"stream"},"aes-192-cfb8":{"cipher":"AES","key":192,"iv":16,"mode":"CFB8","type":"stream"},"aes-256-cfb8":{"cipher":"AES","key":256,"iv":16,"mode":"CFB8","type":"stream"},"aes-128-cfb1":{"cipher":"AES","key":128,"iv":16,"mode":"CFB1","type":"stream"},"aes-192-cfb1":{"cipher":"AES","key":192,"iv":16,"mode":"CFB1","type":"stream"},"aes-256-cfb1":{"cipher":"AES","key":256,"iv":16,"mode":"CFB1","type":"stream"},"aes-128-ofb":{"cipher":"AES","key":128,"iv":16,"mode":"OFB","type":"stream"},"aes-192-ofb":{"cipher":"AES","key":192,"iv":16,"mode":"OFB","type":"stream"},"aes-256-ofb":{"cipher":"AES","key":256,"iv":16,"mode":"OFB","type":"stream"},"aes-128-ctr":{"cipher":"AES","key":128,"iv":16,"mode":"CTR","type":"stream"},"aes-192-ctr":{"cipher":"AES","key":192,"iv":16,"mode":"CTR","type":"stream"},"aes-256-ctr":{"cipher":"AES","key":256,"iv":16,"mode":"CTR","type":"stream"},"aes-128-gcm":{"cipher":"AES","key":128,"iv":12,"mode":"GCM","type":"auth"},"aes-192-gcm":{"cipher":"AES","key":192,"iv":12,"mode":"GCM","type":"auth"},"aes-256-gcm":{"cipher":"AES","key":256,"iv":12,"mode":"GCM","type":"auth"}}

/***/ }),

/***/ 7:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "7Qwb":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7hJy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 8:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "8Fyf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8YCc":
/***/ (function(module, exports) {

module.exports = {"2.16.840.1.101.3.4.1.1":"aes-128-ecb","2.16.840.1.101.3.4.1.2":"aes-128-cbc","2.16.840.1.101.3.4.1.3":"aes-128-ofb","2.16.840.1.101.3.4.1.4":"aes-128-cfb","2.16.840.1.101.3.4.1.21":"aes-192-ecb","2.16.840.1.101.3.4.1.22":"aes-192-cbc","2.16.840.1.101.3.4.1.23":"aes-192-ofb","2.16.840.1.101.3.4.1.24":"aes-192-cfb","2.16.840.1.101.3.4.1.41":"aes-256-ecb","2.16.840.1.101.3.4.1.42":"aes-256-cbc","2.16.840.1.101.3.4.1.43":"aes-256-ofb","2.16.840.1.101.3.4.1.44":"aes-256-cfb"}

/***/ }),

/***/ 9:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "AYSK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_qs__ = __webpack_require__("mw3O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_qs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_base_64__ = __webpack_require__("RYeZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_base_64___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_base_64__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_utf8__ = __webpack_require__("0MZO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_utf8___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_utf8__);








__WEBPACK_IMPORTED_MODULE_2_vue__["default"].prototype.$hidePageLoading = function () {
  // alert(3)
  setTimeout(function () {
    $('.loading').hide('slow');
    $('.loading-img').hide('slow');
    $('body').css({
      'overflow': 'visible'
    });
  }, 300);
};

__WEBPACK_IMPORTED_MODULE_2_vue__["default"].prototype.$showPageLoading = function () {
  // alert(3)
  setTimeout(function () {
    $('.loading').show('slow');
    $('.loading-img').show('slow');
    $('body').css({
      'overflow': 'visible'
    });
  }, 300);
};

__WEBPACK_IMPORTED_MODULE_2_vue__["default"].prototype.$clearLocalStorage = function () {
  try {
    // this.$localStorage.remove('sl')
    // this.$localStorage.set('st', this.selectedProfileAndTest)
    // this.$localStorage.get('get')
    // this.$localStorage.set('sl', lab, 30 * 60 * 1000)

    this.$localStorage.remove('access_token');
    // this.$localStorage.remove('refresh_token')
    this.$localStorage.remove('token_type');
    this.$localStorage.remove('expires_in');
    this.$localStorage.remove('scope');
    this.$localStorage.remove('loggedIn');
    this.$localStorage.remove('userid');
    this.$localStorage.remove('email');
    this.$localStorage.remove('profile');
  } catch (e) {
    console.error(e);
  }
};

__WEBPACK_IMPORTED_MODULE_2_vue__["default"].prototype.$clearLocalStorageForLogout = function () {
  try {
    this.$localStorage.remove('access_token');
    this.$localStorage.remove('refresh_token');
    this.$localStorage.remove('token_type');
    this.$localStorage.remove('expires_in');
    this.$localStorage.remove('scope');
    this.$localStorage.remove('loggedIn');
    this.$localStorage.remove('userid');
    this.$localStorage.remove('email');
    this.$localStorage.remove('profile');
    this.$localStorage.remove('st');
    this.$localStorage.remove('sl');
    this.$localStorage.remove('ct');
    this.$localStorage.remove('sa');
    this.$localStorage.remove('sm');
    this.$localStorage.remove('cou');
    this.$clientTokenForLogout();
  } catch (e) {
    console.error(e);
  }
};

global.ClearTimeout = undefined;
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].prototype.$clientToken = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;

          if (!this.$localStorage.get('refresh_token')) {
            _context.next = 5;
            break;
          }

          return _context.abrupt('return', this.$refreshToken());

        case 5:
          return _context.abrupt('return', this.$clientCredentialToken());

        case 6:
          _context.next = 11;
          break;

        case 8:
          _context.prev = 8;
          _context.t0 = _context['catch'](0);

          console.error(_context.t0);

        case 11:
        case 'end':
          return _context.stop();
      }
    }
  }, _callee, this, [[0, 8]]);
}));

__WEBPACK_IMPORTED_MODULE_2_vue__["default"].prototype.$clientCredentialToken = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
  var _this = this;

  var params, text, bytes, encoded, headers;
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.prev = 0;
          params = {
            'grant_type': 'client_credentials'
          };
          text = 'user:user';
          bytes = Object(__WEBPACK_IMPORTED_MODULE_6_utf8__["encode"])(text);
          encoded = Object(__WEBPACK_IMPORTED_MODULE_5_base_64__["encode"])(bytes);
          headers = {
            headers: {
              'Authorization': 'Basic ' + encoded,
              'Content-Type': 'application/x-www-form-urlencoded'
            }
          };
          _context2.next = 8;
          return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(this.$apiUrl + 'oauth/token', __WEBPACK_IMPORTED_MODULE_4_qs___default.a.stringify(params), headers).then(function (resp) {
            if (!resp.data.error) {
              // this.$clearLocalStorage()
              _this.$localStorage.set('access_token', resp.data.access_token, resp.data.expires_in * 1000);
              _this.$localStorage.set('token_type', resp.data.token_type, resp.data.expires_in * 1000);
              _this.$localStorage.set('expires_in', resp.data.expires_in, resp.data.expires_in * 1000);
              _this.$localStorage.set('loggedIn', false, resp.data.expires_in * 1000);
              _this.$localStorage.remove('userid');
              _this.$localStorage.remove('email');
              _this.$localStorage.remove('refresh_token');
              _this.$localStorage.remove('scope');
              _this.$localStorage.remove('profile');

              console.log('ct');
              if (global.ClearTimeout) {
                clearTimeout(global.ClearTimeout);
              }
              global.ClearTimeout = setTimeout(function () {
                this.$clientCredentialToken();
              }.bind(_this), (resp.data.expires_in - 60 * 60) * 1000);
              return false;
            } else {
              _this.$clientCredentialToken();
            }
          }).catch(function (e) {
            console.log(e);
            return {
              error: e
            };
          });

        case 8:
          return _context2.abrupt('return', _context2.sent);

        case 11:
          _context2.prev = 11;
          _context2.t0 = _context2['catch'](0);

          console.error(_context2.t0);

        case 14:
        case 'end':
          return _context2.stop();
      }
    }
  }, _callee2, this, [[0, 11]]);
}));

__WEBPACK_IMPORTED_MODULE_2_vue__["default"].prototype.$clientTokenForLogout = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
  var _this2 = this;

  var params, text, bytes, encoded, headers;
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.prev = 0;

          if (!(this.$localStorage.get('access_token') === null)) {
            _context3.next = 10;
            break;
          }

          params = {
            'grant_type': 'client_credentials'
          };
          text = 'user:user';
          bytes = Object(__WEBPACK_IMPORTED_MODULE_6_utf8__["encode"])(text);
          encoded = Object(__WEBPACK_IMPORTED_MODULE_5_base_64__["encode"])(bytes);
          headers = {
            headers: {
              'Authorization': 'Basic ' + encoded,
              'Content-Type': 'application/x-www-form-urlencoded'
            }
          };
          _context3.next = 9;
          return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(this.$apiUrl + 'oauth/token', __WEBPACK_IMPORTED_MODULE_4_qs___default.a.stringify(params), headers).then(function (response) {
            if (!response.data.error) {
              _this2.$localStorage.set('access_token', response.data.access_token, response.data.expires_in * 1000);
              _this2.$router.push('/');
            }
          }).catch(function (e) {
            console.log(e);
            return {
              error: e
            };
          });

        case 9:
          return _context3.abrupt('return', _context3.sent);

        case 10:
          _context3.next = 15;
          break;

        case 12:
          _context3.prev = 12;
          _context3.t0 = _context3['catch'](0);

          console.error(_context3.t0);

        case 15:
        case 'end':
          return _context3.stop();
      }
    }
  }, _callee3, this, [[0, 12]]);
}));

__WEBPACK_IMPORTED_MODULE_2_vue__["default"].prototype.$logon = function () {
  var _ref4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(username, password) {
    var _this3 = this;

    var params, text, bytes, encoded, headers;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.prev = 0;
            params = {
              'grant_type': 'password',
              'username': username,
              'password': password
            };
            text = 'patient:patient';
            bytes = Object(__WEBPACK_IMPORTED_MODULE_6_utf8__["encode"])(text);
            encoded = Object(__WEBPACK_IMPORTED_MODULE_5_base_64__["encode"])(bytes);
            headers = {
              headers: {
                'Authorization': 'Basic ' + encoded,
                'Content-Type': 'application/x-www-form-urlencoded'
              }
            };
            _context4.next = 8;
            return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(this.$apiUrl + 'oauth/token', __WEBPACK_IMPORTED_MODULE_4_qs___default.a.stringify(params), headers).then(function (resp) {
              if (!resp.data.error) {
                // this.$clearLocalStorage()
                _this3.$localStorage.set('access_token', resp.data.access_token, resp.data.expires_in * 1000);
                _this3.$localStorage.set('refresh_token', resp.data.refresh_token);
                _this3.$localStorage.set('token_type', resp.data.token_type, resp.data.expires_in * 1000);
                _this3.$localStorage.set('expires_in', resp.data.expires_in, resp.data.expires_in * 1000);
                _this3.$localStorage.set('scope', resp.data.scope, resp.data.expires_in * 1000);
                _this3.$localStorage.set('loggedIn', true, resp.data.expires_in * 1000);
                _this3.$localStorage.set('userid', resp.data.user.userId, resp.data.expires_in * 1000);
                _this3.$localStorage.set('email', resp.data.user.email, resp.data.expires_in * 1000);

                console.log('at');
                if (global.ClearTimeout) {
                  clearTimeout(global.ClearTimeout);
                }
                global.ClearTimeout = setTimeout(function () {
                  this.$refreshToken();
                }.bind(_this3), (resp.data.expires_in - 60 * 60) * 1000);
                return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(_this3.$apiUrl + 'patient/getProfile', {
                  headers: {
                    'Authorization': 'Bearer ' + resp.data.access_token,
                    'Content-type': 'application/json'
                  }
                }).then(function (response) {
                  if (response.data.response_code === 0) {
                    var result = response.data.response;
                    var userDetails = {
                      'username': result.Patient.firstName + ' ' + result.Patient.lastName,
                      'firstName': result.Patient.firstName,
                      'lastName': result.Patient.lastName,
                      'photo': result.Patient.photo,
                      'dob': result.Patient.dob,
                      'phone1': result.Patient.phone1,
                      'phone2': result.Patient.phone2,
                      'sex': result.Patient.sex,
                      'email': result.email,
                      'credits': result.Patient.creditPoint
                    };
                    _this3.$localStorage.set('profile', userDetails, 0);
                    return {
                      msg: 'success',
                      data: resp.data.user
                    };
                  } else {
                    console.log(response.data.response_message);
                    return {
                      error: response.data.response_message
                    };
                  }
                }).catch(function (e) {
                  console.log(e);
                  return {
                    error: e
                  };
                });
              } else {
                return {
                  error: 'Wrong Username/Password combination'
                };
              }
            }).catch(function (e) {
              console.log(e);
              return {
                error: 'Wrong Username/Password combination'
              };
            });

          case 8:
            return _context4.abrupt('return', _context4.sent);

          case 11:
            _context4.prev = 11;
            _context4.t0 = _context4['catch'](0);

            console.error(_context4.t0);

          case 14:
          case 'end':
            return _context4.stop();
        }
      }
    }, _callee4, this, [[0, 11]]);
  }));

  return function (_x, _x2) {
    return _ref4.apply(this, arguments);
  };
}();

__WEBPACK_IMPORTED_MODULE_2_vue__["default"].prototype.$refreshToken = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
  var _this4 = this;

  var params, text, bytes, encoded, headers;
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          _context5.prev = 0;
          params = {
            'grant_type': 'refresh_token',
            'refresh_token': this.$localStorage.get('refresh_token')
          };
          text = 'patient:patient';
          bytes = Object(__WEBPACK_IMPORTED_MODULE_6_utf8__["encode"])(text);
          encoded = Object(__WEBPACK_IMPORTED_MODULE_5_base_64__["encode"])(bytes);
          headers = {
            headers: {
              'Authorization': 'Basic ' + encoded,
              'Content-Type': 'application/x-www-form-urlencoded'
            }
          };
          _context5.next = 8;
          return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(this.$apiUrl + 'oauth/token', __WEBPACK_IMPORTED_MODULE_4_qs___default.a.stringify(params), headers).then(function (resp) {
            if (!resp.data.error) {
              _this4.$clearLocalStorage();
              _this4.$localStorage.set('access_token', resp.data.access_token, resp.data.expires_in * 1000);
              _this4.$localStorage.set('refresh_token', resp.data.refresh_token);
              _this4.$localStorage.set('token_type', resp.data.token_type, resp.data.expires_in * 1000);
              _this4.$localStorage.set('expires_in', resp.data.expires_in, resp.data.expires_in * 1000);
              _this4.$localStorage.set('scope', resp.data.scope, resp.data.expires_in * 1000);
              _this4.$localStorage.set('loggedIn', true, resp.data.expires_in * 1000);
              _this4.$localStorage.set('userid', resp.data.user.userId, resp.data.expires_in * 1000);
              _this4.$localStorage.set('email', resp.data.user.email, resp.data.expires_in * 1000);
              if (global.ClearTimeout) {
                clearTimeout(global.ClearTimeout);
              }
              console.log('rt');
              global.ClearTimeout = setTimeout(function () {
                this.$refreshToken();
              }.bind(_this4), (resp.data.expires_in - 60 * 60) * 1000);
              return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(_this4.$apiUrl + 'patient/getProfile', {
                headers: {
                  'Authorization': 'Bearer ' + resp.data.access_token,
                  'Content-type': 'application/json'
                }
              }).then(function (response) {
                if (response.data.response_code === 0) {
                  var result = response.data.response;
                  var userDetails = {
                    'username': result.Patient.firstName + ' ' + result.Patient.lastName,
                    'firstName': result.Patient.firstName,
                    'lastName': result.Patient.lastName,
                    'photo': result.Patient.photo,
                    'dob': result.Patient.dob,
                    'phone1': result.Patient.phone1,
                    'phone2': result.Patient.phone2,
                    'sex': result.Patient.sex,
                    'email': result.email,
                    'credits': result.Patient.creditPoint
                  };
                  _this4.$localStorage.set('profile', userDetails, resp.data.expires_in * 1000);
                  return {
                    msg: 'success'
                  };
                } else {
                  console.log(response.data.response_message);
                  return {
                    error: response.data.response_message
                  };
                }
              }).catch(function (e) {
                console.log(e);
                return {
                  error: e
                };
              });
            } else {
              _this4.$clearLocalStorage();
              return _this4.$clientCredentialToken();
              // return {
              //   error: resp.data.error
              // }
            }
          }).catch(function (e) {
            console.log(e);
            _this4.$clearLocalStorage();
            return _this4.$clientCredentialToken();
          });

        case 8:
          return _context5.abrupt('return', _context5.sent);

        case 11:
          _context5.prev = 11;
          _context5.t0 = _context5['catch'](0);

          this.$clearLocalStorage();
          return _context5.abrupt('return', this.$clientCredentialToken());

        case 15:
        case 'end':
          return _context5.stop();
      }
    }
  }, _callee5, this, [[0, 11]]);
}));

__WEBPACK_IMPORTED_MODULE_2_vue__["default"].prototype.$verifyOTP = function () {
  var _ref6 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6(username, otp) {
    var _this5 = this;

    var params, headers;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            _context6.prev = 0;
            params = {
              'username': username,
              'otp': otp
            };
            headers = {
              headers: {
                'Authorization': 'Bearer ' + this.$localStorage.get('access_token'),
                'Content-Type': 'application/x-www-form-urlencoded'
              }
            };
            _context6.next = 5;
            return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(this.$apiUrl + 'patient/verifyOTP', __WEBPACK_IMPORTED_MODULE_4_qs___default.a.stringify(params), headers).then(function (resp) {
              if (!resp.data.error) {
                _this5.$clearLocalStorage();
                _this5.$localStorage.set('access_token', resp.data.access_token, resp.data.expires_in * 1000);
                _this5.$localStorage.set('refresh_token', resp.data.refresh_token);
                _this5.$localStorage.set('token_type', resp.data.token_type, resp.data.expires_in * 1000);
                _this5.$localStorage.set('expires_in', resp.data.expires_in, resp.data.expires_in * 1000);
                _this5.$localStorage.set('scope', resp.data.scope, resp.data.expires_in * 1000);
                _this5.$localStorage.set('loggedIn', true, resp.data.expires_in * 1000);
                _this5.$localStorage.set('userid', resp.data.user.userId, resp.data.expires_in * 1000);
                _this5.$localStorage.set('email', resp.data.user.email, resp.data.expires_in * 1000);

                console.log('vt');
                if (global.ClearTimeout) {
                  clearTimeout(global.ClearTimeout);
                }
                global.ClearTimeout = setTimeout(function () {
                  this.$refreshToken();
                }.bind(_this5), (resp.data.expires_in - 60 * 60) * 1000);

                return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(_this5.$apiUrl + 'patient/getProfile', {
                  headers: {
                    'Authorization': 'Bearer ' + resp.data.access_token,
                    'Content-type': 'application/json'
                  }
                }).then(function (response) {
                  if (response.data.response_code === 0) {
                    var result = response.data.response;
                    var userDetails = {
                      'username': result.Patient.firstName + ' ' + result.Patient.lastName,
                      'firstName': result.Patient.firstName,
                      'lastName': result.Patient.lastName,
                      'photo': result.Patient.photo,
                      'dob': result.Patient.dob,
                      'phone1': result.Patient.phone1,
                      'phone2': result.Patient.phone2,
                      'sex': result.Patient.sex,
                      'email': result.email,
                      'credits': result.Patient.creditPoint
                    };
                    _this5.$localStorage.set('profile', userDetails, 0);
                    return {
                      msg: 'success'
                    };
                  } else {
                    console.log(response.data.response_message);
                    return {
                      error: response.data.response_message
                    };
                  }
                }).catch(function (e) {
                  console.log(e);
                  return {
                    error: e
                  };
                });
              } else {}
              return {
                'error': response.data.error
              };
            }).catch(function (e) {
              console.log(e);
              return { error: 'Wrong Email/Password combination' };
            });

          case 5:
            return _context6.abrupt('return', _context6.sent);

          case 8:
            _context6.prev = 8;
            _context6.t0 = _context6['catch'](0);

            console.error(_context6.t0);

          case 11:
          case 'end':
            return _context6.stop();
        }
      }
    }, _callee6, this, [[0, 8]]);
  }));

  return function (_x3, _x4) {
    return _ref6.apply(this, arguments);
  };
}();

__WEBPACK_IMPORTED_MODULE_2_vue__["default"].prototype.$verifyLoginOTP = function () {
  var _ref7 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7(username, otp) {
    var _this6 = this;

    var params, headers;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            _context7.prev = 0;
            params = {
              'username': username,
              'otp': otp
            };
            headers = {
              headers: {
                'Authorization': 'Bearer ' + this.$localStorage.get('access_token'),
                'Content-Type': 'application/x-www-form-urlencoded'
              }
            };
            _context7.next = 5;
            return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(this.$apiUrl + 'patient/verifyLoginOTP', __WEBPACK_IMPORTED_MODULE_4_qs___default.a.stringify(params), headers).then(function (resp) {
              if (!resp.data.error) {
                _this6.$clearLocalStorage();
                _this6.$localStorage.set('access_token', resp.data.access_token, resp.data.expires_in * 1000);
                _this6.$localStorage.set('refresh_token', resp.data.refresh_token);
                _this6.$localStorage.set('token_type', resp.data.token_type, resp.data.expires_in * 1000);
                _this6.$localStorage.set('expires_in', resp.data.expires_in, resp.data.expires_in * 1000);
                _this6.$localStorage.set('scope', resp.data.scope, resp.data.expires_in * 1000);
                _this6.$localStorage.set('loggedIn', true, resp.data.expires_in * 1000);
                _this6.$localStorage.set('userid', resp.data.user.userId, resp.data.expires_in * 1000);
                _this6.$localStorage.set('email', resp.data.user.email, resp.data.expires_in * 1000);

                console.log('vt');
                if (global.ClearTimeout) {
                  clearTimeout(global.ClearTimeout);
                }
                global.ClearTimeout = setTimeout(function () {
                  this.$refreshToken();
                }.bind(_this6), (resp.data.expires_in - 60 * 60) * 1000);

                return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(_this6.$apiUrl + 'patient/getProfile', {
                  headers: {
                    'Authorization': 'Bearer ' + resp.data.access_token,
                    'Content-type': 'application/json'
                  }
                }).then(function (response) {
                  if (response.data.response_code === 0) {
                    var result = response.data.response;
                    var userDetails = {
                      'username': result.Patient.firstName + ' ' + result.Patient.lastName,
                      'firstName': result.Patient.firstName,
                      'lastName': result.Patient.lastName,
                      'photo': result.Patient.photo,
                      'dob': result.Patient.dob,
                      'phone1': result.Patient.phone1,
                      'phone2': result.Patient.phone2,
                      'sex': result.Patient.sex,
                      'email': result.email,
                      'credits': result.Patient.creditPoint
                    };
                    _this6.$localStorage.set('profile', userDetails, 0);
                    return {
                      msg: 'success'
                    };
                  } else {
                    console.log(response.data.response_message);
                    return {
                      error: response.data.response_message
                    };
                  }
                }).catch(function (e) {
                  console.log(e);
                  return {
                    error: e
                  };
                });
              } else {}
              return {
                'error': response.data.error
              };
            }).catch(function (e) {
              console.log(e);
              return { error: 'Wrong Email/Password combination' };
            });

          case 5:
            return _context7.abrupt('return', _context7.sent);

          case 8:
            _context7.prev = 8;
            _context7.t0 = _context7['catch'](0);

            console.error(_context7.t0);

          case 11:
          case 'end':
            return _context7.stop();
        }
      }
    }, _callee7, this, [[0, 8]]);
  }));

  return function (_x5, _x6) {
    return _ref7.apply(this, arguments);
  };
}();

__WEBPACK_IMPORTED_MODULE_2_vue__["default"].prototype.$resetPassword = function () {
  var _ref8 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8(password) {
    var params, headers;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            _context8.prev = 0;
            params = {
              'password': password
            };
            headers = {
              headers: {
                'Authorization': 'Bearer ' + this.$localStorage.get('access_token'),
                'Content-Type': 'application/x-www-form-urlencoded'
              }
            };
            _context8.next = 5;
            return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(this.$apiUrl + 'patient/resetPassword', __WEBPACK_IMPORTED_MODULE_4_qs___default.a.stringify(params), headers).then(function (response) {
              if (!response.data.error) {
                return {
                  msg: 'success'
                };
              }
              return {
                'error': response.data.error
              };
            }).catch(function (e) {
              return {
                error: 'Wrong Email/Password combination'
              };
            });

          case 5:
            return _context8.abrupt('return', _context8.sent);

          case 8:
            _context8.prev = 8;
            _context8.t0 = _context8['catch'](0);

            console.error(_context8.t0);

          case 11:
          case 'end':
            return _context8.stop();
        }
      }
    }, _callee8, this, [[0, 8]]);
  }));

  return function (_x7) {
    return _ref8.apply(this, arguments);
  };
}();

__WEBPACK_IMPORTED_MODULE_2_vue__["default"].prototype.$GET = function () {
  var _ref9 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee9(url, params) {
    var _this7 = this;

    var data;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            _context9.prev = 0;
            data = {
              params: params,
              headers: {
                'Authorization': 'Bearer ' + this.$localStorage.get('access_token'),
                'Content-type': 'application/json'
              }
            };
            _context9.next = 4;
            return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(this.$apiUrl + url, data).then(function (response) {
              var results = [];
              if (response.data.error === undefined) {
                results = response.data;
              }
              return results;
            }).catch(function (e) {
              if (e.response.data.statusCode == 401) {
                return _this7.$clientToken().then(function (token) {
                  return _this7.$GET(url, params);
                });
              } else {
                return false;
              }
            });

          case 4:
            return _context9.abrupt('return', _context9.sent);

          case 7:
            _context9.prev = 7;
            _context9.t0 = _context9['catch'](0);

            console.error(_context9.t0);

          case 10:
          case 'end':
            return _context9.stop();
        }
      }
    }, _callee9, this, [[0, 7]]);
  }));

  return function (_x8, _x9) {
    return _ref9.apply(this, arguments);
  };
}();

__WEBPACK_IMPORTED_MODULE_2_vue__["default"].prototype.$POST = function () {
  var _ref10 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee10(url, params) {
    var _this8 = this;

    var headers;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            _context10.prev = 0;
            headers = {
              headers: {
                'Authorization': 'Bearer ' + this.$localStorage.get('access_token'),
                'Content-type': 'application/json'
              }
            };
            _context10.next = 4;
            return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(this.$apiUrl + url, params, headers).then(function (response) {
              var results = [];
              if (!response.data.error) {
                results = response.data;
              }
              return results;
            }).catch(function (e) {
              if (e.response.data.statusCode == 401) {
                return _this8.$clientToken().then(function (token) {
                  return _this8.$POST(url, params);
                });
              } else {
                return false;
              }
            });

          case 4:
            return _context10.abrupt('return', _context10.sent);

          case 7:
            _context10.prev = 7;
            _context10.t0 = _context10['catch'](0);

            console.error(_context10.t0);

          case 10:
          case 'end':
            return _context10.stop();
        }
      }
    }, _callee10, this, [[0, 7]]);
  }));

  return function (_x10, _x11) {
    return _ref10.apply(this, arguments);
  };
}();

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Webservice'
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("DuR2")))

/***/ }),

/***/ "BZbz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "CV2+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "EEKS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Ea5o":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ElPk":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "I5/F":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "KYqO":
/***/ (function(module, exports) {

module.exports = {"name":"elliptic","version":"6.6.1","description":"EC cryptography","main":"lib/elliptic.js","files":["lib"],"scripts":{"lint":"eslint lib test","lint:fix":"npm run lint -- --fix","unit":"istanbul test _mocha --reporter=spec test/index.js","test":"npm run lint && npm run unit","version":"grunt dist && git add dist/"},"repository":{"type":"git","url":"git@github.com:indutny/elliptic"},"keywords":["EC","Elliptic","curve","Cryptography"],"author":"Fedor Indutny <fedor@indutny.com>","license":"MIT","bugs":{"url":"https://github.com/indutny/elliptic/issues"},"homepage":"https://github.com/indutny/elliptic","devDependencies":{"brfs":"^2.0.2","coveralls":"^3.1.0","eslint":"^7.6.0","grunt":"^1.2.1","grunt-browserify":"^5.3.0","grunt-cli":"^1.3.2","grunt-contrib-connect":"^3.0.0","grunt-contrib-copy":"^1.0.0","grunt-contrib-uglify":"^5.0.0","grunt-mocha-istanbul":"^5.0.2","grunt-saucelabs":"^9.0.1","istanbul":"^0.4.5","mocha":"^8.0.1"},"dependencies":{"bn.js":"^4.11.9","brorand":"^1.1.0","hash.js":"^1.0.0","hmac-drbg":"^1.0.1","inherits":"^2.0.4","minimalistic-assert":"^1.0.1","minimalistic-crypto-utils":"^1.0.1"}}

/***/ }),

/***/ "Kqai":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_mobile_Header__ = __webpack_require__("Ucjp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_mobile_Footer__ = __webpack_require__("SN8v");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_underscore__ = __webpack_require__("rdLu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_underscore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_underscore__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_dateformat__ = __webpack_require__("CqLJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_dateformat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_dateformat__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuejs_datepicker__ = __webpack_require__("XILU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuejs_datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vuejs_datepicker__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







__webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, "UnxO"));
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'SelectAddress',
  beforeCreate: function beforeCreate() {
    if (!this.$localStorage.get('loggedIn') || this.$localStorage.get('loggedIn') === null) {
      this.$router.push({ path: '/' });
    }
    if (!this.$localStorage.get('location') || !this.$localStorage.get('st')) {
      this.$router.push({ path: '/lab' });
    } else if (!this.$localStorage.get('sl')) {
      this.$router.push({ path: '/lab' });
    } else if (!this.$localStorage.get('ct')) {
      this.$router.push({ path: '/appointment' });
    } else if (!this.$localStorage.get('sa')) {
      this.$router.push({ path: '/address' });
    } else if (!this.$localStorage.get('sm')) {
      this.$router.push({ path: '/address' });
    }
    if (this.$localStorage.get('cou')) {
      this.$localStorage.remove('cou');
    }
  },

  components: {
    HeaderVue: __WEBPACK_IMPORTED_MODULE_2__components_mobile_Header__["a" /* default */],
    FooterVue: __WEBPACK_IMPORTED_MODULE_3__components_mobile_Footer__["a" /* default */],
    Datepicker: __WEBPACK_IMPORTED_MODULE_6_vuejs_datepicker___default.a
  },
  data: function data() {
    return {
      selectedLab: [],
      selectedProfileAndTest: [],
      activeAddress: [],
      activeMembers: [],
      testCosts: {},
      payinfo: [],
      addresses: {},
      members: {},
      isAddressActiveId: 0,
      isMemberActiveId: 0,
      isMe: true,
      addMemberForm: false,
      editMemberForm: false,
      addMemberFields: {
        firstName: '',
        lastName: '',
        sex: 'M',
        age: ''
      },
      editMemberFields: {},
      addAddressForm: false,
      editAddressForm: false,
      locationList: [],
      addAddressFields: {},
      editAddressFields: {},
      stateCityDisp: '',
      showLocOther: false,
      couponCode: '',
      couponData: undefined,
      couponError: '',
      isSuccessCoupon: false,
      profileDetails: [],
      map: undefined,
      marker: undefined,
      mapCoordinates: undefined,
      editMemberObj: {
        firstName: '',
        lastName: '',
        email: '',
        phone1: '',
        phone2: '',
        dob: undefined,
        sex: '',
        photo: '',
        address: {},
        disabled: {
          from: new Date()
        }
      },
      isDobError: false,
      dobYears: [],
      dobDate: [],
      year: '',
      month: '',
      ddate: '',
      addressZipCode: '',
      isInvalidPincode: false,
      onBlurKey: 'none',
      isCouponApplied: false,
      selectedLocality: undefined,
      isPage: true,
      isAddAddressPage: false,
      isEditAddressPage: false
    };
  },

  methods: {
    toogleAddress: function toogleAddress(type) {
      if (type === 1) {
        this.isPage = true;
        this.isAddAddressPage = false;
        this.isEditAddressPage = false;
        $("body").css("overflow", "visible");
        // $('body').
      } else if (type === 2) {
        this.isPage = false;
        this.isAddAddressPage = true;
        this.isEditAddressPage = false;
      } else if (type === 3) {
        this.isPage = false;
        this.isAddAddressPage = false;
        this.isEditAddressPage = true;
      } else {
        this.isPage = true;
        this.isAddAddressPage = false;
        this.isEditAddressPage = false;
      }
    },
    closeLocalityPopup: function closeLocalityPopup() {
      this.onBlurKey = false;
      if (this.isAddAddressPage) {
        if (this.addAddressFields.locality && this.addAddressFields.locality !== 'OTHER') {
          this.addAddressFields.zipcode = this.addAddressFields.locality ? this.addAddressFields.locality.locationName + '-' + this.addAddressFields.locality.locationZipCode : '';
        }
        $('#popupAddLocality').modal("hide");
        setTimeout(function () {
          this.$refs.newPincodeAdd.focus();
        }.bind(this), 300);
      } else if (this.isEditAddressPage) {
        if (this.editAddressFields.locality && this.editAddressFields.locality !== 'OTHER') {
          this.editAddressFields.zipcode = this.editAddressFields.locality ? this.editAddressFields.locality.locationName + '-' + this.editAddressFields.locality.locationZipCode : '';
        }
        $('#popupEditLocality').modal("hide");
        setTimeout(function () {
          this.$refs.newPincodeEdit.focus();
        }.bind(this), 300);
      }
    },
    onFocusLocality: function onFocusLocality() {
      if (this.isAddAddressPage) {
        $('#popupAddLocality').modal("show");
        this.addAddressFields.zipcode = '';
        this.showHideLocation(1);
        setTimeout(function () {
          this.$refs.pincodeAdd.focus();
          // this.$refs.pincodeAdd.select()
        }.bind(this), 1000);
      } else if (this.isEditAddressPage) {
        $('#popupEditLocality').modal("show");
        this.editAddressFields.zipcode = '';
        this.showHideLocation(2);
        setTimeout(function () {
          this.$refs.pincodeEdit.focus();
        }.bind(this), 1000);
      }
      this.onBlurKey = true;
    },
    showHideLocation: function showHideLocation(type) {
      var query = '';
      if (type === 1) {
        query = this.addAddressFields.zipcode;
      } else if (type === 2) {
        query = this.editAddressFields.zipcode;
      }
      this.onBlurKey = true;
      if (query.length === 0) {
        this.locationList = this.$localStorage.get('sc').ActiveLocation;
      } else {
        var locationFilter = this.$localStorage.get('sc').ActiveLocation.filter(function (locationVal) {
          var locality = locationVal.locationName;
          // let city = locationVal.City ? locationVal.City.cityName : locationVal.City
          if (!locality) return false;
          locality = locality.toLowerCase();
          return locality.includes(query.toLowerCase());
        }.bind(this));
        // if(locationFilter.length === 0) return false
        this.locationList = locationFilter;
      }
    },
    goBackPopup: function goBackPopup() {
      if (this.isPage) {
        this.$router.push({ path: '/appointment' });
      } else {
        this.toogleAddress(1);
      }
    },
    getNumberOfDays: function getNumberOfDays(dateVal) {
      if (this.year && this.year !== '' && this.month && this.month !== '') {
        var noOfDays = new Date(this.year, this.month, 0).getDate();
        this.dobDate = [];
        for (var j = 1; j <= noOfDays; j++) {
          this.dobDate.push(j.toString());
        }
        if (dateVal) {
          this.ddate = dateVal;
        } else {
          if (this.ddate) {
            var res = true;
            this.dobDate.forEach(function (dataV) {
              if (parseInt(dataV) === parseInt(this.ddate)) {
                res = false;
              }
            }.bind(this));
            if (res) {
              this.ddate = '';
            }
          }
        }
      }
      return false;
    },
    goPayment: function goPayment() {
      if (!this.$localStorage.get('st')) {
        this.$Simplert.open({
          title: 'Alert',
          message: 'Please select a test or profile',
          type: 'warning',
          disableOverlayClick: true,
          showXclose: true,
          useConfirmBtn: false,
          customCloseBtnText: 'OK'
        });
        // alert('Please select a test or profile')
        return false;
      } else if (!this.$localStorage.get('sl')) {
        this.$Simplert.open({
          title: 'Alert',
          message: 'Please select a lab',
          type: 'warning',
          disableOverlayClick: true,
          showXclose: true,
          useConfirmBtn: false,
          customCloseBtnText: 'OK'
        });
        // alert('Please select a lab')
        return false;
      } else if (!this.$localStorage.get('ct')) {
        this.$Simplert.open({
          title: 'Alert',
          message: 'Please select your apoointment date and time',
          type: 'warning',
          disableOverlayClick: true,
          showXclose: true,
          useConfirmBtn: false,
          customCloseBtnText: 'OK'
        });
        // alert('Please select your apoointment date and time')
        return false;
      } else if (!this.$localStorage.get('sa')) {
        this.$Simplert.open({
          title: 'Alert',
          message: 'Please select or add your address',
          type: 'warning',
          disableOverlayClick: true,
          showXclose: true,
          useConfirmBtn: false,
          customCloseBtnText: 'OK'
        });
        // alert('Please select your address')
        return false;
      } else if (!this.$localStorage.get('sm')) {
        this.$Simplert.open({
          title: 'Alert',
          message: 'Please select your member',
          type: 'warning',
          disableOverlayClick: true,
          showXclose: true,
          useConfirmBtn: false,
          customCloseBtnText: 'OK'
        });
        // alert('Please select your member')
        return false;
      } else {
        __WEBPACK_IMPORTED_MODULE_1_vue__["default"].analytics.fbq.event('ViewContent', {
          content_ids: 0,
          content_name: 'PAYMENT INITIATED',
          contents: '',
          content_type: 'PAYMENT_INITIATED'
        });
        this.$router.push({ path: '/payment' });
        return false;
        this.razorPayAssign();
        // this.$router.push({ path: '/payment' })
        // return false
      }
    },
    calculateAge: function calculateAge(birthday) {
      // birthday is a date
      var ageDifMs = Date.now() - birthday.getTime();
      var ageDate = new Date(ageDifMs); // miliseconds from epoch
      return Math.abs(ageDate.getUTCFullYear() - 1970);
    },
    getProfileOld: function getProfileOld() {
      try {
        this.profileDetails = [];
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(this.$GET('patient/getProfile', {})).then(function (res) {
          if (res.response_code === 0) {
            this.profileDetails['username'] = res.response.Patient.firstName + ' ' + res.response.Patient.lastName;
            this.profileDetails['firstName'] = res.response.Patient.firstName;
            this.profileDetails['lastName'] = res.response.Patient.lastName;
            this.profileDetails['photo'] = res.response.Patient.photo;
            this.profileDetails['dob'] = __WEBPACK_IMPORTED_MODULE_5_dateformat___default()(res.response.Patient.dob, 'dd-mm-yyyy');
            this.profileDetails['phone1'] = res.response.Patient.phone1;
            this.profileDetails['phone2'] = res.response.Patient.phone2;
            this.profileDetails['sex'] = res.response.Patient.sex;
            this.profileDetails['email'] = res.response.email;
            if (res.response.Patient.dob) {
              this.profileDetails['age'] = this.calculateAge(new Date(res.response.Patient.dob));
            } else {
              this.profileDetails['age'] = 0;
            }
          }
        }.bind(this)).catch(function (err) {
          console.log(err);
        });
      } catch (e) {
        console.log(e);
      }
    },
    searchLocation: function searchLocation(pincode) {
      try {
        if (this.$localStorage.get('access_token') && this.$localStorage.get('access_token') !== null) {
          var data = {
            'zipcode': pincode
          };
          __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(this.$GET('patient/getAddressByPincode', data)).then(function (res) {
            if (res.response_code === 0) {
              this.locationList = res.response;
            }
          }.bind(this)).catch(function (err) {
            console.error(err);
          });
        }
      } catch (e) {
        console.error(e);
      }
    },
    searchLocality: function searchLocality(type) {
      this.isInvalidPincode = false;
      if (type === 1) {
        if (!this.editAddressFields.locality || this.editAddressFields.zipcode !== this.editAddressFields.locality.locationName + '-' + this.editAddressFields.locality.locationZipCode) {
          this.onBlurKey = 'block';
          this.editAddressFields.locality = undefined;
          try {
            if (this.$localStorage.get('access_token') && this.$localStorage.get('access_token') !== null) {
              var data = {
                'keyword': this.editAddressFields.zipcode,
                'city': this.$localStorage.get('sc') ? this.$localStorage.get('sc').cityId : 0
              };
              __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(this.$POST('patient/searchLocation', data)).then(function (res) {
                console.log(res);
                if (res.response_code === 0) {
                  this.locationList = res.response;
                } else {
                  this.locationList = [];
                }
              }.bind(this)).catch(function (err) {
                console.error(err);
              });
            }
          } catch (e) {
            console.error(e);
          }
        }
      } else if (type === 2) {
        if (!this.addAddressFields.locality || this.addAddressFields.zipcode !== this.addAddressFields.locality.locationName + '-' + this.addAddressFields.locality.locationZipCode) {
          this.onBlurKey = 'block';
          // this.addAddressFields.locality = undefined
          try {
            if (this.$localStorage.get('access_token') && this.$localStorage.get('access_token') !== null) {
              var data = {
                'keyword': this.addAddressFields.zipcode,
                'city': this.$localStorage.get('sc') ? this.$localStorage.get('sc').cityId : 0
              };
              __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(this.$POST('patient/searchLocation', data)).then(function (res) {
                console.log(res);
                if (res.response_code === 0) {
                  this.locationList = res.response;
                } else {
                  this.locationList = [];
                }
              }.bind(this)).catch(function (err) {
                console.error(err);
              });
            }
          } catch (e) {
            console.error(e);
          }
        }
      }
    },
    closeBlock: function closeBlock() {
      setTimeout(function () {
        this.onBlurKey = 'none';
      }.bind(this), 300);
    },
    selectLocation: function selectLocation(event, obj, type) {
      this.isInvalidPincode = false;
      if (type === 1) {
        this.showLocOther = false;
        this.editAddressFields.locality = obj;
        this.editAddressFields.zipcode = obj.locationName + '-' + obj.locationZipCode;
        this.locationList = [];
        this.stateCityDisp = obj.City.cityName + ', ' + obj.State.stateName;
        this.mapWithAddressEdit(this.editAddressFields, 2);
        this.closeLocalityPopup();
      } else if (type === 2) {
        this.showLocOther = false;
        this.addAddressFields.locality = obj;
        this.addAddressFields.zipcode = obj.locationName + '-' + obj.locationZipCode;
        this.locationList = [];
        this.stateCityDisp = obj.City.cityName + ', ' + obj.State.stateName;
        this.mapWithAddressAdd(this.addAddressFields, 2);
        this.closeLocalityPopup();
      } else if (type === 3) {
        this.addAddressFields.locality = 'OTHER';
        this.addAddressFields.zipcode = 'OTHER';
        this.editAddressFields.locality = 'OTHER';
        this.editAddressFields.zipcode = 'OTHER';
        this.showLocOther = true;
        this.stateCityDisp = this.selectedLocality.City.cityName + ',' + this.selectedLocality.State.stateName;
        this.closeLocalityPopup();
      }
    },
    getTestCosts: function getTestCosts(lab) {
      try {
        var labTestCosts = [];
        if (this.$localStorage.get('sl')) {
          if (this.$localStorage.get('sl').labTestList.length > 0) {
            __WEBPACK_IMPORTED_MODULE_4_underscore___default.a.each(this.$localStorage.get('sl').labTestList, function (element) {
              labTestCosts.push(element.labProfileId);
            });
          }
        }
        var data = {
          'labId': this.$localStorage.get('sl') ? this.$localStorage.get('sl').labId : '0',
          'labTests': labTestCosts
        };
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(this.$POST('patient/getTestCosts', data)).then(function (res) {
          if (res.response_code === 0) {
            if (res.response) {
              this.testCosts = res.response;
              var payinfo = {};
              payinfo['mrpTotal'] = res.response.mrp;
              payinfo['phlebotomistFee'] = this.$phlebotomistFee;
              payinfo['subTotal'] = payinfo.mrpTotal + payinfo.phlebotomistFee;
              payinfo['labDiscount'] = res.response.youSaved;
              payinfo['phlebotomyFeeWaiver'] = payinfo.mrpTotal - payinfo.labDiscount > this.$waiverDiscountApplyFee ? this.$phlebotomyFeeWaiver : 0;
              payinfo['total'] = payinfo.subTotal - (payinfo.labDiscount + payinfo.phlebotomyFeeWaiver);
              payinfo['gst'] = Math.round(payinfo.total * this.$GSTFee / 100);
              payinfo['grandTotal'] = payinfo.total + payinfo.gst;
              this.payinfo = payinfo;
            }
          }
        }.bind(this)).catch(function (err) {
          console.error(err);
        });
      } catch (e) {
        console.log(e);
      }
    },
    getAddress: function getAddress() {
      try {
        var data = {};
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(this.$GET('patient/getAddress', data)).then(function (res) {
          if (res.response.length > 0) {
            this.addresses = res.response;
            if (this.isAddressActiveId === 0) {
              __WEBPACK_IMPORTED_MODULE_4_underscore___default.a.each(res.response, function (addresses) {
                if (this.selectedLocality.locationId === addresses.Location.locationId) {
                  if (this.isAddressActiveId > 0) {
                    return false;
                  }
                  this.activeAddress = addresses;
                  this.$localStorage.set('sa', addresses, 30 * 60 * 1000);
                  this.isAddressActiveId = addresses.addressId;
                }
              }, this);
              return false;
            }
            __WEBPACK_IMPORTED_MODULE_4_underscore___default.a.each(res.response, function (element) {
              if (element.addressId === this.isAddressActiveId) {
                if (element.Location.CityControl.cityId === this.$localStorage.get('sc').cityId) {
                  this.activeAddress = element;
                  this.$localStorage.set('sa', element, 30 * 60 * 1000);
                  this.isAddressActiveId = element.addressId;
                } else {
                  this.activeAddress = undefined;
                  this.$localStorage.remove('sa');
                  this.isAddressActiveId = 0;
                }
              }
            }, this);
          }
        }.bind(this)).catch(function (err) {
          console.error(err);
        });
      } catch (e) {
        console.log(e);
      }
    },
    getMembers: function getMembers() {
      try {
        var data = {};
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(this.$GET('patient/getUserAndFamily', data)).then(function (res) {
          this.members = res.response;
          if (res.response.user) {
            if (this.$localStorage.get('sm')) {
              if (this.$localStorage.get('sm').userId === undefined) {
                this.isMemberActiveId = this.$localStorage.get('sm').memberId;
                this.isMe = false;
              } else {
                this.isMemberActiveId = this.$localStorage.get('sm').userId;
                this.isMe = true;
              }
            } else {
              this.isMemberActiveId = res.response.user.userId;
              this.$localStorage.set('sm', res.response.user, 30 * 60 * 1000);
              this.isMe = true;
            }
          }
        }.bind(this)).catch(function (err) {
          console.error(err);
        });
      } catch (e) {
        console.log(e);
      }
    },
    addMember: function addMember() {
      this.addMemberFields = {
        firstName: '',
        lastName: '',
        sex: 'M',
        age: '',
        mobile: ''
      };
      setTimeout(function () {
        this.errors.items = [];
      }.bind(this), 200);
      this.editMemberForm = false;
      this.addAddressForm = false;
      this.editAddressForm = false;
      // this.addMemberForm = !(this.addMemberForm)
      $('#addPatientProfileModal').modal('show');
    },
    editMemberProfile: function editMemberProfile(type) {
      if (type === 1) {
        $('#editMemberProfileModal').modal('show');
        this.getProfile();
      }
    },
    getProfile: function getProfile() {
      try {
        if (this.$localStorage.get('loggedIn') && this.$localStorage.get('access_token') && this.$localStorage.get('access_token') !== null) {
          var data = {};
          __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(this.$GET('patient/getProfile', data)).then(function (res) {
            if (res.response_code === 0) {
              if (res.response) {
                __WEBPACK_IMPORTED_MODULE_4_underscore___default.a.each(res.response.Addresses, function (item) {
                  if (item.isDefault === 1) {
                    this.address = item.address;
                  }
                });
              }
              this.editMemberObj['firstName'] = res.response.Patient.firstName;
              this.editMemberObj['lastName'] = res.response.Patient.lastName;
              this.editMemberObj['email'] = res.response.email;
              this.editMemberObj['phone1'] = res.response.Patient.phone1;
              this.editMemberObj['phone2'] = res.response.Patient.phone2;
              this.editMemberObj['dob'] = res.response.Patient.dob ? res.response.Patient.dob : undefined;
              this.editMemberObj['sex'] = res.response.Patient.sex;

              this.profileDetails['username'] = res.response.Patient.firstName + ' ' + res.response.Patient.lastName;
              this.profileDetails['firstName'] = res.response.Patient.firstName;
              this.profileDetails['lastName'] = res.response.Patient.lastName;
              this.profileDetails['photo'] = res.response.Patient.photo;
              this.profileDetails['dob'] = __WEBPACK_IMPORTED_MODULE_5_dateformat___default()(res.response.Patient.dob, 'dd-mm-yyyy');
              this.profileDetails['phone1'] = res.response.Patient.phone1;
              this.profileDetails['phone2'] = res.response.Patient.phone2;
              this.profileDetails['sex'] = res.response.Patient.sex;
              this.profileDetails['email'] = res.response.email;
              if (res.response.Patient.dob) {
                this.profileDetails['age'] = this.calculateAge(new Date(res.response.Patient.dob));
              } else {
                this.profileDetails['age'] = 0;
              }
              if (res.response.Patient.dob && res.response.Patient.dob !== null) {
                var dob = res.response.Patient.dob.split('T');
                var dobDate = dob[0].split('-');
                this.year = dobDate[0];
                this.month = dobDate[1];
                this.getNumberOfDays(dobDate[2]);
              }
            }
            this.$hidePageLoading();
          }.bind(this)).catch(function (err) {
            console.error(err);
          });
        }
      } catch (e) {
        console.error('method:getProfile', e);
      }
    },
    saveProfile: function saveProfile() {
      var _this = this;

      this.isDobError = false;
      this.$validator.validateAll('edit').then(function (result) {
        if (result) {
          if (_this.year.length !== 4 || _this.month.length <= 0 || _this.ddate.length <= 0) {
            _this.isDobError = true;
            return false;
          }
          try {
            var data = {
              'firstName': _this.editMemberObj.firstName,
              'lastName': _this.editMemberObj.lastName,
              'phone1': _this.editMemberObj.phone1,
              'phone2': _this.editMemberObj.phone2,
              'photo': '',
              'sex': _this.editMemberObj.sex,
              // 'dob': dateFormat(this.editMemberObj.dob, 'yyyy-mm-dd', true),
              'dob': _this.year + '-' + _this.month + '-' + _this.ddate,
              'panNo': '',
              'aadharNo': '',
              'drivingLicenceNo': ''
            };
            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(_this.$POST('patient/updateProfile', data)).then(function (res) {
              if (res.response_code === 0) {
                this.$localStorage.remove('profile');
                var userDetails = {
                  'username': this.editMemberObj.firstName + ' ' + this.editMemberObj.lastName,
                  'firstName': this.editMemberObj.firstName,
                  'lastName': this.editMemberObj.lastName,
                  'phone1': this.editMemberObj.phone1,
                  'dob': __WEBPACK_IMPORTED_MODULE_5_dateformat___default()(this.editMemberObj.dob, 'yyyy-mm-dd', true),
                  'photo': ''
                };
                this.$localStorage.set('profile', userDetails, 0);
                this.getMembers();
                $('#editMemberProfileModal').modal('hide');
              }
            }.bind(_this)).catch(function (err) {
              console.error(err);
            });
          } catch (e) {
            console.error('method:saveProfile', e);
          }
        }
      });
    },
    editMember: function editMember(family) {
      this.addAddressForm = false;
      this.editAddressForm = false;
      this.addMemberForm = false;
      this.editMemberFields = family;
      $('#editPatientProfileModal').modal('show');
      // this.editMemberForm = true
    },
    cancelMember: function cancelMember(type) {
      if (type === 1) {
        $('#editMemberProfileModal').modal('hide');
      } else if (type === 2) {
        $('#editPatientProfileModal').modal('hide');
        this.editMemberFields = {};
      } else if (type === 3) {
        $('#addPatientProfileModal').modal('hide');
        this.addMemberFields = {
          firstName: '',
          lastName: '',
          sex: 'M',
          age: ''
        };
      }
      this.errors.items = [];
      return false;
    },
    saveMember: function saveMember() {
      var _this2 = this;

      try {
        this.$validator.validateAll('addMember').then(function (result) {
          if (result) {
            if (_this2.$localStorage.get('access_token') && _this2.$localStorage.get('access_token') !== null) {
              var data = {
                firstName: _this2.addMemberFields.firstName,
                lastName: _this2.addMemberFields.lastName,
                sex: _this2.addMemberFields.sex,
                mobile: _this2.addMemberFields.mobile,
                age: _this2.addMemberFields.age
              };
              __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(_this2.$POST('patient/saveFamilyMember', data)).then(function (res) {
                if (res.response_code === 0) {
                  this.$localStorage.set('sm', res.response, 30 * 60 * 1000);
                  this.isMe = false;
                  this.getMembers();
                  this.addMemberForm = false;
                  this.editMemberForm = false;
                  this.addAddressForm = false;
                  this.editAddressForm = false;
                  this.addMemberFields = {};
                  this.errors.items = [];
                  $('#addPatientProfileModal').modal('hide');
                }
              }.bind(_this2)).catch(function (err) {
                console.error(err);
              });
            }
          }
        });
      } catch (e) {
        console.log(e);
      }
    },
    setActiveMemberId: function setActiveMemberId(member) {
      if (member.userId) {
        this.isMe = true;
      } else {
        this.isMe = false;
      }
      this.$localStorage.set('sm', member, 30 * 60 * 1000);
    },
    deleteMember: function deleteMember(member) {
      try {
        var confirmMemberFn = function () {
          if (this.$localStorage.get('access_token') && this.$localStorage.get('access_token') !== null) {
            var data = {
              memberId: member.memberId
            };
            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(this.$POST('patient/deleteFamilyMember', data)).then(function (res) {
              if (res.response_code === 0) {
                this.getMembers();
              }
            }.bind(this)).catch(function (err) {
              console.error(err);
            });
          }
        }.bind(this);
        this.$Simplert.open({
          title: 'Confirm',
          message: 'Are you sure confirm, you want to delete this member?',
          type: 'info',
          useConfirmBtn: true,
          onConfirm: confirmMemberFn,
          customConfirmBtnText: 'Ok',
          customCloseBtnText: 'Cancel',
          disableOverlayClick: true
        });
      } catch (e) {
        console.log(e);
      }
    },
    updateMember: function updateMember() {
      var _this3 = this;

      try {
        this.$validator.validateAll('editMember').then(function (result) {
          if (result) {
            if (_this3.$localStorage.get('access_token') && _this3.$localStorage.get('access_token') !== null) {
              var data = {
                memberId: _this3.editMemberFields.memberId,
                firstName: _this3.editMemberFields.firstName,
                lastName: _this3.editMemberFields.lastName,
                sex: _this3.editMemberFields.sex,
                mobile: _this3.editMemberFields.mobile,
                age: _this3.editMemberFields.age
              };
              __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(_this3.$POST('patient/updateFamilyMember', data)).then(function (res) {
                if (res.response_code === 0) {
                  this.$localStorage.set('sm', res.response, 30 * 60 * 1000);
                  this.isMemberActiveId = this.$localStorage.get('sm').memberId;
                  this.isMe = false;
                  this.getMembers();
                  this.addMemberForm = false;
                  this.editMemberForm = false;
                  this.addAddressForm = false;
                  this.editAddressForm = false;
                  this.editMemberFields = {};
                  $('#editPatientProfileModal').modal('hide');
                }
              }.bind(_this3)).catch(function (err) {
                console.error(err);
              });
            }
          }
        });
      } catch (e) {
        console.log(e);
      }
    },
    selectAddress: function selectAddress(address) {
      if (address.Location.CityControl.cityId === this.$localStorage.get('location').CityControl.cityId) {
        this.isAddressActiveId = address.addressId;
        this.$localStorage.set('sa', address, 30 * 60 * 1000);
      } else {
        var SecAlertObj = {};
        SecAlertObj = {
          title: 'Alert',
          message: 'The selected pickup address city (' + address.Location.CityControl.cityName + ') is not within the searched city (' + this.$localStorage.get('location').CityControl.cityName + '). Kindly provide the correct address.',
          type: 'warning',
          disableOverlayClick: true,
          showXclose: true,
          useConfirmBtn: false,
          customCloseBtnText: 'OK'
        };
        this.$Simplert.open(SecAlertObj);
      }
    },
    saveAddress: function saveAddress() {
      var _this4 = this;

      try {
        this.isInvalidPincode = false;
        this.$validator.validateAll('addAddress').then(function (result) {
          if (result) {
            if (_this4.addAddressFields.zipcode && _this4.addAddressFields.zipcode.length > 0 && !_this4.addAddressFields.locality && _this4.addAddressFields.locality !== 'OTHER') {
              _this4.isInvalidPincode = true;
              return false;
            }
            if (_this4.$localStorage.get('access_token') && _this4.$localStorage.get('access_token') !== null) {
              var data = {
                'addressName': _this4.addAddressFields.addressName,
                'flatNo': _this4.addAddressFields.flatNo,
                'address': _this4.addAddressFields.address,
                'landmark': _this4.addAddressFields.landmark,
                'locationOther': _this4.addAddressFields.locationOther ? _this4.addAddressFields.locationOther : '',
                'mobile': _this4.addAddressFields.mobile,
                'isDefault': 0,
                'coordinates': _this4.mapCoordinates
              };
              if (_this4.addAddressFields.locality === 'OTHER') {
                data['locationId'] = 0;
                data['cityId'] = _this4.$localStorage.get('sc') ? _this4.$localStorage.get('sc').cityId : 2;
                data['stateId'] = _this4.$localStorage.get('sc') ? _this4.$localStorage.get('sc').State ? _this4.$localStorage.get('sc').State.stateId : 2 : 2;
                data['zipCode'] = _this4.addAddressFields.locationPincode;
                if (isNaN(_this4.addAddressFields.locationPincode)) {
                  _this4.otherPincodeError = true;
                  return false;
                }
              } else {
                data['locationId'] = _this4.addAddressFields.locality.locationId;
                data['cityId'] = _this4.addAddressFields.locality.City.cityId;
                data['stateId'] = _this4.addAddressFields.locality.State.stateId;
                data['zipCode'] = _this4.addAddressFields.locality.locationZipCode;
              }
              __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(_this4.$POST('patient/saveAddress', data)).then(function (res) {
                if (res.response_code === 0) {
                  this.activeAddress = res.response;
                  this.$localStorage.set('sa', res.response, 30 * 60 * 1000);
                  this.isAddressActiveId = res.response.addressId;
                  this.getAddress();
                  this.addAddressFields = {};
                  this.toogleAddress(1);
                } else {
                  this.$Simplert.open({
                    title: 'Information',
                    message: '<div style="text-align: left; line-height: 20px;">\n                              <p>' + res.response_message + '</p>\n                            </div>',
                    type: 'info',
                    useConfirmBtn: false,
                    customCloseBtnText: 'Ok',
                    disableOverlayClick: true
                  });
                }
              }.bind(_this4)).catch(function (err) {
                console.error(err);
              });
            }
          }
        });
      } catch (e) {
        console.log(e);
      }
    },
    updateAddress: function updateAddress() {
      var _this5 = this;

      try {
        this.isInvalidPincode = false;
        this.$validator.validateAll('editAddress').then(function (result) {
          if (result) {
            if (_this5.editAddressFields.zipcode && _this5.editAddressFields.zipcode.length > 0 && !_this5.editAddressFields.locality && _this5.editAddressFields.locality !== 'OTHER') {
              _this5.isInvalidPincode = true;
              return false;
            }
            if (_this5.$localStorage.get('access_token') && _this5.$localStorage.get('access_token') !== null) {
              var data = {
                'addressId': _this5.editAddressFields.addressId,
                'addressName': _this5.editAddressFields.addressName,
                'address': _this5.editAddressFields.address,
                'flatNo': _this5.editAddressFields.flatNo,
                'landmark': _this5.editAddressFields.landmark,
                'locationOther': _this5.editAddressFields.locationOther ? _this5.editAddressFields.locationOther : '',
                'mobile': _this5.editAddressFields.mobile,
                'isDefault': 0,
                'coordinates': _this5.mapCoordinates
              };
              if (_this5.editAddressFields.locality === 'OTHER') {
                data['locationId'] = 0;
                data['cityId'] = _this5.$localStorage.get('sc') ? _this5.$localStorage.get('sc').cityId : 0;
                data['stateId'] = _this5.$localStorage.get('sc') ? _this5.$localStorage.get('sc').State ? _this5.$localStorage.get('sc').State.stateId : 2 : 2;
                data['zipCode'] = _this5.editAddressFields.locationPincode;
              } else {
                data['locationId'] = _this5.editAddressFields.locality.locationId;
                data['cityId'] = _this5.editAddressFields.locality.City.cityId;
                data['stateId'] = _this5.editAddressFields.locality.State.stateId;
                data['zipCode'] = _this5.editAddressFields.locality.locationZipCode;
              }
              __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(_this5.$POST('patient/updateAddress', data)).then(function (res) {
                if (res.response_code === 0) {
                  this.isAddressActiveId = this.editAddressFields.addressId;
                  this.getAddress();
                  this.addAddressForm = false;
                  this.editAddressForm = false;
                  this.editAddressFields = {};
                  this.toogleAddress(1);
                } else {
                  this.$Simplert.open({
                    title: 'Information',
                    message: '<div style="text-align: left; line-height: 20px;">\n                              <p>' + res.response_message + '</p>\n                            </div>',
                    type: 'info',
                    useConfirmBtn: false,
                    customCloseBtnText: 'Ok',
                    disableOverlayClick: true
                  });
                }
              }.bind(_this5)).catch(function (err) {
                console.error(err);
              });
            }
          }
        });
      } catch (e) {
        console.log('error', e);
      }
    },
    addAddress: function addAddress(value) {
      this.isInvalidPincode = false;
      this.addMemberForm = false;
      this.editMemberForm = false;
      this.addAddressForm = false;
      this.editAddressForm = false;
      this.showLocOther = false;
      var addFields = [];
      this.addressZipCode = '';
      addFields['addressId'] = '';
      addFields['addressName'] = this.$localStorage.get('profile').username;
      addFields['address'] = '';
      addFields['zipcode'] = this.$localStorage.get('location') ? this.$localStorage.get('location').locationName + '-' + this.$localStorage.get('location').locationZipCode : '';
      addFields['locationOther'] = '';
      addFields['mobile'] = this.$localStorage.get('profile').phone1;
      addFields['isDefault'] = 0;
      addFields['coordinates'] = '';
      addFields['state'] = undefined;
      if (this.$localStorage.get('location') && this.$localStorage.get('location').City && this.$localStorage.get('location').State) {
        addFields['cityId'] = this.$localStorage.get('location') ? this.$localStorage.get('location').City.cityId : 2;
        addFields['stateId'] = this.$localStorage.get('location') ? this.$localStorage.get('location').State.stateId : 2;
        addFields['locationId'] = this.$localStorage.get('location') ? this.$localStorage.get('location').locationId : 0;
        addFields['stateCityDisp'] = this.$localStorage.get('location').City.cityName + ', ' + this.$localStorage.get('location').State.stateName;
        addFields['locality'] = this.$localStorage.get('location');
        this.stateCityDisp = addFields['stateCityDisp'];
      } else {
        addFields['locality'] = '';
      }
      this.addAddressFields = addFields;
      this.toogleAddress(2);
      this.mapWithAddressAdd(this.addAddressFields, 2);
      setTimeout(function () {
        $(window).scrollTop(0);
      }.bind(this), 300);
    },
    isNumber: function isNumber(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
        evt.preventDefault();
      } else {
        setTimeout(function () {
          this.onchangePincode();
        }.bind(this), 300);
        return true;
      }
    },
    onchangePincode: function onchangePincode() {
      if (this.addAddressFields.zipcode.length !== 6) {
        console.log(this.addAddressFields.zipcode);
        return false;
      }
      var data = {
        'pincode': this.addAddressFields.zipcode
      };
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(this.$GET('patient/getAddressByPincode', data)).then(function (res) {
        if (res.response.length > 0) {
          this.locationList = res.response;
        } else {
          this.locationList = [];
          this.addAddressFields.locality = '';
        }
      }.bind(this));
    },
    isNumberEdit: function isNumberEdit(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      console.log(charCode);
      if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    onchangePincodeEdit: function onchangePincodeEdit() {
      if (this.editAddressFields.zipcode.length !== 6) {
        return false;
      }
      var data = {
        'pincode': this.editAddressFields.zipcode
      };
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(this.$GET('patient/getAddressByPincode', data)).then(function (res) {
        if (res.response.length > 0) {
          this.locationList = res.response;
        } else {
          this.locationList = [];
          this.editAddressFields.locality = '';
        }
      }.bind(this));
    },
    cancelModalPopup: function cancelModalPopup() {
      $(window).scrollTop(0);
      this.toogleAddress(1);
      this.errors.items = [];
      this.addAddressFields = {};
      this.editAddressFields = {};
      this.addAddressForm = false;
      this.editAddressForm = false;
    },
    addressChanged: function addressChanged(type) {
      if (type === 1) {
        this.mapWithAddressAdd(this.addAddressFields, 2);
      } else {
        this.mapWithAddressEdit(this.editAddressFields, 2);
      }
    },
    editAddress: function editAddress(value) {
      try {
        // if(value.Location.CityControl.cityId !== this.$localStorage.get('sc').cityId){
        //     let SecAlertObj = {
        //       title: 'Alert',
        //       message: `This address belongs to ${value.Location.CityControl.cityName} city. Please choose another or add new address.`,
        //       type: 'warning',
        //       disableOverlayClick: true,
        //       showXclose: true,
        //       useConfirmBtn: false,
        //       customCloseBtnText: 'OK'
        //     }
        //     this.$Simplert.open(SecAlertObj)
        //     return false
        // }
        this.isInvalidPincode = false;
        this.addMemberForm = false;
        this.editMemberForm = false;
        this.addAddressForm = false;
        this.editAddressForm = false;
        this.showLocOther = false;
        var editFields = [];
        editFields['addressId'] = value.addressId;
        editFields['addressName'] = value.addressName;
        editFields['address'] = value.address;
        editFields['flatNo'] = value.flatNo;
        editFields['landmark'] = value.landmark;
        editFields['zipcode'] = value.Location.locationName + '-' + value.Location.locationZipCode;
        editFields['locationOther'] = '';
        editFields['mobile'] = value.mobile;
        editFields['isDefault'] = 0;
        editFields['coordinates'] = value.coordinates;
        editFields['state'] = undefined;
        editFields['locality'] = value.Location;
        this.toogleAddress(3);
        this.mapWithAddressEdit(value, 1);
        setTimeout(function () {
          $(window).scrollTop(0);
        }, 500);
        editFields['cityId'] = value.Location ? value.Location.City.cityId : 2;
        editFields['stateId'] = value.Location ? value.Location.State.stateId : 2;
        editFields['locationId'] = value.Location ? value.Location.locationId : 0;
        editFields['stateCityDisp'] = value.Location.City.cityName + ', ' + value.Location.State.stateName;
        this.editAddressFields = editFields;
        this.stateCityDisp = editFields['stateCityDisp'];
        // var data = {
        //   'pincode': value.zipCode
        // }
        // Promise.resolve(this.$GET('patient/getAddressByPincode', data)).then(function (res) {
        //   if (res.response.length > 0) {
        //     this.locationList = res.response
        //     _.each(res.response, function (element) {
        //       if (element.locationId === value.Location.locationId) {
        //         editFields['cityId'] = (element) ? element.City.cityId : 2
        //         editFields['stateId'] = (element) ? element.State.stateId : 2
        //         editFields['locationId'] = (element) ? element.locationId : 0
        //         editFields['stateCityDisp'] = element.City.cityName + ', ' + element.State.stateName
        //         // myMap(undefined, 'map', 'coordinates_popup', this.editAddressFields.coordinates)
        //         if (element) {
        //           editFields['locality'] = element
        //         } else {
        //           editFields['locality'] = ''
        //         }
        //       }
        //     }, this)
        //     // this.editAddressForm = true
        //     this.editAddressFields = editFields
        //     this.stateCityDisp = editFields['stateCityDisp']
        //   }
        // }.bind(this)).catch(function (err) {
        //   console.error(err)
        // })
      } catch (e) {
        console.log('error', e);
      }
    },
    mapWithAddressAdd: function mapWithAddressAdd(value, type) {
      this.mapCoordinates = undefined;
      var address = '';
      var location = '';
      var stateCity = value.stateCityDisp;
      this.map = new google.maps.Map(document.getElementById('myMapAdd'), {
        zoom: 15,
        mapTypeId: google.maps.MapTypeId.ROADMAP
      });
      if (type === 2) {
        address = value.address;
        console.log(value);
        if (value.locality === 'OTHER') {
          location = value.locationOther;
        } else {
          location = value.locality.locationName;
        }
        this.map = new google.maps.Map(document.getElementById('myMapAdd'), {
          zoom: 17,
          mapTypeId: google.maps.MapTypeId.ROADMAP
        });
        var geocoder = new google.maps.Geocoder();
        geocoder.geocode({
          'address': address && location ? address + ' , ' + location + ', ' + stateCity : address && !location ? address + ', ' + stateCity : !address && location ? location + ', ' + stateCity : ''
        }, function (results, status) {
          if (status === 'OK') {
            this.marker = new google.maps.Marker({
              map: this.map,
              position: results[0].geometry.location
            });
            var latitude = results[0].geometry.location.lat();
            var longitude = results[0].geometry.location.lng();
            var latlng = new google.maps.LatLng(latitude, longitude);
            this.mapCoordinates = latitude + ',' + longitude;
            setTimeout(function () {
              google.maps.event.trigger(this.map, 'resize');
              this.map.setCenter(latlng);
              google.maps.event.trigger(this.map, 'resize');
            }.bind(this), 1000);
          } else {
            this.map = new google.maps.Map(document.getElementById('myMapAdd'), {
              zoom: 15,
              mapTypeId: google.maps.MapTypeId.ROADMAP
            });
            geocoder.geocode({ 'address': location + ', ' + stateCity }, function (resp, status) {
              if (status === 'OK') {
                this.map.setCenter(resp[0].geometry.location);
                this.marker = new google.maps.Marker({
                  map: this.map,
                  position: resp[0].geometry.location
                });
                var latitude = resp[0].geometry.location.lat();
                var longitude = resp[0].geometry.location.lng();
                var latlng = new google.maps.LatLng(latitude, longitude);
                setTimeout(function () {
                  google.maps.event.trigger(this.map, 'resize');
                  this.map.setCenter(latlng);
                  google.maps.event.trigger(this.map, 'resize');
                }.bind(this), 1000);
                this.mapCoordinates = this.map.center.lat() + ',' + this.map.center.lng();
              } else {
                geocoder.geocode({
                  'address': stateCity
                }, function (resp, status) {
                  if (status === 'OK') {
                    this.map.setCenter(resp[0].geometry.location);
                    this.marker = new google.maps.Marker({
                      map: this.map,
                      position: resp[0].geometry.location
                    });
                    var latitude = resp[0].geometry.location.lat();
                    var longitude = resp[0].geometry.location.lng();
                    var latlng = new google.maps.LatLng(latitude, longitude);
                    setTimeout(function () {
                      google.maps.event.trigger(this.map, 'resize');
                      this.map.setCenter(latlng);
                      google.maps.event.trigger(this.map, 'resize');
                    }.bind(this), 1000);
                    this.mapCoordinates = this.map.center.lat() + ',' + this.map.center.lng();
                  } else {
                    console.log('Geocode was not successful for the following reason: ' + status);
                  }
                }.bind(this));
              }
            }.bind(this));
          }
        }.bind(this));
      } else {
        var geocoder = new google.maps.Geocoder();
        geocoder.geocode({
          'address': stateCity
        }, function (resp, status) {
          if (status === 'OK') {
            this.map.setCenter(resp[0].geometry.location);
            this.marker = new google.maps.Marker({
              map: this.map,
              position: resp[0].geometry.location
            });
            var latitude = resp[0].geometry.location.lat();
            var longitude = resp[0].geometry.location.lng();
            var latlng = new google.maps.LatLng(latitude, longitude);
            setTimeout(function () {
              google.maps.event.trigger(this.map, 'resize');
              this.map.setCenter(latlng);
              google.maps.event.trigger(this.map, 'resize');
            }.bind(this), 1000);
            this.mapCoordinates = this.map.center.lat() + ',' + this.map.center.lng();
          } else {
            console.log('Geocode was not successful for the following reason: ' + status);
          }
        }.bind(this));
      }
      google.maps.event.addListener(this.map, 'click', function (event) {
        this.marker.setMap(null);
        this.marker = new google.maps.Marker({
          position: event.latLng
        });
        this.marker.setMap(this.map);
        this.mapCoordinates = event.latLng.lat() + ',' + event.latLng.lng();
      }.bind(this));
    },
    mapWithAddressEdit: function mapWithAddressEdit(value, type) {
      this.mapCoordinates = undefined;
      var address = '';
      var location = '';
      var city = value.City ? value.City.cityName : '';
      var state = value.State ? value.State.stateName : '';
      var stateCity = city + ', ' + state;
      if (type === 1) {
        address = value.address;
        location = value.Location.locationName;
        this.mapCoordinates = value.coordinates;
      } else {
        address = value.address;
        if (value.locality === 'OTHER') {
          location = value.locationOther;
        } else {
          location = value.locality.locationName;
        }
      }
      if (this.mapCoordinates && this.mapCoordinates.length > 0) {
        var cordinatesArray = this.mapCoordinates.split(',');
        this.map = new google.maps.Map(document.getElementById('myMapVal'), {
          zoom: 17,
          mapTypeId: google.maps.MapTypeId.ROADMAP
        });
        var latitude = parseFloat(cordinatesArray[0], 8);
        var longitude = parseFloat(cordinatesArray[1], 8);
        var latlng = new google.maps.LatLng(latitude, longitude);
        this.marker = new google.maps.Marker({
          map: this.map,
          position: latlng
        });
        setTimeout(function () {
          this.map.setCenter(latlng);
          google.maps.event.trigger(this.map, 'resize');
          this.map.setCenter(latlng);
          google.maps.event.trigger(this.map, 'resize');
        }.bind(this), 1000);
      } else {
        this.map = new google.maps.Map(document.getElementById('myMapVal'), {
          zoom: 17,
          mapTypeId: google.maps.MapTypeId.ROADMAP
        });
        var geocoder = new google.maps.Geocoder();

        geocoder.geocode({
          'address': address + ' , ' + location + ', ' + stateCity
        }, function (results, status) {
          console.log(results);
          if (status === 'OK') {
            this.marker = new google.maps.Marker({
              map: this.map,
              position: results[0].geometry.location
            });
            var latitude = results[0].geometry.location.lat();
            var longitude = results[0].geometry.location.lng();
            var latlng = new google.maps.LatLng(latitude, longitude);
            console.log(latitude + ',' + longitude);
            this.mapCoordinates = latitude + ',' + longitude;
            setTimeout(function () {
              google.maps.event.trigger(this.map, 'resize');
              this.map.setCenter(latlng);
              google.maps.event.trigger(this.map, 'resize');
            }.bind(this), 1000);
          } else {
            geocoder.geocode({ 'address': location + ', ' + stateCity }, function (resp, status) {
              console.log(resp);
              if (status === 'OK') {
                this.map.setCenter(resp[0].geometry.location);
                this.marker = new google.maps.Marker({
                  map: this.map,
                  position: resp[0].geometry.location
                });
                var latitude = resp[0].geometry.location.lat();
                var longitude = resp[0].geometry.location.lng();
                var latlng = new google.maps.LatLng(latitude, longitude);
                setTimeout(function () {
                  google.maps.event.trigger(this.map, 'resize');
                  this.map.setCenter(latlng);
                  google.maps.event.trigger(this.map, 'resize');
                }.bind(this), 1000);
                this.mapCoordinates = this.map.center.lat() + ',' + this.map.center.lng();
              } else {
                geocoder.geocode({ 'address': stateCity }, function (resp, status) {
                  if (status === 'OK') {
                    this.map.setCenter(resp[0].geometry.location);
                    this.marker = new google.maps.Marker({
                      map: this.map,
                      position: resp[0].geometry.location
                    });
                    var latitude = resp[0].geometry.location.lat();
                    var longitude = resp[0].geometry.location.lng();
                    var latlng = new google.maps.LatLng(latitude, longitude);
                    setTimeout(function () {
                      google.maps.event.trigger(this.map, 'resize');
                      this.map.setCenter(latlng);
                      google.maps.event.trigger(this.map, 'resize');
                    }.bind(this), 1000);
                    this.mapCoordinates = this.map.center.lat() + ',' + this.map.center.lng();
                  } else {
                    console.log('Geocode was not successful for the following reason: ' + status);
                  }
                }.bind(this));
              }
            }.bind(this));
          }
        }.bind(this));
      }
      google.maps.event.addListener(this.map, 'click', function (event) {
        this.marker.setMap(null);
        this.marker = new google.maps.Marker({
          position: event.latLng
        });
        this.marker.setMap(this.map);
        this.mapCoordinates = event.latLng.lat() + ',' + event.latLng.lng();
      }.bind(this));
    },
    showAddOtherLocation: function showAddOtherLocation() {
      this.showLocOther = false;
      if (this.addAddressFields.locality === 'OTHER') {
        this.showLocOther = true;
        this.stateCityDisp = stateCity;
      } else {
        var jsonLocality = this.addAddressFields.locality;
        this.stateCityDisp = jsonLocality.City.cityName + ', ' + jsonLocality.State.stateName;
      }
      this.mapWithAddressAdd(this.addAddressFields, 2);
    },
    showEditOtherLocation: function showEditOtherLocation() {
      this.showLocOther = false;
      if (this.editAddressFields.locality === 'OTHER') {
        this.showLocOther = true;
        this.stateCityDisp = this.stateCityDisp;
      } else {
        var jsonLocality = this.editAddressFields.locality;
        this.stateCityDisp = jsonLocality.City.cityName + ', ' + jsonLocality.State.stateName;
      }
      this.mapWithAddressEdit(this.editAddressFields, 2);
    },
    deleteAddress: function deleteAddress(addressId) {
      var confirmFn = function () {
        var data = {
          addressId: addressId
        };
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(this.$POST('patient/deleteAddress', data)).then(function (res) {
          if (res.response.length > 0) {
            this.getAddress();
          }
        }.bind(this)).catch(function (err) {
          console.error(err);
        });
      }.bind(this);
      var obj = {};
      obj = {
        title: 'Confirm',
        message: 'Are you sure confirm, you want to delete this address?',
        type: 'info',
        useConfirmBtn: true,
        onConfirm: confirmFn,
        customConfirmBtnText: 'Ok',
        customCloseBtnText: 'Cancel',
        disableOverlayClick: true
      };
      this.$Simplert.open(obj);
      // let r = confirm('Are you sure you want to delete?')
      // if (r === true) {
      //   try {
      //     let data = {
      //       addressId: addressId
      //     }
      //     Promise.resolve(this.$POST('patient/deleteAddress', data)).then(function (res) {
      //       if (res.response.length > 0) {
      //         this.getAddress()
      //       }
      //     }.bind(this)).catch(function (err) {
      //       console.error(err)
      //     })
      //   } catch (e) {
      //     console.log('error', e)
      //   }
      // }
    },
    applyCoupon: function applyCoupon() {
      var _this6 = this;

      this.$validator.validateAll('coupon').then(function (result) {
        if (result) {
          try {
            _this6.couponError = '';
            _this6.isSuccessCoupon = false;
            if (_this6.couponCode === '') {
              _this6.couponError = 'Please enter coupon code';
              return false;
            }
            var data = {
              'coupon_code': _this6.couponCode.toUpperCase()
            };

            if (_this6.$localStorage.get('sl')) {
              data['labId'] = _this6.$localStorage.get('sl').labId;
              var labProfileIds = [];
              if (_this6.$localStorage.get('sl') && _this6.$localStorage.get('sl').labTestList.length > 0) {
                _this6.$localStorage.get('sl').labTestList.forEach(function (element) {
                  if (element.labProfileId > 0) {
                    labProfileIds.push(element.labProfileId);
                  }
                });
              }
              data['labProfileIds'] = labProfileIds;
            } else {
              data['labId'] = 0;
              data['labProfileIds'] = [];
            }

            if (_this6.$localStorage.get('profile')) {
              data['email'] = _this6.$localStorage.get('profile').email;
            } else {
              data['email'] = '';
            }
            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(_this6.$POST('patient/applyCoupon', data)).then(function (res) {
              if (res.response_code === 0) {
                this.$localStorage.set('cou', res.response, 30 * 60 * 1000);
                this.isCouponApplied = true;
                this.couponData = res.response;
                this.couponError = '';
                if (res.response.coupon_percentage > 0) {
                  this.isSuccessCoupon = true;
                  this.couponError = res.response.coupon_percentage + '% ';
                } else {
                  this.isSuccessCoupon = true;
                  this.couponError = 'Rs.' + res.response.coupon_price + ' ';
                }
                this.getCartPaymentDetails();
              } else {
                this.$localStorage.remove('cou');
                if (res.response_code === 4) {
                  this.couponError = res.response_message + ' (Rs.' + res.response.coupon_range + ')';
                } else {
                  this.couponError = res.response_message;
                }
                this.getCartPaymentDetails();
              }
            }.bind(_this6)).catch(function (err) {
              console.error(err);
            });
          } catch (e) {
            console.log('error', e);
          }
        }
      });
    },
    removeCoupon: function removeCoupon() {
      this.$localStorage.remove('cou');
      this.getCartPaymentDetails();
      this.isCouponApplied = false;
      this.couponData = undefined;
      this.couponCode = '';
    },
    getCartPaymentDetails: function getCartPaymentDetails() {
      try {
        var labTestCosts = [];
        if (this.$localStorage.get('sl')) {
          if (this.$localStorage.get('sl').labTestList.length > 0) {
            __WEBPACK_IMPORTED_MODULE_4_underscore___default.a.each(this.$localStorage.get('sl').labTestList, function (element) {
              labTestCosts.push(element.labProfileId);
            });
          }
        }
        var data = {
          'labId': this.$localStorage.get('sl') ? this.$localStorage.get('sl').labId : '0',
          'labTests': labTestCosts,
          'couponCode': this.$localStorage.get('cou') ? this.$localStorage.get('cou').coupon_code : '',
          'couponId': this.$localStorage.get('cou') ? this.$localStorage.get('cou').couponId : '0'
        };
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(this.$POST('patient/cartPaymentDetails', data)).then(function (res) {
          if (res.response_code === 0) {
            if (res.response) {
              var payinfo = {};
              payinfo['mrpTotal'] = res.response.mrpTotal;
              payinfo['phlebotomistFee'] = res.response.phlebotomistFee;
              payinfo['subTotal'] = res.response.subTotal;
              payinfo['labDiscount'] = res.response.labDiscount;
              payinfo['waiverDiscountApplyFee'] = res.response.waiverDiscountApplyFee;
              payinfo['phlebotomyFeeWaiver'] = res.response.phlebotomyFeeWaiver;
              payinfo['total'] = res.response.mrpTotal - res.response.labDiscount; // res.response.total
              payinfo['gst'] = res.response.gst;
              payinfo['couponFee'] = res.response.couponFee;
              payinfo['grandTotal'] = res.response.grandTotal;
              payinfo['couponCode'] = res.response.couponCode;
              payinfo['couponId'] = res.response.couponId;
              if (res.response.grandTotal <= 0) {
                this.payinfo.grandTotal = 0;
                payinfo['grandTotal'] = 0;
              }
              payinfo['priceDetails'] = res.response.priceDetails;
              this.payinfo = payinfo;
            }
          }
          this.$hidePageLoading();
        }.bind(this)).catch(function (err) {
          console.error(err);
        });
      } catch (e) {
        console.log(e);
      }
    },
    razorPayAssign: function razorPayAssign() {
      if (this.payinfo && this.profileDetails) {
        var self = this;
        var options = {
          'key': this.$razorpay_key,
          'amount': Math.ceil(this.payinfo.grandTotal) * 100, // 2000 paise = INR 20
          'name': 'Labotist Private Limited',
          'description': 'Health & Fitness',
          'image': 'https://labotist.com/dist/images/logo-svg.svg',
          'handler': function handler(response) {
            // alert(response.razorpay_payment_id)
            self.saveRequest(response.razorpay_payment_id);
          },
          'prefill': {
            'name': this.profileDetails.username,
            'email': this.profileDetails.email,
            'contact': this.profileDetails.phone1
          },
          'notes': {
            'address': this.profileDetails.username + ', ' + this.$localStorage.get('sa').address + ', ' + this.$localStorage.get('sa').Location.locationName + ', ' + this.$localStorage.get('sa').City.cityName + ', ' + this.$localStorage.get('sa').State.stateName + ' - ' + this.$localStorage.get('sa').zipCode
          },
          'theme': {
            'color': '#057dc2',
            'emi_mode': false
          }
        };
        Razorpay(options).open();
      }
    },
    saveRequest: function saveRequest(paymentId) {
      this.$showPageLoading();
      try {
        var paymentData = {
          paymentId: paymentId
        };
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(this.$GET('payment/fetch', paymentData)).then(function (rzpInfo) {
          if (rzpInfo.response_code === 0) {
            var totalPaidCost = 0;
            if (rzpInfo) {
              totalPaidCost = rzpInfo.response.amount / 100;
            }
            var timezone = new Date().getTimezoneOffset();
            var appointmentDate = this.$localStorage.get('ct').dateFormatMoment;
            var appointmentTimeFrom = this.$localStorage.get('ct').startTime;
            var appointmentTimeTo = this.$localStorage.get('ct').endTime;
            var appointmentDateTimeFrom = this.$localStorage.get('ct').fromDateTime;
            var appointmentDateTimeTo = this.$localStorage.get('ct').toDateTime;
            // alert(this.$localStorage.get('ct').fromDateTime)
            // let appointmentTimeFromTimeZone = dateFormat(this.$localStorage.get('ct').fromDateTime, 'HH:MM:ss')
            // alert(3)
            // let appointmentTimeToTimeZone = dateFormat(this.$localStorage.get('ct').toDateTime, 'HH:MM:ss')
            // alert(4)
            // let appointmentDateTimeFromTimeZone = dateFormat(this.$localStorage.get('ct').fromDateTime, 'yyyy-mm-dd HH:MM:ss', true)
            // alert(5)
            // let appointmentDateTimeToTimeZone = dateFormat(this.$localStorage.get('ct').toDateTime, 'yyyy-mm-dd HH:MM:ss', true)
            // alert(6)
            var data = {
              'paymentId': paymentId,
              'labId': this.$localStorage.get('sl').labId,
              'appointmentDate': appointmentDate,
              'appointmentTimeFrom': appointmentTimeFrom,
              'appointmentTimeTo': appointmentTimeTo,
              'appointmentDateTimeFrom': appointmentDateTimeFrom,
              'appointmentDateTimeTo': appointmentDateTimeTo,
              'timezone': timezone,
              // 'appointmentDateTimeFromTimeZone': appointmentDateTimeFromTimeZone,
              // 'appointmentDateTimeToTimeZone': appointmentDateTimeToTimeZone,
              // 'appointmentTimeFromTimeZone': appointmentTimeFromTimeZone,
              // 'appointmentTimeToTimeZone': appointmentTimeToTimeZone,
              'pickupAddressId': this.$localStorage.get('sa').addressId,
              'pickupLocation': this.$localStorage.get('sa').Location.locationName,
              'pickupZipcode': this.$localStorage.get('sa').zipCode,
              'totalPaidCost': totalPaidCost,
              'actualCost': this.payinfo.subTotal,
              'discountCost': this.payinfo.labDiscount + this.payinfo.phlebotomyFeeWaiver,
              'gstCost': this.payinfo.gstCost,
              'couponCost': this.payinfo.couponFee,
              'couponCode': this.payinfo.couponCode,
              'couponId': this.payinfo.couponId,
              'totalCost': this.payinfo.grandTotal,
              'reqPatientFirstName': this.$localStorage.get('sm').firstName,
              'reqPatientLastName': this.$localStorage.get('sm').lastName,
              'reqPatientSex': this.$localStorage.get('sm').sex,
              'reqPatientAge': this.$localStorage.get('sm').age,
              'reqPatientEmail': this.profileDetails.email,
              'reqPatientMobile': this.$localStorage.get('sm').mobile,
              'pickupAddress': this.$localStorage.get('sa').address + ', ' + this.$localStorage.get('sa').Location.locationName + ', ' + this.$localStorage.get('sa').City.cityName + ', ' + this.$localStorage.get('sa').State.stateName + ' - ' + this.$localStorage.get('sa').zipCode,
              'pickupCoordinates': this.$localStorage.get('sa').coordinates

              // alert(JSON.stringify(data))

            };var labTests = [];
            var labProfiles = [];
            if (this.$localStorage.get('st').length > 0) {
              __WEBPACK_IMPORTED_MODULE_4_underscore___default.a.each(this.$localStorage.get('st'), function (element) {
                if (element.panelId > 0) {
                  labProfiles.push(element.panelId);
                } else {
                  labTests.push(element.testId);
                }
              });
            }
            data.test = labTests;
            data.profile = labProfiles;
            // alert(JSON.stringify(data))
            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(this.$POST('patient/saveRequest', data)).then(function (res) {
              if (res.response_code === 0) {
                this.clearRequestSessions();
                global.successId = res.response.requestId;
                __WEBPACK_IMPORTED_MODULE_1_vue__["default"].analytics.fbq.event('ViewContent', {
                  content_ids: 0,
                  content_name: 'PAYMENT COMPLETED',
                  contents: '',
                  content_type: 'PAYMENT_COMPLETED'
                });
                this.$router.push({ path: '/success', params: { sample: 'hi' } });
              }
            }.bind(this)).catch(function (err) {
              console.log('METHOD:saveRequest', err);
            });
          }
        }.bind(this)).catch(function (err) {
          // alert(JSON.stringify(err))
          console.log('METHOD:saveRequest', err);
        });
      } catch (err) {
        // alert(JSON.stringify(err))
        console.log('METHOD:saveRequest', err);
      }
    },
    clearRequestSessions: function clearRequestSessions() {
      this.$localStorage.remove('location');
      this.$localStorage.remove('st');
      this.$localStorage.remove('sl');
      this.$localStorage.remove('ct');
      this.$localStorage.remove('sa');
      this.$localStorage.remove('step');
      this.$localStorage.remove('cou');
    }
  },
  created: function created() {
    this.toogleAddress(1);
    this.selectedLab = [];
    if (this.$localStorage.get('sl')) {
      this.selectedLab = this.$localStorage.get('sl');
    }
    if (this.$localStorage.get('location')) {
      this.selectedLocality = this.$localStorage.get('location');
    }

    this.selectedProfileAndTest = [];
    if (this.$localStorage.get('st')) {
      this.selectedProfileAndTest = this.$localStorage.get('st');
    }

    this.activeAddress = [];
    if (this.$localStorage.get('sa')) {
      this.activeAddress = this.$localStorage.get('sa');
      this.isAddressActiveId = this.$localStorage.get('sa').addressId;
    }

    this.activeMembers = [];
    if (this.$localStorage.get('sm')) {
      this.activeMembers = this.$localStorage.get('sm');
      if (this.$localStorage.get('sm').userId === undefined) {
        this.isMemberActiveId = this.$localStorage.get('sm').memberId;
      } else {
        this.isMemberActiveId = this.$localStorage.get('sm').userId;
      }
    }
    if (this.$localStorage.get('cou')) {
      this.isCouponApplied = true;
      this.couponData = this.$localStorage.get('cou');
      if (this.$localStorage.get('cou').coupon_percentage > 0) {
        this.isSuccessCoupon = true;
        this.couponError = this.$localStorage.get('cou').coupon_percentage + '% ';
      } else {
        this.isSuccessCoupon = true;
        this.couponError = 'Rs.' + this.$localStorage.get('cou').coupon_price + ' ';
      }
    }
    this.getProfile();
    this.getTestCosts();
    this.getAddress();
    this.getMembers();
    this.searchLocation(this.$localStorage.get('pincode'));
    this.getCartPaymentDetails();
    var year = new Date().getFullYear();
    var endYear = year - 120;
    for (var i = year; i > endYear; i--) {
      this.dobYears.push(i.toString());
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("DuR2")))

/***/ }),

/***/ "Kvcb":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "LNIC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "MFNR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "MXWE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-runtime/regenerator/index.js
var regenerator = __webpack_require__("Xxa5");
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/asyncToGenerator.js
var asyncToGenerator = __webpack_require__("exGp");
var asyncToGenerator_default = /*#__PURE__*/__webpack_require__.n(asyncToGenerator);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/promise.js
var promise = __webpack_require__("//Fk");
var promise_default = /*#__PURE__*/__webpack_require__.n(promise);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/keys.js
var keys = __webpack_require__("fZjL");
var keys_default = /*#__PURE__*/__webpack_require__.n(keys);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/array/from.js
var array_from = __webpack_require__("c/Tr");
var from_default = /*#__PURE__*/__webpack_require__.n(array_from);

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// EXTERNAL MODULE: ./node_modules/vue-cookie/src/vue-cookie.js
var vue_cookie = __webpack_require__("K/Lq");
var vue_cookie_default = /*#__PURE__*/__webpack_require__.n(vue_cookie);

// EXTERNAL MODULE: ./node_modules/vue-local-storage/dist/index.js
var dist = __webpack_require__("/3Sf");
var dist_default = /*#__PURE__*/__webpack_require__.n(dist);

// EXTERNAL MODULE: ./node_modules/vee-validate/dist/vee-validate.esm.js
var vee_validate_esm = __webpack_require__("sUu7");

// EXTERNAL MODULE: ./node_modules/vue2-filters/dist/vue2-filters.js
var vue2_filters = __webpack_require__("OjAt");
var vue2_filters_default = /*#__PURE__*/__webpack_require__.n(vue2_filters);

// EXTERNAL MODULE: ./node_modules/vue-router/dist/vue-router.esm.js
var vue_router_esm = __webpack_require__("/ocq");

// EXTERNAL MODULE: ./src/components/web/Header.vue + 5 modules
var Header = __webpack_require__("sSzK");

// EXTERNAL MODULE: ./src/components/web/Footer.vue + 2 modules
var Footer = __webpack_require__("uTOX");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/web/404.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var _04 = ({
  name: 'PageNotFound',
  components: {
    HeaderVue: Header["a" /* default */],
    FooterVue: Footer["a" /* default */]
  },
  data: function data() {
    return {};
  },
  beforeCreate: function beforeCreate() {},
  mounted: function mounted() {
    this.$hidePageLoading();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-afb43984","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/web/404.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"PageNotFoundDiv"}},[_c('HeaderVue'),_vm._v(" "),_vm._m(0,false,false),_vm._v(" "),_c('FooterVue')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"green-bg"},[_c('div',{staticClass:"section dashboard-online"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-5"},[_c('h2',{staticClass:"section-title red-color"},[_vm._v("404: THE PAGE YOU REQUESTED DOES NOT EXIST")]),_vm._v(" "),_c('p',{staticClass:"theme-lineheight"},[_vm._v("\n                        Oops. Something obviously isn’t right if you’re reading this. The URL you entered or followed no longer seems to exist, has been removed, or has been replaced. If you feel that this an error that needs to be addressed, feel free to contact the administrator of this website.\n                      ")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-7"},[_c('img',{staticClass:"img-fluid section-img responsive-img",attrs:{"src":"static/images/404.png","alt":""}})])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var web_404 = (esExports);
// CONCATENATED MODULE: ./src/components/web/404.vue
function injectStyle (ssrContext) {
  __webpack_require__("z4O+")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-afb43984"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  _04,
  web_404,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_web_404 = (Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/web/HomeFooter.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var HomeFooter = ({
  name: 'HomeFooterVue',
  beforeCreate: function beforeCreate() {},
  data: function data() {
    return {
      newsLetterEmail: ''
    };
  },

  methods: {
    saveNewsLetter: function saveNewsLetter() {
      var _this = this;

      this.$validator.validateAll('newsletter').then(function (result) {
        if (result) {
          try {
            var data = {
              email: _this.newsLetterEmail
            };
            promise_default.a.resolve(_this.$POST('patient/newsSubscriber', data)).then(function (res) {
              if (res.response_code === 0) {
                this.$Simplert.open({
                  title: 'Success',
                  message: 'Thanks for signup newsletter',
                  type: 'success',
                  disableOverlayClick: true,
                  showXclose: true,
                  useConfirmBtn: false
                });
                // alert('Thanks for signup newsletter')
              } else {
                this.$Simplert.open({
                  message: res.response_message,
                  type: 'success',
                  disableOverlayClick: true,
                  showXclose: true,
                  useConfirmBtn: false
                });
              }
            }.bind(_this)).catch(function (err) {
              console.error(err);
            });
          } catch (e) {
            console.error(e);
          }
        }
      }).catch(function () {
        console.log('error exist while save news letter', _this.errors);
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-254599e4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/web/HomeFooter.vue
var HomeFooter_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"homeFooterDiv"}},[_c('div',{staticClass:"grey-section"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-3"},[_c('p',[_vm._v("ABOUT LABOTIST")]),_vm._v(" "),_c('ul',[_c('li',[_c('router-link',{attrs:{"to":"/about-us"}},[_vm._v("About Us ")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/contact-us"}},[_vm._v("Contact Us")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/privacy-policy"}},[_vm._v("Privacy Policy")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/terms"}},[_vm._v("Terms & Conditions")])],1)])]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('p',[_vm._v("JOIN US")]),_vm._v(" "),_c('ul',[_c('li',[_c('router-link',{attrs:{"to":"/lab-signup"}},[_vm._v("Lab Sign Up")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/phlebotomist-signup"}},[_vm._v("Phlebotomist Sign Up")])],1)])]),_vm._v(" "),_vm._m(0,false,false),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('p',[_vm._v("Newsletter Sign Up")]),_vm._v(" "),_c('div',{staticClass:"subscribe"},[_c('form',{attrs:{"data-vv-scope":"newsletter"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.newsLetterEmail),expression:"newsLetterEmail"},{name:"validate",rawName:"v-validate",value:('required|email|max:200'),expression:"'required|email|max:200'"}],staticClass:"form-control",attrs:{"type":"email","name":"email","data-vv-as":"email address","placeholder":"Enter your email address"},domProps:{"value":(_vm.newsLetterEmail)},on:{"input":function($event){if($event.target.composing){ return; }_vm.newsLetterEmail=$event.target.value}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('newsletter.email')),expression:"errors.has('newsletter.email')"}],staticClass:"help is-danger"},[_vm._v(_vm._s(_vm.errors.first('newsletter.email')))]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",attrs:{"disabled":_vm.errors.has('newsletter.email')},on:{"click":function($event){$event.preventDefault();_vm.saveNewsLetter()}}},[_vm._v("SUBSCRIBE")])])])])])])]),_vm._v(" "),_vm._m(1,false,false)])}
var HomeFooter_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-3"},[_c('p',[_vm._v("FOLLOW US")]),_vm._v(" "),_c('ul',{staticClass:"social-link"},[_c('li',[_c('a',{attrs:{"href":"https://www.facebook.com/labotist","onclick":"window.open(this.href); return false;","onkeypress":"window.open(this.href); return false;"}},[_c('span',{staticClass:"sprites sprite-facebook"})])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"https://twitter.com/labotist","onclick":"window.open(this.href); return false;","onkeypress":"window.open(this.href); return false;"}},[_c('span',{staticClass:"sprites sprite-twitter"})])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"https://www.instagram.com/labotist/?hl=en","onclick":"window.open(this.href); return false;","onkeypress":"window.open(this.href); return false;"}},[_c('span',{staticClass:"sprites sprite-instagram"})])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"copy-right text-center"},[_c('p',[_vm._v("2017 labotist . All rights reserved.")])])}]
var HomeFooter_esExports = { render: HomeFooter_render, staticRenderFns: HomeFooter_staticRenderFns }
/* harmony default export */ var web_HomeFooter = (HomeFooter_esExports);
// CONCATENATED MODULE: ./src/components/web/HomeFooter.vue
function HomeFooter_injectStyle (ssrContext) {
  __webpack_require__("UGDT")
}
var HomeFooter_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var HomeFooter___vue_template_functional__ = false
/* styles */
var HomeFooter___vue_styles__ = HomeFooter_injectStyle
/* scopeId */
var HomeFooter___vue_scopeId__ = "data-v-254599e4"
/* moduleIdentifier (server only) */
var HomeFooter___vue_module_identifier__ = null
var HomeFooter_Component = HomeFooter_normalizeComponent(
  HomeFooter,
  web_HomeFooter,
  HomeFooter___vue_template_functional__,
  HomeFooter___vue_styles__,
  HomeFooter___vue_scopeId__,
  HomeFooter___vue_module_identifier__
)

/* harmony default export */ var components_web_HomeFooter = (HomeFooter_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/web/Home.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var Home = ({
  name: 'Home',
  components: {
    HeaderVue: Header["a" /* default */],
    HomeFooterVue: components_web_HomeFooter
  },
  beforeCreate: function beforeCreate() {
    this.query = this.$localStorage.get('location');
  },
  created: function created() {
    setTimeout(function () {
      $('.slider').bxSlider({
        slideWidth: 'auto',
        minSlides: 1,
        maxSlides: 6,
        moveSlides: 6,
        slideMargin: 10,
        auto: true,
        autoControls: true
      });
      $("#carouselExampleControls").carousel();
      var footHeight = $('.fixed-footer').outerHeight();
      $('body').css('margin-bottom', footHeight);
    }, 100);
  },

  mounted: function mounted() {
    this.$hidePageLoading();
  },
  data: function data() {
    return {
      onBlurKey: 'none',
      address: '',
      query: this.$localStorage.get('location') ? this.$localStorage.get('location').locationName + '-' + this.$localStorage.get('location').locationZipCode : '',
      items: [],
      selectedLocation: this.$localStorage.get('location') ? this.$localStorage.get('location') : undefined,
      selectedPincode: this.$localStorage.get('pincode') ? this.$localStorage.get('pincode') : undefined,
      locationObj: null
    };
  },

  methods: {
    goTest: function goTest() {
      this.query = this.selectedLocation ? this.selectedLocation.locationName + '-' + this.selectedLocation.locationZipCode : '';
      if (!this.selectedLocation) {
        return false;
      }
      this.$localStorage.set('location', this.selectedLocation, 0);
      this.$localStorage.set('pincode', this.selectedLocation.locationZipCode, 0);
      vue_esm["default"].analytics.fbq.event('ViewContent', {
        content_ids: this.selectedLocation.locationId,
        content_name: this.selectedLocation.locationZipCode,
        contents: {
          id: this.selectedLocation.locationId,
          location: this.selectedLocation.locationName,
          zipcode: this.selectedLocation.locationZipCode
        },
        content_type: 'PINCODE_ENTERED'
      });
      this.$router.push({ path: '/lab' });
      //   this.$router.push({ path: '/test' })
    },
    searchLocation: function searchLocation(event) {
      if (event.key === 'Control' || event.key === 'Tab') {
        return false;
      }
      this.onBlurKey = 'block';
      this.selectedLocation = undefined;
      this.$localStorage.remove('location');
      this.$localStorage.remove('pincode');
      if (this.query.length < 3) {
        this.onBlurKey = 'none';
        this.items = [];
        return false;
      }
      try {
        if (this.$localStorage.get('access_token') && this.$localStorage.get('access_token') !== null) {
          var data = {
            'keyword': this.query
          };
          promise_default.a.resolve(this.$POST('patient/searchLocation', data)).then(function (res) {
            console.log(res);
            if (res.response_code === 0) {
              this.items = res.response;
            }
          }.bind(this)).catch(function (err) {
            console.error(err);
          });
        }
      } catch (e) {
        console.error(e);
      }
    },
    closeBlock: function closeBlock() {
      setTimeout(function () {
        this.onBlurKey = 'none';
      }.bind(this), 300);
    },
    selectLocation: function selectLocation(event, obj) {
      this.selectedLocation = undefined;
      this.selectedLocation = obj;
      this.selectedPincode = obj.locationZipCode;
      this.query = obj.locationName + '-' + obj.locationZipCode;
      this.items = [];
      this.onBlurKey = 'none';
      setTimeout(function () {
        this.$refs.pincodeSubmit.focus();
      }.bind(this), 300);
    }
  },
  watch: {
    address: function address(val, oldVal) {
      console.log('new: %s, old: %s', val, oldVal);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-39fda32e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/web/Home.vue
var Home_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"HomeDiv"}},[_c('HeaderVue'),_vm._v(" "),_c('div',{staticClass:"banner-section"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-5"},[_c('div',{staticClass:"banner-text"},[_c('h3',{staticClass:"black-color"},[_vm._v("Your blood tests, Your choice of labs, at Your home")]),_vm._v(" "),_c('h4',[_vm._v("Affordable tests at great convenience")]),_vm._v(" "),_c('p',{staticClass:"mt-4"},[_vm._v("Our service is currently in Chennai & Bengaluru only")]),_vm._v(" "),_c('div',{staticClass:"banner-fields mb-4"},[_c('button',{ref:"pincodeSubmit",staticClass:"btn btn-lg btn-primary w-75",attrs:{"type":"button"},on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.$router.push({ path: '/lab' })}}},[_vm._v("\n                                    Book Test\n                                ")])]),_vm._v(" "),_c('img',{staticClass:"offer-img",attrs:{"src":"static/images/offer.svg","alt":""}})])]),_vm._v(" "),_vm._m(0,false,false)])])]),_vm._v(" "),_vm._m(1,false,false),_vm._v(" "),_vm._m(2,false,false),_vm._v(" "),_vm._m(3,false,false),_vm._v(" "),_c('HomeFooterVue'),_vm._v(" "),_vm._m(4,false,false)],1)}
var Home_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-7"},[_c('div',{staticClass:"carousel slide",attrs:{"id":"carouselExampleControls","data-ride":"carousel"}},[_c('div',{staticClass:"carousel-inner"},[_c('div',{staticClass:"carousel-item active"},[_c('img',{staticClass:"d-block w-100",attrs:{"src":"static/images/banner.svg","alt":""}})]),_vm._v(" "),_c('div',{staticClass:"carousel-item"},[_c('img',{staticClass:"d-block w-100",attrs:{"src":"static/images/banner-old.svg","alt":"Second slide"}})])]),_vm._v(" "),_c('a',{staticClass:"carousel-control-prev",attrs:{"href":"#carouselExampleControls","role":"button","data-slide":"prev"}},[_c('span',{staticClass:"carousel-control-prev-icon",attrs:{"aria-hidden":"true"}},[_c('i',{staticClass:"fa fa-angle-double-left"})]),_vm._v(" "),_c('span',{staticClass:"sr-only"},[_vm._v("Previous")])]),_vm._v(" "),_c('a',{staticClass:"carousel-control-next",attrs:{"href":"#carouselExampleControls","role":"button","data-slide":"next"}},[_c('span',{staticClass:"carousel-control-next-icon",attrs:{"aria-hidden":"true"}},[_c('i',{staticClass:"fa fa-angle-double-right"})]),_vm._v(" "),_c('span',{staticClass:"sr-only"},[_vm._v("Next")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"section",staticStyle:{"padding-top":"80px"}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('h2',{staticClass:"section-title text-center"},[_vm._v("Why Labotist")]),_vm._v(" "),_c('div',{staticClass:"why-labotist"},[_c('div',{staticClass:"future-list"},[_c('span',{staticClass:"sprites sprite-pickup align-center"}),_vm._v(" "),_c('p',[_vm._v("Free Home\n                                    "),_c('br'),_vm._v(" Sample Pickup")])]),_vm._v(" "),_c('div',{staticClass:"future-list"},[_c('span',{staticClass:"sprites sprite-phlebotomists align-center"}),_vm._v(" "),_c('p',[_vm._v("Trained\n                                    "),_c('br'),_vm._v(" Phlebotomists")])]),_vm._v(" "),_c('div',{staticClass:"future-list"},[_c('span',{staticClass:"sprites sprite-shield align-center"}),_vm._v(" "),_c('p',[_vm._v("Technology enabled & safe\n                                    "),_c('br'),_vm._v(" sample collection process")])]),_vm._v(" "),_c('div',{staticClass:"future-list"},[_c('span',{staticClass:"sprites sprite-star align-center"}),_vm._v(" "),_c('p',[_vm._v("Know\n                                    "),_c('br'),_vm._v(" your labs better")])]),_vm._v(" "),_c('div',{staticClass:"future-list"},[_c('span',{staticClass:"sprites sprite-mobile align-center"}),_vm._v(" "),_c('p',[_vm._v("Get\n                                    "),_c('br'),_vm._v(" Online Reports")])])])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"blue-bg"},[_c('div',{staticClass:"section"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('img',{staticClass:"img-fluid section-img kit-img",attrs:{"src":"static/images/kit.svg","alt":""}})]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('h2',{staticClass:"section-title"},[_vm._v("We created a specially designed box and universal kit for you to ensure accurate results")]),_vm._v(" "),_c('ul',{staticClass:"kit-list"},[_c('li',[_vm._v("Disposable")]),_vm._v(" "),_c('li',[_vm._v("Pre-bar coded tubes")]),_vm._v(" "),_c('li',[_vm._v("Hygienic sample draw accessories")]),_vm._v(" "),_c('li',[_vm._v("Insulated box for safe transportation of samples")]),_vm._v(" "),_c('li',[_vm._v("Temperature controlled to ensure sample quality")])])])])])]),_vm._v(" "),_c('div',{staticClass:"section"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('h2',{staticClass:"section-title text-center"},[_vm._v("How Labotist Works?")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"white-box"},[_c('div',{staticClass:"white-content"},[_c('span',{staticClass:"sprites sprite-one"}),_vm._v(" "),_c('h5',[_vm._v("Choose test and select lab")]),_vm._v(" "),_c('p',[_vm._v("Select the right test and the best lab based on quality, turn around time, method of\n                                        testing & price, and book your test digitally ")])])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"white-box"},[_c('div',{staticClass:"white-content"},[_c('span',{staticClass:"sprites sprite-two"}),_vm._v(" "),_c('h5',[_vm._v("Sample collected at home")]),_vm._v(" "),_c('p',[_vm._v("A trained phlebotomist will come to your home at the scheduled time to collect the sample in a safe & hygienic method and deliver it to the choosen lab making it very convenient for you.")])])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"white-box"},[_c('div',{staticClass:"white-content"},[_c('span',{staticClass:"sprites sprite-three"}),_vm._v(" "),_c('h5',[_vm._v("Safe, Secure & Accurate")]),_vm._v(" "),_c('p',[_vm._v("The technology driven sample collection process and transportation of samples in a specially designed box, ensures superior sample quality, enabling accurate results.")])])])])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"green-bg"},[_c('div',{staticClass:"section dashboard-online"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-5"},[_c('h2',{staticClass:"section-title"},[_vm._v("Your personal\n                                "),_c('br'),_vm._v(" dashboard online")]),_vm._v(" "),_c('p',{staticClass:"theme-lineheight"},[_vm._v("All lab reports, irrespective of the lab at which you get your tests done, will be stored under\n                                one registered account securely. You will also be able to manage your records or that of\n                                family members under one account. Labotist provides easy access to health records and history whenever and whereever needed.")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-7"},[_c('img',{staticClass:"img-fluid section-img responsive-img",attrs:{"src":"static/images/responsive.svg","alt":""}})])])])]),_vm._v(" "),_c('div',{staticClass:"section"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('h2',{staticClass:"section-title text-center"},[_vm._v("Customer Testimonials")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6 col-lg-4"},[_c('div',{staticClass:"testimonial-box"},[_c('p',[_vm._v("The lab test search and selection of labs was very simple. I was able to make a well informed decision on the lab instead of by default opting to go the nearest one or the one which my doctor asks me to go")])]),_vm._v(" "),_c('div',{staticClass:"testimonial-profile clearfix"},[_c('div',{staticClass:"testimonial-dp",staticStyle:{"background-image":"url(static/images/kumaresh.png)","background-size":"100%"}}),_vm._v(" "),_c('h5',[_vm._v("Kumaresh")]),_vm._v(" "),_c('p',[_vm._v("IT Engineer")])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6 col-lg-4"},[_c('div',{staticClass:"testimonial-box"},[_c('p',[_vm._v("You guys rock. Such a convenient way to research, order and get samples collected and delivered professionally..all just through a few clicks. A great experience.")])]),_vm._v(" "),_c('div',{staticClass:"testimonial-profile clearfix"},[_c('div',{staticClass:"testimonial-dp",staticStyle:{"background-image":"url(static/images/imran.png)","background-size":"100%"}}),_vm._v(" "),_c('h5',[_vm._v("Imran")]),_vm._v(" "),_c('p',[_vm._v("Director of Photography")])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6 col-lg-4"},[_c('div',{staticClass:"testimonial-box"},[_c('p',[_vm._v("First time I ever felt pampered during the blood draw process :). Quick, easy & hygienic. Technology working at its best to ensure safety, quality and convenience.")])]),_vm._v(" "),_c('div',{staticClass:"testimonial-profile clearfix"},[_c('div',{staticClass:"testimonial-dp",staticStyle:{"background-image":"url(static/images/hemavathy.png)","background-size":"100%"}}),_vm._v(" "),_c('h5',[_vm._v("Hemavathy")]),_vm._v(" "),_c('p',[_vm._v("Housewife")])])])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fixed-footer"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-1"},[_c('h5',{staticClass:"text-sm-left foot-title text-nowrap"},[_c('b',[_c('span',{staticClass:"blue-color"},[_vm._v("Our Lab")]),_vm._v(" "),_c('br',{staticClass:"sm-hidden"}),_vm._v(" "),_c('span',{staticClass:"green-color"},[_vm._v("Partners")])])]),_vm._v(" "),_c('div',{staticClass:"left-line"})]),_vm._v(" "),_c('div',{staticClass:"col-sm-11"},[_c('div',{staticClass:"slider"},[_c('div',{staticClass:"slide"},[_c('div',{staticClass:"card"},[_c('img',{staticClass:"card-img-top",attrs:{"src":"static/images/client/medall.jpg","alt":"Medall Health Care Pvt Ltd"}})])]),_vm._v(" "),_c('div',{staticClass:"slide"},[_c('div',{staticClass:"card"},[_c('img',{staticClass:"card-img-top",attrs:{"src":"static/images/client/metroplis.png","alt":"Lister Metropolis Healthcare Limited"}})])]),_vm._v(" "),_c('div',{staticClass:"slide"},[_c('div',{staticClass:"card"},[_c('img',{staticClass:"card-img-top",attrs:{"src":"static/images/client/bioline.jpg","alt":"Bio Line Laboratory"}})])]),_vm._v(" "),_c('div',{staticClass:"slide"},[_c('div',{staticClass:"card"},[_c('img',{staticClass:"card-img-top",attrs:{"src":"static/images/client/techmed.jpg","alt":"Techmed Health Centre & Diagnostic"}})])]),_vm._v(" "),_c('div',{staticClass:"slide"},[_c('div',{staticClass:"card"},[_c('img',{staticClass:"card-img-top",attrs:{"src":"static/images/client/srl.png","alt":"Specialtys Medical Diagnostic(SRL Diagnostics)"}})])]),_vm._v(" "),_c('div',{staticClass:"slide"},[_c('div',{staticClass:"card"},[_c('img',{staticClass:"card-img-top",attrs:{"src":"static/images/client/vrr.jpg","alt":"VRR Diagnostics"}})])]),_vm._v(" "),_c('div',{staticClass:"slide"},[_c('div',{staticClass:"card"},[_c('img',{staticClass:"card-img-top",attrs:{"src":"static/images/client/medcis.png","alt":"Medcis Pathlabs India Pvt. Ltd"}})])]),_vm._v(" "),_c('div',{staticClass:"slide"},[_c('div',{staticClass:"card"},[_c('img',{staticClass:"card-img-top",attrs:{"src":"static/images/client/pathcare.jpg","alt":"Path Care Labs Pvt. Ltd"}})])]),_vm._v(" "),_c('div',{staticClass:"slide"},[_c('div',{staticClass:"card"},[_c('img',{staticClass:"card-img-top",attrs:{"src":"static/images/client/aarthi.jpg","alt":"Aarthi Scans And Labs"}})])]),_vm._v(" "),_c('div',{staticClass:"slide"},[_c('div',{staticClass:"card"},[_c('img',{staticClass:"card-img-top",attrs:{"src":"static/images/client/primex.png","alt":"Primex Scans and Labs"}})])]),_vm._v(" "),_c('div',{staticClass:"slide"},[_c('div',{staticClass:"card"},[_c('img',{staticClass:"card-img-top",attrs:{"src":"static/images/client/microbiological.jpg","alt":"Microbiological Laboratory"}})])]),_vm._v(" "),_c('div',{staticClass:"slide"},[_c('div',{staticClass:"card"},[_c('img',{staticClass:"card-img-top",attrs:{"src":"static/images/client/hitech.jpg","alt":"Hitech Diagnostic Centre"}})])]),_vm._v(" "),_c('div',{staticClass:"slide"},[_c('div',{staticClass:"card"},[_c('img',{staticClass:"card-img-top",attrs:{"src":"static/images/client/asian.jpg","alt":"Asian Diagnostics"}})])]),_vm._v(" "),_c('div',{staticClass:"slide"},[_c('div',{staticClass:"card"},[_c('img',{staticClass:"card-img-top",attrs:{"src":"static/images/client/diagnolabs.jpg","alt":"Diagno labs Pvt Ltd"}})])])])])])])])}]
var Home_esExports = { render: Home_render, staticRenderFns: Home_staticRenderFns }
/* harmony default export */ var web_Home = (Home_esExports);
// CONCATENATED MODULE: ./src/components/web/Home.vue
function Home_injectStyle (ssrContext) {
  __webpack_require__("ncd9")
}
var Home_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var Home___vue_template_functional__ = false
/* styles */
var Home___vue_styles__ = Home_injectStyle
/* scopeId */
var Home___vue_scopeId__ = "data-v-39fda32e"
/* moduleIdentifier (server only) */
var Home___vue_module_identifier__ = null
var Home_Component = Home_normalizeComponent(
  Home,
  web_Home,
  Home___vue_template_functional__,
  Home___vue_styles__,
  Home___vue_scopeId__,
  Home___vue_module_identifier__
)

/* harmony default export */ var components_web_Home = (Home_Component.exports);

// EXTERNAL MODULE: ./src/components/mobile/Header.vue + 2 modules
var mobile_Header = __webpack_require__("Ucjp");

// EXTERNAL MODULE: ./src/components/mobile/Footer.vue + 2 modules
var mobile_Footer = __webpack_require__("SN8v");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/web/Dashboard.vue
//
//
//
//
//
//
//
//

// import Login from '@/components/Login'




/* harmony default export */ var Dashboard = ({
  name: 'Home',
  components: {
    HeaderVue: mobile_Header["a" /* default */],
    FooterVue: mobile_Footer["a" /* default */]
  },
  beforeCreate: function beforeCreate() {
    this.$router.push({ path: '/' });
  },
  created: function created() {
    setTimeout(function () {
      $("#carouselExampleControls").carousel();
      $("#carouselLabPartners").carousel();
    }, 1000);
  },
  data: function data() {
    return {
      onBlurKey: 'none',
      address: '',
      query: this.$localStorage.get('location') ? this.$localStorage.get('location').locationName + '-' + this.$localStorage.get('location').locationZipCode : '',
      items: [],
      selectedLocation: this.$localStorage.get('location') ? this.$localStorage.get('location') : undefined,
      selectedPincode: this.$localStorage.get('pincode') ? this.$localStorage.get('pincode') : undefined,
      locationObj: null
    };
  },

  methods: {},
  watch: {},
  mounted: function mounted() {
    this.$hidePageLoading();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7cb65bfa","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/web/Dashboard.vue
var Dashboard_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"HomeDiv"}},[_c('HeaderVue',{attrs:{"isHeader":"true"}}),_vm._v(" "),_c('FooterVue',{attrs:{"foot":"true"}})],1)}
var Dashboard_staticRenderFns = []
var Dashboard_esExports = { render: Dashboard_render, staticRenderFns: Dashboard_staticRenderFns }
/* harmony default export */ var web_Dashboard = (Dashboard_esExports);
// CONCATENATED MODULE: ./src/components/web/Dashboard.vue
function Dashboard_injectStyle (ssrContext) {
  __webpack_require__("Ea5o")
}
var Dashboard_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var Dashboard___vue_template_functional__ = false
/* styles */
var Dashboard___vue_styles__ = Dashboard_injectStyle
/* scopeId */
var Dashboard___vue_scopeId__ = "data-v-7cb65bfa"
/* moduleIdentifier (server only) */
var Dashboard___vue_module_identifier__ = null
var Dashboard_Component = Dashboard_normalizeComponent(
  Dashboard,
  web_Dashboard,
  Dashboard___vue_template_functional__,
  Dashboard___vue_styles__,
  Dashboard___vue_scopeId__,
  Dashboard___vue_module_identifier__
)

/* harmony default export */ var components_web_Dashboard = (Dashboard_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/web/Public/Sidemenu.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var Sidemenu = ({
  name: 'Sidemenu',
  data: function data() {
    return {};
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-88c999bc","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/web/Public/Sidemenu.vue
var Sidemenu_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"aboutusDiv"}},[_c('ul',{staticClass:"side-menu"},[_c('li',[_c('router-link',{attrs:{"to":"/about-us"}},[_vm._v("About Us ")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/contact-us"}},[_vm._v("Contact Us")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/privacy-policy"}},[_vm._v("Privacy Policy")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/terms"}},[_vm._v("Terms & Conditions")])],1)])])}
var Sidemenu_staticRenderFns = []
var Sidemenu_esExports = { render: Sidemenu_render, staticRenderFns: Sidemenu_staticRenderFns }
/* harmony default export */ var Public_Sidemenu = (Sidemenu_esExports);
// CONCATENATED MODULE: ./src/components/web/Public/Sidemenu.vue
function Sidemenu_injectStyle (ssrContext) {
  __webpack_require__("/+i8")
}
var Sidemenu_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var Sidemenu___vue_template_functional__ = false
/* styles */
var Sidemenu___vue_styles__ = Sidemenu_injectStyle
/* scopeId */
var Sidemenu___vue_scopeId__ = "data-v-88c999bc"
/* moduleIdentifier (server only) */
var Sidemenu___vue_module_identifier__ = null
var Sidemenu_Component = Sidemenu_normalizeComponent(
  Sidemenu,
  Public_Sidemenu,
  Sidemenu___vue_template_functional__,
  Sidemenu___vue_styles__,
  Sidemenu___vue_scopeId__,
  Sidemenu___vue_module_identifier__
)

/* harmony default export */ var web_Public_Sidemenu = (Sidemenu_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/web/Public/Aboutus.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var Aboutus = ({
  name: 'Aboutus',
  data: function data() {
    return {};
  },

  components: {
    HeaderVue: Header["a" /* default */],
    Sidemenu: web_Public_Sidemenu,
    FooterVue: Footer["a" /* default */]
  },
  beforeCreate: function beforeCreate() {},
  mounted: function mounted() {
    this.$hidePageLoading();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-29b2512f","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/web/Public/Aboutus.vue
var Aboutus_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"aboutusDiv"}},[_c('HeaderVue'),_vm._v(" "),_c('div',{staticClass:"inner-page"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-3"},[_c('Sidemenu')],1),_vm._v(" "),_vm._m(0,false,false)])])]),_vm._v(" "),_c('FooterVue')],1)}
var Aboutus_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-9"},[_c('h3',[_vm._v("About Us")]),_vm._v(" "),_c('p',[_vm._v("Labotist is a convenient, technology driven platform that serves as a one stop solution for patients\n                        to easily choose from, and connect with various labs across the city. It is an online marketplace for lab services, \n                        offering patients the convenience of making their choice based on location, cost\n                        of test, quality and turnaround time. Patients also enjoy the added luxury of getting their samples\n                        collected in the comforts of their home by a trained phlebotomist.")]),_vm._v(" "),_c('h3',[_vm._v("How does it work?")]),_vm._v(" "),_c('img',{staticClass:"img-fluid full-width",attrs:{"src":"static/images/about-us.svg","alt":""}}),_vm._v(" "),_c('p',[_vm._v("Patients can visit labotist.com and research for the specific test and profiles that need to be done.\n                        Labotist.com is a lab aggregator and shares all the relevant details, including price, discounts\n                        if any, quality and certifications, typical turnaround time etc. Based on the results, patients\n                        can then choose the lab they would like to engage with.")]),_vm._v(" "),_c('p',[_vm._v("Once a lab has been selected, patients can schedule home sample collection requests at a convenient\n                        date & time. The request gets transmitted to all registered and certified phlebotomists operating\n                        in the area. On the Phlebotomist mobile app, the Phlebotomists can accept the request based on\n                        their convenience and availability. Once accepted, the request is then automatically scheduled\n                        in Phlebotomist’s calendar. When the phlebotomist goes to the patient’s house for sample collection,\n                        the mobile app enables technology guided sample collection process thereby ensuring safety &\n                        accuracy throughout the process. Phlebotomists then deliver the sample to lab chosen by the patient.")]),_vm._v(" "),_c('p',[_vm._v("After processing the samples, the partnering lab then sends the reports to Labotist. Once verified,\n                        the reports are then delivered to the patients, on the Patient Web App. Here, patients can store\n                        and access at once, all the lab reports that have been processed by Labotist (across the different\n                        labs they have opted thus far through Labotist).")])])}]
var Aboutus_esExports = { render: Aboutus_render, staticRenderFns: Aboutus_staticRenderFns }
/* harmony default export */ var Public_Aboutus = (Aboutus_esExports);
// CONCATENATED MODULE: ./src/components/web/Public/Aboutus.vue
function Aboutus_injectStyle (ssrContext) {
  __webpack_require__("vcnv")
}
var Aboutus_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var Aboutus___vue_template_functional__ = false
/* styles */
var Aboutus___vue_styles__ = Aboutus_injectStyle
/* scopeId */
var Aboutus___vue_scopeId__ = "data-v-29b2512f"
/* moduleIdentifier (server only) */
var Aboutus___vue_module_identifier__ = null
var Aboutus_Component = Aboutus_normalizeComponent(
  Aboutus,
  Public_Aboutus,
  Aboutus___vue_template_functional__,
  Aboutus___vue_styles__,
  Aboutus___vue_scopeId__,
  Aboutus___vue_module_identifier__
)

/* harmony default export */ var web_Public_Aboutus = (Aboutus_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/web/Public/Contactus.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var Contactus = ({
  name: 'Contactus',
  components: {
    HeaderVue: Header["a" /* default */],
    FooterVue: Footer["a" /* default */],
    Sidemenu: web_Public_Sidemenu
  },
  beforeCreate: function beforeCreate() {},
  data: function data() {
    return {
      name: '',
      email: '',
      mobile: '',
      message: '',
      success: false
    };
  },

  methods: {
    save: function save() {
      this.$validator.validateAll('contact').then(function (result) {
        if (result) {
          try {
            if (this.name !== '' && this.email !== '' && this.mobile !== '' && this.message !== '') {
              var data = {
                'name': this.name,
                'email': this.email,
                'mobile': this.mobile,
                'message': this.message
              };
              promise_default.a.resolve(this.$POST('patient/contact', data)).then(function (res) {
                if (res.response_code === 0) {
                  this.success = true;
                  //   location.reload()
                  this.$Simplert.open({
                    title: 'Success',
                    message: 'Thanks for contact us. We will touch with you soon.',
                    type: 'warning',
                    disableOverlayClick: true,
                    showXclose: true,
                    useConfirmBtn: false,
                    customCloseBtnText: 'OK'
                  });
                  this.reset();
                }
              }.bind(this)).catch(function (err) {
                console.error(err);
                this.$Simplert.open({
                  title: 'Oops',
                  message: 'Something went wrong please mail us support@labotist.com',
                  type: 'warning',
                  disableOverlayClick: true,
                  showXclose: true,
                  useConfirmBtn: false,
                  customCloseBtnText: 'OK'
                });
                // alert('Something went wrong please mail us support@labotist.com')
              }.bind(this));
            }
          } catch (e) {
            console.error(e);
          }
        }
      }.bind(this));
    },
    reset: function reset() {
      this.errors.items = [];
      this.name = '';
      this.email = '';
      this.mobile = '';
      this.message = '';
      this.success = false;
      setTimeout(function () {
        this.errors.items = [];
      }.bind(this), 30);
    }
  },
  mounted: function mounted() {
    this.$hidePageLoading();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c5ca86fc","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/web/Public/Contactus.vue
var Contactus_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"contactusDiv"}},[_c('HeaderVue'),_vm._v(" "),_c('div',{staticClass:"inner-page"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-3"},[_c('Sidemenu')],1),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"sign-up"},[_vm._m(0,false,false),_vm._v(" "),_c('div',{staticClass:"form-content line-textbox"},[_c('form',{attrs:{"data-vv-scope":"contact"}},[_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.name),expression:"name"},{name:"validate",rawName:"v-validate",value:('required|alpha_spaces|max:75'),expression:"'required|alpha_spaces|max:75'"}],staticClass:"form-control",attrs:{"type":"text","name":"name","data-vv-as":"name","placeholder":"Name"},domProps:{"value":(_vm.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.name=$event.target.value}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('contact.name')),expression:"errors.has('contact.name')"}],staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('contact.name')))])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email),expression:"email"},{name:"validate",rawName:"v-validate",value:('required|email|max:100'),expression:"'required|email|max:100'"}],staticClass:"form-control",attrs:{"type":"email","data-vv-as":"email address","name":"email","placeholder":"Email Address"},domProps:{"value":(_vm.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.email=$event.target.value}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('contact.email')),expression:"errors.has('contact.email')"}],staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('contact.email')))])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.mobile),expression:"mobile"},{name:"validate",rawName:"v-validate",value:('required|numeric|max:10|min:10'),expression:"'required|numeric|max:10|min:10'"}],staticClass:"form-control",attrs:{"type":"text","name":"mobile","data-vv-as":"mobile no.","placeholder":"Mobile No."},domProps:{"value":(_vm.mobile)},on:{"input":function($event){if($event.target.composing){ return; }_vm.mobile=$event.target.value}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('contact.mobile')),expression:"errors.has('contact.mobile')"}],staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('contact.mobile')))])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.message),expression:"message"},{name:"validate",rawName:"v-validate",value:('required|max:2000'),expression:"'required|max:2000'"}],staticClass:"form-control",attrs:{"name":"message","data-vv-as":"message","placeholder":"Message","cols":"30","rows":"3"},domProps:{"value":(_vm.message)},on:{"input":function($event){if($event.target.composing){ return; }_vm.message=$event.target.value}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('contact.message')),expression:"errors.has('contact.message')"}],staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('contact.message')))])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('button',{staticClass:"btn btn-link full-width",on:{"click":function($event){$event.preventDefault();_vm.reset()}}},[_vm._v("Reset")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('button',{staticClass:"btn btn-primary full-width",attrs:{"disabled":(_vm.errors.any())},on:{"click":function($event){$event.preventDefault();_vm.save()}}},[_vm._v("Send")])])])])])])]),_vm._v(" "),_vm._m(1,false,false)])])]),_vm._v(" "),_c('FooterVue')],1)}
var Contactus_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"signup-title"},[_c('h3',[_vm._v("Contact Us / Feedback")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-3"},[_c('div',{staticClass:"get-in-touch"},[_c('h5',[_vm._v("Get in touch")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Labotist Private Limited")])]),_vm._v(" "),_c('p',[_vm._v("Ph:"),_c('a',{attrs:{"href":"tel:+919025662566"}},[_vm._v(" +91 90256 62566")])]),_vm._v(" "),_c('p',[_vm._v("Email: "),_c('a',{attrs:{"href":"mailto:support@labotist.com","target":"_top"}},[_vm._v("support@labotist.com")])])])])}]
var Contactus_esExports = { render: Contactus_render, staticRenderFns: Contactus_staticRenderFns }
/* harmony default export */ var Public_Contactus = (Contactus_esExports);
// CONCATENATED MODULE: ./src/components/web/Public/Contactus.vue
function Contactus_injectStyle (ssrContext) {
  __webpack_require__("CV2+")
}
var Contactus_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var Contactus___vue_template_functional__ = false
/* styles */
var Contactus___vue_styles__ = Contactus_injectStyle
/* scopeId */
var Contactus___vue_scopeId__ = "data-v-c5ca86fc"
/* moduleIdentifier (server only) */
var Contactus___vue_module_identifier__ = null
var Contactus_Component = Contactus_normalizeComponent(
  Contactus,
  Public_Contactus,
  Contactus___vue_template_functional__,
  Contactus___vue_styles__,
  Contactus___vue_scopeId__,
  Contactus___vue_module_identifier__
)

/* harmony default export */ var web_Public_Contactus = (Contactus_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/web/Public/Privacy.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var Privacy = ({
  name: 'Privacy',
  components: {
    HeaderVue: Header["a" /* default */],
    Sidemenu: web_Public_Sidemenu,
    FooterVue: Footer["a" /* default */]
  },
  beforeCreate: function beforeCreate() {},
  data: function data() {
    return {};
  },
  mounted: function mounted() {
    this.$hidePageLoading();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0a7d5b4c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/web/Public/Privacy.vue
var Privacy_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"privacyDiv"}},[_c('HeaderVue'),_vm._v(" "),_c('div',{staticClass:"inner-page"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-3"},[_c('Sidemenu')],1),_vm._v(" "),_vm._m(0,false,false)])])]),_vm._v(" "),_c('FooterVue')],1)}
var Privacy_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-9 privacyPolicy"},[_c('h3',[_vm._v("Privacy Policy")]),_vm._v(" "),_c('p',[_vm._v("About Labotist Private Limited ")]),_vm._v(" "),_c('p',[_vm._v("Labotist Private Limited (“"),_c('b',[_vm._v("We")]),_vm._v("” and/or “"),_c('b',[_vm._v("Us")]),_vm._v("” and/or “"),_c('b',[_vm._v("Company")]),_vm._v("”) is a company incorporated under the Companies Act, 2013. Our website is a convenient, technology driven platform that serves as a one stop solution for patients to easily choose from, and connect with various labs across the city. It is an online marketplace for lab services, offering patients the convenience of making their choice based on location, cost of test, quality and turnaround time. Patients also enjoy the added luxury of getting their samples collected in the comforts of their home by a trained phlebotomist.")]),_vm._v(" "),_c('p',[_vm._v("Similarly, our Website also serves as a marketplace for phlebotomists who are registered on our website. Our Company screens the phlebotomist as commercially viable and creates a well-intended marketplace for phlebotomist to serve as micro entrepreneurs.")]),_vm._v(" "),_c('p',[_vm._v("The Company is concerned about the privacy of its users (\""),_c('b',[_vm._v("User(s)")]),_vm._v("\" and/or \""),_c('b',[_vm._v("You")]),_vm._v("\" and/or “"),_c('b',[_vm._v("Your")]),_vm._v("”) accessing its Website. online platform in the name and style of www.labotist.com (the \""),_c('b',[_vm._v("Website")]),_vm._v("\").")]),_vm._v(" "),_c('p',[_vm._v("Please read the Privacy Policy (“"),_c('b',[_vm._v("Policy")]),_vm._v("”) carefully before using the Website, along with the Terms of Use (“"),_c('b',[_vm._v("Terms")]),_vm._v("”) provided on the Website. Your use of the Website or the services provided by the Website shall signify Your acceptance of this Policy and Your agreement to be legally bound by the same.")]),_vm._v(" "),_c('p',[_vm._v("If You do not agree with the terms of this Policy, do not use the Website or avail any of the services offered on this Website.")]),_vm._v(" "),_c('h4',[_vm._v("About the policy")]),_vm._v(" "),_c('p',[_vm._v("When You register with the Website, We may seek and collect certain personal information for Your use of the Website. You consent to the collection, use, and disclosure of the information in accordance with this Policy. Therefore, We request You to read this Policy carefully before using the Website. ")]),_vm._v(" "),_c('p',[_vm._v("Please note that, We respect and value Your privacy and shall strive towards protecting the information that You provide. We shall keep the information provided to Us as confidential to the extent reasonably possible. You understand that, by registering on the Website, your personal information may be collected. If at any time You wish to have Your information deleted, You can write to "),_c('i',[_vm._v("support@labotist.com")]),_vm._v(". We shall do the needful within 5 working days but We may retain certain information for internal purposes if required under applicable law.")]),_vm._v(" "),_c('p',[_vm._v("Your privacy is of utmost importance to us. We shall process and save your information in accordance with the Information Technology Act, 2000 and the Information Technology (Reasonable Security Practices And Procedures And Sensitive Personal Data Or Information) Rules, 2011.")]),_vm._v(" "),_c('h4',[_vm._v("collection of personally identifiable information")]),_vm._v(" "),_c('p',[_vm._v("We collect personally identifiable information (name, phone number, email etc.) from you when you request for a service. We do not for any reason whatsoever sell your Personal Identifiable Information to any third party or otherwise trade on it.")]),_vm._v(" "),_c('p',[_vm._v("The personal information You may provide to Us that We may use is as follows:")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("Registration details: This will include the password provided by You for which We use reasonable security measures for password protection from anyone.")]),_vm._v(" "),_c('li',[_vm._v("Your usage behavior on the Website.")]),_vm._v(" "),_c('li',[_vm._v("The details of the computer system or computer network that You use to visit the Website and any activities undertaken through the usage of the Website.")]),_vm._v(" "),_c('li',[_vm._v("Your first and last name, e-mail address, phone number, billing and shipping address.")])]),_vm._v(" "),_c('p',[_vm._v("The fundamental reason behind collecting Your personal information is to support and facilitate You to enjoy various features and services provided on the Website. ")]),_vm._v(" "),_c('p',[_vm._v("We select and track Your preferences to provide You with a customized Website experience, to notify You of any updated information and new developments/features and other related functions offered by the Website, to otherwise support Your relationship with Us and to prevent fraud and unlawful use.")]),_vm._v(" "),_c('p',[_vm._v("By accepting the terms of this Policy, You understand, agree and recognize that our storage and processing of Your personal information is for a lawful purpose associated with a function or an activity of the Website. You further understand, agree and acknowledge that You may be required to provide personal information that is classified as sensitive personal information as per applicable laws for Us to provide various services. ")]),_vm._v(" "),_c('p',[_vm._v("Please note that, it is entirely up to the discretion of the User to provide this personal information. However, the User would not be able to avail the services provided by Us if this information is denied.")]),_vm._v(" "),_c('p',[_vm._v("We do not sell, trade or rent Your personal information to any third party unless We have been expressly authorized by You either in writing or electronically to do so. We may at times provide aggregate statistics about our customers, traffic patterns, and related site information to reputable third parties, however this information when disclosed will be in an aggregate form and does not contain any of Your personally identifiable information.")]),_vm._v(" "),_c('p',[_vm._v("You may note that, We adopt reasonable security measures to protect Your password from being exposed or disclosed to anyone")]),_vm._v(" "),_c('h4',[_vm._v("information sharing and disclosure:")]),_vm._v(" "),_c('p',[_vm._v("We are the recipient of all the personal information and shall exercise reasonable care to keep Your personal information confidential to the maximum possible extent. We may limit disclosure of the Users' information to our entities, joint ventures, agents, sellers or third parties for the purposes of the services provided by them or for any other marketing related activity undertaken by or on behalf of our entities and/or its joint ventures on a need-to-know basis. We shall not be liable for any unauthorized use or disclosure of the personal information by any sellers participating on our Websites.")]),_vm._v(" "),_c('p',[_vm._v("We may use the information We collect from You when You register, place an order, sign up for our newsletter, respond to a survey or marketing communication, surf the Website, or use certain other site features in the following ways: To personalize your experience and to allow us to deliver the type of content and product offerings in which you are most interested. ")]),_vm._v(" "),_c('h4',[_vm._v("legal compliance")]),_vm._v(" "),_c('p',[_vm._v("We abide by all the applicable laws in force as well as the mandates of government agencies. We will disclose any information about You to government or law enforcement officials or private parties that We, in our sole discretion, believe necessary or appropriate to respond to claims and legal processes, to protect the property and rights of the Company or a third party, to protect the safety of the public or any person, or to prevent or stop any illegal, unethical or legally fraudulent activity. We may also provide Your personal information to various regulatory authorities upon any demand or request from them.")]),_vm._v(" "),_c('p',[_vm._v("We may provide your personal information, in connection with a merger, acquisition, reorganization or sale of assets or in the event of bankruptcy of the Company.")]),_vm._v(" "),_c('p',[_vm._v("We do not use vulnerability scanning and/or scanning for payment transaction. All our scanning with respect to payments is in compliant with Payment Card Industry Data Security Standard (“"),_c('b',[_vm._v("PCI")]),_vm._v("”) standards. An external PCI compliant payment gateway handles all our credit card transactions. We use regular malware scanning. Your personal information is contained behind secured networks and is only accessible by a limited number of persons who have special access rights to such systems, and are required to keep the information confidential. In addition, all sensitive/credit information you supply is encrypted via Secure Socket Layer (“SSL”) technology. We implement a variety of security measures when a user places an order enters, submits, or accesses their information to maintain the safety of your personal information. All transactions are processed through a gateway provider and are not stored or processed on our servers. ")]),_vm._v(" "),_c('h4',[_vm._v("email policies")]),_vm._v(" "),_c('p',[_vm._v("You can choose the type of emails that You wish to receive from Us. If You decide at any time that You no longer wish to receive such communications from Us, please follow the unsubscribe instructions provided in any of the communications. Please note that, once We receive Your request, it may take an additional period of time for Your subscription to become ineffective.")]),_vm._v(" "),_c('h4',[_vm._v("deletion of your information:")]),_vm._v(" "),_c('p',[_vm._v("If You wish to have the personal information that You have provided to us deleted, You can do so by writing to "),_c('i',[_vm._v("support@labotist.com")]),_vm._v(". Please note that deletion of certain personal information may lead to deletion of Your account with the Website and Your access to certain features of the Website.  You understand that under certain circumstances, the request for the deletion of personal information can be denied.")]),_vm._v(" "),_c('h4',[_vm._v("security:")]),_vm._v(" "),_c('p',[_vm._v("We strive to work towards the security, integrity and privacy of Your personal information and to protect Your personal information against unauthorized disclosure, access or destruction to the extent reasonably possible by Us. Notwithstanding anything contained in this Policy or elsewhere, We shall not be held responsible for any loss, damage or misuse of Your personal information, if such loss, damage or misuse takes place as a result of a Force Majeure Event (as defined below).")]),_vm._v(" "),_c('p',[_vm._v("A \""),_c('b',[_vm._v("Force Majeure Event")]),_vm._v("\" shall mean any event that is beyond our reasonable control and shall include, without limitation, fire, flood, explosion, acts of God, civil commotion, strikes, insurrection, war, acts of government, computer hacking, software failure and storage device, computer crashes etc")]),_vm._v(" "),_c('h4',[_vm._v("third-party disclosure")]),_vm._v(" "),_c('p',[_vm._v("We may disclose Your personal information solely in the legitimate conduct of the business to deliver services to meet Your demands. We may also release information when We believe, in good faith, that such release is reasonably necessary to (1) comply with legal or regulatory requirements; (2) enforce or apply terms of use of our Website; or (3) protect our rights, property or safety of the rights of others.")]),_vm._v(" "),_c('p',[_vm._v("Although We do not sell, trade, or otherwise transfer to outside parties your personally identifiable information unless we provide users with advance notice, this does not include website hosting partners and other parties who assist us in operating our website, conducting our business, or serving our users, so long as those parties agree to keep this information confidential. We may also release information when its release is appropriate to comply with the law, enforce our site policies, or protect ours or others' rights, property or safety.")]),_vm._v(" "),_c('p',[_vm._v("However, non-personally identifiable visitor information may be provided to other parties for marketing, advertising, or other uses.")]),_vm._v(" "),_c('h4',[_vm._v("links to other sites")]),_vm._v(" "),_c('p',[_vm._v("The Website may provide third-party advertisements and links to other websites. We do not provide Your personal information to these third-party websites or advertisers.")]),_vm._v(" "),_c('p',[_vm._v("The links to other websites are operated by third parties and are not controlled by, or affiliated to, or associated with Us unless expressly specified on the Website. Therefore, We do not make any claims concerning the privacy practices or policies of such third parties or terms of use of such websites, nor do We control or guarantee or endorse the accuracy, integrity, or quality of the information available on such websites. Any information provided by You to such third party websites shall be governed in accordance with the privacy policies of the respective websites and it is strongly recommended that You review the privacy policy on any such websites prior to using such websites.")]),_vm._v(" "),_c('h4',[_vm._v("google")]),_vm._v(" "),_c('p',[_vm._v("Google's advertising requirements can be summed up by Google's Advertising Principles. They are put in place to provide a positive experience for users. Click here to view We use Google AdSense Advertising on our Website.")]),_vm._v(" "),_c('p',[_vm._v("Google, as a third-party vendor, uses cookies to serve ads on our site. Google's use of the DART cookie enables it to serve ads to our users based on previous visits to our site and other sites on the Internet. Users may opt-out of the use of the DART cookie by visiting the Google Ad and Content Network privacy policy.")]),_vm._v(" "),_c('p',[_vm._v("We have implemented the following:")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("Google Display Network Impression Reporting")]),_vm._v(" "),_c('li',[_vm._v("Demographics and Interests Reporting")])]),_vm._v(" "),_c('p',[_vm._v("We, along with third-party vendors such as Google use first-party cookies (such as the Google Analytics cookies) and third-party cookies (such as the DoubleClick cookie) or other third-party identifiers together to compile data regarding user interactions with ad impressions and other ad service functions as they relate to our website.")]),_vm._v(" "),_c('h4',[_vm._v("how does our website handle do not track signals?")]),_vm._v(" "),_c('p',[_vm._v("We honor Do Not Track signals and Do Not Track, plant cookies, or use advertising when a Do Not Track (DNT) browser mechanism is in place.")]),_vm._v(" "),_c('h4',[_vm._v("research")]),_vm._v(" "),_c('p',[_vm._v("In support of eHealth initiatives, we may use and share your medical information for research. We will only use and share information for research after obtaining your consent or if the used data does not expressly identify you in any way.")]),_vm._v(" "),_c('h4',[_vm._v("studies and reports")]),_vm._v(" "),_c('p',[_vm._v("We may use your information to study results and produce reports. Such information may be shared with Our partners and advertisers under the sole discretion of the Company.")]),_vm._v(" "),_c('h4',[_vm._v("changes to this privacy policy")]),_vm._v(" "),_c('p',[_vm._v("Any changes we may make to our Policy in the future will be posted on this page and, where appropriate, notified to you by e-mail. Please check back frequently to see any updates or changes to our Policy.")]),_vm._v(" "),_c('h4',[_vm._v("phishing")]),_vm._v(" "),_c('p',[_vm._v("Identity theft and the fraudulent practice currently known as \"phishing\" are of great concern to Us. Phishing is an attempt to acquire personal/sensitive information which the legitimate organization already has. Safeguarding information to help protect You from identity theft is a top priority. We do not and will not, at any time, request Your credit card information or national identification numbers in a non-secure or unsolicited e-mail or telephone communication.")]),_vm._v(" "),_c('h4',[_vm._v("cookies")]),_vm._v(" "),_c('p',[_vm._v("Yes. Cookies are small files that a site or its service provider transfers to your computer's hard drive through your Web browser (if you allow) that enables the site's or service provider's systems to recognize your browser and capture and remember certain information. For instance, We use cookies to help us remember the services/packages obtained by you. They are also used to help us understand your preferences based on previous or current site activity, which enables us to provide you with improved services. We also use cookies to help us compile aggregate data about site traffic and site interaction so that we can offer better site experiences and tools in the future.")]),_vm._v(" "),_c('p',[_vm._v("We use cookies to:")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("Understand and save user's preferences for future visits.")]),_vm._v(" "),_c('li',[_vm._v("Compile aggregate data about site traffic and site interactions in order to offer better site experiences and tools in the future. We may also use trusted third-party services that track this information on our behalf.")])]),_vm._v(" "),_c('p',[_vm._v("You can choose to have Your computer warn you each time a cookie is being sent, or You can choose to turn off all cookies. You can do this through Your browser settings by utilizing the "),_c('i',[_vm._v("Help Menu")]),_vm._v(" to learn the correct way to modify your cookies. If You turn cookies off, some of the features that make Your site experience more efficient may not function properly. It won't affect the User's experience that make Your site experience more efficient and may not function properly. ")]),_vm._v(" "),_c('h4',[_vm._v("contact")]),_vm._v(" "),_c('p',[_vm._v("Our Grievance Officer shall undertake all reasonable efforts to address your grievances at the earliest possible opportunity. You may contact us at:")]),_vm._v(" "),_c('p',[_vm._v("Grievance Officer: Jayaprakaash Jayaraman")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Address:")]),_c('br'),_vm._v("\n                     Flat No 8, 2nd Floor, "),_c('br'),_vm._v("\n                     Old No 4, New No 5 Rajachar Street, "),_c('br'),_vm._v("\n                     T.Nagar, Chennai - 600017")]),_vm._v(" "),_c('p',[_vm._v("Reach out to us on "),_c('i',[_vm._v("support@labotist.com")]),_vm._v(", in case of any queries.")])])}]
var Privacy_esExports = { render: Privacy_render, staticRenderFns: Privacy_staticRenderFns }
/* harmony default export */ var Public_Privacy = (Privacy_esExports);
// CONCATENATED MODULE: ./src/components/web/Public/Privacy.vue
function Privacy_injectStyle (ssrContext) {
  __webpack_require__("xKcD")
}
var Privacy_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var Privacy___vue_template_functional__ = false
/* styles */
var Privacy___vue_styles__ = Privacy_injectStyle
/* scopeId */
var Privacy___vue_scopeId__ = "data-v-0a7d5b4c"
/* moduleIdentifier (server only) */
var Privacy___vue_module_identifier__ = null
var Privacy_Component = Privacy_normalizeComponent(
  Privacy,
  Public_Privacy,
  Privacy___vue_template_functional__,
  Privacy___vue_styles__,
  Privacy___vue_scopeId__,
  Privacy___vue_module_identifier__
)

/* harmony default export */ var web_Public_Privacy = (Privacy_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/web/Public/Terms.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var Terms = ({
  name: 'Terms',
  components: {
    Sidemenu: web_Public_Sidemenu,
    HeaderVue: Header["a" /* default */],
    FooterVue: Footer["a" /* default */]
  },
  beforeCreate: function beforeCreate() {},
  data: function data() {
    return {};
  },
  mounted: function mounted() {
    this.$hidePageLoading();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7434766a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/web/Public/Terms.vue
var Terms_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"termsDiv"}},[_c('HeaderVue'),_vm._v(" "),_c('div',{staticClass:"inner-page"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-3"},[_c('Sidemenu')],1),_vm._v(" "),_vm._m(0,false,false)])])]),_vm._v(" "),_c('FooterVue')],1)}
var Terms_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-9"},[_c('h3',[_vm._v("Terms & Conditions")]),_vm._v(" "),_c('p',[_vm._v("Welcome to "),_c('b',[_vm._v("www.labotist.com")]),_vm._v(". ")]),_vm._v(" "),_c('p',[_vm._v("The Terms & Conditions (“"),_c('b',[_vm._v("Terms")]),_vm._v("”) of use of www.labotist.com (“"),_c('b',[_vm._v("Website")]),_vm._v("”) are between Labotist Private Limited (“"),_c('b',[_vm._v("Company/We/Us")]),_vm._v("”) and its customers/clients (“"),_c('b',[_vm._v("You/Your/User(s)")]),_vm._v("”).")]),_vm._v(" "),_c('p',[_vm._v("These Terms constitute an electronic record in accordance with the provisions of the Information Technology Act, 2000 and the Information Technology (Intermediaries Guidelines) Rules, 2011 thereunder, as amended from time to time.")]),_vm._v(" "),_c('p',[_vm._v("Please read the Terms and the privacy policy of the Company carefully, available at "),_c('b',[_c('i',[_vm._v("www.labotist.com/privacy-policy")])]),_vm._v(" (“"),_c('b',[_vm._v("Privacy Policy")]),_vm._v("”) before using this Website or availing any Services (as defined below) through the Website. In the event of any discrepancy between the Terms and any other Website policies, the provisions of the Terms shall prevail.")]),_vm._v(" "),_c('p',[_vm._v("If You continue to browse and use our Website, You are agreeing to comply with and be bound by the following Terms. If you disagree with any part of these Terms, please do not use our Website.")]),_vm._v(" "),_c('p',[_vm._v("If You do not agree with the Terms or the Privacy Policy, please do not use the Website or avail the Services provided by this Website.")]),_vm._v(" "),_c('h4',[_vm._v("Introduction")]),_vm._v(" "),_c('p',[_vm._v("Our Website is an Internet based online platform operated by the Company which is a company incorporated under the Companies Act, 2013. Our Website is a convenient, technology driven platform that serves as a one-stop solution for patients to easily choose from, and connect with various laboratories  across the city. It is an online marketplace for lab services, offering patients the convenience of making their choice based on location, cost of test, quality and turnaround time. Patients also enjoy the added luxury of getting their samples collected in the comfort of their home by a trained phlebotomist (“"),_c('b',[_vm._v("Services")]),_vm._v("”).")]),_vm._v(" "),_c('p',[_vm._v("Use of the Website is offered to You on the condition that You accept the same without modification of all the terms, conditions and notices contained in these Terms, as may be posted on the Website from time to time.")]),_vm._v(" "),_c('p',[_vm._v("We reserve the right to amend these Terms from time to time as We deem fit and Your continued usage of the Website and the Services offered shall be deemed to be Your acceptance of the Terms. We recommend that, You keep yourself updated with the Terms. We do not hold the responsibility of informing You of any amendments.")]),_vm._v(" "),_c('p',[_vm._v("Users may not access the Services for the purposes of monitoring their availability, performance or functionality, or for any other benchmarking or competitive purposes.")]),_vm._v(" "),_c('p',[_vm._v("We reserve our right to suspend any User’s ability to use or access the Website at our sole discretion and at any time while We investigate complaints or alleged violations of these Terms, or for any other reason. We have the right to club profiles of the laboratories and diagnostic centres to make them more suitable for package searches on the Website while not amending any of the details provided by the concerned laboratories and diagnostic centres. If the Users find that there is any incorrect information, they can contact Us immediately for such corrections. However, We disclaim all liabilities or responsibilities with respect to any of the information provided by the concerned laboratories and diagnostic centres.")]),_vm._v(" "),_c('h4',[_vm._v("Eligibility Criteria")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v(" The Services offered on the Website are not available to all those individuals who are not qualified to enter into a contract as per the Indian Contract Act, 1872.  By using the Website, You represent and warrant that (a) all registration information You submit is truthful and accurate; (b) You will maintain the accuracy of such information, and any changes thereto by regular updates of any such information; (c) You affirm that You are over 18 years of age and are fully able and competent to enter into the terms, conditions, obligations, affirmations, representations, and warranties set forth in these Terms; and (c) You shall use the Website or such other services provided under the Website only in compliance with these Terms and all applicable local, state, national, and international laws, rules and regulations. Your profile may be deleted and Your membership may be terminated by the Company without warning, or without any notice whatsoever, if We believe that You have violated any of the conditions as mentioned under the Terms or Privacy Policy.\n                        ")]),_vm._v(" "),_c('li',[_vm._v("The Company reserves the right to grant or refuse usage of the Services available on the Website. It can also terminate the usage by an existent User of the Website without assigning any reason. ")]),_vm._v(" "),_c('li',[_vm._v("The Website does not have the responsibility to ensure that You conform to the aforesaid eligibility criteria. It shall be Your sole responsibility to ensure that You meet the required qualification.")])]),_vm._v(" "),_c('h4',[_vm._v("User Account")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v(" You will be required to create an Account, if You wish to avail the Services offered on the Website.")]),_vm._v(" "),_c('li',[_vm._v("In order to access the Services offered on the Website, You shall be required to register yourself with the Website, and maintain an account there (\""),_c('b',[_vm._v("Account")]),_vm._v("\"). You will be required to furnish certain information and details, including Your name, mobile number, e-mail address, residential address, payment information (credit/debit card details) if required, and any other information deemed necessary by the Website (“"),_c('b',[_vm._v("Account Information")]),_vm._v("”).")]),_vm._v(" "),_c('li',[_vm._v("It is Your sole responsibility to ensure that the Account Information provided by You is accurate, complete and latest.")]),_vm._v(" "),_c('li',[_vm._v("The Account Information provided by You, may be shared by the Company with any third party for its internal record keeping purposes, internal procedures and with various laboratories/diagnostic centres to enable them to inform You about any schemes, offers, discounts etc.  Further, by providing the Account Information, you agree and acknowledge that you are also granting your consent for the phlebotomists to visit the address provided by you in order to collect/draw the requite samples, call you on the number provided you for any necessary confirmation, deliver the samples the diagnostic centre chosen by you and do such other acts as necessary. ")]),_vm._v(" "),_c('li',[_vm._v("Upon completing the registration process, You can start availing the Services offered on the Website immediately. You shall be responsible for maintaining the confidentiality of the Account Information and for all activities that occur under Your Account. You agree to (a) ensure that You successfully log out from Your Account at the end of each session; and (b) immediately notify the Company of any unauthorized use of Your Account.  If there is reason to believe that there is likely to be a breach of security or misuse of the Your Account/ Website, We may request You to change the password or We may suspend Your account without any liability to the Company, for such period of time as We deem appropriate in the circumstances. The Website shall not be liable for any loss or damage arising from Your failure to comply with this Clause.")]),_vm._v(" "),_c('li',[_vm._v("You acknowledge that Your ability to use Your Account is dependent upon external factors such as internet service providers and internet network availability and the Company cannot guarantee availability of the Website at all times. In addition to the disclaimers set forth in the Terms, the Company shall not be liable to You for any damages arising from Your inability to log into Your Account and access the services of the Website at any time.")])]),_vm._v(" "),_c('h4',[_vm._v("Use of Website")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("Subject to compliance with the Terms, the Privacy Policy, and all other applicable terms and guidelines, the Company grants You a personal, non-exclusive, limited privilege to access and use this Website and the Services provided thereon.")]),_vm._v(" "),_c('li',[_vm._v("No User shall be permitted to perform any of the following prohibited activities:\n                            "),_c('ul',[_c('li',[_vm._v("Making available any content that is misleading, unlawful, harmful, threatening, abusive, tortious, defamatory, libelous, vulgar, obscene, child-pornographic, lewd, lascivious, profane, invasive of another's privacy, hateful, or racially, ethnically or otherwise objectionable.")]),_vm._v(" "),_c('li',[_vm._v("Stalking, intimidating and/or harassing another and/or inciting other to commit violence.")]),_vm._v(" "),_c('li',[_vm._v("Transmitting material that encourages anyone to commit a criminal offence, that results in civil liability or otherwise breaches any relevant laws, regulations or code of practice.")]),_vm._v(" "),_c('li',[_vm._v("Interfering with any other person's use or enjoyment of the Website.")]),_vm._v(" "),_c('li',[_vm._v("Making, transmitting or storing electronic copies of materials protected by copyright without the permission of the owner, committing any act that amounts to the infringement of intellectual property or making available any material that infringes any intellectual property rights or other proprietary rights of anyone else.")]),_vm._v(" "),_c('li',[_vm._v("Make available any content or material that You do not have a right to make available under any law or contractual or fiduciary relationship, unless You own or control the rights thereto or have received all necessary consents for such use of the content.")]),_vm._v(" "),_c('li',[_vm._v("Impersonate any person or entity, or falsely state or otherwise misrepresent Your affiliation with a person or entity.")]),_vm._v(" "),_c('li',[_vm._v("Use any of the Company’s domain names.")]),_vm._v(" "),_c('li',[_vm._v("Reverse engineer, modify, copy, distribute, transmit, display, perform, reproduce, publish, license, create derivative works from, transfer, or sell any information or software obtained from the Website.")]),_vm._v(" "),_c('li',[_vm._v("Post, transmit or make available any material that contains viruses, trojan horses, worms, spyware, time bombs, cancelbots, or other computer programming routines, code, files or such other programs that may harm the Website/services, interests or rights of other Users or limit the functionality of any computer software, hardware or telecommunications, or that may harvest or collect any data or personal information about other Users without their consent.")]),_vm._v(" "),_c('li',[_vm._v("Access or use the Website in any manner that could damage, disable, overburden or impair any of the Website's servers or the networks connected to any of the servers on which the Website is hosted.")]),_vm._v(" "),_c('li',[_vm._v("Intentionally or unintentionally interfere with or disrupt the Services or violate any applicable laws related to the access to or use of the Website, violate any requirements, procedures, policies or regulations of networks connected to the Website, or engage in any activity prohibited by these Terms.")]),_vm._v(" "),_c('li',[_vm._v("Disrupt or interfere with the security of, or otherwise cause harm to, the Website, materials, systems resources, or gain unauthorized access to user accounts, passwords, servers or networks connected to or accessible through the Website or any affiliated or linked sites.")]),_vm._v(" "),_c('li',[_vm._v("Interfere with, or inhibit any user from using and enjoying access to the Website, or the services, or other affiliated sites, or engage in disruptive attacks such as denial of service attack on the Website.")]),_vm._v(" "),_c('li',[_vm._v("Access the Website through any other means other than through the interface that is provided by the Company.")]),_vm._v(" "),_c('li',[_vm._v("Use deep-links, page-scrape, robot, spider or other automatic device, program, algorithm or methodology, or any similar or equivalent manual process, to increase traffic to the Website, to access, acquire, copy or monitor any portion of the Website, or in any way reproduce or circumvent the navigational structure or presentation of the Website, or any content, to obtain or attempt to obtain any content, documents or information through any means not specifically made available through the Website.")]),_vm._v(" "),_c('li',[_vm._v("Alter or modify any part of the services.")]),_vm._v(" "),_c('li',[_vm._v("Use the services for purposes that are not permitted by: (i) these Terms; and (ii) any applicable law, regulation or generally accepted practices or guidelines in the relevant jurisdiction.")]),_vm._v(" "),_c('li',[_vm._v("Violate any of the terms specified under the Terms for the use of the Website.")])])]),_vm._v(" "),_c('li',[_vm._v("Any violation by You of the terms of this Clause may result in immediate suspension or termination of Your Accounts, apart from any legal remedy that the Company can avail. In such instances, the Company may also disclose Your Account Information if required by any Governmental or legal authority.")]),_vm._v(" "),_c('li',[_vm._v("You acknowledge and agree that by accessing or using the Website, You agree to indemnify and hold the Company, its affiliates, and/or licensors, harmless to the fullest extent allowed by law regarding all matters related to Your use of the Website or any loss/damage that is caused to the Website/the Company as a result of You committing any of the aforesaid prohibited activities.")]),_vm._v(" "),_c('li',[_vm._v("The Company has the right to change modify, suspend, or discontinue and/or eliminate any aspect(s), features or functionality of the Website or the Services as it deems fit at any time without notice. The Company makes no commitment, express or implied, to maintain or continue any aspect of the Website.  You agree that the Company shall not be liable to You or any third party for any modification, suspension or discontinuance of the Website.")]),_vm._v(" "),_c('li',[_vm._v("You acknowledge that the Company does not make any representation or warranty  regarding any of its Users. You are advised to independently verify the bona fides of any particular user that You choose to deal with on the Website.")])]),_vm._v(" "),_c('h4',[_vm._v("Delivery of Reports ")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v(" Sample collection will typically be done on the date and time chosen by the User. The User shall have the option to reschedule subject to the availability of the rescheduled time slot.")]),_vm._v(" "),_c('li',[_vm._v("It is clarified that, certain sample collection procedure may get delayed due to certain unforeseen circumstances beyond the control of the Company. In such an event, We will proactively reach out to You and inform the same. You are expected to check your emails and SMS regularly for any such updates.")]),_vm._v(" "),_c('li',[_vm._v("Reports will be generated within the turnaround time as stipulated by the laboratory/diagnostic centre chosen by the User. The Company is not liable for any delay with respect to the generation of the reports by such laboratory/diagnostic centre . Upon delivery of the reports to Us, We shall verify the User name and other necessary credentials after which the Company shall attach and e-mail a soft copy of the report to Your online account. The User shall be able to view the report only by logging into his/her Account.")]),_vm._v(" "),_c('li',[_vm._v("Reported laboratory results are at best informative to the referring clinician and should not be considered as the sole basis for final diagnosis and treatment decisions. They should always be correlated with other relevant clinical and laboratory findings.")]),_vm._v(" "),_c('li',[_vm._v("The accuracy of the laboratory reports is largely dependent on the quality of the sample as well as the assay procedures used by the laboratory/diagnostic centres chosen by the User.")])]),_vm._v(" "),_c('h4',[_vm._v("Payment, Fees and Taxes ")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("The User agrees to pay all package fees, consulting fees and other fees applicable to the selected Services and the User shall not circumvent the fee structure. The fee is dependent on the package that the User purchases online and not on the actual usage of the Services.")]),_vm._v(" "),_c('li',[_vm._v("Each User is solely responsible for the payment of all taxes. The Company shall be in no way responsible for any of the taxes except for its own tax liabilities.")]),_vm._v(" "),_c('li',[_vm._v("The payment can be made online on the Website through a secured payment gateway provided by a third party. It is hereby clarified that, the Company is not responsible for any loss or damage caused to the User during the payment process as the third parties and their activities are beyond the control of the Company. The payment could also be paid offline and be either collected personally from the User.")]),_vm._v(" "),_c('li',[_vm._v("All fees are exclusive of applicable taxes.")]),_vm._v(" "),_c('li',[_vm._v("The Company reserves the right to modify the fee and such modified fee shall reflect on the Website, which shall be binding.")]),_vm._v(" "),_c('li',[_vm._v("In order to process the payments, the User might be required to provide certain details of the his/her bank account, credit/debit card number and other details as required by the third party vendor to process the transactions. The Company clarifies that it does not own or store any credit/debit card information entered by the User.")]),_vm._v(" "),_c('li',[_vm._v("You understand and acknowledge that the Company shall not be held responsible or assume any liability, whatsoever in respect of any loss or damage arising directly or indirectly to You due to:")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("Lack of authorization for any transaction/s, or")]),_vm._v(" "),_c('li',[_vm._v("Exceeding the preset limit set by your bank, or")]),_vm._v(" "),_c('li',[_vm._v("Delay in processing the transaction; or")]),_vm._v(" "),_c('li',[_vm._v("Any payment issues arising out of the transaction; or")]),_vm._v(" "),_c('li',[_vm._v("Decline of transaction for any reason/s")])]),_vm._v(" "),_c('li',[_vm._v("All payments made against the purchases on the Website by You shall be compulsorily in Indian Rupees acceptable in the Republic of India. The Website will not facilitate transactions with respect to any other form of currency with respect to availing of its services. ")])]),_vm._v(" "),_c('h4',[_vm._v("Cancellation and Refund Policy")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("The User can cancel the test request by calling on the phone number mentioned in the order confirmation notification.")]),_vm._v(" "),_c('li',[_vm._v("All laboratory test requests can be canceled until 12 (twelve) hours prior of the scheduled sample collection appointment to be eligible for a full refund.")]),_vm._v(" "),_c('li',[_vm._v("For any requests cancelled less than 12 (twelve) hours prior to the scheduled sample collection appointment  or after the appointment, the User would incur an administrative charge of INR 100 (Rupees One Hundred). This is primarily to compensate the phlebotomist for a lost opportunity to provide the home sample collection service and earn his/her income.")]),_vm._v(" "),_c('li',[_vm._v("Any requests not cancelled before the scheduled sample collection will NOT receive any refund. All refunds will be processed and credited within 15 (fifteen) business days from the date of the cancellation request into the account of the User.")])]),_vm._v(" "),_c('h4',[_vm._v("Limitation of Liability")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("The Company, its officers, directors, employees, partners or agents shall not be held responsible or held liable to You or any third party for any special, incidental, indirect, consequential or punitive damages whatsoever, including those resulting from loss of use, data or profits or any other claim arising out, of or in connection with, Your use of, or access to, the Website.")]),_vm._v(" "),_c('li',[_vm._v("The Company shall not be held responsible or liable in any manner whatsoever, by the Users for any losses, damage, injuries or expenses incurred by the Users as a result of any lawful disclosures made by the Company, where the User has consented to such disclosures by the Company. The User agrees that the services provided by the Company or any of its affiliates or service providers are provided on an  \"as is,\" basis, and without any warranties or conditions ("),_c('i',[_vm._v("express or implied, including the implied warranties of merchantability, accuracy, fitness for a particular purpose, title and non-infringement, arising by statute or otherwise in law or from a course of dealing or usage or trade")]),_vm._v("). The Company does not provide or make any representation, warranty or guarantee, express or implied about the Website or the Services. The Company does not verify any content or information provided by the Users/User selected laboratories/diagnostic centres on the Website and to the fullest extent permitted by law, disclaims all liability arising out of the User’s use or reliance upon the Website, the Services, representations and warranties made by the laboratories/diagnostic centres or the content or information provided by laboratories/ diagnostic centres on the Website or any loss arising out of the manner in which the Services have been rendered.")]),_vm._v(" "),_c('li',[_vm._v("In no event shall the total aggregate liability of the Protected Entities to a User for all damages, losses, and causes of action ("),_c('i',[_vm._v("whether in contract or tort, including, but not limited to, negligence or otherwise")]),_vm._v(") arising from the terms and conditions or a User’s use of the Website exceed, in the aggregate INR 1,000 (Rupees One Thousand). ")]),_vm._v(" "),_c('li',[_vm._v("Notwithstanding anything to the contrary contained herein, the User alone shall be liable for User’s dealings and interaction with the chosen laboratory/diagnostic centres. ")]),_vm._v(" "),_c('li',[_vm._v("In no event shall the Company be held responsible and liable for failure on the part of the chosen laboratories/ diagnostic centres to provide the agreed Services or to make provisions for the carrying out the Services. In no event shall the Company be liable for any comments or feedback given by any of the Users in relation to the Services provided by any chosen laboratories/diagnostic centres.")]),_vm._v(" "),_c('li',[_vm._v("The listing of the laboratories/diagnostic centres on the Website is based on numerous factors including but not limited to the User’s comments and feedbacks. In no event shall the Company be liable or responsible for the listing order of the laboratories/diagnostic centres on the Website.")]),_vm._v(" "),_c('li',[_vm._v("We shall not be held responsible or liable for, any damages to, or viruses that may infect User’s equipment on account of User’s access to, use of, or browsing the Website or the downloading of any material, data, text, images, video content, or audio content from the Website. If a User is dissatisfied with the Website, User’s sole remedy is to discontinue using the Website.")])]),_vm._v(" "),_c('h4',[_vm._v("Ownership and Intellectual Property Rights")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("The Website and the materials therein including but not limited to all text, graphics, user interfaces, visual interfaces, sounds and music ("),_c('i',[_vm._v("if any")]),_vm._v("), artwork and computer code and any other information or materials of any nature whatsoever on the Website is owned and controlled by the Company and such content is protected by copyright, patent and trademark laws, and various other intellectual property rights and unfair competition laws.")]),_vm._v(" "),_c('li',[_vm._v("The trademarks, logos and service marks displayed on the Website or on the Website (the \""),_c('b',[_vm._v("Marks")]),_vm._v("\") are the property of Company or the respective third parties. You are not permitted to use the Marks without the prior consent of the Company or the third party that may own the Marks.")])]),_vm._v(" "),_c('h4',[_vm._v("Termination of Your Account")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("The Company may at its sole discretion and without prior notice, terminate Your access to the Website and its Services for, including but not limited to, any of the following reasons:")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("Your violation of the Terms as mentioned herein.")]),_vm._v(" "),_c('li',[_vm._v("If the Company is unable to verify or authenticate any information provided to by You.")]),_vm._v(" "),_c('li',[_vm._v("If the Company at its sole discretion believes that Your actions may cause any damage or legal liability for other Users or to  the Company or are contrary to the interests of the Company.")])]),_vm._v(" "),_c('li',[_vm._v("On termination of an Account due to the reasons mentioned herein, such User shall no longer have access to and the reports and other material stored on the Website by such User. The User shall ensure that he/she has continuous backup of the reports.")]),_vm._v(" "),_c('li',[_vm._v("The Company reserves the right, at its sole discretion, to pursue all of its legal remedies, including but not limited to deletion of the User’s content from the Website with or without ability to access the Website and the other services, upon any breach by the User under this Terms or if the Company is unable to verify or authenticate any information provided by the User or if the User fails to provide (or after providing such consent, later revokes) the consents necessary or desirable by the Company to provide the services to the User.")])]),_vm._v(" "),_c('h4',[_vm._v("Indemnification")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("You agree to defend, indemnify and hold harmless the Company, its officers, directors, employees and agents, from and against any and all claims, damages, obligations, losses, liabilities, costs or debt, and expenses (including but not limited to attorney's fees) arising from: (i) Your use of and access of the Website; (ii) Your violation of any term of these Terms or any other policy of the Company; (iii) Your violation of any third party right, including without limitation, any copyright, property, or privacy right; or (iv) any claim that Your use of the Website has caused damage to a third party. The defense and indemnification obligation will survive these Terms.")])]),_vm._v(" "),_c('h4',[_vm._v("Governing Law and Jurisdiction")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("The Website, the Terms, all transactions entered into on or through the Website and the relationship between You and the Company shall be governed by and construed in accordance with the laws of India, without regard to conflict of law principles. The courts of Chennai shall have the jurisdiction to try any dispute between the User and Company.")])]),_vm._v(" "),_c('h4',[_vm._v("General Provisions")]),_vm._v(" "),_c('ul',[_c('li',[_c('b',[_vm._v("Notice:")]),_vm._v(" All notices served by the Company shall be provided via email to Your account or as a general notification on the Website. Any notice to be provided to the Company should be sent to "),_c('b',[_vm._v("[•]")]),_vm._v(".")]),_vm._v(" "),_c('li',[_c('b',[_vm._v("Entire Agreement:")]),_vm._v(" The Terms, along with the Privacy Policy, and any other guidelines made applicable by the Website from time to time, constitute the entire agreement between the Company and You with respect to Your access to or use of the Website and the Services thereof.")]),_vm._v(" "),_c('li',[_c('b',[_vm._v("Assignment:")]),_vm._v(" You cannot assign or otherwise transfer the Terms, or any right granted hereunder to any third party. The Company’s rights under the Terms are freely transferable by the Company to any third parties without the requirement of seeking Your consent. The Company may freely transfer, assign or delegate all or any part of these Terms, any rights and duties hereunder. These Terms will be binding upon and inure to the benefit of the successors and permitted assignees of the parties.")]),_vm._v(" "),_c('li',[_c('b',[_vm._v("Severability:")]),_vm._v(" If, for any reason, a court of competent jurisdiction finds any provision of the Terms, or portion thereof, to be unenforceable, that provision shall be enforced to the maximum extent permissible so as to give effect to the intent of the parties as reflected by that provision, and the remainder of the Terms shall continue in full force and effect.")]),_vm._v(" "),_c('li',[_c('b',[_vm._v("Waiver:")]),_vm._v(" Any failure by the Company to enforce or exercise any provision of the Terms, or any related right, shall not constitute a waiver by the Company of that provision or right.")]),_vm._v(" "),_c('li',[_c('b',[_vm._v("Force Majeure:")]),_vm._v(" The Company shall not be held responsible or liable due to any unavailability caused by circumstances beyond the Company’s reasonable control, including without limitation, Acts of God, acts of Government, flood, fire, earthquakes, civil unrest, acts of terror, strikes or other labour problems such as strikes and lockouts, or internet service provider failures or delays.")]),_vm._v(" "),_c('li',[_c('b',[_vm._v("Relationship:")]),_vm._v(" You acknowledge that Your participation on the Website, does not make You an employee or agency or partnership or joint venture or franchise of the Company. Further, you shall not have the right to enter into any obligation or commitment on behalf of the Company.")]),_vm._v(" "),_c('li',[_vm._v("The Company provides these Terms on the Website so that You are aware of the terms that apply to Your use of the Website. You acknowledge that, the Company has given You a reasonable opportunity to review these Terms and that You have agreed to them.")]),_vm._v(" "),_c('li',[_vm._v("In the event that you participate in any promotional activities through the advertisers on the Website, the Company shall not be held responsible for any loss or damage caused to you in this regard.")])]),_vm._v(" "),_c('h4',[_vm._v("DISCLAIMER")]),_vm._v(" "),_c('p',{staticClass:"terms-disclaimer"},[_c('b',[_vm._v("WE DO NOT PROVIDE MEDICAL ADVICE:")]),_vm._v(" THE INFORMATION THAT YOU OBTAIN OR RECEIVE FROM THE COMPANY, AND ITS EMPLOYEES, CONTRACTORS, PARTNERS, SPONSORS, ADVERTISERS, LICENSORS OR OTHERWISE ON THE WEBSITE IS FOR INFORMATIONAL AND SCHEDULING PURPOSES ONLY. THE INFORMATION PROVIDED ON THE WEBSITE IS NOT INTENDED AS A SUBSTITUTE FOR, NOR DOES IT REPLACE, PROFESSIONAL MEDICAL ADVICE, DIAGNOSIS, OR TREATMENT. DO NOT DISREGARD, AVOID OR DELAY OBTAINING MEDICAL ADVICE FROM A QUALIFIED HEALTH CARE PROFESSIONAL BECAUSE OF SOMETHING YOU MAY HAVE READ ON THE WEBSITE. DO NOT USE THE WEBSITE FOR EMERGENCY MEDICAL NEEDS. YOUR USE OF INFORMATION PROVIDED ON THE WEBSITE IS SOLELY AT YOUR OWN RISK. NOTHING STATED OR POSTED ON THE WEBSITE OR AVAILABLE THROUGH ANY SERVICES IS INTENDED TO BE, AND MUST NOT BE TAKEN TO BE, THE PRACTICE OF MEDICINE OR THE PROVISION OF MEDICAL CARE. WE DO NOT RECOMMEND OR ENDORSE ANY SPECIFIC TESTS, PHYSICIANS, LABORATORIES, DIAGNOSTIC CENTRES, PROCEDURES, OPINIONS, OR OTHER INFORMATION THAT MAY APPEAR ON THE WEBSITE. IF YOU RELY ON ANY OF THE INFORMATION PROVIDED BY THE WEBSITE, YOU DO SO SOLELY AT YOUR OWN RISK.")]),_vm._v(" "),_c('p',{staticClass:"terms-disclaimer"},[_c('b',[_vm._v("NO DOCTOR PATIENT RELATIONSHIP:")]),_vm._v(" NO LICENSED MEDICAL PROFESSIONAL/PATIENT RELATIONSHIP IS CREATED BY USING THE INFORMATION PROVIDED BY OR THROUGH THE USE OF THE WEBSITE INCLUDING, BUT NOT LIMITED TO, FIND A TEST FEATURE, LINKS TO OTHER WEBSITES OR ANY ASSISTANCE WE MAY PROVIDE TO HELP YOU FIND AN APPROPRIATE MEDICAL PROFESSIONAL/DIAGNOSTIC CENTER OR SPECIALIST IN ANY FIELD FOR CONDUCTING THE REQUISITE TEST. WE MAKE NO GUARANTEES, REPRESENTATIONS OR WARRANTIES, WHETHER EXPRESSED OR IMPLIED, WITH RESPECT TO PROFESSIONAL QUALIFICATIONS, EXPERTISE, QUALITY OF WORK OR OTHER INFORMATION HEREIN REGARDING THE LABORATORIES/DIAGNOSTIC CENTRE OR THER PHLEBOTOMISTS. IN NO EVENT SHALL WE BE LIABLE TO YOU OR ANYONE ELSE FOR ANY DECISION MADE OR ACTION TAKEN BY YOU IN RELIANCE ON SUCH INFORMATION. WE HAVE NOT CONDUCTED ANY BACKGROUND CHECK ON THE PHLEBOTOMISTS AND WE ARE IN NO WAY LIABLE FOR ANY OF THEIR ACT/OMISSIONS. WE HAVE NO CONTROL OVER, AND CANNOT GUARANTEE THE AVAILABILITY OF ANY DIAGNOSTIC CENTER AT ANY PARTICULAR TIME. WE WILL NOT BE LIABLE FOR CANCELLED OR OTHERWISE UNFULFILLED APPOINTMENTS OR ANY INJURY RESULTING THEREFROM, OR FOR ANY OTHER INJURY RESULTING FROM THE USE OF THE WEBSITE OR SERVICES WHATSOEVER. YOU ARE STRONGLY ADVISED TO PERFORM YOUR OWN INVESTIGATION PRIOR TO SELECTING A HEALTH CARE DIAGNOSTIC CENTRE BY MAKING CONFIRMING TELEPHONE CALLS TO THE RELEVANT DIAGNOSTIC CENTRE. ANY KIND OF AN ENGAGEMENT WITH THE THIRD PARTIES INCLUDING WITH THE DIAGNOSTIC CENTRE WOULD BE ON A PRINCIPAL TO PRINCIPAL BASIS ON THE BEST JUDGEMENT OF YOURSELF.")]),_vm._v(" "),_c('h4',[_vm._v("Feedback")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("Any feedback You provide to this Website shall be deemed to be non-confidential. The Website shall be free to use such information on an unrestricted basis. Further, by submitting the feedback, You represent and warrant that (i) Your feedback does not contain confidential or proprietary information of You or of third parties; (ii) the Company is not under any obligation of confidentiality, express or implied, with respect to the feedback; (iii) the Website may have something similar to the feedback already under consideration or in development; and (iv) You are not entitled to any compensation or reimbursement of any kind from the Company for the feedback under any circumstances, unless specified.")]),_vm._v(" "),_c('li',[_vm._v("Under no circumstances shall the Company be held responsible in any manner for any content provided by other users even such content is offensive, hurtful or offensive. Please exercise caution while accessing the Website.")])]),_vm._v(" "),_c('h4',[_vm._v("Customer Care")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("We make all best endeavors to provide you with a pleasant experience. In the unlikely event that You face any issues, please contact us at "),_c('b',[_vm._v("[•]")])])])])}]
var Terms_esExports = { render: Terms_render, staticRenderFns: Terms_staticRenderFns }
/* harmony default export */ var Public_Terms = (Terms_esExports);
// CONCATENATED MODULE: ./src/components/web/Public/Terms.vue
function Terms_injectStyle (ssrContext) {
  __webpack_require__("Kvcb")
}
var Terms_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var Terms___vue_template_functional__ = false
/* styles */
var Terms___vue_styles__ = Terms_injectStyle
/* scopeId */
var Terms___vue_scopeId__ = "data-v-7434766a"
/* moduleIdentifier (server only) */
var Terms___vue_module_identifier__ = null
var Terms_Component = Terms_normalizeComponent(
  Terms,
  Public_Terms,
  Terms___vue_template_functional__,
  Terms___vue_styles__,
  Terms___vue_scopeId__,
  Terms___vue_module_identifier__
)

/* harmony default export */ var web_Public_Terms = (Terms_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/web/Public/Labsignup.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var Labsignup = ({
  name: 'Labsignup',
  components: {
    HeaderVue: Header["a" /* default */],
    FooterVue: Footer["a" /* default */]
  },
  beforeCreate: function beforeCreate() {},
  data: function data() {
    return {
      pincode: '',
      labname: '',
      contact: '',
      phone: '',
      email: '',
      fax: '',
      address: '',
      city: '',
      state: '',
      success: false
    };
  },

  methods: {
    save: function save() {
      var _this = this;

      this.$validator.validateAll('signup').then(function (result) {
        if (result) {
          try {
            var data = {
              labName: this.labname,
              contactPersonName: this.contact,
              emailAddress: this.email,
              phoneNumber: this.phone,
              faxNumber: this.fax,
              address: this.address,
              cityName: this.city,
              stateName: this.state,
              pincode: this.pincode
            };
            promise_default.a.resolve(this.$POST('patient/labSignup', data)).then(function (res) {
              if (res.response_code === 0) {
                this.success = true;
                this.$Simplert.open({
                  title: 'Success',
                  message: 'Thanks for contact us. We will touch with you soon.',
                  type: 'warning',
                  disableOverlayClick: true,
                  showXclose: true,
                  useConfirmBtn: false,
                  customCloseBtnText: 'OK'
                });
                this.reset();
                // location.reload()
              }
            }.bind(this)).catch(function (err) {
              console.error(err);
              this.$Simplert.open({
                title: 'Oops',
                message: 'Something went wrong please mail us support@labotist.com',
                type: 'warning',
                disableOverlayClick: true,
                showXclose: true,
                useConfirmBtn: false,
                customCloseBtnText: 'OK'
              });
              // alert('Something went wrong please mail us support@labotist.com')
            }.bind(this));
          } catch (e) {
            console.error(e);
          }
        }
      }.bind(this)).catch(function () {
        console.log('errors exist while save lab form', _this.errors);
      });
    },
    reset: function reset() {
      this.pincode = '';
      this.labname = '';
      this.contact = '';
      this.email = '';
      this.phone = '';
      this.fax = '';
      this.address = '';
      this.city = '';
      this.state = '';
      setTimeout(function () {
        this.errors.items = [];
      }.bind(this), 30);
    }
  },
  mounted: function mounted() {
    this.$hidePageLoading();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-add4c9ae","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/web/Public/Labsignup.vue
var Labsignup_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"labSignupDiv"}},[_c('HeaderVue'),_vm._v(" "),_c('div',{staticClass:"inner-page phleb-signup"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_vm._m(0,false,false),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"sign-up"},[_vm._m(1,false,false),_vm._v(" "),_c('div',{staticClass:"form-content line-textbox"},[_c('form',{attrs:{"data-vv-scope":"signup"}},[_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.pincode),expression:"pincode"},{name:"validate",rawName:"v-validate",value:('required|numeric|min:6|max:6'),expression:"'required|numeric|min:6|max:6'"}],staticClass:"form-control",attrs:{"type":"text","name":"pincode","id":"pincode","data-vv-as":"pincode","placeholder":"Pincode (Chennai & Bengaluru)"},domProps:{"value":(_vm.pincode)},on:{"input":function($event){if($event.target.composing){ return; }_vm.pincode=$event.target.value}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('signup.pincode')),expression:"errors.has('signup.pincode')"}],staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('signup.pincode')))])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.labname),expression:"labname"},{name:"validate",rawName:"v-validate",value:('required|max:250'),expression:"'required|max:250'"}],staticClass:"form-control",attrs:{"type":"text","name":"labname","id":"labname","data-vv-as":"lab name","placeholder":"Lab Name"},domProps:{"value":(_vm.labname)},on:{"input":function($event){if($event.target.composing){ return; }_vm.labname=$event.target.value}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('signup.labname')),expression:"errors.has('signup.labname')"}],staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('signup.labname')))])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.contact),expression:"contact"},{name:"validate",rawName:"v-validate",value:('required|alpha_spaces|max:100'),expression:"'required|alpha_spaces|max:100'"}],staticClass:"form-control",attrs:{"type":"text","name":"contact","id":"contact","data-vv-as":"contact name","placeholder":"Contact Person Name"},domProps:{"value":(_vm.contact)},on:{"input":function($event){if($event.target.composing){ return; }_vm.contact=$event.target.value}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('signup.contact')),expression:"errors.has('signup.contact')"}],staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('signup.contact')))])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email),expression:"email"},{name:"validate",rawName:"v-validate",value:('required|email'),expression:"'required|email'"}],staticClass:"form-control",attrs:{"type":"email","name":"email","id":"email","data-vv-as":"email address","placeholder":"Email Address"},domProps:{"value":(_vm.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.email=$event.target.value}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('signup.email')),expression:"errors.has('signup.email')"}],staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('signup.email')))])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.phone),expression:"phone"},{name:"validate",rawName:"v-validate",value:('required|numeric|max:10|min:10'),expression:"'required|numeric|max:10|min:10'"}],staticClass:"form-control",attrs:{"type":"text","name":"phone","id":"phone","data-vv-as":"phone no.","placeholder":"Phone No"},domProps:{"value":(_vm.phone)},on:{"input":function($event){if($event.target.composing){ return; }_vm.phone=$event.target.value}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('signup.phone')),expression:"errors.has('signup.phone')"}],staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('signup.phone')))])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fax),expression:"fax"},{name:"validate",rawName:"v-validate",value:('numeric|max:10|min:10'),expression:"'numeric|max:10|min:10'"}],staticClass:"form-control",attrs:{"type":"text","name":"fax","id":"fax","data-vv-as":"fax no.","placeholder":"Fax No"},domProps:{"value":(_vm.fax)},on:{"input":function($event){if($event.target.composing){ return; }_vm.fax=$event.target.value}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('signup.fax')),expression:"errors.has('signup.fax')"}],staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('signup.fax')))])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.address),expression:"address"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"form-control",attrs:{"type":"text","name":"address","id":"address","data-vv-as":"lab address","placeholder":"Address"},domProps:{"value":(_vm.address)},on:{"input":function($event){if($event.target.composing){ return; }_vm.address=$event.target.value}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('signup.address')),expression:"errors.has('signup.address')"}],staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('signup.address')))])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.city),expression:"city"},{name:"validate",rawName:"v-validate",value:('required|alpha_spaces|max:100'),expression:"'required|alpha_spaces|max:100'"}],staticClass:"form-control",attrs:{"type":"text","name":"city","id":"city","data-vv-as":"city","placeholder":"City"},domProps:{"value":(_vm.city)},on:{"input":function($event){if($event.target.composing){ return; }_vm.city=$event.target.value}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('signup.city')),expression:"errors.has('signup.city')"}],staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('signup.city')))])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.state),expression:"state"},{name:"validate",rawName:"v-validate",value:('required|alpha_spaces|max:100'),expression:"'required|alpha_spaces|max:100'"}],staticClass:"form-control",attrs:{"type":"text","name":"state","id":"state","data-vv-as":"state","placeholder":"State"},domProps:{"value":(_vm.state)},on:{"input":function($event){if($event.target.composing){ return; }_vm.state=$event.target.value}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('signup.state')),expression:"errors.has('signup.state')"}],staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('signup.state')))])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('button',{staticClass:"btn  btn-link full-width",attrs:{"type":"reset"},on:{"click":function($event){$event.preventDefault();_vm.reset()}}},[_vm._v("Reset")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('button',{staticClass:"btn btn-primary full-width",attrs:{"disabled":(_vm.errors.any())},on:{"click":function($event){$event.preventDefault();_vm.save()}}},[_vm._v("Send")])])])])])])])])])]),_vm._v(" "),_c('FooterVue')],1)}
var Labsignup_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-8"},[_c('div',{staticClass:"lab-benefits"},[_c('h2',{staticClass:"mb-3"},[_vm._v("Partner With Us")]),_vm._v(" "),_c('p',{staticClass:"mb-5",staticStyle:{"line-height":"22px","margin-bottom":"10px"}},[_vm._v("A unique initiative for mutual growth of "),_c('br'),_vm._v("your lab & Labotist")]),_vm._v(" "),_c('ul',[_c('li',[_c('span',{staticClass:"number-circle"},[_vm._v("1")]),_vm._v("Experience significant visibility online.")]),_vm._v(" "),_c('li',[_c('span',{staticClass:"number-circle"},[_vm._v("2")]),_vm._v("Gain access to trained & efficient phlebotomists providing high quality of service leading to increased customer satisfaction.")]),_vm._v(" "),_c('li',[_c('span',{staticClass:"number-circle"},[_vm._v("3")]),_vm._v("Eliminate the burden and expenditure on marketing, inventory management, and\n                                logistical aspects involved in transportation of samples between the patient’s homes and the lab, allowing for labs to focus on their core strengths.")]),_vm._v(" "),_c('li',[_c('span',{staticClass:"number-circle"},[_vm._v("4")]),_vm._v("Design your product offerings based on the market intelligence and customer feedback shared by Labotist Data Sciences Team.")]),_vm._v(" "),_c('li',[_c('span',{staticClass:"number-circle"},[_vm._v("5")]),_vm._v("Labotist will take care of customer care, training and payroll of the phlebotomists, while you focus on patients.")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"signup-title"},[_c('h4',[_vm._v("Partner With Us")]),_vm._v(" "),_c('p',[_vm._v("Sign Up Today")])])}]
var Labsignup_esExports = { render: Labsignup_render, staticRenderFns: Labsignup_staticRenderFns }
/* harmony default export */ var Public_Labsignup = (Labsignup_esExports);
// CONCATENATED MODULE: ./src/components/web/Public/Labsignup.vue
function Labsignup_injectStyle (ssrContext) {
  __webpack_require__("tJme")
}
var Labsignup_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var Labsignup___vue_template_functional__ = false
/* styles */
var Labsignup___vue_styles__ = Labsignup_injectStyle
/* scopeId */
var Labsignup___vue_scopeId__ = "data-v-add4c9ae"
/* moduleIdentifier (server only) */
var Labsignup___vue_module_identifier__ = null
var Labsignup_Component = Labsignup_normalizeComponent(
  Labsignup,
  Public_Labsignup,
  Labsignup___vue_template_functional__,
  Labsignup___vue_styles__,
  Labsignup___vue_scopeId__,
  Labsignup___vue_module_identifier__
)

/* harmony default export */ var web_Public_Labsignup = (Labsignup_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/web/Public/Phlebsignup.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var Phlebsignup = ({
  name: 'Phlebsignup',
  components: {
    HeaderVue: Header["a" /* default */],
    FooterVue: Footer["a" /* default */]
  },
  data: function data() {
    return {
      pincode: '',
      firstname: '',
      lastname: '',
      email: '',
      mobile: '',
      phone: '',
      address: '',
      city: '',
      state: '',
      success: false
    };
  },
  beforeCreate: function beforeCreate() {},

  methods: {
    save: function save() {
      var _this = this;

      this.$validator.validateAll('signup').then(function (result) {
        if (result) {
          try {
            var data = {
              firstName: this.firstname,
              lastName: this.lastname,
              emailAddress: this.email,
              mobileNumber: this.mobile,
              phoneNumber: this.phone,
              address: this.address,
              cityName: this.city,
              stateName: this.state,
              pincode: this.pincode
            };
            promise_default.a.resolve(this.$POST('patient/phlebSignup', data)).then(function (res) {
              if (res.response_code === 0) {
                this.success = true;
                // location.reload()
                this.$Simplert.open({
                  title: 'Success',
                  message: 'We have received your details.We will touch with you soon.',
                  type: 'warning',
                  disableOverlayClick: true,
                  showXclose: true,
                  useConfirmBtn: false,
                  customCloseBtnText: 'OK'
                });
                this.reset();
              }
            }.bind(this)).catch(function (err) {
              console.error(err);
              this.$Simplert.open({
                title: 'Oops',
                message: 'Something went wrong please mail us support@labotist.com',
                type: 'warning',
                disableOverlayClick: true,
                showXclose: true,
                useConfirmBtn: false,
                customCloseBtnText: 'OK'
              });
              // alert('Something went wrong please mail us support@labotist.com')
            }.bind(this));
          } catch (e) {
            console.error(e);
          }
        }
      }.bind(this)).catch(function () {
        console.log('errors exist while save lab form', _this.errors);
      });
    },
    reset: function reset() {
      this.pincode = '';
      this.firstname = '';
      this.lastname = '';
      this.email = '';
      this.mobile = '';
      this.phone = '';
      this.address = '';
      this.city = '';
      this.state = '';
      setTimeout(function () {
        this.errors.items = [];
      }.bind(this), 30);
    }
  },
  mounted: function mounted() {
    this.$hidePageLoading();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1071baad","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/web/Public/Phlebsignup.vue
var Phlebsignup_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"phlebSignupDiv"}},[_c('HeaderVue'),_vm._v(" "),_c('div',{staticClass:"inner-page phleb-signup"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_vm._m(0,false,false),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"sign-up"},[_vm._m(1,false,false),_vm._v(" "),_c('div',{staticClass:"form-content line-textbox"},[_c('form',{attrs:{"data-vv-scope":"signup"}},[_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.pincode),expression:"pincode"},{name:"validate",rawName:"v-validate",value:('required|numeric|max:6|min:6'),expression:"'required|numeric|max:6|min:6'"}],staticClass:"form-control",attrs:{"type":"text","name":"pincode","id":"pincode","data-vv-as":"pincode","placeholder":"Pincode (Chennai & Bengaluru)"},domProps:{"value":(_vm.pincode)},on:{"input":function($event){if($event.target.composing){ return; }_vm.pincode=$event.target.value}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('signup.pincode')),expression:"errors.has('signup.pincode')"}],staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('signup.pincode')))])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.firstname),expression:"firstname"},{name:"validate",rawName:"v-validate",value:('required|alpha|max:50'),expression:"'required|alpha|max:50'"}],staticClass:"form-control",attrs:{"type":"text","name":"firstname","id":"firstname","data-vv-as":"first name","placeholder":"First Name"},domProps:{"value":(_vm.firstname)},on:{"input":function($event){if($event.target.composing){ return; }_vm.firstname=$event.target.value}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('signup.firstname')),expression:"errors.has('signup.firstname')"}],staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('signup.firstname')))])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.lastname),expression:"lastname"},{name:"validate",rawName:"v-validate",value:('required|alpha|max:50'),expression:"'required|alpha|max:50'"}],staticClass:"form-control",attrs:{"type":"text","name":"lastname","id":"lastname","data-vv-as":"last name","placeholder":"Last Name"},domProps:{"value":(_vm.lastname)},on:{"input":function($event){if($event.target.composing){ return; }_vm.lastname=$event.target.value}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('signup.lastname')),expression:"errors.has('signup.lastname')"}],staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('signup.lastname')))])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email),expression:"email"},{name:"validate",rawName:"v-validate",value:('required|email'),expression:"'required|email'"}],staticClass:"form-control",attrs:{"type":"email","name":"email","id":"email","data-vv-as":"email address","placeholder":"Email Address"},domProps:{"value":(_vm.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.email=$event.target.value}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('signup.email')),expression:"errors.has('signup.email')"}],staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('signup.email')))])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.phone),expression:"phone"},{name:"validate",rawName:"v-validate",value:('required|numeric|max:10|min:10'),expression:"'required|numeric|max:10|min:10'"}],staticClass:"form-control",attrs:{"type":"text","name":"phone","id":"phone","data-vv-as":"phone no.","placeholder":"Phone No"},domProps:{"value":(_vm.phone)},on:{"input":function($event){if($event.target.composing){ return; }_vm.phone=$event.target.value}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('signup.phone')),expression:"errors.has('signup.phone')"}],staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('signup.phone')))])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.address),expression:"address"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"form-control",attrs:{"type":"text","name":"address","id":"address","data-vv-as":"address","placeholder":"Address"},domProps:{"value":(_vm.address)},on:{"input":function($event){if($event.target.composing){ return; }_vm.address=$event.target.value}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('signup.address')),expression:"errors.has('signup.address')"}],staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('signup.address')))])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.city),expression:"city"},{name:"validate",rawName:"v-validate",value:('required|alpha_spaces|max:50'),expression:"'required|alpha_spaces|max:50'"}],staticClass:"form-control",attrs:{"type":"text","name":"city","id":"city","data-vv-as":"city","placeholder":"City"},domProps:{"value":(_vm.city)},on:{"input":function($event){if($event.target.composing){ return; }_vm.city=$event.target.value}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('signup.city')),expression:"errors.has('signup.city')"}],staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('signup.city')))])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.state),expression:"state"},{name:"validate",rawName:"v-validate",value:('required|alpha_spaces|max:50'),expression:"'required|alpha_spaces|max:50'"}],staticClass:"form-control",attrs:{"type":"text","name":"state","id":"state","data-vv-as":"state","placeholder":"State"},domProps:{"value":(_vm.state)},on:{"input":function($event){if($event.target.composing){ return; }_vm.state=$event.target.value}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('signup.state')),expression:"errors.has('signup.state')"}],staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('signup.state')))])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('button',{staticClass:"btn  btn-link full-width",attrs:{"type":"reset"},on:{"click":function($event){$event.preventDefault();_vm.reset()}}},[_vm._v("Reset")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('button',{staticClass:"btn btn-primary full-width",attrs:{"disabled":(_vm.errors.any())},on:{"click":function($event){$event.preventDefault();_vm.save()}}},[_vm._v("Send")])])])])])])])])])]),_vm._v(" "),_c('FooterVue')],1)}
var Phlebsignup_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-8"},[_c('div',{staticClass:"lab-benefits phlebotomists-signup"},[_c('h3',[_vm._v("Hello Phlebotomist, \n                            "),_c('br'),_vm._v(" Come and Sign Up with us")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('ul',[_c('li',[_c('span',{staticClass:"number-circle"},[_vm._v("1")]),_vm._v("Become micro-entrepreneurs (Be their own boss)")]),_vm._v(" "),_c('li',[_c('span',{staticClass:"number-circle"},[_vm._v("2")]),_vm._v("Work on a schedule that suits them")]),_vm._v(" "),_c('li',[_c('span',{staticClass:"number-circle"},[_vm._v("3")]),_vm._v("Work within the area that is close to home & family")]),_vm._v(" "),_c('li',[_c('span',{staticClass:"number-circle"},[_vm._v("4")]),_vm._v("Get state of the art training and tools")]),_vm._v(" "),_c('li',[_c('span',{staticClass:"number-circle"},[_vm._v("5")]),_vm._v("Use indigenous mobile app that enables technology driven sample collection\n                            ")]),_vm._v(" "),_c('li',[_c('span',{staticClass:"number-circle"},[_vm._v("6")]),_vm._v("Increase their income \n                            ")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"signup-title"},[_c('h4',[_vm._v("Sign Up")]),_vm._v(" "),_c('p',[_vm._v("Join us as a Labotist Phlebotomist")])])}]
var Phlebsignup_esExports = { render: Phlebsignup_render, staticRenderFns: Phlebsignup_staticRenderFns }
/* harmony default export */ var Public_Phlebsignup = (Phlebsignup_esExports);
// CONCATENATED MODULE: ./src/components/web/Public/Phlebsignup.vue
function Phlebsignup_injectStyle (ssrContext) {
  __webpack_require__("Ymwl")
}
var Phlebsignup_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var Phlebsignup___vue_template_functional__ = false
/* styles */
var Phlebsignup___vue_styles__ = Phlebsignup_injectStyle
/* scopeId */
var Phlebsignup___vue_scopeId__ = "data-v-1071baad"
/* moduleIdentifier (server only) */
var Phlebsignup___vue_module_identifier__ = null
var Phlebsignup_Component = Phlebsignup_normalizeComponent(
  Phlebsignup,
  Public_Phlebsignup,
  Phlebsignup___vue_template_functional__,
  Phlebsignup___vue_styles__,
  Phlebsignup___vue_scopeId__,
  Phlebsignup___vue_module_identifier__
)

/* harmony default export */ var web_Public_Phlebsignup = (Phlebsignup_Component.exports);

// EXTERNAL MODULE: ./node_modules/dateformat/lib/dateformat.js
var dateformat = __webpack_require__("CqLJ");
var dateformat_default = /*#__PURE__*/__webpack_require__.n(dateformat);

// EXTERNAL MODULE: ./node_modules/detect-browser/index.js
var detect_browser = __webpack_require__("+9Dj");
var detect_browser_default = /*#__PURE__*/__webpack_require__.n(detect_browser);

// EXTERNAL MODULE: ./node_modules/vue-pdfviewer/pdf/pdf.js
var pdf = __webpack_require__("2gP5");
var pdf_default = /*#__PURE__*/__webpack_require__.n(pdf);

// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__("mtWM");
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/plugin/vue-pdfviewer/CPdf.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var CPdf = ({
    name: 'c-pdf',
    props: {
        pdfurl: {
            default: ''
        },
        value: {},
        maxscale: {
            default: 1,
            type: Number
        },
        minscale: {
            default: 0.8,
            type: Number
        },
        scale: {
            default: null,
            type: Number
        },
        desiredWidth: null
    },
    //['pdfurl', 'value'],
    data: function data() {

        return {
            pdfDoc: null, //pdfjs 生成的对象
            pageNum: 1, //
            pageRendering: false,
            pageNumPending: null,
            compuscale: 0, //放大倍数
            page_num: 0, //当前页数
            page_count: 0, //总页数
            // maxscale: 2, //最大放大倍数
            // minscale: 0.8, //最小放大倍数
            isready: false,
            statePdfUrl: '',
            loader: false
        };
    },

    methods: {
        downloadpdf: function downloadpdf() {
            axios_default()({
                url: this.statePdfUrl,
                method: 'GET',
                responseType: 'blob' // important
            }).then(function (response) {
                var url = window.URL.createObjectURL(new Blob([response.data]));
                var link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'labotistreport.pdf');
                document.body.appendChild(link);
                link.click();
            });
        },
        renderPage: function renderPage(num) {
            //渲染pdf
            var vm = this;
            this.pageRendering = true;
            var canvas = document.getElementById('the-canvas');
            // Using promise to fetch the page
            this.pdfDoc.getPage(num).then(function (page) {
                if (vm.desiredWidth == null || vm.compuscale != null) {
                    var viewport = page.getViewport(vm.compuscale);
                    //alert(vm.canvas.height)
                    canvas.height = viewport.height;
                    canvas.width = viewport.width;
                    vm.isready = true;
                    var renderContext = {
                        canvasContext: vm.ctx,
                        viewport: viewport
                    };
                } else {
                    var desiredWidth = vm.desiredWidth;
                    var viewport = page.getViewport(1);
                    var scale = desiredWidth / viewport.width;
                    var scaledViewport = page.getViewport(scale);
                    canvas.height = scaledViewport.height;
                    canvas.width = scaledViewport.width;
                    vm.compuscale = scale;
                    vm.isready = true;
                    var renderContext = {
                        canvasContext: vm.ctx,
                        viewport: scaledViewport
                    };
                }
                // Render PDF page into canvas context

                var renderTask = page.render(renderContext);

                // Wait for rendering to finish
                renderTask.promise.then(function () {
                    vm.pageRendering = false;
                    if (vm.pageNumPending !== null) {
                        // New page rendering is pending
                        vm.renderPage(vm.pageNumPending);
                        vm.pageNumPending = null;
                    }
                });
            });
            vm.page_num = vm.pageNum;
        },
        addscale: function addscale() {
            if (this.compuscale >= this.maxscale) {
                return;
            }
            this.compuscale += 0.1;
            this.queueRenderPage(this.pageNum);
        },
        minus: function minus() {
            if (this.compuscale <= this.minscale) {
                return;
            }
            this.compuscale -= 0.1;
            this.queueRenderPage(this.pageNum);
        },
        prev: function prev() {
            //上一页
            var vm = this;
            if (vm.pageNum <= 1) {
                return;
            }
            vm.pageNum--;
            vm.queueRenderPage(vm.pageNum);
        },
        next: function next() {
            //下一页
            var vm = this;
            if (vm.pageNum >= vm.page_count) {
                return;
            }
            vm.pageNum++;
            vm.queueRenderPage(vm.pageNum);
        },
        closepdf: function closepdf() {
            //关闭PDF
            this.pdfDoc = null;
            this.isready = false;
            this.compuscale = this.scale;
            this.$emit('closepdf');
        },
        throwerr: function throwerr(err) {
            this.$emit('pdferr', err);
        },
        queueRenderPage: function queueRenderPage(num) {
            if (this.pageRendering) {
                this.pageNumPending = num;
            } else {
                this.renderPage(num);
            }
        }
    },
    computed: {
        ctx: function ctx() {
            var id = document.getElementById('the-canvas');
            return id.getContext('2d');
        },
        isshowpdf: function isshowpdf() {
            if (this.value == undefined) return false;
            return this.value;
        }
    },
    mounted: function mounted() {
        this.compuscale = this.scale;
    },

    watch: {
        isshowpdf: function isshowpdf(b) {
            var vm = this;
            var val = vm.pdfurl;
            this.statePdfUrl = val;

            if (b == false || val == '' || val == undefined) return;
            this.$showPageLoading();
            pdf_default.a.getDocument(val).then(function (pdfDoc_) {
                vm.pdfDoc = pdfDoc_;
                vm.page_count = vm.pdfDoc.numPages;
                vm.renderPage(vm.pageNum);
                this.$hidePageLoading();
            }.bind(this)).catch(function (err) {
                if (err) {
                    console.log(err);
                    vm.throwerr(vm.pdfurl);
                    this.$hidePageLoading();
                }
            }.bind(this));
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-555bddde","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/plugin/vue-pdfviewer/CPdf.vue
var CPdf_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isready),expression:"isready"}],staticClass:"cpdf"},[_c('div',{staticClass:"center"},[_c('div',{staticClass:"contor"},[(!_vm.$IsMobile)?_c('div',{staticClass:"row ",staticStyle:{"font-size":"15px"}},[_c('div',{staticClass:"col-sm-4 text-right"},[_c('i',{staticClass:"fa fa-chevron-circle-left fa-2x",on:{"click":_vm.prev}}),_vm._v(" "),_c('i',{staticClass:"fa fa-chevron-circle-right fa-2x",on:{"click":_vm.next}}),_vm._v(" "),_c('i',{staticClass:"fa fa-download fa-2x",attrs:{"aria-hidden":"true"},on:{"click":_vm.downloadpdf}})]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('span',{staticStyle:{"color":"#fff"}},[_vm._v("Page: "),_c('span',{domProps:{"textContent":_vm._s(_vm.page_num)}}),_vm._v(" / "),_c('span',{domProps:{"textContent":_vm._s(_vm.page_count)}})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4 text-left"},[_c('i',{staticClass:"fa fa-plus-circle fa-2x",on:{"click":_vm.addscale}}),_vm._v(" "),_c('i',{staticClass:"fa fa-minus-circle fa-2x",on:{"click":_vm.minus}}),_vm._v(" "),_c('i',{staticClass:"fa fa-times-circle fa-2x",on:{"click":_vm.closepdf}})])]):_vm._e(),_vm._v(" "),(_vm.$IsMobile)?_c('div',{staticClass:"row ",staticStyle:{"font-size":"13px"}},[_c('i',{staticClass:"fa fa-chevron-circle-left fa-2x",on:{"click":_vm.prev}}),_vm._v(" "),_c('i',{staticClass:"fa fa-chevron-circle-right fa-2x",on:{"click":_vm.next}}),_vm._v(" "),_c('i',{staticClass:"fa fa-download fa-2x",attrs:{"aria-hidden":"true"},on:{"click":_vm.downloadpdf}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#fff","padding":"0px 17px"}},[_c('span',{domProps:{"textContent":_vm._s(_vm.page_num)}}),_vm._v(" / "),_c('span',{domProps:{"textContent":_vm._s(_vm.page_count)}})]),_vm._v(" "),_c('i',{staticClass:"fa fa-plus-circle fa-2x",on:{"click":_vm.addscale}}),_vm._v(" "),_c('i',{staticClass:"fa fa-minus-circle fa-2x",on:{"click":_vm.minus}}),_vm._v(" "),_c('i',{staticClass:"fa fa-times-circle fa-2x",on:{"click":_vm.closepdf}})]):_vm._e()]),_vm._v(" "),_vm._m(0,false,false)])])}
var CPdf_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('canvas',{staticClass:"canvasstyle",attrs:{"id":"the-canvas"}})])])}]
var CPdf_esExports = { render: CPdf_render, staticRenderFns: CPdf_staticRenderFns }
/* harmony default export */ var vue_pdfviewer_CPdf = (CPdf_esExports);
// CONCATENATED MODULE: ./src/components/plugin/vue-pdfviewer/CPdf.vue
function CPdf_injectStyle (ssrContext) {
  __webpack_require__("S3ap")
}
var CPdf_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var CPdf___vue_template_functional__ = false
/* styles */
var CPdf___vue_styles__ = CPdf_injectStyle
/* scopeId */
var CPdf___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var CPdf___vue_module_identifier__ = null
var CPdf_Component = CPdf_normalizeComponent(
  CPdf,
  vue_pdfviewer_CPdf,
  CPdf___vue_template_functional__,
  CPdf___vue_styles__,
  CPdf___vue_scopeId__,
  CPdf___vue_module_identifier__
)

/* harmony default export */ var plugin_vue_pdfviewer_CPdf = (CPdf_Component.exports);

// CONCATENATED MODULE: ./src/components/plugin/vue-pdfviewer/index.js

var vue_pdfviewer_install = function install(Vue) {
        var opys = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        Vue.component(plugin_vue_pdfviewer_CPdf.name, plugin_vue_pdfviewer_CPdf);
};
//install();
/* harmony default export */ var vue_pdfviewer = (plugin_vue_pdfviewer_CPdf);
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/web/Secure/MyResult.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var MyResult = ({
  name: 'MyResult',
  props: [],
  components: {
    HeaderVue: Header["a" /* default */],
    FooterVue: Footer["a" /* default */],
    pdfviewer: vue_pdfviewer
  },
  beforeCreate: function beforeCreate() {
    if (!this.$localStorage.get('loggedIn') || this.$localStorage.get('loggedIn') === null) {
      this.$router.push({ path: '/' });
    }
  },
  data: function data() {
    return {
      loadMorePerHit: 10,
      reportLimit: 10,
      totalReports: [],
      reportList: [],
      limitedReportList: [],
      isLoading: false,
      deviceData: undefined,
      pdfurls: '',
      isshowpdf: false
    };
  },
  created: function created() {
    this.patientReports();
    this.deviceData = detect_browser_default.a.detect();
  },

  methods: {
    closepdf: function closepdf() {
      this.isshowpdf = false;
    },
    pdferr: function pdferr(errurl) {
      console.log(errurl);
      this.pdfurls = '';
      this.isshowpdf = false;
      // alert('Unable to fetch Report try again')
      this.$Simplert.open({
        title: 'Oops',
        message: 'Unable to fetch Report try again',
        type: 'warning',
        disableOverlayClick: true,
        showXclose: true,
        useConfirmBtn: false,
        customCloseBtnText: 'OK'
      });
    },

    loadMore: function loadMore() {
      var increamented = this.reportLimit + this.loadMorePerHit;
      this.reportLimit = increamented > this.totalReports.length ? this.totalReports.length : increamented;
    },
    formatDate: function formatDate(date, format) {
      var dateSplit = date.split(' ');
      return dateformat_default()(dateSplit[0] + 'T' + dateSplit[1], format, true);
    },
    formatReportDate: function formatReportDate(date, format) {
      return dateformat_default()(date, format);
    },
    patientReports: function patientReports() {
      try {
        this.reportList = [];
        var data = {};
        this.isLoading = true;
        promise_default.a.resolve(this.$POST('patient/patientReports', data)).then(function (res) {
          if (res.response_code === 0) {
            this.totalReports = res.response;
            this.isLoading = false;
          } else {
            this.isLoading = false;
          }
          this.$hidePageLoading();
        }.bind(this)).catch(function (err) {
          console.error(err);
        });
      } catch (e) {
        console.error(e);
      }
    },
    viewReport: function viewReport(requestId) {
      try {
        this.reportList = [];
        var data = {
          requestId: requestId
        };
        promise_default.a.resolve(this.$GET('patient/viewReport', data)).then(function (res) {
          if (res.response_code === 0) {
            try {
              //   var popupWindow = window.open(res.response.url, '_blank')
              //   popupWindow.focus()
              this.pdfurls = res.response.url;
              this.isshowpdf = true;
            } catch (e) {
              this.popupBlockerAlert();
            }
          } else {
            this.$Simplert.open({
              title: 'Oops',
              message: res.response_message,
              type: 'warning',
              disableOverlayClick: true,
              showXclose: true,
              useConfirmBtn: false,
              customCloseBtnText: 'OK'
            });
            // alert(res.response_message)
          }
        }.bind(this)).catch(function (err) {
          console.error(err);
        });
      } catch (e) {
        console.error(e);
      }
    },
    popupBlockerAlert: function popupBlockerAlert() {
      if (this.deviceData.name === 'chrome' && this.deviceData.os.indexOf('Windows') > -1) {
        this.$Simplert.open({
          title: 'Popup Blocked',
          message: '<div style="text-align: left; line-height: 25px;">\n                    <strong>1. </strong> Click the <strong>Customize and control Google Chrome</strong> menu (the three horizontal bars in the upper right corner)<br>\n                    <strong>2. </strong> Select <strong>Settings</strong>.<br>\n                    <strong>3. </strong> Click the <strong>Show advanced settings...</strong> at the bottom.<br>\n                    <strong>4. </strong> Under Privacy, click the <strong>Content Settings</strong> button.<br>\n                    <strong>5. </strong> To disable the pop-up blocker check the <strong>Allow all sites to show pop-ups</strong> box.<br>\n                    <strong>6. </strong> To enable pop-ups on specific sites, check <strong>Do not allow any site to show pop-ups</strong> (recommended) and click Exceptions and enter this URL(<strong>https://labotist.com</strong>).\n                </div>',
          type: 'warning',
          disableOverlayClick: true,
          showXclose: true,
          useConfirmBtn: false,
          customCloseBtnText: 'OK'
        });
      } else if (this.deviceData.name === 'chrome' && this.deviceData.os.indexOf('Mac') > -1) {
        this.$Simplert.open({
          title: 'Popup Blocked',
          message: '<div style="text-align: left; line-height: 25px;">\n                    <strong>1. </strong> Click the <strong>Customize and control Google Chrome</strong> menu (the three horizontal bars in the upper right corner)<br>\n                    <strong>2. </strong>  Select <strong>Settings</strong>.<br>\n                    <strong>3. </strong> Click the <strong>Show advanced settings...</strong> at the bottom.<br>\n                    <strong>4. </strong> Under <strong>Privacy</strong>, click the <strong>Content Settings</strong> button.<br>\n                    <strong>5. </strong> To disable the pop-up blocker check the Allow all sites to show pop-ups box.<br>\n                    <strong>6. </strong> To enable pop-ups on specific sites, check <strong>Do not allow any site to show pop-ups</strong> (recommended) and click Exceptions and enter this URL(<strong>https://labotist.com</strong>).<br>\n                </div>',
          type: 'warning',
          disableOverlayClick: true,
          showXclose: true,
          useConfirmBtn: false,
          customCloseBtnText: 'OK'
        });
      } else if (this.deviceData.name === 'chrome' && this.deviceData.os.indexOf('Android') > -1) {
        this.$Simplert.open({
          title: 'Popup Blocked',
          message: '<div style="text-align: left; line-height: 25px;">\n                    <strong>1. </strong> To the right of the address bar, tap More  and then <strong>Settings</strong>.<br>\n                    <strong>2. </strong>  Tap <strong>Site settings</strong> and then <strong>Pop-ups</strong>.<br>\n                    <strong>3. </strong> Turn <strong>Pop-ups</strong> to <strong>Allowed</strong>.\n                    </div>',
          type: 'warning',
          disableOverlayClick: true,
          showXclose: true,
          useConfirmBtn: false,
          customCloseBtnText: 'OK'
        });
      } else if (this.deviceData.name === 'crios' && this.deviceData.os.indexOf('iOS') > -1) {
        this.$Simplert.open({
          title: 'Popup Blocked',
          message: '<div style="text-align: left; line-height: 25px;">\n                    <strong>1. </strong> To the right of the address bar, tap More  and then <strong>Settings</strong>.<br>\n                    <strong>2. </strong>  Tap <strong>Content Settings</strong> and then <strong>Block Pop-ups</strong>.<br>\n                    <strong>3. </strong> Turn <strong>Block pop-ups</strong> off.\n                </div>',
          type: 'warning',
          disableOverlayClick: true,
          showXclose: true,
          useConfirmBtn: false,
          customCloseBtnText: 'OK'
        });
      } else if (this.deviceData.name === 'safari' && this.deviceData.os.indexOf('Mac') > -1) {
        this.$Simplert.open({
          title: 'Popup Blocked',
          message: '<div style="text-align: left; line-height: 25px;">\n                    <strong>1. </strong> From the <strong>Safari</strong> menu, select <strong>Preferences</strong><br>\n                    <strong>2. </strong>  Click <strong>Security</strong> at the top of the window<br>\n                    <strong>3. </strong> Uncheck the <strong>Block pop-up windows</strong> box.\n                </div>',
          type: 'warning',
          disableOverlayClick: true,
          showXclose: true,
          useConfirmBtn: false,
          customCloseBtnText: 'OK'
        });
      } else if (this.deviceData.name === 'ios' && this.deviceData.os.indexOf('iOS') > -1) {
        this.$Simplert.open({
          title: 'Popup Blocked',
          message: '<div style="text-align: left; line-height: 25px;">\n                    <strong>1. </strong> Launch <strong>Settings</strong>.<br>\n                    <strong>2. </strong>  Tap <strong>Safari</strong>.<br>\n                    <strong>3. </strong> Under the <strong>General section</strong>, click the toggle next to <strong>Block Pop-ups</strong> to <strong>disable</strong> the pop-up blocker. A green toggle indicates an enabled pop-up blocker.\n                </div>',
          type: 'warning',
          disableOverlayClick: true,
          showXclose: true,
          useConfirmBtn: false,
          customCloseBtnText: 'OK'
        });
      } else if (this.deviceData.name === 'firefox' && this.deviceData.os.indexOf('Mac') > -1) {
        this.$Simplert.open({
          title: 'Popup Blocked',
          message: '<div style="text-align: left; line-height: 25px;">\n                    <strong>1. </strong> Select <strong>Preferences</strong> from the <strong>Firefox</strong> menu.<br>\n                    <strong>2. </strong>  Choose the <strong>Content</strong> button.<br>\n                    <strong>3. </strong> Uncheck the <strong>Block pop-up windows</strong> box.\n                </div>',
          type: 'warning',
          disableOverlayClick: true,
          showXclose: true,
          useConfirmBtn: false,
          customCloseBtnText: 'OK'
        });
      } else if (this.deviceData.name === 'firefox' && this.deviceData.os.indexOf('Windows') > -1) {
        this.$Simplert.open({
          title: 'Popup Blocked',
          message: '<div style="text-align: left; line-height: 25px;">\n                    <strong>1. </strong> Click the <strong>"hamburger" menu icon (top right) </strong> to open the Firefox menu.<br>\n                    <strong>2. </strong> Click <strong>Options</strong>.<br>\n                    <strong>3. </strong> Click <strong>Privacy & Security</strong> menu.<br>\n                    <strong>4. </strong> Under <strong>Permission</strong> menu make sure that <strong>Block pop-up windows</strong> is activated (checkbox).<br>\n                    <strong>5. </strong> Click the <strong>Exceptions</strong> button located to the right of Block pop-up windows.<br>\n                    <strong>6. </strong> You will see the Allowed Sites dialog box.<br>\n                    <strong>7. </strong> To enable add <strong>https://labotist.com</strong> and then click <strong>Allow</strong>\n                </div>',
          type: 'warning',
          disableOverlayClick: true,
          showXclose: true,
          useConfirmBtn: false,
          customCloseBtnText: 'OK'
        });
      } else {
        this.$Simplert.open({
          title: 'Popup Blocked',
          message: 'Pop-up Blocker is enabled! Please add this site to your exception list.',
          type: 'warning',
          disableOverlayClick: true,
          showXclose: true,
          useConfirmBtn: false,
          customCloseBtnText: 'OK'
        });
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9838fdf2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/web/Secure/MyResult.vue
var MyResult_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"MyResultDiv"}},[_c('HeaderVue'),_vm._v(" "),_vm._m(0,false,false),_vm._v(" "),_c('router-link',{staticClass:"w-100 referal-image",attrs:{"to":"/referral/invite"}},[_c('img',{staticClass:"responsive-result-image",attrs:{"src":"static/images/referral_web_banner.jpg","alt":""}})]),_vm._v(" "),_c('div',{staticClass:"inner-page-result phleb-signup my-profile"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"my-result"},[_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table black-color"},[_vm._m(1,false,false),_vm._v(" "),_vm._l((_vm.limitBy(_vm.totalReports, _vm.reportLimit)),function(item,index){return _c('tbody',{key:index},[_c('tr',[_c('td',[_vm._v("REQ"+_vm._s(item.requestId))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.reqPatientFirstName+ ' '+ item.reqPatientLastName))]),_vm._v(" "),_c('td',[_vm._v("\n                                          "+_vm._s(_vm.formatDate((item.appointmentDate), 'dd/mm/yyyy'))),_c('br'),_vm._v("\n                                          "+_vm._s(item.appointmentFromTime)+" - "+_vm._s(item.appointmentToTime)+"\n                                        ")]),_vm._v(" "),_c('td',[_c('span',[_vm._v(_vm._s((item.requestTestList).join(', ')))])]),_vm._v(" "),_c('td',[_vm._v("\n                                            "+_vm._s(item.labName)),_c('br'),_vm._v(" "),_c('span',{staticClass:"grey-color"},[_vm._v(_vm._s(item.labLocation+', '+item.labCity+' - '+item.labZipcode))])]),_vm._v(" "),_c('td',[_vm._v(_vm._s((item.reportDeliveredDate)?(_vm.formatReportDate(item.reportDeliveredDate, 'dd/mm/yyyy hh:MM TT')):'-'))]),_vm._v(" "),_c('td',[(item.requestStatus === -1)?_c('h6',{staticClass:"m-0 text-danger text-uppercase"},[_vm._v("Payment Pending")]):_vm._e(),_vm._v(" "),(item.requestStatus === -2)?_c('h6',{staticClass:"m-0 text-danger text-uppercase"},[_vm._v("Payment Failure")]):_vm._e(),_vm._v(" "),(item.requestStatus === 0 || item.requestStatus === 2)?_c('h6',{staticClass:"m-0 text-success text-uppercase"},[_vm._v("Requested")]):_vm._e(),_vm._v(" "),(item.requestStatus === 1 || item.requestStatus === 12)?_c('h6',{staticClass:"m-0 text-warning text-uppercase"},[_vm._v("Phelebotomist Accepted")]):_vm._e(),_vm._v(" "),(item.requestStatus === 3)?_c('h6',{staticClass:"m-0 text-warning text-uppercase"},[_vm._v("Sample Collected")]):_vm._e(),_vm._v(" "),(item.requestStatus === 4 || item.requestStatus === 5 || item.requestStatus === 7)?_c('h6',{staticClass:"m-0 text-success text-uppercase"},[_vm._v("Sample Delivered to Lab")]):_vm._e(),_vm._v(" "),(item.requestStatus === 8)?_c('h6',{staticClass:"m-0 text-danger text-uppercase"},[_vm._v("Cancelled")]):_vm._e(),_vm._v(" "),(item.requestStatus === 9)?_c('h6',{staticClass:"m-0 text-secondary text-uppercase"},[_vm._v("Refund")]):_vm._e(),_vm._v(" "),(item.requestStatus === 11)?_c('h6',{staticClass:"m-0 text-danger text-uppercase"},[_vm._v("Payment Processing")]):(item.requestStatus === 6)?_c('button',{staticClass:"btn btn-sm text-nowrap btn-primary",on:{"click":function($event){_vm.viewReport(item.requestId)}}},[_vm._v("View PDF")]):_vm._e()])])])}),_vm._v(" "),(_vm.totalReports.length <= 0 && _vm.isLoading)?_c('tbody',[_vm._m(2,false,false)]):_vm._e(),_vm._v(" "),(_vm.totalReports.length <= 0 && !_vm.isLoading)?_c('tbody',[_vm._m(3,false,false)]):_vm._e()],2)])])])]),_vm._v(" "),(_vm.totalReports.length > _vm.reportLimit)?_c('button',{staticClass:"btn btn-outline-primary align-center",on:{"click":function($event){_vm.loadMore()}}},[_vm._v("Show more Results("+_vm._s(_vm.totalReports.length - _vm.reportLimit)+")")]):_vm._e()])]),_vm._v(" "),_c('pdfviewer',{attrs:{"pdfurl":_vm.pdfurls,"maxscale":4,"minscale":0.6,"scale":1.1,"desiredWidth":2},on:{"closepdf":_vm.closepdf,"pdferr":_vm.pdferr},model:{value:(_vm.isshowpdf),callback:function ($$v) {_vm.isshowpdf=$$v},expression:"isshowpdf"}}),_vm._v(" "),_c('FooterVue')],1)}
var MyResult_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"blue-title-bar"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('h2',[_vm._v("My Results")])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',{staticClass:"grey-section"},[_c('tr',[_c('th',{},[_vm._v("Request No")]),_vm._v(" "),_c('th',[_vm._v("Patient Name")]),_vm._v(" "),_c('th',[_vm._v("Date/ Time")]),_vm._v(" "),_c('th',[_vm._v("Test/ Profile")]),_vm._v(" "),_c('th',[_vm._v("Lab Name/ Locality")]),_vm._v(" "),_c('th',[_vm._v("Report Date")]),_vm._v(" "),_c('th',{staticStyle:{"text-align":"center"}},[_vm._v("Result Status")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td',{attrs:{"colspan":"6","align":"center"}},[_vm._v("Loading...")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td',{attrs:{"colspan":"6","align":"center"}},[_vm._v("No records found")])])}]
var MyResult_esExports = { render: MyResult_render, staticRenderFns: MyResult_staticRenderFns }
/* harmony default export */ var Secure_MyResult = (MyResult_esExports);
// CONCATENATED MODULE: ./src/components/web/Secure/MyResult.vue
function MyResult_injectStyle (ssrContext) {
  __webpack_require__("8Fyf")
}
var MyResult_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var MyResult___vue_template_functional__ = false
/* styles */
var MyResult___vue_styles__ = MyResult_injectStyle
/* scopeId */
var MyResult___vue_scopeId__ = "data-v-9838fdf2"
/* moduleIdentifier (server only) */
var MyResult___vue_module_identifier__ = null
var MyResult_Component = MyResult_normalizeComponent(
  MyResult,
  Secure_MyResult,
  MyResult___vue_template_functional__,
  MyResult___vue_styles__,
  MyResult___vue_scopeId__,
  MyResult___vue_module_identifier__
)

/* harmony default export */ var web_Secure_MyResult = (MyResult_Component.exports);

// EXTERNAL MODULE: ./node_modules/underscore/underscore.js
var underscore = __webpack_require__("rdLu");
var underscore_default = /*#__PURE__*/__webpack_require__.n(underscore);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/web/Secure/MyProfile.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var MyProfile = ({
  name: 'MyProfile',
  props: [],
  components: {
    HeaderVue: Header["a" /* default */],
    FooterVue: Footer["a" /* default */]
  },
  beforeCreate: function beforeCreate() {
    if (!this.$localStorage.get('loggedIn') || this.$localStorage.get('loggedIn') === null) {
      this.$router.push({ path: '/' });
    }
  },
  data: function data() {
    return {
      firstName: '',
      lastName: '',
      email: '',
      phone1: '',
      phone2: '',
      dob: '',
      sex: '',
      photo: '',
      address: {},
      creditPoint: undefined,
      referralCode: '',
      tick: false,
      referralUrl: '',
      credits: ''
    };
  },
  mounted: function mounted() {
    this.getProfile();
    $('input[data-toggle="tooltip"]').tooltip({
      animated: 'fade',
      placement: 'top',
      trigger: 'manual'
    });
  },

  watch: {
    referralUrl: function referralUrl() {
      // this.referralUrl = this.$signupUrl + this.$encryptString(this.referralCode.toLowerCase())
    }
  },
  methods: {
    copyReferralCodeUrl: function copyReferralCodeUrl() {
      this.$refs.copyReferralText.select();
      document.execCommand("copy");
      $('input[data-toggle="tooltip"]').tooltip("show");
      setTimeout(function () {
        $('input[data-toggle="tooltip"]').tooltip("hide");
      }, 1000);
    },
    getProfile: function getProfile() {
      try {
        if (this.$localStorage.get('loggedIn') && this.$localStorage.get('access_token') && this.$localStorage.get('access_token') !== null) {
          var data = {};
          promise_default.a.resolve(this.$GET('patient/getProfile', data)).then(function (res) {
            if (res.response_code === 0) {
              if (res.response) {
                underscore_default.a.each(res.response.Addresses, function (item) {
                  if (item.isDefault === 1) {
                    this.address = item.address;
                  }
                });
              }
              this.firstName = res.response.Patient.firstName;
              this.lastName = res.response.Patient.lastName;
              this.email = res.response.email;
              this.phone1 = res.response.Patient.phone1;
              this.phone2 = res.response.Patient.phone2;
              this.dob = res.response.Patient.dob ? res.response.Patient.dob : '';
              this.sex = res.response.Patient.sex;
              this.creditPoint = res.response.Patient.creditPoint;
              this.referralCode = res.response.Patient.referralCode;
              this.referralUrl = this.$signupUrl + this.$encryptString(this.referralCode);
              this.credits = res.response.credits;

              var userDetails = {
                'username': res.response.Patient.firstName + ' ' + res.response.Patient.lastName,
                'firstName': res.response.Patient.firstName,
                'lastName': res.response.Patient.lastName,
                'photo': res.response.Patient.photo,
                'dob': res.response.Patient.dob,
                'phone1': res.response.Patient.phone1,
                'phone2': res.response.Patient.phone2,
                'sex': res.response.Patient.sex,
                'email': res.response.email,
                'credits': res.response.Patient.creditPoint
              };
              this.$localStorage.set('profile', userDetails, 0);
              this.$root.$emit('profileUpdated', true);
            }
            this.$hidePageLoading();
          }.bind(this)).catch(function (err) {
            console.error(err);
          });
        }
      } catch (e) {
        console.error('method:getProfile', e);
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-147105a2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/web/Secure/MyProfile.vue
var MyProfile_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"MyProfileDiv"}},[_c('HeaderVue'),_vm._v(" "),_c('div',{staticClass:"inner-page phleb-signup my-profile"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6 offset-sm-3"},[_c('div',{staticClass:"sign-up"},[_vm._m(0,false,false),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-5"},[_c('div',{staticClass:"form-content line-textbox"},[_c('label',[_vm._v(_vm._s(_vm.firstName + ' ' + _vm.lastName))]),_vm._v(" "),_c('label',[_vm._v(_vm._s(_vm.email))]),_vm._v(" "),_c('label',[_vm._v(_vm._s(_vm.phone1))]),_vm._v(" "),_c('router-link',{attrs:{"to":"/changepassword"}},[_vm._v("Change Password")]),_vm._v(" "),_c('div',{staticClass:"row mt-3"},[_c('div',{staticClass:"col-sm-12"},[_c('router-link',{attrs:{"to":"/editprofile"}},[_c('button',{staticClass:"btn btn-primary full-width"},[_vm._v("Edit")])])],1)])],1)]),_vm._v(" "),_c('div',{staticClass:"col-sm-7"},[_c('div',{staticClass:"form-content line-textbox"},[_c('div',{staticClass:"d-flex credit-box"},[_c('div',{staticClass:"credit-points"},[_c('div',{staticClass:"d-flex"},[_c('div',{staticClass:"credit-score"},[_c('h1',{staticClass:"m-0"},[_vm._v(_vm._s(_vm.creditPoint))]),_vm._v(" "),_c('p',[_vm._v("Credits")])]),_vm._v(" "),_c('div',{staticClass:"referral-code"},[_c('h4',{staticClass:"mt-0"},[_c('span',{staticClass:"badge badge-secondary"},[_vm._v(_vm._s(_vm.referralCode))])]),_vm._v(" "),_c('h6',{staticClass:"mb-0"},[_vm._v("Your Referral Code")])])]),_vm._v(" "),_c('router-link',{attrs:{"to":"/referral/invite"}},[_c('button',{staticClass:"btn btn-sm btn-outline-primary mt-3 w-100"},[_vm._v("Refer & Earn")])])],1)])])])])])])])])]),_vm._v(" "),_c('FooterVue'),_vm._v(" "),_c('div',{staticClass:"modal fade bd-example-modal-sm",attrs:{"id":"inviteFriends","tabindex":"-1","role":"dialog","aria-labelledby":"exampleModalLabel","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog modal-sm",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_vm._m(1,false,false),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('p',{staticClass:"mt-0"},[_vm._v("\n                    Copy & share the link to your friends & family to earn Rs."+_vm._s(_vm.credits)+" worth of Labotist credits, when each referral completes an order through Labotist. Your friend or family member will also earn Labotist credits which they can immediately use.\n                ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.referralUrl),expression:"referralUrl"}],ref:"copyReferralText",staticClass:"copy-link",attrs:{"type":"text","name":"copyReferralText","id":"copyReferralText","data-toggle":"tooltip","data-placement":"top","title":"Copied"},domProps:{"value":(_vm.referralUrl)},on:{"focus":function($event){_vm.copyReferralCodeUrl()},"click":function($event){_vm.copyReferralCodeUrl()},"input":function($event){if($event.target.composing){ return; }_vm.referralUrl=$event.target.value}}})]),_vm._v(" "),_vm._m(2,false,false)])])])],1)}
var MyProfile_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"signup-title"},[_c('h4',{staticClass:"mt-0 mb-0"},[_vm._v("My Account")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-header"},[_c('h5',{staticClass:"modal-title",attrs:{"id":"exampleModalLabel"}},[_vm._v("Refer and earn credit points")]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-dismiss":"modal"}},[_vm._v("Close")])])}]
var MyProfile_esExports = { render: MyProfile_render, staticRenderFns: MyProfile_staticRenderFns }
/* harmony default export */ var Secure_MyProfile = (MyProfile_esExports);
// CONCATENATED MODULE: ./src/components/web/Secure/MyProfile.vue
function MyProfile_injectStyle (ssrContext) {
  __webpack_require__("w+9O")
}
var MyProfile_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var MyProfile___vue_template_functional__ = false
/* styles */
var MyProfile___vue_styles__ = MyProfile_injectStyle
/* scopeId */
var MyProfile___vue_scopeId__ = "data-v-147105a2"
/* moduleIdentifier (server only) */
var MyProfile___vue_module_identifier__ = null
var MyProfile_Component = MyProfile_normalizeComponent(
  MyProfile,
  Secure_MyProfile,
  MyProfile___vue_template_functional__,
  MyProfile___vue_styles__,
  MyProfile___vue_scopeId__,
  MyProfile___vue_module_identifier__
)

/* harmony default export */ var web_Secure_MyProfile = (MyProfile_Component.exports);

// EXTERNAL MODULE: ./node_modules/vuejs-datepicker/dist/build.js
var build = __webpack_require__("XILU");
var build_default = /*#__PURE__*/__webpack_require__.n(build);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/web/Secure/EditProfile.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var EditProfile = ({
  name: 'EditProfile',
  components: {
    HeaderVue: Header["a" /* default */],
    FooterVue: Footer["a" /* default */],
    Datepicker: build_default.a
  },
  beforeCreate: function beforeCreate() {
    if (!this.$localStorage.get('loggedIn') || this.$localStorage.get('loggedIn') === null) {
      this.$router.push({ path: '/' });
    }
  },
  data: function data() {
    return {
      isDobError: false,
      firstName: '',
      lastName: '',
      email: '',
      phone1: '',
      phone2: '',
      dob: undefined,
      sex: '',
      photo: '',
      address: {},
      disabled: {
        from: new Date()
      },
      dobYears: [],
      dobDate: [],
      year: '',
      month: '',
      ddate: '',
      isMobileError: false,
      mobileErrorMsg: '',
      isError: false
    };
  },
  created: function created() {
    var year = new Date().getFullYear();
    var endYear = year - 120;
    for (var i = year; i > endYear; i--) {
      this.dobYears.push(i.toString());
    }
  },
  mounted: function mounted() {
    this.getProfile();
  },

  methods: {
    getNumberOfDays: function getNumberOfDays(dateVal) {
      if (this.year && this.year !== '' && this.month && this.month !== '') {
        var noOfDays = new Date(this.year, this.month, 0).getDate();
        this.dobDate = [];
        for (var j = 1; j <= noOfDays; j++) {
          this.dobDate.push(j.toString());
        }
        if (dateVal) {
          this.ddate = dateVal;
        } else {
          if (this.ddate) {
            var res = true;
            this.dobDate.forEach(function (dataV) {
              if (parseInt(dataV) === parseInt(this.ddate)) {
                res = false;
              }
            }.bind(this));
            if (res) {
              this.ddate = '';
            }
          }
        }
      }
      return false;
    },
    saveProfile: function saveProfile() {
      var _this = this;

      this.isDobError = false;
      this.isMobileError = false;
      this.isError = false;
      this.$validator.validateAll('edit').then(function (result) {
        if (result) {
          if (_this.year.length !== 4 || _this.month.length <= 0 || _this.ddate.length <= 0) {
            _this.isDobError = true;
            return false;
          }
          try {
            var data = {
              'firstName': _this.firstName,
              'lastName': _this.lastName,
              'phone1': _this.phone1,
              'phone2': _this.phone2,
              'photo': '',
              'sex': _this.sex,
              'dob': _this.year + '-' + _this.month + '-' + _this.ddate,
              'panNo': '',
              'aadharNo': '',
              'drivingLicenceNo': ''
            };
            console.log(data);
            promise_default.a.resolve(_this.$POST('patient/updateProfile', data)).then(function (res) {
              if (res.response_code === 0) {
                this.$localStorage.remove('profile');
                var userDetails = {
                  'username': this.firstName + ' ' + this.lastName,
                  'firstName': this.firstName,
                  'lastName': this.lastName,
                  'phone1': this.phone1,
                  'dob': dateformat_default()(this.dob, 'yyyy-mm-dd', true),
                  'photo': ''
                };
                this.$localStorage.set('profile', userDetails, 0);
                this.$router.push({ path: '/myprofile' });
              } else if (res.response_code === 4) {
                this.isMobileError = true;
                this.mobileErrorMsg = res.response_message;
                this.$refs.mobile.focus();
              } else if (res.response_code === 2) {
                this.isError = true;
              }
            }.bind(_this)).catch(function (err) {
              console.error(err);
            });
          } catch (e) {
            console.error('method:saveProfile', e);
          }
        }
      });
    },
    getProfile: function getProfile() {
      try {
        if (this.$localStorage.get('loggedIn') && this.$localStorage.get('access_token') && this.$localStorage.get('access_token') !== null) {
          var data = {};
          promise_default.a.resolve(this.$GET('patient/getProfile', data)).then(function (res) {
            if (res.response_code === 0) {
              if (res.response) {
                underscore_default.a.each(res.response.Addresses, function (item) {
                  if (item.isDefault === 1) {
                    this.address = item.address;
                  }
                });
              }
              this.firstName = res.response.Patient.firstName;
              this.lastName = res.response.Patient.lastName;
              this.email = res.response.email;
              this.phone1 = res.response.Patient.phone1;
              this.phone2 = res.response.Patient.phone2;
              this.dob = res.response.Patient.dob ? res.response.Patient.dob : undefined;
              this.sex = res.response.Patient.sex;
              if (res.response.Patient.dob && res.response.Patient.dob !== null) {
                var dob = res.response.Patient.dob.split('T');
                var dobDate = dob[0].split('-');
                this.year = dobDate[0];
                this.month = dobDate[1];
                this.getNumberOfDays(dobDate[2]);
              }
            }
            this.$hidePageLoading();
          }.bind(this)).catch(function (err) {
            console.error(err);
          });
        }
      } catch (e) {
        console.error('method:getProfile', e);
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-58680f91","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/web/Secure/EditProfile.vue
var EditProfile_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"EditProfileDiv"}},[_c('HeaderVue'),_vm._v(" "),_c('div',{staticClass:"inner-page phleb-signup my-profile"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-8 offset-lg-2 col-sm-8 offset-sm-2"},[_c('div',{staticClass:"sign-up"},[_vm._m(0,false,false),_vm._v(" "),_c('div',{staticClass:"form-content line-textbox"},[_c('form',{attrs:{"data-vv-scope":"edit"}},[_c('div',{staticClass:"clearfix mt-4"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("First Name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.firstName),expression:"firstName"},{name:"validate",rawName:"v-validate",value:('required|alpha_spaces|min:3|max:50'),expression:"'required|alpha_spaces|min:3|max:50'"}],staticClass:"form-control",attrs:{"type":"text","name":"firstName","data-vv-as":"first name","maxlength":"50"},domProps:{"value":(_vm.firstName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.firstName=$event.target.value}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('edit.firstName')),expression:"errors.has('edit.firstName')"}],staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('edit.firstName')))])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Last Name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.lastName),expression:"lastName"},{name:"validate",rawName:"v-validate",value:('required|alpha_spaces|min:3|max:50'),expression:"'required|alpha_spaces|min:3|max:50'"}],staticClass:"form-control",attrs:{"name":"lastName","type":"text","data-vv-as":"last name","maxlength":"50"},domProps:{"value":(_vm.lastName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.lastName=$event.target.value}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('edit.lastName')),expression:"errors.has('edit.lastName')"}],staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('edit.lastName')))])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Gender")]),_vm._v(" "),_c('div',{staticClass:"form-check form-check-inline",staticStyle:{"margin-top":"15px","margin-bottom":"0px"}},[_c('label',{staticClass:"form-check-label"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.sex),expression:"sex"}],staticClass:"form-check-input",attrs:{"type":"radio","name":"gender","id":"inlineRadio1","value":"M"},domProps:{"checked":(_vm.sex === 'M')?true:false,"checked":_vm._q(_vm.sex,"M")},on:{"change":function($event){_vm.sex="M"}}}),_vm._v(" Male\n                                                  ")])]),_vm._v(" "),_c('div',{staticClass:"form-check form-check-inline",staticStyle:{"margin-top":"15px","margin-bottom":"0px"}},[_c('label',{staticClass:"form-check-label"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.sex),expression:"sex"}],staticClass:"form-check-input",attrs:{"type":"radio","name":"gender","id":"inlineRadio2","value":"F"},domProps:{"checked":(_vm.sex === 'F')?true:false,"checked":_vm._q(_vm.sex,"F")},on:{"change":function($event){_vm.sex="F"}}}),_vm._v(" Female\n                                                  ")])]),_vm._v(" "),_c('div',{staticClass:"form-check form-check-inline",staticStyle:{"margin-top":"15px","margin-bottom":"0px"}},[_c('label',{staticClass:"form-check-label"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.sex),expression:"sex"}],staticClass:"form-check-input",attrs:{"type":"radio","name":"gender","id":"inlineRadio3","value":"O"},domProps:{"checked":(_vm.sex === 'O')?true:false,"checked":_vm._q(_vm.sex,"O")},on:{"change":function($event){_vm.sex="O"}}}),_vm._v(" Other\n                                                  ")])])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Date of birth")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-4"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.year),expression:"year"}],staticClass:"form-control",attrs:{"name":"year","id":"year"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.year=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){_vm.getNumberOfDays()}]}},[_c('option',{staticClass:"dobOptionColor",attrs:{"value":"","disabled":"","selected":""}},[_vm._v("YYYY")]),_vm._v(" "),_vm._l((_vm.dobYears),function(dobYear,index){return _c('option',{key:index,domProps:{"value":dobYear}},[_vm._v(_vm._s(dobYear))])})],2)]),_vm._v(" "),_c('div',{staticClass:"col-4"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.month),expression:"month"}],staticClass:"form-control",attrs:{"name":"month","id":"month"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.month=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){_vm.getNumberOfDays()}]}},[_c('option',{staticClass:"dobOptionColor",attrs:{"value":"","disabled":"","selected":""}},[_vm._v("MMM")]),_vm._v(" "),_c('option',{attrs:{"value":"01"}},[_vm._v("Jan")]),_vm._v(" "),_c('option',{attrs:{"value":"02"}},[_vm._v("Feb")]),_vm._v(" "),_c('option',{attrs:{"value":"03"}},[_vm._v("Mar")]),_vm._v(" "),_c('option',{attrs:{"value":"04"}},[_vm._v("Apr")]),_vm._v(" "),_c('option',{attrs:{"value":"05"}},[_vm._v("May")]),_vm._v(" "),_c('option',{attrs:{"value":"06"}},[_vm._v("Jun")]),_vm._v(" "),_c('option',{attrs:{"value":"07"}},[_vm._v("Jul")]),_vm._v(" "),_c('option',{attrs:{"value":"08"}},[_vm._v("Aug")]),_vm._v(" "),_c('option',{attrs:{"value":"09"}},[_vm._v("Sep")]),_vm._v(" "),_c('option',{attrs:{"value":"10"}},[_vm._v("Oct")]),_vm._v(" "),_c('option',{attrs:{"value":"11"}},[_vm._v("Nov")]),_vm._v(" "),_c('option',{attrs:{"value":"12"}},[_vm._v("Dec")])])]),_vm._v(" "),_c('div',{staticClass:"col-4"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.ddate),expression:"ddate"}],staticClass:"form-control",attrs:{"name":"ddate","id":"ddate"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.ddate=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{staticClass:"dobOptionColor",attrs:{"value":"","disabled":"","selected":""}},[_vm._v("DD")]),_vm._v(" "),_vm._l((_vm.dobDate),function(dobDateVal,index){return _c('option',{key:index,domProps:{"value":dobDateVal ? (parseInt(dobDateVal) < 10 ? '0'+dobDateVal : dobDateVal) : ''}},[_vm._v(_vm._s(dobDateVal ? (parseInt(dobDateVal) < 10 ? '0'+dobDateVal : dobDateVal) : ''))])})],2)]),_vm._v(" "),_c('div',{staticClass:"col-sm-12"},[(_vm.isDobError)?_c('span',{staticClass:"text-danger"},[_vm._v("The date of birth field is required")]):_vm._e()])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Mobile")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.phone1),expression:"phone1"},{name:"validate",rawName:"v-validate",value:('required|numeric|min:10|max:10'),expression:"'required|numeric|min:10|max:10'"}],ref:"mobile",staticClass:"form-control",attrs:{"type":"text","name":"phone1","data-vv-as":"mobile no."},domProps:{"value":(_vm.phone1)},on:{"input":function($event){if($event.target.composing){ return; }_vm.phone1=$event.target.value}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('edit.phone1')),expression:"errors.has('edit.phone1')"}],staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('edit.phone1')))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.isMobileError),expression:"isMobileError"}],staticClass:"text-danger"},[_vm._v(_vm._s(_vm.mobileErrorMsg))])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Alternate Phone No.")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.phone2),expression:"phone2"},{name:"validate",rawName:"v-validate",value:('numeric|min:10|max:10'),expression:"'numeric|min:10|max:10'"}],staticClass:"form-control",attrs:{"type":"text","name":"phone2","data-vv-as":"alternate phone no."},domProps:{"value":(_vm.phone2)},on:{"input":function($event){if($event.target.composing){ return; }_vm.phone2=$event.target.value}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('edit.phone2')),expression:"errors.has('edit.phone2')"}],staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('edit.phone2')))])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Email")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email),expression:"email"},{name:"validate",rawName:"v-validate",value:('required|email|max:100'),expression:"'required|email|max:100'"}],staticClass:"form-control",staticStyle:{"background-color":"#fff","cursor":"not-allowed"},attrs:{"type":"email","name":"email","data-vv-as":"email address","disabled":true},domProps:{"value":(_vm.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.email=$event.target.value}}}),_vm._v(" "),_c('i',{staticClass:"fa",staticStyle:{"font-size":"18px","color":"#000","text-align":"right","float":"right","margin-top":"-25px","margin-right":"10px"}},[_vm._v("")]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('edit.email')),expression:"errors.has('edit.email')"}],staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('edit.email')))])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6 offset-lg-6 float-right text-center"},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.isError),expression:"isError"}],staticClass:"text-danger"},[_vm._v(_vm._s('Sorry something went wrong try again'))])])])]),_vm._v(" "),_c('div',{staticClass:"row mt-3"},[_c('div',{staticClass:"col-sm-6"},[_c('router-link',{staticClass:"btn btn-link full-width",attrs:{"to":"/myprofile"}},[_vm._v("Cancel")])],1),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('button',{staticClass:"btn btn-primary full-width",attrs:{"disabled":(_vm.errors.any())},on:{"click":function($event){$event.preventDefault();_vm.saveProfile()}}},[_vm._v("Update")])])])])])])])])])]),_vm._v(" "),_c('FooterVue')],1)}
var EditProfile_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"signup-title"},[_c('h4',{staticClass:"mt-0 mb-0"},[_vm._v("Edit Account")])])}]
var EditProfile_esExports = { render: EditProfile_render, staticRenderFns: EditProfile_staticRenderFns }
/* harmony default export */ var Secure_EditProfile = (EditProfile_esExports);
// CONCATENATED MODULE: ./src/components/web/Secure/EditProfile.vue
function EditProfile_injectStyle (ssrContext) {
  __webpack_require__("LNIC")
}
var EditProfile_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var EditProfile___vue_template_functional__ = false
/* styles */
var EditProfile___vue_styles__ = EditProfile_injectStyle
/* scopeId */
var EditProfile___vue_scopeId__ = "data-v-58680f91"
/* moduleIdentifier (server only) */
var EditProfile___vue_module_identifier__ = null
var EditProfile_Component = EditProfile_normalizeComponent(
  EditProfile,
  Secure_EditProfile,
  EditProfile___vue_template_functional__,
  EditProfile___vue_styles__,
  EditProfile___vue_scopeId__,
  EditProfile___vue_module_identifier__
)

/* harmony default export */ var web_Secure_EditProfile = (EditProfile_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/web/Secure/ChangePassword.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var ChangePassword = ({
  name: 'ChangePassword',
  components: {
    HeaderVue: Header["a" /* default */],
    FooterVue: Footer["a" /* default */]
  },
  beforeCreate: function beforeCreate() {
    if (!this.$localStorage.get('loggedIn') || this.$localStorage.get('loggedIn') === null) {
      this.$router.push({ path: '/' });
    }
  },
  data: function data() {
    return {
      oldPassword: '',
      newPassword: '',
      confirmPassword: '',
      error: false,
      errormsg: ''
    };
  },

  methods: {
    savePassword: function savePassword() {
      var _this = this;

      this.$validator.validateAll('password').then(function (result) {
        if (result) {
          try {
            _this.error = false;
            _this.errormsg = '';
            var data = {
              'oldPassword': _this.oldPassword,
              'newPassword': _this.newPassword
            };
            promise_default.a.resolve(_this.$POST('patient/changePassword', data)).then(function (res) {
              if (res.response_code === 0) {
                this.$router.push({ path: '/myprofile' });
              } else {
                this.error = true;
                this.errormsg = res.response_message;
              }
            }.bind(_this)).catch(function (err) {
              console.error(err);
            });
          } catch (e) {
            console.error('method:save_password', e);
          }
        }
      });
    }
  },
  mounted: function mounted() {
    this.$hidePageLoading();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2bf48509","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/web/Secure/ChangePassword.vue
var ChangePassword_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"EditProfileDiv"}},[_c('HeaderVue'),_vm._v(" "),_c('div',{staticClass:"inner-page phleb-signup my-profile"},[_c('div',{staticClass:"inner-page phleb-signup my-profile"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col align-self-center"},[_c('form',{attrs:{"data-vv-scope":"password"}},[_c('div',{staticClass:"sign-up change-password"},[_vm._m(0,false,false),_vm._v(" "),_c('div',{staticClass:"form-content line-textbox"},[(_vm.error)?_c('p',{staticClass:"no-mar-top red-color"},[_vm._v(_vm._s(_vm.errormsg))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Type Current Password")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.oldPassword),expression:"oldPassword"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"form-control",attrs:{"type":"password","name":"oldPassword","data-vv-as":"current password"},domProps:{"value":(_vm.oldPassword)},on:{"input":function($event){if($event.target.composing){ return; }_vm.oldPassword=$event.target.value}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('password.oldPassword')),expression:"errors.has('password.oldPassword')"}],staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('password.oldPassword')))])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Type New Password")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.newPassword),expression:"newPassword"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"form-control",attrs:{"type":"password","name":"newPassword","data-vv-as":"new password"},domProps:{"value":(_vm.newPassword)},on:{"input":function($event){if($event.target.composing){ return; }_vm.newPassword=$event.target.value}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('password.newPassword')),expression:"errors.has('password.newPassword')"}],staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('password.newPassword')))])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Retype New Password")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.confirmPassword),expression:"confirmPassword"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"form-control",attrs:{"type":"password","name":"confirmPassword","data-vv-as":"retype new password"},domProps:{"value":(_vm.confirmPassword)},on:{"input":function($event){if($event.target.composing){ return; }_vm.confirmPassword=$event.target.value}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('password.confirmPassword')),expression:"errors.has('password.confirmPassword')"}],staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('password.confirmPassword')))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.confirmPassword !== '' && _vm.newPassword !== _vm.confirmPassword),expression:"confirmPassword !== '' && newPassword !== confirmPassword"}],staticClass:"text-danger"},[_vm._v("The retype new password confirmation does not match")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-4"},[_c('router-link',{attrs:{"to":"/myprofile"}},[_c('button',{staticClass:"btn btn-link"},[_vm._v("Cancel")])])],1),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('button',{staticClass:"btn btn-primary full-width",attrs:{"disabled":(_vm.errors.any())},on:{"click":function($event){$event.preventDefault();_vm.savePassword()}}},[_vm._v("Change Password")])])])])])])])])])]),_vm._v(" "),_c('FooterVue')],1)}
var ChangePassword_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"signup-title"},[_c('h4',{staticClass:"mt-0 mb-0"},[_vm._v("Changes Password")])])}]
var ChangePassword_esExports = { render: ChangePassword_render, staticRenderFns: ChangePassword_staticRenderFns }
/* harmony default export */ var Secure_ChangePassword = (ChangePassword_esExports);
// CONCATENATED MODULE: ./src/components/web/Secure/ChangePassword.vue
function ChangePassword_injectStyle (ssrContext) {
  __webpack_require__("h04o")
}
var ChangePassword_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var ChangePassword___vue_template_functional__ = false
/* styles */
var ChangePassword___vue_styles__ = ChangePassword_injectStyle
/* scopeId */
var ChangePassword___vue_scopeId__ = "data-v-2bf48509"
/* moduleIdentifier (server only) */
var ChangePassword___vue_module_identifier__ = null
var ChangePassword_Component = ChangePassword_normalizeComponent(
  ChangePassword,
  Secure_ChangePassword,
  ChangePassword___vue_template_functional__,
  ChangePassword___vue_styles__,
  ChangePassword___vue_scopeId__,
  ChangePassword___vue_module_identifier__
)

/* harmony default export */ var web_Secure_ChangePassword = (ChangePassword_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/web/Book/Test.vue
//
//
//
//
//


/* harmony default export */ var Test = ({
  name: 'BookTest',
  components: {},
  beforeCreate: function beforeCreate() {},
  data: function data() {
    return {};
  },

  mounted: function mounted() {
    this.$router.push({ path: '/lab' });
  },
  created: function created() {},

  watch: {},
  methods: {}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-27037104","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/web/Book/Test.vue
var Test_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"TestDiv"}})}
var Test_staticRenderFns = []
var Test_esExports = { render: Test_render, staticRenderFns: Test_staticRenderFns }
/* harmony default export */ var Book_Test = (Test_esExports);
// CONCATENATED MODULE: ./src/components/web/Book/Test.vue
var Test_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var Test___vue_template_functional__ = false
/* styles */
var Test___vue_styles__ = null
/* scopeId */
var Test___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Test___vue_module_identifier__ = null
var Test_Component = Test_normalizeComponent(
  Test,
  Book_Test,
  Test___vue_template_functional__,
  Test___vue_styles__,
  Test___vue_scopeId__,
  Test___vue_module_identifier__
)

/* harmony default export */ var web_Book_Test = (Test_Component.exports);

// EXTERNAL MODULE: ./node_modules/fuse.js/dist/fuse.js
var fuse = __webpack_require__("BDm9");
var fuse_default = /*#__PURE__*/__webpack_require__.n(fuse);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/web/Book/Lab.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var Lab = ({
  name: 'ChooseLab',
  components: {
    HeaderVue: Header["a" /* default */],
    FooterVue: Footer["a" /* default */]
  },
  beforeCreate: function beforeCreate() {
    // if (!this.$localStorage.get('pincode') || !this.$localStorage.get('st') || this.$localStorage.get('st').length === 0) {
    //   this.$router.push({ path: '/test' })
    //   return false
    // }
  },
  data: function data() {
    return {
      labLimit: 10,
      labTests: {},
      labLists: [],
      selectedLab: [],
      isLabLoading: false,
      labDetails: '',
      selectedProfileAndTest: [],
      totalLabs: [],
      limitedLabs: [],
      _s3BucketUrl: '',
      clickedProfileName: '',
      clickedProfileDetails: [],
      clickedProfileTests: [],
      clickedProfileTestFirst: [],
      clickedProfileTestSecond: [],
      labSearchContent: 'Loading...',
      labContent: false,
      pincodeButton: false,
      ProfileAndTest: [],
      searchContent: {
        test: [],
        profile: []
      },
      masterTestAndProfile: {
        test: [],
        profile: []
      },
      isSearchLoading: false,
      searchtext: '',
      result_focus: '',
      locationList: [],
      locationMasterList: [],
      selectedCity: this.$localStorage.get('sc'),
      locality: '',
      pincode: '',
      pincodeError: false,
      onBlurKey: false,
      query: undefined,
      sortBy: 3,
      lowestCost: undefined,
      currentLocation: {},
      locationAllowed: false,
      locationChanged: false,
      popularTests: {},
      sideBannerAds: []
    };
  },

  mounted: function mounted() {
    var _this = this;

    // this.geolocation()
    this.getLocation();
    this.$root.$on('removeProfileAndTest', function (selectedProfileAndTest) {
      _this.selectedProfileAndTest = selectedProfileAndTest;
      _this.getLab();
    });
    $('body').click(function (e) {
      if (e.target.id === 'test-option' || $(e.target).parents('#test-option').length) {} else {
        this.searchtext = '';
      }
      if (e.target.id === 'localitySearch' || $(e.target).parents('#localitySearch').length) {} else {
        this.onBlurKey = false;
        this.query = this.locality ? this.locality.locationName : '';
      }
    }.bind(this));
  },
  watch: {
    locationAllowed: function locationAllowed() {
      // this.geolocation()
    }
  },
  created: function created() {
    setTimeout(function () {
      this.geolocation();
    }.bind(this), 2000);
    if (this.$localStorage.get('pincode')) {
      this.pincode = this.$localStorage.get('pincode');
    }
    if (this.$localStorage.get('location')) {
      this.locality = this.$localStorage.get('location');
      this.query = this.locality.locationName;
    } else {
      this.pincodeButton = true;
      // setTimeout(function () {
      //   this.$refs.pincode.focus()
      // }.bind(this), 300)
    }
    if (this.$localStorage.get('st')) {
      this.selectedProfileAndTest = this.$localStorage.get('st');
    }
    this.selectedLab = [];
    if (this.$localStorage.get('sl')) {
      this.selectedLab = this.$localStorage.get('sl');
    }

    this.selectedProfileAndTest = [];
    if (this.$localStorage.get('st')) {
      this.selectedProfileAndTest = this.$localStorage.get('st');
    }
    this.getLab();
    this.getPopularTest();
    this.getAllProfileAndTests();
    // this.searchLocation()
  },

  methods: {
    getIncudedTestAndProfile: function getIncudedTestAndProfile(tl) {
      var testCountVal = 0;

      if (tl.profileTestsCount && tl.profileTestsCount > 0) {
        testCountVal = testCountVal + tl.profileTestsCount;
      }
      if (tl.package == 1) {
        if (tl.includedProfiles && tl.includedProfiles.count > 0) {
          tl.includedProfiles.data.forEach(function (testObj) {
            testCountVal = testCountVal + testObj.ProfileTests.length;
          });
        }
      }
      return testCountVal ? testCountVal + ' Tests' : '';
    },
    getIncudedTestAndProfilePop: function getIncudedTestAndProfilePop(tl) {
      var testCountVal = 0;
      if (tl.testCount && tl.testCount > 0) {
        testCountVal = testCountVal + tl.testCount;
      }
      if (tl.package == 1) {
        if (tl.includedProfiles && tl.includedProfiles.count > 0) {
          tl.includedProfiles.data.forEach(function (testObj) {
            testCountVal = testCountVal + testObj.ProfileTests.length;
          });
        }
      }
      return testCountVal ? testCountVal + ' Tests' : '';
    },
    getIncudedTestAndProfilePopup: function getIncudedTestAndProfilePopup(tl) {
      var profileCountStr = '';
      if (tl.package == 1) {
        if (tl.includedProfiles && tl.includedProfiles.count > 0) {
          profileCountStr = tl.includedProfiles.count + ' Profiles';
        }
      }
      var testCountStr = '';
      if (tl.profileTestsCount && tl.profileTestsCount > 0) {
        testCountStr = tl.profileTestsCount + ' Tests';
      }
      return profileCountStr + (profileCountStr.length > 0 && testCountStr.length > 0 ? ' & ' : '') + testCountStr;
    },
    getIncudedTestAndProfilePopular: function getIncudedTestAndProfilePopular(tl) {
      var testCountVal = 0;
      if (tl.ProfileTests && tl.ProfileTests.length > 0) {
        testCountVal = testCountVal + tl.ProfileTests.length;
      }
      if (tl.package == 1) {
        if (tl.includedProfiles && tl.includedProfiles.count > 0) {
          tl.includedProfiles.data.forEach(function (testObj) {
            testCountVal = testCountVal + testObj.ProfileTests.length;
          });
        }
      }
      return testCountVal ? testCountVal + ' Tests' : '';
    },
    geolocation: function geolocation() {
      var options = {
        maximumAge: 60000,
        timeout: 5000,
        enableHighAccuracy: true
      };
      navigator.geolocation.getCurrentPosition(function (position) {
        console.log('im tracking you!');
        this.currentLocation = {
          lat: position.coords.latitude,
          lng: position.coords.longitude
        };
        this.changeCityUsingLocation();
        return false;
        //   var geocoder = new google.maps.Geocoder()

        //   var latlng = new google.maps.LatLng(position.coords.latitude, position.coords.longitude)

        //   geocoder.geocode({'latLng': latlng}, function(results, status) {
        //     if (status == google.maps.GeocoderStatus.OK) {
        //       if (results[1]) {
        //         let city = []
        //         for (var i=0; i<results[0].address_components.length; i++) {
        //           for (var b=0;b<results[0].address_components[i].types.length;b++) {
        //             if (results[0].address_components[i].types[b] == "administrative_area_level_2") {
        //                 let cityVal = results[0].address_components[i].short_name;
        //                 city.push(cityVal)
        //             }
        //             if (results[0].address_components[i].types[b] == "locality") {
        //                 let cityVal= results[0].address_components[i].short_name;
        //                 city.push(cityVal)
        //             }
        //           }
        //         }
        //         console.log(city)
        //         this.changeCityUsingLocation(city)
        //       } else {
        //         console.log("Geocoder failed due to: No results found")
        //       }
        //     } else {
        //       console.log("Geocoder failed due to: " + status)
        //     }
        //   }.bind(this))
        // this.locationAllowed = true
      }.bind(this), function (error) {
        if (error.code === error.PERMISSION_DENIED) {
          console.log('you denied me :-(');
          this.locationAllowed = false;
          if (!this.$localStorage.get('sc') && this.selectedCity) {
            this.$localStorage.set('sc', this.selectedCity);
          }
        }
      }.bind(this)), options;
    },
    changeCityUsingLocation: function changeCityUsingLocation() {
      var data = {
        coordinates: this.currentLocation
      };
      promise_default.a.resolve(this.$POST('patient/getCityUsingLocation', data)).then(function (res) {
        console.log(res);
        if (res.response_code === 0) {
          if (!this.$localStorage.get('sc')) {
            this.locationMasterList.forEach(function (city) {
              if (res.response.cityId === city.cityId) {
                if (this.selectedCity.cityId !== city.cityId) {
                  this.selectedCity = city;
                  this.$localStorage.set('sc', this.selectedCity);
                  this.selectBannerAds();
                  this.locationList = city.ActiveLocation;
                  this.selectedCity.ActiveLocation.forEach(function (loc) {
                    if (res.response.locationId === loc.locationId) {
                      this.locality = loc;
                      this.pincode = loc.locationZipCode;
                      this.query = loc.locationName;
                      console.log(this.query);
                      this.$localStorage.set('location', loc, 0);
                      this.$localStorage.set('pincode', this.pincode, 0);
                    }
                  }.bind(this));
                  this.onCityChange();
                } else {
                  if (!this.$localStorage.get('location')) {
                    this.selectedCity.ActiveLocation.forEach(function (loc) {
                      if (res.response.locationId === loc.locationId) {
                        this.locality = loc;
                        this.pincode = loc.locationZipCode;
                        this.query = loc.locationName;
                        console.log(this.query);
                        this.$localStorage.set('location', loc, 0);
                        this.$localStorage.set('pincode', this.pincode, 0);
                      }
                    }.bind(this));
                  }
                }
                this.getLab();
              }
            }.bind(this));
          } else if (!this.$localStorage.get('location')) {
            this.selectedCity.ActiveLocation.forEach(function (loc) {
              if (res.response.locationId === loc.locationId) {
                this.locality = loc;
                this.pincode = loc.locationZipCode;
                this.query = loc.locationName;
                console.log(this.query);
                this.$localStorage.set('location', loc, 0);
                this.$localStorage.set('pincode', this.pincode, 0);
              }
            }.bind(this));
            this.getLab();
          }
          if (!this.$localStorage.get('sc') && this.selectedCity) {
            this.$localStorage.set('sc', this.selectedCity);
          }
        } else {
          if (!this.$localStorage.get('sc') && this.selectedCity) {
            this.$localStorage.set('sc', this.selectedCity);
          }
        }
      }.bind(this)).catch(function (err) {
        console.error(err);
      });
    },
    getLocation: function getLocation() {
      var data = {
        currentLocation: this.currentLocation,
        locationAllowed: this.locationAllowed
      };
      promise_default.a.resolve(this.$POST('patient/getCityAndLocation', data)).then(function (res) {
        if (res.response_code === 0) {
          this.locationMasterList = res.response;
          if (this.selectedCity) {
            this.locationMasterList.forEach(function (city) {
              if (this.selectedCity.cityId === city.cityId) {
                this.selectedCity = city;
                // this.$localStorage.set('sc', this.selectedCity)
                this.selectBannerAds();
                this.locationList = city.ActiveLocation;
              }
            }.bind(this));
          } else {
            if (this.locationMasterList.length > 0) {
              this.selectedCity = this.locationMasterList[0];
              // this.$localStorage.set('sc', this.selectedCity)
              this.selectBannerAds();
              this.locationList = this.locationMasterList[0].ActiveLocation;
            } else {
              this.selectedCity = undefined;
              this.locationList = [];
            }
          }
        }
      }.bind(this)).catch(function (err) {
        console.error(err);
      });
    },
    getPopularTest: function getPopularTest() {
      var data = {
        selectedProfileAndTest: this.selectedProfileAndTest
      };
      promise_default.a.resolve(this.$POST('patient/getPopularTestList', data)).then(function (res) {
        if (res.response_code === 0) {
          this.popularTests = res.response;
          this.$hidePageLoading();
        }
      }.bind(this)).catch(function (err) {
        console.error(err);
      });
    },
    labSortOrder: function labSortOrder() {
      if (this.sortBy === '1') {
        this.labLists.sort(function (a, b) {
          a = a.ourCost;
          b = b.ourCost;
          return a < b ? -1 : 1;
        });
      } else if (this.sortBy === '2') {
        this.labLists.sort(function (a, b) {
          a = a.ourCost;
          b = b.ourCost;
          return a > b ? -1 : 1;
        });
      } else if (this.sortBy === '3') {
        this.labLists.sort(function (a, b) {
          a = a.rating;
          b = b.rating;
          return a > b ? -1 : 1;
        });
      }
      // this.getLab()
    },
    adsRedirect: function adsRedirect(url) {
      if (this.pincode && this.pincode.length === 6) {
        url = url + '/' + this.locality.locationName;
      }
      window.open(url, '_blank');
    },
    loadMore: function loadMore() {
      var increamented = this.labLimit + 10;
      this.labLimit = increamented > this.labLists.length ? this.labLists.length : increamented;
    },
    goSearch: function goSearch() {
      this.$router.push({ path: '/lab' });
    },
    goChooseDate: function goChooseDate(lab) {
      if (!this.locality || !this.selectedCity) {
        var confirmFn = function () {
          setTimeout(function () {
            this.$refs.pincode.focus();
          }.bind(this), 300);
        }.bind(this);
        this.$Simplert.open({
          title: 'Information',
          message: 'Please choose your nearest locality',
          type: 'warning',
          useConfirmBtn: false,
          onClose: confirmFn,
          customCloseBtnText: 'Ok',
          disableOverlayClick: true,
          showXclose: true
        });

        return false;
      }
      this.$localStorage.remove('location');
      this.$localStorage.remove('pincode');
      this.$localStorage.remove('sc');
      this.$localStorage.set('location', this.locality);
      this.$localStorage.set('pincode', this.locality.locationZipCode);
      this.$localStorage.set('sc', this.selectedCity);

      this.$localStorage.remove('ct');
      this.$localStorage.remove('cou');
      if (this.$localStorage.get('sl')) {
        if (this.$localStorage.get('sl').labId !== lab.labId) {
          this.$localStorage.remove('ct');
        }
      }
      this.selectedLab = lab;
      this.$localStorage.set('sl', lab, 30 * 60 * 1000);
      this.$localStorage.set('st', this.selectedProfileAndTest);
      vue_esm["default"].analytics.fbq.event('ViewContent', {
        content_ids: lab.labId,
        content_name: lab.labName,
        contents: {
          id: lab.labId,
          name: lab.labName
        },
        content_type: 'LAB'
      });
      this.$router.push({ path: '/appointment' });
    },
    openProfileTestList: function openProfileTestList(profileName, testinfo, tl) {
      this.clickedProfileDetails = {};
      this.clickedProfileTests = [];
      this.clickedProfileName = profileName;
      this.clickedProfileDetails = tl;
      this.clickedProfileTestFirst = [];
      this.clickedProfileTestSecond = [];
      if (tl.testNames) {
        this.clickedProfileTests = tl.testNames.split(',');
        var profileCount = this.clickedProfileDetails.includedProfiles ? this.clickedProfileDetails.includedProfiles.count : 0;
        var testCount = this.clickedProfileTests.length;
        var totalCount = profileCount + testCount;
        if (totalCount > 8) {
          if (totalCount > 5) {
            this.clickedProfileTestFirst = this.clickedProfileTests.slice(0, parseInt(this.clickedProfileTests.length / 2) + this.clickedProfileTests.length % 2 - profileCount);
            this.clickedProfileTestSecond = this.clickedProfileTests.slice(parseInt(this.clickedProfileTests.length / 2) + this.clickedProfileTests.length % 2 - profileCount, this.clickedProfileTests.length);
          } else {
            this.clickedProfileTestFirst = this.clickedProfileTests;
          }
        } else {
          this.clickedProfileTestFirst = this.clickedProfileTests;
        }
      }
      $('#lab_test-popup').modal('show');
      // this.clickedProfileTests = (tl.testNames)
    },
    openPopularProfileTestList: function openPopularProfileTestList(profile) {
      profile['testCount'] = profile.ProfileTests ? profile.ProfileTests.length : 0;
      profile['aliasName'] = profile.name;
      this.clickedProfileDetails = [];
      this.clickedProfileTests = [];
      this.clickedProfileName = profile.name;
      this.clickedProfileDetails = profile;
      this.clickedProfileTestFirst = [];
      this.clickedProfileTestSecond = [];
      if (profile.ProfileTests) {
        this.clickedProfileTests = profile.ProfileTests;
        if (this.clickedProfileTests.length > 8) {
          if (this.clickedProfileTests.length > 5) {
            this.clickedProfileTestFirst = this.clickedProfileTests.slice(0, parseInt(this.clickedProfileTests.length / 2) + this.clickedProfileTests.length % 2);
            this.clickedProfileTestSecond = this.clickedProfileTests.slice(parseInt(this.clickedProfileTests.length / 2) + this.clickedProfileTests.length % 2, this.clickedProfileTests.length);
          } else {
            this.clickedProfileTestFirst = this.clickedProfileTests;
          }
        } else {
          this.clickedProfileTestFirst = this.clickedProfileTests;
        }
      }
      $('#test-popup').modal('show');
    },
    getLab: function getLab() {
      this.labContent = false;
      this.ProfileAndTest = [];
      this.labLists = [];
      this.isLabLoading = true;
      var data = {
        'zipCode': this.$localStorage.get('pincode'),
        'locality': this.$localStorage.get('location') ? this.$localStorage.get('location') : null,
        'locationCoordinate': this.$localStorage.get('location') ? this.$localStorage.get('location').locationCoordinate : null,
        'sortBy': this.sortBy,
        'city': this.selectedCity
      };

      var test = [];
      if (this.selectedProfileAndTest.length > 0) {
        this.selectedProfileAndTest.forEach(function (element) {
          if (element.testId > 0) {
            test.push(element.testId);
          }
        }, this);
      }
      data.test = test;

      var profile = [];
      if (this.selectedProfileAndTest.length > 0) {
        this.selectedProfileAndTest.forEach(function (element) {
          if (element.panelId > 0) {
            profile.push(element.panelId);
          }
        }, this);
      }
      data.profile = profile;
      promise_default.a.resolve(this.$POST('patient/getLab', data)).then(function (res) {
        if (res.response_code === 0) {
          this.isLabLoading = false;
          this.s3BucketUrl = this.$_s3BucketUrl;
          this.labContent = true;
          if (res.response.labList.length > 0) {
            this.labLists = res.response.labList;
            this.lowestCost = res.response.lowestCost;
          } else {
            this.selectedLab = [];
            this.labSearchContent = 'No labs found in your searched locations.';
            this.$localStorage.remove('sl');
          }
        } else {
          this.isLabLoading = false;
          this.selectedLab = [];
          this.labSearchContent = 'No labs found in your searched locations.';
          this.$localStorage.remove('sl');
        }
        this.$hidePageLoading();
      }.bind(this)).catch(function (err) {
        console.error(err);
      });
    },
    getLabDetails: function getLabDetails(lab) {
      try {
        this.labDetails = '';
        if (this.$localStorage.get('access_token') && this.$localStorage.get('access_token') !== null) {
          var data = {
            'labId': lab.labId
          };
          promise_default.a.resolve(this.$POST('patient/getLabDetails', data)).then(function (res) {
            if (res.response_code === 0) {
              this.labDetails = res.response;
            }
          }.bind(this)).catch(function (err) {
            console.error(err);
          });
        }
      } catch (e) {
        console.error(e);
      }
    },
    clearProfileAndTests: function clearProfileAndTests() {
      this.searchContent = {
        test: [],
        profile: []
      };
    },
    getAllProfileAndTests: function getAllProfileAndTests() {
      var data = {
        'keyword': this.searchtext,
        selectedProfileAndTest: this.selectedProfileAndTest
      };
      promise_default.a.resolve(this.$POST('patient/getProfileAndTestList', data)).then(function (res) {
        if (res.response_code === 0) {
          if (!res.response.test || !res.response.profile) {
            this.isSearchLoading = 'No Result';
          } else {
            this.masterTestAndProfile = {
              test: res.response.test,
              profile: res.response.profile
            };
          }
        }
      }.bind(this)).catch(function (err) {
        console.error(err);
      });
    },
    getProfileAndTests_old: function getProfileAndTests_old() {
      // this.searchContent = ''
      this.isSearchLoading = 'Loading...';
      var data = {
        'keyword': this.searchtext,
        selectedProfileAndTest: this.selectedProfileAndTest
      };
      promise_default.a.resolve(this.$POST('patient/getProfileAndTestList', data)).then(function (res) {
        if (res.response_code === 0) {
          if (!res.response.test || !res.response.profile) {
            this.isSearchLoading = 'No Result';
          } else {
            this.isSearchLoading = false;
            var test = res.response.test.sort(this.testSort);
            var profile = res.response.profile.sort(this.testSort);
            // test = test.sort(this.profileSort)
            // profile = profile.sort(this.profileSort)
            this.searchContent = {
              test: test,
              profile: profile
            };
          }
        }
      }.bind(this)).catch(function (err) {
        console.error(err);
      });
    },
    getProfileAndTests: function getProfileAndTests() {
      this.isSearchLoading = 'Loading...';

      var profileOptions = {
        shouldSort: true,
        threshold: 0.6,
        location: 0,
        // distance: 20,
        maxPatternLength: 32,
        minMatchCharLength: 1,
        keys: ["name", "Keywords", "ProfileTests"]
      };

      var testFuse = new fuse_default.a(this.masterTestAndProfile.test, profileOptions); // "list" is the item array

      var profileFuse = new fuse_default.a(this.masterTestAndProfile.profile, profileOptions); // "list" is the item array
      this.searchContent = {
        test: testFuse.search(this.searchtext),
        profile: profileFuse.search(this.searchtext)
      };
      this.isSearchLoading = false;
    },
    testSort: function testSort(a, b) {
      a = a.name.toUpperCase();
      b = b.name.toUpperCase();
      if (a.indexOf(this.searchtext.toUpperCase()) === -1) {
        return 1;
      } else if (b.indexOf(this.searchtext.toUpperCase()) === -1) {
        return -1;
      }
      return a.indexOf(this.searchtext.toUpperCase()) < b.indexOf(this.searchtext.toUpperCase()) ? -1 : 1;
    },
    addTestFromDropdown: function addTestFromDropdown(event, test) {
      if (test.isSelected === 1) {
        return false;
      }
      if (test.testId === 0) {
        this.addTestAndProfile(test);
      } else {
        var filterProfile = [];
        underscore_default.a.each(this.selectedProfileAndTest, function (ele, key) {
          if (ele.testId === 0) {
            filterProfile.push(ele);
          }
        });
        if (filterProfile.length > 0) {
          var LabProfileTestsCount = 0;
          var splitArrayCount = 0;
          var isExistsCount = 0;
          var ExistsArray = [];
          underscore_default.a.each(filterProfile, function (value, key) {
            if (value.LabProfileTests && value.LabProfileTests !== '') {
              var splitArray = value.LabProfileTests.split(',').map(function (item) {
                return item.trim().toUpperCase();
              });
              if (splitArray.indexOf(test.name.toUpperCase()) === '-1') {
                splitArrayCount++;
              } else {
                isExistsCount++;
                ExistsArray.push(value.name);
              }
            } else {
              LabProfileTestsCount++;
            }
          });
          if (LabProfileTestsCount === filterProfile.length) {
            this.addTestAndProfile(test);
          } else if (splitArrayCount === filterProfile.length) {
            this.addTestAndProfile(test);
          } else if (isExistsCount > 0) {
            var confirmFn = function () {
              this.addTestAndProfile(test, true);
            }.bind(this);

            this.$Simplert.open({
              title: 'Confirm',
              message: 'The test that you have selected is already included in one of the profile added to the cart\u201D Just have ok button, no need for cancel.',
              type: 'info',
              useConfirmBtn: true,
              onConfirm: confirmFn,
              customConfirmBtnText: 'Ok',
              customCloseBtnText: 'Cancel',
              disableOverlayClick: true
            });
          } else {
            this.addTestAndProfile(test);
          }
        } else {
          this.addTestAndProfile(test);
        }
      }
    },
    addTestAndProfile: function addTestAndProfile(test, isPopup) {
      this.$localStorage.remove('sl');
      this.$localStorage.remove('ct');
      this.$localStorage.remove('cou');
      if (underscore_default.a.pluck(this.selectedProfileAndTest, 'name').indexOf(test.name) === -1) {
        this.selectedProfileAndTest.push(test);
        if (isPopup) {
          this.$apply(function () {
            this.selectedProfileAndTest = underscore_default.a.uniq(this.selectedProfileAndTest);
          });
        } else {
          this.selectedProfileAndTest = underscore_default.a.uniq(this.selectedProfileAndTest);
        }
        var testFB = {
          id: test.testId === 0 ? test.panelId : test.testId,
          isTest: test.testId === 0 ? 0 : 1,
          name: test.name
        };
        if (test.testId === 0) {
          vue_esm["default"].analytics.fbq.event('ViewContent', {
            content_ids: test.testId === 0 ? test.panelId : test.testId,
            content_name: test.name,
            contents: testFB,
            content_type: 'PROFILE'
          });
        } else {
          vue_esm["default"].analytics.fbq.event('ViewContent', {
            content_ids: test.testId === 0 ? test.panelId : test.testId,
            content_name: test.name,
            contents: testFB,
            content_type: 'TEST'
          });
        }
        this.$localStorage.set('st', this.selectedProfileAndTest);
        this.$root.$emit('selectedProfileAndTest', this.selectedProfileAndTest);
      }
      this.searchtext = '';
      this.getLab();
      this.getPopularTest();
      this.getAllProfileAndTests();
    },
    removeSelectedItems: function removeSelectedItems(items) {
      var index = this.selectedProfileAndTest.indexOf(items);
      this.selectedProfileAndTest.splice(index, 1);
      this.$localStorage.set('st', this.selectedProfileAndTest, 0);
      this.$localStorage.remove('cou');
      if (this.selectedProfileAndTest.length === 0) {
        this.$localStorage.remove('sl');
        this.$localStorage.remove('ct');
      }
      var lab = this.$localStorage.get('sl');
      var labTests = [];
      this.$localStorage.remove('sl');
      if (lab) {
        lab.labTestList.forEach(function (labTest) {
          if (!(items.testId === labTest.testId && labTest.testId !== 0 || items.panelId === labTest.panelId && labTest.panelId !== 0)) {
            labTests.push(labTest);
          }
        });
        lab.labTestList = labTests;
      }
      this.$localStorage.set('sl', lab, 30 * 60 * 1000);

      this.$root.$emit('selectedProfileAndTest', this.selectedProfileAndTest);
      this.getLab();
      this.getPopularTest();
      this.getAllProfileAndTests();
    },
    searchLocation: function searchLocation() {
      // this.onBlurKey = true
      this.locality = undefined;
      this.pincode = undefined;
      var pincode = this.$localStorage.get('pincode');
      this.$localStorage.remove('location');
      this.$localStorage.remove('pincode');
      if (pincode) {
        this.getLab();
      }

      // if (this.query.length < 3) {
      //   this.onBlurKey = false
      //   this.locationList = []
      //   return false
      // }
      try {
        if (this.$localStorage.get('access_token') && this.$localStorage.get('access_token') !== null) {
          var data = {
            'keyword': ''
          };
          promise_default.a.resolve(this.$POST('patient/searchLocation', data)).then(function (res) {
            if (res.response_code === 0) {
              this.locationList = res.response;
              this.locationMasterList = res.response;
            }
          }.bind(this)).catch(function (err) {
            console.error(err);
          });
        }
      } catch (e) {
        console.error(e);
      }
    },
    onCityChange: function onCityChange() {
      var localityCheck = undefined;
      this.$localStorage.remove('sl');
      this.$localStorage.remove('ct');
      this.$localStorage.remove('cou');
      this.$localStorage.set('sc', this.selectedCity);
      this.selectBannerAds();
      this.selectedCity.ActiveLocation.forEach(function (location) {
        if (this.locality && this.locality.locationId === location.locationId) {
          localityCheck = location;
        }
      }.bind(this));
      if (!localityCheck) {
        this.locality = undefined;
        this.pincode = '';
        this.query = '';
        this.$localStorage.remove('location');
        this.$localStorage.remove('pincode');
      }
      this.getLab();
    },
    locationFilterAlphabet: function locationFilterAlphabet(a, b) {
      a = a.locationName;
      b = b.locationName;
      if (a < b) return -1;
      if (a > b) return 1;
      return 0;
    },
    locationFilter: function locationFilter(a, b) {
      a = a.locationName.toUpperCase();
      b = b.locationName.toUpperCase();
      if (a.indexOf(this.query.toUpperCase()) === -1) {
        return 1;
      } else if (b.indexOf(this.query.toUpperCase()) === -1) {
        return -1;
      }
      return a.indexOf(this.query.toUpperCase()) < b.indexOf(this.query.toUpperCase()) ? -1 : 1;
    },
    showHideLocation: function showHideLocation() {
      this.onBlurKey = true;
      if (this.query.length === 0) {
        this.locationList = this.selectedCity.ActiveLocation.sort(this.locationFilterAlphabet);
      } else {
        var locationFilter = this.selectedCity.ActiveLocation.filter(function (locationVal) {
          var locality = locationVal.locationName;
          if (!locality) return false;
          locality = locality.toLowerCase();
          return locality.includes(this.query.toLowerCase());
        }.bind(this));
        this.locationList = locationFilter.sort(this.locationFilter);
      }
    },
    closeBlock: function closeBlock() {
      this.pincodeButton = false;
      // setTimeout(function () {
      //   this.onBlurKey = false
      // }.bind(this), 300)
    },
    closeBlockTest: function closeBlockTest() {
      setTimeout(function () {
        this.searchtext = '';
      }.bind(this), 300);
    },
    selectLocation: function selectLocation(obj) {
      this.locality = undefined;
      this.locality = obj;
      this.pincode = obj.locationZipCode;
      this.query = obj.locationName;
      // this.locationList = []
      this.onBlurKey = false;
      vue_esm["default"].analytics.fbq.event('ViewContent', {
        content_ids: this.locality.locationId,
        content_name: this.locality.locationZipCode,
        contents: {
          id: this.locality.locationId,
          location: this.locality.locationName,
          zipcode: this.locality.locationZipCode
        },
        content_type: 'PINCODE_ENTERED'
      });
      this.$localStorage.remove('sl');
      this.$localStorage.remove('ct');
      this.$localStorage.remove('cou');
      this.$localStorage.remove('location');
      this.$localStorage.set('location', this.locality, 0);
      this.$localStorage.remove('pincode');
      this.$localStorage.set('pincode', this.locality.locationZipCode, 0);
      this.getLab();
    },
    selectBannerAds: function selectBannerAds() {
      if (this.selectedCity.cityId === 2) {
        var city = this.selectedCity.cityName;
        city = city.toLowerCase();
        this.sideBannerAds = [{
          url: '/labs/' + city + '/comprehensive_health_checkup',
          src: 'static/images/banner/comprehensive.jpg'
        }, {
          url: '/labs/' + city + '/General_Health_Checkup',
          src: 'static/images/banner/general.jpg'
        }, {
          url: '/labs/' + city + '/Hypertension_checkup',
          src: 'static/images/banner/hyper.jpg'
        }, {
          url: '/labs/' + city + '/thyroid_function_test_tft',
          src: 'static/images/banner/loosing.jpg'
        }, {
          url: '/labs/' + city + '/thyroid_function_test_advance',
          src: 'static/images/banner/eating.jpg'
        }];
      } else if (this.selectedCity.cityId === 33) {
        var _city = this.selectedCity.cityName;
        _city = _city.toLowerCase();
        this.sideBannerAds = [{
          url: '/labs/' + _city + '/General_Health_Checkup',
          src: 'static/images/banner/general.jpg'
        }, {
          url: '/labs/' + _city + '/comprehensive_health_checkup',
          src: 'static/images/banner/comprehensive.jpg'
        }, {
          url: '/labs/' + _city + '/Hypertension_checkup',
          src: 'static/images/banner/hyper.jpg'
        }, {
          url: '/labs/' + _city + '/thyroid_function_test_tft',
          src: 'static/images/banner/loosing.jpg'
        }, {
          url: '/labs/' + _city + '/thyroid_function_test_advance',
          src: 'static/images/banner/eating.jpg'
        }];
      } else {
        this.sideBannerAds = [];
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-57273c5e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/web/Book/Lab.vue
var Lab_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"LabDiv"}},[_c('HeaderVue'),_vm._v(" "),_c('div',{staticClass:"search-section"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12 col-lg-5"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Select City & Locality")]),_vm._v(" "),_c('div',{staticClass:"input-group mb-2 w-40 float-left"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedCity),expression:"selectedCity"}],staticClass:"form-control remove-right-radius",on:{"click":function($event){_vm.onBlurKey=false;},"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedCity=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){_vm.onCityChange()}]}},_vm._l((_vm.locationMasterList),function(city,index){return _c('option',{key:index,domProps:{"value":city}},[_vm._v(_vm._s(city.cityName))])}))]),_vm._v(" "),_c('div',{staticClass:"input-group mb-2 w-60 float-left",attrs:{"id":"localitySearch"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.query),expression:"query"}],ref:"pincode",staticClass:"form-control remove-left-radius",attrs:{"type":"text","placeholder":"Choose Locality","aria-label":"","name":"x","list":"mycarousel","autocomplete":"off","minlength":"3"},domProps:{"value":(_vm.query)},on:{"blur":function($event){_vm.closeBlock()},"keyup":[function($event){_vm.showHideLocation()},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }_vm.showHideLocation()}],"focus":function($event){_vm.$refs.pincode.select();_vm.searchtext=''; _vm.query=''; _vm.onBlurKey=true; _vm.showHideLocation();},"input":function($event){if($event.target.composing){ return; }_vm.query=$event.target.value}}}),_vm._v(" "),(_vm.onBlurKey)?_c('div',{staticClass:"test-option full-width mt-4 scrollbar locality",staticStyle:{"display":"block"}},[_c('div',{staticClass:"popular-test focus-search p-0"},[_c('ul',{staticClass:"p-0 m-0"},[_vm._l((_vm.locationList),function(item,index){return _c('li',{key:index,staticClass:"p-2",staticStyle:{"border-bottom":"1px"},on:{"click":function($event){_vm.selectLocation(item)}}},[_c('span',[_vm._v(_vm._s(item.locationName)+"\n                                                ")])])}),_vm._v(" "),(_vm.locationList.length === 0)?_c('li',{staticClass:"text-center"},[_vm._v(" --- No Locations ---")]):_vm._e()],2)])]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-12 col-lg-7"},[_c('div',{staticClass:"form-group mb-0"},[_c('label',{staticClass:"ft-s-15"},[_vm._v("Search or Add lab tests")]),_vm._v(" "),_c('div',{staticClass:"input-group mb-2",class:{ 'focused-search': (_vm.searchtext != '') },attrs:{"id":"test-option"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchtext),expression:"searchtext"}],staticClass:"form-control rounded search-terms pl-35",attrs:{"type":"text","placeholder":"Search or Add","aria-label":"","name":"x","list":"mycarousel","autocomplete":"off","minlength":"3"},domProps:{"value":(_vm.searchtext)},on:{"keyup":[function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }_vm.getProfileAndTests()},function($event){_vm.getProfileAndTests()}],"change":function($event){_vm.getProfileAndTests()},"input":function($event){if($event.target.composing){ return; }_vm.searchtext=$event.target.value}}}),_vm._v(" "),_c('img',{staticClass:"search-img",attrs:{"src":"static/images/search.svg","alt":""}}),_vm._v(" "),_c('div',{staticClass:"test-option"},[_c('div',{staticClass:"popular-test focus-search"},[_c('h5',[_vm._v("Test")]),_vm._v(" "),_c('ul',[_vm._l((_vm.searchContent.test),function(test,index){return _c('li',{key:index,on:{"click":function($event){_vm.addTestFromDropdown($event, test)}}},[_c('p',{staticClass:"m-0 capitalize"},[_c('i',{staticClass:"fa fa-plus mr-2"}),_vm._v(" \n                                            "+_vm._s(test.name)+"\n                                            "),(test.isSelected === 1)?_c('i',{staticClass:"fa fa-circle green-color",staticStyle:{"font-size":"11px","margin-left":"3px"}}):_vm._e()]),_vm._v(" "),(test.Keywords)?_c('p',{staticClass:"test-key m-0 pl-4"},[_c('strong',{staticClass:"black-color"},[_vm._v("Also known as:")]),_vm._v(" "),_c('span',{staticClass:"capitalize"},[_vm._v(_vm._s(test.Keywords))])]):_vm._e()])}),_vm._v(" "),(_vm.searchContent.test.length === 0)?_c('li',[_vm._v(" --- No Tests ---")]):_vm._e()],2)]),_vm._v(" "),_c('div',{staticClass:"profile-test"},[_c('h5',[_vm._v("Package")]),_vm._v(" "),_c('ul',[_vm._l((_vm.searchContent.profile),function(profile,index){return _c('li',{key:index,on:{"click":function($event){_vm.addTestFromDropdown($event, profile)}}},[_c('p',{staticClass:"m-0 capitalize"},[_c('i',{staticClass:"fa fa-plus mr-2"}),_vm._v("\n                                                "+_vm._s(profile.name)+"\n                                            "),(profile.isSelected === 1)?_c('i',{staticClass:"fa fa-circle green-color",staticStyle:{"font-size":"11px","margin-left":"3px"}}):_vm._e()]),_vm._v(" "),((profile.testCount && profile.testCount > 0) || (profile.includedProfiles && profile.includedProfiles.count > 0))?_c('p',{staticClass:"test-key m-0 pl-4"},[_c('b',[_vm._v("Includes "+_vm._s(_vm.getIncudedTestAndProfilePop(profile))+" ")])]):_vm._e()])}),_vm._v(" "),(_vm.searchContent.profile.length === 0)?_c('li',[_vm._v(" --- No Profiles --- ")]):_vm._e()],2)])]),_vm._v(" "),(_vm.isSearchLoading)?_c('div',{staticClass:"test-option"},[_vm._v("\n                              "+_vm._s(_vm.isSearchLoading)+"\n                            ")]):_vm._e()]),_vm._v(" "),_c('div',{class:{ 'testProfileSearch': (_vm.searchtext != '') }},[_vm._l((_vm.selectedProfileAndTest),function(sel,index){return _c('span',{key:index,staticClass:"badge badge-primary mb-1"},[_c('span',{staticClass:"capitalize"},[_vm._v(_vm._s(sel.name))]),_vm._v(" "),_c('i',{staticClass:"material-icons float-right",on:{"click":function($event){$event.preventDefault();_vm.removeSelectedItems(sel)}}},[_vm._v("close")])])}),_vm._v(" "),(_vm.selectedProfileAndTest.length <= 0)?_c('span',{staticClass:"mb-1 ft-s-15"},[_vm._v("\n                            No test or package selected\n                          ")]):_vm._e()],2)])])])])]),_vm._v(" "),_c('div',{staticClass:"portal-section"},[_c('div',{class:{'container-fluid' : _vm.selectedProfileAndTest && _vm.selectedProfileAndTest.length > 0 , 'container' : !_vm.selectedProfileAndTest || _vm.selectedProfileAndTest.length <= 0}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-7 offset-sm-3"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-9 mb-0"},[(_vm.labContent && _vm.labLists.length > 0 && !_vm.isLabLoading)?_c('p',{staticClass:"mt-1 mb-0"},[_vm._v("Showing "),_c('b',{staticClass:"black-color"},[_vm._v(_vm._s(_vm.labLists.length)+" Labs ")]),_vm._v(" in "),_c('b',{staticClass:"black-color"},[_vm._v(_vm._s(_vm.$localStorage.get('location') ? _vm.$localStorage.get('location').locationName : (_vm.selectedCity ? _vm.selectedCity.cityName : ''))+" ")]),_vm._v(", starting from "+_vm._s('Rs.'+_vm.lowestCost))]):_vm._e()]),_vm._v(" "),(_vm.labContent && _vm.labLists.length > 0 && !_vm.isLabLoading)?_c('div',{staticClass:"col-sm-3 mb-0"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.sortBy),expression:"sortBy"}],staticClass:"form-control form-control-sm mb-3",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.sortBy=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){_vm.labSortOrder()}]}},[_c('option',{attrs:{"value":"1"}},[_vm._v("Price Low to High")]),_vm._v(" "),_c('option',{attrs:{"value":"2"}},[_vm._v("Price High to Low")]),_vm._v(" "),_c('option',{attrs:{"value":"3"}},[_vm._v("Ratings")])])]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"row"},[(_vm.selectedProfileAndTest && _vm.selectedProfileAndTest.length > 0)?_c('div',{staticClass:"col-sm-3 d-none d-sm-block"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_vm._v("\n                            Popular Packages\n                        ")]),_vm._v(" "),_c('div',{staticClass:"card-body"},[((_vm.popularTests.profile))?_c('ul',{staticClass:"test-list"},_vm._l((_vm.popularTests.profile.slice(0, 5)),function(data,index){return _c('li',{key:index,staticClass:"pd_10 cursor-p"},[_c('span',{on:{"click":function($event){_vm.addTestFromDropdown($event, data)}}},[_c('i',{staticClass:"fa fa-plus mr-2"}),_vm._v(" \n                                      "+_vm._s(data.name)+"\n                                    ")]),_vm._v(" "),_c('span',{staticClass:"blue-color list-popup",on:{"click":function($event){_vm.openPopularProfileTestList(data)}}},[_vm._v("\n                                        (includes "+_vm._s(_vm.getIncudedTestAndProfilePopular(data))+")\n                                    ")]),_vm._v(" "),(data.isSelected === 1)?_c('i',{staticClass:"fa fa-circle green-color test-active-font"}):_vm._e()])})):_c('ul',{staticClass:"lab-test"},[_c('li',[_vm._v("\n                                  Loading...\n                                ")])])])]),_vm._v(" "),_c('div',{staticClass:"card mt-3"},[_c('div',{staticClass:"card-header"},[_vm._v("\n                            Popular Tests\n                        ")]),_vm._v(" "),_c('div',{staticClass:"card-body"},[((_vm.popularTests.test))?_c('ul',{staticClass:"test-list"},_vm._l((_vm.popularTests.test.slice(0, 5)),function(data,index){return _c('li',{key:index,staticClass:"pd_10 cursor-p",on:{"click":function($event){_vm.addTestFromDropdown($event, data)}}},[_c('i',{staticClass:"fa fa-plus mr-2"}),_vm._v(" \n                                    "+_vm._s(data.name)+"\n                                    "),(data.isSelected === 1)?_c('i',{staticClass:"fa fa-circle green-color test-active-font"}):_vm._e()])})):_c('ul',{staticClass:"lab-test"},[_c('li',[_vm._v("\n                                  Loading...\n                                ")])])])])]):_vm._e(),_vm._v(" "),(_vm.selectedProfileAndTest && _vm.selectedProfileAndTest.length > 0)?_c('div',{staticClass:"col-sm-7"},[_vm._l((_vm.limitBy(_vm.labLists, _vm.labLimit)),function(lab,index){return _c('div',{key:index,staticClass:"lab"},[_c('div',{staticClass:"display-flex"},[_c('div',{staticClass:"flex-box"},[_c('div',{staticClass:"lab-logo"},[(lab.logo && lab.logo.length > 0)?_c('img',{attrs:{"src":lab.logo}}):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"lab-rating"},[_c('ul',[_vm._l((parseInt(lab.rating)),function(stars){return _c('li',[_c('i',{staticClass:"material-icons"},[_vm._v("star")])])}),_vm._v(" "),_vm._l((5-parseInt(lab.rating)),function(star_borders){return _c('li',[_c('i',{staticClass:"material-icons"},[_vm._v("star_border")])])})],2)])]),_vm._v(" "),_c('div',{staticClass:"flex-box"},[_c('h6',{staticClass:"black-color mb-0"},[_vm._v(_vm._s(lab.labName))]),_vm._v(" "),_c('p',{staticClass:"mb-0"},[_c('span',{staticClass:"mr-3"},[_c('i',{staticClass:"fa fa-map-marker green-color mr-1",attrs:{"aria-hidden":"true"}}),_vm._v("\n                                    "+_vm._s(lab.branch.branchLocation)+"\n                                  ")])]),_vm._v(" "),_vm._m(0,true,false),_vm._v(" "),_c('p',_vm._l((lab.labTestList),function(tl,key){return _c('span',{key:key},[_c('span',{staticClass:"selected-test"},[_vm._v(_vm._s(tl.aliasName))]),_vm._v(" "),(tl.testId === 0)?_c('span',{staticClass:"selected-test"},[(tl.testId === 0)?_c('span',{staticClass:"blue-color list-popup",on:{"click":function($event){_vm.openProfileTestList(tl.aliasName, tl.testInfo, tl)}}},[_vm._v("\n                                              (includes "+_vm._s(_vm.getIncudedTestAndProfile(tl))+" )\n                                          ")]):_vm._e()]):_vm._e(),_vm._v(" "),((lab.labTestList.length > 1 && (key) != (lab.labTestList.length-1)))?_c('span',{attrs:{"id":key}},[_vm._v(" | ")]):_vm._e()])}))])]),_vm._v(" "),_c('div',{staticClass:"clearfix"},[(lab.certificationList.length > 0)?_c('div',{staticClass:"float-left"},[_c('span',{staticClass:"mb-2"},[_vm._v("Lab Certified with")]),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('ul',{staticClass:"lab-certificate mt-3"},_vm._l((lab.certificationList),function(cert,index){return _c('li',{key:index},[((cert.labCertificateImageId === 1))?_c('img',{attrs:{"src":"static/images/certifi01.jpg","alt":""}}):_vm._e(),_vm._v(" "),((cert.labCertificateImageId === 2))?_c('img',{attrs:{"src":"static/images/certifi03.jpg","alt":""}}):_vm._e(),_vm._v(" "),((cert.labCertificateImageId === 3))?_c('img',{attrs:{"src":"static/images/certifi02.jpg","alt":""}}):_vm._e()])}))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"float-right"},[_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('h5',{staticClass:"float-lg-right mt-1 mb-0 price-tag"},[((lab.actualCost > lab.ourCost))?_c('span',{staticClass:"red-color strip-text"},[_vm._v("Rs. "+_vm._s(lab.actualCost))]):_vm._e(),_vm._v(" "),_c('strong',[_vm._v("Rs. "+_vm._s(lab.ourCost))])]),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('div',{staticClass:"dropup"},[_c('a',{staticClass:"float-right mt-1 mb-3 blue-color dropdown-toggle",attrs:{"data-toggle":"dropdown","aria-haspopup":"true","aria-expanded":"false"}},[_vm._v("Price Breakup")]),_vm._v(" "),_c('div',{staticClass:"dropdown-menu dropdown-menu-right p-3"},[_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"price-breake fs-13"},[_vm._l((lab.labTestList),function(tl,key){return _c('tr',{key:key},[_c('td',{staticClass:"text-nowrap"},[_vm._v(_vm._s(tl.aliasName))]),_vm._v(" "),_c('td',{staticClass:"text-nowrap"},[_c('h5',{staticClass:"float-right mt-1 mb-0 price-tag price-tag price-breakeup"},[((tl.acutalPrice > tl.ourPrice))?_c('span',{staticClass:"red-color strip-text"},[_vm._v("Rs. "+_vm._s(tl.acutalPrice))]):_vm._e(),_vm._v(" Rs. "+_vm._s(tl.ourPrice)+"\n                                                      ")])])])}),_vm._v(" "),_c('tr',{staticClass:"grey-color border-top"},[_c('td',{staticClass:"text-nowrap bo"},[_vm._v("Sub Total")]),_vm._v(" "),_c('td',{staticClass:"text-nowrap"},[_c('h5',{staticClass:"float-right mt-1 mb-0 price-tag price-tag"},[_vm._v("\n                                                            Rs. "+_vm._s(lab.ourCost)+"\n                                                      ")])])])],2)])])]),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),(_vm.$localStorage.get('sl') && _vm.$localStorage.get('sl').labId === lab.labId)?_c('button',{staticClass:"btn btn-primary full-width",on:{"click":function($event){_vm.goChooseDate(lab)}}},[_vm._v("book appointment")]):_vm._e(),_vm._v(" "),(_vm.$localStorage.get('sl') && _vm.$localStorage.get('sl').labId !== lab.labId)?_c('button',{staticClass:"btn btn-primary full-width",on:{"click":function($event){_vm.goChooseDate(lab)}}},[_vm._v("book appointment")]):_vm._e(),_vm._v(" "),(!_vm.$localStorage.get('sl'))?_c('button',{staticClass:"btn btn-primary full-width",on:{"click":function($event){_vm.goChooseDate(lab)}}},[_vm._v("book appointment")]):_vm._e()])])])}),_vm._v(" "),(_vm.labLists.length <= 0)?_c('div',{staticClass:"card  mt-3"},[_c('div',{staticClass:"card-body"},[(_vm.labLists.length <= 0 && !_vm.isLabLoading)?_c('div',{staticClass:"no-labs text-center mt-4"},[_c('img',{attrs:{"src":"static/images/lab-flask.png","alt":""}}),_vm._v(" "),_c('p',[_vm._v("No Labs found for your tests in "+_vm._s(_vm.selectedCity.cityName ? _vm.selectedCity.cityName : ''))])]):_vm._e(),_vm._v(" "),(_vm.labLists.length <= 0 && _vm.isLabLoading)?_c('div',{staticClass:"no-labs text-center mt-4"},[_c('img',{attrs:{"src":"static/images/lab-flask.png","alt":""}}),_vm._v(" "),_c('p',[_vm._v("Loading...")])]):_vm._e()])]):_vm._e()],2):_vm._e(),_vm._v(" "),(_vm.selectedProfileAndTest && _vm.selectedProfileAndTest.length > 0)?_c('div',{staticClass:"col-sm-2"},_vm._l((_vm.sideBannerAds),function(sideBanner,index){return _c('a',{on:{"click":function($event){_vm.adsRedirect(sideBanner.url)}}},[_c('img',{staticClass:"w-100",class:{'mt-3' : (index > 0)},attrs:{"src":sideBanner.src,"alt":""}})])})):_vm._e(),_vm._v(" "),(!_vm.selectedProfileAndTest || _vm.selectedProfileAndTest.length === 0)?_c('div',{staticClass:"col-sm-12 mt-3"},[_c('p',[_vm._v(" Please Choose one or more Profile/Test to show labs")])]):_vm._e(),_vm._v(" "),(!_vm.selectedProfileAndTest || _vm.selectedProfileAndTest.length === 0)?_c('div',{staticClass:"col-sm-5  <mt-0></mt-0>"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_vm._v("\n                          Popular Packages\n                      ")]),_vm._v(" "),_c('div',{staticClass:"card-body"},[((_vm.popularTests.profile))?_c('ul',{staticClass:"test-list"},_vm._l((_vm.popularTests.profile.slice(0, 10)),function(data,index){return _c('li',{key:index,staticClass:"pd_10 cursor-p"},[_c('span',{on:{"click":function($event){_vm.addTestFromDropdown($event, data)}}},[_c('i',{staticClass:"fa fa-plus mr-2"}),_vm._v(" \n                                    "+_vm._s(data.name)+"\n                                  ")]),_vm._v(" "),_c('span',{staticClass:"blue-color list-popup",on:{"click":function($event){_vm.openPopularProfileTestList(data)}}},[_vm._v("\n                                      (includes "+_vm._s(_vm.getIncudedTestAndProfilePopular(data))+")\n                                  ")]),_vm._v(" "),(data.isSelected === 1)?_c('i',{staticClass:"fa fa-circle green-color test-active-font"}):_vm._e()])})):_c('ul',{staticClass:"lab-test"},[_c('li',[_vm._v("\n                                Loading...\n                              ")])])])])]):_vm._e(),_vm._v(" "),(!_vm.selectedProfileAndTest || _vm.selectedProfileAndTest.length === 0)?_c('div',{staticClass:"col-sm-4  mt-0"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_vm._v("\n                            Popular Tests\n                        ")]),_vm._v(" "),_c('div',{staticClass:"card-body"},[((_vm.popularTests.test))?_c('ul',{staticClass:"test-list"},_vm._l((_vm.popularTests.test.slice(0, 10)),function(data,index){return _c('li',{key:index,staticClass:"pd_10 cursor-p",on:{"click":function($event){_vm.addTestFromDropdown($event, data)}}},[_c('i',{staticClass:"fa fa-plus mr-2"}),_vm._v(" \n                                    "+_vm._s(data.name)+"\n                                    "),(data.isSelected === 1)?_c('i',{staticClass:"fa fa-circle green-color test-active-font"}):_vm._e()])})):_c('ul',{staticClass:"lab-test"},[_c('li',[_vm._v("\n                                  Loading...\n                                ")])])])])]):_vm._e(),_vm._v(" "),(!_vm.selectedProfileAndTest || _vm.selectedProfileAndTest.length === 0)?_c('div',{staticClass:"col-sm-3 mt-0"},_vm._l((_vm.sideBannerAds),function(sideBanner,index){return _c('a',{on:{"click":function($event){_vm.adsRedirect(sideBanner.url)}}},[_c('img',{staticClass:"w-100",class:{'mt-3' : (index > 0)},attrs:{"src":sideBanner.src,"alt":""}})])})):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"row mt-3"},[_c('div',{staticClass:"col-sm-4 offset-5"},[(_vm.labLists.length >_vm.labLimit)?_c('button',{staticClass:"btn btn-outline-primary full-width",on:{"click":function($event){_vm.loadMore()}}},[_vm._v("Show more Labs ("+_vm._s(_vm.labLists.length - _vm.labLimit)+")")]):_vm._e()])])])]),_vm._v(" "),_c('div',{staticClass:"modal fade bd-example-modal-lg",attrs:{"id":"test-popup","tabindex":"-1","role":"dialog","aria-labelledby":"exampleModalLabel","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog  modal-lg",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_c('h5',{staticClass:"modal-title",attrs:{"id":"exampleModalLabel"}},[_vm._v(_vm._s(_vm.clickedProfileDetails.aliasName))]),_vm._v(" "),_vm._m(1,false,false)]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[(_vm.clickedProfileDetails.patientInstruction && _vm.clickedProfileDetails.patientInstruction.length > 0)?_c('p',[_vm._v("Patient Instruction:")]):_vm._e(),_vm._v(" "),(_vm.clickedProfileDetails.patientInstruction && _vm.clickedProfileDetails.patientInstruction.length > 0)?_c('p',{staticClass:"black-color"},[_vm._v(_vm._s(_vm.clickedProfileDetails.patientInstruction))]):_vm._e(),_vm._v(" "),(_vm.clickedProfileTests.length > 0 || (_vm.clickedProfileDetails.includedProfiles && _vm.clickedProfileDetails.includedProfiles.count > 0))?_c('p',{class:{'mt-4' : (_vm.clickedProfileDetails.patientInstruction && _vm.clickedProfileDetails.patientInstruction.length > 0 ) }},[_vm._v("Included Tests ("),_c('span',{staticStyle:{"font-size":"12px"}},[_vm._v(_vm._s(_vm.getIncudedTestAndProfilePop(_vm.clickedProfileDetails)))]),_vm._v("): ")]):_vm._e(),_vm._v(" "),(_vm.clickedProfileTests.length > 0 || (_vm.clickedProfileDetails.includedProfiles && _vm.clickedProfileDetails.includedProfiles.count > 0) )?_c('div',{staticClass:"black-color row included-profiles"},[_c('div',{staticClass:"col-sm-6"},[((_vm.clickedProfileDetails.includedProfiles && _vm.clickedProfileDetails.includedProfiles.count > 0))?_c('div',{attrs:{"id":"accordion","role":"tablist"}},_vm._l((_vm.clickedProfileDetails.includedProfiles.data),function(inclProf,index){return _c('div',{key:index,staticClass:"card"},[_c('div',{staticClass:"card-header",attrs:{"role":"tab","id":"headingOne"}},[_c('h5',{staticClass:"mb-0"},[_c('a',{staticClass:"collapsed",attrs:{"data-toggle":"collapse","href":'#collapseTwo'+inclProf.panelId,"aria-expanded":"true","aria-controls":"collapseTwo"}},[_vm._v("\n                                              "+_vm._s(inclProf.panelName+' (includes '+ inclProf.ProfileTests.length +'    Tests)')+"\n                                              "),_c('i',{staticClass:"material-icons float-right"})])])]),_vm._v(" "),_c('div',{staticClass:"collapse",attrs:{"id":'collapseTwo'+inclProf.panelId,"role":"tabpanel","aria-labelledby":"headingOne","data-parent":"#accordion"}},[_c('div',{staticClass:"pl-4"},_vm._l((inclProf.ProfileTests),function(incTest,index){return _c('span',{key:index,staticClass:"mb-2"},[_vm._v(_vm._s(incTest.testName+((inclProf.ProfileTests.length != (index+1))? ' , ' : ''))),_c('br')])}))])])})):_vm._e(),_vm._v(" "),_c('div',{attrs:{"id":"accordion","role":"tablist"}},_vm._l((_vm.clickedProfileTestFirst),function(cli,index){return _c('div',{key:index,staticClass:"card"},[_c('div',{staticClass:"card-header",attrs:{"role":"tab","id":"headingOne"}},[_c('h5',{staticClass:"mb-0"},[_c('a',[_vm._v("\n                                              "+_vm._s(cli)+"\n                                          ")])])])])}))]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{attrs:{"id":"accordion","role":"tablist"}},_vm._l((_vm.clickedProfileTestSecond),function(cli,index){return _c('div',{key:index,staticClass:"card"},[_c('div',{staticClass:"card-header",attrs:{"role":"tab","id":"headingOne"}},[_c('h5',{staticClass:"mb-0"},[_c('a',{staticClass:"collapsed"},[_vm._v("\n                                              "+_vm._s(cli)+"\n                                          ")])])])])}))])]):_c('div',{staticClass:"black-color"},[_c('p',[_vm._v(" -- No tests available -- ")])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal fade bd-example-modal-lg",attrs:{"id":"lab_test-popup","tabindex":"-1","role":"dialog","aria-labelledby":"exampleModalLabel","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog  modal-lg",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_c('h5',{staticClass:"modal-title",attrs:{"id":"exampleModalLabel"}},[_vm._v(_vm._s(_vm.clickedProfileDetails.aliasName))]),_vm._v(" "),_vm._m(2,false,false)]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[(_vm.clickedProfileDetails.patientInstruction && _vm.clickedProfileDetails.patientInstruction.length > 0)?_c('p',[_vm._v("Patient Instruction:")]):_vm._e(),_vm._v(" "),(_vm.clickedProfileDetails.patientInstruction && _vm.clickedProfileDetails.patientInstruction.length > 0)?_c('p',{staticClass:"black-color"},[_vm._v(_vm._s(_vm.clickedProfileDetails.patientInstruction))]):_vm._e(),_vm._v(" "),(_vm.clickedProfileTests.length > 0 || (_vm.clickedProfileDetails.includedProfiles && _vm.clickedProfileDetails.includedProfiles.count > 0))?_c('p',{class:{'mt-4' : (_vm.clickedProfileDetails.patientInstruction && _vm.clickedProfileDetails.patientInstruction.length > 0 ) }},[_vm._v("Included Tests ("),_c('span',{staticStyle:{"font-size":"12px"}},[_vm._v(_vm._s(_vm.getIncudedTestAndProfile(_vm.clickedProfileDetails)))]),_vm._v("): ")]):_vm._e(),_vm._v(" "),(_vm.clickedProfileTests.length > 0 || (_vm.clickedProfileDetails.includedProfiles && _vm.clickedProfileDetails.includedProfiles.count > 0) )?_c('div',{staticClass:"black-color row included-profiles"},[_c('div',{staticClass:"col-sm-6"},[((_vm.clickedProfileDetails.includedProfiles && _vm.clickedProfileDetails.includedProfiles.count > 0))?_c('div',{attrs:{"id":"accordion","role":"tablist"}},_vm._l((_vm.clickedProfileDetails.includedProfiles.data),function(inclProf,index){return _c('div',{key:index,staticClass:"card"},[_c('div',{staticClass:"card-header",attrs:{"role":"tab","id":"headingOne"}},[_c('h5',{staticClass:"mb-0"},[_c('a',{staticClass:"collapsed",attrs:{"data-toggle":"collapse","href":'#collapseOne'+inclProf.panelId,"aria-expanded":"true","aria-controls":"collapseOne"}},[_vm._v("\n                                              "+_vm._s(inclProf.aliasName+' (includes '+ inclProf.ProfileTests.length +' Tests)')+"\n                                              "),_c('i',{staticClass:"material-icons float-right"})])])]),_vm._v(" "),_c('div',{staticClass:"collapse",attrs:{"id":'collapseOne'+inclProf.panelId,"role":"tabpanel","aria-labelledby":"headingOne","data-parent":"#accordion"}},[_c('div',{staticClass:"pl-4"},_vm._l((inclProf.ProfileTests),function(incTest,index){return _c('span',{key:index,staticClass:"mb-2"},[_vm._v(_vm._s(incTest.testName+((inclProf.ProfileTests.length != (index+1))? ' , ' : ''))),_c('br')])}))])])})):_vm._e(),_vm._v(" "),_c('div',{attrs:{"id":"accordion","role":"tablist"}},_vm._l((_vm.clickedProfileTestFirst),function(cli,index){return _c('div',{key:index,staticClass:"card"},[_c('div',{staticClass:"card-header",attrs:{"role":"tab","id":"headingOne"}},[_c('h5',{staticClass:"mb-0"},[_c('a',{staticClass:"collapsed"},[_vm._v("\n                                              "+_vm._s(cli)+"\n                                          ")])])])])}))]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{attrs:{"id":"accordion","role":"tablist"}},_vm._l((_vm.clickedProfileTestSecond),function(cli,index){return _c('div',{key:index,staticClass:"card"},[_c('div',{staticClass:"card-header",attrs:{"role":"tab","id":"headingOne"}},[_c('h5',{staticClass:"mb-0"},[_c('a',{staticClass:"collapsed"},[_vm._v("\n                                              "+_vm._s(cli)+"\n                                          ")])])])])}))])]):_c('div',{staticClass:"black-color"},[_c('p',[_vm._v(" -- No tests available -- ")])])])])])]),_vm._v(" "),_c('FooterVue')],1)}
var Lab_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h6',{staticClass:"pickup-label"},[_c('span',{staticClass:"badge badge-success"},[_vm._v("Free Home Sample Pickup")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])}]
var Lab_esExports = { render: Lab_render, staticRenderFns: Lab_staticRenderFns }
/* harmony default export */ var Book_Lab = (Lab_esExports);
// CONCATENATED MODULE: ./src/components/web/Book/Lab.vue
function Lab_injectStyle (ssrContext) {
  __webpack_require__("NNgi")
}
var Lab_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var Lab___vue_template_functional__ = false
/* styles */
var Lab___vue_styles__ = Lab_injectStyle
/* scopeId */
var Lab___vue_scopeId__ = "data-v-57273c5e"
/* moduleIdentifier (server only) */
var Lab___vue_module_identifier__ = null
var Lab_Component = Lab_normalizeComponent(
  Lab,
  Book_Lab,
  Lab___vue_template_functional__,
  Lab___vue_styles__,
  Lab___vue_scopeId__,
  Lab___vue_module_identifier__
)

/* harmony default export */ var web_Book_Lab = (Lab_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/web/Book/Appointment.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








var myDate = new Date();

/* harmony default export */ var Appointment = ({
  name: 'AppointmentDate',
  components: {
    HeaderVue: Header["a" /* default */],
    FooterVue: Footer["a" /* default */],
    Datepicker: build_default.a
  },
  beforeCreate: function beforeCreate() {
    if (!this.$localStorage.get('st')) {
      //   this.$router.push('/test')
      this.$router.push('/lab');
      return false;
    }
    if (!this.$localStorage.get('sl')) {
      this.$router.push('/lab');
      return false;
    }
    myDate = new Date();
    myDate.setDate(myDate.getDate() - 1);
  },
  data: function data() {
    return {
      isDatePickerOpend: true,
      datepicker: true,
      timepicker: false,
      disabled: {
        to: myDate
      },
      language: 'en',
      payinfo: {
        mrpTotal: 0,
        phlebotomistFee: 0,
        subTotal: 0,
        labDiscount: 0,
        phlebotomyFeeWaiver: 0,
        total: 0,
        gst: 0,
        grandTotal: 0
      },
      dt: '',
      timeSelected: '',
      availableTimes: [{ startTime: '06:00', endTime: '07:00', startTimeDisp: '06:00', endTimeDisp: '07:00 am', isEnable: true, isActive: false },
      // { startTime: '06:30', endTime: '07:00', startTimeDisp: '06:30', endTimeDisp: '07:00 am', isEnable: true, isActive: false },
      { startTime: '07:00', endTime: '08:00', startTimeDisp: '07:00', endTimeDisp: '08:00 am', isEnable: true, isActive: false },
      // { startTime: '07:30', endTime: '08:00', startTimeDisp: '07:30', endTimeDisp: '08:00 am', isEnable: true, isActive: false },
      { startTime: '08:00', endTime: '09:00', startTimeDisp: '08:00', endTimeDisp: '09:00 am', isEnable: true, isActive: false },
      // { startTime: '08:30', endTime: '09:00', startTimeDisp: '08:30', endTimeDisp: '09:00 am', isEnable: true, isActive: false },
      { startTime: '09:00', endTime: '10:00', startTimeDisp: '09:00', endTimeDisp: '10:00 am', isEnable: true, isActive: false },
      // { startTime: '09:30', endTime: '10:00', startTimeDisp: '09:30', endTimeDisp: '10:00 am', isEnable: true, isActive: false },
      { startTime: '10:00', endTime: '11:00', startTimeDisp: '10:00', endTimeDisp: '11:00 am', isEnable: true, isActive: false },
      // { startTime: '10:30', endTime: '11:00', startTimeDisp: '10:30', endTimeDisp: '11:00 am', isEnable: true, isActive: false },
      { startTime: '11:00', endTime: '12:00', startTimeDisp: '11:00', endTimeDisp: '12:00 pm', isEnable: true, isActive: false },
      // { startTime: '11:30', endTime: '12:00', startTimeDisp: '11:30', endTimeDisp: '12:00 pm', isEnable: true, isActive: false },
      { startTime: '12:00', endTime: '13:00', startTimeDisp: '12:00', endTimeDisp: '1:00 pm', isEnable: true, isActive: false },
      // { startTime: '12:30', endTime: '13:00', startTimeDisp: '12:30', endTimeDisp: '01:00 pm', isEnable: true, isActive: false },
      { startTime: '13:00', endTime: '14:00', startTimeDisp: '01:00', endTimeDisp: '02:00 pm', isEnable: true, isActive: false },
      // { startTime: '13:30', endTime: '14:00', startTimeDisp: '01:30', endTimeDisp: '02:00 pm', isEnable: true, isActive: false },
      { startTime: '14:00', endTime: '15:00', startTimeDisp: '02:00', endTimeDisp: '03:00 pm', isEnable: true, isActive: false },
      // { startTime: '14:30', endTime: '15:00', startTimeDisp: '02:30', endTimeDisp: '03:00 pm', isEnable: true, isActive: false },
      { startTime: '15:00', endTime: '16:00', startTimeDisp: '03:00', endTimeDisp: '04:00 pm', isEnable: true, isActive: false },
      // { startTime: '15:30', endTime: '16:00', startTimeDisp: '03:30', endTimeDisp: '04:00 pm', isEnable: true, isActive: false },
      { startTime: '16:00', endTime: '17:00', startTimeDisp: '04:00', endTimeDisp: '05:00 pm', isEnable: true, isActive: false },
      // { startTime: '16:30', endTime: '17:00', startTimeDisp: '04:30', endTimeDisp: '05:00 pm', isEnable: true, isActive: false },
      { startTime: '17:00', endTime: '18:00', startTimeDisp: '05:00', endTimeDisp: '06:00 pm', isEnable: true, isActive: false },
      // { startTime: '17:30', endTime: '18:00', startTimeDisp: '05:30', endTimeDisp: '06:00 pm', isEnable: true, isActive: false },
      { startTime: '18:00', endTime: '19:00', startTimeDisp: '06:00', endTimeDisp: '07:00 pm', isEnable: true, isActive: false },
      // { startTime: '18:30', endTime: '19:00', startTimeDisp: '06:30', endTimeDisp: '07:00 pm', isEnable: true, isActive: false },
      { startTime: '19:00', endTime: '20:00', startTimeDisp: '07:00', endTimeDisp: '08:00 pm', isEnable: true, isActive: false },
      // { startTime: '19:30', endTime: '20:00', startTimeDisp: '07:30', endTimeDisp: '08:00 pm', isEnable: true, isActive: false },
      { startTime: '20:00', endTime: '21:00', startTimeDisp: '08:00', endTimeDisp: '09:00 pm', isEnable: true, isActive: false
        // { startTime: '20:30', endTime: '21:00', startTimeDisp: '08:30', endTimeDisp: '09:00 pm', isEnable: true, isActive: false }
      }],
      selectedLab: [],
      selectedProfileAndTest: [],
      isFasting: 0,
      testCosts: [],
      GSTFee: this.$GSTFee,
      isDateAndTimeChoosed: false
    };
  },

  methods: {
    openDatePicker: function openDatePicker() {
      this.isDatePickerOpend = !this.isDatePickerOpend;
    },
    removeSelectedItems: function removeSelectedItems(cost, selectedTests, selectedLab) {
      var confirmText = 'Are you sure you want to remove?';
      if (selectedTests.length === 1) {
        confirmText = 'Are you sure you want to remove last one?';
      }

      var confirmFn = function () {
        this.$localStorage.remove('st');
        this.$localStorage.remove('cou');
        var reFetcheditems = [];
        selectedTests.forEach(function (items) {
          console.log(items);
          if (!(items.testId === cost.testId && cost.panelId === items.panelId)) {
            reFetcheditems.push(items);
          }
        });
        console.log(reFetcheditems);
        this.$localStorage.set('st', reFetcheditems, 0);

        var reFetchedLabitems = [];
        if (selectedLab) {
          if (selectedLab.labTestList.length > 0) {
            selectedLab.labTestList.forEach(function (labTest) {
              console.log(labTest);
              if (!(labTest.labProfileId === cost.labProfileId)) {
                reFetchedLabitems.push(labTest);
              }
            });
          }
        }
        selectedLab.labTestList = reFetchedLabitems;
        console.log(selectedLab);
        this.$localStorage.set('sl', selectedLab, 30 * 60 * 1000);

        this.getTestCosts();
        this.getFastingTests();

        if (selectedTests.length === 1) {
          //   this.$router.push('/test')
          this.$router.push('/lab');
        }
      }.bind(this);

      this.$Simplert.open({
        title: 'Confirm',
        message: confirmText,
        type: 'info',
        useConfirmBtn: true,
        onConfirm: confirmFn,
        customConfirmBtnText: 'Ok',
        customCloseBtnText: 'Cancel',
        disableOverlayClick: true
      });
    },
    saveDateAndTime: function saveDateAndTime() {
      this.isDateAndTimeChoosed = true;
      console.log('Selected Date:');
      console.log(this.dt);
      console.log('Selected Time:');
      console.log(this.timeSelected);
    },
    changeDateAndTime: function changeDateAndTime() {
      this.isDateAndTimeChoosed = false;
      this.isDatePickerOpend = true;
    },
    showhide: function showhide() {
      this.datepicker = true;
      this.timepicker = false;
    },
    formatDate: function formatDate(date) {
      return dateformat_default()(date, 'dd/mm/yyyy');
    },
    goChooseLocation: function goChooseLocation() {
      this.$localStorage.remove('sa');
      this.$localStorage.remove('sm');
      this.$localStorage.remove('cou');
      vue_esm["default"].analytics.fbq.event('ViewContent', {
        content_ids: 0,
        content_name: 'APPOINTMENT DATE',
        contents: '',
        content_type: 'APPOINTMENT_DATE'
      });
      this.$router.push({ path: '/address' });
      return false;
    },
    fbTriggerDate: function fbTriggerDate() {
      vue_esm["default"].analytics.fbq.event('ViewContent', {
        content_ids: 0,
        content_name: this.$localStorage.get('ct').fromDateTime,
        contents: '',
        content_type: 'APPOINTMENT_DATE'
      });
    },
    formatAMPM: function formatAMPM(time) {
      var setDate = new Date('2017-01-01 '.replace(/-/g, '/') + time.toString());
      var hours = setDate.getHours();
      var minutes = setDate.getMinutes();
      var ampm = hours >= 12 ? 'pm' : 'am';
      hours = hours % 12;
      if (hours === 0) {
        hours = 12;
      }
      minutes = minutes < 10 ? '0' + minutes : minutes;
      var strTime = (hours.toString().length === 1 ? '0' : '') + hours + ':' + minutes + ' ' + ampm;
      return strTime;
    },
    getAvailableTime: function getAvailableTime(date) {
      var self = this;
      try {
        var data = {
          'appointmentDate': dateformat_default()(date, 'yyyy/mm/dd'),
          'zipCode': this.$localStorage.get('location') ? this.$localStorage.get('location').locationZipCode : this.$defaultPincode,
          'labId': this.$localStorage.get('sl') ? this.$localStorage.get('sl').labId : '0'
        };
        var availableTimes = [];
        promise_default.a.resolve(this.$GET('patient/getAvailableTime', data)).then(function (res) {
          if (res.response_code === 0) {
            if (res.response.length > 0) {
              underscore_default.a.each(res.response, function (ele, key) {
                var parts = ele.time.split(':');
                var endTime = parseInt(parts[0]) + 1 + ':00:00';
                // if (parseInt(parts[1]) === 0) {
                //   endTime = parts[0] + ':30:01'
                // } else {
                //   endTime = (parseInt(parts[0]) + 1) + ':00:01'
                // }
                var arrayObj = {
                  startTime: ele.time,
                  startTimeDisp: self.formatAMPM(ele.time).replace(' am', '').replace(' pm', ''),
                  endTime: endTime,
                  endTimeDisp: self.formatAMPM(endTime),
                  isEnable: ele.isAvailable === 1,
                  isActive: false
                };
                var endTimeSplitArray = ele.time.split(':');
                if (dateformat_default()(date, 'yyyy/mm/dd') === dateformat_default()(new Date(), 'yyyy/mm/dd')) {
                  if (parseInt(endTimeSplitArray[0]) < parseInt(dateformat_default()(new Date(), 'HH'))) {
                    arrayObj['isEnable'] = false;
                  }
                  if (parseInt(endTimeSplitArray[0]) === parseInt(dateformat_default()(new Date(), 'HH')) && parseInt(endTimeSplitArray[1]) <= parseInt(dateformat_default()(new Date(), 'mm'))) {
                    arrayObj['isEnable'] = false;
                  }
                }
                availableTimes.push(arrayObj);
                endTime = undefined;
                parts = undefined;
              });
              this.availableTimes = availableTimes;
            }
          }
          this.$hidePageLoading();
        }.bind(this)).catch(function (err) {
          console.error(err);
        });
      } catch (e) {
        console.log(e);
      }
    },
    getTestCosts: function getTestCosts(lab) {
      try {
        var labTestCosts = [];
        if (this.$localStorage.get('sl')) {
          if (this.$localStorage.get('sl').labTestList.length > 0) {
            underscore_default.a.each(this.$localStorage.get('sl').labTestList, function (element) {
              labTestCosts.push(element.labProfileId);
            });
          }
        }
        var data = {
          'labId': this.$localStorage.get('sl') ? this.$localStorage.get('sl').labId : '0',
          'labTests': labTestCosts
        };
        promise_default.a.resolve(this.$POST('patient/getTestCosts', data)).then(function (res) {
          if (res.response_code === 0) {
            if (res.response) {
              this.testCosts = res.response;
              this.payinfo.mrpTotal = res.response.mrp;
              this.payinfo.phlebotomistFee = this.$phlebotomistFee;
              this.payinfo.subTotal = this.payinfo.mrpTotal + this.payinfo.phlebotomistFee;
              this.payinfo.labDiscount = res.response.youSaved;
              this.payinfo.phlebotomyFeeWaiver = this.payinfo.mrpTotal - this.payinfo.labDiscount > this.$waiverDiscountApplyFee ? this.$phlebotomyFeeWaiver : 0;
              this.payinfo.total = this.payinfo.subTotal - (this.payinfo.labDiscount + this.payinfo.phlebotomyFeeWaiver);
              this.payinfo.gst = Math.round(this.payinfo.total * this.$GSTFee / 100);
              this.payinfo.grandTotal = this.payinfo.total + this.payinfo.gst;
            }
          }
        }.bind(this)).catch(function (err) {
          console.error(err);
        });
      } catch (e) {
        console.log(e);
      }
    },
    getFastingTests: function getFastingTests() {
      try {
        this.isFasting = 0;
        var data = this.$localStorage.get('st');
        promise_default.a.resolve(this.$POST('patient/getFastingTests', data)).then(function (res) {
          if (res.response_code === 0) {
            if (res.response.isFasting === 1) {
              this.isFasting = 1;
            }
          }
        }.bind(this)).catch(function (err) {
          console.error(err);
        });
      } catch (e) {
        console.log('error', e);
      }
    },
    dateChange: function dateChange(dt) {
      this.$parent.$children[0].step = this.step;
      this.$parent.$children[0].current = 'health';
      this.datepicker = false;
      this.timepicker = true;
      this.timeSelected = '';
      this.dt = dt;
      var d = new Date(dt);
      var sDatetime = {
        date: d,
        dateFormat: d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate(),
        dateFormatMoment: dateformat_default()(d, 'yyyy-mm-dd', true),
        time: this.timeSelected,
        fromDateTime: dateformat_default()(d, 'yyyy-mm-dd', true) + ' ' + '00:00:00',
        toDateTime: dateformat_default()(d, 'yyyy-mm-dd', true) + ' ' + '00:00:00',
        tz: new Date().getTimezoneOffset()
      };
      this.$localStorage.set('ct', sDatetime, 30 * 60 * 1000);
      this.isDateAndTimeChoosed = false;
      this.getAvailableTime(dt);
    },
    setTime: function setTime(value) {
      this.timeSelected = value;
      var d = new Date(this.dt);
      var sDatetime = {
        date: d,
        dateFormat: d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate(),
        dateFormatMoment: dateformat_default()(d, 'yyyy-mm-dd'),
        time: this.timeSelected,
        fromDateTime: dateformat_default()(d, 'yyyy-mm-dd') + ' ' + this.timeSelected.startTime,
        toDateTime: dateformat_default()(d, 'yyyy-mm-dd') + ' ' + this.timeSelected.endTime,
        tz: new Date().getTimezoneOffset()
      };
      this.$localStorage.set('ct', sDatetime, 30 * 60 * 1000);
      this.isDateAndTimeChoosed = false;
      this.isDateAndTimeChoosed = true;
    }
  },
  created: function created() {
    this.$step = true;
    this.selectedLab = [];
    if (this.$localStorage.get('sl')) {
      this.selectedLab = this.$localStorage.get('sl');
    }
    this.selectedProfileAndTest = [];
    if (this.$localStorage.get('st')) {
      this.selectedProfileAndTest = this.$localStorage.get('st');
    }
    this.timeSelected = '';
    if (this.$localStorage.get('ct') && this.$localStorage.get('ct').time && this.$localStorage.get('ct').date) {
      this.dt = this.$localStorage.get('ct').date;
      this.timeSelected = this.$localStorage.get('ct').time;
      this.getAvailableTime(this.dt);
      this.isDateAndTimeChoosed = true;
      this.isDatePickerOpend = false;
    } else {
      var d = new Date();
      var dDatetime = {
        date: d,
        dateFormat: d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate(),
        dateFormatMoment: dateformat_default()(d, 'yyyy-mm-dd', true),
        time: '',
        fromDateTime: dateformat_default()(d, 'yyyy-mm-dd', true) + ' ' + '00:00:00',
        toDateTime: dateformat_default()(d, 'yyyy-mm-dd', true) + ' ' + '00:00:00',
        tz: new Date().getTimezoneOffset()
      };
      this.dt = d;
      this.$localStorage.set('ct', dDatetime, 30 * 60 * 1000);
      this.isDateAndTimeChoosed = false;
      this.availableTimes = [{ startTime: '06:00', endTime: '06:30', startTimeDisp: '06:00', endTimeDisp: '06:30 am', isEnable: true, isActive: false }, { startTime: '06:30', endTime: '07:00', startTimeDisp: '06:30', endTimeDisp: '07:00 am', isEnable: true, isActive: false }, { startTime: '07:00', endTime: '07:30', startTimeDisp: '07:00', endTimeDisp: '07:30 am', isEnable: true, isActive: false }, { startTime: '07:30', endTime: '08:00', startTimeDisp: '07:30', endTimeDisp: '08:00 am', isEnable: true, isActive: false }, { startTime: '08:00', endTime: '08:30', startTimeDisp: '08:00', endTimeDisp: '08:30 am', isEnable: true, isActive: false }, { startTime: '08:30', endTime: '09:00', startTimeDisp: '08:30', endTimeDisp: '09:00 am', isEnable: true, isActive: false }, { startTime: '09:00', endTime: '09:30', startTimeDisp: '09:00', endTimeDisp: '09:30 am', isEnable: true, isActive: false }, { startTime: '09:30', endTime: '10:00', startTimeDisp: '09:30', endTimeDisp: '10:00 am', isEnable: true, isActive: false }, { startTime: '10:00', endTime: '10:30', startTimeDisp: '10:00', endTimeDisp: '10:30 am', isEnable: true, isActive: false }, { startTime: '10:30', endTime: '11:00', startTimeDisp: '10:30', endTimeDisp: '11:00 am', isEnable: true, isActive: false }, { startTime: '11:00', endTime: '11:30', startTimeDisp: '11:00', endTimeDisp: '11:30 am', isEnable: true, isActive: false }, { startTime: '11:30', endTime: '12:00', startTimeDisp: '11:30', endTimeDisp: '12:00 pm', isEnable: true, isActive: false }, { startTime: '12:00', endTime: '12:30', startTimeDisp: '12:00', endTimeDisp: '12:30 pm', isEnable: true, isActive: false }, { startTime: '12:30', endTime: '13:00', startTimeDisp: '12:30', endTimeDisp: '01:00 pm', isEnable: true, isActive: false }, { startTime: '13:00', endTime: '13:30', startTimeDisp: '01:00', endTimeDisp: '01:30 pm', isEnable: true, isActive: false }, { startTime: '13:30', endTime: '14:00', startTimeDisp: '01:30', endTimeDisp: '02:00 pm', isEnable: true, isActive: false }, { startTime: '14:00', endTime: '14:30', startTimeDisp: '02:00', endTimeDisp: '02:30 pm', isEnable: true, isActive: false }, { startTime: '14:30', endTime: '15:00', startTimeDisp: '02:30', endTimeDisp: '03:00 pm', isEnable: true, isActive: false }, { startTime: '15:00', endTime: '15:30', startTimeDisp: '03:00', endTimeDisp: '03:30 pm', isEnable: true, isActive: false }, { startTime: '15:30', endTime: '16:00', startTimeDisp: '03:30', endTimeDisp: '04:00 pm', isEnable: true, isActive: false }, { startTime: '16:00', endTime: '16:30', startTimeDisp: '04:00', endTimeDisp: '04:30 pm', isEnable: true, isActive: false }, { startTime: '16:30', endTime: '17:00', startTimeDisp: '04:30', endTimeDisp: '05:00 pm', isEnable: true, isActive: false }, { startTime: '17:00', endTime: '17:30', startTimeDisp: '05:00', endTimeDisp: '05:30 pm', isEnable: true, isActive: false }, { startTime: '17:30', endTime: '18:00', startTimeDisp: '05:30', endTimeDisp: '06:00 pm', isEnable: true, isActive: false }, { startTime: '18:00', endTime: '18:30', startTimeDisp: '06:00', endTimeDisp: '06:30 pm', isEnable: true, isActive: false }, { startTime: '18:30', endTime: '19:00', startTimeDisp: '06:30', endTimeDisp: '07:00 pm', isEnable: true, isActive: false }, { startTime: '19:00', endTime: '19:30', startTimeDisp: '07:00', endTimeDisp: '07:30 pm', isEnable: true, isActive: false }, { startTime: '19:30', endTime: '20:00', startTimeDisp: '07:30', endTimeDisp: '08:00 pm', isEnable: true, isActive: false }, { startTime: '20:00', endTime: '20:30', startTimeDisp: '08:00', endTimeDisp: '08:30 pm', isEnable: true, isActive: false }, { startTime: '20:30', endTime: '21:00', startTimeDisp: '08:30', endTimeDisp: '09:00 pm', isEnable: true, isActive: false }];
      this.getAvailableTime(d);
    }
    this.getTestCosts();
    this.getFastingTests();
    this.GSTFee = this.$GSTFee;
  },

  mounted: function mounted() {
    this.$parent.$children[0].step = this.step;
    this.$parent.$children[0].current = 'health';
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4f77d6e3","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/web/Book/Appointment.vue
var Appointment_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"AppointmentDiv"}},[_c('HeaderVue',{attrs:{"step":"true","tab":"health"}}),_vm._v(" "),_c('div',{staticClass:"portal-section"},[_c('div',{staticClass:"container"},[(_vm.isFasting == 1)?_c('div',{staticClass:"alert alert-info"},[_c('strong',[_vm._v("Info:")]),_vm._v(" One or more of the tests ordered would require fasting. Please make sure you choose a convenient time accordingly.\n          ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-8"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12 col-lg-7",attrs:{"id":"test"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isDateAndTimeChoosed == true),expression:"isDateAndTimeChoosed == true"}],staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"alert alert-success mb-2 drop-shadow",attrs:{"role":"alert"}},[_c('i',{staticClass:"fa fa-check fa-check-circle",attrs:{"aria-hidden":"true"}}),_vm._v(" "+_vm._s(_vm.formatDate(_vm.$localStorage.get('ct').date))+" BETWEEN "+_vm._s(_vm.timeSelected.startTimeDisp)+" to "+_vm._s(_vm.timeSelected.endTimeDisp)+"\n                                     "),_c('a',{staticClass:"pull-right blue-color",on:{"click":function($event){_vm.changeDateAndTime()}}},[_c('i',{staticClass:"fa fa-pencil white-color",attrs:{"aria-hidden":"true"}})])]),_vm._v(" "),(_vm.timeSelected.startTimeDisp && _vm.timeSelected.endTimeDisp && _vm.formatDate(_vm.$localStorage.get('ct').date))?_c('p',{staticClass:"confirm-notification"},[_c('i',{staticClass:"material-icons green-color float-left mr-2"},[_vm._v("check")]),_vm._v(" Our Phlebotomist will visit as per your selected schedule\n                                ")]):_vm._e()])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isDateAndTimeChoosed == false),expression:"isDateAndTimeChoosed == false"}],staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('p',{staticClass:"confirm-notification mb-2 mt-0"},[_vm._v("Select Sample Pickup Date/Time")]),_vm._v(" "),_c('div',{staticClass:"chooseDateTime",attrs:{"id":"accordion","role":"tablist"}},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header blue-label",attrs:{"role":"tab","id":"headingOne"}},[_c('h5',{staticClass:"mb-0"},[_c('a',{staticClass:"white-color",class:{'collapse' :_vm.isDatePickerOpend,'collapsed' :!_vm.isDatePickerOpend},on:{"click":function($event){_vm.openDatePicker()}}},[_vm._m(0,false,false),_vm._v(" "),_c('div',{staticClass:"dateandtime"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-5"},[_c('p',{staticClass:"mt-0 mb-1"},[_vm._v("DATE")]),_vm._v(" "),_c('h5',{staticClass:"m-0"},[_vm._v(_vm._s(_vm.formatDate(_vm.$localStorage.get('ct').date)))])]),_vm._v(" "),(_vm.timeSelected.startTimeDisp && _vm.timeSelected.endTimeDisp)?_c('div',{staticClass:"col-sm-6"},[_c('p',{staticClass:"mt-0 mb-1"},[_vm._v("TIME")]),_vm._v(" "),_c('h5',{staticClass:"m-0"},[_vm._v(_vm._s(_vm.timeSelected.startTimeDisp + ' to ' + _vm.timeSelected.endTimeDisp))])]):_c('div',{staticClass:"col-sm-6"},[_c('p',{staticClass:"mt-0 mb-1"},[_vm._v("Time")]),_vm._v(" "),_c('h5',{staticClass:"m-0"},[_vm._v("HR:MIN")])]),_vm._v(" "),_vm._m(1,false,false)])])])])]),_vm._v(" "),(_vm.isDatePickerOpend)?_c('div',{attrs:{"id":"dateAndTime","role":"tabpanel","aria-labelledby":"headingOne","data-parent":"#accordion"}},[_c('div',{staticClass:"card-body"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.datepicker),expression:"datepicker"}],staticClass:"datepicker-box"},[_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"row"},[_vm._m(2,false,false),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('p',{staticClass:"text-right",on:{"click":function($event){_vm.timepicker=true; _vm.datepicker=false}}},[_c('span',{staticClass:"mt-2"},[_vm._v(" Edit Time")]),_vm._v("\n                                                                   "),_c('i',{staticClass:"material-icons float-right mr-2"},[_vm._v("arrow_forward")])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('datepicker',{attrs:{"inline":true,"value":_vm.dt,"format":'dd/MM/yyyy',"disabled":_vm.disabled},on:{"selected":_vm.dateChange},model:{value:(_vm.dt),callback:function ($$v) {_vm.dt=$$v},expression:"dt"}})],1)])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.timepicker),expression:"timepicker"}],staticClass:"timepicker"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('p',{staticClass:"text-left",on:{"click":function($event){_vm.showhide()}}},[_c('i',{staticClass:"material-icons float-left mr-2"},[_vm._v("keyboard_backspace")]),_vm._v(" "),_c('span',{staticClass:"mt-2"},[_vm._v(" Edit Date")])])]),_vm._v(" "),_vm._m(3,false,false)]),_vm._v(" "),_vm._m(4,false,false),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-4"},[(_vm.availableTimes)?_c('ul',{staticClass:"time-list"},_vm._l((_vm.availableTimes.slice(0, 5)),function(value,index){return _c('li',{key:index,class:{'active':(_vm.timeSelected.startTime === value.startTime) && (_vm.timeSelected.endTime === value.endTime), 'disabled': (value.isEnable === false)}},[(value.isEnable)?_c('label',{staticClass:"time-chips m-0",on:{"click":function($event){_vm.setTime(value)}}},[_vm._v("\n                                                                      "+_vm._s(value.startTimeDisp)+" - "+_vm._s(value.endTimeDisp)+"\n                                                                  ")]):_vm._e(),_vm._v(" "),(!value.isEnable)?_c('label',{staticClass:"time-chips m-0"},[_vm._v("\n                                                                      "+_vm._s(value.startTimeDisp)+" - "+_vm._s(value.endTimeDisp)+"\n                                                                  ")]):_vm._e()])})):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[(_vm.availableTimes)?_c('ul',{staticClass:"time-list"},_vm._l((_vm.availableTimes.slice(5, 10)),function(value,index){return _c('li',{key:index,class:{'active':(_vm.timeSelected.startTime === value.startTime) && (_vm.timeSelected.endTime === value.endTime), 'disabled': (value.isEnable === false)}},[(value.isEnable)?_c('label',{staticClass:"time-chips m-0",on:{"click":function($event){_vm.setTime(value)}}},[_vm._v("\n                                                                      "+_vm._s(value.startTimeDisp)+" - "+_vm._s(value.endTimeDisp)+"\n                                                                  ")]):_vm._e(),_vm._v(" "),(!value.isEnable)?_c('label',{staticClass:"time-chips m-0"},[_vm._v("\n                                                                      "+_vm._s(value.startTimeDisp)+" - "+_vm._s(value.endTimeDisp)+"\n                                                                  ")]):_vm._e()])})):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[(_vm.availableTimes)?_c('ul',{staticClass:"time-list"},_vm._l((_vm.availableTimes.slice(10, 15)),function(value,index){return _c('li',{key:index,class:{'active':((_vm.timeSelected.startTime == value.startTime) && (_vm.timeSelected.endTime == value.endTime)), 'disabled': (value.isEnable === false)}},[(value.isEnable)?_c('label',{staticClass:"time-chips m-0",on:{"click":function($event){_vm.setTime(value)}}},[_vm._v("\n                                                                    "+_vm._s(value.startTimeDisp)+" - "+_vm._s(value.endTimeDisp)+"\n                                                                ")]):_vm._e(),_vm._v(" "),(!value.isEnable)?_c('label',{staticClass:"time-chips m-0",attrs:{"disabled":true}},[_vm._v("\n                                                                    "+_vm._s(value.startTimeDisp)+" - "+_vm._s(value.endTimeDisp)+"\n                                                                ")]):_vm._e()])})):_vm._e()])])])])]):_vm._e()])])])]),_vm._v(" "),_c('div',{staticClass:"lab display-flex no-border p-0 mt-4"},[_c('div',{staticClass:"flex-box"},[_c('div',{staticClass:"lab-logo"},[(_vm.selectedLab.logo && _vm.selectedLab.logo.length > 0)?_c('img',{attrs:{"src":_vm.selectedLab.logo}}):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"flex-box"},[_c('h6',{staticClass:"black-color"},[_vm._v(_vm._s(_vm.selectedLab.labName))]),_vm._v(" "),_c('p',{staticClass:"mt-0 mb-1"},[_vm._v(_vm._s(_vm.selectedLab.branch.branchLocation+', '+_vm.selectedLab.branch.branchCity+' - '+_vm.selectedLab.branch.branchZipCode))]),_vm._v(" "),_c('router-link',{staticClass:"text-uppercase",attrs:{"to":"/lab"}},[_vm._v("Change Lab")]),_vm._v(" | "),_c('router-link',{staticClass:"text-uppercase",attrs:{"to":"/lab"}},[_vm._v("Add test")])],1)])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"table-responsive test-conformation"},[_c('table',{staticClass:"table"},[_vm._m(5,false,false),_vm._v(" "),(_vm.testCosts.priceDetails)?_c('tbody',{staticClass:"black-color"},_vm._l((_vm.testCosts.priceDetails),function(cost,index){return _c('tr',{key:index},[_c('td',[_vm._v(_vm._s(cost.aliasName))]),_vm._v(" "),_c('td',[_c('h5',{staticClass:"float-right mt-1 mb-0 price-tags"},[(cost.actualPrice > cost.ourPrice)?_c('span',{staticClass:"red-color strip-text"},[_vm._v("Rs. "+_vm._s(cost.actualPrice))]):_vm._e(),_vm._v(" Rs. "+_vm._s(cost.ourPrice)+"\n                                              ")])]),_vm._v(" "),_c('td',[_c('button',{staticClass:"btn btn-link remove-btn p-0",on:{"click":function($event){_vm.removeSelectedItems(cost, _vm.$localStorage.get('st'), _vm.$localStorage.get('sl'))}}},[_c('img',{attrs:{"src":"static/images/close-black.svg","alt":"delete"}})])])])})):_vm._e(),_vm._v(" "),_c('tfoot',{staticClass:"border-bottom"},[_c('tr',[_c('td',[_vm._v("Sub Total")]),_vm._v(" "),_c('td',[_c('h5',{staticClass:"float-right mt-1 mb-0 price-tags"},[_vm._v("\n                                                  Rs. "+_vm._s(_vm.payinfo.total)+"\n                                              ")])]),_vm._v(" "),_c('td')])])])])])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"mt-0",attrs:{"id":"accordion","role":"tablist"}},[_c('div',{staticClass:"card"},[_vm._m(6,false,false),_vm._v(" "),_c('div',{staticClass:"collapse",attrs:{"id":"collapseOne","role":"tabpanel","aria-labelledby":"headingOne","data-parent":"#sideBar"}},[_c('div',{staticClass:"card-body pb-0 pt-0"},[_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table price-table"},[_c('tr',[_c('td',{staticClass:"border-bottom"},[_c('span',{staticClass:"black-color"},[_vm._v(_vm._s(_vm.$localStorage.get('sl').labName))]),_c('br'),_vm._v(" "),_c('span',{},[_vm._v(_vm._s(_vm.$localStorage.get('sl').branch.branchLocation + ', ' + _vm.$localStorage.get('sl').branch.branchCity + '-' + _vm.$localStorage.get('sl').branch.branchZipCode))])]),_vm._v(" "),_c('td',{staticClass:"border-bottom"})]),_vm._v(" "),_vm._l((_vm.testCosts.priceDetails),function(cost,index){return _c('tr',{key:index},[_c('td',{staticClass:"black-color border-bottom"},[_vm._v(_vm._s(cost.aliasName))]),_vm._v(" "),_c('td',{staticClass:"text-right black-color border-bottom"},[_vm._v("\n                                                Rs. "+_vm._s(cost.ourPrice)+"\n                                              ")])])})],2)])])]),_vm._v(" "),_c('div',{staticClass:"collapse show",attrs:{"id":"collapseTwo","role":"tabpanel","aria-labelledby":"headingOne","data-parent":"#accordion"}},[_c('div',{staticClass:"card-body pb-0 pt-0"},[_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table price-table"},[_c('tr',[_c('td',[_vm._v("Order Value")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_c('h5',{staticClass:"float-right mt-1 mb-0 price-tags"},[(_vm.payinfo.mrpTotal > _vm.payinfo.total)?_c('span',{staticClass:"red-color strip-text"},[_vm._v("Rs. "+_vm._s(_vm.payinfo.mrpTotal))]):_vm._e(),_vm._v(" Rs. "+_vm._s(_vm.payinfo.total)+"\n                                                ")])])]),_vm._v(" "),_c('tr',{staticClass:"black-color"},[_c('td',[_vm._v("Amount Payable")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_c('h5',{staticClass:"float-right mt-1 mb-0 price-tags"},[(_vm.payinfo.mrpTotal > _vm.payinfo.total)?_c('span',{staticClass:"red-color strip-text"},[_vm._v("Rs. "+_vm._s(_vm.payinfo.mrpTotal))]):_vm._e(),_vm._v(" Rs. "+_vm._s(_vm.payinfo.grandTotal)+"\n                                            ")])])])])])])])])]),_vm._v(" "),(!_vm.$localStorage.get('profile'))?_c('button',{staticClass:"btn full-width mt-4",class:{'btn-secondary': (!_vm.dt || !_vm.timeSelected), 'btn-primary' : !(!_vm.dt || !_vm.timeSelected)},attrs:{"disabled":(!_vm.dt || !_vm.timeSelected),"data-toggle":"modal","data-target":".login-box","data-backdrop":"static","data-keyboard":"false"},on:{"click":function($event){_vm.$root.$emit('appointmentLogin',true); _vm.fbTriggerDate()}}},[_vm._v("Proceed to checkout")]):_c('button',{staticClass:"btn full-width mt-4",class:{'btn-secondary': (!_vm.dt || !_vm.timeSelected), 'btn-primary': !(!_vm.dt || !_vm.timeSelected) },attrs:{"disabled":(!_vm.dt || !_vm.timeSelected)},on:{"click":function($event){_vm.goChooseLocation()}}},[_vm._v("Proceed to checkout")])])])])]),_vm._v(" "),_c('FooterVue')],1)}
var Appointment_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"choose-date"},[_vm._v("\n                                                      CHOOSE DATE / TIME\n                                                      "),_c('i',{staticClass:"material-icons float-right"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-1"},[_c('i',{staticClass:"material-icons float-right"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-8"},[_c('p',{staticClass:"text-right"},[_vm._v("Choose Date")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-6"},[_c('p',{staticClass:"text-left"},[_vm._v("Choose Time Slot")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('hr',{staticClass:"mt-0"}),_vm._v(" "),_c('ul',{staticClass:"key-points"},[_c('li',[_c('span',{staticClass:"circle-point available"}),_vm._v(" Available")]),_vm._v(" "),_c('li',[_c('span',{staticClass:"circle-point booked"}),_vm._v(" Un-Available")]),_vm._v(" "),_c('li',[_c('span',{staticClass:"circle-point selected"}),_vm._v(" Selected Time")])]),_vm._v(" "),_c('hr')])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{staticClass:"no-border"},[_vm._v("Test Name")]),_vm._v(" "),_c('th',{staticClass:"text-right no-border"},[_vm._v("Price")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header",attrs:{"role":"tab","id":"headingOne"}},[_c('h5',{staticClass:"pb-2 mb-0 border-bottom"},[_c('a',{staticClass:"black-color collapsed",attrs:{"data-toggle":"collapse","href":"#collapseOne","aria-expanded":"true","aria-controls":"collapseOne"}},[_vm._v("\n                                      Test Details\n                                      "),_c('i',{staticClass:"material-icons float-right"})])])])}]
var Appointment_esExports = { render: Appointment_render, staticRenderFns: Appointment_staticRenderFns }
/* harmony default export */ var Book_Appointment = (Appointment_esExports);
// CONCATENATED MODULE: ./src/components/web/Book/Appointment.vue
function Appointment_injectStyle (ssrContext) {
  __webpack_require__("NVx5")
}
var Appointment_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var Appointment___vue_template_functional__ = false
/* styles */
var Appointment___vue_styles__ = Appointment_injectStyle
/* scopeId */
var Appointment___vue_scopeId__ = "data-v-4f77d6e3"
/* moduleIdentifier (server only) */
var Appointment___vue_module_identifier__ = null
var Appointment_Component = Appointment_normalizeComponent(
  Appointment,
  Book_Appointment,
  Appointment___vue_template_functional__,
  Appointment___vue_styles__,
  Appointment___vue_scopeId__,
  Appointment___vue_module_identifier__
)

/* harmony default export */ var web_Book_Appointment = (Appointment_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/web/Book/Secure/Address.vue
var Address = __webpack_require__("h91p");

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-79f66a28","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/web/Book/Secure/Address.vue
var Address_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"AddressDiv"}},[_c('HeaderVue',{attrs:{"step":"true","tab":"patient"}}),_vm._v(" "),_c('div',{staticClass:"portal-section"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"alert alert-dark",attrs:{"role":"alert"}},[_vm._v("\n                        Patient Details\n                        "),_c('span',{staticClass:"float-right blue-color  cursor-pointer",on:{"click":function($event){_vm.addMember()}}},[_vm._m(0,false,false),_vm._v(" "),_c('span',{staticClass:"hide-ipad"},[_vm._v("\n                              Add New\n                            ")])])]),_vm._v(" "),(_vm.members)?_c('ul',{staticClass:"patient-list mt-4"},[(_vm.members.user)?_c('li',{class:{'selected-address' : (_vm.members.user.userId === _vm.isMemberActiveId && _vm.isMe === true)}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-8",on:{"click":function($event){_vm.isMemberActiveId = _vm.members.user.userId; _vm.setActiveMemberId(_vm.members.user)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("check_circle")])]),_vm._v(" "),_c('div',{staticClass:"col-2"},[_c('button',{staticClass:"btn btn-link edit-btn p-0 float-right",on:{"click":function($event){_vm.editMemberProfile(1)}}},[_c('img',{attrs:{"src":"static/images/pen-blue.svg","alt":""}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('p',{staticClass:"mt-2 mb-0"},[_vm._v(_vm._s(_vm.members.user.firstName + ' ' + _vm.members.user.lastName))]),_vm._v(" "),(_vm.members.user.age || (_vm.members.user.sex && _vm.members.user.sex.length > 0) )?_c('p',{staticClass:"mb-0"},[_vm._v(_vm._s(_vm.members.user.age)+", "+_vm._s((_vm.members.user.sex==='O'?'Other':((_vm.members.user.sex==='M')?'Male':((_vm.members.user.sex==='F')?'Female':'')))))]):_vm._e(),_vm._v(" "),(_vm.members.user.mobile)?_c('p',[_vm._v("M: "+_vm._s(_vm.members.user.mobile))]):_vm._e()])])]):_vm._e(),_vm._v(" "),_vm._l((_vm.members.family),function(family,index){return _c('li',{key:index,class:{'selected-address' : (family.memberId === _vm.isMemberActiveId && _vm.isMe === false)}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-8",on:{"click":function($event){_vm.isMemberActiveId = family.memberId; _vm.setActiveMemberId(family)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("check_circle")])]),_vm._v(" "),_c('div',{staticClass:"col-2"},[_c('button',{staticClass:"btn btn-link edit-btn p-0 float-right",on:{"click":function($event){_vm.editMember(family)}}},[_c('img',{attrs:{"src":"static/images/pen-blue.svg","alt":""}})])]),_vm._v(" "),((family.memberId !== _vm.isMemberActiveId || _vm.isMe))?_c('div',{staticClass:"col-2",on:{"click":function($event){_vm.deleteMember(family)}}},[_vm._m(1,true,false)]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('p',{staticClass:"mt-2 mb-0"},[_vm._v(_vm._s(family.firstName + ' ' + family.lastName))]),_vm._v(" "),(family.age || (family.sex && family.sex.length > 0) )?_c('p',{staticClass:"mb-0"},[_vm._v(_vm._s(family.age)+", "+_vm._s((family.sex==='O'?'Other':((family.sex==='M')?'Male':((family.sex==='F')?'Female':'')))))]):_vm._e(),_vm._v(" "),(family.mobile)?_c('p',[_vm._v("M: "+_vm._s(family.mobile))]):_vm._e()])])])})],2):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"alert alert-dark",attrs:{"role":"alert"}},[_vm._v("\n                        Pickup Address\n                        "),_c('span',{staticClass:"float-right blue-color cursor-pointer",on:{"click":function($event){_vm.addAddress()}}},[_vm._m(2,false,false),_vm._v(" "),_c('span',{staticClass:"hide-ipad"},[_vm._v("\n                              Add New\n                            ")])])]),_vm._v(" "),(_vm.addresses)?_c('ul',{staticClass:"patient-list mt-4"},_vm._l((_vm.addresses),function(address,index){return _c('li',{key:index,class:{'selected-address' : (address.addressId === _vm.isAddressActiveId)}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-8",on:{"click":function($event){_vm.selectAddress(address)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("check_circle")])]),_vm._v(" "),_c('div',{staticClass:"col-2"},[_c('button',{staticClass:"btn btn-link edit-btn p-0 float-right",on:{"click":function($event){_vm.editAddress(address) }}},[_c('img',{attrs:{"src":"static/images/pen-blue.svg","alt":""}})])]),_vm._v(" "),((address.addressId !== _vm.isAddressActiveId))?_c('div',{staticClass:"col-2",on:{"click":function($event){_vm.deleteAddress(address.addressId)}}},[_vm._m(3,true,false)]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('address',{staticClass:"mt-2"},[_vm._v("\n                                        "+_vm._s(address.flatNo ? address.flatNo +', ' : '')+" "+_vm._s(address.address)+", "+_vm._s(address.landmark ? address.landmark +', ' : '')+" "+_vm._s(address.Location.locationName)+", "),_c('br'),_vm._v(_vm._s(address.City.cityName)+" - "+_vm._s(address.zipCode)+". \n                                    ")])])])])})):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('form',{attrs:{"data-vv-scope":"coupon"},on:{"submit":function($event){$event.preventDefault();_vm.applyCoupon()}}},[(!_vm.isCouponApplied)?_c('div',{staticClass:"input-group mt-0"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.couponCode),expression:"couponCode"},{name:"validate",rawName:"v-validate",value:('required|max:25'),expression:"'required|max:25'"}],staticClass:"form-control text-uppercase",attrs:{"type":"text","name":"couponCode","data-vv-as":"coupon code","placeholder":"Coupon code","aria-label":"Coupon code"},domProps:{"value":(_vm.couponCode)},on:{"keyup":function($event){_vm.couponError='';},"input":function($event){if($event.target.composing){ return; }_vm.couponCode=$event.target.value}}}),_vm._v(" "),_c('span',{staticClass:"input-group-btn"},[_c('button',{staticClass:"btn btn-link",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();_vm.applyCoupon()}}},[_vm._v("Apply")])])]):_vm._e(),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('coupon.couponCode')),expression:"errors.has('coupon.couponCode')"}],staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('coupon.couponCode')))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.errors.has('coupon.couponCode') && _vm.couponError && !_vm.isSuccessCoupon),expression:"!errors.has('coupon.couponCode') && couponError && !isSuccessCoupon"}],class:{'text-danger': !_vm.isSuccessCoupon,'green-color': _vm.isSuccessCoupon}},[_vm._v(_vm._s(_vm.couponError))])]),_vm._v(" "),(_vm.isCouponApplied && _vm.couponData)?_c('div',{staticClass:"input-group mt-0"},[_c('div',{staticClass:"alert alert-success applied-coupon w-100"},[_c('button',{staticClass:"close close-circle",attrs:{"type":"button"},on:{"click":function($event){_vm.removeCoupon()}}},[_c('span',[_vm._v("×")])]),_vm._v(" "),_c('h6',{staticClass:"text-center alert-heading mb-0"},[_vm._v("Applied Coupon :  "),_c('b',[_vm._v(_vm._s(_vm.couponData.coupon_code)+" ")])]),_vm._v(" "),_c('hr',{staticClass:"mt-2 mb-2"}),_vm._v(" "),_c('p',{staticClass:"text-center mb-0"},[_vm._v(_vm._s(_vm.couponError)+" reduced on your order value.")])])]):_vm._e(),_vm._v(" "),(_vm.payinfo.creditPoints && _vm.payinfo.creditPoints > 0)?_c('div',{staticClass:"mt-3",attrs:{"id":"accordion","role":"tablist"}},[_c('div',{staticClass:"card p-3"},[_c('span',{staticClass:"ml-4 green-color"},[_vm._v("Labotist Credits Available = "+_vm._s(_vm.payinfo.creditPoints))]),_vm._v(" "),_c('label',{staticClass:"checkbox_container"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.redeemCredits),expression:"redeemCredits"}],ref:"redeemCredits",attrs:{"type":"checkbox","name":"redeemCredits","id":"redeemCredits","data-vv-as":"redeemCredits"},domProps:{"checked":Array.isArray(_vm.redeemCredits)?_vm._i(_vm.redeemCredits,null)>-1:(_vm.redeemCredits)},on:{"change":[function($event){var $$a=_vm.redeemCredits,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.redeemCredits=$$a.concat([$$v]))}else{$$i>-1&&(_vm.redeemCredits=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.redeemCredits=$$c}},function($event){_vm.termsConditionError=false}]}}),_vm._v(" "),_c('span',{staticClass:"checkbox_checkmark"})]),_vm._v(" "),_c('span',{staticClass:"ml-4"},[_vm._v("I would like to use my Labotist Credits towards this purchase.")])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"mt-3",attrs:{"id":"accordion","role":"tablist"}},[_c('div',{staticClass:"card"},[_vm._m(4,false,false),_vm._v(" "),_c('div',{staticClass:"collapse",attrs:{"id":"collapseOne","role":"tabpanel","aria-labelledby":"headingOne","data-parent":"#sideBar"}},[_c('div',{staticClass:"card-body pb-0 pt-0"},[_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table price-table"},[_c('tr',[_c('td',{staticClass:"border-bottom",attrs:{"colspan":"2"}},[_c('span',{staticClass:"black-color"},[_vm._v(_vm._s(_vm.$localStorage.get('sl').labName))]),_c('br'),_vm._v(" "),_c('span',{},[_vm._v(_vm._s(_vm.$localStorage.get('sl').branch.branchLocation + ', ' + _vm.$localStorage.get('sl').branch.branchCity + '-' + _vm.$localStorage.get('sl').branch.branchZipCode))])])]),_vm._v(" "),_vm._l((_vm.testCosts.priceDetails),function(cost,index){return _c('tr',{key:index},[_c('td',{staticClass:"black-color border-bottom"},[_vm._v(_vm._s(cost.aliasName))]),_vm._v(" "),_c('td',{staticClass:"text-right black-color border-bottom"},[_vm._v("\n                                                  Rs. "+_vm._s(cost.ourPrice)+"\n                                                ")])])})],2)])])]),_vm._v(" "),_c('div',{staticClass:"collapse show",attrs:{"id":"collapseTwo","role":"tabpanel","aria-labelledby":"headingOne","data-parent":"#accordion"}},[_c('div',{staticClass:"card-body pb-0 pt-0"},[_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table price-table"},[_c('tr',[_c('td',[_vm._v("Order Value")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_c('h5',{staticClass:"float-right mt-1 mb-0 price-tags"},[(_vm.payinfo.mrpTotal > _vm.payinfo.total)?_c('span',{staticClass:"red-color strip-text"},[_vm._v("Rs. "+_vm._s(_vm.payinfo.mrpTotal))]):_vm._e(),_vm._v(" Rs. "+_vm._s(_vm.payinfo.total)+"\n                                                  ")])])]),_vm._v(" "),(_vm.payinfo.couponFee > 0)?_c('tr',[_c('td',[_vm._v("Coupon Discount")]),_vm._v(" "),_c('td',{staticClass:"text-right green-color"},[_vm._v("- Rs. "+_vm._s(_vm.payinfo.couponFee))])]):_vm._e(),_vm._v(" "),(_vm.payinfo.mrpTotal != _vm.payinfo.subTotal)?_c('tr',{staticClass:"black-color"},[_c('td',[_vm._v("Sub Total")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("Rs. "+_vm._s(_vm.payinfo.total - _vm.payinfo.couponFee))])]):_vm._e(),_vm._v(" "),(_vm.payinfo.phlebotomistFee > 0)?_c('tr',{staticClass:"black-color"},[_c('td',[_vm._v("Phlebotomist Fee\n                                                   "),_c('i',{staticClass:"fa fa-info-circle",attrs:{"aria-hidden":"true","data-toggle":"tooltip","data-placement":"top","title":'This price is applicable when the order value is below Rs.'+_vm.payinfo.waiverDiscountApplyFee}})]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("Rs. "+_vm._s(_vm.payinfo.phlebotomistFee))])]):_vm._e(),_vm._v(" "),(_vm.redeemCreditPoints > 0)?_c('tr',[_c('td',[_vm._v("Credits Applied")]),_vm._v(" "),_c('td',{staticClass:"text-right green-color"},[_vm._v("- Rs. "+_vm._s(_vm.redeemCreditPoints))])]):_vm._e(),_vm._v(" "),(_vm.payinfo.phlebotomyFeeWaiver > 0)?_c('tr',{staticClass:"black-color"},[_c('td',[_vm._v("Coupon Discount")]),_vm._v(" "),_c('td',{staticClass:"text-right green-color"},[_vm._v("-Rs. "+_vm._s(_vm.payinfo.phlebotomyFeeWaiver))])]):_vm._e(),_vm._v(" "),_c('tr',{staticClass:"black-color"},[_c('td',[_vm._v("Amount Payable")]),_vm._v(" "),_c('td',[_c('h5',{staticClass:"float-right mt-1 mb-0 price-tags"},[(_vm.payinfo.mrpTotal > _vm.payinfo.total)?_c('span',{staticClass:"red-color strip-text"},[_vm._v("Rs. "+_vm._s(_vm.payinfo.grandTotalStrike))]):_vm._e(),_vm._v(" Rs. "+_vm._s(_vm.payinfo.grandTotal-_vm.redeemCreditPoints)+"\n                                                  ")])])])])])])])])]),_vm._v(" "),(_vm.$cashPayment && (_vm.payinfo.grandTotal - _vm.redeemCreditPoints) > 0)?_c('div',{staticClass:"mt-3",attrs:{"id":"accordion","role":"tablist"}},[_c('div',{staticClass:"card"},[_vm._m(5,false,false),_vm._v(" "),_c('div',{staticClass:"pl-3 pb-3"},[_c('label',{staticClass:"checkbox_container mr-5"},[_vm._v("Online\n                            "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.paymentType),expression:"paymentType"}],ref:"paymentType",attrs:{"type":"radio","name":"paymentType","id":"paymentType","data-vv-as":"paymentType","value":"1"},domProps:{"checked":_vm._q(_vm.paymentType,"1")},on:{"change":function($event){_vm.paymentType="1"}}}),_vm._v(" "),_c('span',{staticClass:"checkbox_checkmark"})]),_vm._v(" "),_c('label',{staticClass:"checkbox_container"},[_vm._v("Cash\n                            "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.paymentType),expression:"paymentType"}],ref:"paymentType",attrs:{"type":"radio","name":"paymentType","id":"paymentType","data-vv-as":"paymentType","value":"2"},domProps:{"checked":_vm._q(_vm.paymentType,"2")},on:{"change":function($event){_vm.paymentType="2"}}}),_vm._v(" "),_c('span',{staticClass:"checkbox_checkmark"})])])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"mt-3",attrs:{"id":"accordion","role":"tablist"}},[_c('div',{staticClass:"card p-3"},[_c('label',{staticClass:"checkbox_container"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.termsCondition),expression:"termsCondition"}],ref:"termsCondition",attrs:{"type":"checkbox","name":"termsCondition","id":"termsCondition","data-vv-as":"termsCondition"},domProps:{"checked":Array.isArray(_vm.termsCondition)?_vm._i(_vm.termsCondition,null)>-1:(_vm.termsCondition)},on:{"change":[function($event){var $$a=_vm.termsCondition,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.termsCondition=$$a.concat([$$v]))}else{$$i>-1&&(_vm.termsCondition=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.termsCondition=$$c}},function($event){_vm.termsConditionError=false}]}}),_vm._v(" "),_c('span',{staticClass:"checkbox_checkmark"})]),_vm._v(" "),_c('span',{staticClass:"ml-4"},[_vm._v("I have read and agree to the Labotist "),_c('span',{staticClass:"termsCondition",on:{"click":function($event){_vm.termsConditionChanged(2)}}},[_vm._v("Terms of Service")]),_vm._v(" and "),_c('span',{staticClass:"termsCondition",on:{"click":function($event){_vm.termsConditionChanged(3)}}},[_vm._v("Privacy Policy")]),_vm._v("?")]),_vm._v(" "),(_vm.termsConditionError)?_c('span',{staticClass:"text-danger fs-12"},[_vm._v("Please agree terms & condition to complete payment")]):_vm._e()])]),_vm._v(" "),((_vm.payinfo.grandTotal - _vm.redeemCreditPoints) > 0)?_c('button',{staticClass:"btn btn-primary full-width mt-4",on:{"click":function($event){$event.preventDefault();if($event.target !== $event.currentTarget){ return null; }_vm.goPayment()}}},[_vm._v(_vm._s(_vm.paymentType == 2 ? 'Complete Request' : ('Pay Rs.'+(_vm.payinfo.grandTotal - _vm.redeemCreditPoints))))]):_vm._e(),_vm._v(" "),((_vm.payinfo.grandTotal - _vm.redeemCreditPoints) == 0)?_c('button',{staticClass:"btn btn-primary full-width mt-4",on:{"click":function($event){$event.preventDefault();if($event.target !== $event.currentTarget){ return null; }_vm.goPayment(true)}}},[_vm._v("Complete Request")]):_vm._e()])])])]),_vm._v(" "),_c('FooterVue'),_vm._v(" "),_c('div',{staticClass:"modal fade bd-example-modal-lg",attrs:{"id":"addAddressModal","tabindex":"-1","role":"dialog","aria-labelledby":"exampleModalLabel","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog ",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_vm._m(6,false,false),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('form',{attrs:{"data-vv-scope":"addAddress"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"clearfix line-textbox"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],staticClass:"form-group"},[_c('label',[_vm._v("Full name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.addAddressFields.addressName),expression:"addAddressFields.addressName"},{name:"validate",rawName:"v-validate",value:('required|alpha_spaces'),expression:"'required|alpha_spaces'"}],staticClass:"form-control",attrs:{"type":"text","name":"fullName","id":"fullName","maxlength":"100","data-vv-as":"full name"},domProps:{"value":(_vm.addAddressFields.addressName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.addAddressFields, "addressName", $event.target.value)}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('addAddress.fullName')),expression:"errors.has('addAddress.fullName')"}],staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('addAddress.fullName')))])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Flat No, Floor and Apt Name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.addAddressFields.flatNo),expression:"addAddressFields.flatNo"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"form-control",attrs:{"type":"text","name":"flatNo","id":"flatNo","data-vv-as":"flatNo","maxlength":"500"},domProps:{"value":(_vm.addAddressFields.flatNo)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.addAddressFields, "flatNo", $event.target.value)}}}),_vm._v(" "),_c('small',[_vm._v("Ex : 3/123, 2nd Floor, XXXX apt")]),_c('br'),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('addAddress.flatNo')),expression:"errors.has('addAddress.flatNo')"}],staticClass:"text-danger"},[_vm._v("Flat No, Floor and Apt Name is required.")])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Street Address")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.addAddressFields.address),expression:"addAddressFields.address"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"form-control",attrs:{"type":"text","name":"address","id":"address","data-vv-as":"address"},domProps:{"value":(_vm.addAddressFields.address)},on:{"blur":function($event){_vm.addressChanged(1)},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.addAddressFields, "address", $event.target.value)}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('addAddress.address')),expression:"errors.has('addAddress.address')"}],staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('addAddress.address')))])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_vm._m(7,false,false),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.addAddressFields.landmark),expression:"addAddressFields.landmark"}],staticClass:"form-control",attrs:{"type":"text","name":"landmark","id":"landmark","data-vv-as":"landmark","maxlength":"300"},domProps:{"value":(_vm.addAddressFields.landmark)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.addAddressFields, "landmark", $event.target.value)}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('addAddress.landmark')),expression:"errors.has('addAddress.landmark')"}],staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('addAddress.landmark')))])]),_vm._v(" "),_c('div',{staticClass:"form-group address-locality-search"},[_vm._m(8,false,false),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.addAddressFields.zipcode),expression:"addAddressFields.zipcode"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],ref:"pincodeAdd",staticClass:"form-control",attrs:{"type":"text","name":"zipcode","id":"zipcode","data-vv-as":"zipcode","aria-label":"","list":"mycarousel","autocomplete":"off","minlength":"3"},domProps:{"value":(_vm.addAddressFields.zipcode)},on:{"keyup":[function($event){_vm.searchLocality(2)},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }_vm.searchLocality(2)}],"blur":function($event){_vm.closeBlock()},"focus":function($event){_vm.$refs.pincodeAdd.select();_vm.searchtext=''},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.addAddressFields, "zipcode", $event.target.value)}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('addAddress.zipcode')),expression:"errors.has('addAddress.zipcode')"}],staticClass:"text-danger"},[_vm._v("The Locality/Pincode field is required")]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.isInvalidPincode),expression:"isInvalidPincode"}],staticClass:"text-danger"},[_vm._v("Please choose Locality/Pincode")]),_vm._v(" "),_c('div',{staticClass:"test-option full-width scrollbar locality",style:({ display: _vm.onBlurKey})},[_c('div',{staticClass:"popular-test focus-search p-0"},[_c('ul',{staticClass:"p-0 m-0"},[_vm._l((_vm.locationList),function(item,index){return _c('li',{key:index,staticClass:"p-2",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.selectLocation($event, item, 2)}}},[_vm._v("\n                                                "+_vm._s(item.locationName+'-'+item.locationZipCode)+"\n                                            ")])}),_vm._v(" "),(_vm.locationList.length === 0)?_c('li',{staticClass:"p-2 color-blue text-center",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.selectLocation($event, undefined, 3)}}},[_vm._v("\n                                                Other\n                                            ")]):_vm._e(),_vm._v(" "),(_vm.locationList.length !== 0)?_c('li',{staticClass:"p-2 color-blue ",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.selectLocation($event, undefined, 3)}}},[_vm._v("\n                                                Other\n                                            ")]):_vm._e()],2)])])]),_vm._v(" "),(_vm.showLocOther)?_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("New Pincode")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.addAddressFields.locationPincode),expression:"addAddressFields.locationPincode"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"form-control",attrs:{"type":"text","name":"locationPincode","id":"locationPincode","maxlength":"6"},domProps:{"value":(_vm.addAddressFields.locationPincode)},on:{"blur":function($event){_vm.addressChanged(1)},"keypress":_vm.isNumberEdit,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.addAddressFields, "locationPincode", $event.target.value)}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('addAddress.locationPincode')),expression:"errors.has('addAddress.locationPincode')"}],staticClass:"text-danger"},[_vm._v("The Pincode field is required.")])]):_vm._e(),_vm._v(" "),(_vm.showLocOther)?_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("New Location")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.addAddressFields.locationOther),expression:"addAddressFields.locationOther"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"form-control",attrs:{"type":"text","name":"locationOther","id":"locationOther"},domProps:{"value":(_vm.addAddressFields.locationOther)},on:{"blur":function($event){_vm.addressChanged(1)},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.addAddressFields, "locationOther", $event.target.value)}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('addAddress.locationOther')),expression:"errors.has('addAddress.locationOther')"}],staticClass:"text-danger"},[_vm._v("The Location field is required.")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('p',{staticClass:"black-color"},[_c('span',[_vm._v(_vm._s(_vm.stateCityDisp))])])])])]),_vm._v(" "),_vm._m(9,false,false)]),_vm._v(" "),_c('div',{staticClass:"row mmt-3"},[_c('div',{staticClass:"col-sm-6"},[_c('a',{staticClass:"btn btn-link full-width",on:{"click":function($event){_vm.cancelModalPopup()}}},[_vm._v("Cancel")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('button',{staticClass:"btn btn-primary full-width",attrs:{"type":"button"},on:{"click":function($event){_vm.saveAddress()}}},[_vm._v("Save")])])])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal fade bd-example-modal-lg",attrs:{"id":"editAddressModal","tabindex":"-1","role":"dialog","aria-labelledby":"exampleModalLabel","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_vm._m(10,false,false),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('form',{attrs:{"data-vv-scope":"editAddress"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"clearfix line-textbox"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],staticClass:"form-group"},[_c('label',[_vm._v("Full name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.editAddressFields.addressName),expression:"editAddressFields.addressName"},{name:"validate",rawName:"v-validate",value:('required|alpha_spaces'),expression:"'required|alpha_spaces'"}],staticClass:"form-control",attrs:{"type":"text","name":"fullName","id":"fullName","maxlength":"100","data-vv-as":"full name"},domProps:{"value":(_vm.editAddressFields.addressName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.editAddressFields, "addressName", $event.target.value)}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('editAddress.fullName')),expression:"errors.has('editAddress.fullName')"}],staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('editAddress.fullName')))])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Flat No, Floor and Apt Name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.editAddressFields.flatNo),expression:"editAddressFields.flatNo"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"form-control",attrs:{"type":"text","name":"flatNo","id":"flatNo","data-vv-as":"flatNo"},domProps:{"value":(_vm.editAddressFields.flatNo)},on:{"blur":function($event){_vm.addressChanged(2)},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.editAddressFields, "flatNo", $event.target.value)}}}),_vm._v(" "),_c('small',[_vm._v("Ex : 3/123, 2nd Floor, XXXX apt")]),_c('br'),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('editAddress.flatNo')),expression:"errors.has('editAddress.flatNo')"}],staticClass:"text-danger"},[_vm._v("Flat No, Floor and Apt Name is required.")])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Street Address")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.editAddressFields.address),expression:"editAddressFields.address"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"form-control",attrs:{"type":"text","name":"address","id":"address","data-vv-as":"address"},domProps:{"value":(_vm.editAddressFields.address)},on:{"blur":function($event){_vm.addressChanged(2)},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.editAddressFields, "address", $event.target.value)}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('editAddress.address')),expression:"errors.has('editAddress.address')"}],staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('editAddress.address')))])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_vm._m(11,false,false),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.editAddressFields.landmark),expression:"editAddressFields.landmark"}],staticClass:"form-control",attrs:{"type":"text","name":"landmark","id":"landmark","data-vv-as":"landmark"},domProps:{"value":(_vm.editAddressFields.landmark)},on:{"blur":function($event){_vm.addressChanged(2)},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.editAddressFields, "landmark", $event.target.value)}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('editAddress.landmark')),expression:"errors.has('editAddress.landmark')"}],staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('editAddress.landmark')))])]),_vm._v(" "),_c('div',{staticClass:"form-group address-locality-search"},[_vm._m(12,false,false),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.editAddressFields.zipcode),expression:"editAddressFields.zipcode"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],ref:"pincodeEdit",staticClass:"form-control",attrs:{"type":"text","name":"zipcode","id":"zipcode","data-vv-as":"zipcode","aria-label":"","list":"mycarousel","autocomplete":"off","minlength":"3"},domProps:{"value":(_vm.editAddressFields.zipcode)},on:{"keyup":[function($event){_vm.searchLocality(1)},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }_vm.searchLocality(1)}],"blur":function($event){_vm.closeBlock()},"focus":function($event){_vm.$refs.pincodeEdit.select();_vm.searchtext=''},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.editAddressFields, "zipcode", $event.target.value)}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('editAddress.zipcode')),expression:"errors.has('editAddress.zipcode')"}],staticClass:"text-danger"},[_vm._v("The Locality/Pincode field is required")]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.isInvalidPincode),expression:"isInvalidPincode"}],staticClass:"text-danger"},[_vm._v("Please choose Locality/Pincode")]),_vm._v(" "),_c('div',{staticClass:"test-option full-width scrollbar locality",style:({ display: _vm.onBlurKey})},[_c('div',{staticClass:"popular-test focus-search p-0"},[_c('ul',{staticClass:"p-0 m-0"},[_vm._l((_vm.locationList),function(item,index){return _c('li',{key:index,staticClass:"p-2",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.selectLocation($event, item, 1)}}},[_vm._v("\n                                                "+_vm._s(item.locationName+'-'+item.locationZipCode)+"\n                                            ")])}),_vm._v(" "),(_vm.locationList.length === 0)?_c('li',{staticClass:"p-2 color-blue text-center",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.selectLocation($event, undefined, 3)}}},[_vm._v("\n                                                Other\n                                            ")]):_vm._e(),_vm._v(" "),(_vm.locationList.length !== 0)?_c('li',{staticClass:"p-2 color-blue ",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.selectLocation($event, undefined, 3)}}},[_vm._v("\n                                                Other\n                                            ")]):_vm._e()],2)])])]),_vm._v(" "),(_vm.showLocOther)?_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("New Pincode")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.editAddressFields.locationPincode),expression:"editAddressFields.locationPincode"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"form-control",attrs:{"type":"text","name":"locationPincode","id":"locationPincode","maxlength":"6"},domProps:{"value":(_vm.editAddressFields.locationPincode)},on:{"blur":function($event){_vm.addressChanged(2)},"keypress":_vm.isNumberEdit,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.editAddressFields, "locationPincode", $event.target.value)}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('editAddress.locationPincode')),expression:"errors.has('editAddress.locationPincode')"}],staticClass:"text-danger"},[_vm._v("The Pincode field is required.")])]):_vm._e(),_vm._v(" "),(_vm.showLocOther)?_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("New Location")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.editAddressFields.locationOther),expression:"editAddressFields.locationOther"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"form-control",attrs:{"type":"text","name":"locationOther","id":"locationOther"},domProps:{"value":(_vm.editAddressFields.locationOther)},on:{"blur":function($event){_vm.addressChanged(2)},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.editAddressFields, "locationOther", $event.target.value)}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('editAddress.locationOther')),expression:"errors.has('editAddress.locationOther')"}],staticClass:"text-danger"},[_vm._v("The Location field is required.")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.stateCityDisp))])])])]),_vm._v(" "),_vm._m(13,false,false)]),_vm._v(" "),_c('div',{staticClass:"row mmt-3"},[_c('div',{staticClass:"col-sm-6"},[_c('a',{staticClass:"btn btn-link full-width",on:{"click":function($event){_vm.cancelModalPopup()}}},[_vm._v("Cancel")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('button',{staticClass:"btn btn-primary full-width",attrs:{"type":"button"},on:{"click":function($event){_vm.updateAddress()}}},[_vm._v("Update")])])])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal fade bd-example-modal-lg",attrs:{"id":"editMemberProfileModal","tabindex":"-1","role":"dialog","aria-labelledby":"exampleModalLabel","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog  modal-lg",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_vm._m(14,false,false),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('form',{attrs:{"data-vv-scope":"edit"}},[_c('div',{staticClass:"clearfix mt-4"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("First Name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.editMemberObj.firstName),expression:"editMemberObj.firstName"},{name:"validate",rawName:"v-validate",value:('required|alpha_spaces|min:3|max:50'),expression:"'required|alpha_spaces|min:3|max:50'"}],staticClass:"form-control",attrs:{"type":"text","name":"firstName","data-vv-as":"first name","maxlength":"50"},domProps:{"value":(_vm.editMemberObj.firstName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.editMemberObj, "firstName", $event.target.value)}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('edit.firstName')),expression:"errors.has('edit.firstName')"}],staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('edit.firstName')))])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Last Name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.editMemberObj.lastName),expression:"editMemberObj.lastName"},{name:"validate",rawName:"v-validate",value:('required|alpha_spaces|min:3|max:50'),expression:"'required|alpha_spaces|min:3|max:50'"}],staticClass:"form-control",attrs:{"name":"lastName","type":"text","data-vv-as":"last name","maxlength":"50"},domProps:{"value":(_vm.editMemberObj.lastName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.editMemberObj, "lastName", $event.target.value)}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('edit.lastName')),expression:"errors.has('edit.lastName')"}],staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('edit.lastName')))])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Gender")]),_vm._v(" "),_c('div',{staticClass:"form-check form-check-inline",staticStyle:{"margin-top":"15px","margin-bottom":"0px"}},[_c('label',{staticClass:"form-check-label"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.editMemberObj.sex),expression:"editMemberObj.sex"}],staticClass:"form-check-input",attrs:{"type":"radio","name":"gender","id":"inlineRadio1","value":"M"},domProps:{"checked":(_vm.editMemberObj.sex === 'M')?true:false,"checked":_vm._q(_vm.editMemberObj.sex,"M")},on:{"change":function($event){_vm.$set(_vm.editMemberObj, "sex", "M")}}}),_vm._v(" Male\n                                            ")])]),_vm._v(" "),_c('div',{staticClass:"form-check form-check-inline",staticStyle:{"margin-top":"15px","margin-bottom":"0px"}},[_c('label',{staticClass:"form-check-label"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.editMemberObj.sex),expression:"editMemberObj.sex"}],staticClass:"form-check-input",attrs:{"type":"radio","name":"gender","id":"inlineRadio2","value":"F"},domProps:{"checked":(_vm.editMemberObj.sex === 'F')?true:false,"checked":_vm._q(_vm.editMemberObj.sex,"F")},on:{"change":function($event){_vm.$set(_vm.editMemberObj, "sex", "F")}}}),_vm._v(" Female\n                                            ")])]),_vm._v(" "),_c('div',{staticClass:"form-check form-check-inline",staticStyle:{"margin-top":"15px","margin-bottom":"0px"}},[_c('label',{staticClass:"form-check-label"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.editMemberObj.sex),expression:"editMemberObj.sex"}],staticClass:"form-check-input",attrs:{"type":"radio","name":"gender","id":"inlineRadio3","value":"O"},domProps:{"checked":(_vm.editMemberObj.sex === 'O')?true:false,"checked":_vm._q(_vm.editMemberObj.sex,"O")},on:{"change":function($event){_vm.$set(_vm.editMemberObj, "sex", "O")}}}),_vm._v(" Other\n                                            ")])])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Date of birth")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-4"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.year),expression:"year"}],staticClass:"form-control",attrs:{"name":"year","id":"year"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.year=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){_vm.getNumberOfDays()}]}},[_c('option',{staticClass:"dobOptionColor",attrs:{"value":"","disabled":"","selected":""}},[_vm._v("YYYY")]),_vm._v(" "),_vm._l((_vm.dobYears),function(dobYear,index){return _c('option',{key:index,domProps:{"value":dobYear}},[_vm._v(_vm._s(dobYear))])})],2)]),_vm._v(" "),_c('div',{staticClass:"col-4"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.month),expression:"month"}],staticClass:"form-control",attrs:{"name":"month","id":"month"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.month=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){_vm.getNumberOfDays()}]}},[_c('option',{staticClass:"dobOptionColor",attrs:{"value":"","disabled":"","selected":""}},[_vm._v("MMM")]),_vm._v(" "),_c('option',{attrs:{"value":"01"}},[_vm._v("Jan")]),_vm._v(" "),_c('option',{attrs:{"value":"02"}},[_vm._v("Feb")]),_vm._v(" "),_c('option',{attrs:{"value":"03"}},[_vm._v("Mar")]),_vm._v(" "),_c('option',{attrs:{"value":"04"}},[_vm._v("Apr")]),_vm._v(" "),_c('option',{attrs:{"value":"05"}},[_vm._v("May")]),_vm._v(" "),_c('option',{attrs:{"value":"06"}},[_vm._v("Jun")]),_vm._v(" "),_c('option',{attrs:{"value":"07"}},[_vm._v("Jul")]),_vm._v(" "),_c('option',{attrs:{"value":"08"}},[_vm._v("Aug")]),_vm._v(" "),_c('option',{attrs:{"value":"09"}},[_vm._v("Sep")]),_vm._v(" "),_c('option',{attrs:{"value":"10"}},[_vm._v("Oct")]),_vm._v(" "),_c('option',{attrs:{"value":"11"}},[_vm._v("Nov")]),_vm._v(" "),_c('option',{attrs:{"value":"12"}},[_vm._v("Dec")])])]),_vm._v(" "),_c('div',{staticClass:"col-4"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.ddate),expression:"ddate"}],staticClass:"form-control",attrs:{"name":"ddate","id":"ddate"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.ddate=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{staticClass:"dobOptionColor",attrs:{"value":"","disabled":"","selected":""}},[_vm._v("DD")]),_vm._v(" "),_vm._l((_vm.dobDate),function(dobDateVal,index){return _c('option',{key:index,domProps:{"value":dobDateVal ? (parseInt(dobDateVal) < 10 ? '0'+dobDateVal : dobDateVal) : ''}},[_vm._v(_vm._s(dobDateVal ? (parseInt(dobDateVal) < 10 ? '0'+dobDateVal : dobDateVal) : ''))])})],2)]),_vm._v(" "),_c('div',{staticClass:"col-sm-12"},[(_vm.isDobError)?_c('span',{staticClass:"text-danger"},[_vm._v("The date of birth field is required")]):_vm._e()])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Mobile")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.editMemberObj.phone1),expression:"editMemberObj.phone1"},{name:"validate",rawName:"v-validate",value:('required|numeric|min:10|max:10'),expression:"'required|numeric|min:10|max:10'"}],staticClass:"form-control",attrs:{"type":"text","name":"phone1","data-vv-as":"mobile no."},domProps:{"value":(_vm.editMemberObj.phone1)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.editMemberObj, "phone1", $event.target.value)}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('edit.phone1')),expression:"errors.has('edit.phone1')"}],staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('edit.phone1')))])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Alternate Phone No.")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.editMemberObj.phone2),expression:"editMemberObj.phone2"},{name:"validate",rawName:"v-validate",value:('numeric|min:10|max:10'),expression:"'numeric|min:10|max:10'"}],staticClass:"form-control",attrs:{"type":"text","name":"phone2","data-vv-as":"alternate phone no."},domProps:{"value":(_vm.editMemberObj.phone2)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.editMemberObj, "phone2", $event.target.value)}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('edit.phone2')),expression:"errors.has('edit.phone2')"}],staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('edit.phone2')))])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Email")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.editMemberObj.email),expression:"editMemberObj.email"},{name:"validate",rawName:"v-validate",value:('required|email|max:100'),expression:"'required|email|max:100'"}],staticClass:"form-control",staticStyle:{"background-color":"#fff","cursor":"not-allowed"},attrs:{"type":"email","name":"email","data-vv-as":"email address","disabled":true},domProps:{"value":(_vm.editMemberObj.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.editMemberObj, "email", $event.target.value)}}}),_vm._v(" "),_c('i',{staticClass:"fa",staticStyle:{"font-size":"18px","color":"#000","text-align":"right","float":"right","margin-top":"-25px","margin-right":"10px"}},[_vm._v("")]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('edit.email')),expression:"errors.has('edit.email')"}],staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('edit.email')))])])])])]),_vm._v(" "),_c('div',{staticClass:"row mt-3"},[_c('div',{staticClass:"col-sm-6"}),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('a',{staticClass:"btn btn-link full-width",on:{"click":function($event){_vm.cancelMember(1)}}},[_vm._v("Cancel")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('button',{staticClass:"btn btn-primary full-width",attrs:{"disabled":(_vm.errors.any())},on:{"click":function($event){$event.preventDefault();_vm.saveProfile()}}},[_vm._v("Update")])])])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal fade bd-example-modal-sm",attrs:{"id":"editPatientProfileModal","tabindex":"-1","role":"dialog","aria-labelledby":"exampleModalLabel","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog  modal-sm",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_vm._m(15,false,false),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('form',{attrs:{"data-vv-scope":"editMember"},on:{"submit":function($event){$event.preventDefault();_vm.updateMember($event)}}},[_c('div',{staticClass:"clearfix mt-4 line-textbox"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Patient First Name*")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.editMemberFields.firstName),expression:"editMemberFields.firstName"},{name:"validate",rawName:"v-validate",value:('required|alpha_spaces|max:50'),expression:"'required|alpha_spaces|max:50'"}],ref:"editMemberFirstName",staticClass:"form-control",attrs:{"type":"text","name":"firstName","id":"firstName","maxlength":"50","data-vv-as":"first name"},domProps:{"value":(_vm.editMemberFields.firstName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.editMemberFields, "firstName", $event.target.value)}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('editMember.firstName')),expression:"errors.has('editMember.firstName')"}],staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('editMember.firstName')))])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Patient Last Name*")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.editMemberFields.lastName),expression:"editMemberFields.lastName"},{name:"validate",rawName:"v-validate",value:('required|alpha_spaces|max:50'),expression:"'required|alpha_spaces|max:50'"}],staticClass:"form-control",attrs:{"type":"text","name":"lastName","id":"lastName","maxlength":"50","data-vv-as":"last name"},domProps:{"value":(_vm.editMemberFields.lastName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.editMemberFields, "lastName", $event.target.value)}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('editMember.lastName')),expression:"errors.has('editMember.lastName')"}],staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('editMember.lastName')))])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Mobile*")]),_vm._v(" "),_c('input',{directives:[{name:"mask",rawName:"v-mask",value:('##########'),expression:"'##########'"},{name:"model",rawName:"v-model",value:(_vm.editMemberFields.mobile),expression:"editMemberFields.mobile"},{name:"validate",rawName:"v-validate",value:('required|numeric|min:10|max:10'),expression:"'required|numeric|min:10|max:10'"}],staticClass:"form-control",attrs:{"type":"text","name":"mobile","id":"mobile","maxlength":"50","data-vv-as":"last name"},domProps:{"value":(_vm.editMemberFields.mobile)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.editMemberFields, "mobile", $event.target.value)}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('editMember.mobile')),expression:"errors.has('editMember.mobile')"}],staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('editMember.mobile')))])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Gender*")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"form-check form-check-inline"},[_c('label',{staticClass:"form-check-label"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.editMemberFields.sex),expression:"editMemberFields.sex"}],staticClass:"form-check-input",attrs:{"type":"radio","name":"gender","id":"inlineRadio1","value":"M"},domProps:{"checked":_vm._q(_vm.editMemberFields.sex,"M")},on:{"change":function($event){_vm.$set(_vm.editMemberFields, "sex", "M")}}}),_vm._v(" Male\n                                  ")])]),_vm._v(" "),_c('div',{staticClass:"form-check form-check-inline"},[_c('label',{staticClass:"form-check-label"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.editMemberFields.sex),expression:"editMemberFields.sex"}],staticClass:"form-check-input",attrs:{"type":"radio","name":"gender","id":"inlineRadio2","value":"F"},domProps:{"checked":_vm._q(_vm.editMemberFields.sex,"F")},on:{"change":function($event){_vm.$set(_vm.editMemberFields, "sex", "F")}}}),_vm._v(" Female\n                                  ")])]),_vm._v(" "),_c('div',{staticClass:"form-check form-check-inline"},[_c('label',{staticClass:"form-check-label"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.editMemberFields.sex),expression:"editMemberFields.sex"}],staticClass:"form-check-input",attrs:{"type":"radio","name":"gender","id":"inlineRadio2","value":"O"},domProps:{"checked":_vm._q(_vm.editMemberFields.sex,"O")},on:{"change":function($event){_vm.$set(_vm.editMemberFields, "sex", "O")}}}),_vm._v(" Other\n                                  ")])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Age*")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.editMemberFields.age),expression:"editMemberFields.age"},{name:"validate",rawName:"v-validate",value:('required|numeric|max:2'),expression:"'required|numeric|max:2'"}],staticClass:"form-control",attrs:{"type":"text","name":"age","id":"age","data-vv-as":"age"},domProps:{"value":(_vm.editMemberFields.age)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.editMemberFields, "age", $event.target.value)}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('editMember.age')),expression:"errors.has('editMember.age')"}],staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('editMember.age')))])])]),_vm._v(" "),_c('div',{staticClass:"row mt-3"},[_c('div',{staticClass:"col-sm-6"},[_c('a',{staticClass:"btn btn-link full-width",on:{"click":function($event){_vm.cancelMember(2)}}},[_vm._v("Cancel")])]),_vm._v(" "),_vm._m(16,false,false)])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal fade bd-example-modal-sm",attrs:{"id":"addPatientProfileModal","tabindex":"-1","role":"dialog","aria-labelledby":"exampleModalLabel","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog  modal-sm",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_vm._m(17,false,false),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('form',{attrs:{"data-vv-scope":"addMember"},on:{"submit":function($event){$event.preventDefault();_vm.saveMember($event)}}},[_c('div',{staticClass:"clearfix mt-4 line-textbox"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Patient First Name*")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.addMemberFields.firstName),expression:"addMemberFields.firstName"},{name:"validate",rawName:"v-validate",value:('required|alpha_spaces|max:50'),expression:"'required|alpha_spaces|max:50'"}],staticClass:"form-control",attrs:{"type":"text","name":"firstName","id":"firstName","maxlength":"50","data-vv-as":"first name"},domProps:{"value":(_vm.addMemberFields.firstName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.addMemberFields, "firstName", $event.target.value)}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('addMember.firstName')),expression:"errors.has('addMember.firstName')"}],staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('addMember.firstName')))])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Patient Last Name*")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.addMemberFields.lastName),expression:"addMemberFields.lastName"},{name:"validate",rawName:"v-validate",value:('required|alpha_spaces|max:50'),expression:"'required|alpha_spaces|max:50'"}],staticClass:"form-control",attrs:{"type":"text","name":"lastName","id":"lastName","maxlength":"50","data-vv-as":"last name"},domProps:{"value":(_vm.addMemberFields.lastName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.addMemberFields, "lastName", $event.target.value)}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('addMember.lastName')),expression:"errors.has('addMember.lastName')"}],staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('addMember.lastName')))])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Mobile*")]),_vm._v(" "),_c('input',{directives:[{name:"mask",rawName:"v-mask",value:('##########'),expression:"'##########'"},{name:"model",rawName:"v-model",value:(_vm.addMemberFields.mobile),expression:"addMemberFields.mobile"},{name:"validate",rawName:"v-validate",value:('required|numeric|min:10|max:10'),expression:"'required|numeric|min:10|max:10'"}],staticClass:"form-control",attrs:{"type":"text","name":"mobile","id":"mobile","maxlength":"50","data-vv-as":"mobile"},domProps:{"value":(_vm.addMemberFields.mobile)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.addMemberFields, "mobile", $event.target.value)}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('addMember.mobile')),expression:"errors.has('addMember.mobile')"}],staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('addMember.mobile')))])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Gender*")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"form-check form-check-inline"},[_c('label',{staticClass:"form-check-label"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.addMemberFields.sex),expression:"addMemberFields.sex"}],staticClass:"form-check-input",attrs:{"type":"radio","name":"gender","id":"inlineRadio1","value":"M"},domProps:{"checked":_vm._q(_vm.addMemberFields.sex,"M")},on:{"change":function($event){_vm.$set(_vm.addMemberFields, "sex", "M")}}}),_vm._v(" Male\n                                    ")])]),_vm._v(" "),_c('div',{staticClass:"form-check form-check-inline"},[_c('label',{staticClass:"form-check-label"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.addMemberFields.sex),expression:"addMemberFields.sex"}],staticClass:"form-check-input",attrs:{"type":"radio","name":"gender","id":"inlineRadio2","value":"F"},domProps:{"checked":_vm._q(_vm.addMemberFields.sex,"F")},on:{"change":function($event){_vm.$set(_vm.addMemberFields, "sex", "F")}}}),_vm._v(" Female\n                                    ")])]),_vm._v(" "),_c('div',{staticClass:"form-check form-check-inline"},[_c('label',{staticClass:"form-check-label"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.addMemberFields.sex),expression:"addMemberFields.sex"}],staticClass:"form-check-input",attrs:{"type":"radio","name":"gender","id":"inlineRadio2","value":"O"},domProps:{"checked":_vm._q(_vm.addMemberFields.sex,"O")},on:{"change":function($event){_vm.$set(_vm.addMemberFields, "sex", "O")}}}),_vm._v(" Other\n                                    ")])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Age*")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.addMemberFields.age),expression:"addMemberFields.age"},{name:"validate",rawName:"v-validate",value:('required|numeric|max:2'),expression:"'required|numeric|max:2'"}],staticClass:"form-control",attrs:{"type":"text","name":"age","id":"age","data-vv-as":"age"},domProps:{"value":(_vm.addMemberFields.age)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.addMemberFields, "age", $event.target.value)}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('addMember.age')),expression:"errors.has('addMember.age')"}],staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('addMember.age')))])])]),_vm._v(" "),_c('div',{staticClass:"row mt-3"},[_c('div',{staticClass:"col-sm-6"},[_c('a',{staticClass:"btn btn-link full-width",on:{"click":function($event){_vm.cancelMember(3)}}},[_vm._v("Cancel")])]),_vm._v(" "),_vm._m(18,false,false)])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal fade bd-example-modal-lg",attrs:{"id":"termsAndCondition","tabindex":"-1","role":"dialog","aria-labelledby":"exampleModalLabel","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog modal-lg",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_vm._m(19,false,false),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_vm._m(20,false,false),_vm._v(" "),_c('div',{staticClass:"row mt-3"},[_c('div',{staticClass:"col-sm-6"},[_c('a',{staticClass:"btn btn-link full-width",on:{"click":function($event){_vm.termsConditionChanged(0)}}},[_vm._v("Close")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('button',{staticClass:"btn btn-primary full-width",on:{"click":function($event){_vm.termsConditionChanged(0, true)}}},[_vm._v("I Agree")])])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal fade bd-example-modal-lg",attrs:{"id":"privacyPolicy","tabindex":"-1","role":"dialog","aria-labelledby":"exampleModalLabel","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog modal-lg",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_vm._m(21,false,false),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_vm._m(22,false,false),_vm._v(" "),_c('div',{staticClass:"row mt-3"},[_c('div',{staticClass:"col-sm-6"},[_c('a',{staticClass:"btn btn-link full-width",on:{"click":function($event){_vm.termsConditionChanged(0)}}},[_vm._v("Close")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('button',{staticClass:"btn btn-primary full-width",on:{"click":function($event){_vm.termsConditionChanged(0, true)}}},[_vm._v("I Agree")])])])])])])])],1)}
var Address_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"badge add-badge badge-light float-left"},[_c('i',{staticClass:"material-icons"},[_vm._v("add")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-link remove-btn p-0"},[_c('img',{attrs:{"src":"static/images/close-black.svg","alt":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"badge add-badge badge-light float-left"},[_c('i',{staticClass:"material-icons"},[_vm._v("add")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-link remove-btn p-0"},[_c('img',{attrs:{"src":"static/images/close-black.svg","alt":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header",attrs:{"role":"tab","id":"headingOne"}},[_c('h5',{staticClass:"pb-2 mb-0 border-bottom"},[_c('a',{staticClass:"black-color collapsed",attrs:{"data-toggle":"collapse","href":"#collapseOne","aria-expanded":"true","aria-controls":"collapseOne"}},[_vm._v("\n                                        Test Details\n                                        "),_c('i',{staticClass:"material-icons float-right"})])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header",attrs:{"role":"tab","id":"headingOne"}},[_c('h5',{staticClass:"pb-2 mb-0 border-bottom fs-14 black-color"},[_vm._v("\n                              Choose Payment Option\n                            ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-header"},[_c('h5',{staticClass:"modal-title",attrs:{"id":"exampleModalLabel"}},[_vm._v("Add Address")]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_vm._v("Landmark "),_c('span',{staticClass:"locality-message"},[_vm._v("(Optional)")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_vm._v("Location / Pincode "),_c('span',{staticClass:"locality-message"},[_vm._v("(Choose nearest if exact match not available)")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-12"},[_c('div',{staticStyle:{"width":"100%","height":"200px","background":"#ccc"},attrs:{"id":"myMapAdd"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-header"},[_c('h5',{staticClass:"modal-title",attrs:{"id":"exampleModalLabel"}},[_vm._v(" Edit Address")]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_vm._v("Landmark "),_c('span',{staticClass:"locality-message"},[_vm._v("(Optional)")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_vm._v("Location / Pincode "),_c('span',{staticClass:"locality-message"},[_vm._v("(Choose nearest if exact match not available)")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-12"},[_c('div',{staticStyle:{"width":"100%","height":"200px","background":"#ccc"},attrs:{"id":"myMapVal"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-header"},[_c('h5',{staticClass:"modal-title",attrs:{"id":"exampleModalLabel"}},[_vm._v(" Edit Profile Details")]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-header"},[_c('h5',{staticClass:"modal-title",attrs:{"id":"exampleModalLabel"}},[_vm._v(" Edit Patient Details")]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-6"},[_c('button',{staticClass:"btn btn-primary full-width",attrs:{"type":"submit"}},[_vm._v("Update")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-header"},[_c('h5',{staticClass:"modal-title",attrs:{"id":"exampleModalLabel"}},[_vm._v(" Add Patient Details")]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-6"},[_c('button',{staticClass:"btn btn-primary full-width",attrs:{"type":"submit"}},[_vm._v("Save")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-header"},[_c('h5',{staticClass:"modal-title",attrs:{"id":"exampleModalLabel"}},[_vm._v("Terms and Condition")]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('p',[_vm._v("Welcome to "),_c('b',[_vm._v("www.labotist.com")]),_vm._v(". ")]),_vm._v(" "),_c('p',[_vm._v("The Terms & Conditions (“"),_c('b',[_vm._v("Terms")]),_vm._v("”) of use of www.labotist.com (“"),_c('b',[_vm._v("Website")]),_vm._v("”) are between Labotist Private Limited (“"),_c('b',[_vm._v("Company/We/Us")]),_vm._v("”) and its customers/clients (“"),_c('b',[_vm._v("You/Your/User(s)")]),_vm._v("”).")]),_vm._v(" "),_c('p',[_vm._v("These Terms constitute an electronic record in accordance with the provisions of the Information Technology Act, 2000 and the Information Technology (Intermediaries Guidelines) Rules, 2011 thereunder, as amended from time to time.")]),_vm._v(" "),_c('p',[_vm._v("Please read the Terms and the privacy policy of the Company carefully, available at "),_c('b',[_c('i',[_vm._v("www.labotist.com/privacy-policy")])]),_vm._v(" (“"),_c('b',[_vm._v("Privacy Policy")]),_vm._v("”) before using this Website or availing any Services (as defined below) through the Website. In the event of any discrepancy between the Terms and any other Website policies, the provisions of the Terms shall prevail.")]),_vm._v(" "),_c('p',[_vm._v("If You continue to browse and use our Website, You are agreeing to comply with and be bound by the following Terms. If you disagree with any part of these Terms, please do not use our Website.")]),_vm._v(" "),_c('p',[_vm._v("If You do not agree with the Terms or the Privacy Policy, please do not use the Website or avail the Services provided by this Website.")]),_vm._v(" "),_c('h4',[_vm._v("Introduction")]),_vm._v(" "),_c('p',[_vm._v("Our Website is an Internet based online platform operated by the Company which is a company incorporated under the Companies Act, 2013. Our Website is a convenient, technology driven platform that serves as a one-stop solution for patients to easily choose from, and connect with various laboratories  across the city. It is an online marketplace for lab services, offering patients the convenience of making their choice based on location, cost of test, quality and turnaround time. Patients also enjoy the added luxury of getting their samples collected in the comfort of their home by a trained phlebotomist (“"),_c('b',[_vm._v("Services")]),_vm._v("”).")]),_vm._v(" "),_c('p',[_vm._v("Use of the Website is offered to You on the condition that You accept the same without modification of all the terms, conditions and notices contained in these Terms, as may be posted on the Website from time to time.")]),_vm._v(" "),_c('p',[_vm._v("We reserve the right to amend these Terms from time to time as We deem fit and Your continued usage of the Website and the Services offered shall be deemed to be Your acceptance of the Terms. We recommend that, You keep yourself updated with the Terms. We do not hold the responsibility of informing You of any amendments.")]),_vm._v(" "),_c('p',[_vm._v("Users may not access the Services for the purposes of monitoring their availability, performance or functionality, or for any other benchmarking or competitive purposes.")]),_vm._v(" "),_c('p',[_vm._v("We reserve our right to suspend any User’s ability to use or access the Website at our sole discretion and at any time while We investigate complaints or alleged violations of these Terms, or for any other reason. We have the right to club profiles of the laboratories and diagnostic centres to make them more suitable for package searches on the Website while not amending any of the details provided by the concerned laboratories and diagnostic centres. If the Users find that there is any incorrect information, they can contact Us immediately for such corrections. However, We disclaim all liabilities or responsibilities with respect to any of the information provided by the concerned laboratories and diagnostic centres.")]),_vm._v(" "),_c('h4',[_vm._v("Eligibility Criteria")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v(" The Services offered on the Website are not available to all those individuals who are not qualified to enter into a contract as per the Indian Contract Act, 1872.  By using the Website, You represent and warrant that (a) all registration information You submit is truthful and accurate; (b) You will maintain the accuracy of such information, and any changes thereto by regular updates of any such information; (c) You affirm that You are over 18 years of age and are fully able and competent to enter into the terms, conditions, obligations, affirmations, representations, and warranties set forth in these Terms; and (c) You shall use the Website or such other services provided under the Website only in compliance with these Terms and all applicable local, state, national, and international laws, rules and regulations. Your profile may be deleted and Your membership may be terminated by the Company without warning, or without any notice whatsoever, if We believe that You have violated any of the conditions as mentioned under the Terms or Privacy Policy.\n                            ")]),_vm._v(" "),_c('li',[_vm._v("The Company reserves the right to grant or refuse usage of the Services available on the Website. It can also terminate the usage by an existent User of the Website without assigning any reason. ")]),_vm._v(" "),_c('li',[_vm._v("The Website does not have the responsibility to ensure that You conform to the aforesaid eligibility criteria. It shall be Your sole responsibility to ensure that You meet the required qualification.")])]),_vm._v(" "),_c('h4',[_vm._v("User Account")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v(" You will be required to create an Account, if You wish to avail the Services offered on the Website.")]),_vm._v(" "),_c('li',[_vm._v("In order to access the Services offered on the Website, You shall be required to register yourself with the Website, and maintain an account there (\""),_c('b',[_vm._v("Account")]),_vm._v("\"). You will be required to furnish certain information and details, including Your name, mobile number, e-mail address, residential address, payment information (credit/debit card details) if required, and any other information deemed necessary by the Website (“"),_c('b',[_vm._v("Account Information")]),_vm._v("”).")]),_vm._v(" "),_c('li',[_vm._v("It is Your sole responsibility to ensure that the Account Information provided by You is accurate, complete and latest.")]),_vm._v(" "),_c('li',[_vm._v("The Account Information provided by You, may be shared by the Company with any third party for its internal record keeping purposes, internal procedures and with various laboratories/diagnostic centres to enable them to inform You about any schemes, offers, discounts etc.  Further, by providing the Account Information, you agree and acknowledge that you are also granting your consent for the phlebotomists to visit the address provided by you in order to collect/draw the requite samples, call you on the number provided you for any necessary confirmation, deliver the samples the diagnostic centre chosen by you and do such other acts as necessary. ")]),_vm._v(" "),_c('li',[_vm._v("Upon completing the registration process, You can start availing the Services offered on the Website immediately. You shall be responsible for maintaining the confidentiality of the Account Information and for all activities that occur under Your Account. You agree to (a) ensure that You successfully log out from Your Account at the end of each session; and (b) immediately notify the Company of any unauthorized use of Your Account.  If there is reason to believe that there is likely to be a breach of security or misuse of the Your Account/ Website, We may request You to change the password or We may suspend Your account without any liability to the Company, for such period of time as We deem appropriate in the circumstances. The Website shall not be liable for any loss or damage arising from Your failure to comply with this Clause.")]),_vm._v(" "),_c('li',[_vm._v("You acknowledge that Your ability to use Your Account is dependent upon external factors such as internet service providers and internet network availability and the Company cannot guarantee availability of the Website at all times. In addition to the disclaimers set forth in the Terms, the Company shall not be liable to You for any damages arising from Your inability to log into Your Account and access the services of the Website at any time.")])]),_vm._v(" "),_c('h4',[_vm._v("Use of Website")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("Subject to compliance with the Terms, the Privacy Policy, and all other applicable terms and guidelines, the Company grants You a personal, non-exclusive, limited privilege to access and use this Website and the Services provided thereon.")]),_vm._v(" "),_c('li',[_vm._v("No User shall be permitted to perform any of the following prohibited activities:\n                                "),_c('ul',[_c('li',[_vm._v("Making available any content that is misleading, unlawful, harmful, threatening, abusive, tortious, defamatory, libelous, vulgar, obscene, child-pornographic, lewd, lascivious, profane, invasive of another's privacy, hateful, or racially, ethnically or otherwise objectionable.")]),_vm._v(" "),_c('li',[_vm._v("Stalking, intimidating and/or harassing another and/or inciting other to commit violence.")]),_vm._v(" "),_c('li',[_vm._v("Transmitting material that encourages anyone to commit a criminal offence, that results in civil liability or otherwise breaches any relevant laws, regulations or code of practice.")]),_vm._v(" "),_c('li',[_vm._v("Interfering with any other person's use or enjoyment of the Website.")]),_vm._v(" "),_c('li',[_vm._v("Making, transmitting or storing electronic copies of materials protected by copyright without the permission of the owner, committing any act that amounts to the infringement of intellectual property or making available any material that infringes any intellectual property rights or other proprietary rights of anyone else.")]),_vm._v(" "),_c('li',[_vm._v("Make available any content or material that You do not have a right to make available under any law or contractual or fiduciary relationship, unless You own or control the rights thereto or have received all necessary consents for such use of the content.")]),_vm._v(" "),_c('li',[_vm._v("Impersonate any person or entity, or falsely state or otherwise misrepresent Your affiliation with a person or entity.")]),_vm._v(" "),_c('li',[_vm._v("Use any of the Company’s domain names.")]),_vm._v(" "),_c('li',[_vm._v("Reverse engineer, modify, copy, distribute, transmit, display, perform, reproduce, publish, license, create derivative works from, transfer, or sell any information or software obtained from the Website.")]),_vm._v(" "),_c('li',[_vm._v("Post, transmit or make available any material that contains viruses, trojan horses, worms, spyware, time bombs, cancelbots, or other computer programming routines, code, files or such other programs that may harm the Website/services, interests or rights of other Users or limit the functionality of any computer software, hardware or telecommunications, or that may harvest or collect any data or personal information about other Users without their consent.")]),_vm._v(" "),_c('li',[_vm._v("Access or use the Website in any manner that could damage, disable, overburden or impair any of the Website's servers or the networks connected to any of the servers on which the Website is hosted.")]),_vm._v(" "),_c('li',[_vm._v("Intentionally or unintentionally interfere with or disrupt the Services or violate any applicable laws related to the access to or use of the Website, violate any requirements, procedures, policies or regulations of networks connected to the Website, or engage in any activity prohibited by these Terms.")]),_vm._v(" "),_c('li',[_vm._v("Disrupt or interfere with the security of, or otherwise cause harm to, the Website, materials, systems resources, or gain unauthorized access to user accounts, passwords, servers or networks connected to or accessible through the Website or any affiliated or linked sites.")]),_vm._v(" "),_c('li',[_vm._v("Interfere with, or inhibit any user from using and enjoying access to the Website, or the services, or other affiliated sites, or engage in disruptive attacks such as denial of service attack on the Website.")]),_vm._v(" "),_c('li',[_vm._v("Access the Website through any other means other than through the interface that is provided by the Company.")]),_vm._v(" "),_c('li',[_vm._v("Use deep-links, page-scrape, robot, spider or other automatic device, program, algorithm or methodology, or any similar or equivalent manual process, to increase traffic to the Website, to access, acquire, copy or monitor any portion of the Website, or in any way reproduce or circumvent the navigational structure or presentation of the Website, or any content, to obtain or attempt to obtain any content, documents or information through any means not specifically made available through the Website.")]),_vm._v(" "),_c('li',[_vm._v("Alter or modify any part of the services.")]),_vm._v(" "),_c('li',[_vm._v("Use the services for purposes that are not permitted by: (i) these Terms; and (ii) any applicable law, regulation or generally accepted practices or guidelines in the relevant jurisdiction.")]),_vm._v(" "),_c('li',[_vm._v("Violate any of the terms specified under the Terms for the use of the Website.")])])]),_vm._v(" "),_c('li',[_vm._v("Any violation by You of the terms of this Clause may result in immediate suspension or termination of Your Accounts, apart from any legal remedy that the Company can avail. In such instances, the Company may also disclose Your Account Information if required by any Governmental or legal authority.")]),_vm._v(" "),_c('li',[_vm._v("You acknowledge and agree that by accessing or using the Website, You agree to indemnify and hold the Company, its affiliates, and/or licensors, harmless to the fullest extent allowed by law regarding all matters related to Your use of the Website or any loss/damage that is caused to the Website/the Company as a result of You committing any of the aforesaid prohibited activities.")]),_vm._v(" "),_c('li',[_vm._v("The Company has the right to change modify, suspend, or discontinue and/or eliminate any aspect(s), features or functionality of the Website or the Services as it deems fit at any time without notice. The Company makes no commitment, express or implied, to maintain or continue any aspect of the Website.  You agree that the Company shall not be liable to You or any third party for any modification, suspension or discontinuance of the Website.")]),_vm._v(" "),_c('li',[_vm._v("You acknowledge that the Company does not make any representation or warranty  regarding any of its Users. You are advised to independently verify the bona fides of any particular user that You choose to deal with on the Website.")])]),_vm._v(" "),_c('h4',[_vm._v("Delivery of Reports ")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v(" Sample collection will typically be done on the date and time chosen by the User. The User shall have the option to reschedule subject to the availability of the rescheduled time slot.")]),_vm._v(" "),_c('li',[_vm._v("It is clarified that, certain sample collection procedure may get delayed due to certain unforeseen circumstances beyond the control of the Company. In such an event, We will proactively reach out to You and inform the same. You are expected to check your emails and SMS regularly for any such updates.")]),_vm._v(" "),_c('li',[_vm._v("Reports will be generated within the turnaround time as stipulated by the laboratory/diagnostic centre chosen by the User. The Company is not liable for any delay with respect to the generation of the reports by such laboratory/diagnostic centre . Upon delivery of the reports to Us, We shall verify the User name and other necessary credentials after which the Company shall attach and e-mail a soft copy of the report to Your online account. The User shall be able to view the report only by logging into his/her Account.")]),_vm._v(" "),_c('li',[_vm._v("Reported laboratory results are at best informative to the referring clinician and should not be considered as the sole basis for final diagnosis and treatment decisions. They should always be correlated with other relevant clinical and laboratory findings.")]),_vm._v(" "),_c('li',[_vm._v("The accuracy of the laboratory reports is largely dependent on the quality of the sample as well as the assay procedures used by the laboratory/diagnostic centres chosen by the User.")])]),_vm._v(" "),_c('h4',[_vm._v("Payment, Fees and Taxes ")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("The User agrees to pay all package fees, consulting fees and other fees applicable to the selected Services and the User shall not circumvent the fee structure. The fee is dependent on the package that the User purchases online and not on the actual usage of the Services.")]),_vm._v(" "),_c('li',[_vm._v("Each User is solely responsible for the payment of all taxes. The Company shall be in no way responsible for any of the taxes except for its own tax liabilities.")]),_vm._v(" "),_c('li',[_vm._v("The payment can be made online on the Website through a secured payment gateway provided by a third party. It is hereby clarified that, the Company is not responsible for any loss or damage caused to the User during the payment process as the third parties and their activities are beyond the control of the Company. The payment could also be paid offline and be either collected personally from the User.")]),_vm._v(" "),_c('li',[_vm._v("All fees are exclusive of applicable taxes.")]),_vm._v(" "),_c('li',[_vm._v("The Company reserves the right to modify the fee and such modified fee shall reflect on the Website, which shall be binding.")]),_vm._v(" "),_c('li',[_vm._v("In order to process the payments, the User might be required to provide certain details of the his/her bank account, credit/debit card number and other details as required by the third party vendor to process the transactions. The Company clarifies that it does not own or store any credit/debit card information entered by the User.")]),_vm._v(" "),_c('li',[_vm._v("You understand and acknowledge that the Company shall not be held responsible or assume any liability, whatsoever in respect of any loss or damage arising directly or indirectly to You due to:")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("Lack of authorization for any transaction/s, or")]),_vm._v(" "),_c('li',[_vm._v("Exceeding the preset limit set by your bank, or")]),_vm._v(" "),_c('li',[_vm._v("Delay in processing the transaction; or")]),_vm._v(" "),_c('li',[_vm._v("Any payment issues arising out of the transaction; or")]),_vm._v(" "),_c('li',[_vm._v("Decline of transaction for any reason/s")])]),_vm._v(" "),_c('li',[_vm._v("All payments made against the purchases on the Website by You shall be compulsorily in Indian Rupees acceptable in the Republic of India. The Website will not facilitate transactions with respect to any other form of currency with respect to availing of its services. ")])]),_vm._v(" "),_c('h4',[_vm._v("Cancellation and Refund Policy")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("The User can cancel the test request by calling on the phone number mentioned in the order confirmation notification.")]),_vm._v(" "),_c('li',[_vm._v("All laboratory test requests can be canceled until 12 (twelve) hours prior of the scheduled sample collection appointment to be eligible for a full refund.")]),_vm._v(" "),_c('li',[_vm._v("For any requests cancelled less than 12 (twelve) hours prior to the scheduled sample collection appointment  or after the appointment, the User would incur an administrative charge of INR 100 (Rupees One Hundred). This is primarily to compensate the phlebotomist for a lost opportunity to provide the home sample collection service and earn his/her income.")]),_vm._v(" "),_c('li',[_vm._v("Any requests not cancelled before the scheduled sample collection will NOT receive any refund. All refunds will be processed and credited within 15 (fifteen) business days from the date of the cancellation request into the account of the User.")])]),_vm._v(" "),_c('h4',[_vm._v("Limitation of Liability")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("The Company, its officers, directors, employees, partners or agents shall not be held responsible or held liable to You or any third party for any special, incidental, indirect, consequential or punitive damages whatsoever, including those resulting from loss of use, data or profits or any other claim arising out, of or in connection with, Your use of, or access to, the Website.")]),_vm._v(" "),_c('li',[_vm._v("The Company shall not be held responsible or liable in any manner whatsoever, by the Users for any losses, damage, injuries or expenses incurred by the Users as a result of any lawful disclosures made by the Company, where the User has consented to such disclosures by the Company. The User agrees that the services provided by the Company or any of its affiliates or service providers are provided on an  \"as is,\" basis, and without any warranties or conditions ("),_c('i',[_vm._v("express or implied, including the implied warranties of merchantability, accuracy, fitness for a particular purpose, title and non-infringement, arising by statute or otherwise in law or from a course of dealing or usage or trade")]),_vm._v("). The Company does not provide or make any representation, warranty or guarantee, express or implied about the Website or the Services. The Company does not verify any content or information provided by the Users/User selected laboratories/diagnostic centres on the Website and to the fullest extent permitted by law, disclaims all liability arising out of the User’s use or reliance upon the Website, the Services, representations and warranties made by the laboratories/diagnostic centres or the content or information provided by laboratories/ diagnostic centres on the Website or any loss arising out of the manner in which the Services have been rendered.")]),_vm._v(" "),_c('li',[_vm._v("In no event shall the total aggregate liability of the Protected Entities to a User for all damages, losses, and causes of action ("),_c('i',[_vm._v("whether in contract or tort, including, but not limited to, negligence or otherwise")]),_vm._v(") arising from the terms and conditions or a User’s use of the Website exceed, in the aggregate INR 1,000 (Rupees One Thousand). ")]),_vm._v(" "),_c('li',[_vm._v("Notwithstanding anything to the contrary contained herein, the User alone shall be liable for User’s dealings and interaction with the chosen laboratory/diagnostic centres. ")]),_vm._v(" "),_c('li',[_vm._v("In no event shall the Company be held responsible and liable for failure on the part of the chosen laboratories/ diagnostic centres to provide the agreed Services or to make provisions for the carrying out the Services. In no event shall the Company be liable for any comments or feedback given by any of the Users in relation to the Services provided by any chosen laboratories/diagnostic centres.")]),_vm._v(" "),_c('li',[_vm._v("The listing of the laboratories/diagnostic centres on the Website is based on numerous factors including but not limited to the User’s comments and feedbacks. In no event shall the Company be liable or responsible for the listing order of the laboratories/diagnostic centres on the Website.")]),_vm._v(" "),_c('li',[_vm._v("We shall not be held responsible or liable for, any damages to, or viruses that may infect User’s equipment on account of User’s access to, use of, or browsing the Website or the downloading of any material, data, text, images, video content, or audio content from the Website. If a User is dissatisfied with the Website, User’s sole remedy is to discontinue using the Website.")])]),_vm._v(" "),_c('h4',[_vm._v("Ownership and Intellectual Property Rights")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("The Website and the materials therein including but not limited to all text, graphics, user interfaces, visual interfaces, sounds and music ("),_c('i',[_vm._v("if any")]),_vm._v("), artwork and computer code and any other information or materials of any nature whatsoever on the Website is owned and controlled by the Company and such content is protected by copyright, patent and trademark laws, and various other intellectual property rights and unfair competition laws.")]),_vm._v(" "),_c('li',[_vm._v("The trademarks, logos and service marks displayed on the Website or on the Website (the \""),_c('b',[_vm._v("Marks")]),_vm._v("\") are the property of Company or the respective third parties. You are not permitted to use the Marks without the prior consent of the Company or the third party that may own the Marks.")])]),_vm._v(" "),_c('h4',[_vm._v("Termination of Your Account")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("The Company may at its sole discretion and without prior notice, terminate Your access to the Website and its Services for, including but not limited to, any of the following reasons:")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("Your violation of the Terms as mentioned herein.")]),_vm._v(" "),_c('li',[_vm._v("If the Company is unable to verify or authenticate any information provided to by You.")]),_vm._v(" "),_c('li',[_vm._v("If the Company at its sole discretion believes that Your actions may cause any damage or legal liability for other Users or to  the Company or are contrary to the interests of the Company.")])]),_vm._v(" "),_c('li',[_vm._v("On termination of an Account due to the reasons mentioned herein, such User shall no longer have access to and the reports and other material stored on the Website by such User. The User shall ensure that he/she has continuous backup of the reports.")]),_vm._v(" "),_c('li',[_vm._v("The Company reserves the right, at its sole discretion, to pursue all of its legal remedies, including but not limited to deletion of the User’s content from the Website with or without ability to access the Website and the other services, upon any breach by the User under this Terms or if the Company is unable to verify or authenticate any information provided by the User or if the User fails to provide (or after providing such consent, later revokes) the consents necessary or desirable by the Company to provide the services to the User.")])]),_vm._v(" "),_c('h4',[_vm._v("Indemnification")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("You agree to defend, indemnify and hold harmless the Company, its officers, directors, employees and agents, from and against any and all claims, damages, obligations, losses, liabilities, costs or debt, and expenses (including but not limited to attorney's fees) arising from: (i) Your use of and access of the Website; (ii) Your violation of any term of these Terms or any other policy of the Company; (iii) Your violation of any third party right, including without limitation, any copyright, property, or privacy right; or (iv) any claim that Your use of the Website has caused damage to a third party. The defense and indemnification obligation will survive these Terms.")])]),_vm._v(" "),_c('h4',[_vm._v("Governing Law and Jurisdiction")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("The Website, the Terms, all transactions entered into on or through the Website and the relationship between You and the Company shall be governed by and construed in accordance with the laws of India, without regard to conflict of law principles. The courts of Chennai shall have the jurisdiction to try any dispute between the User and Company.")])]),_vm._v(" "),_c('h4',[_vm._v("General Provisions")]),_vm._v(" "),_c('ul',[_c('li',[_c('b',[_vm._v("Notice:")]),_vm._v(" All notices served by the Company shall be provided via email to Your account or as a general notification on the Website. Any notice to be provided to the Company should be sent to "),_c('b',[_vm._v("[•]")]),_vm._v(".")]),_vm._v(" "),_c('li',[_c('b',[_vm._v("Entire Agreement:")]),_vm._v(" The Terms, along with the Privacy Policy, and any other guidelines made applicable by the Website from time to time, constitute the entire agreement between the Company and You with respect to Your access to or use of the Website and the Services thereof.")]),_vm._v(" "),_c('li',[_c('b',[_vm._v("Assignment:")]),_vm._v(" You cannot assign or otherwise transfer the Terms, or any right granted hereunder to any third party. The Company’s rights under the Terms are freely transferable by the Company to any third parties without the requirement of seeking Your consent. The Company may freely transfer, assign or delegate all or any part of these Terms, any rights and duties hereunder. These Terms will be binding upon and inure to the benefit of the successors and permitted assignees of the parties.")]),_vm._v(" "),_c('li',[_c('b',[_vm._v("Severability:")]),_vm._v(" If, for any reason, a court of competent jurisdiction finds any provision of the Terms, or portion thereof, to be unenforceable, that provision shall be enforced to the maximum extent permissible so as to give effect to the intent of the parties as reflected by that provision, and the remainder of the Terms shall continue in full force and effect.")]),_vm._v(" "),_c('li',[_c('b',[_vm._v("Waiver:")]),_vm._v(" Any failure by the Company to enforce or exercise any provision of the Terms, or any related right, shall not constitute a waiver by the Company of that provision or right.")]),_vm._v(" "),_c('li',[_c('b',[_vm._v("Force Majeure:")]),_vm._v(" The Company shall not be held responsible or liable due to any unavailability caused by circumstances beyond the Company’s reasonable control, including without limitation, Acts of God, acts of Government, flood, fire, earthquakes, civil unrest, acts of terror, strikes or other labour problems such as strikes and lockouts, or internet service provider failures or delays.")]),_vm._v(" "),_c('li',[_c('b',[_vm._v("Relationship:")]),_vm._v(" You acknowledge that Your participation on the Website, does not make You an employee or agency or partnership or joint venture or franchise of the Company. Further, you shall not have the right to enter into any obligation or commitment on behalf of the Company.")]),_vm._v(" "),_c('li',[_vm._v("The Company provides these Terms on the Website so that You are aware of the terms that apply to Your use of the Website. You acknowledge that, the Company has given You a reasonable opportunity to review these Terms and that You have agreed to them.")]),_vm._v(" "),_c('li',[_vm._v("In the event that you participate in any promotional activities through the advertisers on the Website, the Company shall not be held responsible for any loss or damage caused to you in this regard.")])]),_vm._v(" "),_c('h4',[_vm._v("DISCLAIMER")]),_vm._v(" "),_c('p',{staticClass:"terms-disclaimer"},[_c('b',[_vm._v("WE DO NOT PROVIDE MEDICAL ADVICE:")]),_vm._v(" THE INFORMATION THAT YOU OBTAIN OR RECEIVE FROM THE COMPANY, AND ITS EMPLOYEES, CONTRACTORS, PARTNERS, SPONSORS, ADVERTISERS, LICENSORS OR OTHERWISE ON THE WEBSITE IS FOR INFORMATIONAL AND SCHEDULING PURPOSES ONLY. THE INFORMATION PROVIDED ON THE WEBSITE IS NOT INTENDED AS A SUBSTITUTE FOR, NOR DOES IT REPLACE, PROFESSIONAL MEDICAL ADVICE, DIAGNOSIS, OR TREATMENT. DO NOT DISREGARD, AVOID OR DELAY OBTAINING MEDICAL ADVICE FROM A QUALIFIED HEALTH CARE PROFESSIONAL BECAUSE OF SOMETHING YOU MAY HAVE READ ON THE WEBSITE. DO NOT USE THE WEBSITE FOR EMERGENCY MEDICAL NEEDS. YOUR USE OF INFORMATION PROVIDED ON THE WEBSITE IS SOLELY AT YOUR OWN RISK. NOTHING STATED OR POSTED ON THE WEBSITE OR AVAILABLE THROUGH ANY SERVICES IS INTENDED TO BE, AND MUST NOT BE TAKEN TO BE, THE PRACTICE OF MEDICINE OR THE PROVISION OF MEDICAL CARE. WE DO NOT RECOMMEND OR ENDORSE ANY SPECIFIC TESTS, PHYSICIANS, LABORATORIES, DIAGNOSTIC CENTRES, PROCEDURES, OPINIONS, OR OTHER INFORMATION THAT MAY APPEAR ON THE WEBSITE. IF YOU RELY ON ANY OF THE INFORMATION PROVIDED BY THE WEBSITE, YOU DO SO SOLELY AT YOUR OWN RISK.")]),_vm._v(" "),_c('p',{staticClass:"terms-disclaimer"},[_c('b',[_vm._v("NO DOCTOR PATIENT RELATIONSHIP:")]),_vm._v(" NO LICENSED MEDICAL PROFESSIONAL/PATIENT RELATIONSHIP IS CREATED BY USING THE INFORMATION PROVIDED BY OR THROUGH THE USE OF THE WEBSITE INCLUDING, BUT NOT LIMITED TO, FIND A TEST FEATURE, LINKS TO OTHER WEBSITES OR ANY ASSISTANCE WE MAY PROVIDE TO HELP YOU FIND AN APPROPRIATE MEDICAL PROFESSIONAL/DIAGNOSTIC CENTER OR SPECIALIST IN ANY FIELD FOR CONDUCTING THE REQUISITE TEST. WE MAKE NO GUARANTEES, REPRESENTATIONS OR WARRANTIES, WHETHER EXPRESSED OR IMPLIED, WITH RESPECT TO PROFESSIONAL QUALIFICATIONS, EXPERTISE, QUALITY OF WORK OR OTHER INFORMATION HEREIN REGARDING THE LABORATORIES/DIAGNOSTIC CENTRE OR THER PHLEBOTOMISTS. IN NO EVENT SHALL WE BE LIABLE TO YOU OR ANYONE ELSE FOR ANY DECISION MADE OR ACTION TAKEN BY YOU IN RELIANCE ON SUCH INFORMATION. WE HAVE NOT CONDUCTED ANY BACKGROUND CHECK ON THE PHLEBOTOMISTS AND WE ARE IN NO WAY LIABLE FOR ANY OF THEIR ACT/OMISSIONS. WE HAVE NO CONTROL OVER, AND CANNOT GUARANTEE THE AVAILABILITY OF ANY DIAGNOSTIC CENTER AT ANY PARTICULAR TIME. WE WILL NOT BE LIABLE FOR CANCELLED OR OTHERWISE UNFULFILLED APPOINTMENTS OR ANY INJURY RESULTING THEREFROM, OR FOR ANY OTHER INJURY RESULTING FROM THE USE OF THE WEBSITE OR SERVICES WHATSOEVER. YOU ARE STRONGLY ADVISED TO PERFORM YOUR OWN INVESTIGATION PRIOR TO SELECTING A HEALTH CARE DIAGNOSTIC CENTRE BY MAKING CONFIRMING TELEPHONE CALLS TO THE RELEVANT DIAGNOSTIC CENTRE. ANY KIND OF AN ENGAGEMENT WITH THE THIRD PARTIES INCLUDING WITH THE DIAGNOSTIC CENTRE WOULD BE ON A PRINCIPAL TO PRINCIPAL BASIS ON THE BEST JUDGEMENT OF YOURSELF.")]),_vm._v(" "),_c('h4',[_vm._v("Feedback")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("Any feedback You provide to this Website shall be deemed to be non-confidential. The Website shall be free to use such information on an unrestricted basis. Further, by submitting the feedback, You represent and warrant that (i) Your feedback does not contain confidential or proprietary information of You or of third parties; (ii) the Company is not under any obligation of confidentiality, express or implied, with respect to the feedback; (iii) the Website may have something similar to the feedback already under consideration or in development; and (iv) You are not entitled to any compensation or reimbursement of any kind from the Company for the feedback under any circumstances, unless specified.")]),_vm._v(" "),_c('li',[_vm._v("Under no circumstances shall the Company be held responsible in any manner for any content provided by other users even such content is offensive, hurtful or offensive. Please exercise caution while accessing the Website.")])]),_vm._v(" "),_c('h4',[_vm._v("Customer Care")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("We make all best endeavors to provide you with a pleasant experience. In the unlikely event that You face any issues, please contact us at "),_c('b',[_vm._v("[•]")])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-header"},[_c('h5',{staticClass:"modal-title",attrs:{"id":"exampleModalLabel"}},[_vm._v("Privacy Policy")]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('p',[_vm._v("About Labotist Private Limited ")]),_vm._v(" "),_c('p',[_vm._v("Labotist Private Limited (“"),_c('b',[_vm._v("We")]),_vm._v("” and/or “"),_c('b',[_vm._v("Us")]),_vm._v("” and/or “"),_c('b',[_vm._v("Company")]),_vm._v("”) is a company incorporated under the Companies Act, 2013. Our website is a convenient, technology driven platform that serves as a one stop solution for patients to easily choose from, and connect with various labs across the city. It is an online marketplace for lab services, offering patients the convenience of making their choice based on location, cost of test, quality and turnaround time. Patients also enjoy the added luxury of getting their samples collected in the comforts of their home by a trained phlebotomist.")]),_vm._v(" "),_c('p',[_vm._v("Similarly, our Website also serves as a marketplace for phlebotomists who are registered on our website. Our Company screens the phlebotomist as commercially viable and creates a well-intended marketplace for phlebotomist to serve as micro entrepreneurs.")]),_vm._v(" "),_c('p',[_vm._v("The Company is concerned about the privacy of its users (\""),_c('b',[_vm._v("User(s)")]),_vm._v("\" and/or \""),_c('b',[_vm._v("You")]),_vm._v("\" and/or “"),_c('b',[_vm._v("Your")]),_vm._v("”) accessing its Website. online platform in the name and style of www.labotist.com (the \""),_c('b',[_vm._v("Website")]),_vm._v("\").")]),_vm._v(" "),_c('p',[_vm._v("Please read the Privacy Policy (“"),_c('b',[_vm._v("Policy")]),_vm._v("”) carefully before using the Website, along with the Terms of Use (“"),_c('b',[_vm._v("Terms")]),_vm._v("”) provided on the Website. Your use of the Website or the services provided by the Website shall signify Your acceptance of this Policy and Your agreement to be legally bound by the same.")]),_vm._v(" "),_c('p',[_vm._v("If You do not agree with the terms of this Policy, do not use the Website or avail any of the services offered on this Website.")]),_vm._v(" "),_c('h4',[_vm._v("About the policy")]),_vm._v(" "),_c('p',[_vm._v("When You register with the Website, We may seek and collect certain personal information for Your use of the Website. You consent to the collection, use, and disclosure of the information in accordance with this Policy. Therefore, We request You to read this Policy carefully before using the Website. ")]),_vm._v(" "),_c('p',[_vm._v("Please note that, We respect and value Your privacy and shall strive towards protecting the information that You provide. We shall keep the information provided to Us as confidential to the extent reasonably possible. You understand that, by registering on the Website, your personal information may be collected. If at any time You wish to have Your information deleted, You can write to "),_c('i',[_vm._v("support@labotist.com")]),_vm._v(". We shall do the needful within 5 working days but We may retain certain information for internal purposes if required under applicable law.")]),_vm._v(" "),_c('p',[_vm._v("Your privacy is of utmost importance to us. We shall process and save your information in accordance with the Information Technology Act, 2000 and the Information Technology (Reasonable Security Practices And Procedures And Sensitive Personal Data Or Information) Rules, 2011.")]),_vm._v(" "),_c('h4',[_vm._v("collection of personally identifiable information")]),_vm._v(" "),_c('p',[_vm._v("We collect personally identifiable information (name, phone number, email etc.) from you when you request for a service. We do not for any reason whatsoever sell your Personal Identifiable Information to any third party or otherwise trade on it.")]),_vm._v(" "),_c('p',[_vm._v("The personal information You may provide to Us that We may use is as follows:")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("Registration details: This will include the password provided by You for which We use reasonable security measures for password protection from anyone.")]),_vm._v(" "),_c('li',[_vm._v("Your usage behavior on the Website.")]),_vm._v(" "),_c('li',[_vm._v("The details of the computer system or computer network that You use to visit the Website and any activities undertaken through the usage of the Website.")]),_vm._v(" "),_c('li',[_vm._v("Your first and last name, e-mail address, phone number, billing and shipping address.")])]),_vm._v(" "),_c('p',[_vm._v("The fundamental reason behind collecting Your personal information is to support and facilitate You to enjoy various features and services provided on the Website. ")]),_vm._v(" "),_c('p',[_vm._v("We select and track Your preferences to provide You with a customized Website experience, to notify You of any updated information and new developments/features and other related functions offered by the Website, to otherwise support Your relationship with Us and to prevent fraud and unlawful use.")]),_vm._v(" "),_c('p',[_vm._v("By accepting the terms of this Policy, You understand, agree and recognize that our storage and processing of Your personal information is for a lawful purpose associated with a function or an activity of the Website. You further understand, agree and acknowledge that You may be required to provide personal information that is classified as sensitive personal information as per applicable laws for Us to provide various services. ")]),_vm._v(" "),_c('p',[_vm._v("Please note that, it is entirely up to the discretion of the User to provide this personal information. However, the User would not be able to avail the services provided by Us if this information is denied.")]),_vm._v(" "),_c('p',[_vm._v("We do not sell, trade or rent Your personal information to any third party unless We have been expressly authorized by You either in writing or electronically to do so. We may at times provide aggregate statistics about our customers, traffic patterns, and related site information to reputable third parties, however this information when disclosed will be in an aggregate form and does not contain any of Your personally identifiable information.")]),_vm._v(" "),_c('p',[_vm._v("You may note that, We adopt reasonable security measures to protect Your password from being exposed or disclosed to anyone")]),_vm._v(" "),_c('h4',[_vm._v("information sharing and disclosure:")]),_vm._v(" "),_c('p',[_vm._v("We are the recipient of all the personal information and shall exercise reasonable care to keep Your personal information confidential to the maximum possible extent. We may limit disclosure of the Users' information to our entities, joint ventures, agents, sellers or third parties for the purposes of the services provided by them or for any other marketing related activity undertaken by or on behalf of our entities and/or its joint ventures on a need-to-know basis. We shall not be liable for any unauthorized use or disclosure of the personal information by any sellers participating on our Websites.")]),_vm._v(" "),_c('p',[_vm._v("We may use the information We collect from You when You register, place an order, sign up for our newsletter, respond to a survey or marketing communication, surf the Website, or use certain other site features in the following ways: To personalize your experience and to allow us to deliver the type of content and product offerings in which you are most interested. ")]),_vm._v(" "),_c('h4',[_vm._v("legal compliance")]),_vm._v(" "),_c('p',[_vm._v("We abide by all the applicable laws in force as well as the mandates of government agencies. We will disclose any information about You to government or law enforcement officials or private parties that We, in our sole discretion, believe necessary or appropriate to respond to claims and legal processes, to protect the property and rights of the Company or a third party, to protect the safety of the public or any person, or to prevent or stop any illegal, unethical or legally fraudulent activity. We may also provide Your personal information to various regulatory authorities upon any demand or request from them.")]),_vm._v(" "),_c('p',[_vm._v("We may provide your personal information, in connection with a merger, acquisition, reorganization or sale of assets or in the event of bankruptcy of the Company.")]),_vm._v(" "),_c('p',[_vm._v("We do not use vulnerability scanning and/or scanning for payment transaction. All our scanning with respect to payments is in compliant with Payment Card Industry Data Security Standard (“"),_c('b',[_vm._v("PCI")]),_vm._v("”) standards. An external PCI compliant payment gateway handles all our credit card transactions. We use regular malware scanning. Your personal information is contained behind secured networks and is only accessible by a limited number of persons who have special access rights to such systems, and are required to keep the information confidential. In addition, all sensitive/credit information you supply is encrypted via Secure Socket Layer (“SSL”) technology. We implement a variety of security measures when a user places an order enters, submits, or accesses their information to maintain the safety of your personal information. All transactions are processed through a gateway provider and are not stored or processed on our servers. ")]),_vm._v(" "),_c('h4',[_vm._v("email policies")]),_vm._v(" "),_c('p',[_vm._v("You can choose the type of emails that You wish to receive from Us. If You decide at any time that You no longer wish to receive such communications from Us, please follow the unsubscribe instructions provided in any of the communications. Please note that, once We receive Your request, it may take an additional period of time for Your subscription to become ineffective.")]),_vm._v(" "),_c('h4',[_vm._v("deletion of your information:")]),_vm._v(" "),_c('p',[_vm._v("If You wish to have the personal information that You have provided to us deleted, You can do so by writing to "),_c('i',[_vm._v("support@labotist.com")]),_vm._v(". Please note that deletion of certain personal information may lead to deletion of Your account with the Website and Your access to certain features of the Website.  You understand that under certain circumstances, the request for the deletion of personal information can be denied.")]),_vm._v(" "),_c('h4',[_vm._v("security:")]),_vm._v(" "),_c('p',[_vm._v("We strive to work towards the security, integrity and privacy of Your personal information and to protect Your personal information against unauthorized disclosure, access or destruction to the extent reasonably possible by Us. Notwithstanding anything contained in this Policy or elsewhere, We shall not be held responsible for any loss, damage or misuse of Your personal information, if such loss, damage or misuse takes place as a result of a Force Majeure Event (as defined below).")]),_vm._v(" "),_c('p',[_vm._v("A \""),_c('b',[_vm._v("Force Majeure Event")]),_vm._v("\" shall mean any event that is beyond our reasonable control and shall include, without limitation, fire, flood, explosion, acts of God, civil commotion, strikes, insurrection, war, acts of government, computer hacking, software failure and storage device, computer crashes etc")]),_vm._v(" "),_c('h4',[_vm._v("third-party disclosure")]),_vm._v(" "),_c('p',[_vm._v("We may disclose Your personal information solely in the legitimate conduct of the business to deliver services to meet Your demands. We may also release information when We believe, in good faith, that such release is reasonably necessary to (1) comply with legal or regulatory requirements; (2) enforce or apply terms of use of our Website; or (3) protect our rights, property or safety of the rights of others.")]),_vm._v(" "),_c('p',[_vm._v("Although We do not sell, trade, or otherwise transfer to outside parties your personally identifiable information unless we provide users with advance notice, this does not include website hosting partners and other parties who assist us in operating our website, conducting our business, or serving our users, so long as those parties agree to keep this information confidential. We may also release information when its release is appropriate to comply with the law, enforce our site policies, or protect ours or others' rights, property or safety.")]),_vm._v(" "),_c('p',[_vm._v("However, non-personally identifiable visitor information may be provided to other parties for marketing, advertising, or other uses.")]),_vm._v(" "),_c('h4',[_vm._v("links to other sites")]),_vm._v(" "),_c('p',[_vm._v("The Website may provide third-party advertisements and links to other websites. We do not provide Your personal information to these third-party websites or advertisers.")]),_vm._v(" "),_c('p',[_vm._v("The links to other websites are operated by third parties and are not controlled by, or affiliated to, or associated with Us unless expressly specified on the Website. Therefore, We do not make any claims concerning the privacy practices or policies of such third parties or terms of use of such websites, nor do We control or guarantee or endorse the accuracy, integrity, or quality of the information available on such websites. Any information provided by You to such third party websites shall be governed in accordance with the privacy policies of the respective websites and it is strongly recommended that You review the privacy policy on any such websites prior to using such websites.")]),_vm._v(" "),_c('h4',[_vm._v("google")]),_vm._v(" "),_c('p',[_vm._v("Google's advertising requirements can be summed up by Google's Advertising Principles. They are put in place to provide a positive experience for users. Click here to view We use Google AdSense Advertising on our Website.")]),_vm._v(" "),_c('p',[_vm._v("Google, as a third-party vendor, uses cookies to serve ads on our site. Google's use of the DART cookie enables it to serve ads to our users based on previous visits to our site and other sites on the Internet. Users may opt-out of the use of the DART cookie by visiting the Google Ad and Content Network privacy policy.")]),_vm._v(" "),_c('p',[_vm._v("We have implemented the following:")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("Google Display Network Impression Reporting")]),_vm._v(" "),_c('li',[_vm._v("Demographics and Interests Reporting")])]),_vm._v(" "),_c('p',[_vm._v("We, along with third-party vendors such as Google use first-party cookies (such as the Google Analytics cookies) and third-party cookies (such as the DoubleClick cookie) or other third-party identifiers together to compile data regarding user interactions with ad impressions and other ad service functions as they relate to our website.")]),_vm._v(" "),_c('h4',[_vm._v("how does our website handle do not track signals?")]),_vm._v(" "),_c('p',[_vm._v("We honor Do Not Track signals and Do Not Track, plant cookies, or use advertising when a Do Not Track (DNT) browser mechanism is in place.")]),_vm._v(" "),_c('h4',[_vm._v("research")]),_vm._v(" "),_c('p',[_vm._v("In support of eHealth initiatives, we may use and share your medical information for research. We will only use and share information for research after obtaining your consent or if the used data does not expressly identify you in any way.")]),_vm._v(" "),_c('h4',[_vm._v("studies and reports")]),_vm._v(" "),_c('p',[_vm._v("We may use your information to study results and produce reports. Such information may be shared with Our partners and advertisers under the sole discretion of the Company.")]),_vm._v(" "),_c('h4',[_vm._v("changes to this privacy policy")]),_vm._v(" "),_c('p',[_vm._v("Any changes we may make to our Policy in the future will be posted on this page and, where appropriate, notified to you by e-mail. Please check back frequently to see any updates or changes to our Policy.")]),_vm._v(" "),_c('h4',[_vm._v("phishing")]),_vm._v(" "),_c('p',[_vm._v("Identity theft and the fraudulent practice currently known as \"phishing\" are of great concern to Us. Phishing is an attempt to acquire personal/sensitive information which the legitimate organization already has. Safeguarding information to help protect You from identity theft is a top priority. We do not and will not, at any time, request Your credit card information or national identification numbers in a non-secure or unsolicited e-mail or telephone communication.")]),_vm._v(" "),_c('h4',[_vm._v("cookies")]),_vm._v(" "),_c('p',[_vm._v("Yes. Cookies are small files that a site or its service provider transfers to your computer's hard drive through your Web browser (if you allow) that enables the site's or service provider's systems to recognize your browser and capture and remember certain information. For instance, We use cookies to help us remember the services/packages obtained by you. They are also used to help us understand your preferences based on previous or current site activity, which enables us to provide you with improved services. We also use cookies to help us compile aggregate data about site traffic and site interaction so that we can offer better site experiences and tools in the future.")]),_vm._v(" "),_c('p',[_vm._v("We use cookies to:")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("Understand and save user's preferences for future visits.")]),_vm._v(" "),_c('li',[_vm._v("Compile aggregate data about site traffic and site interactions in order to offer better site experiences and tools in the future. We may also use trusted third-party services that track this information on our behalf.")])]),_vm._v(" "),_c('p',[_vm._v("You can choose to have Your computer warn you each time a cookie is being sent, or You can choose to turn off all cookies. You can do this through Your browser settings by utilizing the "),_c('i',[_vm._v("Help Menu")]),_vm._v(" to learn the correct way to modify your cookies. If You turn cookies off, some of the features that make Your site experience more efficient may not function properly. It won't affect the User's experience that make Your site experience more efficient and may not function properly. ")]),_vm._v(" "),_c('h4',[_vm._v("contact")]),_vm._v(" "),_c('p',[_vm._v("Our Grievance Officer shall undertake all reasonable efforts to address your grievances at the earliest possible opportunity. You may contact us at:")]),_vm._v(" "),_c('p',[_vm._v("Grievance Officer: Jayaprakaash Jayaraman")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Address:")]),_c('br'),_vm._v("\n                        Flat No 8, 2nd Floor, "),_c('br'),_vm._v("\n                        Old No 4, New No 5 Rajachar Street, "),_c('br'),_vm._v("\n                        T.Nagar, Chennai - 600017")]),_vm._v(" "),_c('p',[_vm._v("Reach out to us on "),_c('i',[_vm._v("support@labotist.com")]),_vm._v(", in case of any queries.")])])])}]
var Address_esExports = { render: Address_render, staticRenderFns: Address_staticRenderFns }
/* harmony default export */ var Secure_Address = (Address_esExports);
// CONCATENATED MODULE: ./src/components/web/Book/Secure/Address.vue
function Address_injectStyle (ssrContext) {
  __webpack_require__("pcMA")
}
var Address_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var Address___vue_template_functional__ = false
/* styles */
var Address___vue_styles__ = Address_injectStyle
/* scopeId */
var Address___vue_scopeId__ = "data-v-79f66a28"
/* moduleIdentifier (server only) */
var Address___vue_module_identifier__ = null
var Address_Component = Address_normalizeComponent(
  Address["a" /* default */],
  Secure_Address,
  Address___vue_template_functional__,
  Address___vue_styles__,
  Address___vue_scopeId__,
  Address___vue_module_identifier__
)

/* harmony default export */ var Book_Secure_Address = (Address_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/web/Book/Secure/Payment.vue
//
//
//
//
//

/* harmony default export */ var Payment = ({
  name: 'PaymentSection',
  props: [],
  components: {},
  beforeCreate: function beforeCreate() {},
  data: function data() {
    return {};
  },
  created: function created() {},
  mounted: function mounted() {
    this.$router.push('/address');
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-703da73a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/web/Book/Secure/Payment.vue
var Payment_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"PaymentDiv"}})}
var Payment_staticRenderFns = []
var Payment_esExports = { render: Payment_render, staticRenderFns: Payment_staticRenderFns }
/* harmony default export */ var Secure_Payment = (Payment_esExports);
// CONCATENATED MODULE: ./src/components/web/Book/Secure/Payment.vue
function Payment_injectStyle (ssrContext) {
  __webpack_require__("Wycz")
}
var Payment_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var Payment___vue_template_functional__ = false
/* styles */
var Payment___vue_styles__ = Payment_injectStyle
/* scopeId */
var Payment___vue_scopeId__ = "data-v-703da73a"
/* moduleIdentifier (server only) */
var Payment___vue_module_identifier__ = null
var Payment_Component = Payment_normalizeComponent(
  Payment,
  Secure_Payment,
  Payment___vue_template_functional__,
  Payment___vue_styles__,
  Payment___vue_scopeId__,
  Payment___vue_module_identifier__
)

/* harmony default export */ var Book_Secure_Payment = (Payment_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/web/Book/Secure/Success.vue
var Success = __webpack_require__("64pn");

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ff152292","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/web/Book/Secure/Success.vue
var Success_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"SuccessDiv"}},[_c('HeaderVue',{attrs:{"isHealthCartEnabled":"true"}}),_vm._v(" "),_c('div',{staticClass:"search-section"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_vm._m(0,false,false),_vm._v(" "),_c('div',{staticClass:"col-sm-2"},[_c('router-link',{staticClass:"btn btn-light full-width mar-t-15",attrs:{"to":"/myresult"}},[_vm._v("My Orders")])],1)])])]),_vm._v(" "),(_vm.requestDetails)?_c('div',{staticClass:"portal-section"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-7"},[_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table black-color"},[_c('tr',[_c('td',{staticClass:"no-border text-nowrap"},[_vm._v("Request ID")]),_vm._v(" "),_c('td',{staticClass:"no-border"},[_vm._v(_vm._s('REQ'+_vm.requestDetails.requestId))])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"no-border text-nowrap"},[_vm._v("Patient Name")]),_vm._v(" "),_c('td',{staticClass:"no-border"},[_vm._v(_vm._s(_vm.requestDetails.reqPatientFirstName+' '+_vm.requestDetails.reqPatientLastName))])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"no-border text-nowrap"},[_vm._v("Appointment Date & Time")]),_vm._v(" "),_c('td',{staticClass:"no-border"},[_c('div',{staticClass:"green-outline"},[_vm._v("\n                                        "+_vm._s(_vm.appointmentDate)+"  |  "+_vm._s(_vm.appointmentStartTime)+" to "+_vm._s(_vm.appointmentEndTime)+"\n                                    ")])])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"no-border text-nowrap"},[_vm._v("Sample Collection Address")]),_vm._v(" "),_c('td',{staticClass:"no-border"},[_c('address',[_vm._v("\n                                        "+_vm._s(_vm.requestDetails.pickupAddress)+"\n                                        "),_c('br'),_vm._v(" M: "+_vm._s(_vm.requestDetails.reqPatientMobile)+"\n                                    ")])])])])]),_vm._v(" "),_c('div',{staticClass:"lab display-flex no-border p-0 mt-0"},[_c('div',{staticClass:"flex-box"},[_c('div',{staticClass:"lab-logo"},[(_vm.requestDetails.Lab.logo)?_c('img',{attrs:{"src":_vm.$s3BucketUrl + _vm.requestDetails.Lab.logo}}):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"flex-box"},[_c('h6',{staticClass:"black-color"},[_vm._v(_vm._s(_vm.requestDetails.Lab.labName))]),_vm._v(" "),_c('p',{staticClass:"grey-color"},[_vm._v(_vm._s(_vm.requestDetails.LabBranch.Address.Location.locationName)+", "+_vm._s(_vm.requestDetails.LabBranch.Address.City.cityName)+", "+_vm._s(_vm.requestDetails.LabBranch.Address.State.stateName)+" - "+_vm._s(_vm.requestDetails.LabBranch.Address.zipCode))])])]),_vm._v(" "),_c('div',{staticClass:"table-responsive test-conformation"},[_c('table',{staticClass:"table"},[_vm._m(1,false,false),_vm._v(" "),_c('tbody',{staticClass:"black-color"},[_vm._l((_vm.requestDetails.RequestTests),function(requestTest,index){return _c('tr',{key:index},[(requestTest)?_c('td',{attrs:{"colspan":"2"}},[_c('span',[_vm._v(_vm._s(requestTest.Profile?(requestTest.Profile.panelName):(requestTest.Test.testName)))])]):_vm._e(),_vm._v(" "),_c('td',[_c('span',{staticClass:"float-right"},[_vm._v("\n                                            Rs. "+_vm._s(requestTest.testCost)+"\n                                        ")])])])}),_vm._v(" "),(_vm.requestDetails.phlebCost && _vm.requestDetails.phlebCost > 0)?_c('tr',[_c('td',{staticClass:"no-border"}),_vm._v(" "),_c('td',[_vm._v("Phlebotomist Fee")]),_vm._v(" "),_c('td',[_c('span',{staticClass:"float-right"},[_vm._v("\n                                           + Rs. "+_vm._s(_vm.requestDetails.phlebCost)+"\n                                        ")])]),_vm._v(" "),_c('td')]):_vm._e(),_vm._v(" "),_c('tr',{staticClass:"grey-color"},[_c('td',{staticClass:"no-border"}),_vm._v(" "),_c('td',[_vm._v("Sub Total")]),_vm._v(" "),_c('td',[_c('h5',{staticClass:"float-right mt-1 mb-0 price-tags"},[_vm._v("\n                                            Rs. "+_vm._s((_vm.requestDetails.cost-_vm.requestDetails.discountCost) + (_vm.requestDetails.phlebCost && _vm.requestDetails.phlebCost > 0 ? _vm.requestDetails.phlebCost : 0))+"\n                                        ")])]),_vm._v(" "),_c('td')]),_vm._v(" "),(_vm.requestDetails.couponCost)?_c('tr',[_c('td',{staticClass:"no-border"}),_vm._v(" "),_c('td',[_vm._v("Coupon Discount")]),_vm._v(" "),_c('td',[_c('h5',{staticClass:"float-right mt-1 mb-0 price-tags green-color"},[_vm._v("\n                                            - Rs."+_vm._s(_vm.requestDetails.couponCost)+"\n                                        ")])]),_vm._v(" "),_c('td')]):_vm._e(),_vm._v(" "),(_vm.requestDetails.creditDiscount && _vm.requestDetails.creditDiscount > 0)?_c('tr',[_c('td',{staticClass:"no-border"}),_vm._v(" "),_c('td',[_vm._v("Credits Applied")]),_vm._v(" "),_c('td',[_c('h5',{staticClass:"float-right mt-1 mb-0 price-tags green-color"},[_vm._v("\n                                            - Rs."+_vm._s(_vm.requestDetails.creditDiscount)+"\n                                        ")])]),_vm._v(" "),_c('td')]):_vm._e(),_vm._v(" "),(_vm.requestDetails.paymentType == 1)?_c('tr',[_c('td',{staticClass:"no-border"}),_vm._v(" "),_c('td',{staticClass:"border-bottom"},[_vm._v("Cash Due")]),_vm._v(" "),_c('td',{staticClass:"border-bottom"},[_c('h5',{staticClass:"float-right mt-1 mb-0 price-tags"},[_vm._v("\n                                            Rs. "+_vm._s(_vm.requestDetails.totalUnpaidCost)+"\n                                        ")])]),_vm._v(" "),_c('td',{staticClass:"border-bottom"})]):_c('tr',[_c('td',{staticClass:"no-border"}),_vm._v(" "),_c('td',{staticClass:"border-bottom"},[_vm._v("Amount Paid")]),_vm._v(" "),_c('td',{staticClass:"border-bottom"},[_c('h5',{staticClass:"float-right mt-1 mb-0 price-tags"},[_vm._v("\n                                            Rs. "+_vm._s(_vm.requestDetails.totalPaidCost)+"\n                                        ")])]),_vm._v(" "),_c('td',{staticClass:"border-bottom"})])],2)])]),_vm._v(" "),_c('button',{staticClass:"btn btn-outline-primary mt-4",on:{"click":function($event){_vm.goHome()}}},[_vm._v("\n                        Go to Home page\n                    ")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4 offset-sm-1"})])])]):_vm._e(),_vm._v(" "),_c('FooterVue')],1)}
var Success_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-10"},[_c('div',{staticClass:"check-box float-left mr-3"},[_c('img',{staticClass:"mt-2",attrs:{"src":"static/images/check.png","alt":""}})]),_vm._v(" "),_c('div',{staticClass:"float-left thank-msg"},[_c('h5',{staticClass:"mb-0"},[_vm._v("Thank you, your order has been placed successfully!")]),_vm._v(" "),_c('p',[_vm._v("Our phlebotomist will get in touch with you at the phone number that you have provided before\n                            coming to collect the sample at the address mentioned.")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{staticClass:"no-border"},[_vm._v("Test Name")]),_vm._v(" "),_c('th',{staticClass:"no-border"}),_vm._v(" "),_c('th',{staticClass:"text-right no-border"},[_vm._v("Price")])])])}]
var Success_esExports = { render: Success_render, staticRenderFns: Success_staticRenderFns }
/* harmony default export */ var Secure_Success = (Success_esExports);
// CONCATENATED MODULE: ./src/components/web/Book/Secure/Success.vue
function Success_injectStyle (ssrContext) {
  __webpack_require__("MFNR")
}
var Success_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var Success___vue_template_functional__ = false
/* styles */
var Success___vue_styles__ = Success_injectStyle
/* scopeId */
var Success___vue_scopeId__ = "data-v-ff152292"
/* moduleIdentifier (server only) */
var Success___vue_module_identifier__ = null
var Success_Component = Success_normalizeComponent(
  Success["a" /* default */],
  Secure_Success,
  Success___vue_template_functional__,
  Success___vue_styles__,
  Success___vue_scopeId__,
  Success___vue_module_identifier__
)

/* harmony default export */ var Book_Secure_Success = (Success_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/web/BlogFrame.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var BlogFrame = ({
  name: 'BlogFrame',
  components: {},
  beforeCreate: function beforeCreate() {
    this.query = this.$localStorage.get('location');
  },
  data: function data() {
    return {
      onBlurKey: 'none',
      address: '',
      query: this.$localStorage.get('location') ? this.$localStorage.get('location').locationName + '-' + this.$localStorage.get('location').locationZipCode : '',
      items: [],
      selectedLocation: this.$localStorage.get('location') ? this.$localStorage.get('location') : undefined,
      selectedPincode: this.$localStorage.get('pincode') ? this.$localStorage.get('pincode') : undefined,
      locationObj: null
    };
  },

  methods: {
    goTest: function goTest() {
      //   this.query = this.selectedLocation ? this.selectedLocation.locationName + '-' + this.selectedLocation.locationZipCode : ''
      //   if (!this.selectedLocation) {
      //     return false
      //   }
      //   this.$localStorage.set('location', this.selectedLocation, 0)
      //   this.$localStorage.set('pincode', this.selectedLocation.locationZipCode, 0)
      //   this.$root.$emit('bookTest', true)
      window.open(this.$blogRedirectUrl, 'myWindow');
    },
    searchLocation: function searchLocation(query) {
      this.onBlurKey = 'block';
      this.selectedLocation = undefined;
      this.$localStorage.remove('location');
      this.$localStorage.remove('pincode');
      if (this.query.length < 3) {
        this.onBlurKey = 'none';
        this.items = [];
        return false;
      }
      try {
        if (this.$localStorage.get('access_token') && this.$localStorage.get('access_token') != null) {
          var data = {
            'keyword': this.query
          };
          promise_default.a.resolve(this.$POST('patient/searchLocation', data)).then(function (res) {
            console.log(res);
            if (res.response_code === 0) {
              this.items = res.response;
            }
          }.bind(this)).catch(function (err) {
            console.error(err);
          });
        }
      } catch (e) {
        console.error(e);
      }
    },
    closeBlock: function closeBlock() {
      setTimeout(function () {
        this.onBlurKey = 'none';
      }.bind(this), 300);
    },
    selectLocation: function selectLocation(event, obj) {
      this.selectedLocation = undefined;
      this.selectedLocation = obj;
      this.selectedPincode = obj.locationZipCode;
      this.query = obj.locationName + '-' + obj.locationZipCode;
      this.items = [];
      this.onBlurKey = 'none';
    }
  },
  watch: {
    address: function address(val, oldVal) {
      console.log('new: %s, old: %s', val, oldVal);
    }
  },
  mounted: function mounted() {
    this.$hidePageLoading();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b7b9265e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/web/BlogFrame.vue
var BlogFrame_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"BlogDiv"}},[_c('div',{staticClass:"iframe-view"},[_c('div',{staticClass:"text-center pt-0"},[_c('h2',{staticClass:"black-color font-weight-normal text-center"},[_vm._v("Do any medical test at your home")]),_vm._v(" "),_c('img',{attrs:{"src":"static/images/search-code-img.svg","alt":""}}),_vm._v(" "),_c('p',[_vm._v("Our service is currently in Chennai & Bengaluru only")]),_vm._v(" "),_c('div',{staticClass:"banner-fields"},[_c('button',{ref:"pincodeSubmit",staticClass:"btn btn-lg btn-primary mb-3",attrs:{"type":"button"},on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.goTest()},"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }_vm.goTest()}}},[_vm._v("\n                  Book Test\n              ")])])])])])}
var BlogFrame_staticRenderFns = []
var BlogFrame_esExports = { render: BlogFrame_render, staticRenderFns: BlogFrame_staticRenderFns }
/* harmony default export */ var web_BlogFrame = (BlogFrame_esExports);
// CONCATENATED MODULE: ./src/components/web/BlogFrame.vue
function BlogFrame_injectStyle (ssrContext) {
  __webpack_require__("NmNP")
}
var BlogFrame_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var BlogFrame___vue_template_functional__ = false
/* styles */
var BlogFrame___vue_styles__ = BlogFrame_injectStyle
/* scopeId */
var BlogFrame___vue_scopeId__ = "data-v-b7b9265e"
/* moduleIdentifier (server only) */
var BlogFrame___vue_module_identifier__ = null
var BlogFrame_Component = BlogFrame_normalizeComponent(
  BlogFrame,
  web_BlogFrame,
  BlogFrame___vue_template_functional__,
  BlogFrame___vue_styles__,
  BlogFrame___vue_scopeId__,
  BlogFrame___vue_module_identifier__
)

/* harmony default export */ var components_web_BlogFrame = (BlogFrame_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/web/Book/LabLocation.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var LabLocation = ({
  name: 'ChooseLab',
  components: {
    HeaderVue: Header["a" /* default */],
    FooterVue: Footer["a" /* default */]
  },
  beforeCreate: function beforeCreate() {
    // if (!this.$localStorage.get('pincode') || !this.$localStorage.get('st') || this.$localStorage.get('st').length === 0) {
    //   this.$router.push({ path: '/test' })
    //   return false
    // }
  },
  data: function data() {
    return {
      labLimit: 10,
      labTests: {},
      labLists: [],
      selectedLab: [],
      isLabLoading: false,
      labDetails: '',
      selectedProfileAndTest: [],
      totalLabs: [],
      limitedLabs: [],
      _s3BucketUrl: '',
      clickedProfileName: '',
      clickedProfileDetails: [],
      clickedProfileTests: [],
      clickedProfileTestFirst: [],
      clickedProfileTestSecond: [],
      labSearchContent: 'Loading...',
      labContent: false,
      pincodeButton: false,
      ProfileAndTest: [],
      searchContent: {
        test: [],
        profile: []
      },
      masterTestAndProfile: {
        test: [],
        profile: []
      },
      isSearchLoading: false,
      searchtext: '',
      result_focus: '',
      locationList: [],
      locationMasterList: [],
      selectedCity: undefined,
      locality: '',
      pincode: '',
      pincodeError: false,
      onBlurKey: false,
      query: undefined,
      sortBy: 1,
      lowestCost: undefined,
      currentLocation: null,
      locationAllowed: false,
      locationChanged: false,
      popularTests: {},
      sideBannerAds: []
    };
  },

  mounted: function mounted() {
    var _this = this;

    this.$root.$on('removeProfileAndTest', function (selectedProfileAndTest) {
      _this.selectedProfileAndTest = selectedProfileAndTest;
      _this.getLab();
    });
    $('body').click(function (e) {
      if (e.target.id === 'test-option' || $(e.target).parents('#test-option').length) {} else {
        this.searchtext = '';
      }
      if (e.target.id === 'localitySearch' || $(e.target).parents('#localitySearch').length) {} else {
        this.onBlurKey = false;
        this.query = this.locality ? this.locality.locationName : '';
      }
    }.bind(this));
  },
  watch: {
    locationAllowed: function locationAllowed() {
      // this.geolocation()
    }
  },
  created: function created() {
    if (this.$route.params.city) {
      this.getTestByFilter();
    }
    return false;
    // if (this.$localStorage.get('pincode')) {
    //   this.pincode = this.$localStorage.get('pincode')
    // }
    // if (this.$localStorage.get('location')) {
    //   this.locality = this.$localStorage.get('location')
    //   this.query = this.locality.locationName
    // } else {
    //   this.pincodeButton = true
    //   setTimeout(function () {
    //     // this.$refs.pincode.focus()
    //   }.bind(this), 300)
    // }
    // if (this.$localStorage.get('st')) {
    //   this.selectedProfileAndTest = this.$localStorage.get('st')
    // }
    // this.selectedLab = []
    // if (this.$localStorage.get('sl')) {
    //   this.selectedLab = this.$localStorage.get('sl')
    // }

    // this.selectedProfileAndTest = []
    // if (this.$localStorage.get('st')) {
    //   this.selectedProfileAndTest = this.$localStorage.get('st')
    // }
    // this.getLab()
    // this.searchLocation()
  },

  methods: {
    getIncudedTestAndProfile: function getIncudedTestAndProfile(tl) {
      var testCountVal = 0;

      if (tl.profileTestsCount && tl.profileTestsCount > 0) {
        testCountVal = testCountVal + tl.profileTestsCount;
      }
      if (tl.package == 1) {
        if (tl.includedProfiles && tl.includedProfiles.count > 0) {
          tl.includedProfiles.data.forEach(function (testObj) {
            testCountVal = testCountVal + testObj.ProfileTests.length;
          });
        }
      }
      return testCountVal ? testCountVal + ' Tests' : '';
    },
    getIncudedTestAndProfilePop: function getIncudedTestAndProfilePop(tl) {
      var testCountVal = 0;
      console.log(tl);
      if (tl.testCount && tl.testCount > 0) {
        testCountVal = testCountVal + tl.testCount;
      }
      if (tl.package == 1) {
        if (tl.includedProfiles && tl.includedProfiles.count > 0) {
          tl.includedProfiles.data.forEach(function (testObj) {
            testCountVal = testCountVal + testObj.ProfileTests.length;
          });
        }
      }
      return testCountVal ? testCountVal + ' Tests' : '';
    },
    getIncudedTestAndProfilePopup: function getIncudedTestAndProfilePopup(tl) {
      var profileCountStr = '';
      if (tl.package == 1) {
        if (tl.includedProfiles && tl.includedProfiles.count > 0) {
          profileCountStr = tl.includedProfiles.count + ' Profiles';
        }
      }
      var testCountStr = '';
      if (tl.profileTestsCount && tl.profileTestsCount > 0) {
        testCountStr = tl.profileTestsCount + ' Tests';
      }
      return profileCountStr + (profileCountStr.length > 0 && testCountStr.length > 0 ? ' & ' : '') + testCountStr;
    },
    getIncudedTestAndProfilePopular: function getIncudedTestAndProfilePopular(tl) {
      var testCountVal = 0;
      if (tl.ProfileTests && tl.ProfileTests.length > 0) {
        testCountVal = testCountVal + tl.ProfileTests.length;
      }
      if (tl.package == 1) {
        if (tl.includedProfiles && tl.includedProfiles.count > 0) {
          tl.includedProfiles.data.forEach(function (testObj) {
            testCountVal = testCountVal + testObj.ProfileTests.length;
          });
        }
      }
      return testCountVal ? testCountVal + ' Tests' : '';
    },
    geolocation: function geolocation() {
      var options = {
        maximumAge: 60000,
        timeout: 5000,
        enableHighAccuracy: true
      };
      navigator.geolocation.getCurrentPosition(function (position) {
        console.log('im tracking you!');
        this.currentLocation = {
          lat: position.coords.latitude,
          lng: position.coords.longitude
        };
        this.changeCityUsingLocation();
        return false;
      }.bind(this), function (error) {
        if (error.code === error.PERMISSION_DENIED) {
          console.log('you denied me :-(');
          this.locationAllowed = false;
          if (!this.$localStorage.get('sc') && this.selectedCity) {
            this.$localStorage.set('sc', this.selectedCity);
          }
        }
      }.bind(this)), options;
    },
    changeCityUsingLocation: function changeCityUsingLocation() {
      var data = {
        coordinates: this.currentLocation
      };
      promise_default.a.resolve(this.$POST('patient/getCityUsingLocation', data)).then(function (res) {
        if (res.response_code === 0) {
          if (!this.$localStorage.get('sc')) {
            this.locationMasterList.forEach(function (city) {
              if (res.response.cityId === city.cityId) {
                if (this.selectedCity.cityId !== city.cityId) {
                  this.selectedCity = city;
                  this.$localStorage.set('sc', this.selectedCity);
                  this.selectBannerAds();
                  this.locationList = city.ActiveLocation;
                  this.selectedCity.ActiveLocation.forEach(function (loc) {
                    if (res.response.locationId === loc.locationId) {
                      this.locality = loc;
                      this.pincode = loc.locationZipCode;
                      this.query = loc.locationName;
                      this.$localStorage.set('location', loc, 0);
                      this.$localStorage.set('pincode', this.pincode, 0);
                    }
                  }.bind(this));
                  this.onCityChange();
                } else {
                  if (!this.$localStorage.get('location')) {
                    this.selectedCity.ActiveLocation.forEach(function (loc) {
                      if (res.response.locationId === loc.locationId) {
                        this.locality = loc;
                        this.pincode = loc.locationZipCode;
                        this.query = loc.locationName;
                        this.$localStorage.set('location', loc, 0);
                        this.$localStorage.set('pincode', this.pincode, 0);
                      }
                    }.bind(this));
                  }
                }
                this.getLab();
              }
            }.bind(this));
          } else if (!this.$localStorage.get('location')) {
            this.selectedCity.ActiveLocation.forEach(function (loc) {
              if (res.response.locationId === loc.locationId) {
                this.locality = loc;
                this.pincode = loc.locationZipCode;
                this.query = loc.locationName;
                this.$localStorage.set('location', loc, 0);
                this.$localStorage.set('pincode', this.pincode, 0);
                this.$router.push('/labs/' + this.selectedCity.cityName + '/' + this.$route.params.test + '/' + loc.locationName);
              }
            }.bind(this));
            this.getLab();
          }
          if (!this.$localStorage.get('sc') && this.selectedCity) {
            this.$localStorage.set('sc', this.selectedCity);
          }
        } else {
          if (!this.$localStorage.get('sc') && this.selectedCity) {
            this.$localStorage.set('sc', this.selectedCity);
          }
        }
      }.bind(this)).catch(function (err) {
        console.error(err);
      });
    },
    getLocation: function getLocation() {
      var data = {
        currentLocation: this.currentLocation,
        locationAllowed: this.locationAllowed
      };
      promise_default.a.resolve(this.$POST('patient/getCityAndLocation', data)).then(function (res) {
        console.log(res);
        if (res.response_code === 0) {
          this.locationMasterList = res.response;
          if (this.selectedCity) {
            this.locationMasterList.forEach(function (city) {
              if (this.selectedCity.cityId === city.cityId) {
                this.selectedCity = city;
                this.$localStorage.set('sc', this.selectedCity);
                this.selectBannerAds();
                this.locationList = city.ActiveLocation;
              }
            }.bind(this));
          } else {
            if (this.locationMasterList.length > 0) {
              this.selectedCity = this.locationMasterList[0];
              this.$localStorage.set('sc', this.selectedCity);
              this.selectBannerAds();
              this.locationList = this.locationMasterList[0].ActiveLocation;
            } else {
              this.selectedCity = undefined;
              this.locationList = [];
            }
          }
        }
      }.bind(this)).catch(function (err) {
        console.error(err);
      });
    },
    getPopularTest: function getPopularTest() {
      var data = {
        selectedProfileAndTest: this.selectedProfileAndTest
      };
      promise_default.a.resolve(this.$POST('patient/getPopularTestList', data)).then(function (res) {
        if (res.response_code === 0) {
          this.popularTests = res.response;
          this.$hidePageLoading();
        }
      }.bind(this)).catch(function (err) {
        console.error(err);
      });
    },
    labSortOrder: function labSortOrder() {
      if (this.sortBy === '1') {
        this.labLists.sort(function (a, b) {
          a = a.ourCost;
          b = b.ourCost;
          return a < b ? -1 : 1;
        });
      } else if (this.sortBy === '2') {
        this.labLists.sort(function (a, b) {
          a = a.ourCost;
          b = b.ourCost;
          return a > b ? -1 : 1;
        });
      } else if (this.sortBy === '3') {
        this.labLists.sort(function (a, b) {
          a = a.rating;
          b = b.rating;
          return a > b ? -1 : 1;
        });
      }
      // this.getLab()
    },
    adsRedirect: function adsRedirect(url) {
      if (this.pincode && this.pincode.length === 6) {
        url = url + '/' + this.locality.locationName;
      }
      window.open(url, '_blank');
    },
    getTestByFilter: function getTestByFilter(type) {
      var testsArr = [];
      if (this.$route.params.test && this.$route.params.test.length > 0) {
        var testKeyArray = this.$route.params.test.split('&');
        testKeyArray.forEach(function (testName) {
          var testNameData = testName ? testName.split('_').join(' ') : '';
          testsArr.push(testNameData);
        });
      }
      var locationKey = this.$route.params.location ? this.$route.params.location.split('_').join(' ') : '';
      var data = {
        'city': this.$route.params.city ? this.$route.params.city : '',
        'location': this.$route.params.location ? locationKey : undefined,
        'test': testsArr
      };
      this.$localStorage.remove('sc');
      this.$localStorage.remove('location');
      this.$localStorage.remove('pincode');
      this.$localStorage.remove('st');
      promise_default.a.resolve(this.$POST('patient/getTestByFilter', data)).then(function (res) {
        // this.geolocation()
        this.getLocation();
        if (res.response_code === 0) {
          if (res.response.city && res.response.city != null) {
            this.selectedCity = res.response.city;
            this.$localStorage.set('sc', this.selectedCity);
            this.selectBannerAds();
            if (res.response.city.ActiveLocation && res.response.city.ActiveLocation.length > 0) {
              this.$localStorage.set('location', res.response.city.ActiveLocation[0]);
              this.$localStorage.set('pincode', res.response.city.ActiveLocation[0].locationZipCode);
              this.closePopup(0);
            } else {
              this.geolocation();
              if (!this.$localStorage.get('ftp')) {
                this.$localStorage.set('ftp', 'YES', 0);
                $('.carousel').carousel({
                  interval: 2000
                });
                // $('html').css({"position":"fixed", "width":"100%"})
                setTimeout(function () {
                  $('.flash-message').css('opacity', '1');
                  $('.black-overlay').css('opacity', '1');
                }, 1000);
              } else {
                // this.$localStorage.remove('ftp')
                this.closePopup(0);
              }
            }
          }
          // if (res.response.location && res.response.location != null) {
          //   // this.$localStorage.set('location',res.response.location)
          //   // this.$localStorage.set('pincode', res.response.location.locationZipCode)
          //   // this.closePopup(0)
          // } else {
          //   if (!this.$localStorage.get('ftp')) {
          //     this.$localStorage.set('ftp','YES',0)
          //     $('.carousel').carousel({
          //       interval: 2000
          //     })
          //     // $('html').css({"position":"fixed", "width":"100%"})
          //     setTimeout(function () {
          //       $('.flash-message').css("opacity", "1")
          //       $('.black-overlay').css("opacity", "1")
          //       // this.$refs.pincodePopup.focus()
          //     }.bind(this), 1000)
          //   } else {
          //     // this.$localStorage.remove('ftp')
          //     this.closePopup(0)
          //   }
          // }
          if (res.response.selectedTest && res.response.selectedTest.length > 0) {
            this.selectedProfileAndTest = [];
            document.title = res.response.selectedTest[0].name + ' - Labotist';
            this.selectedProfileAndTest = res.response.selectedTest;
            this.$localStorage.set('st', this.selectedProfileAndTest);
            this.$root.$emit('selectedProfileAndTest', this.selectedProfileAndTest);
            this.getLab(res.response.selectedTest.name);
          } else {
            this.selectedLab = [];
            this.labSearchContent = 'No labs found in your searched locations.';
            this.$localStorage.remove('sl');
          }
          this.afterCreate();
          this.getPopularTest();
          this.getAllProfileAndTests();
        }
        this.$hidePageLoading();
      }.bind(this)).catch(function (err) {
        console.error(err);
      });
    },
    closePopup: function closePopup(type) {
      if (type === 1) {
        if (!this.pincode || this.pincode.length !== 6) {
          this.showLocalityError = true;
          return false;
        }
      }
      if (type === 2) {
        this.query = undefined;
        // $('html').css({"position":"relative", "width":"100%"})
      }
      if (type === 3) {
        // $('html').css({"position":"relative", "width":"100%"})
      }
      $('.flash-message').addClass('bounce');
      $('.black-overlay').css('opacity', '0');
      setTimeout(function () {
        $('.flash-message').css('opacity', '0');
        $('.flash-message').css('bottom', '-500px');
        $('.black-overlay').css('display', 'none');
        setTimeout(function () {
          $('.flash-message').css('display', 'none');
        }, 400);
      }, 400);
    },
    afterCreate: function afterCreate() {
      if (this.$localStorage.get('pincode')) {
        this.pincode = this.$localStorage.get('pincode');
      }
      if (this.$localStorage.get('location')) {
        this.locality = this.$localStorage.get('location');
        this.query = this.locality.locationName;
      } else {
        this.pincodeButton = true;
        // setTimeout(function () {
        //   this.$refs.pincodePopup.focus()
        // }.bind(this), 300)
      }
    },
    loadMore: function loadMore() {
      var increamented = this.labLimit + 10;
      this.labLimit = increamented > this.labLists.length ? this.labLists.length : increamented;
    },
    goSearch: function goSearch() {
      this.$router.push({ path: '/lab' });
    },
    goChooseDate: function goChooseDate(lab) {
      if (!this.locality || !this.selectedCity) {
        var confirmFn = function () {
          setTimeout(function () {
            this.$refs.pincode.focus();
          }.bind(this), 300);
        }.bind(this);
        this.$Simplert.open({
          title: 'Information',
          message: 'Please choose your nearest locality',
          type: 'warning',
          useConfirmBtn: false,
          onClose: confirmFn,
          customCloseBtnText: 'Ok',
          disableOverlayClick: true,
          showXclose: true
        });
        return false;
      }
      this.$localStorage.remove('location');
      this.$localStorage.remove('pincode');
      this.$localStorage.remove('sc');
      this.$localStorage.set('location', this.locality);
      this.$localStorage.set('pincode', this.locality.locationZipCode);
      this.$localStorage.set('sc', this.selectedCity);

      this.$localStorage.remove('ct');
      this.$localStorage.remove('cou');
      if (this.$localStorage.get('sl')) {
        if (this.$localStorage.get('sl').labId !== lab.labId) {
          this.$localStorage.remove('ct');
        }
      }
      this.selectedLab = lab;
      this.$localStorage.set('sl', lab, 30 * 60 * 1000);
      this.$localStorage.set('st', this.selectedProfileAndTest);
      vue_esm["default"].analytics.fbq.event('ViewContent', {
        content_ids: lab.labId,
        content_name: lab.labName,
        contents: {
          id: lab.labId,
          name: lab.labName
        },
        content_type: 'LAB'
      });
      this.$router.push({ path: '/appointment' });
    },
    openProfileTestList: function openProfileTestList(profileName, testinfo, tl) {
      this.clickedProfileDetails = {};
      this.clickedProfileTests = [];
      this.clickedProfileName = profileName;
      this.clickedProfileDetails = tl;
      this.clickedProfileTestFirst = [];
      this.clickedProfileTestSecond = [];
      if (tl.testNames) {
        this.clickedProfileTests = tl.testNames.split(',');
        var profileCount = this.clickedProfileDetails.includedProfiles ? this.clickedProfileDetails.includedProfiles.count : 0;
        var testCount = this.clickedProfileTests.length;
        var totalCount = profileCount + testCount;
        if (totalCount > 8) {
          if (totalCount > 5) {
            this.clickedProfileTestFirst = this.clickedProfileTests.slice(0, parseInt(this.clickedProfileTests.length / 2) + this.clickedProfileTests.length % 2 - profileCount);
            this.clickedProfileTestSecond = this.clickedProfileTests.slice(parseInt(this.clickedProfileTests.length / 2) + this.clickedProfileTests.length % 2 - profileCount, this.clickedProfileTests.length);
          } else {
            this.clickedProfileTestFirst = this.clickedProfileTests;
          }
        } else {
          this.clickedProfileTestFirst = this.clickedProfileTests;
        }
      }
      $('#lab_test-popup').modal('show');
      // this.clickedProfileTests = (tl.testNames)
    },
    openPopularProfileTestList: function openPopularProfileTestList(profile) {
      profile['testCount'] = profile.ProfileTests ? profile.ProfileTests.length : 0;
      profile['aliasName'] = profile.name;
      this.clickedProfileDetails = [];
      this.clickedProfileTests = [];
      this.clickedProfileName = profile.name;
      this.clickedProfileDetails = profile;
      this.clickedProfileTestFirst = [];
      this.clickedProfileTestSecond = [];
      if (profile.ProfileTests) {
        this.clickedProfileTests = profile.ProfileTests;
        if (this.clickedProfileTests.length > 8) {
          if (this.clickedProfileTests.length > 5) {
            this.clickedProfileTestFirst = this.clickedProfileTests.slice(0, parseInt(this.clickedProfileTests.length / 2) + this.clickedProfileTests.length % 2);
            this.clickedProfileTestSecond = this.clickedProfileTests.slice(parseInt(this.clickedProfileTests.length / 2) + this.clickedProfileTests.length % 2, this.clickedProfileTests.length);
          } else {
            this.clickedProfileTestFirst = this.clickedProfileTests;
          }
        } else {
          this.clickedProfileTestFirst = this.clickedProfileTests;
        }
      }
      $('#test-popup').modal('show');
    },
    getLab: function getLab(selectedTestName) {
      this.labContent = false;
      this.ProfileAndTest = [];
      this.labLists = [];
      this.isLabLoading = true;
      var data = {
        'zipCode': this.$localStorage.get('pincode'),
        'locality': this.$localStorage.get('location') ? this.$localStorage.get('location') : null,
        'locationCoordinate': this.$localStorage.get('location') ? this.$localStorage.get('location').locationCoordinate : null,
        'sortBy': this.sortBy,
        'city': this.selectedCity
      };
      var test = [];
      if (this.selectedProfileAndTest.length > 0) {
        this.selectedProfileAndTest.forEach(function (element) {
          if (element.testId > 0) {
            test.push(element.testId);
          }
        }, this);
      }
      data.test = test;

      var profile = [];
      if (this.selectedProfileAndTest.length > 0) {
        this.selectedProfileAndTest.forEach(function (element) {
          if (element.panelId > 0) {
            profile.push(element.panelId);
          }
        }, this);
      }
      data.profile = profile;
      promise_default.a.resolve(this.$POST('patient/getLab', data)).then(function (res) {
        if (res.response_code === 0) {
          this.isLabLoading = false;
          this.s3BucketUrl = this.$_s3BucketUrl;
          this.labContent = true;
          if (res.response.labList.length > 0) {
            this.labLists = res.response.labList;
            this.lowestCost = res.response.lowestCost;
            if (selectedTestName) {
              var description = 'Book ' + selectedTestName + ', Starting from Rs.' + res.response.lowestCost + ' in ' + (this.$localStorage.get('location') ? this.$localStorage.get('location').locationName : this.selectedCity.cityName) + '. Hygienic and top notch home sample collection';
              this.appendMetaTag(description);
            }
          } else {
            this.selectedLab = [];
            this.labSearchContent = 'No labs found in your searched locations.';
            this.$localStorage.remove('sl');
          }
        } else {
          this.isLabLoading = false;
          this.selectedLab = [];
          this.labSearchContent = 'No labs found in your searched locations.';
          this.$localStorage.remove('sl');
        }
        this.$hidePageLoading();
      }.bind(this)).catch(function (err) {
        console.error(err);
      });
    },
    appendMetaTag: function appendMetaTag(description) {
      var metatag = document.head.querySelector("meta[name='description']");
      if (metatag) {
        metatag.content = description;
      }
      var ogmetatag = document.head.querySelector("meta[property='og:description']");
      if (ogmetatag) {
        ogmetatag.content = description;
      }
    },
    getLabDetails: function getLabDetails(lab) {
      try {
        this.labDetails = '';
        if (this.$localStorage.get('access_token') && this.$localStorage.get('access_token') !== null) {
          var data = {
            'labId': lab.labId
          };
          promise_default.a.resolve(this.$POST('patient/getLabDetails', data)).then(function (res) {
            if (res.response_code === 0) {
              this.labDetails = res.response;
            }
          }.bind(this)).catch(function (err) {
            console.error(err);
          });
        }
      } catch (e) {
        console.error(e);
      }
    },
    clearProfileAndTests: function clearProfileAndTests() {
      this.searchContent = {
        test: [],
        profile: []
      };
    },
    getAllProfileAndTests: function getAllProfileAndTests() {
      var data = {
        'keyword': this.searchtext,
        selectedProfileAndTest: this.selectedProfileAndTest
      };
      promise_default.a.resolve(this.$POST('patient/getProfileAndTestList', data)).then(function (res) {
        if (res.response_code === 0) {
          if (!res.response.test || !res.response.profile) {
            this.isSearchLoading = 'No Result';
          } else {
            this.masterTestAndProfile = {
              test: res.response.test,
              profile: res.response.profile
            };
          }
        }
      }.bind(this)).catch(function (err) {
        console.error(err);
      });
    },
    getProfileAndTests_old: function getProfileAndTests_old() {
      // this.searchContent = ''
      this.isSearchLoading = 'Loading...';
      var data = {
        'keyword': this.searchtext,
        selectedProfileAndTest: this.selectedProfileAndTest
      };
      promise_default.a.resolve(this.$POST('patient/getProfileAndTestList', data)).then(function (res) {
        if (res.response_code === 0) {
          if (!res.response.test || !res.response.profile) {
            this.isSearchLoading = 'No Result';
          } else {
            this.isSearchLoading = false;
            var test = res.response.test.sort(this.testSort);
            var profile = res.response.profile.sort(this.testSort);
            // test = test.sort(this.profileSort)
            // profile = profile.sort(this.profileSort)
            this.searchContent = {
              test: test,
              profile: profile
            };
            console.log(this.searchContent);
          }
        }
      }.bind(this)).catch(function (err) {
        console.error(err);
      });
    },
    getProfileAndTests: function getProfileAndTests() {
      this.isSearchLoading = 'Loading...';
      var data = {
        'keyword': this.searchtext,
        selectedProfileAndTest: this.selectedProfileAndTest
      };
      this.isSearchLoading = 'Loading...';
      var profileOptions = {
        shouldSort: true,
        threshold: 0.6,
        location: 0,
        // distance: 20,
        maxPatternLength: 32,
        minMatchCharLength: 1,
        keys: ["name", "Keywords", "ProfileTests"]
      };

      var testFuse = new fuse_default.a(this.masterTestAndProfile.test, profileOptions); // "list" is the item array

      var profileFuse = new fuse_default.a(this.masterTestAndProfile.profile, profileOptions); // "list" is the item array
      this.searchContent = {
        test: testFuse.search(this.searchtext),
        profile: profileFuse.search(this.searchtext)
      };
      this.isSearchLoading = false;
    },
    testSort: function testSort(a, b) {
      a = a.name.toUpperCase();
      b = b.name.toUpperCase();
      if (a.indexOf(this.searchtext.toUpperCase()) === -1) {
        return 1;
      } else if (b.indexOf(this.searchtext.toUpperCase()) === -1) {
        return -1;
      }
      return a.indexOf(this.searchtext.toUpperCase()) < b.indexOf(this.searchtext.toUpperCase()) ? -1 : 1;
    },
    addTestFromDropdown: function addTestFromDropdown(event, test) {
      if (test.isSelected === 1) {
        return false;
      }
      if (test.testId === 0) {
        this.addTestAndProfile(test);
      } else {
        var filterProfile = [];
        underscore_default.a.each(this.selectedProfileAndTest, function (ele, key) {
          if (ele.testId === 0) {
            filterProfile.push(ele);
          }
        });
        if (filterProfile.length > 0) {
          var LabProfileTestsCount = 0;
          var splitArrayCount = 0;
          var isExistsCount = 0;
          var ExistsArray = [];
          underscore_default.a.each(filterProfile, function (value, key) {
            if (value.LabProfileTests && value.LabProfileTests !== '') {
              var splitArray = value.LabProfileTests.split(',').map(function (item) {
                return item.trim().toUpperCase();
              });
              if (splitArray.indexOf(test.name.toUpperCase()) === '-1') {
                splitArrayCount++;
              } else {
                isExistsCount++;
                ExistsArray.push(value.name);
              }
            } else {
              LabProfileTestsCount++;
            }
          });
          if (LabProfileTestsCount === filterProfile.length) {
            this.addTestAndProfile(test);
          } else if (splitArrayCount === filterProfile.length) {
            this.addTestAndProfile(test);
          } else if (isExistsCount > 0) {
            var confirmFn = function () {
              this.addTestAndProfile(test, true);
            }.bind(this);

            this.$Simplert.open({
              title: 'Confirm',
              message: 'The test that you have selected is already included in one of the profile added to the cart\u201D Just have ok button, no need for cancel.',
              type: 'info',
              useConfirmBtn: true,
              onConfirm: confirmFn,
              customConfirmBtnText: 'Ok',
              customCloseBtnText: 'Cancel',
              disableOverlayClick: true
            });
          } else {
            this.addTestAndProfile(test);
          }
        } else {
          this.addTestAndProfile(test);
        }
      }
    },
    addTestAndProfile: function addTestAndProfile(test, isPopup) {
      this.$localStorage.remove('sl');
      this.$localStorage.remove('ct');
      this.$localStorage.remove('cou');
      if (underscore_default.a.pluck(this.selectedProfileAndTest, 'name').indexOf(test.name) === -1) {
        this.selectedProfileAndTest.push(test);
        if (isPopup) {
          this.$apply(function () {
            this.selectedProfileAndTest = underscore_default.a.uniq(this.selectedProfileAndTest);
          });
        } else {
          this.selectedProfileAndTest = underscore_default.a.uniq(this.selectedProfileAndTest);
        }
        var testFB = {
          id: test.testId === 0 ? test.panelId : test.testId,
          isTest: test.testId === 0 ? 0 : 1,
          name: test.name
        };
        if (test.testId === 0) {
          vue_esm["default"].analytics.fbq.event('ViewContent', {
            content_ids: test.testId === 0 ? test.panelId : test.testId,
            content_name: test.name,
            contents: testFB,
            content_type: 'PROFILE'
          });
        } else {
          vue_esm["default"].analytics.fbq.event('ViewContent', {
            content_ids: test.testId === 0 ? test.panelId : test.testId,
            content_name: test.name,
            contents: testFB,
            content_type: 'TEST'
          });
        }
        this.$localStorage.set('st', this.selectedProfileAndTest);
        this.$root.$emit('selectedProfileAndTest', this.selectedProfileAndTest);
      }
      this.searchtext = '';
      // this.getLab()
      // this.getPopularTest()
      this.$router.push({ path: '/lab' });
    },
    removeSelectedItems: function removeSelectedItems(items) {
      var index = this.selectedProfileAndTest.indexOf(items);
      this.selectedProfileAndTest.splice(index, 1);
      this.$localStorage.set('st', this.selectedProfileAndTest, 0);
      this.$localStorage.remove('cou');
      if (this.selectedProfileAndTest.length === 0) {
        this.$localStorage.remove('sl');
        this.$localStorage.remove('ct');
      }
      var lab = this.$localStorage.get('sl');
      var labTests = [];
      this.$localStorage.remove('sl');
      if (lab) {
        lab.labTestList.forEach(function (labTest) {
          if (!(items.testId === labTest.testId && labTest.testId !== 0 || items.panelId === labTest.panelId && labTest.panelId !== 0)) {
            labTests.push(labTest);
          }
        });
        lab.labTestList = labTests;
      }
      this.$localStorage.set('sl', lab, 30 * 60 * 1000);

      this.$root.$emit('selectedProfileAndTest', this.selectedProfileAndTest);
      // this.getLab()
      // this.getPopularTest()
      this.$router.push({ path: '/lab' });
    },
    searchLocation: function searchLocation() {
      // this.onBlurKey = true
      this.locality = undefined;
      this.pincode = undefined;
      var pincode = this.$localStorage.get('pincode');
      this.$localStorage.remove('location');
      this.$localStorage.remove('pincode');
      if (pincode) {
        this.getLab();
      }

      // if (this.query.length < 3) {
      //   this.onBlurKey = false
      //   this.locationList = []
      //   return false
      // }
      try {
        if (this.$localStorage.get('access_token') && this.$localStorage.get('access_token') !== null) {
          var data = {
            'keyword': ''
          };
          promise_default.a.resolve(this.$POST('patient/searchLocation', data)).then(function (res) {
            console.log(res);
            if (res.response_code === 0) {
              this.locationList = res.response;
              this.locationMasterList = res.response;
            }
          }.bind(this)).catch(function (err) {
            console.error(err);
          });
        }
      } catch (e) {
        console.error(e);
      }
    },
    onCityChange: function onCityChange() {
      var localityCheck = undefined;
      this.$localStorage.set('sc', this.selectedCity);
      this.$localStorage.remove('sl');
      this.$localStorage.remove('ct');
      this.$localStorage.remove('cou');
      this.selectBannerAds();
      this.selectedCity.ActiveLocation.forEach(function (location) {
        if (this.locality && this.locality.locationId === location.locationId) {
          localityCheck = location;
        }
      }.bind(this));
      if (!localityCheck) {
        this.locality = undefined;
        this.pincode = '';
        this.query = '';
        this.$localStorage.remove('location');
        this.$localStorage.remove('pincode');
      }
      // this.getLab()
      this.$router.push({ path: '/lab' });
    },
    locationFilterAlphabet: function locationFilterAlphabet(a, b) {
      a = a.locationName;
      b = b.locationName;
      if (a < b) return -1;
      if (a > b) return 1;
      return 0;
    },
    locationFilter: function locationFilter(a, b) {
      a = a.locationName.toUpperCase();
      b = b.locationName.toUpperCase();
      if (a.indexOf(this.query.toUpperCase()) === -1) {
        return 1;
      } else if (b.indexOf(this.query.toUpperCase()) === -1) {
        return -1;
      }
      return a.indexOf(this.query.toUpperCase()) < b.indexOf(this.query.toUpperCase()) ? -1 : 1;
    },
    showHideLocation: function showHideLocation() {
      this.onBlurKey = true;
      if (this.query.length === 0) {
        this.locationList = this.selectedCity.ActiveLocation.sort(this.locationFilterAlphabet);
      } else {
        var locationFilter = this.selectedCity.ActiveLocation.filter(function (locationVal) {
          var locality = locationVal.locationName;
          if (!locality) return false;
          locality = locality.toLowerCase();
          return locality.includes(this.query.toLowerCase());
        }.bind(this));
        this.locationList = locationFilter.sort(this.locationFilter);
      }
    },
    closeBlock: function closeBlock() {
      this.pincodeButton = false;
      // setTimeout(function () {
      //   this.onBlurKey = false
      // }.bind(this), 300)
    },
    closeBlockTest: function closeBlockTest() {
      setTimeout(function () {
        this.searchtext = '';
      }.bind(this), 300);
    },
    selectLocation: function selectLocation(obj) {
      this.locality = undefined;
      this.locality = obj;
      this.pincode = obj.locationZipCode;
      this.query = obj.locationName;
      // this.locationList = []
      this.onBlurKey = false;
      vue_esm["default"].analytics.fbq.event('ViewContent', {
        content_ids: this.locality.locationId,
        content_name: this.locality.locationZipCode,
        contents: {
          id: this.locality.locationId,
          location: this.locality.locationName,
          zipcode: this.locality.locationZipCode
        },
        content_type: 'PINCODE_ENTERED'
      });
      this.$localStorage.remove('sl');
      this.$localStorage.remove('ct');
      this.$localStorage.remove('cou');
      this.$localStorage.remove('location');
      this.$localStorage.set('location', this.locality, 0);
      this.$localStorage.remove('pincode');
      this.$localStorage.set('pincode', this.locality.locationZipCode, 0);
      // this.getLab()
      this.$router.push('/lab');
    },
    selectBannerAds: function selectBannerAds() {
      if (this.selectedCity.cityId === 2) {
        var city = this.selectedCity.cityName;
        city = city.toLowerCase();
        this.sideBannerAds = [{
          url: '/labs/' + city + '/comprehensive_health_checkup',
          src: 'static/images/banner/comprehensive.jpg'
        }, {
          url: '/labs/' + city + '/General_Health_Checkup',
          src: 'static/images/banner/general.jpg'
        }, {
          url: '/labs/' + city + '/Hypertension_checkup',
          src: 'static/images/banner/hyper.jpg'
        }, {
          url: '/labs/' + city + '/thyroid_function_test_tft',
          src: 'static/images/banner/loosing.jpg'
        }, {
          url: '/labs/' + city + '/thyroid_function_test_advance',
          src: 'static/images/banner/eating.jpg'
        }];
      } else if (this.selectedCity.cityId === 33) {
        var _city = this.selectedCity.cityName;
        _city = _city.toLowerCase();
        this.sideBannerAds = [{
          url: '/labs/' + _city + '/General_Health_Checkup',
          src: 'static/images/banner/general.jpg'
        }, {
          url: '/labs/' + _city + '/comprehensive_health_checkup',
          src: 'static/images/banner/comprehensive.jpg'
        }, {
          url: '/labs/' + _city + '/Hypertension_checkup',
          src: 'static/images/banner/hyper.jpg'
        }, {
          url: '/labs/' + _city + '/thyroid_function_test_tft',
          src: 'static/images/banner/loosing.jpg'
        }, {
          url: '/labs/' + _city + '/thyroid_function_test_advance',
          src: 'static/images/banner/eating.jpg'
        }];
      } else {
        this.sideBannerAds = [];
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fe97abb4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/web/Book/LabLocation.vue
var LabLocation_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"LabDiv"}},[_c('HeaderVue'),_vm._v(" "),_c('div',{staticClass:"search-section"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12 col-lg-5"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Select City & Locality")]),_vm._v(" "),_c('div',{staticClass:"input-group mb-2 w-40 float-left"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedCity),expression:"selectedCity"}],staticClass:"form-control remove-right-radius",on:{"click":function($event){_vm.onBlurKey=false;},"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedCity=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){_vm.onCityChange()}]}},_vm._l((_vm.locationMasterList),function(city,index){return _c('option',{key:index,domProps:{"value":city}},[_vm._v(_vm._s(city.cityName))])}))]),_vm._v(" "),_c('div',{staticClass:"input-group mb-2 w-60 float-left",attrs:{"id":"localitySearch"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.query),expression:"query"}],ref:"pincode",staticClass:"form-control remove-left-radius",attrs:{"type":"text","placeholder":"Choose Locality","aria-label":"","name":"x","list":"mycarousel","autocomplete":"off","minlength":"3"},domProps:{"value":(_vm.query)},on:{"blur":function($event){_vm.closeBlock()},"keyup":[function($event){_vm.showHideLocation()},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }_vm.showHideLocation()}],"focus":function($event){_vm.$refs.pincode.select();_vm.searchtext=''; _vm.query=''; _vm.onBlurKey=true; _vm.showHideLocation();},"input":function($event){if($event.target.composing){ return; }_vm.query=$event.target.value}}}),_vm._v(" "),(_vm.onBlurKey)?_c('div',{staticClass:"test-option full-width mt-4 scrollbar locality",staticStyle:{"display":"block"}},[_c('div',{staticClass:"popular-test focus-search p-0"},[_c('ul',{staticClass:"p-0 m-0"},[_vm._l((_vm.locationList),function(item,index){return _c('li',{key:index,staticClass:"p-2",staticStyle:{"border-bottom":"1px"},on:{"click":function($event){_vm.selectLocation(item)}}},[_c('span',[_vm._v(_vm._s(item.locationName)+"\n                                                ")])])}),_vm._v(" "),(_vm.locationList.length === 0)?_c('li',{staticClass:"text-center"},[_vm._v(" --- No Locations ---")]):_vm._e()],2)])]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-12 col-lg-7"},[_c('div',{staticClass:"form-group mb-0"},[_c('label',{staticClass:"ft-s-15"},[_vm._v("Search or Add lab tests")]),_vm._v(" "),_c('div',{staticClass:"input-group mb-2",class:{ 'focused-search': (_vm.searchtext != '') },attrs:{"id":"test-option"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchtext),expression:"searchtext"}],staticClass:"form-control rounded search-terms pl-35",attrs:{"type":"text","placeholder":"Search or Add","aria-label":"","name":"x","list":"mycarousel","autocomplete":"off","minlength":"3"},domProps:{"value":(_vm.searchtext)},on:{"keyup":[function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }_vm.getProfileAndTests()},function($event){_vm.getProfileAndTests()}],"change":function($event){_vm.getProfileAndTests()},"input":function($event){if($event.target.composing){ return; }_vm.searchtext=$event.target.value}}}),_vm._v(" "),_c('img',{staticClass:"search-img",attrs:{"src":"static/images/search.svg","alt":""}}),_vm._v(" "),_c('div',{staticClass:"test-option"},[_c('div',{staticClass:"popular-test focus-search"},[_c('h5',[_vm._v("Test")]),_vm._v(" "),_c('ul',[_vm._l((_vm.searchContent.test),function(test,index){return _c('li',{key:index,on:{"click":function($event){_vm.addTestFromDropdown($event, test)}}},[_c('p',{staticClass:"m-0 capitalize"},[_c('i',{staticClass:"fa fa-plus mr-2"}),_vm._v(" \n                                            "+_vm._s(test.name)+"\n                                            "),(test.isSelected === 1)?_c('i',{staticClass:"fa fa-circle green-color",staticStyle:{"font-size":"11px","margin-left":"3px"}}):_vm._e()]),_vm._v(" "),(test.Keywords)?_c('p',{staticClass:"test-key m-0 pl-4"},[_c('strong',{staticClass:"black-color"},[_vm._v("Also known as:")]),_vm._v(" "),_c('span',{staticClass:"capitalize"},[_vm._v(_vm._s(test.Keywords))])]):_vm._e()])}),_vm._v(" "),(_vm.searchContent.test.length === 0)?_c('li',[_vm._v(" --- No Tests ---")]):_vm._e()],2)]),_vm._v(" "),_c('div',{staticClass:"profile-test"},[_c('h5',[_vm._v("Package")]),_vm._v(" "),_c('ul',[_vm._l((_vm.searchContent.profile),function(profile,index){return _c('li',{key:index,on:{"click":function($event){_vm.addTestFromDropdown($event, profile)}}},[_c('p',{staticClass:"m-0 capitalize"},[_c('i',{staticClass:"fa fa-plus mr-2"}),_vm._v("\n                                                "+_vm._s(profile.name)+"\n                                            "),(profile.isSelected === 1)?_c('i',{staticClass:"fa fa-circle green-color",staticStyle:{"font-size":"11px","margin-left":"3px"}}):_vm._e()]),_vm._v(" "),((profile.testCount && profile.testCount > 0) || (profile.includedProfiles && profile.includedProfiles.count > 0))?_c('p',{staticClass:"test-key m-0 pl-4"},[_c('b',[_vm._v("Includes "+_vm._s(_vm.getIncudedTestAndProfilePop(profile))+" ")])]):_vm._e()])}),_vm._v(" "),(_vm.searchContent.profile.length === 0)?_c('li',[_vm._v(" --- No Profiles --- ")]):_vm._e()],2)])]),_vm._v(" "),(_vm.isSearchLoading)?_c('div',{staticClass:"test-option"},[_vm._v("\n                              "+_vm._s(_vm.isSearchLoading)+"\n                            ")]):_vm._e()]),_vm._v(" "),_c('div',{class:{ 'testProfileSearch': (_vm.searchtext != '') }},[_vm._l((_vm.selectedProfileAndTest),function(sel,index){return _c('span',{key:index,staticClass:"badge badge-primary mb-1"},[_c('span',{staticClass:"capitalize"},[_vm._v(_vm._s(sel.name))]),_vm._v(" "),_c('i',{staticClass:"material-icons float-right",on:{"click":function($event){$event.preventDefault();_vm.removeSelectedItems(sel)}}},[_vm._v("close")])])}),_vm._v(" "),(_vm.selectedProfileAndTest.length <= 0)?_c('span',{staticClass:"mb-1 ft-s-15"},[_vm._v("\n                            No test or profile selected\n                          ")]):_vm._e()],2)])])])])]),_vm._v(" "),_c('div',{staticClass:"portal-section"},[_c('div',{class:{'container-fluid' : _vm.selectedProfileAndTest && _vm.selectedProfileAndTest.length > 0 , 'container' : !_vm.selectedProfileAndTest || _vm.selectedProfileAndTest.length <= 0}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-7 offset-sm-3"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-9 mb-0"},[(_vm.labContent && _vm.labLists.length > 0 && !_vm.isLabLoading)?_c('p',{staticClass:"mt-1 mb-0"},[_vm._v("Showing "),_c('b',{staticClass:"black-color"},[_vm._v(_vm._s(_vm.labLists.length)+" Labs ")]),_vm._v(" in "),_c('b',{staticClass:"black-color"},[_vm._v(_vm._s(_vm.$localStorage.get('location') ? _vm.$localStorage.get('location').locationName : (_vm.selectedCity ? _vm.selectedCity.cityName : ''))+" ")]),_vm._v(", starting from "+_vm._s('Rs.'+_vm.lowestCost))]):_vm._e()]),_vm._v(" "),(_vm.labContent && _vm.labLists.length > 0 && !_vm.isLabLoading)?_c('div',{staticClass:"col-sm-3 mb-0"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.sortBy),expression:"sortBy"}],staticClass:"form-control form-control-sm mb-3",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.sortBy=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){_vm.labSortOrder()}]}},[_c('option',{attrs:{"value":"1"}},[_vm._v("Price Low to High")]),_vm._v(" "),_c('option',{attrs:{"value":"2"}},[_vm._v("Price High to Low")]),_vm._v(" "),_c('option',{attrs:{"value":"3"}},[_vm._v("Ratings")])])]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"row"},[(_vm.selectedProfileAndTest && _vm.selectedProfileAndTest.length > 0)?_c('div',{staticClass:"col-sm-3 d-none d-sm-block"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_vm._v("\n                            Popular Packages\n                        ")]),_vm._v(" "),_c('div',{staticClass:"card-body"},[((_vm.popularTests.profile))?_c('ul',{staticClass:"test-list"},_vm._l((_vm.popularTests.profile.slice(0, 5)),function(data,index){return _c('li',{key:index,staticClass:"pd_10 cursor-p"},[_c('span',{on:{"click":function($event){_vm.addTestFromDropdown($event, data)}}},[_c('i',{staticClass:"fa fa-plus mr-2"}),_vm._v(" \n                                      "+_vm._s(data.name)+"\n                                    ")]),_vm._v(" "),_c('span',{staticClass:"blue-color list-popup",on:{"click":function($event){_vm.openPopularProfileTestList(data)}}},[_vm._v("\n                                        (includes "+_vm._s(_vm.getIncudedTestAndProfilePopular(data))+")\n                                    ")]),_vm._v(" "),(data.isSelected === 1)?_c('i',{staticClass:"fa fa-circle green-color test-active-font"}):_vm._e()])})):_c('ul',{staticClass:"lab-test"},[_c('li',[_vm._v("\n                                  Loading...\n                                ")])])])]),_vm._v(" "),_c('div',{staticClass:"card mt-3"},[_c('div',{staticClass:"card-header"},[_vm._v("\n                            Popular Tests\n                        ")]),_vm._v(" "),_c('div',{staticClass:"card-body"},[((_vm.popularTests.test))?_c('ul',{staticClass:"test-list"},_vm._l((_vm.popularTests.test.slice(0, 5)),function(data,index){return _c('li',{key:index,staticClass:"pd_10 cursor-p",on:{"click":function($event){_vm.addTestFromDropdown($event, data)}}},[_c('i',{staticClass:"fa fa-plus mr-2"}),_vm._v(" \n                                    "+_vm._s(data.name)+"\n                                    "),(data.isSelected === 1)?_c('i',{staticClass:"fa fa-circle green-color test-active-font"}):_vm._e()])})):_c('ul',{staticClass:"lab-test"},[_c('li',[_vm._v("\n                                  Loading...\n                                ")])])])])]):_vm._e(),_vm._v(" "),(_vm.selectedProfileAndTest && _vm.selectedProfileAndTest.length > 0)?_c('div',{staticClass:"col-sm-7"},[(_vm.selectedProfileAndTest[0].info && _vm.selectedProfileAndTest[0].info.length > 0)?_c('div',{staticClass:"lab"},[_c('div',{staticClass:"display-flex"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 collapse-group"},[_c('h4',{staticClass:"text-black capitalize profile_detail fs-14"},[_vm._v(_vm._s(_vm.selectedProfileAndTest[0].name))]),_vm._v(" "),_c('p',{staticClass:"p-profile-detail"},[_vm._v("\n                                        "+_vm._s(_vm.selectedProfileAndTest[0].info.length > 0 ? _vm.selectedProfileAndTest[0].info : '')+"\n                                      ")])])])]),_vm._v(" "),_c('div',{staticClass:"clearfix"})]):_vm._e(),_vm._v(" "),_vm._l((_vm.limitBy(_vm.labLists, _vm.labLimit)),function(lab,index){return _c('div',{key:index,staticClass:"lab"},[_c('div',{staticClass:"display-flex"},[_c('div',{staticClass:"flex-box"},[_c('div',{staticClass:"lab-logo"},[(lab.logo && lab.logo.length > 0)?_c('img',{attrs:{"src":lab.logo}}):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"lab-rating"},[_c('ul',[_vm._l((parseInt(lab.rating)),function(stars){return _c('li',[_c('i',{staticClass:"material-icons"},[_vm._v("star")])])}),_vm._v(" "),_vm._l((5-parseInt(lab.rating)),function(star_borders){return _c('li',[_c('i',{staticClass:"material-icons"},[_vm._v("star_border")])])})],2)])]),_vm._v(" "),_c('div',{staticClass:"flex-box"},[_c('h6',{staticClass:"black-color mb-0"},[_vm._v(_vm._s(lab.labName))]),_vm._v(" "),_c('p',{staticClass:"mb-0"},[_c('span',{staticClass:"mr-3"},[_c('i',{staticClass:"fa fa-map-marker green-color mr-1",attrs:{"aria-hidden":"true"}}),_vm._v("\n                                    "+_vm._s(lab.branch.branchLocation)+"\n                                  ")])]),_vm._v(" "),_vm._m(0,true,false),_vm._v(" "),_c('p',_vm._l((lab.labTestList),function(tl,key){return _c('span',{key:key},[_c('span',{staticClass:"selected-test"},[_vm._v(_vm._s(tl.aliasName))]),_vm._v(" "),(tl.testId === 0)?_c('span',{staticClass:"selected-test"},[(tl.testId === 0)?_c('span',{staticClass:"blue-color list-popup",on:{"click":function($event){_vm.openProfileTestList(tl.aliasName, tl.testInfo, tl)}}},[_vm._v("\n                                              (includes "+_vm._s(_vm.getIncudedTestAndProfile(tl))+" )\n                                          ")]):_vm._e()]):_vm._e(),_vm._v(" "),((lab.labTestList.length > 1 && (key) != (lab.labTestList.length-1)))?_c('span',{attrs:{"id":key}},[_vm._v(" | ")]):_vm._e()])}))])]),_vm._v(" "),_c('div',{staticClass:"clearfix"},[(lab.certificationList.length > 0)?_c('div',{staticClass:"float-left"},[_c('span',{staticClass:"mb-2"},[_vm._v("Lab Certified with")]),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('ul',{staticClass:"lab-certificate mt-3"},_vm._l((lab.certificationList),function(cert,index){return _c('li',{key:index},[((cert.labCertificateImageId === 1))?_c('img',{attrs:{"src":"static/images/certifi01.jpg","alt":""}}):_vm._e(),_vm._v(" "),((cert.labCertificateImageId === 2))?_c('img',{attrs:{"src":"static/images/certifi03.jpg","alt":""}}):_vm._e(),_vm._v(" "),((cert.labCertificateImageId === 3))?_c('img',{attrs:{"src":"static/images/certifi02.jpg","alt":""}}):_vm._e()])}))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"float-right"},[_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('h5',{staticClass:"float-lg-right mt-1 mb-0 price-tag"},[((lab.actualCost > lab.ourCost))?_c('span',{staticClass:"red-color strip-text"},[_vm._v("Rs. "+_vm._s(lab.actualCost))]):_vm._e(),_vm._v(" "),_c('strong',[_vm._v("Rs. "+_vm._s(lab.ourCost))])]),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('div',{staticClass:"dropup"},[_c('a',{staticClass:"float-right mt-1 mb-3 blue-color dropdown-toggle",attrs:{"data-toggle":"dropdown","aria-haspopup":"true","aria-expanded":"false"}},[_vm._v("Price Breakup")]),_vm._v(" "),_c('div',{staticClass:"dropdown-menu dropdown-menu-right p-3"},[_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"price-breake fs-13"},[_vm._l((lab.labTestList),function(tl,key){return _c('tr',{key:key},[_c('td',{staticClass:"text-nowrap"},[_vm._v(_vm._s(tl.aliasName))]),_vm._v(" "),_c('td',{staticClass:"text-nowrap"},[_c('h5',{staticClass:"float-right mt-1 mb-0 price-tag price-tag price-breakeup"},[((tl.acutalPrice > tl.ourPrice))?_c('span',{staticClass:"red-color strip-text"},[_vm._v("Rs. "+_vm._s(tl.acutalPrice))]):_vm._e(),_vm._v(" Rs. "+_vm._s(tl.ourPrice)+"\n                                                      ")])])])}),_vm._v(" "),_c('tr',{staticClass:"grey-color border-top"},[_c('td',{staticClass:"text-nowrap bo"},[_vm._v("Sub Total")]),_vm._v(" "),_c('td',{staticClass:"text-nowrap"},[_c('h5',{staticClass:"float-right mt-1 mb-0 price-tag price-tag"},[_vm._v("\n                                                            Rs. "+_vm._s(lab.ourCost)+"\n                                                      ")])])])],2)])])]),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),(_vm.$localStorage.get('sl') && _vm.$localStorage.get('sl').labId === lab.labId)?_c('button',{staticClass:"btn btn-primary full-width",on:{"click":function($event){_vm.goChooseDate(lab)}}},[_vm._v("book appointment")]):_vm._e(),_vm._v(" "),(_vm.$localStorage.get('sl') && _vm.$localStorage.get('sl').labId !== lab.labId)?_c('button',{staticClass:"btn btn-primary full-width",on:{"click":function($event){_vm.goChooseDate(lab)}}},[_vm._v("book appointment")]):_vm._e(),_vm._v(" "),(!_vm.$localStorage.get('sl'))?_c('button',{staticClass:"btn btn-primary full-width",on:{"click":function($event){_vm.goChooseDate(lab)}}},[_vm._v("book appointment")]):_vm._e()])])])}),_vm._v(" "),(_vm.labLists.length <= 0)?_c('div',{staticClass:"card  mt-3"},[_c('div',{staticClass:"card-body"},[(_vm.labLists.length <= 0 && !_vm.isLabLoading)?_c('div',{staticClass:"no-labs text-center mt-4"},[_c('img',{attrs:{"src":"static/images/lab-flask.png","alt":""}}),_vm._v(" "),_c('p',[_vm._v("No Labs found for your tests in "+_vm._s(_vm.selectedCity.cityName ? _vm.selectedCity.cityName : ''))])]):_vm._e(),_vm._v(" "),(_vm.labLists.length <= 0 && _vm.isLabLoading)?_c('div',{staticClass:"no-labs text-center mt-4"},[_c('img',{attrs:{"src":"static/images/lab-flask.png","alt":""}}),_vm._v(" "),_c('p',[_vm._v("Loading...")])]):_vm._e()])]):_vm._e()],2):_vm._e(),_vm._v(" "),(_vm.selectedProfileAndTest && _vm.selectedProfileAndTest.length > 0)?_c('div',{staticClass:"col-sm-2"},_vm._l((_vm.sideBannerAds),function(sideBanner,index){return _c('a',{on:{"click":function($event){_vm.adsRedirect(sideBanner.url)}}},[_c('img',{staticClass:"w-100",class:{'mt-3' : (index > 0)},attrs:{"src":sideBanner.src,"alt":""}})])})):_vm._e(),_vm._v(" "),(!_vm.selectedProfileAndTest || _vm.selectedProfileAndTest.length === 0)?_c('div',{staticClass:"col-sm-12 mt-3"},[_c('p',[_vm._v(" Please Choose one or more Profile/Test to show labs")])]):_vm._e(),_vm._v(" "),(!_vm.selectedProfileAndTest || _vm.selectedProfileAndTest.length === 0)?_c('div',{staticClass:"col-sm-5  <mt-0></mt-0>"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_vm._v("\n                          Popular Packages\n                      ")]),_vm._v(" "),_c('div',{staticClass:"card-body"},[((_vm.popularTests.profile))?_c('ul',{staticClass:"test-list"},_vm._l((_vm.popularTests.profile.slice(0, 10)),function(data,index){return _c('li',{key:index,staticClass:"pd_10 cursor-p"},[_c('span',{on:{"click":function($event){_vm.addTestFromDropdown($event, data)}}},[_c('i',{staticClass:"fa fa-plus mr-2"}),_vm._v(" \n                                    "+_vm._s(data.name)+"\n                                  ")]),_vm._v(" "),_c('span',{staticClass:"blue-color list-popup",on:{"click":function($event){_vm.openPopularProfileTestList(data)}}},[_vm._v("\n                                      (includes "+_vm._s(_vm.getIncudedTestAndProfilePopular(data))+")\n                                  ")]),_vm._v(" "),(data.isSelected === 1)?_c('i',{staticClass:"fa fa-circle green-color test-active-font"}):_vm._e()])})):_c('ul',{staticClass:"lab-test"},[_c('li',[_vm._v("\n                                Loading...\n                              ")])])])])]):_vm._e(),_vm._v(" "),(!_vm.selectedProfileAndTest || _vm.selectedProfileAndTest.length === 0)?_c('div',{staticClass:"col-sm-4  mt-0"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_vm._v("\n                            Popular Tests\n                        ")]),_vm._v(" "),_c('div',{staticClass:"card-body"},[((_vm.popularTests.test))?_c('ul',{staticClass:"test-list"},_vm._l((_vm.popularTests.test.slice(0, 10)),function(data,index){return _c('li',{key:index,staticClass:"pd_10 cursor-p",on:{"click":function($event){_vm.addTestFromDropdown($event, data)}}},[_c('i',{staticClass:"fa fa-plus mr-2"}),_vm._v(" \n                                    "+_vm._s(data.name)+"\n                                    "),(data.isSelected === 1)?_c('i',{staticClass:"fa fa-circle green-color test-active-font"}):_vm._e()])})):_c('ul',{staticClass:"lab-test"},[_c('li',[_vm._v("\n                                  Loading...\n                                ")])])])])]):_vm._e(),_vm._v(" "),(!_vm.selectedProfileAndTest || _vm.selectedProfileAndTest.length === 0)?_c('div',{staticClass:"col-sm-3 mt-0"},_vm._l((_vm.sideBannerAds),function(sideBanner,index){return _c('a',{on:{"click":function($event){_vm.adsRedirect(sideBanner.url)}}},[_c('img',{staticClass:"w-100",class:{'mt-3' : (index > 0)},attrs:{"src":sideBanner.src,"alt":""}})])})):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"row mt-3"},[_c('div',{staticClass:"col-sm-4 offset-5"},[(_vm.labLists.length >_vm.labLimit)?_c('button',{staticClass:"btn btn-outline-primary full-width",on:{"click":function($event){_vm.loadMore()}}},[_vm._v("Show more Labs ("+_vm._s(_vm.labLists.length - _vm.labLimit)+")")]):_vm._e()])])])]),_vm._v(" "),_c('div',{staticClass:"modal fade bd-example-modal-lg",attrs:{"id":"test-popup","tabindex":"-1","role":"dialog","aria-labelledby":"exampleModalLabel","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog  modal-lg",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_c('h5',{staticClass:"modal-title",attrs:{"id":"exampleModalLabel"}},[_vm._v(_vm._s(_vm.clickedProfileDetails.aliasName))]),_vm._v(" "),_vm._m(1,false,false)]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[(_vm.clickedProfileDetails.patientInstruction && _vm.clickedProfileDetails.patientInstruction.length > 0)?_c('p',[_vm._v("Patient Instruction:")]):_vm._e(),_vm._v(" "),(_vm.clickedProfileDetails.patientInstruction && _vm.clickedProfileDetails.patientInstruction.length > 0)?_c('p',{staticClass:"black-color"},[_vm._v(_vm._s(_vm.clickedProfileDetails.patientInstruction))]):_vm._e(),_vm._v(" "),(_vm.clickedProfileTests.length > 0 || (_vm.clickedProfileDetails.includedProfiles && _vm.clickedProfileDetails.includedProfiles.count > 0))?_c('p',{class:{'mt-4' : (_vm.clickedProfileDetails.patientInstruction && _vm.clickedProfileDetails.patientInstruction.length > 0 ) }},[_vm._v("Included Tests ("),_c('span',{staticStyle:{"font-size":"12px"}},[_vm._v(_vm._s(_vm.getIncudedTestAndProfilePop(_vm.clickedProfileDetails)))]),_vm._v("): ")]):_vm._e(),_vm._v(" "),(_vm.clickedProfileTests.length > 0 || (_vm.clickedProfileDetails.includedProfiles && _vm.clickedProfileDetails.includedProfiles.count > 0) )?_c('div',{staticClass:"black-color row included-profiles"},[_c('div',{staticClass:"col-sm-6"},[((_vm.clickedProfileDetails.includedProfiles && _vm.clickedProfileDetails.includedProfiles.count > 0))?_c('div',{attrs:{"id":"accordion","role":"tablist"}},_vm._l((_vm.clickedProfileDetails.includedProfiles.data),function(inclProf,index){return _c('div',{key:index,staticClass:"card"},[_c('div',{staticClass:"card-header",attrs:{"role":"tab","id":"headingOne"}},[_c('h5',{staticClass:"mb-0"},[_c('a',{staticClass:"collapsed",attrs:{"data-toggle":"collapse","href":'#collapseTwo'+inclProf.panelId,"aria-expanded":"true","aria-controls":"collapseTwo"}},[_vm._v("\n                                              "+_vm._s(inclProf.panelName+' (includes '+ inclProf.ProfileTests.length +' Tests)')+"\n                                              "),_c('i',{staticClass:"material-icons float-right"})])])]),_vm._v(" "),_c('div',{staticClass:"collapse",attrs:{"id":'collapseTwo'+inclProf.panelId,"role":"tabpanel","aria-labelledby":"headingOne","data-parent":"#accordion"}},[_c('div',{staticClass:"pl-4"},_vm._l((inclProf.ProfileTests),function(incTest,index){return _c('span',{key:index,staticClass:"mb-2"},[_vm._v(_vm._s(incTest.testName+((inclProf.ProfileTests.length != (index+1))? ' , ' : ''))),_c('br')])}))])])})):_vm._e(),_vm._v(" "),_c('div',{attrs:{"id":"accordion","role":"tablist"}},_vm._l((_vm.clickedProfileTestFirst),function(cli,index){return _c('div',{key:index,staticClass:"card"},[_c('div',{staticClass:"card-header",attrs:{"role":"tab","id":"headingOne"}},[_c('h5',{staticClass:"mb-0"},[_c('a',[_vm._v("\n                                              "+_vm._s(cli)+"\n                                          ")])])])])}))]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{attrs:{"id":"accordion","role":"tablist"}},_vm._l((_vm.clickedProfileTestSecond),function(cli,index){return _c('div',{key:index,staticClass:"card"},[_c('div',{staticClass:"card-header",attrs:{"role":"tab","id":"headingOne"}},[_c('h5',{staticClass:"mb-0"},[_c('a',{staticClass:"collapsed"},[_vm._v("\n                                              "+_vm._s(cli)+"\n                                          ")])])])])}))])]):_c('div',{staticClass:"black-color"},[_c('p',[_vm._v(" -- No tests available -- ")])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal fade bd-example-modal-lg",attrs:{"id":"lab_test-popup","tabindex":"-1","role":"dialog","aria-labelledby":"exampleModalLabel","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog  modal-lg",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_c('h5',{staticClass:"modal-title",attrs:{"id":"exampleModalLabel"}},[_vm._v(_vm._s(_vm.clickedProfileDetails.aliasName))]),_vm._v(" "),_vm._m(2,false,false)]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[(_vm.clickedProfileDetails.patientInstruction && _vm.clickedProfileDetails.patientInstruction.length > 0)?_c('p',[_vm._v("Patient Instruction:")]):_vm._e(),_vm._v(" "),(_vm.clickedProfileDetails.patientInstruction && _vm.clickedProfileDetails.patientInstruction.length > 0)?_c('p',{staticClass:"black-color"},[_vm._v(_vm._s(_vm.clickedProfileDetails.patientInstruction))]):_vm._e(),_vm._v(" "),(_vm.clickedProfileTests.length > 0 || (_vm.clickedProfileDetails.includedProfiles && _vm.clickedProfileDetails.includedProfiles.count > 0))?_c('p',{class:{'mt-4' : (_vm.clickedProfileDetails.patientInstruction && _vm.clickedProfileDetails.patientInstruction.length > 0 ) }},[_vm._v("Included Tests ("),_c('span',{staticStyle:{"font-size":"12px"}},[_vm._v(_vm._s(_vm.getIncudedTestAndProfile(_vm.clickedProfileDetails)))]),_vm._v("): ")]):_vm._e(),_vm._v(" "),(_vm.clickedProfileTests.length > 0 || (_vm.clickedProfileDetails.includedProfiles && _vm.clickedProfileDetails.includedProfiles.count > 0) )?_c('div',{staticClass:"black-color row included-profiles"},[_c('div',{staticClass:"col-sm-6"},[((_vm.clickedProfileDetails.includedProfiles && _vm.clickedProfileDetails.includedProfiles.count > 0))?_c('div',{attrs:{"id":"accordion","role":"tablist"}},_vm._l((_vm.clickedProfileDetails.includedProfiles.data),function(inclProf,index){return _c('div',{key:index,staticClass:"card"},[_c('div',{staticClass:"card-header",attrs:{"role":"tab","id":"headingOne"}},[_c('h5',{staticClass:"mb-0"},[_c('a',{staticClass:"collapsed",attrs:{"data-toggle":"collapse","href":'#collapseOne'+inclProf.panelId,"aria-expanded":"true","aria-controls":"collapseOne"}},[_vm._v("\n                                              "+_vm._s(inclProf.aliasName+' (includes '+ inclProf.ProfileTests.length +' Tests)')+"\n                                              "),_c('i',{staticClass:"material-icons float-right"})])])]),_vm._v(" "),_c('div',{staticClass:"collapse",attrs:{"id":'collapseOne'+inclProf.panelId,"role":"tabpanel","aria-labelledby":"headingOne","data-parent":"#accordion"}},[_c('div',{staticClass:"pl-4"},_vm._l((inclProf.ProfileTests),function(incTest,index){return _c('span',{key:index,staticClass:"mb-2"},[_vm._v(_vm._s(incTest.testName+((inclProf.ProfileTests.length != (index+1))? ' , ' : ''))),_c('br')])}))])])})):_vm._e(),_vm._v(" "),_c('div',{attrs:{"id":"accordion","role":"tablist"}},_vm._l((_vm.clickedProfileTestFirst),function(cli,index){return _c('div',{key:index,staticClass:"card"},[_c('div',{staticClass:"card-header",attrs:{"role":"tab","id":"headingOne"}},[_c('h5',{staticClass:"mb-0"},[_c('a',{staticClass:"collapsed"},[_vm._v("\n                                              "+_vm._s(cli)+"\n                                          ")])])])])}))]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{attrs:{"id":"accordion","role":"tablist"}},_vm._l((_vm.clickedProfileTestSecond),function(cli,index){return _c('div',{key:index,staticClass:"card"},[_c('div',{staticClass:"card-header",attrs:{"role":"tab","id":"headingOne"}},[_c('h5',{staticClass:"mb-0"},[_c('a',{staticClass:"collapsed"},[_vm._v("\n                                              "+_vm._s(cli)+"\n                                          ")])])])])}))])]):_c('div',{staticClass:"black-color"},[_c('p',[_vm._v(" -- No tests available -- ")])])])])])]),_vm._v(" "),_c('FooterVue')],1)}
var LabLocation_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h6',{staticClass:"pickup-label"},[_c('span',{staticClass:"badge badge-success"},[_vm._v("Free Home Sample Pickup")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])}]
var LabLocation_esExports = { render: LabLocation_render, staticRenderFns: LabLocation_staticRenderFns }
/* harmony default export */ var Book_LabLocation = (LabLocation_esExports);
// CONCATENATED MODULE: ./src/components/web/Book/LabLocation.vue
function LabLocation_injectStyle (ssrContext) {
  __webpack_require__("ZgSQ")
}
var LabLocation_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var LabLocation___vue_template_functional__ = false
/* styles */
var LabLocation___vue_styles__ = LabLocation_injectStyle
/* scopeId */
var LabLocation___vue_scopeId__ = "data-v-fe97abb4"
/* moduleIdentifier (server only) */
var LabLocation___vue_module_identifier__ = null
var LabLocation_Component = LabLocation_normalizeComponent(
  LabLocation,
  Book_LabLocation,
  LabLocation___vue_template_functional__,
  LabLocation___vue_styles__,
  LabLocation___vue_scopeId__,
  LabLocation___vue_module_identifier__
)

/* harmony default export */ var web_Book_LabLocation = (LabLocation_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/web/Public/Redirect.vue
//
//
//
//
//

/* harmony default export */ var Redirect = ({
  name: 'Redirect',
  components: {},
  beforeCreate: function beforeCreate() {
    document.title = this.$route.params.data + ' - Labotist';
  },
  data: function data() {
    return {};
  },
  mounted: function mounted() {
    setTimeout(function () {
      if (this.$route.params.tests) {
        this.$router.push({ path: '/redirect/labs/' + this.$route.params.tests });
        //   wind   ow.location = this.$route.params.tests;
      } else {
        this.$router.push({ path: '/' });
      }
      this.$hidePageLoading();
    }.bind(this), 500);
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b40a0e70","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/web/Public/Redirect.vue
var Redirect_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"redirectDiv"}})}
var Redirect_staticRenderFns = []
var Redirect_esExports = { render: Redirect_render, staticRenderFns: Redirect_staticRenderFns }
/* harmony default export */ var Public_Redirect = (Redirect_esExports);
// CONCATENATED MODULE: ./src/components/web/Public/Redirect.vue
var Redirect_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var Redirect___vue_template_functional__ = false
/* styles */
var Redirect___vue_styles__ = null
/* scopeId */
var Redirect___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Redirect___vue_module_identifier__ = null
var Redirect_Component = Redirect_normalizeComponent(
  Redirect,
  Public_Redirect,
  Redirect___vue_template_functional__,
  Redirect___vue_styles__,
  Redirect___vue_scopeId__,
  Redirect___vue_module_identifier__
)

/* harmony default export */ var web_Public_Redirect = (Redirect_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/web/Public/LabRedirect.vue

//
//
//
//
//

/* harmony default export */ var LabRedirect = ({
  name: 'Redirect',
  components: {},
  beforeCreate: function beforeCreate() {
    document.title = this.$route.params.testdata + ' - Labotist';
  },
  data: function data() {
    return {
      currentLocation: {}
    };
  },
  mounted: function mounted() {},
  created: function created() {
    this.geolocation();
  },

  methods: {
    geolocation: function geolocation() {
      var options = {
        maximumAge: 60000,
        timeout: 5000,
        enableHighAccuracy: true
      };
      navigator.geolocation.getCurrentPosition(function (position) {
        console.log('im tracking you!');
        this.currentLocation = {
          lat: position.coords.latitude,
          lng: position.coords.longitude
        };
        this.changeCityUsingLocation();
        return false;
      }.bind(this), function (error) {
        if (error.code === error.PERMISSION_DENIED) {
          console.log('you denied me :-(');
          setTimeout(function () {
            this.$router.push({ path: '/labs/chennai/' + this.$route.params.testdata });
          }.bind(this), 500);
        }
      }.bind(this)), options;
    },
    changeCityUsingLocation: function changeCityUsingLocation() {
      var data = {
        coordinates: this.currentLocation
      };
      promise_default.a.resolve(this.$POST('patient/getCityUsingLocation', data)).then(function (res) {
        if (res.response_code === 0) {
          if (res.response.cityName) {
            var laburl = '/labs/' + res.response.cityName + '/' + this.$route.params.testdata;
            if (res.response.locationName) {
              laburl = laburl + '/' + res.response.locationName;
            }
            this.$router.push({ path: laburl });
          } else {
            this.$router.push({ path: '/labs/chennai/' + this.$route.params.testdata });
          }
        } else {
          this.$router.push({ path: '/labs/chennai/' + this.$route.params.testdata });
        }
      }.bind(this)).catch(function (err) {
        console.error(err);
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f9c70c66","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/web/Public/LabRedirect.vue
var LabRedirect_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"redirectDiv"}})}
var LabRedirect_staticRenderFns = []
var LabRedirect_esExports = { render: LabRedirect_render, staticRenderFns: LabRedirect_staticRenderFns }
/* harmony default export */ var Public_LabRedirect = (LabRedirect_esExports);
// CONCATENATED MODULE: ./src/components/web/Public/LabRedirect.vue
var LabRedirect_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var LabRedirect___vue_template_functional__ = false
/* styles */
var LabRedirect___vue_styles__ = null
/* scopeId */
var LabRedirect___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var LabRedirect___vue_module_identifier__ = null
var LabRedirect_Component = LabRedirect_normalizeComponent(
  LabRedirect,
  Public_LabRedirect,
  LabRedirect___vue_template_functional__,
  LabRedirect___vue_styles__,
  LabRedirect___vue_scopeId__,
  LabRedirect___vue_module_identifier__
)

/* harmony default export */ var web_Public_LabRedirect = (LabRedirect_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/web/Public/ReferalSignup.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



// import Sidemenu from '@/components/web/Public/Sidemenu'

/* harmony default export */ var ReferalSignup = ({
  name: 'Privacy',
  components: {
    HeaderVue: Header["a" /* default */],
    // Sidemenu,
    FooterVue: Footer["a" /* default */]
  },
  beforeCreate: function beforeCreate() {},
  created: function created() {
    if (this.$route.params.referal_code) {
      console.log(this.$route.params.referal_code);
      try {
        this.referralCode = this.$decryptString(this.$route.params.referal_code);
        console.log(this.referralCode);
      } catch (err) {
        this.referralCode = '';
        console.log(err);
      }
    } else {
      this.$localStorage.remove('ref_code');
    }
  },
  data: function data() {
    return {
      isDobError: false,
      otherSignup: false,
      loginWithoutBtn: false,
      login: {
        username: '',
        password: '',
        error: false,
        errormsg: '',
        otp_send: 1,
        login_otp: '',
        successmsg: ''
      },
      forgot: {
        username: '',
        otp: '',
        newPassword: '',
        confirmPassword: '',
        error: false,
        errormsg: '',
        success: 1,
        successmsg: '',
        otpType: ''
      },
      otp: {
        username: '',
        error: false,
        errormsg: '',
        success: false,
        successmsg: ''
      },
      signup: {
        email: '',
        mobile: '',
        firstName: '',
        password: '',
        referralCode: '',
        dob: undefined,
        sex: 'M',
        otp: '',
        error: false,
        errormsg: '',
        success: false,
        successmsg: '',
        dobYears: [],
        dobDate: [],
        year: '',
        month: '',
        ddate: ''
      },
      disabled: {
        from: new Date()
      },
      appointmentLogin: false,
      referralCode: '',
      referralCodeDisable: false
    };
  },
  mounted: function mounted() {
    this.$hidePageLoading();
  },

  methods: {
    create_account: function create_account() {

      this.isDobError = false;
      this.signup.error = false;
      this.$validator.validateAll('signup').then(function (result) {
        if (result) {
          // if (this.signup.year.length !== 4 || this.signup.month.length <= 0 || this.signup.ddate.length <= 0) {
          //   this.isDobError = true
          //   return false
          // }
          try {
            if (this.signup.email !== '' && this.signup.mobile !== '' && this.signup.firstName !== '' && this.signup.password !== '') {
              var params = {
                'firstName': this.signup.firstName,
                'lastName': '',
                'phone1': this.signup.mobile,
                'email': this.signup.email,
                'password': this.signup.password,
                'referralCode': this.referralCode,
                // 'sex': this.signup.sex,
                'sex': '',
                // 'dob': this.signup.year + '-' + this.signup.month + '-' + this.signup.ddate,
                'dob': null
                // 'dob': dateFormat(this.signup.dob, 'yyyy-mm-dd', true)
              };
              promise_default.a.resolve(this.$POST('patient/quickSignUp', params)).then(function (response) {
                if (response.response_code === 0) {
                  this.signup.error = false;
                  this.signup.errormsg = '';
                  this.signup.success = true;
                  this.signup.successmsg = 'We have send an authentication code for verifying your account.';
                  Vue.analytics.fbq.event('ViewContent', {
                    content_ids: 0,
                    content_name: 'SIGN UP SUCCESS',
                    contents: '',
                    content_type: 'SIGNUP_SUCCESS'
                  });
                } else {
                  this.signup.success = false;
                  this.signup.error = true;
                  this.signup.errormsg = response.response_message;
                  this.signup.otp = '';
                  if (response.response_code === 3) {
                    this.$refs.signUpEmail.focus();
                  } else if (response.response_code === 4) {
                    this.$refs.signUpMobile.focus();
                  }
                }
              }.bind(this)).catch(function (err) {
                console.log(err);
              });
            } else {
              this.$Simplert.open({
                title: 'Alert',
                message: 'Please enter required fields!',
                type: 'warning',
                disableOverlayClick: true,
                showXclose: true,
                useConfirmBtn: false,
                customCloseBtnText: 'OK'
              });
              // alert('Please enter required fields!')
            }
          } catch (e) {
            console.error(e);
          }
        }
      }.bind(this));
    },
    signup_verify_otp: function signup_verify_otp() {
      var _this = this;

      this.$validator.validateAll('signupOtp').then(function (result) {
        if (result) {
          if (_this.signup.email !== '' && _this.signup.otp !== '') {
            _this.$verifyOTP(_this.signup.email, _this.signup.otp).then(function (response) {
              if (response.error) {
                this.signup.error = true;
                this.signup.errormsg = 'Invalid OTP';
                this.signup.successmsg = '';
                return false;
              } else {
                if (this.appointmentLogin) {
                  this.appointmentLogin = false;
                  this.$root.$emit('isLogin', true);
                  //   $('.signup').modal('hide')
                  this.$router.push('/address');
                  // location.reload()
                  return false;
                } else {
                  this.$root.$emit('isLogin', true);
                  $('.signup').modal('hide');
                  // location.reload()
                  // this.$router.push('/myprofile')
                  this.$router.push({ path: '/referral/landing' });
                }
              }
            }.bind(_this)).catch(function (err) {
              console.error(err);
            });
          }
        }
      });
    },
    signup_resend: function signup_resend() {
      try {
        if (this.signup.email !== '') {
          var data = {
            'email': this.signup.email
          };
          promise_default.a.resolve(this.$POST('patient/resendOTP', data)).then(function (res) {
            if (res.response_code === 0) {
              this.signup.error = false;
              this.signup.errormsg = '';
              this.signup.success = true;
              this.signup.successmsg = 'We have resend an authentication code to your mail id.';
            } else {
              this.signup.success = false;
              this.signup.error = true;
              this.signup.errormsg = res.response_message;
              this.signup.otp = '';
            }
          }.bind(this)).catch(function (err) {
            console.log(err);
          });
        }
      } catch (e) {
        console.error(e);
      }
    },
    bookNowClicked: function bookNowClicked() {
      if (this.referralCode && this.referralCode.length > 0) {
        this.$localStorage.set('ref_code', this.referralCode);
      } else {
        this.$localStorage.remove('ref_code');
      }
      this.$router.push('/lab');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1e4beae7","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/web/Public/ReferalSignup.vue
var ReferalSignup_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"referalSignupDiv"}},[_c('HeaderVue'),_vm._v(" "),_vm._m(0,false,false),_vm._v(" "),_vm._m(1,false,false),_vm._v(" "),_c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"inner-page1 reg-content"},[_c('div',{staticClass:"container"},[_vm._m(2,false,false),_vm._v(" "),_c('div',{staticClass:"row mt-5"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"ref-form align-center p-0",staticStyle:{"padding":"0px !important"}},[_c('img',{staticClass:"img-fluid",attrs:{"src":"static/images/Register_to_get.png","alt":""}}),_vm._v(" "),(_vm.signup.error)?_c('p',{staticClass:"no-mar-top red-color"},[_vm._v(_vm._s(_vm.signup.errormsg))]):_vm._e(),_vm._v(" "),(_vm.signup.success)?_c('p',{staticClass:"no-mar-top green-color"},[_vm._v(_vm._s(_vm.signup.successmsg))]):_vm._e(),_vm._v(" "),_c('form',{directives:[{name:"show",rawName:"v-show",value:(!_vm.signup.success),expression:"!signup.success"}],attrs:{"data-vv-scope":"signup"}},[_c('div',{staticClass:"form-content line-textbox"},[_c('h2',[_vm._v("Create an Account with Labotist")]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.signup.email),expression:"signup.email"},{name:"validate",rawName:"v-validate",value:('required|email|max:100'),expression:"'required|email|max:100'"}],ref:"signUpEmail",staticClass:"form-control",attrs:{"type":"email","id":"signUpEmail","name":"email","data-vv-as":"email address","maxlength":"100","placeholder":"Email address"},domProps:{"value":(_vm.signup.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.signup, "email", $event.target.value)}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('signup.email')),expression:"errors.has('signup.email')"}],staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('signup.email')))])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"mask",rawName:"v-mask",value:('##########'),expression:"'##########'"},{name:"model",rawName:"v-model",value:(_vm.signup.mobile),expression:"signup.mobile"},{name:"validate",rawName:"v-validate",value:('required|numeric|min:10|max:10'),expression:"'required|numeric|min:10|max:10'"}],ref:"signUpMobile",staticClass:"form-control",attrs:{"type":"text","name":"mobile","data-vv-as":"mobile no.","placeholder":"Mobile number"},domProps:{"value":(_vm.signup.mobile)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.signup, "mobile", $event.target.value)}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('signup.mobile')),expression:"errors.has('signup.mobile')"}],staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('signup.mobile')))])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.signup.firstName),expression:"signup.firstName"},{name:"validate",rawName:"v-validate",value:('required|alpha_spaces|max:50'),expression:"'required|alpha_spaces|max:50'"}],staticClass:"form-control",attrs:{"type":"text","name":"firstName","data-vv-as":"first name","maxlength":"50","placeholder":"Name"},domProps:{"value":(_vm.signup.firstName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.signup, "firstName", $event.target.value)}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('signup.firstName')),expression:"errors.has('signup.firstName')"}],staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('signup.firstName')))])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.signup.password),expression:"signup.password"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"form-control",attrs:{"type":"password","name":"password","data-vv-as":"password","placeholder":"Password"},domProps:{"value":(_vm.signup.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.signup, "password", $event.target.value)}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('signup.password')),expression:"errors.has('signup.password')"}],staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('signup.password')))])]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary w-100",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();_vm.create_account()}}},[_vm._v("Register")])])]),_vm._v(" "),_c('form',{directives:[{name:"show",rawName:"v-show",value:(_vm.signup.success),expression:"signup.success"}],attrs:{"data-vv-scope":"signupOtp"}},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"signUpEmail"}},[_vm._v("Enter OTP")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.signup.otp),expression:"signup.otp"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"form-control",attrs:{"type":"text","name":"sotp","data-vv-as":"signup otp","placeholder":"Enter OTP"},domProps:{"value":(_vm.signup.otp)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.signup, "otp", $event.target.value)}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('signupOtp.sotp')),expression:"errors.has('signupOtp.sotp')"}],staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('signupOtp.sotp')))])]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary full-width mar-b-15",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();_vm.signup_verify_otp()}}},[_vm._v("Verify")]),_vm._v(" "),_c('a',{staticClass:"text-center signup-link display-block",on:{"click":function($event){$event.preventDefault();_vm.signup_resend()}}},[_vm._v("Resend?")])])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"small-box"},[_c('p',[_vm._v("Use credit to book blood test now")]),_vm._v(" "),_c('button',{staticClass:"btn btn-warning w-100",on:{"click":function($event){_vm.bookNowClicked()}}},[_vm._v("Book Now")])]),_vm._v(" "),_vm._m(3,false,false)])])])]),_vm._v(" "),_vm._m(4,false,false),_vm._v(" "),_vm._m(5,false,false)])],1)}
var ReferalSignup_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading"},[_c('div',{staticClass:"loading-img"},[_c('img',{attrs:{"src":"static/images/loading.gif","alt":""}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"reg-header"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('img',{staticClass:"img-fluid at-home",attrs:{"src":"static/images/at-home.png","alt":""}})]),_vm._v(" "),_c('div',{staticClass:"col-sm-6 sec2"},[_c('p',[_vm._v("Free Home Blood Sample Collection")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('p',[_vm._v("Search Prescribed Test")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('p',[_vm._v("No Minimum value Order")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('p',[_vm._v("Access Report Online")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('p',[_vm._v("Pay Online or By Cash")]),_vm._v(" "),_c('hr')])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('h4',[_vm._v("\n                            Labotist is an online marketplace for lab services, offering patients the convenience of\n                            picking labs for their medical tests based on location, cost and turnover time. Using its\n                            technology powered phlebotomy\n                            kit and highly trained Phlebotomist, patients are assured safe, sophisticated and accurate\n                            sample collection\n                            process.\n                        ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"test-features"},[_c('li',{staticClass:"clearfix"},[_c('img',{attrs:{"src":"static/images/icon/blood-test.png","alt":""}}),_vm._v("\n                                Pick from over 1000+ blood tests\n                            ")]),_vm._v(" "),_c('li',{staticClass:"clearfix"},[_c('img',{attrs:{"src":"static/images/icon/compare-cost.png","alt":""}}),_vm._v("\n                                Compare cost of tests across partner labs\n                            ")]),_vm._v(" "),_c('li',{staticClass:"clearfix"},[_c('img',{attrs:{"src":"static/images/icon/confort-your.png","alt":""}}),_vm._v("\n                                Get blood test done from the comfort of your home\n                            ")]),_vm._v(" "),_c('li',{staticClass:"clearfix"},[_c('img',{attrs:{"src":"static/images/icon/online-dashboard.png","alt":""}}),_vm._v("\n                                Access to reports on an online dashboard\n                            ")]),_vm._v(" "),_c('li',{staticClass:"clearfix"},[_c('img',{attrs:{"src":"static/images/icon/blood-test.png","alt":""}}),_vm._v("\n                                Temperature controlled phlebotomy kit\n                            ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ignition"},[_c('div',{staticClass:"flex-container"},[_c('div',{staticStyle:{"background-color":"#8cc751"}},[_vm._v("Hygienic")]),_vm._v(" "),_c('div',{staticStyle:{"background-color":"#d7df21"}},[_vm._v("Convenient")]),_vm._v(" "),_c('div',{staticStyle:{"background-color":"#ffcb08"}},[_vm._v("Hygienic")])]),_vm._v(" "),_c('div',{staticClass:"ign-route"},[_c('h2',[_vm._v("How To Book")]),_vm._v(" "),_c('img',{attrs:{"src":"static/images/ignition.png","alt":""}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"copy-right text-center"},[_c('p',[_vm._v("2017 labotist . All rights received.")])])}]
var ReferalSignup_esExports = { render: ReferalSignup_render, staticRenderFns: ReferalSignup_staticRenderFns }
/* harmony default export */ var Public_ReferalSignup = (ReferalSignup_esExports);
// CONCATENATED MODULE: ./src/components/web/Public/ReferalSignup.vue
function ReferalSignup_injectStyle (ssrContext) {
  __webpack_require__("jD0P")
}
var ReferalSignup_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var ReferalSignup___vue_template_functional__ = false
/* styles */
var ReferalSignup___vue_styles__ = ReferalSignup_injectStyle
/* scopeId */
var ReferalSignup___vue_scopeId__ = "data-v-1e4beae7"
/* moduleIdentifier (server only) */
var ReferalSignup___vue_module_identifier__ = null
var ReferalSignup_Component = ReferalSignup_normalizeComponent(
  ReferalSignup,
  Public_ReferalSignup,
  ReferalSignup___vue_template_functional__,
  ReferalSignup___vue_styles__,
  ReferalSignup___vue_scopeId__,
  ReferalSignup___vue_module_identifier__
)

/* harmony default export */ var web_Public_ReferalSignup = (ReferalSignup_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/web/Public/ReferalLogin.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




// import Sidemenu from '@/components/web/Public/Sidemenu'

/* harmony default export */ var ReferalLogin = ({
  name: 'ReferalLogin',
  components: {
    HeaderVue: Header["a" /* default */],
    // Sidemenu,
    FooterVue: Footer["a" /* default */]
  },
  data: function data() {
    return {
      isDobError: false,
      otherSignup: false,
      loginWithoutBtn: false,
      login: {
        username: '',
        password: '',
        error: false,
        errormsg: '',
        otp_send: 1,
        login_otp: '',
        successmsg: ''
      },
      forgot: {
        username: '',
        otp: '',
        newPassword: '',
        confirmPassword: '',
        error: false,
        errormsg: '',
        success: 1,
        successmsg: '',
        otpType: ''
      },
      otp: {
        username: '',
        error: false,
        errormsg: '',
        success: false,
        successmsg: ''
      },
      signup: {
        email: '',
        mobile: '',
        name: '',
        password: '',
        referralCode: '',
        dob: undefined,
        sex: 'M',
        otp: '',
        error: false,
        errormsg: '',
        success: false,
        successmsg: '',
        dobYears: [],
        dobDate: [],
        year: '',
        month: '',
        ddate: ''
      },
      disabled: {
        from: new Date()
      },
      appointmentLogin: false,
      referralCodeDisable: false
    };
  },
  beforeCreate: function beforeCreate() {
    if (this.$localStorage.get('loggedIn') && this.$localStorage.get('loggedIn')) {
      console.log(this.$localStorage.get('loggedIn'));
      this.$router.push({ path: '/referral/invite' });
      // this.$router.push({ path: '/' })
    }
  },
  mounted: function mounted() {
    this.$hidePageLoading();
  },

  methods: {
    loginWithOtpChanged: function loginWithOtpChanged(resend) {
      var _this = this;

      if (this.login.username === '') {
        this.$refs.login_username.focus();
      }
      this.login.error = false;
      this.$validator.validateAll('login').then(function (result) {
        if (result) {
          if (_this.login.username !== '') {
            var data = {
              'mobile': _this.login.username
            };
            promise_default.a.resolve(_this.$POST('patient/sendOTP', data)).then(function (res) {
              if (res.response_code === 0) {
                this.login['otp_send'] = 2;
                this.login['error'] = false;
                this.login['errormsg'] = '';
                if (resend) {
                  this.login['successmsg'] = 'We have resend an OTP to your mobile number.';
                } else {
                  this.login['successmsg'] = 'We have send an OTP to your mobile number.';
                }

                this.login['login_otp'] = '';
                console.log(this.login);
              } else {
                this.login['otp_send'] = 1;
                this.login['error'] = true;
                this.login['errormsg'] = res.response_message;
                this.login['successmsg'] = '';
                this.login['login_otp'] = '';
              }
            }.bind(_this)).catch(function (err) {
              console.log('METHOD:forgetPassword', err);
            });
          }
        }
      });
    },
    loginClicked: function loginClicked() {
      this.login.error = false;
      if (this.login.login_with_otp) {
        this.loginWithOtpChanged();
      } else {
        this.logon();
      }
    },
    logon: function logon() {
      var _this2 = this;

      if (this.login.username === '') {
        this.$refs.login_username.focus();
      } else if (this.login.password === '') {
        this.$refs.login_password.focus();
      }
      this.login.error = false;
      this.$validator.validateAll('login').then(function (result) {
        if (result) {
          if (_this2.login.username !== '' && _this2.login.password !== '') {
            _this2.$logon(_this2.login.username, _this2.login.password).then(function (response) {
              if (response.error) {
                this.login.error = true;
                this.login.errormsg = response.error;
                return false;
              } else {
                vue_esm["default"].analytics.fbq.event('ViewContent', {
                  content_ids: 0,
                  content_name: 'LOGIN SUCCESS',
                  contents: '',
                  content_type: 'LOGIN_SUCCESS'
                });
                if (response.data && response.data.isFirst === 1) {
                  $('.login-box').modal('hide');
                  $('.forgot').modal('show');
                  this.forgot.error = false;
                  this.forgot.success = 3;
                  return false;
                }
                if (this.appointmentLogin) {
                  this.appointmentLogin = false;
                  this.$root.$emit('isLogin', true);
                  $('.login-box').modal('hide');
                  this.$router.push('/address');
                  return false;
                } else {
                  this.$root.$emit('isLogin', true);
                  this.$router.push({ path: '/referral/invite' });
                }
              }
            }.bind(_this2)).catch(function (err) {
              console.error(err);
            });
          }
        }
      });
    },
    verifyLoginOTP: function verifyLoginOTP() {
      var _this3 = this;

      if (this.login.login_otp === '') {
        this.$refs.login_otp.focus();
      }
      this.login.error = false;
      this.$validator.validateAll('login-wt-otp').then(function (result) {
        if (result) {
          if (_this3.login.username !== '' && _this3.login.login_otp !== '') {
            _this3.$verifyLoginOTP(_this3.login.username, _this3.login.login_otp).then(function (response) {
              console.log(response);
              if (response.error) {
                this.login.error = true;
                this.login.errormsg = 'Invalid OTP';
                this.login.successmsg = '';
                return false;
              } else {
                this.login.error = false;
                vue_esm["default"].analytics.fbq.event('ViewContent', {
                  content_ids: 0,
                  content_name: 'LOGIN SUCCESS',
                  contents: '',
                  content_type: 'LOGIN_SUCCESS'
                });
                if (response.data && response.data.isFirst === 1) {
                  $('.login-box').modal('hide');
                  $('.forgot').modal('show');
                  this.forgot.error = false;
                  this.forgot.success = 3;
                  return false;
                }
                if (this.appointmentLogin) {
                  this.appointmentLogin = false;
                  this.$root.$emit('isLogin', true);
                  $('.login-box').modal('hide');
                  this.$router.push('/address');
                  return false;
                } else {
                  this.$root.$emit('isLogin', true);
                  this.$router.push({ path: '/referral/invite' });
                }
                return false;
              }
            }.bind(_this3)).catch(function (err) {
              console.error(err);
            });
          }
        }
      });
    },
    clearFields: function clearFields(type) {
      this.login = {
        username: '',
        password: '',
        error: false,
        errormsg: '',
        otp_send: 1,
        login_otp: '',
        successmsg: ''
      }, this.forgot = {
        username: '',
        otp: '',
        newPassword: '',
        confirmPassword: '',
        error: false,
        errormsg: '',
        success: 1,
        successmsg: ''
      };
      setTimeout(function () {
        this.errors.items = [];
      }.bind(this), 200);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1f8bef6a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/web/Public/ReferalLogin.vue
var ReferalLogin_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"referalLoginDiv"}},[_c('HeaderVue'),_vm._v(" "),_vm._m(0,false,false),_vm._v(" "),_c('header',{staticClass:"reg-header passon-header"}),_vm._v(" "),_c('div',{staticClass:"wrapper pass-on"},[_c('div',{staticClass:"inner-page reg-content"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_vm._m(1,false,false),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('img',{staticClass:"img-fluid align-center",attrs:{"src":"static/images/logo-svg.svg","alt":""}}),_vm._v(" "),_c('div',{staticClass:"ref-form align-center"},[(_vm.login.error)?_c('p',{staticClass:"no-mar-top red-color fs-14"},[_vm._v(_vm._s(_vm.login.errormsg))]):_vm._e(),_vm._v(" "),(_vm.login.successmsg)?_c('p',{staticClass:"no-mar-top green-color fs-14"},[_vm._v(_vm._s(_vm.login.successmsg))]):_vm._e(),_vm._v(" "),_c('form',{directives:[{name:"show",rawName:"v-show",value:(_vm.login.otp_send === 1),expression:"login.otp_send === 1"}],attrs:{"data-vv-scope":"login"}},[(!_vm.login.login_with_otp)?_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.login.username),expression:"login.username"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],ref:"login_username",staticClass:"form-control",attrs:{"type":"text","name":"username","id":"username","data-vv-as":"email or mobile","placeholder":"Email or Mobile Number"},domProps:{"value":(_vm.login.username)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.login, "username", $event.target.value)}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('login.username')),expression:"errors.has('login.username')"}],staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('login.username')))])]):_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"mask",rawName:"v-mask",value:('##########'),expression:"'##########'"},{name:"model",rawName:"v-model",value:(_vm.login.username),expression:"login.username"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],ref:"login_username",staticClass:"form-control",attrs:{"type":"text","name":"username","id":"username","data-vv-as":"mobile","placeholder":"Mobile Number"},domProps:{"value":(_vm.login.username)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.login, "username", $event.target.value)}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('login.username')),expression:"errors.has('login.username')"}],staticClass:"text-danger"},[_vm._v("The mobile number field is required.")])]),_vm._v(" "),(!_vm.login.login_with_otp)?_c('div',{staticClass:"form-group  mb-2"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.login.password),expression:"login.password"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],ref:"login_password",staticClass:"form-control",attrs:{"type":"password","name":"password","id":"password","data-vv-as":"password","placeholder":"Password"},domProps:{"value":(_vm.login.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.login, "password", $event.target.value)}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('login.password')),expression:"errors.has('login.password')"}],staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('login.password')))])]):_c('div',{staticClass:"form-group  mb-2"},[_c('input',{staticClass:"form-control",attrs:{"type":"password","placeholder":"Password","disabled":""}})]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('a',{staticClass:"mb-3 text-center signup-link float-right display-block",attrs:{"data-dismiss":"modal","data-toggle":"modal","href":"#lost","data-target":".forgot","data-backdrop":"static","data-keyboard":"false"},on:{"click":function($event){_vm.clearFields()}}},[_vm._v("\n                                            Forgot Password?\n                                        ")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-12 mb-3"},[_c('label',{staticClass:"checkbox_container"},[_vm._v("Login With OTP?\n                                        "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.login.login_with_otp),expression:"login.login_with_otp"}],ref:"login_with_otp",attrs:{"type":"checkbox","name":"login_with_otp","id":"login_with_otp","data-vv-as":"login_with_otp"},domProps:{"checked":Array.isArray(_vm.login.login_with_otp)?_vm._i(_vm.login.login_with_otp,null)>-1:(_vm.login.login_with_otp)},on:{"change":function($event){var $$a=_vm.login.login_with_otp,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.login.login_with_otp=$$a.concat([$$v]))}else{$$i>-1&&(_vm.login.login_with_otp=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.$set(_vm.login, "login_with_otp", $$c)}}}}),_vm._v(" "),_c('span',{staticClass:"checkbox_checkmark"})])])]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary full-width",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();_vm.loginClicked()}}},[_vm._v(_vm._s(!_vm.login.login_with_otp ? 'Login' : 'Send OTP'))])]),_vm._v(" "),_c('form',{directives:[{name:"show",rawName:"v-show",value:(_vm.login.otp_send === 2),expression:"login.otp_send === 2"}],attrs:{"data-vv-scope":"login-wt-otp"}},[_c('div',{staticClass:"form-group  mb-2"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.login.login_otp),expression:"login.login_otp"},{name:"mask",rawName:"v-mask",value:('##########'),expression:"'##########'"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],ref:"login_otp",staticClass:"form-control",attrs:{"type":"text","name":"login_otp","id":"login_otp","maxlength":"6","data-vv-as":"OTP","placeholder":"Enter your OTP"},domProps:{"value":(_vm.login.login_otp)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.login, "login_otp", $event.target.value)}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('login-wt-otp.login_otp')),expression:"errors.has('login-wt-otp.login_otp')"}],staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('login-wt-otp.login_otp')))])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('a',{staticClass:"mb-3 text-center signup-link blue-color",on:{"click":function($event){_vm.clearFields()}}},[_vm._v("\n                                        Back to Login?\n                                    ")]),_vm._v(" "),_c('a',{staticClass:"mb-3 text-center signup-link float-right display-block resent_otp",on:{"click":function($event){_vm.loginWithOtpChanged(true)}}},[_vm._v("Resend OTP?")])])]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary full-width mar-b-15",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();_vm.verifyLoginOTP()}}},[_vm._v("Verify OTP")])])])])])])])]),_vm._v(" "),_c('FooterVue')],1)}
var ReferalLogin_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading"},[_c('div',{staticClass:"loading-img"},[_c('img',{attrs:{"src":"static/images/walk.gif","alt":""}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-6"},[_c('h1',{staticClass:"red-color"},[_vm._v("It's time to pass on the goodness")]),_vm._v(" "),_c('p',[_vm._v("Thank you for being our esteemed customer. You know it’s convenient to get a home blood test\n                            done through Labotist. Now your friends and family can benefit too. We have made it easy\n                            for you to refer a friend to avail our home blood test services.")]),_vm._v(" "),_c('p',[_vm._v("\n                            You get a credit of INR.100 in your Labotist account when your friend books a blood test\n                            with us. Of course, we won't leave your friend behind! They get an instant credit of\n                            INR.150 as soon as they register with us!\n                        ")]),_vm._v(" "),_c('h3',[_vm._v("Steps to refer:")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("\n                                Login using your Labotist login credentials\n                            ")]),_vm._v(" "),_c('li',[_vm._v("\n                                You will see the message with referral link\n                            ")]),_vm._v(" "),_c('li',[_vm._v("\n                                Share the message and link via your preferred mode - facebook, whatsapp, Instagram,\n                                email, etc\n                            ")])])])}]
var ReferalLogin_esExports = { render: ReferalLogin_render, staticRenderFns: ReferalLogin_staticRenderFns }
/* harmony default export */ var Public_ReferalLogin = (ReferalLogin_esExports);
// CONCATENATED MODULE: ./src/components/web/Public/ReferalLogin.vue
function ReferalLogin_injectStyle (ssrContext) {
  __webpack_require__("7Qwb")
}
var ReferalLogin_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var ReferalLogin___vue_template_functional__ = false
/* styles */
var ReferalLogin___vue_styles__ = ReferalLogin_injectStyle
/* scopeId */
var ReferalLogin___vue_scopeId__ = "data-v-1f8bef6a"
/* moduleIdentifier (server only) */
var ReferalLogin___vue_module_identifier__ = null
var ReferalLogin_Component = ReferalLogin_normalizeComponent(
  ReferalLogin,
  Public_ReferalLogin,
  ReferalLogin___vue_template_functional__,
  ReferalLogin___vue_styles__,
  ReferalLogin___vue_scopeId__,
  ReferalLogin___vue_module_identifier__
)

/* harmony default export */ var web_Public_ReferalLogin = (ReferalLogin_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/web/Public/ReferalInvite.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



// import Sidemenu from '@/components/web/Public/Sidemenu'

/* harmony default export */ var ReferalInvite = ({
  name: 'ReferalLogin',
  components: {
    HeaderVue: Header["a" /* default */],
    // Sidemenu,
    FooterVue: Footer["a" /* default */]
  },
  data: function data() {
    return {
      referralCode: '',
      referralUrl: 'https://labotist.com/',
      title: 'Labotist - Referral Program',
      quote: 'Hi, \r\n Here is the referral link to register with Labotist.com. They provide home blood test service and on registering you will get a credit of Rs 150 which you can use against your bookings with them, for blood test at home. \r\n   Labotists offers over 1000+ tests in partnership with 50 labs in Bengaluru and Chennai.\n ',
      description: 'Hi, \r\n Here is the referral link to register with Labotist.com. They provide home blood test service and on registering you will get a credit of Rs 150 which you can use against your bookings with them, for blood test at home. \r\n   Labotists offers over 1000+ tests in partnership with 50 labs in Bengaluru and Chennai.\n ',
      hashtags: 'homebloodtest, chennai, bengaluru',
      twitterUser: 'labotist'
    };
  },
  beforeCreate: function beforeCreate() {},
  created: function created() {
    if (!this.$localStorage.get('loggedIn') || this.$localStorage.get('loggedIn') == null) {
      this.$router.push({ path: '/referral/login' });
    } else {
      this.getProfile();
    }
  },
  mounted: function mounted() {
    this.$hidePageLoading();
    $('input[data-toggle="tooltip"]').tooltip({
      animated: 'fade',
      placement: 'top',
      trigger: 'manual'
    });
  },

  methods: {
    getProfile: function getProfile() {
      try {
        if (this.$localStorage.get('loggedIn') && this.$localStorage.get('access_token') && this.$localStorage.get('access_token') !== null) {
          var data = {};
          promise_default.a.resolve(this.$GET('patient/getProfile', data)).then(function (res) {
            if (res.response_code === 0) {
              this.referralCode = res.response.Patient.referralCode;
              this.referralUrl = this.$signupUrl + this.$encryptString(res.response.Patient.referralCode);
            }
            this.$hidePageLoading();
          }.bind(this)).catch(function (err) {
            console.error(err);
          });
        }
      } catch (e) {
        console.error('method:getProfile', e);
      }
    },
    copyReferralCodeUrl: function copyReferralCodeUrl() {
      var referralUrl = document.getElementById('referralUrl');
      setTimeout(function () {
        referralUrl.setSelectionRange(0, referralUrl.value.length);
        document.execCommand("copy");
        $('input[data-toggle="tooltip"]').tooltip("show");
      }, 1);
      setTimeout(function () {
        $('input[data-toggle="tooltip"]').tooltip("hide");
      }, 1000);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f7b36f50","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/web/Public/ReferalInvite.vue
var ReferalInvite_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"referalInviteDiv"}},[_c('HeaderVue'),_vm._v(" "),_vm._m(0,false,false),_vm._v(" "),_c('header',{staticClass:"reg-header passon-header"}),_vm._v(" "),_c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"pass-on"},[_c('div',{staticClass:"inner-page reg-content"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_vm._m(1,false,false),_vm._v(" "),_c('div',{staticClass:"col-sm-5"},[_vm._m(2,false,false),_vm._v(" "),_c('div',{staticClass:"ref-form align-center"},[_c('h1',[_vm._v("Refer Now")]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.referralCode),expression:"referralCode"}],staticClass:"form-control",attrs:{"type":"text","id":"referralCode","name":"referralCode","aria-describedby":"emailHelp","placeholder":"Referral Code","disabled":""},domProps:{"value":(_vm.referralCode)},on:{"input":function($event){if($event.target.composing){ return; }_vm.referralCode=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.description),expression:"description"}],staticClass:"form-control",attrs:{"name":"","cols":"30","rows":"10"},domProps:{"value":(_vm.description)},on:{"input":function($event){if($event.target.composing){ return; }_vm.description=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.referralUrl),expression:"referralUrl"}],ref:"copyReferralText",staticClass:"form-control",attrs:{"type":"text","id":"referralUrl","name":"referralUrl","aria-describedby":"emailHelp","data-toggle":"tooltip","data-placement":"top","title":"Copied","placeholder":"Link"},domProps:{"value":(_vm.referralUrl)},on:{"focus":function($event){_vm.copyReferralCodeUrl()},"click":function($event){_vm.copyReferralCodeUrl()},"input":function($event){if($event.target.composing){ return; }_vm.referralUrl=$event.target.value}}})]),_vm._v(" "),_c('social-sharing',{attrs:{"url":_vm.referralUrl,"title":_vm.description,"description":_vm.description,"quote":_vm.description,"hashtags":_vm.hashtags,"twitter-user":_vm.twitterUser},inlineTemplate:{render:function(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"share-btn text-right mt-3"},[_vm._v("\n                                    Share Via :\n                                    "),_vm._v(" "),_c('network',{attrs:{"network":"facebook"}},[_c('i',{staticClass:"fa fa-facebook-square"})]),_vm._v(" "),_c('network',{attrs:{"network":"twitter"}},[_c('i',{staticClass:"fa fa-twitter"})])],1)},staticRenderFns:[]}})],1)])])])])])]),_vm._v(" "),_c('FooterVue')],1)}
var ReferalInvite_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading"},[_c('div',{staticClass:"loading-img"},[_c('img',{attrs:{"src":"static/images/walk.gif","alt":""}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-7"},[_c('h1',{staticClass:"red-color"},[_vm._v("It's time to pass on the goodness")]),_vm._v(" "),_c('p',[_vm._v("Thank you for being our esteemed customer. You know it’s convenient to get a home blood test\n                                done through Labotist. Now your friends and family can benefit too. We have made it easy\n                                for you to refer a friend to avail our home blood test services.")]),_vm._v(" "),_c('p',[_vm._v("\n                                You get a credit of INR.100 in your Labotist account when your friend books a blood test\n                                with us. Of course, we won't leave your friend behind! They get an instant credit of\n                                INR.150 as soon as they register with us!\n                            ")]),_vm._v(" "),_c('h3',[_vm._v("Steps to refer:")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("\n                                    Login using your Labotist login credentials\n                                ")]),_vm._v(" "),_c('li',[_vm._v("\n                                    You will see the message with referral link\n                                ")]),_vm._v(" "),_c('li',[_vm._v("\n                                    Share the message and link via your preferred mode - facebook, whatsapp, Instagram,\n                                    email, etc\n                                ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row icon-thr"},[_c('div',{staticClass:"col-sm-1"}),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('img',{attrs:{"src":"static/images/Vector Smart Object1.png","alt":"","width":"50px"}}),_vm._v(" "),_c('h2',[_vm._v("login")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('img',{attrs:{"src":"static/images/document.png","alt":"","width":"50px"}}),_vm._v(" "),_c('h2',[_vm._v("Copy Referral message")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('img',{attrs:{"src":"static/images/share.png","alt":"","width":"50px"}}),_vm._v(" "),_c('h2',[_vm._v("Share with Friends")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-1"})])}]
var ReferalInvite_esExports = { render: ReferalInvite_render, staticRenderFns: ReferalInvite_staticRenderFns }
/* harmony default export */ var Public_ReferalInvite = (ReferalInvite_esExports);
// CONCATENATED MODULE: ./src/components/web/Public/ReferalInvite.vue
function ReferalInvite_injectStyle (ssrContext) {
  __webpack_require__("hPLD")
}
var ReferalInvite_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var ReferalInvite___vue_template_functional__ = false
/* styles */
var ReferalInvite___vue_styles__ = ReferalInvite_injectStyle
/* scopeId */
var ReferalInvite___vue_scopeId__ = "data-v-f7b36f50"
/* moduleIdentifier (server only) */
var ReferalInvite___vue_module_identifier__ = null
var ReferalInvite_Component = ReferalInvite_normalizeComponent(
  ReferalInvite,
  Public_ReferalInvite,
  ReferalInvite___vue_template_functional__,
  ReferalInvite___vue_styles__,
  ReferalInvite___vue_scopeId__,
  ReferalInvite___vue_module_identifier__
)

/* harmony default export */ var web_Public_ReferalInvite = (ReferalInvite_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/web/Public/ReferralLanding.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



// import FooterVue from "@/components/web/Footer";

/* harmony default export */ var ReferralLanding = ({
    name: "ReferralLanding",
    components: {
        HeaderVue: Header["a" /* default */]
        // FooterVue
    },
    mounted: function mounted() {
        this.getProfile();
    },
    beforeCreate: function beforeCreate() {},
    created: function created() {
        this.getProfile();
        setTimeout(function () {
            $('.slider').bxSlider({
                slideWidth: 'auto',
                minSlides: 1,
                maxSlides: 6,
                moveSlides: 6,
                slideMargin: 10,
                auto: true,
                autoControls: true
            });
            $("#carouselExampleControls").carousel();
            var footHeight = $('.fixed-footer').outerHeight();
            $('body').css('margin-bottom', footHeight);
        }, 100);
    },
    data: function data() {
        return {
            referralCode: '',
            referralUrl: 'https://labotist.com/',
            title: 'Labotist - Referral Program',
            quote: 'Hi, \r\n Here is the referral link to register with Labotist.com. They provide home blood test service and on registering you will get a credit of Rs 150 which you can use against your bookings with them, for blood test at home. \r\n   Labotists offers over 1000+ tests in partnership with 50 labs in Bengaluru and Chennai.',
            description: 'Hi,  \r\n  Here is the referral link to register with Labotist.com. They provide home blood test service and on registering you will get a credit of Rs 150 which you can use against your bookings with them, for blood test at home. \r\n   Labotists offers over 1000+ tests in partnership with 50 labs in Bengaluru and Chennai.',
            hashtags: 'Labotist,free blood sample collection,',
            twitterUser: 'Labotist.com'
        };
    },

    methods: {
        getProfile: function getProfile() {
            try {
                if (this.$localStorage.get('loggedIn') && this.$localStorage.get('access_token') && this.$localStorage.get('access_token') !== null) {
                    var data = {};
                    promise_default.a.resolve(this.$GET('patient/getProfile', data)).then(function (res) {
                        if (res.response_code === 0) {
                            if (res.response) {
                                underscore_default.a.each(res.response.Addresses, function (item) {
                                    if (item.isDefault === 1) {
                                        this.address = item.address;
                                    }
                                });
                            }
                            console.log("inside the process");
                            console.log(res.response);
                            this.firstName = res.response.Patient.firstName;
                            this.lastName = res.response.Patient.lastName;
                            this.email = res.response.email;
                            this.phone1 = res.response.Patient.phone1;
                            this.phone2 = res.response.Patient.phone2;
                            this.dob = res.response.Patient.dob ? res.response.Patient.dob : '';
                            this.sex = res.response.Patient.sex;
                            this.creditPoint = res.response.Patient.creditPoint;
                            this.referralCode = res.response.Patient.referralCode;
                            this.referralUrl = this.$signupUrl + this.$encryptString(this.referralCode);
                            this.credits = res.response.credits;
                        }
                        this.$hidePageLoading();
                    }.bind(this)).catch(function (err) {
                        console.error(err);
                    });
                }
            } catch (e) {
                console.error('method:getProfile', e);
            }
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-905d4304","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/web/Public/ReferralLanding.vue
var ReferralLanding_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"referalLandingDiv"}},[_c('HeaderVue'),_vm._v(" "),_vm._m(0,false,false),_vm._v(" "),_c('div',{staticClass:"credit-section"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-4  cr-left"},[_c('h3',[_vm._v("Your Credit")]),_vm._v(" "),_c('h2',[_vm._v("Rs."+_vm._s(_vm.creditPoint))]),_vm._v(" "),_c('router-link',{attrs:{"to":"/lab"}},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"}},[_vm._v("USE NOW")])])],1),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('div',{staticClass:"cr-content"},[_c('h2',[_vm._v("Refer Now ")]),_vm._v(" "),_c('div',{staticClass:"cr-code"},[_c('h5',[_vm._v(_vm._s(_vm.referralCode))])]),_vm._v(" "),_c('div',{staticClass:"cr-cod-con"},[_c('p',[_vm._v(_vm._s(_vm.description))])]),_vm._v(" "),_c('social-sharing',{attrs:{"title":_vm.description,"description":_vm.description,"quote":_vm.description,"hashtags":_vm.hashtags,"twitter-user":_vm.twitterUser,"url":_vm.referralUrl},inlineTemplate:{render:function(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"share-btn mt-3 mt-b "},[_vm._v("\n                                Share Via :\n                                "),_c('network',{attrs:{"network":"facebook"}},[_c('i',{staticClass:"fa fa-facebook-square"})]),_vm._v(" "),_c('network',{attrs:{"network":"twitter"}},[_c('i',{staticClass:"fa fa-twitter"})])],1)},staticRenderFns:[]}})],1)])])])]),_vm._v(" "),_vm._m(1,false,false),_vm._v(" "),_vm._m(2,false,false)],1)}
var ReferralLanding_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading"},[_c('div',{staticClass:"loading-img"},[_c('img',{attrs:{"src":"static/images/walk.gif","alt":""}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"inline-img"},[_c('div',[_c('a',{attrs:{"href":"/redirect/labs/Dengue_Profile"}},[_c('img',{attrs:{"src":"static/images/book1.png","alt":""}})])]),_vm._v(" "),_c('div',[_c('a',{attrs:{"href":"/redirect/labs/Mega_Health_Checkup"}},[_c('img',{attrs:{"src":"static/images/book3.png","alt":""}})])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fixed-footer"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-1"},[_c('h5',{staticClass:"text-sm-left foot-title text-nowrap"},[_c('b',[_c('span',{staticClass:"blue-color"},[_vm._v("Our Lab")]),_vm._v(" "),_c('br',{staticClass:"sm-hidden"}),_vm._v(" "),_c('span',{staticClass:"green-color"},[_vm._v("Partners")])])]),_vm._v(" "),_c('div',{staticClass:"left-line"})]),_vm._v(" "),_c('div',{staticClass:"col-sm-11"},[_c('div',{staticClass:"slider"},[_c('div',{staticClass:"slide"},[_c('div',{staticClass:"card"},[_c('img',{staticClass:"card-img-top",attrs:{"src":"static/images/client/medall.jpg","alt":"Medall Health Care Pvt Ltd"}})])]),_vm._v(" "),_c('div',{staticClass:"slide"},[_c('div',{staticClass:"card"},[_c('img',{staticClass:"card-img-top",attrs:{"src":"static/images/client/metroplis.png","alt":"Lister Metropolis Healthcare Limited"}})])]),_vm._v(" "),_c('div',{staticClass:"slide"},[_c('div',{staticClass:"card"},[_c('img',{staticClass:"card-img-top",attrs:{"src":"static/images/client/bioline.jpg","alt":"Bio Line Laboratory"}})])]),_vm._v(" "),_c('div',{staticClass:"slide"},[_c('div',{staticClass:"card"},[_c('img',{staticClass:"card-img-top",attrs:{"src":"static/images/client/techmed.jpg","alt":"Techmed Health Centre & Diagnostic"}})])]),_vm._v(" "),_c('div',{staticClass:"slide"},[_c('div',{staticClass:"card"},[_c('img',{staticClass:"card-img-top",attrs:{"src":"static/images/client/srl.png","alt":"Specialtys Medical Diagnostic(SRL Diagnostics)"}})])]),_vm._v(" "),_c('div',{staticClass:"slide"},[_c('div',{staticClass:"card"},[_c('img',{staticClass:"card-img-top",attrs:{"src":"static/images/client/vrr.jpg","alt":"VRR Diagnostics"}})])]),_vm._v(" "),_c('div',{staticClass:"slide"},[_c('div',{staticClass:"card"},[_c('img',{staticClass:"card-img-top",attrs:{"src":"static/images/client/medcis.png","alt":"Medcis Pathlabs India Pvt. Ltd"}})])]),_vm._v(" "),_c('div',{staticClass:"slide"},[_c('div',{staticClass:"card"},[_c('img',{staticClass:"card-img-top",attrs:{"src":"static/images/client/pathcare.jpg","alt":"Path Care Labs Pvt. Ltd"}})])]),_vm._v(" "),_c('div',{staticClass:"slide"},[_c('div',{staticClass:"card"},[_c('img',{staticClass:"card-img-top",attrs:{"src":"static/images/client/aarthi.jpg","alt":"Aarthi Scans And Labs"}})])]),_vm._v(" "),_c('div',{staticClass:"slide"},[_c('div',{staticClass:"card"},[_c('img',{staticClass:"card-img-top",attrs:{"src":"static/images/client/primex.png","alt":"Primex Scans and Labs"}})])]),_vm._v(" "),_c('div',{staticClass:"slide"},[_c('div',{staticClass:"card"},[_c('img',{staticClass:"card-img-top",attrs:{"src":"static/images/client/microbiological.jpg","alt":"Microbiological Laboratory"}})])]),_vm._v(" "),_c('div',{staticClass:"slide"},[_c('div',{staticClass:"card"},[_c('img',{staticClass:"card-img-top",attrs:{"src":"static/images/client/hitech.jpg","alt":"Hitech Diagnostic Centre"}})])]),_vm._v(" "),_c('div',{staticClass:"slide"},[_c('div',{staticClass:"card"},[_c('img',{staticClass:"card-img-top",attrs:{"src":"static/images/client/asian.jpg","alt":"Asian Diagnostics"}})])]),_vm._v(" "),_c('div',{staticClass:"slide"},[_c('div',{staticClass:"card"},[_c('img',{staticClass:"card-img-top",attrs:{"src":"static/images/client/diagnolabs.jpg","alt":"Diagno labs Pvt Ltd"}})])])])])])])])}]
var ReferralLanding_esExports = { render: ReferralLanding_render, staticRenderFns: ReferralLanding_staticRenderFns }
/* harmony default export */ var Public_ReferralLanding = (ReferralLanding_esExports);
// CONCATENATED MODULE: ./src/components/web/Public/ReferralLanding.vue
function ReferralLanding_injectStyle (ssrContext) {
  __webpack_require__("dyeu")
}
var ReferralLanding_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var ReferralLanding___vue_template_functional__ = false
/* styles */
var ReferralLanding___vue_styles__ = ReferralLanding_injectStyle
/* scopeId */
var ReferralLanding___vue_scopeId__ = "data-v-905d4304"
/* moduleIdentifier (server only) */
var ReferralLanding___vue_module_identifier__ = null
var ReferralLanding_Component = ReferralLanding_normalizeComponent(
  ReferralLanding,
  Public_ReferralLanding,
  ReferralLanding___vue_template_functional__,
  ReferralLanding___vue_styles__,
  ReferralLanding___vue_scopeId__,
  ReferralLanding___vue_module_identifier__
)

/* harmony default export */ var web_Public_ReferralLanding = (ReferralLanding_Component.exports);

// CONCATENATED MODULE: ./src/router/WebRouter.js






// Public Components







// Secure Login Components





// Public Booking Components




// Secure Booking Components














/* harmony default export */ var WebRouter = ({
  routes: [{
    path: '*',
    component: components_web_404,
    meta: {
      title: '404:Page Not Found - Labotist'
    }
  }, {
    path: '/',
    name: 'Home',
    components: { default: components_web_Home, 'HeaderVue': Header["a" /* default */], 'FooterVue': Footer["a" /* default */] },
    meta: {
      title: 'Home - Labotist',
      metaTags: [{
        name: 'description',
        content: 'Pick a test, Pick a Lab, Pick a time. We will take care of the rest. Hygienic and top notch home sample collection for free'
      }, {
        property: 'og:description',
        content: 'Pick a test, Pick a Lab, Pick a time. We will take care of the rest. Hygienic and top notch home sample collection for free'
      }]
    }
  }, {
    path: '/dashboard',
    name: 'Dashboard',
    component: components_web_Dashboard,
    meta: {
      title: 'Home - Labotist',
      metaTags: [{
        name: 'description',
        content: 'Pick a test, Pick a Lab, Pick a time. We will take care of the rest | Book Test or View Results'
      }, {
        property: 'og:description',
        content: 'Pick a test, Pick a Lab, Pick a time. We will take care of the rest | Book Test or View Results'
      }]
    }
  }, {
    path: '/login',
    name: 'Login',
    component: components_web_Home,
    meta: {
      title: 'Login - Labotist',
      metaTags: [{
        name: 'description',
        content: 'Pick a test, Pick a Lab, Pick a time. We will take care of the rest. Hygienic and top notch home sample collection for free'
      }, {
        property: 'og:description',
        content: 'Pick a test, Pick a Lab, Pick a time. We will take care of the rest. Hygienic and top notch home sample collection for free'
      }]
    }
  }, {
    path: '/signup/:referralCode',
    name: 'Login',
    component: components_web_Home,
    meta: {
      title: 'Login - Labotist',
      metaTags: [{
        name: 'description',
        content: 'Pick a test, Pick a Lab, Pick a time. We will take care of the rest. Hygienic and top notch home sample collection for free'
      }, {
        property: 'og:description',
        content: 'Pick a test, Pick a Lab, Pick a time. We will take care of the rest. Hygienic and top notch home sample collection for free'
      }]
    }
  }, {
    path: '/about-us',
    name: 'Aboutus',
    component: web_Public_Aboutus,
    meta: {
      title: 'About Us - Labotist',
      metaTags: [{
        name: 'description',
        content: 'Top notch home sample collection service provider, technology driven, temperature controlled sample tracking & monitoring.'
      }, {
        property: 'og:description',
        content: 'Top notch home sample collection service provider, technology driven, temperature controlled sample tracking & monitoring.'
      }]
    }
  }, {
    path: '/contact-us',
    name: 'Contactus',
    component: web_Public_Contactus,
    meta: {
      title: 'Contact Us - Labotist',
      metaTags: [{
        name: 'description',
        content: 'Call us at 90256 62566 to book any lab test or learn more about services.'
      }, {
        property: 'og:description',
        content: 'Call us at 90256 62566 to book any lab test or learn more about services.'
      }]
    }
  }, {
    path: '/privacy-policy',
    name: 'Privacy',
    component: web_Public_Privacy,
    meta: {
      title: 'Privacy - Labotist',
      metaTags: [{
        name: 'description',
        content: 'Privacy policy and terms & conditions'
      }, {
        property: 'og:description',
        content: 'Privacy policy and terms & conditions'
      }]
    }
  }, {
    path: '/terms',
    name: 'Terms',
    component: web_Public_Terms,
    meta: {
      title: 'Terms - Labotist',
      metaTags: [{
        name: 'description',
        content: 'Privacy policy and terms & conditions'
      }, {
        property: 'og:description',
        content: 'Privacy policy and terms & conditions'
      }]
    }
  }, {
    path: '/lab-signup',
    name: 'Labsignup',
    component: web_Public_Labsignup,
    meta: {
      title: 'Lab Sign Up - Labotist',
      metaTags: [{
        name: 'description',
        content: 'Partner with us for home sample collection services while you focus on your core business. In addition Improve your brand visibility, reach and revenue. Reduce the headache and cost of managing phlebotomy operations.'
      }, {
        property: 'og:description',
        content: 'Partner with us for home sample collection services while you focus on your core business. In addition Improve your brand visibility, reach and revenue. Reduce the headache and cost of managing phlebotomy operations.'
      }]
    }
  }, {
    path: '/phlebotomist-signup',
    name: 'Phlebsignup',
    component: web_Public_Phlebsignup,
    meta: {
      title: 'Phlebotomist Sign Up - Labotist',
      metaTags: [{
        name: 'description',
        content: 'Partner with us full-time or part-time to earn more, work flexible hours and provide exceptional service to Patients. Become the experts through advanced training and use of technology.'
      }, {
        property: 'og:description',
        content: 'Partner with us full-time or part-time to earn more, work flexible hours and provide exceptional service to Patients. Become the experts through advanced training and use of technology.'
      }]
    }
  }, {
    path: '/myresult',
    name: 'MyResult',
    component: web_Secure_MyResult,
    meta: {
      title: 'My Result - Labotist',
      metaTags: [{
        name: 'description',
        content: 'View results from any labs, share it easily to your doctor or family member'
      }, {
        property: 'og:description',
        content: 'View results from any labs, share it easily to your doctor or family member'
      }]
    }
  }, {
    path: '/myprofile',
    name: 'MyProfile',
    component: web_Secure_MyProfile,
    meta: {
      title: 'My Profile - Labotist',
      metaTags: [{
        name: 'description',
        content: 'Complete your profile for timely service, accurate status notifications, reminders and customized packages. '
      }, {
        property: 'og:description',
        content: 'Complete your profile for timely service, accurate status notifications, reminders and customized packages. '
      }]
    }
  }, {
    path: '/editprofile',
    name: 'EditProfile',
    component: web_Secure_EditProfile,
    meta: {
      title: 'Edit Profile - Labotist',
      metaTags: [{
        name: 'description',
        content: 'Complete your profile for timely service, accurate status notifications, reminders and customized packages. '
      }, {
        property: 'og:description',
        content: 'Complete your profile for timely service, accurate status notifications, reminders and customized packages. '
      }]
    }
  }, {
    path: '/changepassword',
    name: 'ChangePassword',
    component: web_Secure_ChangePassword,
    meta: {
      title: 'Change Password - Labotist',
      metaTags: [{
        name: 'description',
        content: 'Complete your profile for timely service, accurate status notifications, reminders and customized packages. '
      }, {
        property: 'og:description',
        content: 'Complete your profile for timely service, accurate status notifications, reminders and customized packages. '
      }]
    }
  }, {
    path: '/test',
    name: 'Test',
    component: web_Book_Test,
    meta: {
      title: 'Find Your Test | Labotist',
      metaTags: [{
        name: 'description',
        content: 'Search for tests and pick your favorite lab in the city to get your blood test done. Free home sample collection.'
      }, {
        property: 'og:description',
        content: 'Search for tests and pick your favorite lab in the city to get your blood test done. Free home sample collection.'
      }]
    }
  }, {
    path: '/lab',
    name: 'Lab',
    component: web_Book_Lab,
    meta: {
      title: 'Choose Lab - Labotist',
      metaTags: [{
        name: 'description',
        content: 'Search for tests and pick your favorite lab in the city to get your blood test done. Free home sample collection.'
      }, {
        property: 'og:description',
        content: 'Search for tests and pick your favorite lab in the city to get your blood test done. Free home sample collection.'
      }]
    }
  }, {
    path: '/appointment',
    name: 'Appointment',
    component: web_Book_Appointment,
    meta: {
      title: 'Appointment Date|Time - Labotist',
      metaTags: [{
        name: 'description',
        content: 'Book a convenient date and time for home sample collection. Our trained phlebotomist will take care of the rest. '
      }, {
        property: 'og:description',
        content: 'Book a convenient date and time for home sample collection. Our trained phlebotomist will take care of the rest. '
      }]
    }
  }, {
    path: '/address',
    name: 'Address',
    component: Book_Secure_Address,
    meta: {
      title: 'Select Address - Labotist',
      metaTags: [{
        name: 'description',
        content: 'Choose a convenient location for sample collection. At home or at work. We will be there. '
      }, {
        property: 'og:description',
        content: 'Choose a convenient location for sample collection. At home or at work. We will be there. '
      }]
    }
  }, {
    path: '/payment',
    name: 'Payment',
    component: Book_Secure_Payment,
    meta: {
      title: 'Payment - Labotist',
      metaTags: [{
        name: 'description',
        content: 'Choose a convenient location for sample collection. At home or at work. Make payment and create an order.  '
      }, {
        property: 'og:description',
        content: 'Choose a convenient location for sample collection. At home or at work. Make payment and create an order.  '
      }]
    }
  }, {
    path: '/success',
    name: 'Success',
    component: Book_Secure_Success,
    meta: {
      title: 'Success - Labotist',
      metaTags: [{
        name: 'description',
        content: 'Thanks for placing order with Labotist.'
      }, {
        property: 'og:description',
        content: 'Thanks for placing order with Labotist.'
      }]
    },
    props: true
  }, {
    path: '/blog_iframe',
    name: 'BlogFrame',
    component: components_web_BlogFrame,
    meta: {
      title: 'Labotist'
    }
  }, {
    path: '/labs/:city/:test',
    name: 'LabLocation',
    component: web_Book_LabLocation,
    meta: {
      title: 'Choose Lab - Labotist',
      metaTags: [{
        name: 'description',
        content: ''
      }, {
        property: 'og:description',
        content: ''
      }]
    }
  }, {
    path: '/labs/:city/:test/:location',
    name: 'LabLocation',
    component: web_Book_LabLocation,
    meta: {
      title: 'Choose Lab - Labotist',
      metaTags: [{
        name: 'description',
        content: ''
      }, {
        property: 'og:description',
        content: ''
      }]
    }
  }, {
    path: '/redirect/:data',
    name: 'Redirect',
    component: web_Public_Redirect,
    meta: {
      title: 'Labotist'
    }
  }, {
    path: '/redirect/:data/url/:tests',
    name: 'Redirect',
    component: web_Public_Redirect,
    meta: {
      title: 'Labotist'
    }
  }, {
    path: '/redirect/labs/:testdata',
    name: 'LabRedirect',
    component: web_Public_LabRedirect,
    meta: {
      title: 'Choose Lab - Labotist'
    }
  }, {
    path: '/referral/signup',
    name: 'ReferalSignup',
    component: web_Public_ReferalSignup,
    meta: {
      title: 'Choose Lab - Labotist'
    }
  }, {
    path: '/referral/signup/:referal_code',
    name: 'ReferalSignup',
    component: web_Public_ReferalSignup,
    meta: {
      title: 'Choose Lab - Labotist'
    }
  }, {
    path: '/referral/login',
    name: 'ReferalLogin',
    component: web_Public_ReferalLogin,
    meta: {
      title: 'Choose Lab - Labotist'
    }
  }, {
    path: '/referral/invite',
    name: 'ReferalInvite',
    component: web_Public_ReferalInvite,
    meta: {
      title: 'Choose Lab - Labotist'
    }
  }, {
    path: '/referral/landing',
    name: 'ReferralLanding',
    component: web_Public_ReferralLanding,
    meta: {
      title: 'Choose Lab - Labotist'
    }
  }]
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/404.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var mobile_404 = ({
  name: '404Page',
  components: {
    HeaderVue: mobile_Header["a" /* default */],
    FooterVue: mobile_Footer["a" /* default */]
  },
  data: function data() {
    return {};
  },
  beforeCreate: function beforeCreate() {},
  mounted: function mounted() {
    this.$hidePageLoading();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-af2dc0cc","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/404.vue
var _04_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"PageNotFoundDiv"}},[_c('HeaderVue',{attrs:{"isHeader":"true"}}),_vm._v(" "),_vm._m(0,false,false),_vm._v(" "),_c('FooterVue')],1)}
var _04_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"green-bg"},[_c('div',{staticClass:"section dashboard-online"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-5"},[_c('h2',{staticClass:"section-title red-color"},[_vm._v("404: THE PAGE YOU REQUESTED DOES NOT EXIST")]),_vm._v(" "),_c('p',{staticClass:"theme-lineheight"},[_vm._v("\n                        Oops. Something obviously isn’t right if you’re reading this. The URL you entered or followed no longer seems to exist, has been removed, or has been replaced. If you feel that this an error that needs to be addressed, feel free to contact the administrator of this website.\n                      ")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-7"},[_c('img',{staticClass:"img-fluid section-img responsive-img",attrs:{"src":"static/images/404.png","alt":""}})])])])])])}]
var _04_esExports = { render: _04_render, staticRenderFns: _04_staticRenderFns }
/* harmony default export */ var components_mobile_404 = (_04_esExports);
// CONCATENATED MODULE: ./src/components/mobile/404.vue
function _04_injectStyle (ssrContext) {
  __webpack_require__("cepg")
}
var _04_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var _04___vue_template_functional__ = false
/* styles */
var _04___vue_styles__ = _04_injectStyle
/* scopeId */
var _04___vue_scopeId__ = "data-v-af2dc0cc"
/* moduleIdentifier (server only) */
var _04___vue_module_identifier__ = null
var _04_Component = _04_normalizeComponent(
  mobile_404,
  components_mobile_404,
  _04___vue_template_functional__,
  _04___vue_styles__,
  _04___vue_scopeId__,
  _04___vue_module_identifier__
)

/* harmony default export */ var src_components_mobile_404 = (_04_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/Home.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import Login from '@/components/Login'




/* harmony default export */ var mobile_Home = ({
  name: 'Home',
  components: {
    HeaderVue: mobile_Header["a" /* default */],
    FooterVue: mobile_Footer["a" /* default */]
  },
  beforeCreate: function beforeCreate() {
    this.query = this.$localStorage.get('location');
  },
  created: function created() {
    setTimeout(function () {
      $("#carouselExampleControls").carousel();
      $("#carouselLabPartners").carousel();
    }, 1000);
  },
  data: function data() {
    return {
      onBlurKey: 'none',
      address: '',
      query: this.$localStorage.get('location') ? this.$localStorage.get('location').locationName + '-' + this.$localStorage.get('location').locationZipCode : '',
      items: [],
      selectedLocation: this.$localStorage.get('location') ? this.$localStorage.get('location') : undefined,
      selectedPincode: this.$localStorage.get('pincode') ? this.$localStorage.get('pincode') : undefined,
      locationObj: null
    };
  },

  methods: {
    goTest: function goTest() {
      this.query = this.selectedLocation ? this.selectedLocation.locationName + '-' + this.selectedLocation.locationZipCode : '';
      if (!this.selectedLocation) {
        return false;
      }
      this.$localStorage.set('location', this.selectedLocation, 0);
      this.$localStorage.set('pincode', this.selectedLocation.locationZipCode, 0);
      vue_esm["default"].analytics.fbq.event('ViewContent', {
        content_ids: this.selectedLocation.locationId,
        content_name: this.selectedLocation.locationZipCode,
        contents: { id: this.selectedLocation.locationId, location: this.selectedLocation.locationName, zipcode: this.selectedLocation.locationZipCode },
        content_type: 'PINCODE_ENTERED'
      });
      this.$router.push({ path: '/lab' });
    },
    searchLocation: function searchLocation(event) {
      if (event.key === 'Control' || event.key === 'Tab') {
        return false;
      }
      this.onBlurKey = 'block';
      this.selectedLocation = undefined;
      this.$localStorage.remove('location');
      this.$localStorage.remove('pincode');
      if (this.query.length < 3) {
        this.onBlurKey = 'none';
        this.items = [];
        return false;
      }
      try {
        if (this.$localStorage.get('access_token') !== '') {
          var data = {
            'keyword': this.query
          };
          promise_default.a.resolve(this.$POST('patient/searchLocation', data)).then(function (res) {
            console.log(res);
            if (res.response_code === 0) {
              this.items = res.response;
            }
          }.bind(this)).catch(function (err) {
            console.error(err);
          });
        }
      } catch (e) {
        console.error(e);
      }
    },
    closeBlock: function closeBlock() {
      setTimeout(function () {
        this.onBlurKey = 'none';
      }.bind(this), 300);
    },
    selectLocation: function selectLocation(event, obj) {
      this.selectedLocation = undefined;
      this.selectedLocation = obj;
      this.selectedPincode = obj.locationZipCode;
      this.query = obj.locationName + '-' + obj.locationZipCode;
      this.items = [];
      this.onBlurKey = 'none';
      setTimeout(function () {
        this.$refs.pincodeSubmit.focus();
      }.bind(this), 300);
    }
  },
  watch: {
    address: function address(val, oldVal) {
      console.log('new: %s, old: %s', val, oldVal);
    }
  },
  mounted: function mounted() {
    this.$hidePageLoading();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-29b504e6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/Home.vue
var mobile_Home_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"HomeDiv"}},[_c('HeaderVue',{attrs:{"isHeader":"true"}}),_vm._v(" "),_c('div',{staticClass:"banner-section"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"banner-text"},[_c('h1',[_vm._v("Your blood tests, Your choice of labs, at Your home")]),_vm._v(" "),_c('h4',[_vm._v("Affordable tests at great convenience")]),_vm._v(" "),_c('p',{staticClass:"black-color text-center mb-1 mt-3 font-weight-bold"},[_vm._v("Our service is currently in Chennai & Bengaluru")]),_vm._v(" "),_c('div',{staticClass:"banner-fields"},[_vm._v("\n                            "+_vm._s(_vm.query.locationName)+"\n                            "),_c('button',{ref:"pincodeSubmit",staticClass:"btn btn-lg btn-primary full-width mt-3",attrs:{"type":"button"},on:{"click":function($event){_vm.$router.push({ path: '/lab' })}}},[_vm._v("\n                            Book Test\n                            ")])])])])])]),_vm._v(" "),_vm._m(0,false,false)]),_vm._v(" "),_vm._m(1,false,false),_vm._v(" "),_vm._m(2,false,false),_vm._v(" "),_vm._m(3,false,false),_vm._v(" "),_c('FooterVue',{attrs:{"foot":"true"}})],1)}
var mobile_Home_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"row mt-3"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"carousel slide",attrs:{"id":"carouselExampleControls","data-ride":"carousel"}},[_c('div',{staticClass:"carousel-inner"},[_c('div',{staticClass:"carousel-item active"},[_c('img',{staticClass:"d-block w-100",attrs:{"src":"static/images/banner.svg","alt":""}})]),_vm._v(" "),_c('div',{staticClass:"carousel-item"},[_c('img',{staticClass:"d-block w-100",attrs:{"src":"static/images/banner-old.svg","alt":"Second slide"}})])]),_vm._v(" "),_c('a',{staticClass:"carousel-control-prev",attrs:{"href":"#carouselExampleControls","role":"button","data-slide":"prev"}},[_c('span',{staticClass:"carousel-control-prev-icon",attrs:{"aria-hidden":"true"}},[_c('i',{staticClass:"fa fa-angle-double-left"})]),_vm._v(" "),_c('span',{staticClass:"sr-only"},[_vm._v("Previous")])]),_vm._v(" "),_c('a',{staticClass:"carousel-control-next",attrs:{"href":"#carouselExampleControls","role":"button","data-slide":"next"}},[_c('span',{staticClass:"carousel-control-next-icon",attrs:{"aria-hidden":"true"}},[_c('i',{staticClass:"fa fa-angle-double-right"})]),_vm._v(" "),_c('span',{staticClass:"sr-only"},[_vm._v("Next")])])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"section"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('h2',{staticClass:"section-title text-center"},[_vm._v("Why Labotist?")]),_vm._v(" "),_c('div',{staticClass:"why-labotist flex-row "},[_c('div',{staticClass:"future-list flex-nowrap flex-column"},[_c('span',{staticClass:"sprites sprite-pickup align-center"}),_vm._v(" "),_c('p',[_vm._v("Free Home\n                                "),_c('br'),_vm._v(" Sample Pickup")])]),_vm._v(" "),_c('div',{staticClass:"future-list flex-column"},[_c('span',{staticClass:"sprites sprite-phlebotomists align-center"}),_vm._v(" "),_c('p',[_vm._v("Trained\n                                "),_c('br'),_vm._v(" Phlebotomists")])]),_vm._v(" "),_c('div',{staticClass:"future-list flex-column"},[_c('span',{staticClass:"sprites sprite-shield align-center"}),_vm._v(" "),_c('p',[_vm._v("Technology enabled & safe\n                                "),_c('br'),_vm._v(" sample collection process")])]),_vm._v(" "),_c('div',{staticClass:"future-list"},[_c('span',{staticClass:"sprites sprite-star align-center"}),_vm._v(" "),_c('p',[_vm._v("Know\n                                "),_c('br'),_vm._v(" your labs better")])]),_vm._v(" "),_c('div',{staticClass:"future-list"},[_c('span',{staticClass:"sprites sprite-mobile align-center"}),_vm._v(" "),_c('p',[_vm._v("Get\n                                "),_c('br'),_vm._v(" Online Reports")])])])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"blue-bg"},[_c('div',{staticClass:"section"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('h2',{staticClass:"section-title"},[_vm._v("We created a specially designed box and universal kit for you to ensure accurate results")]),_vm._v(" "),_c('img',{staticClass:"img-fluid section-img kit-img",attrs:{"src":"static/images/kit.svg","alt":""}}),_vm._v(" "),_c('ul',{staticClass:"kit-list"},[_c('li',[_vm._v("Disposable")]),_vm._v(" "),_c('li',[_vm._v("Pre-bar coded tubes")]),_vm._v(" "),_c('li',[_vm._v("Hygienic sample draw accessories")]),_vm._v(" "),_c('li',[_vm._v("Insulated box for safe transportation of samples")]),_vm._v(" "),_c('li',[_vm._v("Temperature controlled to ensure sample quality")])])])])])]),_vm._v(" "),_c('div',{staticClass:"section"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('h2',{staticClass:"section-title text-center"},[_vm._v("How Labotist Works?")])])]),_vm._v(" "),_c('div',{staticClass:"flex-row labotist-work"},[_c('div',{staticClass:"flex-column"},[_c('div',{staticClass:"white-box ml-0"},[_c('div',{staticClass:"white-content"},[_c('span',{staticClass:"sprites sprite-one"}),_vm._v(" "),_c('h5',[_vm._v("Choose test and select lab")]),_vm._v(" "),_c('p',[_vm._v("Select the right test and the best lab based on quality, turn around time, method of\n                                    testing & price, and book your test digitally ")])])])]),_vm._v(" "),_c('div',{staticClass:"flex-column"},[_c('div',{staticClass:"white-box"},[_c('div',{staticClass:"white-content"},[_c('span',{staticClass:"sprites sprite-two"}),_vm._v(" "),_c('h5',[_vm._v("Sample collected at home")]),_vm._v(" "),_c('p',[_vm._v("A trained phlebotomist will come to your home at the scheduled time to collect the sample in a safe & hygienic method and deliver it to the choosen lab making it very convenient for you.")])])])]),_vm._v(" "),_c('div',{staticClass:"flex-column"},[_c('div',{staticClass:"white-box"},[_c('div',{staticClass:"white-content"},[_c('span',{staticClass:"sprites sprite-three"}),_vm._v(" "),_c('h5',[_vm._v("Safe, Secure & Accurate")]),_vm._v(" "),_c('p',[_vm._v("The technology driven sample collection process and transportation of samples in a specially designed box, ensures superior sample quality, enabling accurate results.")])])])])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"green-bg"},[_c('div',{staticClass:"section dashboard-online"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-5"},[_c('h2',{staticClass:"section-title"},[_vm._v("Your personal\n                            "),_c('br'),_vm._v(" dashboard online")]),_vm._v(" "),_c('p',{staticClass:"theme-lineheight"},[_vm._v("All lab reports, irrespective of the lab at which you get your tests done, will be stored under\n                            one registered account securely. You will also be able to manage your records or that of\n                            family members under one account. Labotist provides easy access to health records and history whenever and whereever needed.")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-7"},[_c('img',{staticClass:"img-fluid full-width section-img responsive-img",attrs:{"src":"static/images/responsive.svg","alt":""}})])])])]),_vm._v(" "),_c('div',{staticClass:"section"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('h2',{staticClass:"section-title text-center"},[_vm._v("What our customer say")])])]),_vm._v(" "),_c('div',{staticClass:"d-flex testimonial-list"},[_c('div',{staticClass:"flex-column"},[_c('div',{staticClass:"testimonial-box"},[_c('p',[_vm._v("The lab test search and selection of labs was very simple. I was able to make a well informed decision on the lab instead of by default opting to go the nearest one or the one which my doctor asks me to go")])]),_vm._v(" "),_c('div',{staticClass:"testimonial-profile clearfix"},[_c('div',{staticClass:"testimonial-dp",staticStyle:{"background-image":"url(static/images/kumaresh.png)","background-size":"100%"}}),_vm._v(" "),_c('h5',[_vm._v("Kumaresh")]),_vm._v(" "),_c('p',[_vm._v("IT Engineer")])])]),_vm._v(" "),_c('div',{staticClass:"flex-column"},[_c('div',{staticClass:"testimonial-box"},[_c('p',[_vm._v("You guys rock. Such a convenient way to research, order and get samples collected and delivered professionally..all just through a few clicks. A great experience.")])]),_vm._v(" "),_c('div',{staticClass:"testimonial-profile clearfix"},[_c('div',{staticClass:"testimonial-dp",staticStyle:{"background-image":"url(static/images/imran.png)","background-size":"100%"}}),_vm._v(" "),_c('h5',[_vm._v("Imran")]),_vm._v(" "),_c('p',[_vm._v("Director of Photography")])])]),_vm._v(" "),_c('div',{staticClass:"flex-column"},[_c('div',{staticClass:"testimonial-box"},[_c('p',[_vm._v("First time I ever felt pampered during the blood draw process :). Quick, easy & hygienic. Technology working at its best to ensure safety, quality and convenience.")])]),_vm._v(" "),_c('div',{staticClass:"testimonial-profile clearfix"},[_c('div',{staticClass:"testimonial-dp",staticStyle:{"background-image":"url(static/images/hemavathy.png)","background-size":"100%"}}),_vm._v(" "),_c('h5',[_vm._v("Hemavathy")]),_vm._v(" "),_c('p',[_vm._v("Housewife")])])])])]),_vm._v(" "),_c('div',{staticClass:"container"},[_c('div',{staticClass:"row mt-3"},[_c('div',{staticClass:"col-sm-12"},[_c('h2',{staticClass:"section-title text-center"},[_vm._v("Our Lab Partners")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"carousel slide",attrs:{"id":"carouselLabPartners","data-ride":"carousel"}},[_c('div',{staticClass:"carousel-inner"},[_c('div',{staticClass:"carousel-item active"},[_c('img',{staticClass:"d-block w-75 align-center",attrs:{"src":"static/images/client/medall.jpg","alt":"Medall Health Care Pvt Ltd"}})]),_vm._v(" "),_c('div',{staticClass:"carousel-item"},[_c('img',{staticClass:"d-block w-75 align-center",attrs:{"src":"static/images/client/metroplis.png","alt":"Lister Metropolis Healthcare Limited"}})]),_vm._v(" "),_c('div',{staticClass:"carousel-item"},[_c('img',{staticClass:"d-block w-75 align-center",attrs:{"src":"static/images/client/bioline.jpg","alt":"Bio Line Laboratory"}})]),_vm._v(" "),_c('div',{staticClass:"carousel-item"},[_c('img',{staticClass:"d-block w-75 align-center",attrs:{"src":"static/images/client/techmed.jpg","alt":"Techmed Health Centre & Diagnostic"}})]),_vm._v(" "),_c('div',{staticClass:"carousel-item"},[_c('img',{staticClass:"d-block w-75 align-center",attrs:{"src":"static/images/client/srl.png","alt":"Specialtys Medical Diagnostic(SRL Diagnostics)"}})]),_vm._v(" "),_c('div',{staticClass:"carousel-item"},[_c('img',{staticClass:"d-block w-75 align-center",attrs:{"src":"static/images/client/vrr.jpg","alt":"VRR Diagnostics"}})]),_vm._v(" "),_c('div',{staticClass:"carousel-item"},[_c('img',{staticClass:"d-block w-75 align-center",attrs:{"src":"static/images/client/medcis.png","alt":"Medcis Pathlabs India Pvt. Ltd"}})]),_vm._v(" "),_c('div',{staticClass:"carousel-item"},[_c('img',{staticClass:"d-block w-75 align-center",attrs:{"src":"static/images/client/pathcare.jpg","alt":"Path Care Labs Pvt. Ltd"}})]),_vm._v(" "),_c('div',{staticClass:"carousel-item"},[_c('img',{staticClass:"d-block w-75 align-center",attrs:{"src":"static/images/client/aarthi.jpg","alt":"Aarthi Scans And Labs"}})]),_vm._v(" "),_c('div',{staticClass:"carousel-item"},[_c('img',{staticClass:"d-block w-75 align-center",attrs:{"src":"static/images/client/primex.png","alt":"Primex Scans and Labs"}})]),_vm._v(" "),_c('div',{staticClass:"carousel-item"},[_c('img',{staticClass:"d-block w-75 align-center",attrs:{"src":"static/images/client/microbiological.jpg","alt":"Microbiological Laboratory"}})]),_vm._v(" "),_c('div',{staticClass:"carousel-item"},[_c('img',{staticClass:"d-block w-75 align-center",attrs:{"src":"static/images/client/hitech.jpg","alt":"Hitech Diagnostic Centre"}})]),_vm._v(" "),_c('div',{staticClass:"carousel-item"},[_c('img',{staticClass:"d-block w-75 align-center",attrs:{"src":"static/images/client/asian.jpg","alt":"Asian Diagnostics"}})]),_vm._v(" "),_c('div',{staticClass:"carousel-item"},[_c('img',{staticClass:"d-block w-75 align-center",attrs:{"src":"static/images/client/diagnolabs.jpg","alt":"Diagno labs Pvt Ltd"}})])]),_vm._v(" "),_c('a',{staticClass:"carousel-control-prev",attrs:{"href":"#carouselLabPartners","role":"button","data-slide":"prev"}},[_c('span',{staticClass:"carousel-control-prev-icon",attrs:{"aria-hidden":"true"}},[_c('i',{staticClass:"fa fa-angle-double-left"})]),_vm._v(" "),_c('span',{staticClass:"sr-only"},[_vm._v("Previous")])]),_vm._v(" "),_c('a',{staticClass:"carousel-control-next",attrs:{"href":"#carouselLabPartners","role":"button","data-slide":"next"}},[_c('span',{staticClass:"carousel-control-next-icon",attrs:{"aria-hidden":"true"}},[_c('i',{staticClass:"fa fa-angle-double-right"})]),_vm._v(" "),_c('span',{staticClass:"sr-only"},[_vm._v("Next")])])])])])])])])}]
var mobile_Home_esExports = { render: mobile_Home_render, staticRenderFns: mobile_Home_staticRenderFns }
/* harmony default export */ var components_mobile_Home = (mobile_Home_esExports);
// CONCATENATED MODULE: ./src/components/mobile/Home.vue
function mobile_Home_injectStyle (ssrContext) {
  __webpack_require__("S9p6")
}
var mobile_Home_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var mobile_Home___vue_template_functional__ = false
/* styles */
var mobile_Home___vue_styles__ = mobile_Home_injectStyle
/* scopeId */
var mobile_Home___vue_scopeId__ = "data-v-29b504e6"
/* moduleIdentifier (server only) */
var mobile_Home___vue_module_identifier__ = null
var mobile_Home_Component = mobile_Home_normalizeComponent(
  mobile_Home,
  components_mobile_Home,
  mobile_Home___vue_template_functional__,
  mobile_Home___vue_styles__,
  mobile_Home___vue_scopeId__,
  mobile_Home___vue_module_identifier__
)

/* harmony default export */ var src_components_mobile_Home = (mobile_Home_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/Dashboard.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import Login from '@/components/Login'




/* harmony default export */ var mobile_Dashboard = ({
  name: 'Home',
  components: {
    HeaderVue: mobile_Header["a" /* default */],
    FooterVue: mobile_Footer["a" /* default */]
  },
  beforeCreate: function beforeCreate() {
    this.query = this.$localStorage.get('location');
  },
  created: function created() {
    setTimeout(function () {
      $("#carouselExampleControls").carousel();
      $("#carouselLabPartners").carousel();
    }, 1000);
  },
  data: function data() {
    return {
      onBlurKey: 'none',
      address: '',
      query: this.$localStorage.get('location') ? this.$localStorage.get('location').locationName + '-' + this.$localStorage.get('location').locationZipCode : '',
      items: [],
      selectedLocation: this.$localStorage.get('location') ? this.$localStorage.get('location') : undefined,
      selectedPincode: this.$localStorage.get('pincode') ? this.$localStorage.get('pincode') : undefined,
      locationObj: null
    };
  },

  methods: {
    onClickEvent: function onClickEvent(type) {
      if (type === 1) {
        this.$router.push({ path: '/lab' });
      } else if (type === 2) {
        if (this.$localStorage.get('profile') && this.$localStorage.get('profile') != null) {
          this.$router.push({ path: '/myresult' });
        } else {
          this.$root.$emit('myresultLogin', true);
        }
      } else if (type === 3) {
        if (this.$localStorage.get('profile') && this.$localStorage.get('profile') != null) {
          this.$router.push({ path: '/myprofile' });
        } else {
          this.$root.$emit('myprofileLogin', true);
        }
      } else if (type === 4) {
        this.$router.push({ path: '/contact-us' });
      }
    }
  },
  watch: {},
  mounted: function mounted() {
    this.$hidePageLoading();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-114c3954","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/Dashboard.vue
var mobile_Dashboard_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"HomeDiv"}},[_c('HeaderVue',{attrs:{"isHeader":"true"}}),_vm._v(" "),_c('div',{staticClass:"section pb-0"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-3"},[_c('div',{staticClass:"widget dashboard-box bg-green",on:{"click":function($event){_vm.onClickEvent(1)}}},[_vm._m(0,false,false),_vm._v(" "),_vm._m(1,false,false)])]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('div',{staticClass:"widget dashboard-box bg-grayLight",on:{"click":function($event){_vm.onClickEvent(2)}}},[_vm._m(2,false,false),_vm._v(" "),_vm._m(3,false,false)])]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('div',{staticClass:"widget dashboard-box bg-blue",on:{"click":function($event){_vm.onClickEvent(3)}}},[_vm._m(4,false,false),_vm._v(" "),_vm._m(5,false,false)])]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('div',{staticClass:"widget dashboard-box bg-gray",on:{"click":function($event){_vm.onClickEvent(4)}}},[_vm._m(6,false,false),_vm._v(" "),_vm._m(7,false,false)])])])])]),_vm._v(" "),_vm._m(8,false,false),_vm._v(" "),_c('FooterVue',{attrs:{"foot":"true"}})],1)}
var mobile_Dashboard_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-icon pull-left"},[_c('i',{staticClass:"fa fa-flask",attrs:{"aria-hidden":"true"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-left heading"},[_c('h3',{staticClass:"text-dark"},[_vm._v(" Book Test ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-icon pull-left"},[_c('i',{staticClass:"fa fa-list-alt",attrs:{"aria-hidden":"true"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-left heading"},[_c('h3',{staticClass:"text-white"},[_vm._v(" My Results ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-icon pull-left"},[_c('i',{staticClass:"fa fa-user",attrs:{"aria-hidden":"true"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-left heading"},[_c('h3',{staticClass:"text-white"},[_vm._v(" My Profile ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-icon pull-left"},[_c('i',{staticClass:"fa fa-id-card-o",attrs:{"aria-hidden":"true"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-left heading"},[_c('h3',{staticClass:"text-white"},[_vm._v(" Contact Us ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"section"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('h2',{staticClass:"section-title"},[_vm._v("Why Labotist")]),_vm._v(" "),_c('div',{staticClass:"why-labotist flex-row"},[_c('div',{staticClass:"future-list flex-nowrap flex-column"},[_c('span',{staticClass:"sprites sprite-pickup align-center"}),_vm._v(" "),_c('p',[_vm._v("Free Home\n                                "),_c('br'),_vm._v(" Sample Pickup")])]),_vm._v(" "),_c('div',{staticClass:"future-list flex-column"},[_c('span',{staticClass:"sprites sprite-phlebotomists align-center"}),_vm._v(" "),_c('p',[_vm._v("Trained\n                                "),_c('br'),_vm._v(" Phlebotomists")])]),_vm._v(" "),_c('div',{staticClass:"future-list flex-column"},[_c('span',{staticClass:"sprites sprite-shield align-center"}),_vm._v(" "),_c('p',[_vm._v("Technology enabled & safe\n                                "),_c('br'),_vm._v(" sample collection process")])]),_vm._v(" "),_c('div',{staticClass:"future-list flex-column"},[_c('span',{staticClass:"sprites sprite-star align-center"}),_vm._v(" "),_c('p',[_vm._v("Know\n                                "),_c('br'),_vm._v(" your labs better")])]),_vm._v(" "),_c('div',{staticClass:"future-list flex-column"},[_c('span',{staticClass:"sprites sprite-mobile align-center"}),_vm._v(" "),_c('p',[_vm._v("Get\n                                "),_c('br'),_vm._v(" Online Reports")])])])])])])])}]
var mobile_Dashboard_esExports = { render: mobile_Dashboard_render, staticRenderFns: mobile_Dashboard_staticRenderFns }
/* harmony default export */ var components_mobile_Dashboard = (mobile_Dashboard_esExports);
// CONCATENATED MODULE: ./src/components/mobile/Dashboard.vue
function mobile_Dashboard_injectStyle (ssrContext) {
  __webpack_require__("pHF6")
}
var mobile_Dashboard_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var mobile_Dashboard___vue_template_functional__ = false
/* styles */
var mobile_Dashboard___vue_styles__ = mobile_Dashboard_injectStyle
/* scopeId */
var mobile_Dashboard___vue_scopeId__ = "data-v-114c3954"
/* moduleIdentifier (server only) */
var mobile_Dashboard___vue_module_identifier__ = null
var mobile_Dashboard_Component = mobile_Dashboard_normalizeComponent(
  mobile_Dashboard,
  components_mobile_Dashboard,
  mobile_Dashboard___vue_template_functional__,
  mobile_Dashboard___vue_styles__,
  mobile_Dashboard___vue_scopeId__,
  mobile_Dashboard___vue_module_identifier__
)

/* harmony default export */ var src_components_mobile_Dashboard = (mobile_Dashboard_Component.exports);

// EXTERNAL MODULE: ./src/components/mobile/Login.vue + 2 modules
var Login = __webpack_require__("QHB8");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/Public/Sidemenu.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var mobile_Public_Sidemenu = ({
  name: 'Sidemenu',
  data: function data() {
    return {};
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-480a7504","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/Public/Sidemenu.vue
var Public_Sidemenu_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"aboutusDiv"}})}
var Public_Sidemenu_staticRenderFns = []
var Public_Sidemenu_esExports = { render: Public_Sidemenu_render, staticRenderFns: Public_Sidemenu_staticRenderFns }
/* harmony default export */ var components_mobile_Public_Sidemenu = (Public_Sidemenu_esExports);
// CONCATENATED MODULE: ./src/components/mobile/Public/Sidemenu.vue
function Public_Sidemenu_injectStyle (ssrContext) {
  __webpack_require__("I5/F")
}
var Public_Sidemenu_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var Public_Sidemenu___vue_template_functional__ = false
/* styles */
var Public_Sidemenu___vue_styles__ = Public_Sidemenu_injectStyle
/* scopeId */
var Public_Sidemenu___vue_scopeId__ = "data-v-480a7504"
/* moduleIdentifier (server only) */
var Public_Sidemenu___vue_module_identifier__ = null
var Public_Sidemenu_Component = Public_Sidemenu_normalizeComponent(
  mobile_Public_Sidemenu,
  components_mobile_Public_Sidemenu,
  Public_Sidemenu___vue_template_functional__,
  Public_Sidemenu___vue_styles__,
  Public_Sidemenu___vue_scopeId__,
  Public_Sidemenu___vue_module_identifier__
)

/* harmony default export */ var src_components_mobile_Public_Sidemenu = (Public_Sidemenu_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/Public/Aboutus.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var mobile_Public_Aboutus = ({
  name: 'Aboutus',
  data: function data() {
    return {};
  },

  components: {
    HeaderVue: mobile_Header["a" /* default */],
    Sidemenu: src_components_mobile_Public_Sidemenu,
    FooterVue: mobile_Footer["a" /* default */]
  },
  beforeCreate: function beforeCreate() {},
  mounted: function mounted() {
    this.$hidePageLoading();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4fadf95a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/Public/Aboutus.vue
var Public_Aboutus_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"aboutusDiv"}},[_c('div',{staticClass:"wrapper"},[_c('HeaderVue',{attrs:{"isHeader":"true"}}),_vm._v(" "),_vm._m(0,false,false),_vm._v(" "),_c('FooterVue',{attrs:{"foot":"true"}})],1)])}
var Public_Aboutus_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid static-content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('h3',[_vm._v("About Us")]),_vm._v(" "),_c('p',[_vm._v("Labotist is a convenient, technology driven platform that serves as a one stop solution for patients\n                        to easily choose from, and connect with various labs across the city. It is an online marketplace for lab services, \n                        offering patients the convenience of making their choice based on location, cost\n                        of test, quality and turnaround time. Patients also enjoy the added luxury of getting their samples\n                        collected in the comforts of their home by a trained phlebotomist.")]),_vm._v(" "),_c('h3',[_vm._v("How does it work?")]),_vm._v(" "),_c('img',{staticClass:"img-fluid full-width mb-4",attrs:{"src":"static/images/about-us.svg","alt":""}}),_vm._v(" "),_c('p',[_vm._v("Patients can visit labotist.com and research for the specific test and profiles that need to be done.\n                        Labotist.com is a lab aggregator and shares all the relevant details, including price, discounts\n                        if any, quality and certifications, typical turnaround time etc. Based on the results, patients\n                        can then choose the lab they would like to engage with.")]),_vm._v(" "),_c('p',[_vm._v("Once a lab has been selected, patients can schedule home sample collection requests at a convenient\n                        date & time. The request gets transmitted to all registered and certified phlebotomists operating\n                        in the area. On the Phlebotomist mobile app, the Phlebotomists can accept the request based on\n                        their convenience and availability. Once accepted, the request is then automatically scheduled\n                        in Phlebotomist’s calendar. When the phlebotomist goes to the patient’s house for sample collection,\n                        the mobile app enables technology guided sample collection process thereby ensuring safety &\n                        accuracy throughout the process. Phlebotomists then deliver the sample to lab chosen by the patient.")]),_vm._v(" "),_c('p',[_vm._v("After processing the samples, the partnering lab then sends the reports to Labotist. Once verified,\n                        the reports are then delivered to the patients, on the Patient Web App. Here, patients can store\n                        and access at once, all the lab reports that have been processed by Labotist (across the different\n                        labs they have opted thus far through Labotist).")])])])])}]
var Public_Aboutus_esExports = { render: Public_Aboutus_render, staticRenderFns: Public_Aboutus_staticRenderFns }
/* harmony default export */ var components_mobile_Public_Aboutus = (Public_Aboutus_esExports);
// CONCATENATED MODULE: ./src/components/mobile/Public/Aboutus.vue
function Public_Aboutus_injectStyle (ssrContext) {
  __webpack_require__("4gyR")
}
var Public_Aboutus_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var Public_Aboutus___vue_template_functional__ = false
/* styles */
var Public_Aboutus___vue_styles__ = Public_Aboutus_injectStyle
/* scopeId */
var Public_Aboutus___vue_scopeId__ = "data-v-4fadf95a"
/* moduleIdentifier (server only) */
var Public_Aboutus___vue_module_identifier__ = null
var Public_Aboutus_Component = Public_Aboutus_normalizeComponent(
  mobile_Public_Aboutus,
  components_mobile_Public_Aboutus,
  Public_Aboutus___vue_template_functional__,
  Public_Aboutus___vue_styles__,
  Public_Aboutus___vue_scopeId__,
  Public_Aboutus___vue_module_identifier__
)

/* harmony default export */ var src_components_mobile_Public_Aboutus = (Public_Aboutus_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/Public/Contactus.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var mobile_Public_Contactus = ({
  name: 'Contactus',
  components: {
    HeaderVue: mobile_Header["a" /* default */],
    FooterVue: mobile_Footer["a" /* default */],
    Sidemenu: src_components_mobile_Public_Sidemenu
  },
  beforeCreate: function beforeCreate() {},
  data: function data() {
    return {
      name: '',
      email: '',
      mobile: '',
      message: '',
      success: false
    };
  },

  methods: {
    save: function save() {
      this.$validator.validateAll('contact').then(function (result) {
        if (result) {
          try {
            if (this.name !== '' && this.email !== '' && this.mobile !== '' && this.message !== '') {
              var data = {
                'name': this.name,
                'email': this.email,
                'mobile': this.mobile,
                'message': this.message
              };
              promise_default.a.resolve(this.$POST('patient/contact', data)).then(function (res) {
                if (res.response_code === 0) {
                  this.success = true;
                  //   location.reload()
                  this.$Simplert.open({
                    title: 'Success',
                    message: 'Thanks for contact us. We will touch with you soon.',
                    type: 'warning',
                    disableOverlayClick: true,
                    showXclose: true,
                    useConfirmBtn: false,
                    customCloseBtnText: 'OK'
                  });
                  this.reset();
                }
              }.bind(this)).catch(function (err) {
                console.error(err);
                this.$Simplert.open({
                  title: 'Oops',
                  message: 'Something went wrong please mail us support@labotist.com',
                  type: 'warning',
                  disableOverlayClick: true,
                  showXclose: true,
                  useConfirmBtn: false,
                  customCloseBtnText: 'OK'
                });
                // alert('Something went wrong please mail us support@labotist.com')
              }.bind(this));
            }
          } catch (e) {
            console.error(e);
          }
        }
      }.bind(this));
    },
    reset: function reset() {
      this.errors.items = [];
      this.name = '';
      this.email = '';
      this.mobile = '';
      this.message = '';
      this.success = false;
      setTimeout(function () {
        this.errors.items = [];
      }.bind(this), 30);
    }
  },
  mounted: function mounted() {
    this.$hidePageLoading();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-eea514b4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/Public/Contactus.vue
var Public_Contactus_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"contactusDiv"}},[_c('HeaderVue',{attrs:{"isHeader":"true"}}),_vm._v(" "),_c('div',{staticClass:"container-fluid static-content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('h3',[_vm._v("Contact us / Feedback")]),_vm._v(" "),_c('div',{staticClass:"form-content line-textbox"},[_c('form',{attrs:{"data-vv-scope":"contact"}},[_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.name),expression:"name"},{name:"validate",rawName:"v-validate",value:('required|alpha_spaces|max:75'),expression:"'required|alpha_spaces|max:75'"}],staticClass:"form-control",attrs:{"type":"text","name":"name","data-vv-as":"name","placeholder":"Name"},domProps:{"value":(_vm.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.name=$event.target.value}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('contact.name')),expression:"errors.has('contact.name')"}],staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('contact.name')))])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email),expression:"email"},{name:"validate",rawName:"v-validate",value:('required|email|max:100'),expression:"'required|email|max:100'"}],staticClass:"form-control",attrs:{"type":"email","data-vv-as":"email address","name":"email","placeholder":"Email Address"},domProps:{"value":(_vm.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.email=$event.target.value}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('contact.email')),expression:"errors.has('contact.email')"}],staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('contact.email')))])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.mobile),expression:"mobile"},{name:"validate",rawName:"v-validate",value:('required|numeric|max:10|min:10'),expression:"'required|numeric|max:10|min:10'"}],staticClass:"form-control",attrs:{"type":"text","name":"mobile","data-vv-as":"mobile no.","placeholder":"Mobile No."},domProps:{"value":(_vm.mobile)},on:{"input":function($event){if($event.target.composing){ return; }_vm.mobile=$event.target.value}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('contact.mobile')),expression:"errors.has('contact.mobile')"}],staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('contact.mobile')))])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.message),expression:"message"},{name:"validate",rawName:"v-validate",value:('required|max:2000'),expression:"'required|max:2000'"}],staticClass:"form-control",attrs:{"name":"message","data-vv-as":"message","cols":"30","rows":"3","placeholder":"Message"},domProps:{"value":(_vm.message)},on:{"input":function($event){if($event.target.composing){ return; }_vm.message=$event.target.value}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('contact.message')),expression:"errors.has('contact.message')"}],staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('contact.message')))])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-5"},[_c('button',{staticClass:"btn btn-link full-width",on:{"click":function($event){$event.preventDefault();_vm.reset()}}},[_vm._v("Reset")])]),_vm._v(" "),_c('div',{staticClass:"col-7"},[_c('button',{staticClass:"btn btn-primary fly-msg full-width",attrs:{"disabled":(_vm.errors.any())},on:{"click":function($event){$event.preventDefault();_vm.save()}}},[_vm._v("Save")])])])])])])])]),_vm._v(" "),_vm._m(0,false,false),_vm._v(" "),_c('FooterVue',{attrs:{"foot":"true"}})],1)}
var Public_Contactus_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contact-info",staticStyle:{"padding-left":"13%"}},[_c('div',{staticClass:"container"},[_c('ul',{staticClass:"row text-center"},[_c('li',[_c('span',{staticClass:"sprites sprite-mail align-center"}),_vm._v(" "),_c('p',[_c('a',{attrs:{"href":"mailto:support@labotist.com","target":"_top"}},[_vm._v(" support@labotist.com ")])])]),_vm._v(" "),_c('li',[_c('span',{staticClass:"sprites sprite-call align-center"}),_vm._v(" "),_c('p',[_c('a',{attrs:{"href":"tel:+919025662566"}},[_vm._v("+91 90256 62566")])])])])])])}]
var Public_Contactus_esExports = { render: Public_Contactus_render, staticRenderFns: Public_Contactus_staticRenderFns }
/* harmony default export */ var components_mobile_Public_Contactus = (Public_Contactus_esExports);
// CONCATENATED MODULE: ./src/components/mobile/Public/Contactus.vue
function Public_Contactus_injectStyle (ssrContext) {
  __webpack_require__("4M1+")
}
var Public_Contactus_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var Public_Contactus___vue_template_functional__ = false
/* styles */
var Public_Contactus___vue_styles__ = Public_Contactus_injectStyle
/* scopeId */
var Public_Contactus___vue_scopeId__ = "data-v-eea514b4"
/* moduleIdentifier (server only) */
var Public_Contactus___vue_module_identifier__ = null
var Public_Contactus_Component = Public_Contactus_normalizeComponent(
  mobile_Public_Contactus,
  components_mobile_Public_Contactus,
  Public_Contactus___vue_template_functional__,
  Public_Contactus___vue_styles__,
  Public_Contactus___vue_scopeId__,
  Public_Contactus___vue_module_identifier__
)

/* harmony default export */ var src_components_mobile_Public_Contactus = (Public_Contactus_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/Public/Privacy.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var mobile_Public_Privacy = ({
  name: 'Privacy',
  components: {
    HeaderVue: mobile_Header["a" /* default */],
    Sidemenu: src_components_mobile_Public_Sidemenu,
    FooterVue: mobile_Footer["a" /* default */]
  },
  beforeCreate: function beforeCreate() {},
  data: function data() {
    return {};
  },
  mounted: function mounted() {
    this.$hidePageLoading();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8e17e520","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/Public/Privacy.vue
var Public_Privacy_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"privacyDiv"}},[_c('HeaderVue',{attrs:{"isHeader":"true"}}),_vm._v(" "),_vm._m(0,false,false),_vm._v(" "),_c('FooterVue',{attrs:{"foot":"true"}})],1)}
var Public_Privacy_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid static-content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('h3',[_vm._v("Privacy Policy")]),_vm._v(" "),_c('p',[_vm._v("About Labotist Private Limited ")]),_vm._v(" "),_c('p',[_vm._v("Labotist Private Limited (“"),_c('b',[_vm._v("We")]),_vm._v("” and/or “"),_c('b',[_vm._v("Us")]),_vm._v("” and/or “"),_c('b',[_vm._v("Company")]),_vm._v("”) is a company incorporated under the Companies Act, 2013. Our website is a convenient, technology driven platform that serves as a one stop solution for patients to easily choose from, and connect with various labs across the city. It is an online marketplace for lab services, offering patients the convenience of making their choice based on location, cost of test, quality and turnaround time. Patients also enjoy the added luxury of getting their samples collected in the comforts of their home by a trained phlebotomist.")]),_vm._v(" "),_c('p',[_vm._v("Similarly, our Website also serves as a marketplace for phlebotomists who are registered on our website. Our Company screens the phlebotomist as commercially viable and creates a well-intended marketplace for phlebotomist to serve as micro entrepreneurs.")]),_vm._v(" "),_c('p',[_vm._v("The Company is concerned about the privacy of its users (\""),_c('b',[_vm._v("User(s)")]),_vm._v("\" and/or \""),_c('b',[_vm._v("You")]),_vm._v("\" and/or “"),_c('b',[_vm._v("Your")]),_vm._v("”) accessing its Website. online platform in the name and style of www.labotist.com (the \""),_c('b',[_vm._v("Website")]),_vm._v("\").")]),_vm._v(" "),_c('p',[_vm._v("Please read the Privacy Policy (“"),_c('b',[_vm._v("Policy")]),_vm._v("”) carefully before using the Website, along with the Terms of Use (“"),_c('b',[_vm._v("Terms")]),_vm._v("”) provided on the Website. Your use of the Website or the services provided by the Website shall signify Your acceptance of this Policy and Your agreement to be legally bound by the same.")]),_vm._v(" "),_c('p',[_vm._v("If You do not agree with the terms of this Policy, do not use the Website or avail any of the services offered on this Website.")]),_vm._v(" "),_c('h4',[_vm._v("About the policy")]),_vm._v(" "),_c('p',[_vm._v("When You register with the Website, We may seek and collect certain personal information for Your use of the Website. You consent to the collection, use, and disclosure of the information in accordance with this Policy. Therefore, We request You to read this Policy carefully before using the Website. ")]),_vm._v(" "),_c('p',[_vm._v("Please note that, We respect and value Your privacy and shall strive towards protecting the information that You provide. We shall keep the information provided to Us as confidential to the extent reasonably possible. You understand that, by registering on the Website, your personal information may be collected. If at any time You wish to have Your information deleted, You can write to "),_c('i',[_vm._v("support@labotist.com")]),_vm._v(". We shall do the needful within 5 working days but We may retain certain information for internal purposes if required under applicable law.")]),_vm._v(" "),_c('p',[_vm._v("Your privacy is of utmost importance to us. We shall process and save your information in accordance with the Information Technology Act, 2000 and the Information Technology (Reasonable Security Practices And Procedures And Sensitive Personal Data Or Information) Rules, 2011.")]),_vm._v(" "),_c('h4',[_vm._v("collection of personally identifiable information")]),_vm._v(" "),_c('p',[_vm._v("We collect personally identifiable information (name, phone number, email etc.) from you when you request for a service. We do not for any reason whatsoever sell your Personal Identifiable Information to any third party or otherwise trade on it.")]),_vm._v(" "),_c('p',[_vm._v("The personal information You may provide to Us that We may use is as follows:")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("Registration details: This will include the password provided by You for which We use reasonable security measures for password protection from anyone.")]),_vm._v(" "),_c('li',[_vm._v("Your usage behavior on the Website.")]),_vm._v(" "),_c('li',[_vm._v("The details of the computer system or computer network that You use to visit the Website and any activities undertaken through the usage of the Website.")]),_vm._v(" "),_c('li',[_vm._v("Your first and last name, e-mail address, phone number, billing and shipping address.")])]),_vm._v(" "),_c('p',[_vm._v("The fundamental reason behind collecting Your personal information is to support and facilitate You to enjoy various features and services provided on the Website. ")]),_vm._v(" "),_c('p',[_vm._v("We select and track Your preferences to provide You with a customized Website experience, to notify You of any updated information and new developments/features and other related functions offered by the Website, to otherwise support Your relationship with Us and to prevent fraud and unlawful use.")]),_vm._v(" "),_c('p',[_vm._v("By accepting the terms of this Policy, You understand, agree and recognize that our storage and processing of Your personal information is for a lawful purpose associated with a function or an activity of the Website. You further understand, agree and acknowledge that You may be required to provide personal information that is classified as sensitive personal information as per applicable laws for Us to provide various services. ")]),_vm._v(" "),_c('p',[_vm._v("Please note that, it is entirely up to the discretion of the User to provide this personal information. However, the User would not be able to avail the services provided by Us if this information is denied.")]),_vm._v(" "),_c('p',[_vm._v("We do not sell, trade or rent Your personal information to any third party unless We have been expressly authorized by You either in writing or electronically to do so. We may at times provide aggregate statistics about our customers, traffic patterns, and related site information to reputable third parties, however this information when disclosed will be in an aggregate form and does not contain any of Your personally identifiable information.")]),_vm._v(" "),_c('p',[_vm._v("You may note that, We adopt reasonable security measures to protect Your password from being exposed or disclosed to anyone")]),_vm._v(" "),_c('h4',[_vm._v("information sharing and disclosure:")]),_vm._v(" "),_c('p',[_vm._v("We are the recipient of all the personal information and shall exercise reasonable care to keep Your personal information confidential to the maximum possible extent. We may limit disclosure of the Users' information to our entities, joint ventures, agents, sellers or third parties for the purposes of the services provided by them or for any other marketing related activity undertaken by or on behalf of our entities and/or its joint ventures on a need-to-know basis. We shall not be liable for any unauthorized use or disclosure of the personal information by any sellers participating on our Websites.")]),_vm._v(" "),_c('p',[_vm._v("We may use the information We collect from You when You register, place an order, sign up for our newsletter, respond to a survey or marketing communication, surf the Website, or use certain other site features in the following ways: To personalize your experience and to allow us to deliver the type of content and product offerings in which you are most interested. ")]),_vm._v(" "),_c('h4',[_vm._v("legal compliance")]),_vm._v(" "),_c('p',[_vm._v("We abide by all the applicable laws in force as well as the mandates of government agencies. We will disclose any information about You to government or law enforcement officials or private parties that We, in our sole discretion, believe necessary or appropriate to respond to claims and legal processes, to protect the property and rights of the Company or a third party, to protect the safety of the public or any person, or to prevent or stop any illegal, unethical or legally fraudulent activity. We may also provide Your personal information to various regulatory authorities upon any demand or request from them.")]),_vm._v(" "),_c('p',[_vm._v("We may provide your personal information, in connection with a merger, acquisition, reorganization or sale of assets or in the event of bankruptcy of the Company.")]),_vm._v(" "),_c('p',[_vm._v("We do not use vulnerability scanning and/or scanning for payment transaction. All our scanning with respect to payments is in compliant with Payment Card Industry Data Security Standard (“"),_c('b',[_vm._v("PCI")]),_vm._v("”) standards. An external PCI compliant payment gateway handles all our credit card transactions. We use regular malware scanning. Your personal information is contained behind secured networks and is only accessible by a limited number of persons who have special access rights to such systems, and are required to keep the information confidential. In addition, all sensitive/credit information you supply is encrypted via Secure Socket Layer (“SSL”) technology. We implement a variety of security measures when a user places an order enters, submits, or accesses their information to maintain the safety of your personal information. All transactions are processed through a gateway provider and are not stored or processed on our servers. ")]),_vm._v(" "),_c('h4',[_vm._v("email policies")]),_vm._v(" "),_c('p',[_vm._v("You can choose the type of emails that You wish to receive from Us. If You decide at any time that You no longer wish to receive such communications from Us, please follow the unsubscribe instructions provided in any of the communications. Please note that, once We receive Your request, it may take an additional period of time for Your subscription to become ineffective.")]),_vm._v(" "),_c('h4',[_vm._v("deletion of your information:")]),_vm._v(" "),_c('p',[_vm._v("If You wish to have the personal information that You have provided to us deleted, You can do so by writing to "),_c('i',[_vm._v("support@labotist.com")]),_vm._v(". Please note that deletion of certain personal information may lead to deletion of Your account with the Website and Your access to certain features of the Website.  You understand that under certain circumstances, the request for the deletion of personal information can be denied.")]),_vm._v(" "),_c('h4',[_vm._v("security:")]),_vm._v(" "),_c('p',[_vm._v("We strive to work towards the security, integrity and privacy of Your personal information and to protect Your personal information against unauthorized disclosure, access or destruction to the extent reasonably possible by Us. Notwithstanding anything contained in this Policy or elsewhere, We shall not be held responsible for any loss, damage or misuse of Your personal information, if such loss, damage or misuse takes place as a result of a Force Majeure Event (as defined below).")]),_vm._v(" "),_c('p',[_vm._v("A \""),_c('b',[_vm._v("Force Majeure Event")]),_vm._v("\" shall mean any event that is beyond our reasonable control and shall include, without limitation, fire, flood, explosion, acts of God, civil commotion, strikes, insurrection, war, acts of government, computer hacking, software failure and storage device, computer crashes etc")]),_vm._v(" "),_c('h4',[_vm._v("third-party disclosure")]),_vm._v(" "),_c('p',[_vm._v("We may disclose Your personal information solely in the legitimate conduct of the business to deliver services to meet Your demands. We may also release information when We believe, in good faith, that such release is reasonably necessary to (1) comply with legal or regulatory requirements; (2) enforce or apply terms of use of our Website; or (3) protect our rights, property or safety of the rights of others.")]),_vm._v(" "),_c('p',[_vm._v("Although We do not sell, trade, or otherwise transfer to outside parties your personally identifiable information unless we provide users with advance notice, this does not include website hosting partners and other parties who assist us in operating our website, conducting our business, or serving our users, so long as those parties agree to keep this information confidential. We may also release information when its release is appropriate to comply with the law, enforce our site policies, or protect ours or others' rights, property or safety.")]),_vm._v(" "),_c('p',[_vm._v("However, non-personally identifiable visitor information may be provided to other parties for marketing, advertising, or other uses.")]),_vm._v(" "),_c('h4',[_vm._v("links to other sites")]),_vm._v(" "),_c('p',[_vm._v("The Website may provide third-party advertisements and links to other websites. We do not provide Your personal information to these third-party websites or advertisers.")]),_vm._v(" "),_c('p',[_vm._v("The links to other websites are operated by third parties and are not controlled by, or affiliated to, or associated with Us unless expressly specified on the Website. Therefore, We do not make any claims concerning the privacy practices or policies of such third parties or terms of use of such websites, nor do We control or guarantee or endorse the accuracy, integrity, or quality of the information available on such websites. Any information provided by You to such third party websites shall be governed in accordance with the privacy policies of the respective websites and it is strongly recommended that You review the privacy policy on any such websites prior to using such websites.")]),_vm._v(" "),_c('h4',[_vm._v("google")]),_vm._v(" "),_c('p',[_vm._v("Google's advertising requirements can be summed up by Google's Advertising Principles. They are put in place to provide a positive experience for users. Click here to view We use Google AdSense Advertising on our Website.")]),_vm._v(" "),_c('p',[_vm._v("Google, as a third-party vendor, uses cookies to serve ads on our site. Google's use of the DART cookie enables it to serve ads to our users based on previous visits to our site and other sites on the Internet. Users may opt-out of the use of the DART cookie by visiting the Google Ad and Content Network privacy policy.")]),_vm._v(" "),_c('p',[_vm._v("We have implemented the following:")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("Google Display Network Impression Reporting")]),_vm._v(" "),_c('li',[_vm._v("Demographics and Interests Reporting")])]),_vm._v(" "),_c('p',[_vm._v("We, along with third-party vendors such as Google use first-party cookies (such as the Google Analytics cookies) and third-party cookies (such as the DoubleClick cookie) or other third-party identifiers together to compile data regarding user interactions with ad impressions and other ad service functions as they relate to our website.")]),_vm._v(" "),_c('h4',[_vm._v("how does our website handle do not track signals?")]),_vm._v(" "),_c('p',[_vm._v("We honor Do Not Track signals and Do Not Track, plant cookies, or use advertising when a Do Not Track (DNT) browser mechanism is in place.")]),_vm._v(" "),_c('h4',[_vm._v("research")]),_vm._v(" "),_c('p',[_vm._v("In support of eHealth initiatives, we may use and share your medical information for research. We will only use and share information for research after obtaining your consent or if the used data does not expressly identify you in any way.")]),_vm._v(" "),_c('h4',[_vm._v("studies and reports")]),_vm._v(" "),_c('p',[_vm._v("We may use your information to study results and produce reports. Such information may be shared with Our partners and advertisers under the sole discretion of the Company.")]),_vm._v(" "),_c('h4',[_vm._v("changes to this privacy policy")]),_vm._v(" "),_c('p',[_vm._v("Any changes we may make to our Policy in the future will be posted on this page and, where appropriate, notified to you by e-mail. Please check back frequently to see any updates or changes to our Policy.")]),_vm._v(" "),_c('h4',[_vm._v("phishing")]),_vm._v(" "),_c('p',[_vm._v("Identity theft and the fraudulent practice currently known as \"phishing\" are of great concern to Us. Phishing is an attempt to acquire personal/sensitive information which the legitimate organization already has. Safeguarding information to help protect You from identity theft is a top priority. We do not and will not, at any time, request Your credit card information or national identification numbers in a non-secure or unsolicited e-mail or telephone communication.")]),_vm._v(" "),_c('h4',[_vm._v("cookies")]),_vm._v(" "),_c('p',[_vm._v("Yes. Cookies are small files that a site or its service provider transfers to your computer's hard drive through your Web browser (if you allow) that enables the site's or service provider's systems to recognize your browser and capture and remember certain information. For instance, We use cookies to help us remember the services/packages obtained by you. They are also used to help us understand your preferences based on previous or current site activity, which enables us to provide you with improved services. We also use cookies to help us compile aggregate data about site traffic and site interaction so that we can offer better site experiences and tools in the future.")]),_vm._v(" "),_c('p',[_vm._v("We use cookies to:")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("Understand and save user's preferences for future visits.")]),_vm._v(" "),_c('li',[_vm._v("Compile aggregate data about site traffic and site interactions in order to offer better site experiences and tools in the future. We may also use trusted third-party services that track this information on our behalf.")])]),_vm._v(" "),_c('p',[_vm._v("You can choose to have Your computer warn you each time a cookie is being sent, or You can choose to turn off all cookies. You can do this through Your browser settings by utilizing the "),_c('i',[_vm._v("Help Menu")]),_vm._v(" to learn the correct way to modify your cookies. If You turn cookies off, some of the features that make Your site experience more efficient may not function properly. It won't affect the User's experience that make Your site experience more efficient and may not function properly. ")]),_vm._v(" "),_c('h4',[_vm._v("contact")]),_vm._v(" "),_c('p',[_vm._v("Our Grievance Officer shall undertake all reasonable efforts to address your grievances at the earliest possible opportunity. You may contact us at:")]),_vm._v(" "),_c('p',[_vm._v("Grievance Officer: Jayaprakaash Jayaraman")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Address:")]),_c('br'),_vm._v("\n                    Flat No 8, 2nd Floor, "),_c('br'),_vm._v("\n                    Old No 4, New No 5 Rajachar Street, "),_c('br'),_vm._v("\n                    T.Nagar, Chennai - 600017")]),_vm._v(" "),_c('p',[_vm._v("Reach out to us on "),_c('i',[_vm._v("support@labotist.com")]),_vm._v(", in case of any queries.")])])])])}]
var Public_Privacy_esExports = { render: Public_Privacy_render, staticRenderFns: Public_Privacy_staticRenderFns }
/* harmony default export */ var components_mobile_Public_Privacy = (Public_Privacy_esExports);
// CONCATENATED MODULE: ./src/components/mobile/Public/Privacy.vue
function Public_Privacy_injectStyle (ssrContext) {
  __webpack_require__("rji4")
}
var Public_Privacy_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var Public_Privacy___vue_template_functional__ = false
/* styles */
var Public_Privacy___vue_styles__ = Public_Privacy_injectStyle
/* scopeId */
var Public_Privacy___vue_scopeId__ = "data-v-8e17e520"
/* moduleIdentifier (server only) */
var Public_Privacy___vue_module_identifier__ = null
var Public_Privacy_Component = Public_Privacy_normalizeComponent(
  mobile_Public_Privacy,
  components_mobile_Public_Privacy,
  Public_Privacy___vue_template_functional__,
  Public_Privacy___vue_styles__,
  Public_Privacy___vue_scopeId__,
  Public_Privacy___vue_module_identifier__
)

/* harmony default export */ var src_components_mobile_Public_Privacy = (Public_Privacy_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/Public/Terms.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var mobile_Public_Terms = ({
  name: 'Terms',
  components: {
    Sidemenu: src_components_mobile_Public_Sidemenu,
    HeaderVue: mobile_Header["a" /* default */],
    FooterVue: mobile_Footer["a" /* default */]
  },
  beforeCreate: function beforeCreate() {},
  data: function data() {
    return {};
  },
  mounted: function mounted() {
    this.$hidePageLoading();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-61eaafef","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/Public/Terms.vue
var Public_Terms_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"termsDiv"}},[_c('HeaderVue',{attrs:{"isHeader":"true"}}),_vm._v(" "),_vm._m(0,false,false),_vm._v(" "),_c('FooterVue',{attrs:{"foot":"true"}})],1)}
var Public_Terms_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid static-content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('h3',[_vm._v("Terms & Conditions")]),_vm._v(" "),_c('p',[_vm._v("Welcome to "),_c('b',[_vm._v("www.labotist.com")]),_vm._v(". ")]),_vm._v(" "),_c('p',[_vm._v("The Terms & Conditions (“"),_c('b',[_vm._v("Terms")]),_vm._v("”) of use of www.labotist.com (“"),_c('b',[_vm._v("Website")]),_vm._v("”) are between Labotist Private Limited (“"),_c('b',[_vm._v("Company/We/Us")]),_vm._v("”) and its customers/clients (“"),_c('b',[_vm._v("You/Your/User(s)")]),_vm._v("”).")]),_vm._v(" "),_c('p',[_vm._v("These Terms constitute an electronic record in accordance with the provisions of the Information Technology Act, 2000 and the Information Technology (Intermediaries Guidelines) Rules, 2011 thereunder, as amended from time to time.")]),_vm._v(" "),_c('p',[_vm._v("Please read the Terms and the privacy policy of the Company carefully, available at "),_c('b',[_c('i',[_vm._v("www.labotist.com/privacy-policy")])]),_vm._v(" (“"),_c('b',[_vm._v("Privacy Policy")]),_vm._v("”) before using this Website or availing any Services (as defined below) through the Website. In the event of any discrepancy between the Terms and any other Website policies, the provisions of the Terms shall prevail.")]),_vm._v(" "),_c('p',[_vm._v("If You continue to browse and use our Website, You are agreeing to comply with and be bound by the following Terms. If you disagree with any part of these Terms, please do not use our Website.")]),_vm._v(" "),_c('p',[_vm._v("If You do not agree with the Terms or the Privacy Policy, please do not use the Website or avail the Services provided by this Website.")]),_vm._v(" "),_c('h4',[_vm._v("Introduction")]),_vm._v(" "),_c('p',[_vm._v("Our Website is an Internet based online platform operated by the Company which is a company incorporated under the Companies Act, 2013. Our Website is a convenient, technology driven platform that serves as a one-stop solution for patients to easily choose from, and connect with various laboratories  across the city. It is an online marketplace for lab services, offering patients the convenience of making their choice based on location, cost of test, quality and turnaround time. Patients also enjoy the added luxury of getting their samples collected in the comfort of their home by a trained phlebotomist (“"),_c('b',[_vm._v("Services")]),_vm._v("”).")]),_vm._v(" "),_c('p',[_vm._v("Use of the Website is offered to You on the condition that You accept the same without modification of all the terms, conditions and notices contained in these Terms, as may be posted on the Website from time to time.")]),_vm._v(" "),_c('p',[_vm._v("We reserve the right to amend these Terms from time to time as We deem fit and Your continued usage of the Website and the Services offered shall be deemed to be Your acceptance of the Terms. We recommend that, You keep yourself updated with the Terms. We do not hold the responsibility of informing You of any amendments.")]),_vm._v(" "),_c('p',[_vm._v("Users may not access the Services for the purposes of monitoring their availability, performance or functionality, or for any other benchmarking or competitive purposes.")]),_vm._v(" "),_c('p',[_vm._v("We reserve our right to suspend any User’s ability to use or access the Website at our sole discretion and at any time while We investigate complaints or alleged violations of these Terms, or for any other reason. We have the right to club profiles of the laboratories and diagnostic centres to make them more suitable for package searches on the Website while not amending any of the details provided by the concerned laboratories and diagnostic centres. If the Users find that there is any incorrect information, they can contact Us immediately for such corrections. However, We disclaim all liabilities or responsibilities with respect to any of the information provided by the concerned laboratories and diagnostic centres.")]),_vm._v(" "),_c('h4',[_vm._v("Eligibility Criteria")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v(" The Services offered on the Website are not available to all those individuals who are not qualified to enter into a contract as per the Indian Contract Act, 1872.  By using the Website, You represent and warrant that (a) all registration information You submit is truthful and accurate; (b) You will maintain the accuracy of such information, and any changes thereto by regular updates of any such information; (c) You affirm that You are over 18 years of age and are fully able and competent to enter into the terms, conditions, obligations, affirmations, representations, and warranties set forth in these Terms; and (c) You shall use the Website or such other services provided under the Website only in compliance with these Terms and all applicable local, state, national, and international laws, rules and regulations. Your profile may be deleted and Your membership may be terminated by the Company without warning, or without any notice whatsoever, if We believe that You have violated any of the conditions as mentioned under the Terms or Privacy Policy.\n                    ")]),_vm._v(" "),_c('li',[_vm._v("The Company reserves the right to grant or refuse usage of the Services available on the Website. It can also terminate the usage by an existent User of the Website without assigning any reason. ")]),_vm._v(" "),_c('li',[_vm._v("The Website does not have the responsibility to ensure that You conform to the aforesaid eligibility criteria. It shall be Your sole responsibility to ensure that You meet the required qualification.")])]),_vm._v(" "),_c('h4',[_vm._v("User Account")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v(" You will be required to create an Account, if You wish to avail the Services offered on the Website.")]),_vm._v(" "),_c('li',[_vm._v("In order to access the Services offered on the Website, You shall be required to register yourself with the Website, and maintain an account there (\""),_c('b',[_vm._v("Account")]),_vm._v("\"). You will be required to furnish certain information and details, including Your name, mobile number, e-mail address, residential address, payment information (credit/debit card details) if required, and any other information deemed necessary by the Website (“"),_c('b',[_vm._v("Account Information")]),_vm._v("”).")]),_vm._v(" "),_c('li',[_vm._v("It is Your sole responsibility to ensure that the Account Information provided by You is accurate, complete and latest.")]),_vm._v(" "),_c('li',[_vm._v("The Account Information provided by You, may be shared by the Company with any third party for its internal record keeping purposes, internal procedures and with various laboratories/diagnostic centres to enable them to inform You about any schemes, offers, discounts etc.  Further, by providing the Account Information, you agree and acknowledge that you are also granting your consent for the phlebotomists to visit the address provided by you in order to collect/draw the requite samples, call you on the number provided you for any necessary confirmation, deliver the samples the diagnostic centre chosen by you and do such other acts as necessary. ")]),_vm._v(" "),_c('li',[_vm._v("Upon completing the registration process, You can start availing the Services offered on the Website immediately. You shall be responsible for maintaining the confidentiality of the Account Information and for all activities that occur under Your Account. You agree to (a) ensure that You successfully log out from Your Account at the end of each session; and (b) immediately notify the Company of any unauthorized use of Your Account.  If there is reason to believe that there is likely to be a breach of security or misuse of the Your Account/ Website, We may request You to change the password or We may suspend Your account without any liability to the Company, for such period of time as We deem appropriate in the circumstances. The Website shall not be liable for any loss or damage arising from Your failure to comply with this Clause.")]),_vm._v(" "),_c('li',[_vm._v("You acknowledge that Your ability to use Your Account is dependent upon external factors such as internet service providers and internet network availability and the Company cannot guarantee availability of the Website at all times. In addition to the disclaimers set forth in the Terms, the Company shall not be liable to You for any damages arising from Your inability to log into Your Account and access the services of the Website at any time.")])]),_vm._v(" "),_c('h4',[_vm._v("Use of Website")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("Subject to compliance with the Terms, the Privacy Policy, and all other applicable terms and guidelines, the Company grants You a personal, non-exclusive, limited privilege to access and use this Website and the Services provided thereon.")]),_vm._v(" "),_c('li',[_vm._v("No User shall be permitted to perform any of the following prohibited activities:\n                        "),_c('ul',[_c('li',[_vm._v("Making available any content that is misleading, unlawful, harmful, threatening, abusive, tortious, defamatory, libelous, vulgar, obscene, child-pornographic, lewd, lascivious, profane, invasive of another's privacy, hateful, or racially, ethnically or otherwise objectionable.")]),_vm._v(" "),_c('li',[_vm._v("Stalking, intimidating and/or harassing another and/or inciting other to commit violence.")]),_vm._v(" "),_c('li',[_vm._v("Transmitting material that encourages anyone to commit a criminal offence, that results in civil liability or otherwise breaches any relevant laws, regulations or code of practice.")]),_vm._v(" "),_c('li',[_vm._v("Interfering with any other person's use or enjoyment of the Website.")]),_vm._v(" "),_c('li',[_vm._v("Making, transmitting or storing electronic copies of materials protected by copyright without the permission of the owner, committing any act that amounts to the infringement of intellectual property or making available any material that infringes any intellectual property rights or other proprietary rights of anyone else.")]),_vm._v(" "),_c('li',[_vm._v("Make available any content or material that You do not have a right to make available under any law or contractual or fiduciary relationship, unless You own or control the rights thereto or have received all necessary consents for such use of the content.")]),_vm._v(" "),_c('li',[_vm._v("Impersonate any person or entity, or falsely state or otherwise misrepresent Your affiliation with a person or entity.")]),_vm._v(" "),_c('li',[_vm._v("Use any of the Company’s domain names.")]),_vm._v(" "),_c('li',[_vm._v("Reverse engineer, modify, copy, distribute, transmit, display, perform, reproduce, publish, license, create derivative works from, transfer, or sell any information or software obtained from the Website.")]),_vm._v(" "),_c('li',[_vm._v("Post, transmit or make available any material that contains viruses, trojan horses, worms, spyware, time bombs, cancelbots, or other computer programming routines, code, files or such other programs that may harm the Website/services, interests or rights of other Users or limit the functionality of any computer software, hardware or telecommunications, or that may harvest or collect any data or personal information about other Users without their consent.")]),_vm._v(" "),_c('li',[_vm._v("Access or use the Website in any manner that could damage, disable, overburden or impair any of the Website's servers or the networks connected to any of the servers on which the Website is hosted.")]),_vm._v(" "),_c('li',[_vm._v("Intentionally or unintentionally interfere with or disrupt the Services or violate any applicable laws related to the access to or use of the Website, violate any requirements, procedures, policies or regulations of networks connected to the Website, or engage in any activity prohibited by these Terms.")]),_vm._v(" "),_c('li',[_vm._v("Disrupt or interfere with the security of, or otherwise cause harm to, the Website, materials, systems resources, or gain unauthorized access to user accounts, passwords, servers or networks connected to or accessible through the Website or any affiliated or linked sites.")]),_vm._v(" "),_c('li',[_vm._v("Interfere with, or inhibit any user from using and enjoying access to the Website, or the services, or other affiliated sites, or engage in disruptive attacks such as denial of service attack on the Website.")]),_vm._v(" "),_c('li',[_vm._v("Access the Website through any other means other than through the interface that is provided by the Company.")]),_vm._v(" "),_c('li',[_vm._v("Use deep-links, page-scrape, robot, spider or other automatic device, program, algorithm or methodology, or any similar or equivalent manual process, to increase traffic to the Website, to access, acquire, copy or monitor any portion of the Website, or in any way reproduce or circumvent the navigational structure or presentation of the Website, or any content, to obtain or attempt to obtain any content, documents or information through any means not specifically made available through the Website.")]),_vm._v(" "),_c('li',[_vm._v("Alter or modify any part of the services.")]),_vm._v(" "),_c('li',[_vm._v("Use the services for purposes that are not permitted by: (i) these Terms; and (ii) any applicable law, regulation or generally accepted practices or guidelines in the relevant jurisdiction.")]),_vm._v(" "),_c('li',[_vm._v("Violate any of the terms specified under the Terms for the use of the Website.")])])]),_vm._v(" "),_c('li',[_vm._v("Any violation by You of the terms of this Clause may result in immediate suspension or termination of Your Accounts, apart from any legal remedy that the Company can avail. In such instances, the Company may also disclose Your Account Information if required by any Governmental or legal authority.")]),_vm._v(" "),_c('li',[_vm._v("You acknowledge and agree that by accessing or using the Website, You agree to indemnify and hold the Company, its affiliates, and/or licensors, harmless to the fullest extent allowed by law regarding all matters related to Your use of the Website or any loss/damage that is caused to the Website/the Company as a result of You committing any of the aforesaid prohibited activities.")]),_vm._v(" "),_c('li',[_vm._v("The Company has the right to change modify, suspend, or discontinue and/or eliminate any aspect(s), features or functionality of the Website or the Services as it deems fit at any time without notice. The Company makes no commitment, express or implied, to maintain or continue any aspect of the Website.  You agree that the Company shall not be liable to You or any third party for any modification, suspension or discontinuance of the Website.")]),_vm._v(" "),_c('li',[_vm._v("You acknowledge that the Company does not make any representation or warranty  regarding any of its Users. You are advised to independently verify the bona fides of any particular user that You choose to deal with on the Website.")])]),_vm._v(" "),_c('h4',[_vm._v("Delivery of Reports ")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v(" Sample collection will typically be done on the date and time chosen by the User. The User shall have the option to reschedule subject to the availability of the rescheduled time slot.")]),_vm._v(" "),_c('li',[_vm._v("It is clarified that, certain sample collection procedure may get delayed due to certain unforeseen circumstances beyond the control of the Company. In such an event, We will proactively reach out to You and inform the same. You are expected to check your emails and SMS regularly for any such updates.")]),_vm._v(" "),_c('li',[_vm._v("Reports will be generated within the turnaround time as stipulated by the laboratory/diagnostic centre chosen by the User. The Company is not liable for any delay with respect to the generation of the reports by such laboratory/diagnostic centre . Upon delivery of the reports to Us, We shall verify the User name and other necessary credentials after which the Company shall attach and e-mail a soft copy of the report to Your online account. The User shall be able to view the report only by logging into his/her Account.")]),_vm._v(" "),_c('li',[_vm._v("Reported laboratory results are at best informative to the referring clinician and should not be considered as the sole basis for final diagnosis and treatment decisions. They should always be correlated with other relevant clinical and laboratory findings.")]),_vm._v(" "),_c('li',[_vm._v("The accuracy of the laboratory reports is largely dependent on the quality of the sample as well as the assay procedures used by the laboratory/diagnostic centres chosen by the User.")])]),_vm._v(" "),_c('h4',[_vm._v("Payment, Fees and Taxes ")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("The User agrees to pay all package fees, consulting fees and other fees applicable to the selected Services and the User shall not circumvent the fee structure. The fee is dependent on the package that the User purchases online and not on the actual usage of the Services.")]),_vm._v(" "),_c('li',[_vm._v("Each User is solely responsible for the payment of all taxes. The Company shall be in no way responsible for any of the taxes except for its own tax liabilities.")]),_vm._v(" "),_c('li',[_vm._v("The payment can be made online on the Website through a secured payment gateway provided by a third party. It is hereby clarified that, the Company is not responsible for any loss or damage caused to the User during the payment process as the third parties and their activities are beyond the control of the Company. The payment could also be paid offline and be either collected personally from the User.")]),_vm._v(" "),_c('li',[_vm._v("All fees are exclusive of applicable taxes.")]),_vm._v(" "),_c('li',[_vm._v("The Company reserves the right to modify the fee and such modified fee shall reflect on the Website, which shall be binding.")]),_vm._v(" "),_c('li',[_vm._v("In order to process the payments, the User might be required to provide certain details of the his/her bank account, credit/debit card number and other details as required by the third party vendor to process the transactions. The Company clarifies that it does not own or store any credit/debit card information entered by the User.")]),_vm._v(" "),_c('li',[_vm._v("You understand and acknowledge that the Company shall not be held responsible or assume any liability, whatsoever in respect of any loss or damage arising directly or indirectly to You due to:")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("Lack of authorization for any transaction/s, or")]),_vm._v(" "),_c('li',[_vm._v("Exceeding the preset limit set by your bank, or")]),_vm._v(" "),_c('li',[_vm._v("Delay in processing the transaction; or")]),_vm._v(" "),_c('li',[_vm._v("Any payment issues arising out of the transaction; or")]),_vm._v(" "),_c('li',[_vm._v("Decline of transaction for any reason/s")])]),_vm._v(" "),_c('li',[_vm._v("All payments made against the purchases on the Website by You shall be compulsorily in Indian Rupees acceptable in the Republic of India. The Website will not facilitate transactions with respect to any other form of currency with respect to availing of its services. ")])]),_vm._v(" "),_c('h4',[_vm._v("Cancellation and Refund Policy")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("The User can cancel the test request by calling on the phone number mentioned in the order confirmation notification.")]),_vm._v(" "),_c('li',[_vm._v("All laboratory test requests can be canceled until 12 (twelve) hours prior of the scheduled sample collection appointment to be eligible for a full refund.")]),_vm._v(" "),_c('li',[_vm._v("For any requests cancelled less than 12 (twelve) hours prior to the scheduled sample collection appointment  or after the appointment, the User would incur an administrative charge of INR 100 (Rupees One Hundred). This is primarily to compensate the phlebotomist for a lost opportunity to provide the home sample collection service and earn his/her income.")]),_vm._v(" "),_c('li',[_vm._v("Any requests not cancelled before the scheduled sample collection will NOT receive any refund. All refunds will be processed and credited within 15 (fifteen) business days from the date of the cancellation request into the account of the User.")])]),_vm._v(" "),_c('h4',[_vm._v("Limitation of Liability")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("The Company, its officers, directors, employees, partners or agents shall not be held responsible or held liable to You or any third party for any special, incidental, indirect, consequential or punitive damages whatsoever, including those resulting from loss of use, data or profits or any other claim arising out, of or in connection with, Your use of, or access to, the Website.")]),_vm._v(" "),_c('li',[_vm._v("The Company shall not be held responsible or liable in any manner whatsoever, by the Users for any losses, damage, injuries or expenses incurred by the Users as a result of any lawful disclosures made by the Company, where the User has consented to such disclosures by the Company. The User agrees that the services provided by the Company or any of its affiliates or service providers are provided on an  \"as is,\" basis, and without any warranties or conditions ("),_c('i',[_vm._v("express or implied, including the implied warranties of merchantability, accuracy, fitness for a particular purpose, title and non-infringement, arising by statute or otherwise in law or from a course of dealing or usage or trade")]),_vm._v("). The Company does not provide or make any representation, warranty or guarantee, express or implied about the Website or the Services. The Company does not verify any content or information provided by the Users/User selected laboratories/diagnostic centres on the Website and to the fullest extent permitted by law, disclaims all liability arising out of the User’s use or reliance upon the Website, the Services, representations and warranties made by the laboratories/diagnostic centres or the content or information provided by laboratories/ diagnostic centres on the Website or any loss arising out of the manner in which the Services have been rendered.")]),_vm._v(" "),_c('li',[_vm._v("In no event shall the total aggregate liability of the Protected Entities to a User for all damages, losses, and causes of action ("),_c('i',[_vm._v("whether in contract or tort, including, but not limited to, negligence or otherwise")]),_vm._v(") arising from the terms and conditions or a User’s use of the Website exceed, in the aggregate INR 1,000 (Rupees One Thousand). ")]),_vm._v(" "),_c('li',[_vm._v("Notwithstanding anything to the contrary contained herein, the User alone shall be liable for User’s dealings and interaction with the chosen laboratory/diagnostic centres. ")]),_vm._v(" "),_c('li',[_vm._v("In no event shall the Company be held responsible and liable for failure on the part of the chosen laboratories/ diagnostic centres to provide the agreed Services or to make provisions for the carrying out the Services. In no event shall the Company be liable for any comments or feedback given by any of the Users in relation to the Services provided by any chosen laboratories/diagnostic centres.")]),_vm._v(" "),_c('li',[_vm._v("The listing of the laboratories/diagnostic centres on the Website is based on numerous factors including but not limited to the User’s comments and feedbacks. In no event shall the Company be liable or responsible for the listing order of the laboratories/diagnostic centres on the Website.")]),_vm._v(" "),_c('li',[_vm._v("We shall not be held responsible or liable for, any damages to, or viruses that may infect User’s equipment on account of User’s access to, use of, or browsing the Website or the downloading of any material, data, text, images, video content, or audio content from the Website. If a User is dissatisfied with the Website, User’s sole remedy is to discontinue using the Website.")])]),_vm._v(" "),_c('h4',[_vm._v("Ownership and Intellectual Property Rights")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("The Website and the materials therein including but not limited to all text, graphics, user interfaces, visual interfaces, sounds and music ("),_c('i',[_vm._v("if any")]),_vm._v("), artwork and computer code and any other information or materials of any nature whatsoever on the Website is owned and controlled by the Company and such content is protected by copyright, patent and trademark laws, and various other intellectual property rights and unfair competition laws.")]),_vm._v(" "),_c('li',[_vm._v("The trademarks, logos and service marks displayed on the Website or on the Website (the \""),_c('b',[_vm._v("Marks")]),_vm._v("\") are the property of Company or the respective third parties. You are not permitted to use the Marks without the prior consent of the Company or the third party that may own the Marks.")])]),_vm._v(" "),_c('h4',[_vm._v("Termination of Your Account")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("The Company may at its sole discretion and without prior notice, terminate Your access to the Website and its Services for, including but not limited to, any of the following reasons:")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("Your violation of the Terms as mentioned herein.")]),_vm._v(" "),_c('li',[_vm._v("If the Company is unable to verify or authenticate any information provided to by You.")]),_vm._v(" "),_c('li',[_vm._v("If the Company at its sole discretion believes that Your actions may cause any damage or legal liability for other Users or to  the Company or are contrary to the interests of the Company.")])]),_vm._v(" "),_c('li',[_vm._v("On termination of an Account due to the reasons mentioned herein, such User shall no longer have access to and the reports and other material stored on the Website by such User. The User shall ensure that he/she has continuous backup of the reports.")]),_vm._v(" "),_c('li',[_vm._v("The Company reserves the right, at its sole discretion, to pursue all of its legal remedies, including but not limited to deletion of the User’s content from the Website with or without ability to access the Website and the other services, upon any breach by the User under this Terms or if the Company is unable to verify or authenticate any information provided by the User or if the User fails to provide (or after providing such consent, later revokes) the consents necessary or desirable by the Company to provide the services to the User.")])]),_vm._v(" "),_c('h4',[_vm._v("Indemnification")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("You agree to defend, indemnify and hold harmless the Company, its officers, directors, employees and agents, from and against any and all claims, damages, obligations, losses, liabilities, costs or debt, and expenses (including but not limited to attorney's fees) arising from: (i) Your use of and access of the Website; (ii) Your violation of any term of these Terms or any other policy of the Company; (iii) Your violation of any third party right, including without limitation, any copyright, property, or privacy right; or (iv) any claim that Your use of the Website has caused damage to a third party. The defense and indemnification obligation will survive these Terms.")])]),_vm._v(" "),_c('h4',[_vm._v("Governing Law and Jurisdiction")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("The Website, the Terms, all transactions entered into on or through the Website and the relationship between You and the Company shall be governed by and construed in accordance with the laws of India, without regard to conflict of law principles. The courts of Chennai shall have the jurisdiction to try any dispute between the User and Company.")])]),_vm._v(" "),_c('h4',[_vm._v("General Provisions")]),_vm._v(" "),_c('ul',[_c('li',[_c('b',[_vm._v("Notice:")]),_vm._v(" All notices served by the Company shall be provided via email to Your account or as a general notification on the Website. Any notice to be provided to the Company should be sent to "),_c('b',[_vm._v("[•]")]),_vm._v(".")]),_vm._v(" "),_c('li',[_c('b',[_vm._v("Entire Agreement:")]),_vm._v(" The Terms, along with the Privacy Policy, and any other guidelines made applicable by the Website from time to time, constitute the entire agreement between the Company and You with respect to Your access to or use of the Website and the Services thereof.")]),_vm._v(" "),_c('li',[_c('b',[_vm._v("Assignment:")]),_vm._v(" You cannot assign or otherwise transfer the Terms, or any right granted hereunder to any third party. The Company’s rights under the Terms are freely transferable by the Company to any third parties without the requirement of seeking Your consent. The Company may freely transfer, assign or delegate all or any part of these Terms, any rights and duties hereunder. These Terms will be binding upon and inure to the benefit of the successors and permitted assignees of the parties.")]),_vm._v(" "),_c('li',[_c('b',[_vm._v("Severability:")]),_vm._v(" If, for any reason, a court of competent jurisdiction finds any provision of the Terms, or portion thereof, to be unenforceable, that provision shall be enforced to the maximum extent permissible so as to give effect to the intent of the parties as reflected by that provision, and the remainder of the Terms shall continue in full force and effect.")]),_vm._v(" "),_c('li',[_c('b',[_vm._v("Waiver:")]),_vm._v(" Any failure by the Company to enforce or exercise any provision of the Terms, or any related right, shall not constitute a waiver by the Company of that provision or right.")]),_vm._v(" "),_c('li',[_c('b',[_vm._v("Force Majeure:")]),_vm._v(" The Company shall not be held responsible or liable due to any unavailability caused by circumstances beyond the Company’s reasonable control, including without limitation, Acts of God, acts of Government, flood, fire, earthquakes, civil unrest, acts of terror, strikes or other labour problems such as strikes and lockouts, or internet service provider failures or delays.")]),_vm._v(" "),_c('li',[_c('b',[_vm._v("Relationship:")]),_vm._v(" You acknowledge that Your participation on the Website, does not make You an employee or agency or partnership or joint venture or franchise of the Company. Further, you shall not have the right to enter into any obligation or commitment on behalf of the Company.")]),_vm._v(" "),_c('li',[_vm._v("The Company provides these Terms on the Website so that You are aware of the terms that apply to Your use of the Website. You acknowledge that, the Company has given You a reasonable opportunity to review these Terms and that You have agreed to them.")]),_vm._v(" "),_c('li',[_vm._v("In the event that you participate in any promotional activities through the advertisers on the Website, the Company shall not be held responsible for any loss or damage caused to you in this regard.")])]),_vm._v(" "),_c('h4',[_vm._v("DISCLAIMER")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("WE DO NOT PROVIDE MEDICAL ADVICE:")]),_vm._v(" THE INFORMATION THAT YOU OBTAIN OR RECEIVE FROM THE COMPANY, AND ITS EMPLOYEES, CONTRACTORS, PARTNERS, SPONSORS, ADVERTISERS, LICENSORS OR OTHERWISE ON THE WEBSITE IS FOR INFORMATIONAL AND SCHEDULING PURPOSES ONLY. THE INFORMATION PROVIDED ON THE WEBSITE IS NOT INTENDED AS A SUBSTITUTE FOR, NOR DOES IT REPLACE, PROFESSIONAL MEDICAL ADVICE, DIAGNOSIS, OR TREATMENT. DO NOT DISREGARD, AVOID OR DELAY OBTAINING MEDICAL ADVICE FROM A QUALIFIED HEALTH CARE PROFESSIONAL BECAUSE OF SOMETHING YOU MAY HAVE READ ON THE WEBSITE. DO NOT USE THE WEBSITE FOR EMERGENCY MEDICAL NEEDS. YOUR USE OF INFORMATION PROVIDED ON THE WEBSITE IS SOLELY AT YOUR OWN RISK. NOTHING STATED OR POSTED ON THE WEBSITE OR AVAILABLE THROUGH ANY SERVICES IS INTENDED TO BE, AND MUST NOT BE TAKEN TO BE, THE PRACTICE OF MEDICINE OR THE PROVISION OF MEDICAL CARE. WE DO NOT RECOMMEND OR ENDORSE ANY SPECIFIC TESTS, PHYSICIANS, LABORATORIES, DIAGNOSTIC CENTRES, PROCEDURES, OPINIONS, OR OTHER INFORMATION THAT MAY APPEAR ON THE WEBSITE. IF YOU RELY ON ANY OF THE INFORMATION PROVIDED BY THE WEBSITE, YOU DO SO SOLELY AT YOUR OWN RISK.")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("NO DOCTOR PATIENT RELATIONSHIP:")]),_vm._v(" NO LICENSED MEDICAL PROFESSIONAL/PATIENT RELATIONSHIP IS CREATED BY USING THE INFORMATION PROVIDED BY OR THROUGH THE USE OF THE WEBSITE INCLUDING, BUT NOT LIMITED TO, FIND A TEST FEATURE, LINKS TO OTHER WEBSITES OR ANY ASSISTANCE WE MAY PROVIDE TO HELP YOU FIND AN APPROPRIATE MEDICAL PROFESSIONAL/DIAGNOSTIC CENTER OR SPECIALIST IN ANY FIELD FOR CONDUCTING THE REQUISITE TEST. WE MAKE NO GUARANTEES, REPRESENTATIONS OR WARRANTIES, WHETHER EXPRESSED OR IMPLIED, WITH RESPECT TO PROFESSIONAL QUALIFICATIONS, EXPERTISE, QUALITY OF WORK OR OTHER INFORMATION HEREIN REGARDING THE LABORATORIES/DIAGNOSTIC CENTRE OR THER PHLEBOTOMISTS. IN NO EVENT SHALL WE BE LIABLE TO YOU OR ANYONE ELSE FOR ANY DECISION MADE OR ACTION TAKEN BY YOU IN RELIANCE ON SUCH INFORMATION. WE HAVE NOT CONDUCTED ANY BACKGROUND CHECK ON THE PHLEBOTOMISTS AND WE ARE IN NO WAY LIABLE FOR ANY OF THEIR ACT/OMISSIONS. WE HAVE NO CONTROL OVER, AND CANNOT GUARANTEE THE AVAILABILITY OF ANY DIAGNOSTIC CENTER AT ANY PARTICULAR TIME. WE WILL NOT BE LIABLE FOR CANCELLED OR OTHERWISE UNFULFILLED APPOINTMENTS OR ANY INJURY RESULTING THEREFROM, OR FOR ANY OTHER INJURY RESULTING FROM THE USE OF THE WEBSITE OR SERVICES WHATSOEVER. YOU ARE STRONGLY ADVISED TO PERFORM YOUR OWN INVESTIGATION PRIOR TO SELECTING A HEALTH CARE DIAGNOSTIC CENTRE BY MAKING CONFIRMING TELEPHONE CALLS TO THE RELEVANT DIAGNOSTIC CENTRE. ANY KIND OF AN ENGAGEMENT WITH THE THIRD PARTIES INCLUDING WITH THE DIAGNOSTIC CENTRE WOULD BE ON A PRINCIPAL TO PRINCIPAL BASIS ON THE BEST JUDGEMENT OF YOURSELF.")]),_vm._v(" "),_c('h4',[_vm._v("Feedback")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("Any feedback You provide to this Website shall be deemed to be non-confidential. The Website shall be free to use such information on an unrestricted basis. Further, by submitting the feedback, You represent and warrant that (i) Your feedback does not contain confidential or proprietary information of You or of third parties; (ii) the Company is not under any obligation of confidentiality, express or implied, with respect to the feedback; (iii) the Website may have something similar to the feedback already under consideration or in development; and (iv) You are not entitled to any compensation or reimbursement of any kind from the Company for the feedback under any circumstances, unless specified.")]),_vm._v(" "),_c('li',[_vm._v("Under no circumstances shall the Company be held responsible in any manner for any content provided by other users even such content is offensive, hurtful or offensive. Please exercise caution while accessing the Website.")])]),_vm._v(" "),_c('h4',[_vm._v("Customer Care")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("We make all best endeavors to provide you with a pleasant experience. In the unlikely event that You face any issues, please contact us at "),_c('b',[_vm._v("[•]")])])])])])])}]
var Public_Terms_esExports = { render: Public_Terms_render, staticRenderFns: Public_Terms_staticRenderFns }
/* harmony default export */ var components_mobile_Public_Terms = (Public_Terms_esExports);
// CONCATENATED MODULE: ./src/components/mobile/Public/Terms.vue
function Public_Terms_injectStyle (ssrContext) {
  __webpack_require__("2kof")
}
var Public_Terms_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var Public_Terms___vue_template_functional__ = false
/* styles */
var Public_Terms___vue_styles__ = Public_Terms_injectStyle
/* scopeId */
var Public_Terms___vue_scopeId__ = "data-v-61eaafef"
/* moduleIdentifier (server only) */
var Public_Terms___vue_module_identifier__ = null
var Public_Terms_Component = Public_Terms_normalizeComponent(
  mobile_Public_Terms,
  components_mobile_Public_Terms,
  Public_Terms___vue_template_functional__,
  Public_Terms___vue_styles__,
  Public_Terms___vue_scopeId__,
  Public_Terms___vue_module_identifier__
)

/* harmony default export */ var src_components_mobile_Public_Terms = (Public_Terms_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/Public/Labsignup.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var mobile_Public_Labsignup = ({
  name: 'Labsignup',
  components: {
    HeaderVue: mobile_Header["a" /* default */],
    FooterVue: mobile_Footer["a" /* default */]
  },
  beforeCreate: function beforeCreate() {},
  data: function data() {
    return {
      pincode: '',
      labname: '',
      contact: '',
      phone: '',
      email: '',
      fax: '',
      address: '',
      city: '',
      state: '',
      success: false
    };
  },

  methods: {
    save: function save() {
      var _this = this;

      this.$validator.validateAll('signup').then(function (result) {
        if (result) {

          try {
            var data = {
              labName: this.labname,
              contactPersonName: this.contact,
              emailAddress: this.email,
              phoneNumber: this.phone,
              faxNumber: this.fax,
              address: this.address,
              cityName: this.city,
              stateName: this.state,
              pincode: this.pincode
            };
            promise_default.a.resolve(this.$POST('patient/labSignup', data)).then(function (res) {
              if (res.response_code === 0) {
                this.success = true;
                this.$Simplert.open({
                  title: 'Success',
                  message: 'Thanks for contact us. We will touch with you soon.',
                  type: 'warning',
                  disableOverlayClick: true,
                  showXclose: true,
                  useConfirmBtn: false,
                  customCloseBtnText: 'OK'
                });
                this.reset();
                // location.reload()
              }
            }.bind(this)).catch(function (err) {
              console.error(err);
              this.$Simplert.open({
                title: 'Oops',
                message: 'Something went wrong please mail us support@labotist.com',
                type: 'warning',
                disableOverlayClick: true,
                showXclose: true,
                useConfirmBtn: false,
                customCloseBtnText: 'OK'
              });
              // alert('Something went wrong please mail us support@labotist.com')
            }.bind(this));
          } catch (e) {
            console.error(e);
          }
        }
      }.bind(this)).catch(function () {
        console.log('errors exist while save lab form', _this.errors);
      });
    },
    reset: function reset() {
      this.pincode = '';
      this.labname = '';
      this.contact = '';
      this.email = '';
      this.phone = '';
      this.fax = '';
      this.address = '';
      this.city = '';
      this.state = '';
      setTimeout(function () {
        this.errors.items = [];
      }.bind(this), 30);
    }
  },
  mounted: function mounted() {
    this.$hidePageLoading();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d6af5766","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/Public/Labsignup.vue
var Public_Labsignup_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"labSignupDiv"}},[_c('HeaderVue',{attrs:{"isHeader":"true"}}),_vm._v(" "),_vm._m(0,false,false),_vm._v(" "),_c('div',{staticClass:"modal fade",attrs:{"id":"sign-upForm","tabindex":"-1","role":"dialog","aria-labelledby":"sign-upFormLabel","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_vm._m(1,false,false),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"form-content line-textbox"},[_vm._m(2,false,false),_vm._v(" "),_c('form',{attrs:{"data-vv-scope":"signup"}},[_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.pincode),expression:"pincode"},{name:"validate",rawName:"v-validate",value:('required|numeric|min:6|max:6'),expression:"'required|numeric|min:6|max:6'"}],staticClass:"form-control",attrs:{"type":"text","name":"pincode","id":"pincode","data-vv-as":"pincode","placeholder":"Pincode (Chennai & Bengaluru)"},domProps:{"value":(_vm.pincode)},on:{"input":function($event){if($event.target.composing){ return; }_vm.pincode=$event.target.value}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('signup.pincode')),expression:"errors.has('signup.pincode')"}],staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('signup.pincode')))])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.labname),expression:"labname"},{name:"validate",rawName:"v-validate",value:('required|max:250'),expression:"'required|max:250'"}],staticClass:"form-control",attrs:{"type":"text","name":"labname","id":"labname","data-vv-as":"lab name","placeholder":"Lab Name"},domProps:{"value":(_vm.labname)},on:{"input":function($event){if($event.target.composing){ return; }_vm.labname=$event.target.value}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('signup.labname')),expression:"errors.has('signup.labname')"}],staticClass:"text-danger"})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.contact),expression:"contact"},{name:"validate",rawName:"v-validate",value:('required|alpha_spaces|max:100'),expression:"'required|alpha_spaces|max:100'"}],staticClass:"form-control",attrs:{"type":"text","name":"contact","id":"contact","data-vv-as":"contact name","placeholder":"Contact Person Name"},domProps:{"value":(_vm.contact)},on:{"input":function($event){if($event.target.composing){ return; }_vm.contact=$event.target.value}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('signup.contact')),expression:"errors.has('signup.contact')"}],staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('signup.contact')))])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email),expression:"email"},{name:"validate",rawName:"v-validate",value:('required|email'),expression:"'required|email'"}],staticClass:"form-control",attrs:{"type":"email","name":"email","id":"email","data-vv-as":"email address","placeholder":"Email Address"},domProps:{"value":(_vm.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.email=$event.target.value}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('signup.email')),expression:"errors.has('signup.email')"}],staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('signup.email')))])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.phone),expression:"phone"},{name:"validate",rawName:"v-validate",value:('required|numeric|max:10|min:10'),expression:"'required|numeric|max:10|min:10'"}],staticClass:"form-control",attrs:{"type":"text","name":"phone","id":"phone","data-vv-as":"phone no.","placeholder":"Phone No"},domProps:{"value":(_vm.phone)},on:{"input":function($event){if($event.target.composing){ return; }_vm.phone=$event.target.value}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('signup.phone')),expression:"errors.has('signup.phone')"}],staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('signup.phone')))])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fax),expression:"fax"},{name:"validate",rawName:"v-validate",value:('numeric|max:10|min:10'),expression:"'numeric|max:10|min:10'"}],staticClass:"form-control",attrs:{"type":"text","name":"fax","id":"fax","data-vv-as":"fax no.","placeholder":"Fax No"},domProps:{"value":(_vm.fax)},on:{"input":function($event){if($event.target.composing){ return; }_vm.fax=$event.target.value}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('signup.fax')),expression:"errors.has('signup.fax')"}],staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('signup.fax')))])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.address),expression:"address"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"form-control",attrs:{"type":"text","name":"address","id":"address","data-vv-as":"lab address","placeholder":"Address"},domProps:{"value":(_vm.address)},on:{"input":function($event){if($event.target.composing){ return; }_vm.address=$event.target.value}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('signup.address')),expression:"errors.has('signup.address')"}],staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('signup.address')))])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.city),expression:"city"},{name:"validate",rawName:"v-validate",value:('required|alpha_spaces|max:100'),expression:"'required|alpha_spaces|max:100'"}],staticClass:"form-control",attrs:{"type":"text","name":"city","id":"city","data-vv-as":"city","placeholder":"City"},domProps:{"value":(_vm.city)},on:{"input":function($event){if($event.target.composing){ return; }_vm.city=$event.target.value}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('signup.city')),expression:"errors.has('signup.city')"}],staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('signup.city')))])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.state),expression:"state"},{name:"validate",rawName:"v-validate",value:('required|alpha_spaces|max:100'),expression:"'required|alpha_spaces|max:100'"}],staticClass:"form-control",attrs:{"type":"text","name":"state","id":"state","data-vv-as":"state","placeholder":"State"},domProps:{"value":(_vm.state)},on:{"input":function($event){if($event.target.composing){ return; }_vm.state=$event.target.value}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('signup.state')),expression:"errors.has('signup.state')"}],staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('signup.state')))])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-6"},[_c('button',{staticClass:"btn  btn-link full-width",attrs:{"type":"reset"},on:{"click":function($event){$event.preventDefault();_vm.reset()}}},[_vm._v("Reset")])]),_vm._v(" "),_c('div',{staticClass:"col-6"},[_c('button',{staticClass:"btn btn-primary full-width fly-msg",attrs:{"data-dismiss":"modal","aria-label":"Close","disabled":(_vm.errors.any())},on:{"click":function($event){$event.preventDefault();_vm.save()}}},[_vm._v("Save")])])])])])])])])]),_vm._v(" "),_c('FooterVue')],1)}
var Public_Labsignup_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"phleb-signup"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"lab-benefits phlebotomists-signup"},[_c('h2',[_vm._v("Partner With Us")]),_vm._v(" "),_c('p',[_vm._v("A unique initiative for mutual growth of "),_c('br'),_vm._v("your lab & Labotist")]),_vm._v(" "),_c('ul',[_c('li',[_c('span',{staticClass:"number-circle"},[_vm._v("1")]),_vm._v("Experience significant visibility online.")]),_vm._v(" "),_c('li',[_c('span',{staticClass:"number-circle"},[_vm._v("2")]),_vm._v("Gain access to trained & efficient phlebotomists providing high quality of service leading to increased customer satisfaction.")]),_vm._v(" "),_c('li',[_c('span',{staticClass:"number-circle"},[_vm._v("3")]),_vm._v("Eliminate the burden and expenditure on marketing, inventory management, and\n                                logistical aspects involved in transportation of samples between the patient’s homes and the lab, allowing for labs to focus on their core strengths.")]),_vm._v(" "),_c('li',[_c('span',{staticClass:"number-circle"},[_vm._v("4")]),_vm._v("Design your product offerings based on the market intelligence and customer feedback shared by Labotist Data Sciences Team.")]),_vm._v(" "),_c('li',[_c('span',{staticClass:"number-circle"},[_vm._v("5")]),_vm._v("Labotist will take care of customer care, training and payroll of the phlebotomists, while you focus on patients.")])])])])])]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary full-width rounded-0",attrs:{"data-toggle":"modal","data-target":"#sign-upForm"}},[_vm._v("Sign Up")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"menu_popup",attrs:{"data-dismiss":"modal","aria-label":"Close"}},[_c('i',{staticClass:"material-icons"},[_vm._v("arrow_back")])]),_vm._v(" "),_c('h3',{staticClass:"screen-title mt-13p"},[_vm._v("Partner With Us")])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('b',[_vm._v("Sign Up Today")])])}]
var Public_Labsignup_esExports = { render: Public_Labsignup_render, staticRenderFns: Public_Labsignup_staticRenderFns }
/* harmony default export */ var components_mobile_Public_Labsignup = (Public_Labsignup_esExports);
// CONCATENATED MODULE: ./src/components/mobile/Public/Labsignup.vue
function Public_Labsignup_injectStyle (ssrContext) {
  __webpack_require__("BZbz")
}
var Public_Labsignup_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var Public_Labsignup___vue_template_functional__ = false
/* styles */
var Public_Labsignup___vue_styles__ = Public_Labsignup_injectStyle
/* scopeId */
var Public_Labsignup___vue_scopeId__ = "data-v-d6af5766"
/* moduleIdentifier (server only) */
var Public_Labsignup___vue_module_identifier__ = null
var Public_Labsignup_Component = Public_Labsignup_normalizeComponent(
  mobile_Public_Labsignup,
  components_mobile_Public_Labsignup,
  Public_Labsignup___vue_template_functional__,
  Public_Labsignup___vue_styles__,
  Public_Labsignup___vue_scopeId__,
  Public_Labsignup___vue_module_identifier__
)

/* harmony default export */ var src_components_mobile_Public_Labsignup = (Public_Labsignup_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/Public/Phlebsignup.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var mobile_Public_Phlebsignup = ({
  name: 'Phlebsignup',
  components: {
    HeaderVue: mobile_Header["a" /* default */],
    FooterVue: mobile_Footer["a" /* default */]
  },
  data: function data() {
    return {
      pincode: '',
      firstname: '',
      lastname: '',
      email: '',
      mobile: '',
      phone: '',
      address: '',
      city: '',
      state: '',
      success: false
    };
  },
  beforeCreate: function beforeCreate() {},

  methods: {
    save: function save() {
      var _this = this;

      this.$validator.validateAll('signup').then(function (result) {
        if (result) {
          try {
            var data = {
              firstName: this.firstname,
              lastName: this.lastname,
              emailAddress: this.email,
              mobileNumber: this.mobile,
              phoneNumber: this.phone,
              address: this.address,
              cityName: this.city,
              stateName: this.state,
              pincode: this.pincode
            };
            promise_default.a.resolve(this.$POST('patient/phlebSignup', data)).then(function (res) {
              if (res.response_code === 0) {
                this.success = true;
                // location.reload()
                this.$Simplert.open({
                  title: 'Success',
                  message: 'We have received your details.We will touch with you soon.',
                  type: 'warning',
                  disableOverlayClick: true,
                  showXclose: true,
                  useConfirmBtn: false,
                  customCloseBtnText: 'OK'
                });
                this.reset();
              }
            }.bind(this)).catch(function (err) {
              console.error(err);
              this.$Simplert.open({
                title: 'Oops',
                message: 'Something went wrong please mail us support@labotist.com',
                type: 'warning',
                disableOverlayClick: true,
                showXclose: true,
                useConfirmBtn: false,
                customCloseBtnText: 'OK'
              });
              // alert('Something went wrong please mail us support@labotist.com')
            }.bind(this));
          } catch (e) {
            console.error(e);
          }
        }
      }.bind(this)).catch(function () {
        console.log('errors exist while save lab form', _this.errors);
      });
    },
    reset: function reset() {
      this.pincode = '';
      this.firstname = '';
      this.lastname = '';
      this.email = '';
      this.mobile = '';
      this.phone = '';
      this.address = '';
      this.city = '';
      this.state = '';
      setTimeout(function () {
        this.errors.items = [];
      }.bind(this), 30);
    }
  },
  mounted: function mounted() {
    this.$hidePageLoading();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-623abad1","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/Public/Phlebsignup.vue
var Public_Phlebsignup_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"phlebSignupDiv"}},[_c('HeaderVue',{attrs:{"isHeader":"true"}}),_vm._v(" "),_vm._m(0,false,false),_vm._v(" "),_c('FooterVue'),_vm._v(" "),_c('div',{staticClass:"modal fade",attrs:{"id":"sign-upForm","tabindex":"-1","role":"dialog","aria-labelledby":"sign-upFormLabel","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_vm._m(1,false,false),_vm._v(" "),_c('div',{staticClass:"modal-body pt-0"},[_c('div',{staticClass:"form-content line-textbox"},[_vm._m(2,false,false),_vm._v(" "),_c('form',{attrs:{"data-vv-scope":"signup"}},[_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.pincode),expression:"pincode"},{name:"validate",rawName:"v-validate",value:('required|numeric|max:6|min:6'),expression:"'required|numeric|max:6|min:6'"}],staticClass:"form-control",attrs:{"type":"text","name":"pincode","id":"pincode","data-vv-as":"pincode","placeholder":"Pincode (Chennai & Banglore)"},domProps:{"value":(_vm.pincode)},on:{"input":function($event){if($event.target.composing){ return; }_vm.pincode=$event.target.value}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('signup.pincode')),expression:"errors.has('signup.pincode')"}],staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('signup.pincode')))])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.firstname),expression:"firstname"},{name:"validate",rawName:"v-validate",value:('required|alpha|max:50'),expression:"'required|alpha|max:50'"}],staticClass:"form-control",attrs:{"type":"text","name":"firstname","id":"firstname","data-vv-as":"first name","placeholder":"First Name"},domProps:{"value":(_vm.firstname)},on:{"input":function($event){if($event.target.composing){ return; }_vm.firstname=$event.target.value}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('signup.firstname')),expression:"errors.has('signup.firstname')"}],staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('signup.firstname')))])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.lastname),expression:"lastname"},{name:"validate",rawName:"v-validate",value:('required|alpha|max:50'),expression:"'required|alpha|max:50'"}],staticClass:"form-control",attrs:{"type":"text","name":"lastname","id":"lastname","data-vv-as":"last name","placeholder":"Last Name"},domProps:{"value":(_vm.lastname)},on:{"input":function($event){if($event.target.composing){ return; }_vm.lastname=$event.target.value}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('signup.lastname')),expression:"errors.has('signup.lastname')"}],staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('signup.lastname')))])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email),expression:"email"},{name:"validate",rawName:"v-validate",value:('required|email'),expression:"'required|email'"}],staticClass:"form-control",attrs:{"type":"email","name":"email","id":"email","data-vv-as":"email address","placeholder":"Email Address"},domProps:{"value":(_vm.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.email=$event.target.value}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('signup.email')),expression:"errors.has('signup.email')"}],staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('signup.email')))])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.phone),expression:"phone"},{name:"validate",rawName:"v-validate",value:('required|numeric|max:10|min:10'),expression:"'required|numeric|max:10|min:10'"}],staticClass:"form-control",attrs:{"type":"text","name":"phone","id":"phone","data-vv-as":"phone no.","placeholder":"Phone No"},domProps:{"value":(_vm.phone)},on:{"input":function($event){if($event.target.composing){ return; }_vm.phone=$event.target.value}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('signup.phone')),expression:"errors.has('signup.phone')"}],staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('signup.phone')))])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.address),expression:"address"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"form-control",attrs:{"type":"text","name":"address","id":"address","data-vv-as":"address","placeholder":"Address"},domProps:{"value":(_vm.address)},on:{"input":function($event){if($event.target.composing){ return; }_vm.address=$event.target.value}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('signup.address')),expression:"errors.has('signup.address')"}],staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('signup.address')))])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.city),expression:"city"},{name:"validate",rawName:"v-validate",value:('required|alpha_spaces|max:50'),expression:"'required|alpha_spaces|max:50'"}],staticClass:"form-control",attrs:{"type":"text","name":"city","id":"city","data-vv-as":"city","placeholder":"City"},domProps:{"value":(_vm.city)},on:{"input":function($event){if($event.target.composing){ return; }_vm.city=$event.target.value}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('signup.city')),expression:"errors.has('signup.city')"}],staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('signup.city')))])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.state),expression:"state"},{name:"validate",rawName:"v-validate",value:('required|alpha_spaces|max:50'),expression:"'required|alpha_spaces|max:50'"}],staticClass:"form-control",attrs:{"type":"text","name":"state","id":"state","data-vv-as":"state","placeholder":"State"},domProps:{"value":(_vm.state)},on:{"input":function($event){if($event.target.composing){ return; }_vm.state=$event.target.value}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('signup.state')),expression:"errors.has('signup.state')"}],staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('signup.state')))])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-6"},[_c('button',{staticClass:"btn  btn-link full-width",attrs:{"type":"reset"},on:{"click":function($event){$event.preventDefault();_vm.reset()}}},[_vm._v("\n                                        Reset\n                                    ")])]),_vm._v(" "),_c('div',{staticClass:"col-6"},[_c('button',{staticClass:"btn btn-primary full-width fly-msg",attrs:{"data-dismiss":"modal","aria-label":"Close","disabled":(_vm.errors.any())},on:{"click":function($event){$event.preventDefault();_vm.save()}}},[_vm._v("\n                                       Save\n                                    ")])])])])])])])])])],1)}
var Public_Phlebsignup_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"alert alert-success alert-dismissable flyover flyover-centered",attrs:{"id":"message1"}},[_c('strong',[_c('i',{staticClass:"fa fa-check mr-2"})]),_vm._v("\n            Thank you! We have received your form, we will get in touch at the earliest.\n        ")]),_vm._v(" "),_c('div',{staticClass:"phleb-signup"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"phlebotomists-signup"},[_c('h2',[_vm._v("Phlebotomists\n                                "),_c('br'),_vm._v(" Benefits")]),_vm._v(" "),_c('ul',[_c('li',[_c('span',{staticClass:"number-circle"},[_vm._v("1")]),_vm._v("Become micro-entrepreneurs (Be their own boss)")]),_vm._v(" "),_c('li',[_c('span',{staticClass:"number-circle"},[_vm._v("2")]),_vm._v("Work on a schedule that suits them")]),_vm._v(" "),_c('li',[_c('span',{staticClass:"number-circle"},[_vm._v("3")]),_vm._v("Work within the area that is close to home & family")]),_vm._v(" "),_c('li',[_c('span',{staticClass:"number-circle"},[_vm._v("4")]),_vm._v("Get state of the art training and tools")]),_vm._v(" "),_c('li',[_c('span',{staticClass:"number-circle"},[_vm._v("5")]),_vm._v("Use indigenous mobile app that enables technology driven sample collection\n                                ")]),_vm._v(" "),_c('li',[_c('span',{staticClass:"number-circle"},[_vm._v("6")]),_vm._v("Increase their income \n                                ")])])])])])]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary full-width rounded-0",attrs:{"data-toggle":"modal","data-target":"#sign-upForm"}},[_vm._v("Sign Up")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"menu_popup",attrs:{"data-dismiss":"modal","aria-label":"Close"}},[_c('i',{staticClass:"material-icons"},[_vm._v("arrow_back")])]),_vm._v(" "),_c('h3',{staticClass:"screen-title mt-13p"},[_vm._v("Sign Up")])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('b',[_vm._v("Join us as a Labotist Phlebotomist")])])}]
var Public_Phlebsignup_esExports = { render: Public_Phlebsignup_render, staticRenderFns: Public_Phlebsignup_staticRenderFns }
/* harmony default export */ var components_mobile_Public_Phlebsignup = (Public_Phlebsignup_esExports);
// CONCATENATED MODULE: ./src/components/mobile/Public/Phlebsignup.vue
function Public_Phlebsignup_injectStyle (ssrContext) {
  __webpack_require__("7hJy")
}
var Public_Phlebsignup_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var Public_Phlebsignup___vue_template_functional__ = false
/* styles */
var Public_Phlebsignup___vue_styles__ = Public_Phlebsignup_injectStyle
/* scopeId */
var Public_Phlebsignup___vue_scopeId__ = "data-v-623abad1"
/* moduleIdentifier (server only) */
var Public_Phlebsignup___vue_module_identifier__ = null
var Public_Phlebsignup_Component = Public_Phlebsignup_normalizeComponent(
  mobile_Public_Phlebsignup,
  components_mobile_Public_Phlebsignup,
  Public_Phlebsignup___vue_template_functional__,
  Public_Phlebsignup___vue_styles__,
  Public_Phlebsignup___vue_scopeId__,
  Public_Phlebsignup___vue_module_identifier__
)

/* harmony default export */ var src_components_mobile_Public_Phlebsignup = (Public_Phlebsignup_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/json/stringify.js
var stringify = __webpack_require__("mvHQ");
var stringify_default = /*#__PURE__*/__webpack_require__.n(stringify);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/Secure/MyResult.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var mobile_Secure_MyResult = ({
  name: 'MyResult',
  props: [],
  components: {
    HeaderVue: mobile_Header["a" /* default */],
    FooterVue: mobile_Footer["a" /* default */],
    pdfviewer: vue_pdfviewer
  },
  beforeCreate: function beforeCreate() {
    if (!this.$localStorage.get('loggedIn') || this.$localStorage.get('loggedIn') === null) {
      this.$router.push({ path: '/' });
    }
  },
  data: function data() {
    return {
      loadMorePerHit: 10,
      reportLimit: 10,
      totalReports: [],
      reportList: [],
      limitedReportList: [],
      isLoading: false,
      deviceData: undefined,
      pdfurls: '',
      isshowpdf: false
    };
  },
  created: function created() {
    this.patientReports();
    this.deviceData = detect_browser_default.a.detect();
  },

  methods: {
    closepdf: function closepdf() {
      this.isshowpdf = false;
      this.pdfurls = '';
    },
    pdferr: function pdferr(errurl) {
      console.log(errurl);
      this.pdfurls = '';
      this.isshowpdf = false;
      // alert('Unable to fetch Report try again')
      this.$Simplert.open({
        title: 'Oops',
        message: 'Unable to fetch Report try again',
        type: 'warning',
        disableOverlayClick: true,
        showXclose: true,
        useConfirmBtn: false,
        customCloseBtnText: 'OK'
      });
    },

    loadMore: function loadMore() {
      var increamented = this.reportLimit + this.loadMorePerHit;
      this.reportLimit = increamented > this.totalReports.length ? this.totalReports.length : increamented;
    },
    formatDate: function formatDate(date, format) {
      var dateSplit = date.split(' ');
      return dateformat_default()(dateSplit[0] + 'T' + dateSplit[1], format, true);
    },
    formatReportDate: function formatReportDate(date, format) {
      return dateformat_default()(date, format);
    },
    patientReports: function patientReports() {
      try {
        this.reportList = [];
        var data = {};
        this.isLoading = true;
        promise_default.a.resolve(this.$POST('patient/patientReports', data)).then(function (res) {
          if (res.response_code === 0) {
            this.totalReports = res.response;
            this.isLoading = false;
          } else {
            this.isLoading = false;
          }
          this.$hidePageLoading();
        }.bind(this)).catch(function (err) {
          console.error(err);
        });
      } catch (e) {
        console.error(e);
      }
    },
    viewReport: function viewReport(requestId) {
      try {
        this.reportList = [];
        var data = {
          requestId: requestId
        };
        promise_default.a.resolve(this.$GET('patient/viewReport', data)).then(function (res) {
          if (res.response_code === 0) {
            if (this.$WebView && this.$WebViewBridge) {
              var _data = {
                type: 'openReport',
                requestId: res.response.requestId ? 'REQ' + res.response.requestId : '',
                pdfUrl: res.response.url
              };
              this.$WebViewBridge.send(stringify_default()(_data));
            } else {
              try {
                // var popupWindow = window.open(res.response.url, '_blank')
                // popupWindow.focus()
                this.pdfurls = res.response.url;
                this.isshowpdf = true;
              } catch (e) {
                //   this.popupBlockerAlert()
              }
            }
          } else {
            this.$Simplert.open({
              title: 'Oops',
              message: res.response_message,
              type: 'warning',
              disableOverlayClick: true,
              showXclose: true,
              useConfirmBtn: false,
              customCloseBtnText: 'OK'
            });
            // alert(res.response_message)
          }
        }.bind(this)).catch(function (err) {
          console.error(err);
        });
      } catch (e) {
        console.error(e);
      }
    },
    popupBlockerAlert: function popupBlockerAlert() {
      if (this.deviceData.name === 'chrome' && this.deviceData.os.indexOf('Windows') > -1) {
        this.$Simplert.open({
          title: 'Popup Blocked',
          message: '<div style="text-align: left; line-height: 25px;">\n                        <strong>1. </strong> Click the <strong>Customize and control Google Chrome</strong> menu (the three horizontal bars in the upper right corner)<br>\n                        <strong>2. </strong> Select <strong>Settings</strong>.<br>\n                        <strong>3. </strong> Click the <strong>Show advanced settings...</strong> at the bottom.<br>\n                        <strong>4. </strong> Under Privacy, click the <strong>Content Settings</strong> button.<br>\n                        <strong>5. </strong> To disable the pop-up blocker check the <strong>Allow all sites to show pop-ups</strong> box.<br>\n                        <strong>6. </strong> To enable pop-ups on specific sites, check <strong>Do not allow any site to show pop-ups</strong> (recommended) and click Exceptions and enter this URL(<strong>https://labotist.com</strong>).\n                    </div>',
          type: 'warning',
          disableOverlayClick: true,
          showXclose: true,
          useConfirmBtn: false,
          customCloseBtnText: 'OK'
        });
      } else if (this.deviceData.name === 'chrome' && this.deviceData.os.indexOf('Mac') > -1) {
        this.$Simplert.open({
          title: 'Popup Blocked',
          message: '<div style="text-align: left; line-height: 25px;">\n                    <strong>1. </strong> Click the <strong>Customize and control Google Chrome</strong> menu (the three horizontal bars in the upper right corner)<br>\n                    <strong>2. </strong>  Select <strong>Settings</strong>.<br>\n                    <strong>3. </strong> Click the <strong>Show advanced settings...</strong> at the bottom.<br>\n                    <strong>4. </strong> Under <strong>Privacy</strong>, click the <strong>Content Settings</strong> button.<br>\n                    <strong>5. </strong> To disable the pop-up blocker check the Allow all sites to show pop-ups box.<br>\n                    <strong>6. </strong> To enable pop-ups on specific sites, check <strong>Do not allow any site to show pop-ups</strong> (recommended) and click Exceptions and enter this URL(<strong>https://labotist.com</strong>).<br>\n                </div>',
          type: 'warning',
          disableOverlayClick: true,
          showXclose: true,
          useConfirmBtn: false,
          customCloseBtnText: 'OK'
        });
      } else if (this.deviceData.name === 'chrome' && this.deviceData.os.indexOf('Android') > -1) {
        this.$Simplert.open({
          title: 'Popup Blocked',
          message: '<div style="text-align: left; line-height: 25px;">\n                <strong>1. </strong> To the right of the address bar, tap More  and then <strong>Settings</strong>.<br>\n                <strong>2. </strong>  Tap <strong>Site settings</strong> and then <strong>Pop-ups</strong>.<br>\n                <strong>3. </strong> Turn <strong>Pop-ups</strong> to <strong>Allowed</strong>.\n                </div>',
          type: 'warning',
          disableOverlayClick: true,
          showXclose: true,
          useConfirmBtn: false,
          customCloseBtnText: 'OK'
        });
      } else if (this.deviceData.name === 'crios' && this.deviceData.os.indexOf('iOS') > -1) {
        this.$Simplert.open({
          title: 'Popup Blocked',
          message: '<div style="text-align: left; line-height: 25px;">\n                    <strong>1. </strong> To the right of the address bar, tap More  and then <strong>Settings</strong>.<br>\n                    <strong>2. </strong>  Tap <strong>Content Settings</strong> and then <strong>Block Pop-ups</strong>.<br>\n                    <strong>3. </strong> Turn <strong>Block pop-ups</strong> off.\n                </div>',
          type: 'warning',
          disableOverlayClick: true,
          showXclose: true,
          useConfirmBtn: false,
          customCloseBtnText: 'OK'
        });
      } else if (this.deviceData.name === 'safari' && this.deviceData.os.indexOf('Mac') > -1) {
        this.$Simplert.open({
          title: 'Popup Blocked',
          message: '<div style="text-align: left; line-height: 25px;">\n                        <strong>1. </strong> From the <strong>Safari</strong> menu, select <strong>Preferences</strong><br>\n                        <strong>2. </strong>  Click <strong>Security</strong> at the top of the window<br>\n                        <strong>3. </strong> Uncheck the <strong>Block pop-up windows</strong> box.\n                    </div>',
          type: 'warning',
          disableOverlayClick: true,
          showXclose: true,
          useConfirmBtn: false,
          customCloseBtnText: 'OK'
        });
      } else if (this.deviceData.name === 'ios' && this.deviceData.os.indexOf('iOS') > -1) {
        this.$Simplert.open({
          title: 'Popup Blocked',
          message: '<div style="text-align: left; line-height: 25px;">\n                        <strong>1. </strong> Launch <strong>Settings</strong>.<br>\n                        <strong>2. </strong>  Tap <strong>Safari</strong>.<br>\n                        <strong>3. </strong> Under the <strong>General section</strong>, click the toggle next to <strong>Block Pop-ups</strong> to <strong>disable</strong> the pop-up blocker. A green toggle indicates an enabled pop-up blocker.\n                    </div>',
          type: 'warning',
          disableOverlayClick: true,
          showXclose: true,
          useConfirmBtn: false,
          customCloseBtnText: 'OK'
        });
      } else if (this.deviceData.name === 'firefox' && this.deviceData.os.indexOf('Mac') > -1) {
        this.$Simplert.open({
          title: 'Popup Blocked',
          message: '<div style="text-align: left; line-height: 25px;">\n                        <strong>1. </strong> Select <strong>Preferences</strong> from the <strong>Firefox</strong> menu.<br>\n                        <strong>2. </strong>  Choose the <strong>Content</strong> button.<br>\n                        <strong>3. </strong> Uncheck the <strong>Block pop-up windows</strong> box.\n                    </div>',
          type: 'warning',
          disableOverlayClick: true,
          showXclose: true,
          useConfirmBtn: false,
          customCloseBtnText: 'OK'
        });
      } else if (this.deviceData.name === 'firefox' && this.deviceData.os.indexOf('Windows') > -1) {
        this.$Simplert.open({
          title: 'Popup Blocked',
          message: '<div style="text-align: left; line-height: 25px;">\n                            <strong>1. </strong> Click the <strong>"hamburger" menu icon (top right) </strong> to open the Firefox menu.<br>\n                            <strong>2. </strong> Click <strong>Options</strong>.<br>\n                            <strong>3. </strong> Click <strong>Privacy & Security</strong> menu.<br>\n                            <strong>4. </strong> Under <strong>Permission</strong> menu make sure that <strong>Block pop-up windows</strong> is activated (checkbox).<br>\n                            <strong>5. </strong> Click the <strong>Exceptions</strong> button located to the right of Block pop-up windows.<br>\n                            <strong>6. </strong> You will see the Allowed Sites dialog box.<br>\n                            <strong>7. </strong> To enable add <strong>https://labotist.com</strong> and then click <strong>Allow</strong>\n                        </div>',
          type: 'warning',
          disableOverlayClick: true,
          showXclose: true,
          useConfirmBtn: false,
          customCloseBtnText: 'OK'
        });
      } else {
        this.$Simplert.open({
          title: 'Popup Blocked',
          message: 'Pop-up Blocker is enabled! Please add this site to your exception list.',
          type: 'warning',
          disableOverlayClick: true,
          showXclose: true,
          useConfirmBtn: false,
          customCloseBtnText: 'OK'
        });
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5779d93a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/Secure/MyResult.vue
var Secure_MyResult_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"MyResultDiv"}},[_c('HeaderVue',{attrs:{"isHeader":"true"}}),_vm._v(" "),_c('div',{staticClass:"container-fluid static-content"},[_vm._m(0,false,false),_vm._v(" "),_c('router-link',{staticClass:"w-100 referal-image",attrs:{"to":"/referral/invite"}},[_c('img',{staticClass:"responsive-result-image",attrs:{"src":"static/images/referral_mobile_banner.jpg","alt":""}})]),_vm._v(" "),_c('div',{staticClass:"row mt-3"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"report-list"},[_vm._l((_vm.limitBy(_vm.totalReports, _vm.reportLimit)),function(item,index){return _c('div',{key:index,staticClass:"report"},[_c('div',{staticClass:"label-data"},[_c('h6',{staticClass:"m-0 text-warning float-right"},[(item.requestStatus === -1)?_c('span',[_vm._v("Payment Pending")]):_vm._e(),_vm._v(" "),(item.requestStatus === -2)?_c('span',{staticClass:"text-danger"},[_vm._v("Payment Failure")]):_vm._e(),_vm._v(" "),(item.requestStatus === 0 || item.requestStatus === 2)?_c('span',{staticClass:"text-success "},[_vm._v("Requested")]):_vm._e(),_vm._v(" "),(item.requestStatus === 1 || item.requestStatus === 12)?_c('span',[_vm._v("Phelebotomist Accepted")]):_vm._e(),_vm._v(" "),(item.requestStatus === 3)?_c('span',[_vm._v("Sample Collected")]):_vm._e(),_vm._v(" "),(item.requestStatus === 4 || item.requestStatus === 5 || item.requestStatus === 7)?_c('span',{staticClass:" text-success"},[_vm._v("Sample Delivered to Lab")]):_vm._e(),_vm._v(" "),(item.requestStatus === 8)?_c('span',{staticClass:"text-danger"},[_vm._v("Cancelled")]):_vm._e(),_vm._v(" "),(item.requestStatus === 9)?_c('span',{staticClass:"text-secondary"},[_vm._v("Refund")]):_vm._e(),_vm._v(" "),(item.requestStatus === 11)?_c('span',{staticClass:"text-danger"},[_vm._v("Payment Processing")]):(item.requestStatus === 6)?_c('button',{staticClass:"btn btn-sm text-nowrap btn-primary",on:{"click":function($event){_vm.viewReport(item.requestId)}}},[_vm._v("View PDF")]):_vm._e()]),_vm._v(" "),_c('p',[_vm._v("\n                               Request No\n                            ")]),_vm._v(" "),_c('p',[_vm._v("\n                               REQ"+_vm._s(item.requestId)+"\n                            ")])]),_vm._v(" "),_c('div',{staticClass:"label-data"},[_c('p',[_vm._v("\n                                Patient Name\n                            ")]),_vm._v(" "),_c('p',[_vm._v("\n                                "+_vm._s(item.reqPatientFirstName+ ' '+ item.reqPatientLastName)+"\n                            ")])]),_vm._v(" "),_c('div',{staticClass:"label-data"},[_c('p',[_vm._v("\n                                Date/Time\n                            ")]),_vm._v(" "),_c('p',[_vm._v("\n                                "+_vm._s(_vm.formatDate((item.appointmentDate), 'dd/mm/yyyy'))),_c('br'),_vm._v("\n                                "+_vm._s(item.appointmentFromTime)+" - "+_vm._s(item.appointmentToTime)+"\n                            ")])]),_vm._v(" "),_c('div',{staticClass:"label-data"},[_c('p',[_vm._v("\n                                Test / Profile\n                            ")]),_vm._v(" "),_c('p',[_vm._v("\n                                "+_vm._s((item.requestTestList).join(', '))+"\n                            ")])]),_vm._v(" "),_c('div',{staticClass:"label-data"},[_c('p',[_vm._v("\n                                Lab Name / Locality\n                            ")]),_vm._v(" "),_c('p',[_vm._v("\n                                "+_vm._s(item.labName)),_c('br'),_vm._v(" "),_c('span',{staticClass:"grey-color"},[_vm._v(_vm._s(item.labLocation+', '+item.labCity+' - '+item.labZipcode))])])]),_vm._v(" "),_c('div',{staticClass:"label-data"},[_c('p',[_vm._v("\n                                Report Date\n                            ")]),_vm._v(" "),_c('p',[_vm._v("\n                               "+_vm._s((item.reportDeliveredDate)?(_vm.formatReportDate(item.reportDeliveredDate, 'dd/mm/yyyy hh:MM TT')):'-')+"\n                            ")])])])}),_vm._v(" "),(_vm.totalReports.length <= 0 && _vm.isLoading)?_c('div',{staticClass:"col-12"},[_c('span',[_vm._v("Loading ")])]):_vm._e(),_vm._v(" "),(_vm.totalReports.length <= 0 && !_vm.isLoading)?_c('div',{staticClass:"col-12"},[_c('span',[_vm._v(" No records found ")])]):_vm._e()],2)])]),_vm._v(" "),_c('div',{staticClass:"col-sm-12",staticStyle:{"text-align":"center !important","padding-bottom":"8%"}},[(_vm.totalReports.length > _vm.reportLimit)?_c('button',{staticClass:"btn btn-outline-primary align-center",on:{"click":function($event){_vm.loadMore()}}},[_vm._v("Show more Results("+_vm._s(_vm.totalReports.length - _vm.reportLimit)+")")]):_vm._e()])],1),_vm._v(" "),_c('FooterVue'),_vm._v(" "),_c('pdfviewer',{attrs:{"pdfurl":_vm.pdfurls,"maxscale":4,"minscale":0.5,"scale":0.5,"desiredWidth":2},on:{"closepdf":_vm.closepdf,"pdferr":_vm.pdferr},model:{value:(_vm.isshowpdf),callback:function ($$v) {_vm.isshowpdf=$$v},expression:"isshowpdf"}})],1)}
var Secure_MyResult_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"signup-title"},[_c('h4',{staticClass:"mt-0 mb-0 text-center"},[_vm._v("My Results")])])])])}]
var Secure_MyResult_esExports = { render: Secure_MyResult_render, staticRenderFns: Secure_MyResult_staticRenderFns }
/* harmony default export */ var components_mobile_Secure_MyResult = (Secure_MyResult_esExports);
// CONCATENATED MODULE: ./src/components/mobile/Secure/MyResult.vue
var Secure_MyResult_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var Secure_MyResult___vue_template_functional__ = false
/* styles */
var Secure_MyResult___vue_styles__ = null
/* scopeId */
var Secure_MyResult___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Secure_MyResult___vue_module_identifier__ = null
var Secure_MyResult_Component = Secure_MyResult_normalizeComponent(
  mobile_Secure_MyResult,
  components_mobile_Secure_MyResult,
  Secure_MyResult___vue_template_functional__,
  Secure_MyResult___vue_styles__,
  Secure_MyResult___vue_scopeId__,
  Secure_MyResult___vue_module_identifier__
)

/* harmony default export */ var src_components_mobile_Secure_MyResult = (Secure_MyResult_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/Secure/MyProfile.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




// import Datepicker from 'vuejs-datepicker'


/* harmony default export */ var mobile_Secure_MyProfile = ({
  name: 'MyProfile',
  props: [],
  components: {
    HeaderVue: mobile_Header["a" /* default */],
    FooterVue: mobile_Footer["a" /* default */]
  },
  beforeCreate: function beforeCreate() {
    if (!this.$localStorage.get('loggedIn') || this.$localStorage.get('loggedIn') === null) {
      this.$router.push({ path: '/' });
    }
  },
  data: function data() {
    return {
      firstName: '',
      lastName: '',
      email: '',
      phone1: '',
      phone2: '',
      dob: '',
      sex: '',
      photo: '',
      address: {},
      oldPassword: '',
      newPassword: '',
      confirmPassword: '',
      error: false,
      errormsg: '',
      isDobError: false,
      disabled: {
        from: new Date()
      },
      dobYears: [],
      dobDate: [],
      year: '',
      month: '',
      ddate: '',
      isMobileError: false,
      mobileErrorMsg: '',
      isError: false,
      creditPoint: undefined,
      referralCode: '',
      tick: false,
      referralUrl: '',
      credits: ''
    };
  },
  mounted: function mounted() {
    this.getProfile();
    $('input[data-toggle="tooltip"]').tooltip({
      animated: 'fade',
      placement: 'bottom',
      trigger: 'manual'
    });
  },

  watch: {
    referralUrl: function referralUrl() {
      this.referralUrl = this.$signupUrl + this.referralCode.toLowerCase();
    }
  },
  created: function created() {
    var year = new Date().getFullYear();
    var endYear = year - 120;
    for (var i = year; i > endYear; i--) {
      this.dobYears.push(i.toString());
    }
  },

  methods: {
    copyReferralCodeUrl: function copyReferralCodeUrl() {
      setTimeout(function () {
        this.$refs.copyReferralText.setSelectionRange(0, this.referralUrl.length);
        document.execCommand("copy");
        $('input[data-toggle="tooltip"]').tooltip("show");
        setTimeout(function () {
          $('input[data-toggle="tooltip"]').tooltip("hide");
        }, 1000);
      }.bind(this), 100);
    },
    // getProfile: function () {
    //   try {
    //     if (this.$localStorage.get('loggedIn') === 'true' && this.$localStorage.get('access_token') !== '') {
    //       var data = {}
    //       Promise.resolve(this.$GET('patient/getProfile', data)).then(function (res) {
    //         if (res.response_code === 0) {
    //           if (res.response) {
    //             _.each(res.response.Addresses, function (item) {
    //               if (item.isDefault === 1) {
    //                 this.address = item.address
    //               }
    //             })
    //           }
    //           this.firstName = res.response.Patient.firstName
    //           this.lastName = res.response.Patient.lastName
    //           this.email = res.response.email
    //           this.phone1 = res.response.Patient.phone1
    //           this.phone2 = res.response.Patient.phone2
    //           this.dob = res.response.Patient.dob ? res.response.Patient.dob : ''
    //           this.sex = res.response.Patient.sex
    //         }
    //         this.$hidePageLoading()
    //       }.bind(this)).catch(function (err) {
    //         console.error(err)
    //       })
    //     }
    //   } catch (e) {
    //     console.error('method:getProfile', e)
    //   }
    // },
    savePassword: function savePassword() {
      var _this = this;

      this.$validator.validateAll('password').then(function (result) {
        if (result) {
          try {
            _this.error = false;
            _this.errormsg = '';
            var data = {
              'oldPassword': _this.oldPassword,
              'newPassword': _this.newPassword
            };
            promise_default.a.resolve(_this.$POST('patient/changePassword', data)).then(function (res) {
              if (res.response_code === 0) {
                this.$router.push({ path: '/myprofile' });
              } else {
                this.error = true;
                this.errormsg = res.response_message;
              }
            }.bind(_this)).catch(function (err) {
              console.error(err);
            });
          } catch (e) {
            console.error('method:save_password', e);
          }
        }
      });
    },
    getNumberOfDays: function getNumberOfDays(dateVal) {
      if (this.year && this.year !== '' && this.month && this.month !== '') {
        var noOfDays = new Date(this.year, this.month, 0).getDate();
        this.dobDate = [];
        for (var j = 1; j <= noOfDays; j++) {
          this.dobDate.push(j.toString());
        }
        if (dateVal) {
          this.ddate = dateVal;
        } else {
          if (this.ddate) {
            var res = true;
            this.dobDate.forEach(function (dataV) {
              if (parseInt(dataV) === parseInt(this.ddate)) {
                res = false;
              }
            }.bind(this));
            if (res) {
              this.ddate = '';
            }
          }
        }
      }
      return false;
    },
    saveProfile: function saveProfile() {
      var _this2 = this;

      this.isDobError = false;
      this.isMobileError = false;
      this.isError = false;
      this.$validator.validateAll('edit').then(function (result) {
        if (result) {
          if (_this2.year.length !== 4 || _this2.month.length <= 0 || _this2.ddate.length <= 0) {
            _this2.isDobError = true;
            return false;
          }
          try {
            var data = {
              'firstName': _this2.firstName,
              'lastName': _this2.lastName,
              'phone1': _this2.phone1,
              'phone2': _this2.phone2,
              'photo': '',
              'sex': _this2.sex,
              'dob': _this2.year + '-' + _this2.month + '-' + _this2.ddate,
              'panNo': '',
              'aadharNo': '',
              'drivingLicenceNo': ''
            };
            console.log(data);
            promise_default.a.resolve(_this2.$POST('patient/updateProfile', data)).then(function (res) {
              if (res.response_code === 0) {
                this.$localStorage.remove('profile');
                var userDetails = {
                  'username': this.firstName + ' ' + this.lastName,
                  'firstName': this.firstName,
                  'lastName': this.lastName,
                  'phone1': this.phone1,
                  'dob': dateformat_default()(this.dob, 'yyyy-mm-dd', true),
                  'photo': ''
                };
                this.$localStorage.set('profile', userDetails, 0);
                // this.$router.push({path : '/myprofile'})
                $('#editProfile').modal('toggle');
              } else if (res.response_code === 4) {
                this.isMobileError = true;
                this.mobileErrorMsg = res.response_message;
                this.$refs.mobile.focus();
              } else if (res.response_code === 2) {
                this.isError = true;
              }
            }.bind(_this2)).catch(function (err) {
              console.error(err);
            });
          } catch (e) {
            console.error('method:saveProfile', e);
          }
        }
      });
    },
    getProfile: function getProfile() {
      try {
        if (this.$localStorage.get('loggedIn') && this.$localStorage.get('access_token') && this.$localStorage.get('access_token') !== null) {
          var data = {};
          promise_default.a.resolve(this.$GET('patient/getProfile', data)).then(function (res) {
            if (res.response_code === 0) {
              if (res.response) {
                underscore_default.a.each(res.response.Addresses, function (item) {
                  if (item.isDefault === 1) {
                    this.address = item.address;
                  }
                });
              }
              this.firstName = res.response.Patient.firstName;
              this.lastName = res.response.Patient.lastName;
              this.email = res.response.email;
              this.phone1 = res.response.Patient.phone1;
              this.phone2 = res.response.Patient.phone2;
              this.dob = res.response.Patient.dob ? res.response.Patient.dob : undefined;
              this.sex = res.response.Patient.sex;
              this.creditPoint = res.response.Patient.creditPoint;
              this.referralCode = res.response.Patient.referralCode;
              this.credits = res.response.credits;
              if (res.response.Patient.dob && res.response.Patient.dob !== null) {
                var dob = res.response.Patient.dob.split('T');
                var dobDate = dob[0].split('-');
                this.year = dobDate[0];
                this.month = dobDate[1];
                this.getNumberOfDays(dobDate[2]);
              }
            }
            this.referralUrl = this.$signupUrl + this.referralCode.toLowerCase();
            this.$hidePageLoading();
          }.bind(this)).catch(function (err) {
            console.error(err);
          });
        }
      } catch (e) {
        console.error('method:getProfile', e);
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3d4b935a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/Secure/MyProfile.vue
var Secure_MyProfile_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"MyProfileDiv"}},[_c('HeaderVue',{attrs:{"isHeader":"true"}}),_vm._v(" "),_c('div',{staticClass:"container-fluid static-content"},[_vm._m(0,false,false),_vm._v(" "),_c('div',{staticClass:"row mt-3"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"form-content line-textbox"},[_c('div',{staticClass:"d-flex credit-box"},[_c('div',{staticClass:"credit-points"},[_c('div',{staticClass:"d-flex"},[_c('div',{staticClass:"pr-3"},[_c('h1',{staticClass:"m-0"},[_vm._v(_vm._s(_vm.creditPoint))]),_vm._v(" "),_c('p',[_vm._v("Credits")])]),_vm._v(" "),_c('div',{staticClass:"referral-code"},[_c('h3',{staticClass:"m-0"},[_vm._v(_vm._s(_vm.referralCode))]),_vm._v(" "),_c('h6',[_vm._v("Referral Code")])])]),_vm._v(" "),_vm._m(1,false,false)])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('router-link',{attrs:{"to":"/referral/invite"}},[_c('button',{staticClass:"btn btn-outline-primary w-100 mb-3"},[_vm._v("Refer & Earn")])]),_vm._v(" "),_c('label',[_vm._v(_vm._s(_vm.firstName + ' ' + _vm.lastName))]),_vm._v(" "),_c('label',[_vm._v(_vm._s(_vm.email))]),_vm._v(" "),_c('label',[_vm._v(_vm._s(_vm.phone1))]),_vm._v(" "),_c('a',{attrs:{"href":"#","data-toggle":"modal","data-target":"#changePassword"}},[_vm._v("Change Password")]),_vm._v(" "),_vm._m(2,false,false)],1)])])]),_vm._v(" "),_vm._m(3,false,false),_vm._v(" "),_c('FooterVue'),_vm._v(" "),_c('div',{staticClass:"modal fade",attrs:{"id":"changePassword","tabindex":"-1","role":"dialog","aria-labelledby":"changePasswordLabel","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_vm._m(4,false,false),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('form',{attrs:{"data-vv-scope":"password"}},[_c('div',{staticClass:"form-content line-textbox"},[(_vm.error)?_c('p',{staticClass:"no-mar-top red-color"},[_vm._v(_vm._s(_vm.errormsg))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Type Current Password")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.oldPassword),expression:"oldPassword"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"form-control",attrs:{"type":"password","name":"oldPassword","data-vv-as":"current password"},domProps:{"value":(_vm.oldPassword)},on:{"input":function($event){if($event.target.composing){ return; }_vm.oldPassword=$event.target.value}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('password.oldPassword')),expression:"errors.has('password.oldPassword')"}],staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('password.oldPassword')))])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Type New Password")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.newPassword),expression:"newPassword"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"form-control",attrs:{"type":"password","name":"newPassword","data-vv-as":"new password"},domProps:{"value":(_vm.newPassword)},on:{"input":function($event){if($event.target.composing){ return; }_vm.newPassword=$event.target.value}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('password.newPassword')),expression:"errors.has('password.newPassword')"}],staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('password.newPassword')))])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Retype New Password")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.confirmPassword),expression:"confirmPassword"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"form-control",attrs:{"type":"password","name":"confirmPassword","data-vv-as":"retype new password"},domProps:{"value":(_vm.confirmPassword)},on:{"input":function($event){if($event.target.composing){ return; }_vm.confirmPassword=$event.target.value}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('password.confirmPassword')),expression:"errors.has('password.confirmPassword')"}],staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('password.confirmPassword')))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.confirmPassword !== '' && _vm.newPassword !== _vm.confirmPassword),expression:"confirmPassword !== '' && newPassword !== confirmPassword"}],staticClass:"text-danger"},[_vm._v("The retype new password confirmation does not match")])]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary full-width",attrs:{"data-dismiss":"modal","aria-label":"Close","disabled":(_vm.errors.any())},on:{"click":function($event){$event.preventDefault();_vm.savePassword()}}},[_vm._v("CHANGE PASSWORD")])])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal fade",attrs:{"id":"editProfile","tabindex":"-1","role":"dialog","aria-labelledby":"editProfileLabel","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_vm._m(5,false,false),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('form',{attrs:{"data-vv-scope":"edit"}},[_c('div',{staticClass:"clearfix line-textbox mt-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("First Name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.firstName),expression:"firstName"},{name:"validate",rawName:"v-validate",value:('required|alpha_spaces|min:3|max:50'),expression:"'required|alpha_spaces|min:3|max:50'"}],staticClass:"form-control",attrs:{"type":"text","name":"firstName","data-vv-as":"first name","maxlength":"50"},domProps:{"value":(_vm.firstName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.firstName=$event.target.value}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('edit.firstName')),expression:"errors.has('edit.firstName')"}],staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('edit.firstName')))])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Last Name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.lastName),expression:"lastName"},{name:"validate",rawName:"v-validate",value:('required|alpha_spaces|min:3|max:50'),expression:"'required|alpha_spaces|min:3|max:50'"}],staticClass:"form-control",attrs:{"name":"lastName","type":"text","data-vv-as":"last name","maxlength":"50"},domProps:{"value":(_vm.lastName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.lastName=$event.target.value}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('edit.lastName')),expression:"errors.has('edit.lastName')"}],staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('edit.lastName')))])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Gender")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"form-check form-check-inline"},[_c('label',{staticClass:"form-check-label"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.sex),expression:"sex"}],staticClass:"form-check-input",attrs:{"type":"radio","name":"gender","id":"inlineRadio1","value":"M"},domProps:{"checked":(_vm.sex === 'M')?true:false,"checked":_vm._q(_vm.sex,"M")},on:{"change":function($event){_vm.sex="M"}}}),_vm._v(" Male\n                                ")])]),_vm._v(" "),_c('div',{staticClass:"form-check form-check-inline"},[_c('label',{staticClass:"form-check-label"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.sex),expression:"sex"}],staticClass:"form-check-input",attrs:{"type":"radio","name":"gender","id":"inlineRadio2","value":"F"},domProps:{"checked":(_vm.sex === 'F')?true:false,"checked":_vm._q(_vm.sex,"F")},on:{"change":function($event){_vm.sex="F"}}}),_vm._v(" Female\n                                ")])]),_vm._v(" "),_c('div',{staticClass:"form-check form-check-inline"},[_c('label',{staticClass:"form-check-label"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.sex),expression:"sex"}],staticClass:"form-check-input",attrs:{"type":"radio","name":"gender","id":"inlineRadio3","value":"O"},domProps:{"checked":(_vm.sex === 'O')?true:false,"checked":_vm._q(_vm.sex,"O")},on:{"change":function($event){_vm.sex="O"}}}),_vm._v(" Other\n                                ")])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Date of birth")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-4"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.year),expression:"year"}],staticClass:"form-control",attrs:{"name":"year","id":"year"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.year=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){_vm.getNumberOfDays()}]}},[_c('option',{staticClass:"dobOptionColor",attrs:{"value":"","disabled":"","selected":""}},[_vm._v("YYYY")]),_vm._v(" "),_vm._l((_vm.dobYears),function(dobYear,index){return _c('option',{key:index,domProps:{"value":dobYear}},[_vm._v(_vm._s(dobYear))])})],2)]),_vm._v(" "),_c('div',{staticClass:"col-4"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.month),expression:"month"}],staticClass:"form-control",attrs:{"name":"month","id":"month"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.month=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){_vm.getNumberOfDays()}]}},[_c('option',{staticClass:"dobOptionColor",attrs:{"value":"","disabled":"","selected":""}},[_vm._v("MMM")]),_vm._v(" "),_c('option',{attrs:{"value":"01"}},[_vm._v("Jan")]),_vm._v(" "),_c('option',{attrs:{"value":"02"}},[_vm._v("Feb")]),_vm._v(" "),_c('option',{attrs:{"value":"03"}},[_vm._v("Mar")]),_vm._v(" "),_c('option',{attrs:{"value":"04"}},[_vm._v("Apr")]),_vm._v(" "),_c('option',{attrs:{"value":"05"}},[_vm._v("May")]),_vm._v(" "),_c('option',{attrs:{"value":"06"}},[_vm._v("Jun")]),_vm._v(" "),_c('option',{attrs:{"value":"07"}},[_vm._v("Jul")]),_vm._v(" "),_c('option',{attrs:{"value":"08"}},[_vm._v("Aug")]),_vm._v(" "),_c('option',{attrs:{"value":"09"}},[_vm._v("Sep")]),_vm._v(" "),_c('option',{attrs:{"value":"10"}},[_vm._v("Oct")]),_vm._v(" "),_c('option',{attrs:{"value":"11"}},[_vm._v("Nov")]),_vm._v(" "),_c('option',{attrs:{"value":"12"}},[_vm._v("Dec")])])]),_vm._v(" "),_c('div',{staticClass:"col-4"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.ddate),expression:"ddate"}],staticClass:"form-control",attrs:{"name":"ddate","id":"ddate"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.ddate=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{staticClass:"dobOptionColor",attrs:{"value":"","disabled":"","selected":""}},[_vm._v("DD")]),_vm._v(" "),_vm._l((_vm.dobDate),function(dobDateVal,index){return _c('option',{key:index,domProps:{"value":dobDateVal ? (parseInt(dobDateVal) < 10 ? '0'+dobDateVal : dobDateVal) : ''}},[_vm._v(_vm._s(dobDateVal ? (parseInt(dobDateVal) < 10 ? '0'+dobDateVal : dobDateVal) : ''))])})],2)]),_vm._v(" "),_c('div',{staticClass:"col-sm-12"},[(_vm.isDobError)?_c('span',{staticClass:"text-danger"},[_vm._v("The date of birth field is required")]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Email")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email),expression:"email"},{name:"validate",rawName:"v-validate",value:('required|email|max:100'),expression:"'required|email|max:100'"}],staticClass:"form-control",staticStyle:{"background-color":"#fff","cursor":"not-allowed"},attrs:{"type":"email","name":"email","data-vv-as":"email address","disabled":true},domProps:{"value":(_vm.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.email=$event.target.value}}}),_vm._v(" "),_c('i',{staticClass:"fa",staticStyle:{"font-size":"18px","color":"#000","text-align":"right","float":"right","margin-top":"-25px","margin-right":"10px"}},[_vm._v("")]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('edit.email')),expression:"errors.has('edit.email')"}],staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('edit.email')))])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Mobile")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.phone1),expression:"phone1"},{name:"validate",rawName:"v-validate",value:('required|numeric|min:10|max:10'),expression:"'required|numeric|min:10|max:10'"}],ref:"mobile",staticClass:"form-control",attrs:{"type":"text","name":"phone1","data-vv-as":"mobile no."},domProps:{"value":(_vm.phone1)},on:{"input":function($event){if($event.target.composing){ return; }_vm.phone1=$event.target.value}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('edit.phone1')),expression:"errors.has('edit.phone1')"}],staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('edit.phone1')))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.isMobileError),expression:"isMobileError"}],staticClass:"text-danger"},[_vm._v(_vm._s(_vm.mobileErrorMsg))])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Alternate Phone No.")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.phone2),expression:"phone2"},{name:"validate",rawName:"v-validate",value:('numeric|min:10|max:10'),expression:"'numeric|min:10|max:10'"}],staticClass:"form-control",attrs:{"type":"text","name":"phone2","data-vv-as":"alternate phone no."},domProps:{"value":(_vm.phone2)},on:{"input":function($event){if($event.target.composing){ return; }_vm.phone2=$event.target.value}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('edit.phone2')),expression:"errors.has('edit.phone2')"}],staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('edit.phone2')))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.isError),expression:"isError"}],staticClass:"text-danger"},[_vm._v(_vm._s('Sorry something went wrong try again'))])]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary full-width",attrs:{"disabled":(_vm.errors.any())},on:{"click":function($event){$event.preventDefault();_vm.saveProfile()}}},[_vm._v("Update")])])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal fade bd-example-modal-sm",attrs:{"id":"inviteFriends","tabindex":"-1","role":"dialog","aria-labelledby":"exampleModalLabel","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog modal-sm",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_vm._m(6,false,false),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('p',{staticClass:"grey-color"},[_vm._v("\n                  Copy & share the link to your friends & family to earn Rs."+_vm._s(_vm.credits)+" worth of Labotist credits, when each referral completes an order through Labotist. Your friend or family member will also earn Labotist credits which they can immediately use.\n                ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.referralUrl),expression:"referralUrl"}],ref:"copyReferralText",staticClass:"copy-link",attrs:{"type":"text","name":"copyReferralText","id":"copyReferralText","data-toggle":"tooltip","data-placement":"top","title":"Copied"},domProps:{"value":(_vm.referralUrl)},on:{"focus":function($event){_vm.copyReferralCodeUrl()},"click":function($event){_vm.copyReferralCodeUrl()},"input":function($event){if($event.target.composing){ return; }_vm.referralUrl=$event.target.value}}})]),_vm._v(" "),_vm._m(7,false,false)])])])],1)}
var Secure_MyProfile_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"signup-title"},[_c('h4',{staticClass:"mt-0 mb-0"},[_vm._v("My Account")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h1',{staticClass:"credit-icon"},[_c('i',{staticClass:"fa fa-certificate"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row mt-3 mb-3"},[_c('div',{staticClass:"col-12"},[_c('button',{staticClass:"btn btn-primary full-width",attrs:{"data-toggle":"modal","data-target":"#editProfile"}},[_vm._v("Edit")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contact-info"},[_c('div',{staticClass:"container"},[_c('ul',{staticClass:"row text-center"},[_c('li',[_c('span',{staticClass:"sprites sprite-mail align-center"}),_vm._v(" "),_c('p',[_c('a',{attrs:{"href":"mailto:support@labotist.com","target":"_top"}},[_vm._v(" support@labotist.com ")])])]),_vm._v(" "),_c('li',[_c('span',{staticClass:"sprites sprite-call align-center"}),_vm._v(" "),_c('p',[_c('a',{attrs:{"href":"tel:+919025662566"}},[_vm._v("+91 90256 62566")])])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-header"},[_c('button',{staticClass:"close black-color",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("\n                        ×\n                    ")])]),_vm._v(" "),_c('h5',{staticClass:"modal-title",attrs:{"id":"changePasswordLabel"}},[_vm._v("\n                    Change Password\n                ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-header"},[_c('button',{staticClass:"close black-color",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("\n                        ×\n                    ")])]),_vm._v(" "),_c('h5',{staticClass:"modal-title",attrs:{"id":"editProfileLabel"}},[_vm._v("\n                    Edit Profile\n                ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-header"},[_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{staticClass:"material-icons"},[_vm._v("arrow_back")])]),_vm._v(" "),_c('h5',{staticClass:"modal-title",attrs:{"id":"exampleModalLabel"}},[_vm._v("Refer and earn credit points")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-dismiss":"modal"}},[_vm._v("Close")])])}]
var Secure_MyProfile_esExports = { render: Secure_MyProfile_render, staticRenderFns: Secure_MyProfile_staticRenderFns }
/* harmony default export */ var components_mobile_Secure_MyProfile = (Secure_MyProfile_esExports);
// CONCATENATED MODULE: ./src/components/mobile/Secure/MyProfile.vue
function Secure_MyProfile_injectStyle (ssrContext) {
  __webpack_require__("yst5")
}
var Secure_MyProfile_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var Secure_MyProfile___vue_template_functional__ = false
/* styles */
var Secure_MyProfile___vue_styles__ = Secure_MyProfile_injectStyle
/* scopeId */
var Secure_MyProfile___vue_scopeId__ = "data-v-3d4b935a"
/* moduleIdentifier (server only) */
var Secure_MyProfile___vue_module_identifier__ = null
var Secure_MyProfile_Component = Secure_MyProfile_normalizeComponent(
  mobile_Secure_MyProfile,
  components_mobile_Secure_MyProfile,
  Secure_MyProfile___vue_template_functional__,
  Secure_MyProfile___vue_styles__,
  Secure_MyProfile___vue_scopeId__,
  Secure_MyProfile___vue_module_identifier__
)

/* harmony default export */ var src_components_mobile_Secure_MyProfile = (Secure_MyProfile_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/Secure/EditProfile.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var mobile_Secure_EditProfile = ({
  name: 'EditProfile',
  components: {
    HeaderVue: mobile_Header["a" /* default */],
    FooterVue: mobile_Footer["a" /* default */],
    Datepicker: build_default.a
  },
  beforeCreate: function beforeCreate() {
    if (!this.$localStorage.get('loggedIn') || this.$localStorage.get('loggedIn') === null) {
      this.$router.push({ path: '/' });
    }
  },
  data: function data() {
    return {
      isDobError: false,
      firstName: '',
      lastName: '',
      email: '',
      phone1: '',
      phone2: '',
      dob: undefined,
      sex: '',
      photo: '',
      address: {},
      disabled: {
        from: new Date()
      },
      dobYears: [],
      dobDate: [],
      year: '',
      month: '',
      ddate: '',
      isMobileError: false,
      mobileErrorMsg: '',
      isError: false
    };
  },
  created: function created() {
    var year = new Date().getFullYear();
    var endYear = year - 120;
    for (var i = year; i > endYear; i--) {
      this.dobYears.push(i.toString());
    }
  },
  mounted: function mounted() {
    this.getProfile();
  },

  methods: {
    getNumberOfDays: function getNumberOfDays(dateVal) {
      if (this.year && this.year !== '' && this.month && this.month !== '') {
        var noOfDays = new Date(this.year, this.month, 0).getDate();
        this.dobDate = [];
        for (var j = 1; j <= noOfDays; j++) {
          this.dobDate.push(j.toString());
        }
        if (dateVal) {
          this.ddate = dateVal;
        } else {
          if (this.ddate) {
            var res = true;
            this.dobDate.forEach(function (dataV) {
              if (parseInt(dataV) === parseInt(this.ddate)) {
                res = false;
              }
            }.bind(this));
            if (res) {
              this.ddate = '';
            }
          }
        }
      }
      return false;
    },
    saveProfile: function saveProfile() {
      var _this = this;

      this.isDobError = false;
      this.isMobileError = false;
      this.isError = false;
      this.$validator.validateAll('edit').then(function (result) {
        if (result) {
          if (_this.year.length !== 4 || _this.month.length <= 0 || _this.ddate.length <= 0) {
            _this.isDobError = true;
            return false;
          }
          try {
            var data = {
              'firstName': _this.firstName,
              'lastName': _this.lastName,
              'phone1': _this.phone1,
              'phone2': _this.phone2,
              'photo': '',
              'sex': _this.sex,
              'dob': _this.year + '-' + _this.month + '-' + _this.ddate,
              'panNo': '',
              'aadharNo': '',
              'drivingLicenceNo': ''
            };
            console.log(data);
            promise_default.a.resolve(_this.$POST('patient/updateProfile', data)).then(function (res) {
              if (res.response_code === 0) {
                this.$localStorage.remove('profile');
                var userDetails = {
                  'username': this.firstName + ' ' + this.lastName,
                  'firstName': this.firstName,
                  'lastName': this.lastName,
                  'phone1': this.phone1,
                  'dob': dateformat_default()(this.dob, 'yyyy-mm-dd', true),
                  'photo': ''
                };
                this.$localStorage.set('profile', userDetails, 0);
                this.$router.push({ path: '/myprofile' });
              } else if (res.response_code === 4) {
                this.isMobileError = true;
                this.mobileErrorMsg = res.response_message;
                this.$refs.mobile.focus();
              } else if (res.response_code === 2) {
                this.isError = true;
              }
            }.bind(_this)).catch(function (err) {
              console.error(err);
            });
          } catch (e) {
            console.error('method:saveProfile', e);
          }
        }
      });
    },
    getProfile: function getProfile() {
      try {
        if (this.$localStorage.get('loggedIn') && this.$localStorage.get('access_token') && this.$localStorage.get('access_token') !== null) {
          var data = {};
          promise_default.a.resolve(this.$GET('patient/getProfile', data)).then(function (res) {
            if (res.response_code === 0) {
              if (res.response) {
                underscore_default.a.each(res.response.Addresses, function (item) {
                  if (item.isDefault === 1) {
                    this.address = item.address;
                  }
                });
              }
              this.firstName = res.response.Patient.firstName;
              this.lastName = res.response.Patient.lastName;
              this.email = res.response.email;
              this.phone1 = res.response.Patient.phone1;
              this.phone2 = res.response.Patient.phone2;
              this.dob = res.response.Patient.dob ? res.response.Patient.dob : undefined;
              this.sex = res.response.Patient.sex;
              if (res.response.Patient.dob && res.response.Patient.dob !== null) {
                var dob = res.response.Patient.dob.split('T');
                var dobDate = dob[0].split('-');
                this.year = dobDate[0];
                this.month = dobDate[1];
                this.getNumberOfDays(dobDate[2]);
              }
            }
            this.$hidePageLoading();
          }.bind(this)).catch(function (err) {
            console.error(err);
          });
        }
      } catch (e) {
        console.error('method:getProfile', e);
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ab9de096","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/Secure/EditProfile.vue
var Secure_EditProfile_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"EditProfileDiv"}},[_c('HeaderVue',{attrs:{"isHeader":"true"}}),_vm._v(" "),_c('div',{staticClass:"inner-page phleb-signup my-profile"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-8 offset-lg-2 col-sm-8 offset-sm-2"},[_c('div',{staticClass:"sign-up"},[_vm._m(0,false,false),_vm._v(" "),_c('div',{staticClass:"form-content line-textbox"},[_c('form',{attrs:{"data-vv-scope":"edit"}},[_c('div',{staticClass:"clearfix mt-4"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("First Name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.firstName),expression:"firstName"},{name:"validate",rawName:"v-validate",value:('required|alpha_spaces|min:3|max:50'),expression:"'required|alpha_spaces|min:3|max:50'"}],staticClass:"form-control",attrs:{"type":"text","name":"firstName","data-vv-as":"first name","maxlength":"50"},domProps:{"value":(_vm.firstName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.firstName=$event.target.value}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('edit.firstName')),expression:"errors.has('edit.firstName')"}],staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('edit.firstName')))])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Last Name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.lastName),expression:"lastName"},{name:"validate",rawName:"v-validate",value:('required|alpha_spaces|min:3|max:50'),expression:"'required|alpha_spaces|min:3|max:50'"}],staticClass:"form-control",attrs:{"name":"lastName","type":"text","data-vv-as":"last name","maxlength":"50"},domProps:{"value":(_vm.lastName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.lastName=$event.target.value}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('edit.lastName')),expression:"errors.has('edit.lastName')"}],staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('edit.lastName')))])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Gender")]),_vm._v(" "),_c('div',{staticClass:"form-check form-check-inline",staticStyle:{"margin-top":"15px","margin-bottom":"0px"}},[_c('label',{staticClass:"form-check-label"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.sex),expression:"sex"}],staticClass:"form-check-input",attrs:{"type":"radio","name":"gender","id":"inlineRadio1","value":"M"},domProps:{"checked":(_vm.sex === 'M')?true:false,"checked":_vm._q(_vm.sex,"M")},on:{"change":function($event){_vm.sex="M"}}}),_vm._v(" Male\n                                                  ")])]),_vm._v(" "),_c('div',{staticClass:"form-check form-check-inline",staticStyle:{"margin-top":"15px","margin-bottom":"0px"}},[_c('label',{staticClass:"form-check-label"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.sex),expression:"sex"}],staticClass:"form-check-input",attrs:{"type":"radio","name":"gender","id":"inlineRadio2","value":"F"},domProps:{"checked":(_vm.sex === 'F')?true:false,"checked":_vm._q(_vm.sex,"F")},on:{"change":function($event){_vm.sex="F"}}}),_vm._v(" Female\n                                                  ")])]),_vm._v(" "),_c('div',{staticClass:"form-check form-check-inline",staticStyle:{"margin-top":"15px","margin-bottom":"0px"}},[_c('label',{staticClass:"form-check-label"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.sex),expression:"sex"}],staticClass:"form-check-input",attrs:{"type":"radio","name":"gender","id":"inlineRadio3","value":"O"},domProps:{"checked":(_vm.sex === 'O')?true:false,"checked":_vm._q(_vm.sex,"O")},on:{"change":function($event){_vm.sex="O"}}}),_vm._v(" Other\n                                                  ")])])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Date of birth")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-4"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.year),expression:"year"}],staticClass:"form-control",attrs:{"name":"year","id":"year"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.year=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){_vm.getNumberOfDays()}]}},[_c('option',{staticClass:"dobOptionColor",attrs:{"value":"","disabled":"","selected":""}},[_vm._v("YYYY")]),_vm._v(" "),_vm._l((_vm.dobYears),function(dobYear,index){return _c('option',{key:index,domProps:{"value":dobYear}},[_vm._v(_vm._s(dobYear))])})],2)]),_vm._v(" "),_c('div',{staticClass:"col-4"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.month),expression:"month"}],staticClass:"form-control",attrs:{"name":"month","id":"month"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.month=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){_vm.getNumberOfDays()}]}},[_c('option',{staticClass:"dobOptionColor",attrs:{"value":"","disabled":"","selected":""}},[_vm._v("MMM")]),_vm._v(" "),_c('option',{attrs:{"value":"01"}},[_vm._v("Jan")]),_vm._v(" "),_c('option',{attrs:{"value":"02"}},[_vm._v("Feb")]),_vm._v(" "),_c('option',{attrs:{"value":"03"}},[_vm._v("Mar")]),_vm._v(" "),_c('option',{attrs:{"value":"04"}},[_vm._v("Apr")]),_vm._v(" "),_c('option',{attrs:{"value":"05"}},[_vm._v("May")]),_vm._v(" "),_c('option',{attrs:{"value":"06"}},[_vm._v("Jun")]),_vm._v(" "),_c('option',{attrs:{"value":"07"}},[_vm._v("Jul")]),_vm._v(" "),_c('option',{attrs:{"value":"08"}},[_vm._v("Aug")]),_vm._v(" "),_c('option',{attrs:{"value":"09"}},[_vm._v("Sep")]),_vm._v(" "),_c('option',{attrs:{"value":"10"}},[_vm._v("Oct")]),_vm._v(" "),_c('option',{attrs:{"value":"11"}},[_vm._v("Nov")]),_vm._v(" "),_c('option',{attrs:{"value":"12"}},[_vm._v("Dec")])])]),_vm._v(" "),_c('div',{staticClass:"col-4"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.ddate),expression:"ddate"}],staticClass:"form-control",attrs:{"name":"ddate","id":"ddate"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.ddate=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{staticClass:"dobOptionColor",attrs:{"value":"","disabled":"","selected":""}},[_vm._v("DD")]),_vm._v(" "),_vm._l((_vm.dobDate),function(dobDateVal,index){return _c('option',{key:index,domProps:{"value":dobDateVal ? (parseInt(dobDateVal) < 10 ? '0'+dobDateVal : dobDateVal) : ''}},[_vm._v(_vm._s(dobDateVal ? (parseInt(dobDateVal) < 10 ? '0'+dobDateVal : dobDateVal) : ''))])})],2)]),_vm._v(" "),_c('div',{staticClass:"col-sm-12"},[(_vm.isDobError)?_c('span',{staticClass:"text-danger"},[_vm._v("The date of birth field is required")]):_vm._e()])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Mobile")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.phone1),expression:"phone1"},{name:"validate",rawName:"v-validate",value:('required|numeric|min:10|max:10'),expression:"'required|numeric|min:10|max:10'"}],ref:"mobile",staticClass:"form-control",attrs:{"type":"text","name":"phone1","data-vv-as":"mobile no."},domProps:{"value":(_vm.phone1)},on:{"input":function($event){if($event.target.composing){ return; }_vm.phone1=$event.target.value}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('edit.phone1')),expression:"errors.has('edit.phone1')"}],staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('edit.phone1')))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.isMobileError),expression:"isMobileError"}],staticClass:"text-danger"},[_vm._v(_vm._s(_vm.mobileErrorMsg))])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Alternate Phone No.")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.phone2),expression:"phone2"},{name:"validate",rawName:"v-validate",value:('numeric|min:10|max:10'),expression:"'numeric|min:10|max:10'"}],staticClass:"form-control",attrs:{"type":"text","name":"phone2","data-vv-as":"alternate phone no."},domProps:{"value":(_vm.phone2)},on:{"input":function($event){if($event.target.composing){ return; }_vm.phone2=$event.target.value}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('edit.phone2')),expression:"errors.has('edit.phone2')"}],staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('edit.phone2')))])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Email")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email),expression:"email"},{name:"validate",rawName:"v-validate",value:('required|email|max:100'),expression:"'required|email|max:100'"}],staticClass:"form-control",staticStyle:{"background-color":"#fff","cursor":"not-allowed"},attrs:{"type":"email","name":"email","data-vv-as":"email address","disabled":true},domProps:{"value":(_vm.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.email=$event.target.value}}}),_vm._v(" "),_c('i',{staticClass:"fa",staticStyle:{"font-size":"18px","color":"#000","text-align":"right","float":"right","margin-top":"-25px","margin-right":"10px"}},[_vm._v("")]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('edit.email')),expression:"errors.has('edit.email')"}],staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('edit.email')))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.isError),expression:"isError"}],staticClass:"text-danger"},[_vm._v(_vm._s('Sorry something went wrong try again'))])])])])]),_vm._v(" "),_c('div',{staticClass:"row mt-3"},[_c('div',{staticClass:"col-sm-6"},[_c('router-link',{staticClass:"btn btn-link full-width",attrs:{"to":"/myprofile"}},[_vm._v("Cancel")])],1),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('button',{staticClass:"btn btn-primary full-width",attrs:{"disabled":(_vm.errors.any())},on:{"click":function($event){$event.preventDefault();_vm.saveProfile()}}},[_vm._v("Update")])])])])])])])])])]),_vm._v(" "),_c('FooterVue')],1)}
var Secure_EditProfile_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"signup-title"},[_c('h4',{staticClass:"mt-0 mb-0"},[_vm._v("Edit Account")])])}]
var Secure_EditProfile_esExports = { render: Secure_EditProfile_render, staticRenderFns: Secure_EditProfile_staticRenderFns }
/* harmony default export */ var components_mobile_Secure_EditProfile = (Secure_EditProfile_esExports);
// CONCATENATED MODULE: ./src/components/mobile/Secure/EditProfile.vue
function Secure_EditProfile_injectStyle (ssrContext) {
  __webpack_require__("TUxi")
}
var Secure_EditProfile_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var Secure_EditProfile___vue_template_functional__ = false
/* styles */
var Secure_EditProfile___vue_styles__ = Secure_EditProfile_injectStyle
/* scopeId */
var Secure_EditProfile___vue_scopeId__ = "data-v-ab9de096"
/* moduleIdentifier (server only) */
var Secure_EditProfile___vue_module_identifier__ = null
var Secure_EditProfile_Component = Secure_EditProfile_normalizeComponent(
  mobile_Secure_EditProfile,
  components_mobile_Secure_EditProfile,
  Secure_EditProfile___vue_template_functional__,
  Secure_EditProfile___vue_styles__,
  Secure_EditProfile___vue_scopeId__,
  Secure_EditProfile___vue_module_identifier__
)

/* harmony default export */ var src_components_mobile_Secure_EditProfile = (Secure_EditProfile_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/Secure/ChangePassword.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var mobile_Secure_ChangePassword = ({
  name: 'ChangePassword',
  components: {
    HeaderVue: mobile_Header["a" /* default */],
    FooterVue: mobile_Footer["a" /* default */]
  },
  beforeCreate: function beforeCreate() {
    if (!this.$localStorage.get('loggedIn') || this.$localStorage.get('loggedIn') === null) {
      this.$router.push({ path: '/' });
    }
  },
  data: function data() {
    return {
      oldPassword: '',
      newPassword: '',
      confirmPassword: '',
      error: false,
      errormsg: ''
    };
  },

  methods: {
    savePassword: function savePassword() {
      var _this = this;

      this.$validator.validateAll('password').then(function (result) {
        if (result) {
          try {
            _this.error = false;
            _this.errormsg = '';
            var data = {
              'oldPassword': _this.oldPassword,
              'newPassword': _this.newPassword
            };
            promise_default.a.resolve(_this.$POST('patient/changePassword', data)).then(function (res) {
              if (res.response_code === 0) {
                this.$router.push({ path: '/myprofile' });
              } else {
                this.error = true;
                this.errormsg = res.response_message;
              }
            }.bind(_this)).catch(function (err) {
              console.error(err);
            });
          } catch (e) {
            console.error('method:save_password', e);
          }
        }
      });
    }
  },
  mounted: function mounted() {
    this.$hidePageLoading();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ccc83b36","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/Secure/ChangePassword.vue
var Secure_ChangePassword_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"EditProfileDiv"}},[_c('HeaderVue',{attrs:{"isHeader":"true"}}),_vm._v(" "),_c('div',{staticClass:"inner-page phleb-signup my-profile"},[_c('div',{staticClass:"inner-page phleb-signup my-profile"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col align-self-center"},[_c('form',{attrs:{"data-vv-scope":"password"}},[_c('div',{staticClass:"sign-up change-password"},[_vm._m(0,false,false),_vm._v(" "),_c('div',{staticClass:"form-content line-textbox"},[(_vm.error)?_c('p',{staticClass:"no-mar-top red-color"},[_vm._v(_vm._s(_vm.errormsg))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Type Current Password")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.oldPassword),expression:"oldPassword"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"form-control",attrs:{"type":"password","name":"oldPassword","data-vv-as":"current password"},domProps:{"value":(_vm.oldPassword)},on:{"input":function($event){if($event.target.composing){ return; }_vm.oldPassword=$event.target.value}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('password.oldPassword')),expression:"errors.has('password.oldPassword')"}],staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('password.oldPassword')))])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Type New Password")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.newPassword),expression:"newPassword"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"form-control",attrs:{"type":"password","name":"newPassword","data-vv-as":"new password"},domProps:{"value":(_vm.newPassword)},on:{"input":function($event){if($event.target.composing){ return; }_vm.newPassword=$event.target.value}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('password.newPassword')),expression:"errors.has('password.newPassword')"}],staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('password.newPassword')))])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Retype New Password")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.confirmPassword),expression:"confirmPassword"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"form-control",attrs:{"type":"password","name":"confirmPassword","data-vv-as":"retype new password"},domProps:{"value":(_vm.confirmPassword)},on:{"input":function($event){if($event.target.composing){ return; }_vm.confirmPassword=$event.target.value}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('password.confirmPassword')),expression:"errors.has('password.confirmPassword')"}],staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('password.confirmPassword')))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.confirmPassword !== '' && _vm.newPassword !== _vm.confirmPassword),expression:"confirmPassword !== '' && newPassword !== confirmPassword"}],staticClass:"text-danger"},[_vm._v("The retype new password confirmation does not match")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-4"},[_c('router-link',{attrs:{"to":"/myprofile"}},[_c('button',{staticClass:"btn btn-link"},[_vm._v("Cancel")])])],1),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('button',{staticClass:"btn btn-primary full-width",attrs:{"disabled":(_vm.errors.any())},on:{"click":function($event){$event.preventDefault();_vm.savePassword()}}},[_vm._v("Change Password")])])])])])])])])])]),_vm._v(" "),_c('FooterVue')],1)}
var Secure_ChangePassword_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"signup-title"},[_c('h4',{staticClass:"mt-0 mb-0"},[_vm._v("Changes Password")])])}]
var Secure_ChangePassword_esExports = { render: Secure_ChangePassword_render, staticRenderFns: Secure_ChangePassword_staticRenderFns }
/* harmony default export */ var components_mobile_Secure_ChangePassword = (Secure_ChangePassword_esExports);
// CONCATENATED MODULE: ./src/components/mobile/Secure/ChangePassword.vue
function Secure_ChangePassword_injectStyle (ssrContext) {
  __webpack_require__("TACJ")
}
var Secure_ChangePassword_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var Secure_ChangePassword___vue_template_functional__ = false
/* styles */
var Secure_ChangePassword___vue_styles__ = Secure_ChangePassword_injectStyle
/* scopeId */
var Secure_ChangePassword___vue_scopeId__ = "data-v-ccc83b36"
/* moduleIdentifier (server only) */
var Secure_ChangePassword___vue_module_identifier__ = null
var Secure_ChangePassword_Component = Secure_ChangePassword_normalizeComponent(
  mobile_Secure_ChangePassword,
  components_mobile_Secure_ChangePassword,
  Secure_ChangePassword___vue_template_functional__,
  Secure_ChangePassword___vue_styles__,
  Secure_ChangePassword___vue_scopeId__,
  Secure_ChangePassword___vue_module_identifier__
)

/* harmony default export */ var src_components_mobile_Secure_ChangePassword = (Secure_ChangePassword_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/Book/Test.vue
//
//
//
//
//


/* harmony default export */ var mobile_Book_Test = ({
  name: 'BookTest',
  components: {},
  beforeCreate: function beforeCreate() {},
  data: function data() {
    return {};
  },

  mounted: function mounted() {
    this.$router.push({ path: '/lab' });
  },
  created: function created() {},

  watch: {},
  methods: {}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6721ceda","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/Book/Test.vue
var Book_Test_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"TestDiv"}})}
var Book_Test_staticRenderFns = []
var Book_Test_esExports = { render: Book_Test_render, staticRenderFns: Book_Test_staticRenderFns }
/* harmony default export */ var components_mobile_Book_Test = (Book_Test_esExports);
// CONCATENATED MODULE: ./src/components/mobile/Book/Test.vue
var Book_Test_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var Book_Test___vue_template_functional__ = false
/* styles */
var Book_Test___vue_styles__ = null
/* scopeId */
var Book_Test___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Book_Test___vue_module_identifier__ = null
var Book_Test_Component = Book_Test_normalizeComponent(
  mobile_Book_Test,
  components_mobile_Book_Test,
  Book_Test___vue_template_functional__,
  Book_Test___vue_styles__,
  Book_Test___vue_scopeId__,
  Book_Test___vue_module_identifier__
)

/* harmony default export */ var src_components_mobile_Book_Test = (Book_Test_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/defineProperty.js
var defineProperty = __webpack_require__("bOdI");
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/Book/Lab.vue



var _methods;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var mobile_Book_Lab = ({
  name: 'ChooseLab',
  components: {
    HeaderVue: mobile_Header["a" /* default */],
    FooterVue: mobile_Footer["a" /* default */]
  },
  beforeCreate: function beforeCreate() {
    // if (!this.$localStorage.get('pincode') || !this.$localStorage.get('st') || this.$localStorage.get('st').length === 0) {
    //   this.$router.push({ path: '/test' })
    //   return false
    // }
  },
  data: function data() {
    return {
      labLimit: 10,
      labTests: {},
      labLists: [],
      selectedLab: [],
      isLabLoading: false,
      labDetails: '',
      selectedProfileAndTest: [],
      totalLabs: [],
      limitedLabs: [],
      _s3BucketUrl: '',
      clickedProfileName: '',
      clickedProfileDetails: [],
      clickedProfileTests: [],
      clickedProfileTestFirst: [],
      clickedProfileTestSecond: [],
      labSearchContent: 'Loading...',
      labContent: false,
      pincodeButton: false,
      ProfileAndTest: [],
      searchContent: {
        test: [],
        profile: []
      },
      masterTestAndProfile: {
        test: [],
        profile: []
      },
      isSearchLoading: false,
      searchtext: '',
      result_focus: '',
      locationList: [],
      locationMasterList: [],
      selectedCity: this.$localStorage.get('sc'),
      locality: '',
      pincode: '',
      pincodeError: false,
      onBlurKey: false,
      query: undefined,
      sortBy: 3,
      lowestCost: undefined,
      currentLocation: null,
      locationAllowed: false,
      locationChanged: false,
      popularTests: {},
      sideBannerAds: [],
      isPopularPackages: false
    };
  },

  mounted: function mounted() {
    var _this = this;

    this.getLocation();
    this.$root.$on('removeProfileAndTest', function (selectedProfileAndTest) {
      _this.selectedProfileAndTest = selectedProfileAndTest;
      _this.getLab();
      _this.getPopularTest();
      _this.getAllProfileAndTests();
    });
    $('body').click(function (e) {
      if (e.target.id === 'localitySearch' || $(e.target).parents('#localitySearch').length) {} else if (e.target.id === 'popupLocality' || $(e.target).parents('#popupLocality').length) {} else {
        this.onBlurKey = false;
        this.query = this.locality ? this.locality.locationName : '';
      }
    }.bind(this));
  },
  watch: {
    searchtext: function searchtext() {
      this.getProfileAndTests();
    }
  },
  created: function created() {
    setTimeout(function () {
      this.geolocation();
    }.bind(this), 2000);
    if (this.$localStorage.get('pincode')) {
      this.pincode = this.$localStorage.get('pincode');
    }
    if (this.$localStorage.get('location')) {
      this.locality = this.$localStorage.get('location');
      this.query = this.locality.locationName;
    } else {
      this.pincodeButton = true;
    }

    this.selectedLab = [];
    if (this.$localStorage.get('sl')) {
      this.selectedLab = this.$localStorage.get('sl');
    }

    this.selectedProfileAndTest = [];
    if (this.$localStorage.get('st')) {
      this.selectedProfileAndTest = this.$localStorage.get('st');
    }
    this.getLab();
    this.getPopularTest();
    this.getAllProfileAndTests();
    if (this.selectedProfileAndTest.length == 0 || this.$localStorage.get('addTest')) {
      this.$localStorage.remove('addTest');
      setTimeout(function () {
        $('#popupTest').modal('show');
      }, 500);
    }
  },

  methods: (_methods = {
    getIncudedTestAndProfile: function getIncudedTestAndProfile(tl) {
      var testCountVal = 0;

      if (tl.profileTestsCount && tl.profileTestsCount > 0) {
        testCountVal = testCountVal + tl.profileTestsCount;
      }
      if (tl.package == 1) {
        if (tl.includedProfiles && tl.includedProfiles.count > 0) {
          tl.includedProfiles.data.forEach(function (testObj) {
            testCountVal = testCountVal + testObj.ProfileTests.length;
          });
        }
      }
      return testCountVal ? testCountVal + ' Test(s)' : '';
    },
    getIncudedTestAndProfilePopup: function getIncudedTestAndProfilePopup(tl) {
      var profileCountStr = '';
      if (tl.package == 1) {
        if (tl.includedProfiles && tl.includedProfiles.count > 0) {
          profileCountStr = tl.includedProfiles.count + ' Profile(s)';
        }
      }
      var testCountStr = '';
      if (tl.testCount && tl.testCount > 0) {
        testCountStr = tl.testCount + ' Test(s)';
      }
      return profileCountStr + (profileCountStr.length > 0 && testCountStr.length > 0 ? ' & ' : '') + testCountStr;
    },
    getIncudedTestAndProfilePop: function getIncudedTestAndProfilePop(tl) {
      var testCountVal = 0;
      if (tl.testCount && tl.testCount > 0) {
        testCountVal = testCountVal + tl.testCount;
      }
      if (tl.package == 1) {
        if (tl.includedProfiles && tl.includedProfiles.count > 0) {
          tl.includedProfiles.data.forEach(function (testObj) {
            testCountVal = testCountVal + testObj.ProfileTests.length;
          });
        }
      }
      return testCountVal ? testCountVal + ' Tests' : '';
    },
    getIncudedTestAndProfilePopular: function getIncudedTestAndProfilePopular(tl) {
      var profileCountStr = '';
      if (tl.package == 1) {
        if (tl.includedProfiles && tl.includedProfiles.count > 0) {
          profileCountStr = tl.includedProfiles.count + ' Profile(s)';
        }
      }
      var testCountStr = '';
      if (tl.ProfileTestCount && tl.ProfileTestCount > 0) {
        testCountStr = tl.ProfileTestCount + ' Test(s)';
      }
      return profileCountStr + (profileCountStr.length > 0 && testCountStr.length > 0 ? ' & ' : '') + testCountStr;
    }
  }, defineProperty_default()(_methods, 'getIncudedTestAndProfilePopular', function getIncudedTestAndProfilePopular(tl) {
    var testCountVal = 0;
    if (tl.ProfileTests && tl.ProfileTests.length > 0) {
      testCountVal = testCountVal + tl.ProfileTests.length;
    }
    if (tl.package == 1) {
      if (tl.includedProfiles && tl.includedProfiles.count > 0) {
        tl.includedProfiles.data.forEach(function (testObj) {
          testCountVal = testCountVal + testObj.ProfileTests.length;
        });
      }
    }
    return testCountVal ? testCountVal + ' Tests' : '';
  }), defineProperty_default()(_methods, 'geolocation', function geolocation() {
    var options = {
      maximumAge: 60000,
      timeout: 5000,
      enableHighAccuracy: true
    };
    navigator.geolocation.getCurrentPosition(function (position) {
      console.log('im tracking you!');
      this.currentLocation = {
        lat: position.coords.latitude,
        lng: position.coords.longitude
      };
      this.changeCityUsingLocation();
      return false;
    }.bind(this), function (error) {
      if (error.code === error.PERMISSION_DENIED) {
        console.log('you denied me :-(');
        this.locationAllowed = false;
        if (!this.$localStorage.get('sc') && this.selectedCity) {
          this.$localStorage.set('sc', this.selectedCity);
        }
      }
    }.bind(this)), options;
  }), defineProperty_default()(_methods, 'changeCityUsingLocation', function changeCityUsingLocation() {
    var data = {
      coordinates: this.currentLocation
    };
    promise_default.a.resolve(this.$POST('patient/getCityUsingLocation', data)).then(function (res) {
      if (res.response_code === 0) {
        if (!this.$localStorage.get('sc')) {
          this.locationMasterList.forEach(function (city) {
            if (res.response.cityId === city.cityId) {
              if (this.selectedCity.cityId !== city.cityId) {
                this.selectedCity = city;
                this.$localStorage.set('sc', this.selectedCity);
                this.selectBannerAds();
                this.locationList = city.ActiveLocation;
                this.selectedCity.ActiveLocation.forEach(function (loc) {
                  if (res.response.locationId === loc.locationId) {
                    this.locality = loc;
                    this.pincode = loc.locationZipCode;
                    this.query = loc.locationName;
                    this.$localStorage.set('location', loc, 0);
                    this.$localStorage.set('pincode', this.pincode, 0);
                  }
                }.bind(this));
                this.onCityChange();
              } else {
                if (!this.$localStorage.get('location')) {
                  this.selectedCity.ActiveLocation.forEach(function (loc) {
                    if (res.response.locationId === loc.locationId) {
                      this.locality = loc;
                      this.pincode = loc.locationZipCode;
                      this.query = loc.locationName;
                      this.$localStorage.set('location', loc, 0);
                      this.$localStorage.set('pincode', this.pincode, 0);
                    }
                  }.bind(this));
                }
              }
              this.getLab();
            }
          }.bind(this));
        } else if (!this.$localStorage.get('location')) {
          this.selectedCity.ActiveLocation.forEach(function (loc) {
            if (res.response.locationId === loc.locationId) {
              this.locality = loc;
              this.pincode = loc.locationZipCode;
              this.query = loc.locationName;
              this.$localStorage.set('location', loc, 0);
              this.$localStorage.set('pincode', this.pincode, 0);
            }
          }.bind(this));
          this.getLab();
        }
        if (!this.$localStorage.get('sc') && this.selectedCity) {
          this.$localStorage.set('sc', this.selectedCity);
        }
      } else {
        if (!this.$localStorage.get('sc') && this.selectedCity) {
          this.$localStorage.set('sc', this.selectedCity);
        }
      }
    }.bind(this)).catch(function (err) {
      console.error(err);
    });
  }), defineProperty_default()(_methods, 'closeLocalityPopup', function closeLocalityPopup() {
    this.onBlurKey = false;
    this.query = this.locality ? this.locality.locationName : '';
    $('#popupLocality').modal("hide");
  }), defineProperty_default()(_methods, 'ProfileAndTests', function ProfileAndTests(value) {
    if (value === 1) {
      this.getProfileAndTests();
    } else {
      this.getProfileAndTests();
    }
  }), defineProperty_default()(_methods, 'openSearchModel', function openSearchModel() {
    $('#popupTest').modal("show");
    setTimeout(function () {
      this.$refs.searchtext.focus();
      this.getProfileAndTests();
    }.bind(this), 800);
  }), defineProperty_default()(_methods, 'goBackLab', function goBackLab() {
    $('#popupTest').modal('hide');
  }), defineProperty_default()(_methods, 'getLocation', function getLocation() {
    var data = {
      currentLocation: this.currentLocation,
      locationAllowed: this.locationAllowed
    };
    promise_default.a.resolve(this.$POST('patient/getCityAndLocation', data)).then(function (res) {
      if (res.response_code === 0) {
        this.locationMasterList = res.response;
        if (this.selectedCity) {
          this.locationMasterList.forEach(function (city) {
            if (this.selectedCity.cityId === city.cityId) {
              this.selectedCity = city;
              // this.$localStorage.set('sc', this.selectedCity)
              this.selectBannerAds();
              this.locationList = city.ActiveLocation;
            }
          }.bind(this));
        } else {
          if (this.locationMasterList.length > 0) {
            this.selectedCity = this.locationMasterList[0];
            // this.$localStorage.set('sc', this.selectedCity)
            this.selectBannerAds();
            this.locationList = this.locationMasterList[0].ActiveLocation;
          } else {
            this.selectedCity = undefined;
            this.locationList = [];
          }
        }
      }
    }.bind(this)).catch(function (err) {
      console.error(err);
    });
  }), defineProperty_default()(_methods, 'getPopularTest', function getPopularTest() {
    var data = {
      selectedProfileAndTest: this.selectedProfileAndTest
    };
    promise_default.a.resolve(this.$POST('patient/getPopularTestList', data)).then(function (res) {
      if (res.response_code === 0) {
        this.popularTests = {
          test: res.response.test.slice(0, 5),
          profile: res.response.profile.slice(0, 5)
        };
      }
      this.$hidePageLoading();
    }.bind(this)).catch(function (err) {
      console.error(err);
    });
  }), defineProperty_default()(_methods, 'labSortOrder', function labSortOrder() {
    if (this.sortBy === '1') {
      this.labLists.sort(function (a, b) {
        a = a.ourCost;
        b = b.ourCost;
        return a < b ? -1 : 1;
      });
    } else if (this.sortBy === '2') {
      this.labLists.sort(function (a, b) {
        a = a.ourCost;
        b = b.ourCost;
        return a > b ? -1 : 1;
      });
    } else if (this.sortBy === '3') {
      this.labLists.sort(function (a, b) {
        a = a.rating;
        b = b.rating;
        return a > b ? -1 : 1;
      });
    }
    setTimeout(function () {
      $('#sort-by').modal("hide");
    }, 500);
    // this.getLab()
  }), defineProperty_default()(_methods, 'adsRedirect', function adsRedirect(url) {
    if (this.pincode && this.pincode.length === 6) {
      url = url + '/' + this.locality.locationName;
    }
    window.open(url, '_blank');
  }), defineProperty_default()(_methods, 'getTestByFilter', function getTestByFilter(type) {
    var testKey = this.$route.params.test ? this.$route.params.test.split('_').join(' ') : '';
    var locationKey = this.$route.params.location ? this.$route.params.location.split('_').join(' ') : '';
    var data = {
      'city': this.$route.params.city ? this.$route.params.city : '',
      'location': this.$route.params.location ? locationKey : undefined,
      'test': testKey
    };
    this.$localStorage.remove('sc');
    this.$localStorage.remove('location');
    this.$localStorage.remove('pincode');
    this.$localStorage.remove('st');
    promise_default.a.resolve(this.$POST('patient/getTestByFilter', data)).then(function (res) {
      // this.geolocation()
      this.getLocation();
      if (res.response_code === 0) {
        if (res.response.city && res.response.city != null) {
          this.selectedCity = res.response.city;
          this.$localStorage.set('sc', this.selectedCity);
          this.selectBannerAds();
          if (res.response.city.ActiveLocation && res.response.city.ActiveLocation.length > 0) {
            this.$localStorage.set('location', res.response.city.ActiveLocation[0]);
            this.$localStorage.set('pincode', res.response.city.ActiveLocation[0].locationZipCode);
            this.closePopup(0);
          } else {
            if (!this.$localStorage.get('ftp')) {
              this.$localStorage.set('ftp', 'YES', 0);
              $('.carousel').carousel({
                interval: 2000
              });
              // $('html').css({"position":"fixed", "width":"100%"});
              setTimeout(function () {
                $('.flash-message').css("opacity", "1");
                $('.black-overlay').css("opacity", "1");
                // this.$refs.pincodePopup.focus()
              }.bind(this), 1000);
            } else {
              // this.$localStorage.remove('ftp')
              this.closePopup(0);
            }
          }
        }
        // if(res.response.location && res.response.location != null){
        //   // this.$localStorage.set('location',res.response.location)
        //   // this.$localStorage.set('pincode', res.response.location.locationZipCode)
        //   // this.closePopup(0)
        // }else{
        //   if(!this.$localStorage.get('ftp')){
        //     this.$localStorage.set('ftp','YES',0)
        //     $('.carousel').carousel({
        //       interval: 2000
        //     });
        //     // $('html').css({"position":"fixed", "width":"100%"});
        //     setTimeout(function () {
        //       $('.flash-message').css("opacity", "1");
        //       $('.black-overlay').css("opacity", "1");
        //       // this.$refs.pincodePopup.focus()
        //     }.bind(this), 1000);
        //   }else{
        //     // this.$localStorage.remove('ftp')
        //     this.closePopup(0)
        //   }
        // }
        if (res.response.selectedTest && res.response.selectedTest != null) {
          this.selectedProfileAndTest = [];
          document.title = res.response.selectedTest.name + ' - Labotist';
          // res.response.selectedTest
          this.selectedProfileAndTest.push(res.response.selectedTest);
          this.$localStorage.set('st', this.selectedProfileAndTest);
          this.$root.$emit('selectedProfileAndTest', this.selectedProfileAndTest);
          this.getLab();
        } else {
          this.selectedLab = [];
          this.labSearchContent = 'No labs found in your searched locations.';
          this.$localStorage.remove('sl');
        }
        this.afterCreate();
        this.getPopularTest();
        this.getAllProfileAndTests();
      }
      this.$hidePageLoading();
    }.bind(this)).catch(function (err) {
      console.error(err);
    });
  }), defineProperty_default()(_methods, 'closePopup', function closePopup(type) {
    if (type === 1) {
      if (!this.pincode || this.pincode.length !== 6) {
        this.showLocalityError = true;
        return false;
      }
    }
    if (type === 2) {
      this.query = undefined;
      // $('html').css({"position":"relative", "width":"100%"});
    }
    if (type === 3) {
      // $('html').css({"position":"relative", "width":"100%"});
    }
    $('.flash-message').addClass("bounce");
    $('.black-overlay').css("opacity", "0");
    setTimeout(function () {
      $('.flash-message').css("opacity", "0");
      $('.flash-message').css("bottom", "-500px");
      $('.black-overlay').css("display", "none");
      setTimeout(function () {
        $('.flash-message').css("display", "none");
      }, 400);
    }, 400);
  }), defineProperty_default()(_methods, 'afterCreate', function afterCreate() {
    if (this.$localStorage.get('pincode')) {
      this.pincode = this.$localStorage.get('pincode');
    }
    if (this.$localStorage.get('location')) {
      this.locality = this.$localStorage.get('location');
      this.query = this.locality.locationName;
    } else {
      this.pincodeButton = true;
      setTimeout(function () {
        // this.$refs.pincodePopup.focus()
      }.bind(this), 300);
    }
  }), defineProperty_default()(_methods, 'loadMore', function loadMore() {
    var increamented = this.labLimit + 10;
    this.labLimit = increamented > this.labLists.length ? this.labLists.length : increamented;
  }), defineProperty_default()(_methods, 'goChooseDate', function goChooseDate(lab) {
    if (!this.locality || !this.selectedCity) {
      var confirmFn = function () {
        this.onFocusLocality();
      }.bind(this);
      this.$Simplert.open({
        title: 'Information',
        message: 'Please choose your nearest locality',
        type: 'warning',
        useConfirmBtn: false,
        onClose: confirmFn,
        customCloseBtnText: 'Ok',
        disableOverlayClick: true,
        showXclose: true
      });
      return false;
    }
    this.$localStorage.remove('location');
    this.$localStorage.remove('pincode');
    this.$localStorage.remove('sc');
    this.$localStorage.set('location', this.locality);
    this.$localStorage.set('pincode', this.locality.locationZipCode);
    this.$localStorage.set('sc', this.selectedCity);

    this.$localStorage.remove('ct');
    this.$localStorage.remove('cou');
    if (this.$localStorage.get('sl')) {
      if (this.$localStorage.get('sl').labId !== lab.labId) {
        this.$localStorage.remove('ct');
      }
    }
    this.selectedLab = lab;
    this.$localStorage.set('sl', lab, 30 * 60 * 1000);
    this.$localStorage.set('st', this.selectedProfileAndTest);
    vue_esm["default"].analytics.fbq.event('ViewContent', {
      content_ids: lab.labId,
      content_name: lab.labName,
      contents: { id: lab.labId, name: lab.labName },
      content_type: 'LAB'
    });
    this.$router.push({ path: '/appointment' });
  }), defineProperty_default()(_methods, 'openProfileTestList', function openProfileTestList(profileName, testinfo, tl) {
    // alert(profileName)
    this.clickedProfileDetails = [];
    this.clickedProfileTests = [];
    this.clickedProfileName = profileName;
    this.clickedProfileDetails = tl;
    this.clickedProfileTestFirst = [];
    this.clickedProfileTestSecond = [];
    if (tl.testNames) {
      this.clickedProfileTests = tl.testNames.split(',');
      if (this.clickedProfileTests.length > 8) {
        if (this.clickedProfileTests.length > 5) {
          this.clickedProfileTestFirst = this.clickedProfileTests.slice(0, parseInt(this.clickedProfileTests.length / 2) + this.clickedProfileTests.length % 2);
          this.clickedProfileTestSecond = this.clickedProfileTests.slice(parseInt(this.clickedProfileTests.length / 2) + this.clickedProfileTests.length % 2, this.clickedProfileTests.length);
        } else {
          this.clickedProfileTestFirst = this.clickedProfileTests;
        }
      } else {
        this.clickedProfileTestFirst = this.clickedProfileTests;
      }
    }
    $('#test-popup').modal('show');
    // this.clickedProfileTests = (tl.testNames)
  }), defineProperty_default()(_methods, 'openPopularProfileTestList', function openPopularProfileTestList(profile) {
    profile['testCount'] = profile.ProfileTests ? profile.ProfileTests.length : 0;
    profile['aliasName'] = profile.name;
    this.clickedProfileDetails = [];
    this.clickedProfileTests = [];
    this.clickedProfileName = profile.name;
    this.clickedProfileDetails = profile;
    // this.clickedProfileDetails
    this.clickedProfileTestFirst = [];
    this.clickedProfileTestSecond = [];
    if (profile.ProfileTests) {
      this.clickedProfileTests = profile.ProfileTests;
      if (this.clickedProfileTests.length > 8) {
        if (this.clickedProfileTests.length > 5) {
          this.clickedProfileTestFirst = this.clickedProfileTests.slice(0, parseInt(this.clickedProfileTests.length / 2) + this.clickedProfileTests.length % 2);
          this.clickedProfileTestSecond = this.clickedProfileTests.slice(parseInt(this.clickedProfileTests.length / 2) + this.clickedProfileTests.length % 2, this.clickedProfileTests.length);
        } else {
          this.clickedProfileTestFirst = this.clickedProfileTests;
        }
      } else {
        this.clickedProfileTestFirst = this.clickedProfileTests;
      }
    }
    $('#test-popup').modal('show');
  }), defineProperty_default()(_methods, 'getLab', function getLab() {
    this.labContent = false;
    this.ProfileAndTest = [];
    this.labLists = [];
    this.isLabLoading = true;
    var data = {
      'zipCode': this.$localStorage.get('pincode'),
      'locality': this.$localStorage.get('location') ? this.$localStorage.get('location') : null,
      'locationCoordinate': this.$localStorage.get('location') ? this.$localStorage.get('location').locationCoordinate : null,
      'sortBy': this.sortBy,
      'city': this.selectedCity
    };

    var test = [];
    if (this.selectedProfileAndTest.length > 0) {
      this.selectedProfileAndTest.forEach(function (element) {
        if (element.testId > 0) {
          test.push(element.testId);
        }
      }, this);
    }
    data.test = test;

    var profile = [];
    if (this.selectedProfileAndTest.length > 0) {
      this.selectedProfileAndTest.forEach(function (element) {
        if (element.panelId > 0) {
          profile.push(element.panelId);
        }
      }, this);
    }
    data.profile = profile;
    promise_default.a.resolve(this.$POST('patient/getLab', data)).then(function (res) {
      if (res.response_code === 0) {
        this.isLabLoading = false;
        this.s3BucketUrl = this.$_s3BucketUrl;
        this.labContent = true;
        if (res.response.labList.length > 0) {
          this.labLists = res.response.labList;
          this.lowestCost = res.response.lowestCost;
        } else {
          this.selectedLab = [];
          this.labSearchContent = 'No labs found in your searched locations.';
          this.$localStorage.remove('sl');
        }
      } else {
        this.isLabLoading = false;
        this.selectedLab = [];
        this.labSearchContent = 'No labs found in your searched locations.';
        this.$localStorage.remove('sl');
      }
      this.$hidePageLoading();
    }.bind(this)).catch(function (err) {
      console.error(err);
    });
  }), defineProperty_default()(_methods, 'getLabDetails', function getLabDetails(lab) {
    try {
      this.labDetails = '';
      if (this.$localStorage.get('access_token') !== '') {
        var data = {
          'labId': lab.labId
        };
        promise_default.a.resolve(this.$POST('patient/getLabDetails', data)).then(function (res) {
          if (res.response_code === 0) {
            this.labDetails = res.response;
          }
        }.bind(this)).catch(function (err) {
          console.error(err);
        });
      }
    } catch (e) {
      console.error(e);
    }
  }), defineProperty_default()(_methods, 'clearProfileAndTests', function clearProfileAndTests() {
    this.searchContent = {
      test: [],
      profile: []
    };
  }), defineProperty_default()(_methods, 'getAllProfileAndTests', function getAllProfileAndTests() {
    if (this.searchtext === '') {
      this.isPopularPackages = true;
    } else {
      this.isPopularPackages = false;
    }
    var data = {
      'keyword': '',
      selectedProfileAndTest: this.selectedProfileAndTest
    };
    promise_default.a.resolve(this.$POST('patient/getProfileAndTestList', data)).then(function (res) {
      if (res.response_code === 0) {
        if (!res.response.test || !res.response.profile) {
          this.isSearchLoading = 'No Result';
        } else {
          this.masterTestAndProfile = {
            tests: res.response.test,
            profile: res.response.profile,
            test: res.response.test.concat(res.response.profile)
          };
          if (this.searchtext.length > 0) {
            this.getProfileAndTests();
          }
        }
      }
    }.bind(this)).catch(function (err) {
      console.error(err);
    });
  }), defineProperty_default()(_methods, 'getProfileAndTests_old', function getProfileAndTests_old() {
    if (this.searchtext === '') {
      this.isPopularPackages = true;
      return;
    } else {
      this.isPopularPackages = false;
    }
    this.isSearchLoading = 'Loading...';
    var data = {
      'keyword': this.searchtext,
      selectedProfileAndTest: this.selectedProfileAndTest
    };
    promise_default.a.resolve(this.$POST('patient/getProfileAndTestList', data)).then(function (res) {
      if (res.response_code === 0) {
        if (!res.response.test || !res.response.profile) {
          this.isSearchLoading = 'No Result';
        } else {
          this.isSearchLoading = false;
          var test = res.response.test.sort(this.testSort);
          var profile = res.response.profile.sort(this.testSort);
          // test = test.sort(this.profileSort)
          // profile = profile.sort(this.profileSort)
          this.searchContent = {
            test: test,
            profile: profile
          };
        }
      }
    }.bind(this)).catch(function (err) {
      console.error(err);
    });
  }), defineProperty_default()(_methods, 'getProfileAndTests', function getProfileAndTests() {
    if (this.searchtext === '') {
      this.isPopularPackages = true;
      return;
    } else {
      this.isPopularPackages = false;
    }
    this.isSearchLoading = 'Loading...';
    var profileOptions = {
      shouldSort: true,
      threshold: 0.6,
      location: 0,
      // distance: 20,
      maxPatternLength: 32,
      minMatchCharLength: 1,
      keys: ["name", "Keywords", "ProfileTests"]
    };

    var testFuse = new fuse_default.a(this.masterTestAndProfile.test, profileOptions); // "list" is the item array
    this.searchContent = {
      test: testFuse.search(this.searchtext)
    };
    this.isSearchLoading = false;
  }), defineProperty_default()(_methods, 'testSort', function testSort(a, b) {
    a = a.name.toUpperCase();
    b = b.name.toUpperCase();
    if (a.indexOf(this.searchtext.toUpperCase()) === -1) {
      return 1;
    } else if (b.indexOf(this.searchtext.toUpperCase()) === -1) {
      return -1;
    }
    return a.indexOf(this.searchtext.toUpperCase()) < b.indexOf(this.searchtext.toUpperCase()) ? -1 : 1;
  }), defineProperty_default()(_methods, 'updateSelectedTest', function updateSelectedTest(test, isTest, isPopular) {
    if (isTest === 1 && isPopular === 1) {
      if (this.popularTests.test && this.popularTests.test.length > 0) {
        this.popularTests.test.forEach(function (testValue, index) {
          if (testValue.testId === test.testId) {
            this.popularTests.test[index].isSelected = 1;
          }
        }.bind(this));
      }
    } else if (isTest === 2 && isPopular === 1) {
      var popularProfile = this.popularTests.profile;
      if (popularProfile && popularProfile.length > 0) {
        popularProfile.forEach(function (profileValue, index) {
          if (profileValue.panelId === test.panelId) {
            popularProfile[index].isSelected = 1;
            this.popularTests.profile = popularProfile;
          }
        }.bind(this));
      }
    } else if (isTest === 1 && isPopular === 2 && test.testId > 0) {
      var testList = this.searchContent.test;
      if (testList && testList.length > 0) {
        testList.forEach(function (profileValue, index) {
          if (test.testId > 0 && profileValue.testId === test.testId) {
            testList[index].isSelected = 1;
            this.searchContent.test = testList;
          }
        }.bind(this));
      }
    } else if (isTest === 1 && isPopular === 2 && test.panelId > 0) {
      var profileList = this.searchContent.profile;
      if (profileList && profileList.length > 0) {
        profileList.forEach(function (profileValue, index) {
          if (test.panelId > 0 && profileValue.panelId === test.panelId) {
            profileList[index].isSelected = 1;
            this.searchContent.profile = profileList;
          }
        }.bind(this));
      }
    }
  }), defineProperty_default()(_methods, 'addTestFromDropdown', function addTestFromDropdown(event, test, isTest, isPopular) {
    if (test.isSelected === 1) {
      return false;
    }
    if (isTest && isPopular) {
      setTimeout(function () {
        this.updateSelectedTest(test, isTest, isPopular);
      }.bind(this), 100);
    }
    if (test.testId === 0) {
      this.addTestAndProfile(test);
    } else {
      var filterProfile = [];
      underscore_default.a.each(this.selectedProfileAndTest, function (ele, key) {
        if (ele.testId === 0) {
          filterProfile.push(ele);
        }
      });
      if (filterProfile.length > 0) {
        var LabProfileTestsCount = 0;
        var splitArrayCount = 0;
        var isExistsCount = 0;
        var ExistsArray = [];
        underscore_default.a.each(filterProfile, function (value, key) {
          if (value.LabProfileTests && value.LabProfileTests !== '') {
            var splitArray = value.LabProfileTests.split(',').map(function (item) {
              return item.trim().toUpperCase();
            });
            if (splitArray.indexOf(test.name.toUpperCase()) === '-1') {
              splitArrayCount++;
            } else {
              isExistsCount++;
              ExistsArray.push(value.name);
            }
          } else {
            LabProfileTestsCount++;
          }
        });
        if (LabProfileTestsCount === filterProfile.length) {
          this.addTestAndProfile(test);
        } else if (splitArrayCount === filterProfile.length) {
          this.addTestAndProfile(test);
        } else if (isExistsCount > 0) {
          var confirmFn = function () {
            this.addTestAndProfile(test, true);
          }.bind(this);

          this.$Simplert.open({
            title: 'Confirm',
            message: 'The test that you have selected is already included in one of the profile added to the cart\u201D Just have ok button, no need for cancel.',
            type: 'info',
            useConfirmBtn: true,
            onConfirm: confirmFn,
            customConfirmBtnText: 'Ok',
            customCloseBtnText: 'Cancel',
            disableOverlayClick: true
          });
        } else {
          this.addTestAndProfile(test);
        }
      } else {
        this.addTestAndProfile(test);
      }
    }
  }), defineProperty_default()(_methods, 'addTestAndProfile', function addTestAndProfile(test, isPopup) {
    this.$localStorage.remove('sl');
    this.$localStorage.remove('ct');
    this.$localStorage.remove('cou');
    if (underscore_default.a.pluck(this.selectedProfileAndTest, 'name').indexOf(test.name) === -1) {
      this.selectedProfileAndTest.push(test);
      if (isPopup) {
        this.$apply(function () {
          this.selectedProfileAndTest = underscore_default.a.uniq(this.selectedProfileAndTest);
        });
      } else {
        this.selectedProfileAndTest = underscore_default.a.uniq(this.selectedProfileAndTest);
      }
      var testFB = {
        id: test.testId === 0 ? test.panelId : test.testId,
        isTest: test.testId === 0 ? 0 : 1,
        name: test.name
      };
      if (test.testId === 0) {
        vue_esm["default"].analytics.fbq.event('ViewContent', {
          content_ids: test.testId === 0 ? test.panelId : test.testId,
          content_name: test.name,
          contents: testFB,
          content_type: 'PROFILE'
        });
      } else {
        vue_esm["default"].analytics.fbq.event('ViewContent', {
          content_ids: test.testId === 0 ? test.panelId : test.testId,
          content_name: test.name,
          contents: testFB,
          content_type: 'TEST'
        });
      }
      this.$localStorage.set('st', this.selectedProfileAndTest);
      this.$root.$emit('selectedProfileAndTest', this.selectedProfileAndTest);
    }
    this.getLab();
    this.getPopularTest();
    this.getAllProfileAndTests();
  }), defineProperty_default()(_methods, 'removeSelectedItems', function removeSelectedItems(items) {
    var index = this.selectedProfileAndTest.indexOf(items);
    this.selectedProfileAndTest.splice(index, 1);
    this.$localStorage.set('st', this.selectedProfileAndTest, 0);
    this.$localStorage.remove('cou');
    if (this.selectedProfileAndTest.length === 0) {
      this.$localStorage.remove('sl');
      this.$localStorage.remove('ct');
    }
    var lab = this.$localStorage.get('sl');
    var labTests = [];
    this.$localStorage.remove('sl');
    if (lab) {
      lab.labTestList.forEach(function (labTest) {
        if (!(items.testId === labTest.testId && labTest.testId !== 0 || items.panelId === labTest.panelId && labTest.panelId !== 0)) {
          labTests.push(labTest);
        }
      });
      lab.labTestList = labTests;
    }
    this.$localStorage.set('sl', lab, 30 * 60 * 1000);

    this.$root.$emit('selectedProfileAndTest', this.selectedProfileAndTest);
    this.getPopularTest();
    this.getLab();
    this.getAllProfileAndTests();
  }), defineProperty_default()(_methods, 'searchLocation', function searchLocation() {
    // this.onBlurKey = true
    this.locality = undefined;
    this.pincode = undefined;
    var pincode = this.$localStorage.get('pincode');
    this.$localStorage.remove('location');
    this.$localStorage.remove('pincode');
    if (pincode) {
      this.getLab();
    }

    // if (this.query.length < 3) {
    //   this.onBlurKey = false
    //   this.locationList = []
    //   return false
    // }
    try {
      if (this.$localStorage.get('access_token') !== '') {
        var data = {
          'keyword': ''
        };
        promise_default.a.resolve(this.$POST('patient/searchLocation', data)).then(function (res) {
          if (res.response_code === 0) {
            this.locationList = res.response;
            this.locationMasterList = res.response;
          }
        }.bind(this)).catch(function (err) {
          console.error(err);
        });
      }
    } catch (e) {
      console.error(e);
    }
  }), defineProperty_default()(_methods, 'onCityChange', function onCityChange() {
    var localityCheck = undefined;
    this.$localStorage.remove('sl');
    this.$localStorage.remove('ct');
    this.$localStorage.remove('cou');
    this.$localStorage.set('sc', this.selectedCity);
    this.selectedCity.ActiveLocation.forEach(function (location) {
      if (this.locality && location && this.locality.locationId === location.locationId) {
        localityCheck = location;
      }
    }.bind(this));
    if (!localityCheck) {
      this.locality = undefined;
      this.pincode = '';
      this.query = '';
      this.$localStorage.remove('location');
      this.$localStorage.remove('pincode');
    }
    this.getLab();
  }), defineProperty_default()(_methods, 'locationFilterAlphabet', function locationFilterAlphabet(a, b) {
    a = a.locationName;
    b = b.locationName;
    if (a < b) return -1;
    if (a > b) return 1;
    return 0;
  }), defineProperty_default()(_methods, 'locationFilter', function locationFilter(a, b) {
    a = a.locationName.toUpperCase();
    b = b.locationName.toUpperCase();
    if (a.indexOf(this.query.toUpperCase()) === -1) {
      return 1;
    } else if (b.indexOf(this.query.toUpperCase()) === -1) {
      return -1;
    }
    return a.indexOf(this.query.toUpperCase()) < b.indexOf(this.query.toUpperCase()) ? -1 : 1;
  }), defineProperty_default()(_methods, 'showHideLocation', function showHideLocation() {
    this.onBlurKey = true;
    if (this.query.length === 0) {
      this.locationList = this.selectedCity.ActiveLocation.sort(this.locationFilterAlphabet);
    } else {
      var locationFilter = this.selectedCity.ActiveLocation.filter(function (locationVal) {
        var locality = locationVal.locationName;
        if (!locality) return false;
        locality = locality.toLowerCase();
        return locality.includes(this.query.toLowerCase());
      }.bind(this));
      this.locationList = locationFilter.sort(this.locationFilter);
    }
  }), defineProperty_default()(_methods, 'onFocusLocality', function onFocusLocality() {
    $('#popupLocality').modal("show");
    setTimeout(function () {
      this.$refs.pincode.focus();
      this.$refs.pincode.select();
    }.bind(this), 800);
    this.query = '';
    this.onBlurKey = true;
    this.showHideLocation();
  }), defineProperty_default()(_methods, 'closeBlock', function closeBlock() {
    this.pincodeButton = false;
    // setTimeout(function () {
    //   this.onBlurKey = false
    // }.bind(this), 300)
  }), defineProperty_default()(_methods, 'closeBlockTest', function closeBlockTest() {
    setTimeout(function () {
      this.searchtext = '';
    }.bind(this), 300);
  }), defineProperty_default()(_methods, 'selectLocation', function selectLocation(obj) {
    this.locality = undefined;
    this.locality = obj;
    this.pincode = obj.locationZipCode;
    this.query = obj.locationName;
    // this.locationList = []
    this.onBlurKey = false;
    vue_esm["default"].analytics.fbq.event('ViewContent', {
      content_ids: this.locality.locationId,
      content_name: this.locality.locationZipCode,
      contents: { id: this.locality.locationId, location: this.locality.locationName, zipcode: this.locality.locationZipCode },
      content_type: 'PINCODE_ENTERED'
    });
    this.$localStorage.remove('sl');
    this.$localStorage.remove('ct');
    this.$localStorage.remove('cou');

    this.$localStorage.remove('location');
    this.$localStorage.set('location', this.locality, 0);
    this.$localStorage.remove('pincode');
    this.$localStorage.set('pincode', this.locality.locationZipCode, 0);
    this.getLab();
    $('#popupLocality').modal("hide");
  }), defineProperty_default()(_methods, 'selectBannerAds', function selectBannerAds() {
    if (this.selectedCity.cityId === 2) {
      this.sideBannerAds = [{
        url: '/labs/chennai/Women%E2%80%99s_Wellness_Check',
        src: 'static/images/banner/women.jpg'
      }, {
        url: '/labs/chennai/comprehensive_health_checkup',
        src: 'static/images/banner/comprehensive.jpg'
      }, {
        url: '/labs/chennai/General_Health_Checkup',
        src: 'static/images/banner/general.jpg'
      }, {
        url: '/labs/chennai/Hypertension_checkup',
        src: 'static/images/banner/hyper.jpg'
      }];
    } else if (this.selectedCity.cityId === 33) {
      this.sideBannerAds = [{
        url: '/labs/bangaluru/comprehensive_health_checkup',
        src: 'static/images/banner/comprehensive.jpg'
      }, {
        url: '/labs/bangaluru/Women%E2%80%99s_Wellness_Check',
        src: 'static/images/banner/women.jpg'
      }, {
        url: '/labs/bangaluru/General_Health_Checkup',
        src: 'static/images/banner/general.jpg'
      }, {
        url: '/labs/bangaluru/Hypertension_checkup',
        src: 'static/images/banner/hyper.jpg'
      }];
    }
  }), _methods)
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f4670216","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/Book/Lab.vue
var Book_Lab_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"LabDiv"}},[_c('HeaderVue',{attrs:{"isHeader":"true"}}),_vm._v(" "),_c('div',{staticClass:"search-section"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-6 pr-1"},[_c('div',{staticClass:"input-group mb-2"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedCity),expression:"selectedCity"}],staticClass:"form-control",on:{"click":function($event){_vm.onBlurKey=false;},"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedCity=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){_vm.onCityChange()}]}},_vm._l((_vm.locationMasterList),function(city,index){return _c('option',{key:index,domProps:{"value":city}},[_vm._v(_vm._s(city.cityName))])}))])]),_vm._v(" "),_c('div',{staticClass:"col-6 pl-0"},[_c('div',{staticClass:"input-group mb-2"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.query),expression:"query"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Enter Locality","aria-label":"","name":"x","list":"mycarousel","autocomplete":"off","minlength":"3"},domProps:{"value":(_vm.query)},on:{"focus":function($event){_vm.onFocusLocality()},"input":function($event){if($event.target.composing){ return; }_vm.query=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"form-group mb-0"},[_c('div',{staticClass:"input-group mb-0",class:{ 'focused-search': (_vm.searchtext != '') }},[_c('input',{staticClass:"form-control text-left pl-35",attrs:{"type":"text","placeholder":"Search or Add lab tests","aria-label":"","name":"x","list":"mycarousel","autocomplete":"off","minlength":"3"},on:{"focus":function($event){_vm.openSearchModel()}}}),_vm._v(" "),_c('img',{staticClass:"search-img",attrs:{"src":"static/images/search.svg","alt":""}}),_vm._v(" "),(_vm.isSearchLoading)?_c('div',{staticClass:"test-option"},[_vm._v("\n                              "+_vm._s(_vm.isSearchLoading)+"\n                            ")]):_vm._e()])])])])])]),_vm._v(" "),_c('div',{staticClass:"main-content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[(_vm.labContent && _vm.labLists && _vm.labLists.length > 0 && !_vm.isLabLoading)?_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"title float-left title-width"},[_c('p',[_vm._v("\n                          Showing \n                            "),_c('b',{staticClass:"black-color"},[_vm._v("\n                              "+_vm._s(_vm.labLists.length)+" Labs \n                            ")]),_vm._v(" \n                            in \n                            "),_c('b',{staticClass:"black-color"},[_vm._v("\n                              "+_vm._s(_vm.$localStorage.get('location') ? _vm.$localStorage.get('location').locationName : (_vm.selectedCity ? _vm.selectedCity.cityName : ''))+"\n                            ")]),_vm._v("\n                            , starting from "+_vm._s('Rs.'+_vm.lowestCost)+"\n                        ")])]),_vm._v(" "),_vm._m(0,false,false)]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"lab-list"},[_vm._l((_vm.limitBy(_vm.labLists, _vm.labLimit)),function(lab,index){return _c('div',{key:index,staticClass:"lab"},[_c('div',{staticClass:"lab-title"},[_c('div',{staticClass:"lab-logo mr-2"},[(lab.logo && lab.logo.length > 0)?_c('img',{attrs:{"src":lab.logo}}):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"details"},[_c('h5',[_c('strong',[_vm._v("\n                                        "+_vm._s(lab.labName)+"\n                                      ")])]),_vm._v(" "),_c('p',{staticClass:"mb-0"},[_c('span',{staticClass:"mr-1 ft-s-12"},[_c('i',{staticClass:"fa fa-map-marker green-color",attrs:{"aria-hidden":"true"}}),_vm._v("\n                                        "+_vm._s(lab.branch.branchLocation)+"\n                                      ")])]),_vm._v(" "),_vm._m(1,true,false),_vm._v(" "),_c('div',{staticClass:"lab-rating"},[_c('ul',[_vm._l((parseInt(lab.rating)),function(stars){return _c('li',[_c('i',{staticClass:"material-icons"},[_vm._v("star")])])}),_vm._v(" "),_vm._l((5-parseInt(lab.rating)),function(star_borders){return _c('li',[_c('i',{staticClass:"material-icons"},[_vm._v("star_border")])])})],2)])])]),_vm._v(" "),_c('div',{staticClass:"test-list"},[_c('ul',[_c('li',_vm._l((lab.labTestList),function(tl,key){return _c('span',{key:key},[_c('span',{staticClass:"selected-test"},[_vm._v(_vm._s(tl.aliasName))]),_vm._v(" "),(tl.testId === 0)?_c('span',{staticClass:"selected-test"},[(tl.testId === 0)?_c('span',{staticClass:"blue-color list-popup",on:{"click":function($event){_vm.openProfileTestList(tl.aliasName, tl.testInfo, tl)}}},[_vm._v("\n                                                (includes "+_vm._s(_vm.getIncudedTestAndProfile(tl))+")\n                                            ")]):_vm._e()]):_vm._e(),_vm._v(" "),((lab.labTestList.length > 1 && (key) != (lab.labTestList.length-1)))?_c('span',{attrs:{"id":key}},[_vm._v(" | ")]):_vm._e()])}))])]),_vm._v(" "),(lab.certificationList.length > 0)?_c('p',[_vm._v("Lab certified with")]):_c('p'),_vm._v(" "),_c('div',{staticClass:"certified-price clearfix"}),_vm._v(" "),_c('div',{staticClass:"certified-price clearfix"},[_c('div',{staticClass:"certified"},_vm._l((lab.certificationList),function(cert,index){return _c('div',{key:index,staticClass:"certificate"},[((cert.labCertificateImageId == 1))?_c('img',{attrs:{"src":"static/images/certifi01.jpg","alt":""}}):_vm._e(),_vm._v(" "),((cert.labCertificateImageId == 2))?_c('img',{attrs:{"src":"static/images/certifi03.jpg","alt":""}}):_vm._e(),_vm._v(" "),((cert.labCertificateImageId == 3))?_c('img',{attrs:{"src":"static/images/certifi02.jpg","alt":""}}):_vm._e(),_vm._v(" "),((cert.labCertificateImageId == ''))?_c('img',{attrs:{"src":"static/images/certifi02.jpg","alt":""}}):_vm._e()])})),_vm._v(" "),_c('div',{staticClass:"price",staticStyle:{"float":"right"}},[_c('div',{staticClass:"price-detail"},[_c('h5',{staticClass:"clearfix"},[_c('span',{staticClass:"labo-price"},[_vm._v("\n                                              Rs."+_vm._s(lab.ourCost)+"\n                                            ")]),_vm._v(" "),((lab.actualCost > lab.ourCost))?_c('span',{staticClass:"original-price red-color strip-text"},[_vm._v("\n                                              Rs."+_vm._s(lab.actualCost)+"\n                                            ")]):_vm._e()]),_vm._v(" "),_c('a',{staticClass:"float-right blue-color dropdown-toggle price-break-line-hide",attrs:{"data-toggle":"collapse","href":'#priceCollapse1'+lab.labId,"aria-expanded":"true","aria-controls":'#priceCollapse1'+lab.labId}},[_vm._v("\n                                            Price Breakup\n                                        ")])])])]),_vm._v(" "),_c('div',{staticClass:"collapse",attrs:{"id":'priceCollapse1'+lab.labId}},[_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"price-breake fs-13 w-100"},[_vm._l((lab.labTestList),function(tl,key){return _c('tr',{key:key},[_c('td',{},[_vm._v(_vm._s(tl.aliasName))]),_vm._v(" "),_c('td',{staticClass:"text-nowrap"},[((tl.acutalPrice > tl.ourPrice))?_c('span',{staticClass:"red-color strip-text"},[_vm._v("Rs. "+_vm._s(tl.acutalPrice))]):_vm._e()]),_vm._v(" "),_c('td',{staticClass:"text-nowrap"},[_vm._v("Rs. "+_vm._s(tl.ourPrice))])])}),_vm._v(" "),_c('tr',{staticClass:"grey-color border-top"},[_c('td',{staticClass:"text-nowrap bo"},[_vm._v("Sub Total")]),_vm._v(" "),_c('td',{staticClass:"text-nowrap"}),_vm._v(" "),_c('td',{staticClass:"text-nowrap black-color"},[_vm._v("Rs. "+_vm._s(lab.ourCost))])])],2)])]),_vm._v(" "),(_vm.$localStorage.get('sl'))?_c('div',[(_vm.$localStorage.get('sl').labId === lab.labId)?_c('button',{staticClass:"btn btn-primary full-width mt-15",on:{"click":function($event){_vm.goChooseDate(lab)}}},[_vm._v("\n                                  book appointment\n                              ")]):_c('button',{staticClass:"btn btn-primary full-width mt-15",on:{"click":function($event){_vm.goChooseDate(lab)}}},[_vm._v("\n                                  book appointment\n                              ")])]):_c('button',{staticClass:"btn btn-primary full-width mt-15",on:{"click":function($event){_vm.goChooseDate(lab)}}},[_vm._v("\n                                book appointment\n                            ")])])}),_vm._v(" "),(_vm.labLists.length <= 0)?_c('div',{staticClass:"card  mt-3"},[_c('div',{staticClass:"card-body"},[(_vm.labLists.length <= 0 && !_vm.isLabLoading)?_c('div',{staticClass:"no-labs text-center mt-4"},[_c('img',{attrs:{"src":"static/images/lab-flask.png","alt":""}}),_vm._v(" "),_c('p',[_vm._v("No Labs found for your tests in "+_vm._s(_vm.selectedCity ? _vm.selectedCity.cityName : ''))])]):_vm._e(),_vm._v(" "),(_vm.labLists.length <= 0 && _vm.isLabLoading)?_c('div',{staticClass:"no-labs text-center mt-4"},[_c('img',{attrs:{"src":"static/images/lab-flask.png","alt":""}}),_vm._v(" "),_c('p',[_vm._v("Loading...")])]):_vm._e()])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row mt-3"},[_c('div',{staticClass:"col-sm-6"},[(_vm.labLists.length >_vm.labLimit)?_c('button',{staticClass:"btn btn-outline-primary full-width",on:{"click":function($event){_vm.loadMore()}}},[_vm._v("Show more Labs ("+_vm._s(_vm.labLists.length - _vm.labLimit)+")")]):_vm._e()])])],2)])])])]),_vm._v(" "),_c('div',{staticClass:"fixed-footer p-10",class:{ 'display-none': _vm.selectedProfileAndTest.length === 0 , 'display-block':  _vm.selectedProfileAndTest.length > 0},attrs:{"id":"fixed-footer"}},[_c('h4',{staticClass:"fs-14"},[_vm._v("\n          Lab Test Selected \n          "),_c('span',[_vm._v(_vm._s(_vm.selectedProfileAndTest && _vm.selectedProfileAndTest.length > 0 ? '(' + _vm.selectedProfileAndTest.length + ')' : ''))])]),_vm._v(" "),_c('div',{staticClass:"flex-row footer-test"},[(_vm.selectedProfileAndTest.length <= 0)?_c('span',{staticClass:"chips"},[_vm._v("No test or profile selected")]):_vm._e(),_vm._v(" "),_vm._l((_vm.selectedProfileAndTest),function(sel,index){return _c('div',{key:index,staticClass:"flex-column"},[_c('p',{staticClass:"chips"},[_c('span',{staticClass:"float-left mr-2"},[_vm._v(_vm._s(sel.name))]),_vm._v(" "),_c('i',{staticClass:"material-icons",on:{"click":function($event){$event.preventDefault();_vm.removeSelectedItems(sel)}}},[_vm._v("close")])])])})],2)]),_vm._v(" "),_c('div',{staticClass:"modal fade",attrs:{"id":"test-popup","tabindex":"-1","role":"dialog","aria-labelledby":"exampleModalLabel","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"header"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_vm._m(2,false,false),_vm._v(" "),_c('h3',{staticClass:"screen-title mt-13p"},[_vm._v(_vm._s(_vm.clickedProfileDetails.aliasName))])])])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[(_vm.clickedProfileDetails.patientInstruction && _vm.clickedProfileDetails.patientInstruction.length > 0)?_c('p',[_c('b',[_vm._v("Patient Instruction:")])]):_vm._e(),_vm._v(" "),(_vm.clickedProfileDetails.patientInstruction && _vm.clickedProfileDetails.patientInstruction.length > 0)?_c('p',{staticClass:"black-color"},[_vm._v(_vm._s(_vm.clickedProfileDetails.patientInstruction))]):_vm._e(),_vm._v(" "),((_vm.clickedProfileTests && _vm.clickedProfileTests.length > 0) || (_vm.clickedProfileDetails.includedProfiles && _vm.clickedProfileDetails.includedProfiles.count > 0))?_c('p',{class:{'mt-4' : (_vm.clickedProfileDetails.patientInstruction && _vm.clickedProfileDetails.patientInstruction.length > 0 ) }},[_c('b',[_vm._v("Included Tests("+_vm._s(_vm.getIncudedTestAndProfile(_vm.clickedProfileDetails))+"): ")])]):_vm._e(),_vm._v(" "),((_vm.clickedProfileTests && _vm.clickedProfileTests.length > 0) || (_vm.clickedProfileDetails.includedProfiles && _vm.clickedProfileDetails.includedProfiles.count > 0))?_c('div',{staticClass:"black-color row included-profiles"},[_c('div',{staticClass:"col-sm-12"},[((_vm.clickedProfileDetails.includedProfiles && _vm.clickedProfileDetails.includedProfiles.count > 0))?_c('div',{attrs:{"id":"accordion","role":"tablist"}},_vm._l((_vm.clickedProfileDetails.includedProfiles.data),function(inclProf,index){return _c('div',{key:index,staticClass:"card"},[_c('div',{staticClass:"card-header",attrs:{"role":"tab","id":"headingOne"}},[_c('h5',{staticClass:"mb-0"},[_c('a',{staticClass:"collapsed",attrs:{"data-toggle":"collapse","href":'#collapseOne'+inclProf.panelId,"aria-expanded":"true","aria-controls":"collapseOne"}},[_vm._v("\n                                                "+_vm._s(inclProf.aliasName+' (includes '+ inclProf.ProfileTests.length +' Tests)')+"\n                                                "),_c('i',{staticClass:"material-icons float-right"})])])]),_vm._v(" "),_c('div',{staticClass:"collapse",attrs:{"id":'collapseOne'+inclProf.panelId,"role":"tabpanel","aria-labelledby":"headingOne","data-parent":"#accordion"}},[_c('div',{staticClass:"pl-4"},_vm._l((inclProf.ProfileTests),function(incTest,index){return _c('span',{key:index,staticClass:"mb-2"},[_vm._v(_vm._s(incTest.testName+((inclProf.ProfileTests.length != (index+1))? ' , ' : ''))),_c('br')])}))])])})):_vm._e(),_vm._v(" "),_c('div',{attrs:{"id":"accordion","role":"tablist"}},_vm._l((_vm.clickedProfileTestFirst),function(cli,index){return _c('div',{key:index,staticClass:"card"},[_c('div',{staticClass:"card-header",attrs:{"role":"tab","id":"headingOne"}},[_c('h5',{staticClass:"mb-0"},[_c('a',{staticClass:"collapsed"},[_vm._v("\n                                              "+_vm._s(cli)+"\n                                          ")])])])])})),_vm._v(" "),_c('div',{attrs:{"id":"accordion","role":"tablist"}},_vm._l((_vm.clickedProfileTestSecond),function(cli,index){return _c('div',{key:index,staticClass:"card"},[_c('div',{staticClass:"card-header",attrs:{"role":"tab","id":"headingOne"}},[_c('h5',{staticClass:"mb-0"},[_c('a',{staticClass:"collapsed"},[_vm._v("\n                                            "+_vm._s(cli)+"\n                                        ")])])])])}))])]):_c('div',{staticClass:"black-color"},[_c('p',[_vm._v(" -- No tests available -- ")])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal fade",attrs:{"id":"popupTest","tabindex":"-1","role":"dialog","aria-labelledby":"popupTest","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"header"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"menu_popup",on:{"click":function($event){$event.preventDefault();_vm.goBackLab()}}},[_c('i',{staticClass:"material-icons"},[_vm._v("arrow_back")])]),_vm._v(" "),_c('h3',{staticClass:"screen-title mt-13p"},[_vm._v("Book Test")])])])])]),_vm._v(" "),_c('div',{staticClass:"modal-body p-0"},[_c('div',{staticClass:"search-section"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"form-group mb-0"},[_c('label',[_vm._v("Search or Add lab tests")]),_vm._v(" "),_c('div',{staticClass:"input-group mb-0",class:{ 'focused-search': (_vm.searchtext != '') }},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchtext),expression:"searchtext"}],ref:"searchtext",staticClass:"form-control text-left pl-35",attrs:{"type":"text","placeholder":"Search or Add","aria-label":"","name":"x","list":"mycarousel","autocomplete":"off","minlength":"3"},domProps:{"value":(_vm.searchtext)},on:{"input":function($event){if($event.target.composing){ return; }_vm.searchtext=$event.target.value}}}),_vm._v(" "),_c('img',{staticClass:"search-img",attrs:{"src":"static/images/search.svg","alt":""}})])])])])])]),_vm._v(" "),(_vm.isPopularPackages)?_c('div',{staticClass:"tabs  test-search-popup"},[_vm._m(3,false,false),_vm._v(" "),_c('div',{staticClass:"tab-content test-option",attrs:{"id":"myTabContent"}},[_c('div',{staticClass:"tab-pane fade show active ",attrs:{"id":"test","role":"tabpanel","aria-labelledby":"test-tab"}},[_c('div',{staticClass:"popular-test"},[_c('ul',_vm._l((_vm.popularTests.profile),function(test,index){return _c('li',{key:index,staticClass:"mb-0",on:{"click":function($event){_vm.addTestFromDropdown($event, test, 1, 1)}}},[_c('div',[_c('p',{staticClass:"m-0"},[_c('i',{staticClass:"fa fa-plus mr-2"}),_vm._v(" "+_vm._s(test.name)+"\n                                              "),(test.isSelected === 1)?_c('i',{staticClass:"fa fa-circle green-color",staticStyle:{"font-size":"11px","margin-left":"3px"}}):_vm._e()]),_vm._v(" "),(test.testId != 0 && test.Keywords)?_c('p',{staticClass:"test-key m-0 pl-4"},[_c('b',[_vm._v("Also known as:")]),_vm._v(" "),_c('span',{staticClass:"capitalize"},[_vm._v(_vm._s(test.Keywords))])]):_vm._e(),_vm._v(" "),(test.panelId != 0 && test.ProfileTests && test.ProfileTests.length > 0)?_c('p',{staticClass:"test-key m-0 pl-4"},[_c('b',[_vm._v("Includes "+_vm._s(_vm.getIncudedTestAndProfilePopular(test)))])]):_vm._e()]),_vm._v(" "),_c('div')])}))])])]),_vm._v(" "),_vm._m(4,false,false),_vm._v(" "),_c('div',{staticClass:"tab-content test-option",attrs:{"id":"myTabContent"}},[_c('div',{staticClass:"tab-pane fade show active ",attrs:{"id":"test","role":"tabpanel","aria-labelledby":"test-tab"}},[_c('div',{staticClass:"popular-test"},[_c('ul',_vm._l((_vm.popularTests.test),function(test,index){return _c('li',{key:index,staticClass:"mb-0",on:{"click":function($event){_vm.addTestFromDropdown($event, test, 1, 1)}}},[_c('div',[_c('p',{staticClass:"m-0"},[_c('i',{staticClass:"fa fa-plus mr-2"}),_vm._v(" "+_vm._s(test.name)+"\n                                              "),(test.isSelected === 1)?_c('i',{staticClass:"fa fa-circle green-color",staticStyle:{"font-size":"11px","margin-left":"3px"}}):_vm._e()]),_vm._v(" "),(test.testId != 0 && test.Keywords)?_c('p',{staticClass:"test-key m-0 pl-4"},[_c('b',[_vm._v("Also known as:")]),_vm._v(" "),_c('span',{staticClass:"capitalize"},[_vm._v(_vm._s(test.Keywords))])]):_vm._e(),_vm._v(" "),(test.panelId != 0 && test.ProfileTests && test.ProfileTests.length > 0)?_c('p',{staticClass:"test-key m-0 pl-4"},[_c('b',[_vm._v("Includes "+_vm._s(_vm.getIncudedTestAndProfilePop(test)))])]):_vm._e()]),_vm._v(" "),_c('div')])}))])])])]):_vm._e(),_vm._v(" "),(!_vm.isPopularPackages)?_c('div',{staticClass:"tabs"},[_c('ul',{staticClass:"nav",attrs:{"id":"myTab","role":"tablist"}},[_c('li',{staticClass:"nav-item mb-0",staticStyle:{"font-size":"15px"}},[_c('a',{staticClass:"nav-link active",attrs:{"id":"test-tab","data-toggle":"tab","href":"#test","role":"tab","aria-controls":"test","aria-selected":"true"},on:{"click":function($event){_vm.ProfileAndTests(1)}}},[_c('b',[_vm._v(_vm._s(_vm.searchContent && _vm.searchContent.test && _vm.searchContent.test.length > 0 ? 'Showing ' + _vm.searchContent.test.length + ' results' : 'No Tests available for your search'))])])])]),_vm._v(" "),_c('div',{staticClass:"tab-content test-option",attrs:{"id":"myTabContent"}},[_c('div',{staticClass:"tab-pane fade show active ",attrs:{"id":"test","role":"tabpanel","aria-labelledby":"test-tab"}},[_c('div',{staticClass:"popular-test"},[_c('ul',_vm._l((_vm.searchContent.test),function(test,index){return _c('li',{key:index,staticClass:"mb-0",on:{"click":function($event){_vm.addTestFromDropdown($event, test, 1, 2)}}},[_c('div',[_c('p',{staticClass:"m-0"},[_c('i',{staticClass:"fa fa-plus mr-2"}),_vm._v(" "+_vm._s(test.name)+"\n                                              "),(test.isSelected === 1)?_c('i',{staticClass:"fa fa-circle green-color",staticStyle:{"font-size":"11px","margin-left":"3px"}}):_vm._e()]),_vm._v(" "),(test.testId != 0 && test.Keywords)?_c('p',{staticClass:"test-key m-0 pl-4"},[_c('b',[_vm._v("Also known as:")]),_vm._v(" "),_c('span',{staticClass:"capitalize"},[_vm._v(_vm._s(test.Keywords))])]):_vm._e(),_vm._v(" "),(test.panelId != 0 && test.ProfileTests && test.ProfileTests.length > 0)?_c('p',{staticClass:"test-key m-0 pl-4"},[_c('b',[_vm._v("Includes "+_vm._s(_vm.getIncudedTestAndProfilePop(test)))])]):_vm._e()]),_vm._v(" "),(test.testId > 0)?_c('div',[_c('span',{staticClass:"badge badge-primary"},[_vm._v("Test")])]):_vm._e(),_vm._v(" "),(test.panelId > 0)?_c('div',[_c('span',{staticClass:"badge badge-primary"},[_vm._v("Package")])]):_vm._e()])}))])])])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"fixed-footer p-0",class:{ 'display-none': _vm.selectedProfileAndTest.length === 0 , 'display-block':  _vm.selectedProfileAndTest.length > 0},attrs:{"id":"fixed-footer-modal"}},[_c('div',{staticClass:"test-details-popover",attrs:{"id":"accordion","role":"tablist"}},[_c('div',{staticClass:"card m-0"},[_c('div',{staticClass:"card-header",attrs:{"role":"tab","id":"headingOne"}},[_c('h5',{staticClass:"mb-0"},[_c('a',{staticClass:"collapsed gray-color",attrs:{"data-toggle":"collapse","href":"#testDetails","aria-expanded":"true","aria-controls":"testDetails"}},[_vm._v("\n                                    Selected Tests \n                                    "),_c('span',[_vm._v(_vm._s(_vm.selectedProfileAndTest && _vm.selectedProfileAndTest.length > 0 ? '(' + _vm.selectedProfileAndTest.length + ')' : ''))]),_vm._v(" "),_c('i',{staticClass:"material-icons float-right"})])])]),_vm._v(" "),_c('div',{staticClass:"collapse",attrs:{"id":"testDetails","role":"tabpanel","aria-labelledby":"headingOne","data-parent":"#accordion"}},[_c('div',{staticClass:"card-body pb-0"},[_c('div',{staticClass:"row scroll-test"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"table-responsive test-conformation"},[_c('table',{staticClass:"table mb-0"},[_c('tbody',{staticClass:"black-color"},_vm._l((_vm.selectedProfileAndTest),function(sel,index){return _c('tr',{key:index},[_c('td',[_vm._v("\n                                                          "+_vm._s(sel.name)+"\n                                                        ")]),_vm._v(" "),_c('td',[_c('button',{staticClass:"btn btn-link remove-btn p-0",on:{"click":function($event){$event.preventDefault();_vm.removeSelectedItems(sel)}}},[_c('img',{attrs:{"src":"static/images/close-black.svg","alt":"delete"}})])])])}))])])])])])])])]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary full-width fixed-button",on:{"click":function($event){_vm.goBackLab()}}},[_vm._v("\n                    Show Labs\n                ")])])])])]),_vm._v(" "),_c('div',{staticClass:"modal fade",attrs:{"id":"popupLocality","tabindex":"-1","role":"dialog","aria-labelledby":"popupTest","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"header"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"menu_popup",on:{"click":function($event){_vm.closeLocalityPopup()}}},[_c('i',{staticClass:"material-icons"},[_vm._v("arrow_back")])]),_vm._v(" "),_c('h3',{staticClass:"screen-title mt-13p"},[_vm._v("Choose Locality")])])])])]),_vm._v(" "),_c('div',{staticClass:"search-section"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"form-group mb-0"},[_c('label',[_vm._v("Select Locality")]),_vm._v(" "),_c('div',{staticClass:"input-group mb-0",class:{ 'focused-search': (_vm.searchtext != '') }},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.query),expression:"query"}],ref:"pincode",staticClass:"form-control text-left",attrs:{"type":"text","placeholder":"Search your nearest locality","aria-label":"","name":"x","list":"mycarousel","autocomplete":"off","minlength":"3"},domProps:{"value":(_vm.query)},on:{"blur":function($event){_vm.closeBlock()},"keyup":[function($event){_vm.showHideLocation()},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }_vm.showHideLocation()}],"input":function($event){if($event.target.composing){ return; }_vm.query=$event.target.value}}})])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-12"},[_c('span',[_vm._v("City/ Locality : "),_c('b',[_vm._v(" "+_vm._s(_vm.selectedCity ? _vm.selectedCity.cityName : '-' + ' / ' + (_vm.$localStorage.get('location') ? _vm.$localStorage.get('location').locationName : '-')))])]),_vm._v(" "),_c('br')])])])]),_vm._v(" "),_c('div',{staticClass:"modal-body locality-search-popup"},[_c('div',[_c('div',{staticClass:"popular-test"},[_c('ul',{staticClass:"p-0 m-0"},[_vm._l((_vm.locationList.slice(0, 150)),function(item,index){return _c('li',{key:index,staticClass:"p-2 location-border",on:{"click":function($event){_vm.selectLocation(item)}}},[_c('span',[_vm._v("\n                                "+_vm._s(item.locationName)+"\n                                "),(_vm.locality && item.locationId === _vm.locality.locationId)?_c('i',{staticClass:"fa fa-check green-color",staticStyle:{"font-size":"13px","margin-left":"3px"}}):_vm._e()])])}),_vm._v(" "),(_vm.locationList.length === 0)?_c('li',{staticClass:"text-center"},[_vm._v(" --- No Locations ---")]):_vm._e()],2)])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal fade",attrs:{"id":"sort-by","tabindex":"-1","role":"dialog","aria-labelledby":"sort-byLabel","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_vm._m(5,false,false),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"form-check"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.sortBy),expression:"sortBy"}],attrs:{"type":"radio","id":"sortByLow","name":"sortBy","value":"1"},domProps:{"checked":_vm._q(_vm.sortBy,"1")},on:{"change":[function($event){_vm.sortBy="1"},function($event){_vm.labSortOrder()}]}}),_vm._v(" "),_c('label',{staticClass:"form-check-label",attrs:{"for":"sortByLow"}},[_vm._v("\n                        Price Low to High\n                      ")])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.sortBy),expression:"sortBy"}],attrs:{"type":"radio","id":"sortByHigh","name":"sortBy","value":"2"},domProps:{"checked":_vm._q(_vm.sortBy,"2")},on:{"change":[function($event){_vm.sortBy="2"},function($event){_vm.labSortOrder()}]}}),_vm._v(" "),_c('label',{staticClass:"form-check-label",attrs:{"for":"sortByHigh"}},[_vm._v("\n                        Price High to Low\n                      ")])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.sortBy),expression:"sortBy"}],attrs:{"type":"radio","id":"sortByRate","name":"sortBy","value":"3"},domProps:{"checked":_vm._q(_vm.sortBy,"3")},on:{"change":[function($event){_vm.sortBy="3"},function($event){_vm.labSortOrder()}]}}),_vm._v(" "),_c('label',{staticClass:"form-check-label",attrs:{"for":"sortByRate"}},[_vm._v("\n                        Ratings\n                      ")])])])])])]),_vm._v(" "),_c('FooterVue')],1)}
var Book_Lab_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"filter-section float-right"},[_c('button',{staticClass:"btn btn-link remove-padding",attrs:{"data-toggle":"modal","data-target":"#sort-by"}},[_c('span',{staticClass:"sprites sprite-filter"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h6',{staticClass:"pickup-label"},[_c('span',{staticClass:"badge badge-success"},[_vm._v("Free Home Sample Pickup")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"menu_popup",attrs:{"data-dismiss":"modal","aria-label":"Close"}},[_c('i',{staticClass:"material-icons"},[_vm._v("arrow_back")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"nav",attrs:{"id":"myTab","role":"tablist"}},[_c('li',{staticClass:"nav-item mb-0",staticStyle:{"font-size":"15px"}},[_c('a',{staticClass:"nav-link active",attrs:{"id":"profile-tab","data-toggle":"tab","href":"#test_pop","role":"tab","aria-controls":"test","aria-selected":"true"}},[_c('b',[_vm._v("Popular Packages")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"nav",attrs:{"id":"myTab","role":"tablist"}},[_c('li',{staticClass:"nav-item",staticStyle:{"font-size":"15px"}},[_c('a',{staticClass:"nav-link",attrs:{"id":"test-tab","data-toggle":"tab","href":"#profile_pop","role":"tab","aria-controls":"profile","aria-selected":"false"}},[_c('b',[_vm._v("Popular tests")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"menu_popup",attrs:{"data-dismiss":"modal","aria-label":"Close"}},[_c('i',{staticClass:"material-icons"},[_vm._v("arrow_back")])]),_vm._v(" "),_c('h3',{staticClass:"screen-title mt-13p"},[_vm._v("Sort Lab By")])])])])])}]
var Book_Lab_esExports = { render: Book_Lab_render, staticRenderFns: Book_Lab_staticRenderFns }
/* harmony default export */ var components_mobile_Book_Lab = (Book_Lab_esExports);
// CONCATENATED MODULE: ./src/components/mobile/Book/Lab.vue
function Book_Lab_injectStyle (ssrContext) {
  __webpack_require__("d0wn")
}
var Book_Lab_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var Book_Lab___vue_template_functional__ = false
/* styles */
var Book_Lab___vue_styles__ = Book_Lab_injectStyle
/* scopeId */
var Book_Lab___vue_scopeId__ = "data-v-f4670216"
/* moduleIdentifier (server only) */
var Book_Lab___vue_module_identifier__ = null
var Book_Lab_Component = Book_Lab_normalizeComponent(
  mobile_Book_Lab,
  components_mobile_Book_Lab,
  Book_Lab___vue_template_functional__,
  Book_Lab___vue_styles__,
  Book_Lab___vue_scopeId__,
  Book_Lab___vue_module_identifier__
)

/* harmony default export */ var src_components_mobile_Book_Lab = (Book_Lab_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/Book/LabLocation.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var mobile_Book_LabLocation = ({
  name: 'ChooseLab',
  components: {
    HeaderVue: mobile_Header["a" /* default */],
    FooterVue: mobile_Footer["a" /* default */]
  },
  beforeCreate: function beforeCreate() {
    // if (!this.$localStorage.get('pincode') || !this.$localStorage.get('st') || this.$localStorage.get('st').length === 0) {
    //   this.$router.push({ path: '/test' })
    //   return false
    // }
  },
  data: function data() {
    return {
      labLimit: 10,
      labTests: {},
      labLists: [],
      selectedLab: [],
      isLabLoading: false,
      labDetails: '',
      selectedProfileAndTest: [],
      totalLabs: [],
      limitedLabs: [],
      _s3BucketUrl: '',
      clickedProfileName: '',
      clickedProfileDetails: [],
      clickedProfileTests: [],
      clickedProfileTestFirst: [],
      clickedProfileTestSecond: [],
      labSearchContent: 'Loading...',
      labContent: false,
      pincodeButton: false,
      ProfileAndTest: [],
      searchContent: {
        test: [],
        profile: []
      },
      masterTestAndProfile: {
        test: [],
        profile: []
      },
      isSearchLoading: false,
      searchtext: '',
      result_focus: '',
      locationList: [],
      locationMasterList: [],
      selectedCity: undefined,
      locality: '',
      pincode: '',
      pincodeError: false,
      onBlurKey: false,
      query: undefined,
      sortBy: 1,
      lowestCost: undefined,
      currentLocation: null,
      locationAllowed: false,
      locationChanged: false,
      popularTests: {},
      sideBannerAds: [],
      isPopularPackages: false
    };
  },

  mounted: function mounted() {
    var _this = this;

    this.$root.$on('removeProfileAndTest', function (selectedProfileAndTest) {
      _this.selectedProfileAndTest = selectedProfileAndTest;
      _this.getLab();
    });
  },
  watch: {
    searchtext: function searchtext() {
      this.getProfileAndTests();
    }
  },
  created: function created() {
    if (this.$route.params.city) {
      this.getTestByFilter();
    }
    return false;
    if (this.$localStorage.get('pincode')) {
      this.pincode = this.$localStorage.get('pincode');
    }
    if (this.$localStorage.get('location')) {
      this.locality = this.$localStorage.get('location');
      this.query = this.locality.locationName;
    } else {
      this.pincodeButton = true;
      // setTimeout(function () {
      //   this.$refs.pincode.focus()
      // }.bind(this), 300)
    }
    if (this.$localStorage.get('st')) {
      this.selectedProfileAndTest = this.$localStorage.get('st');
    }
    this.selectedLab = [];
    if (this.$localStorage.get('sl')) {
      this.selectedLab = this.$localStorage.get('sl');
    }

    this.selectedProfileAndTest = [];
    if (this.$localStorage.get('st')) {
      this.selectedProfileAndTest = this.$localStorage.get('st');
    }
    // this.getLab()
    this.getLab();
    this.getAllProfileAndTests();
    this.getPopularTest();
  },

  methods: {
    getIncudedTestAndProfile: function getIncudedTestAndProfile(tl) {
      var testCountVal = 0;

      if (tl.profileTestsCount && tl.profileTestsCount > 0) {
        testCountVal = testCountVal + tl.profileTestsCount;
      }
      if (tl.package == 1) {
        if (tl.includedProfiles && tl.includedProfiles.count > 0) {
          tl.includedProfiles.data.forEach(function (testObj) {
            testCountVal = testCountVal + testObj.ProfileTests.length;
          });
        }
      }
      return testCountVal ? testCountVal + ' Test(s)' : '';
    },
    getIncudedTestAndProfilePop: function getIncudedTestAndProfilePop(tl) {
      var testCountVal = 0;
      if (tl.testCount && tl.testCount > 0) {
        testCountVal = testCountVal + tl.testCount;
      }
      if (tl.package == 1) {
        if (tl.includedProfiles && tl.includedProfiles.count > 0) {
          tl.includedProfiles.data.forEach(function (testObj) {
            testCountVal = testCountVal + testObj.ProfileTests.length;
          });
        }
      }
      return testCountVal ? testCountVal + ' Tests' : '';
    },
    getIncudedTestAndProfilePopup: function getIncudedTestAndProfilePopup(tl) {
      var profileCountStr = '';
      if (tl.package == 1) {
        if (tl.includedProfiles && tl.includedProfiles.count > 0) {
          profileCountStr = tl.includedProfiles.count + ' Profile(s)';
        }
      }
      var testCountStr = '';
      if (tl.testCount && tl.testCount > 0) {
        testCountStr = tl.testCount + ' Test(s)';
      }
      return profileCountStr + (profileCountStr.length > 0 && testCountStr.length > 0 ? ' & ' : '') + testCountStr;
    },
    getIncudedTestAndProfilePopular: function getIncudedTestAndProfilePopular(tl) {
      var profileCountStr = '';
      if (tl.package == 1) {
        if (tl.includedProfiles && tl.includedProfiles.count > 0) {
          profileCountStr = tl.includedProfiles.count + ' Profile(s)';
        }
      }
      var testCountStr = '';
      if (tl.ProfileTestCount && tl.ProfileTestCount > 0) {
        testCountStr = tl.ProfileTestCount + ' Test(s)';
      }
      return profileCountStr + (profileCountStr.length > 0 && testCountStr.length > 0 ? ' & ' : '') + testCountStr;
    },
    geolocation: function geolocation() {
      var options = {
        maximumAge: 60000,
        timeout: 5000,
        enableHighAccuracy: true
      };
      navigator.geolocation.getCurrentPosition(function (position) {
        console.log('im tracking you!');
        this.currentLocation = {
          lat: position.coords.latitude,
          lng: position.coords.longitude
        };
        this.changeCityUsingLocation();
        return false;
      }.bind(this), function (error) {
        if (error.code === error.PERMISSION_DENIED) {
          console.log('you denied me :-(');
          this.locationAllowed = false;
          if (!this.$localStorage.get('sc') && this.selectedCity) {
            this.$localStorage.set('sc', this.selectedCity);
          }
        }
      }.bind(this)), options;
    },
    changeCityUsingLocation: function changeCityUsingLocation() {
      var data = {
        coordinates: this.currentLocation
      };
      promise_default.a.resolve(this.$POST('patient/getCityUsingLocation', data)).then(function (res) {
        if (res.response_code === 0) {
          if (!this.$localStorage.get('sc')) {
            this.locationMasterList.forEach(function (city) {
              if (res.response.cityId === city.cityId) {
                if (this.selectedCity.cityId !== city.cityId) {
                  this.selectedCity = city;
                  this.$localStorage.set('sc', this.selectedCity);
                  this.selectBannerAds();
                  this.locationList = city.ActiveLocation;
                  this.selectedCity.ActiveLocation.forEach(function (loc) {
                    if (res.response.locationId === loc.locationId) {
                      this.locality = loc;
                      this.pincode = loc.locationZipCode;
                      this.query = loc.locationName;
                      this.$localStorage.set('location', loc, 0);
                      this.$localStorage.set('pincode', this.pincode, 0);
                    }
                  }.bind(this));
                  this.onCityChange();
                } else {
                  if (!this.$localStorage.get('location')) {
                    this.selectedCity.ActiveLocation.forEach(function (loc) {
                      if (res.response.locationId === loc.locationId) {
                        this.locality = loc;
                        this.pincode = loc.locationZipCode;
                        this.query = loc.locationName;
                        this.$localStorage.set('location', loc, 0);
                        this.$localStorage.set('pincode', this.pincode, 0);
                        this.$router.push('/labs/' + this.selectedCity.cityName + '/' + this.$route.params.test + '/' + loc.locationName);
                      }
                    }.bind(this));
                  }
                }
                this.getLab();
              }
            }.bind(this));
          } else if (!this.$localStorage.get('location')) {
            this.selectedCity.ActiveLocation.forEach(function (loc) {
              if (res.response.locationId === loc.locationId) {
                this.locality = loc;
                this.pincode = loc.locationZipCode;
                this.query = loc.locationName;
                this.$localStorage.set('location', loc, 0);
                this.$localStorage.set('pincode', this.pincode, 0);
              }
            }.bind(this));
            this.getLab();
          }
          if (!this.$localStorage.get('sc') && this.selectedCity) {
            this.$localStorage.set('sc', this.selectedCity);
          }
        } else {
          if (!this.$localStorage.get('sc') && this.selectedCity) {
            this.$localStorage.set('sc', this.selectedCity);
          }
        }
      }.bind(this)).catch(function (err) {
        console.error(err);
      });
    },
    closeLocalityPopup: function closeLocalityPopup() {
      this.onBlurKey = false;
      this.query = this.locality ? this.locality.locationName : '';
      $('#popupLocality').modal("hide");
    },
    ProfileAndTests: function ProfileAndTests(value) {
      if (value === 1) {
        this.getAllProfileAndTests();
      } else {
        this.getAllProfileAndTests();
      }
    },
    openSearchModel: function openSearchModel() {
      $('#popupTest').modal("show");
      setTimeout(function () {
        this.$refs.searchtext.focus();
        this.getAllProfileAndTests();
      }.bind(this), 800);
    },
    goBackLab: function goBackLab() {
      $('#popupTest').modal('hide');
    },
    getLocation: function getLocation() {
      var data = {
        currentLocation: this.currentLocation,
        locationAllowed: this.locationAllowed
      };
      promise_default.a.resolve(this.$POST('patient/getCityAndLocation', data)).then(function (res) {
        if (res.response_code === 0) {
          this.locationMasterList = res.response;
          if (this.selectedCity) {
            this.locationMasterList.forEach(function (city) {
              if (this.selectedCity.cityId === city.cityId) {
                this.selectedCity = city;
                this.$localStorage.set('sc', this.selectedCity);
                this.selectBannerAds();
                this.locationList = city.ActiveLocation;
              }
            }.bind(this));
          } else {
            if (this.locationMasterList.length > 0) {
              this.selectedCity = this.locationMasterList[0];
              this.$localStorage.set('sc', this.selectedCity);
              this.selectBannerAds();
              this.locationList = this.locationMasterList[0].ActiveLocation;
            } else {
              this.selectedCity = undefined;
              this.locationList = [];
            }
          }
        }
      }.bind(this)).catch(function (err) {
        console.error(err);
      });
    },
    getPopularTest: function getPopularTest() {
      var data = {
        selectedProfileAndTest: this.selectedProfileAndTest
      };
      promise_default.a.resolve(this.$POST('patient/getPopularTestList', data)).then(function (res) {
        if (res.response_code === 0) {
          this.popularTests = {
            test: res.response.test.slice(0, 5),
            profile: res.response.profile.slice(0, 5)
          };
          this.$hidePageLoading();
        }
      }.bind(this)).catch(function (err) {
        console.error(err);
      });
    },
    labSortOrder: function labSortOrder() {
      if (this.sortBy === '1') {
        this.labLists.sort(function (a, b) {
          a = a.ourCost;
          b = b.ourCost;
          return a < b ? -1 : 1;
        });
      } else if (this.sortBy === '2') {
        this.labLists.sort(function (a, b) {
          a = a.ourCost;
          b = b.ourCost;
          return a > b ? -1 : 1;
        });
      } else if (this.sortBy === '3') {
        this.labLists.sort(function (a, b) {
          a = a.rating;
          b = b.rating;
          return a > b ? -1 : 1;
        });
      }
      setTimeout(function () {
        $('#sort-by').modal("hide");
      }, 500);
      // this.getLab()
    },
    adsRedirect: function adsRedirect(url) {
      if (this.pincode && this.pincode.length === 6) {
        url = url + '/' + this.locality.locationName;
      }
      window.open(url, '_blank');
    },
    getTestByFilter: function getTestByFilter(type) {
      var testsArr = [];
      if (this.$route.params.test && this.$route.params.test.length > 0) {
        var testKeyArray = this.$route.params.test.split('&');
        testKeyArray.forEach(function (testName) {
          var testNameData = testName ? testName.split('_').join(' ') : '';
          testsArr.push(testNameData);
        });
      }
      var locationKey = this.$route.params.location ? this.$route.params.location.split('_').join(' ') : '';
      var data = {
        'city': this.$route.params.city ? this.$route.params.city : '',
        'location': this.$route.params.location ? locationKey : undefined,
        'test': testsArr
      };
      this.$localStorage.remove('sc');
      this.$localStorage.remove('location');
      this.$localStorage.remove('pincode');
      this.$localStorage.remove('st');
      promise_default.a.resolve(this.$POST('patient/getTestByFilter', data)).then(function (res) {
        // this.geolocation()
        this.getLocation();
        if (res.response_code === 0) {
          if (res.response.city && res.response.city != null) {
            this.selectedCity = res.response.city;
            this.$localStorage.set('sc', this.selectedCity);
            this.selectBannerAds();
            if (res.response.city.ActiveLocation && res.response.city.ActiveLocation.length > 0) {
              this.$localStorage.set('location', res.response.city.ActiveLocation[0]);
              this.$localStorage.set('pincode', res.response.city.ActiveLocation[0].locationZipCode);
              this.closePopup(0);
            } else {
              this.geolocation();
              if (!this.$localStorage.get('ftp')) {
                this.$localStorage.set('ftp', 'YES', 0);
                $('.carousel').carousel({
                  interval: 2000
                });
                // $('html').css({"position":"fixed", "width":"100%"});
                setTimeout(function () {
                  $('.flash-message').css("opacity", "1");
                  $('.black-overlay').css("opacity", "1");
                  // this.$refs.pincodePopup.focus()
                }.bind(this), 1000);
              } else {
                // this.$localStorage.remove('ftp')
                this.closePopup(0);
              }
            }
          }
          // if(res.response.location && res.response.location != null){
          //   // this.$localStorage.set('location',res.response.location)
          //   // this.$localStorage.set('pincode', res.response.location.locationZipCode)
          //   // this.closePopup(0)
          // }else{
          //   if(!this.$localStorage.get('ftp')){
          //     this.$localStorage.set('ftp','YES',0)
          //     $('.carousel').carousel({
          //       interval: 2000
          //     });
          //     // $('html').css({"position":"fixed", "width":"100%"});
          //     setTimeout(function () {
          //       $('.flash-message').css("opacity", "1");
          //       $('.black-overlay').css("opacity", "1");
          //       // this.$refs.pincodePopup.focus()
          //     }.bind(this), 1000);
          //   }else{
          //     // this.$localStorage.remove('ftp')
          //     this.closePopup(0)
          //   }
          // }
          if (res.response.selectedTest && res.response.selectedTest.length > 0) {
            this.selectedProfileAndTest = [];
            document.title = res.response.selectedTest[0].name + ' - Labotist';
            // res.response.selectedTest
            this.selectedProfileAndTest = res.response.selectedTest;
            this.$localStorage.set('st', this.selectedProfileAndTest);
            this.$root.$emit('selectedProfileAndTest', this.selectedProfileAndTest);
            this.getLab(res.response.selectedTest.name);
          } else {
            this.selectedLab = [];
            this.labSearchContent = 'No labs found in your searched locations.';
            this.$localStorage.remove('sl');
          }
          this.afterCreate();
          this.getPopularTest();
        }
        this.$hidePageLoading();
      }.bind(this)).catch(function (err) {
        console.error(err);
      });
    },
    closePopup: function closePopup(type) {
      if (type === 1) {
        if (!this.pincode || this.pincode.length !== 6) {
          this.showLocalityError = true;
          return false;
        }
      }
      if (type === 2) {
        this.query = undefined;
        // $('html').css({"position":"relative", "width":"100%"});
      }
      if (type === 3) {
        // $('html').css({"position":"relative", "width":"100%"});
      }
      $('.flash-message').addClass('bounce');
      $('.black-overlay').css("opacity", '0');
      setTimeout(function () {
        $('.flash-message').css('opacity', '0');
        $('.flash-message').css('bottom', '-500px');
        $('.black-overlay').css('display', 'none');
        setTimeout(function () {
          $('.flash-message').css('display', 'none');
        }, 400);
      }, 400);
    },
    afterCreate: function afterCreate() {
      if (this.$localStorage.get('pincode')) {
        this.pincode = this.$localStorage.get('pincode');
      }
      if (this.$localStorage.get('location')) {
        this.locality = this.$localStorage.get('location');
        this.query = this.locality.locationName;
      } else {
        this.pincodeButton = true;
        // setTimeout(function () {
        //   this.$refs.pincodePopup.focus()
        // }.bind(this), 300)
      }
    },
    loadMore: function loadMore() {
      var increamented = this.labLimit + 10;
      this.labLimit = increamented > this.labLists.length ? this.labLists.length : increamented;
    },
    goSearch: function goSearch() {
      this.$router.push({ path: '/lab' });
    },
    goChooseDate: function goChooseDate(lab) {
      if (!this.locality || !this.selectedCity) {
        var confirmFn = function () {
          setTimeout(function () {
            this.onFocusLocality();
          }.bind(this), 300);
        }.bind(this);
        this.$Simplert.open({
          title: 'Information',
          message: 'Please choose your nearest locality',
          type: 'warning',
          useConfirmBtn: false,
          onClose: confirmFn,
          customCloseBtnText: 'Ok',
          disableOverlayClick: true,
          showXclose: true
        });
        return false;
      }
      this.$localStorage.remove('location');
      this.$localStorage.remove('pincode');
      this.$localStorage.remove('sc');
      this.$localStorage.set('location', this.locality);
      this.$localStorage.set('pincode', this.locality.locationZipCode);
      this.$localStorage.set('sc', this.selectedCity);

      this.$localStorage.remove('ct');
      this.$localStorage.remove('cou');
      if (this.$localStorage.get('sl')) {
        if (this.$localStorage.get('sl').labId !== lab.labId) {
          this.$localStorage.remove('ct');
        }
      }
      this.selectedLab = lab;
      this.$localStorage.set('sl', lab, 30 * 60 * 1000);
      this.$localStorage.set('st', this.selectedProfileAndTest);
      vue_esm["default"].analytics.fbq.event('ViewContent', {
        content_ids: lab.labId,
        content_name: lab.labName,
        contents: { id: lab.labId, name: lab.labName },
        content_type: 'LAB'
      });
      this.$router.push({ path: '/appointment' });
    },
    onFocusLocality: function onFocusLocality() {
      $('#popupLocality').modal('show');
      setTimeout(function () {
        this.$refs.pincode.focus();
        this.$refs.pincode.select();
      }.bind(this), 800);
      this.query = '';
      this.onBlurKey = true;
      this.showHideLocation();
    },
    openProfileTestList: function openProfileTestList(profileName, testinfo, tl) {
      // alert(profileName)
      this.clickedProfileDetails = [];
      this.clickedProfileTests = [];
      this.clickedProfileName = profileName;
      this.clickedProfileDetails = tl;
      this.clickedProfileTestFirst = [];
      this.clickedProfileTestSecond = [];
      if (tl.testNames) {
        this.clickedProfileTests = tl.testNames.split(',');
        if (this.clickedProfileTests.length > 8) {
          if (this.clickedProfileTests.length > 5) {
            this.clickedProfileTestFirst = this.clickedProfileTests.slice(0, parseInt(this.clickedProfileTests.length / 2) + this.clickedProfileTests.length % 2);
            this.clickedProfileTestSecond = this.clickedProfileTests.slice(parseInt(this.clickedProfileTests.length / 2) + this.clickedProfileTests.length % 2, this.clickedProfileTests.length);
          } else {
            this.clickedProfileTestFirst = this.clickedProfileTests;
          }
        } else {
          this.clickedProfileTestFirst = this.clickedProfileTests;
        }
      }
      $('#test-popup').modal('show');
      // this.clickedProfileTests = (tl.testNames)
    },
    openPopularProfileTestList: function openPopularProfileTestList(profile) {
      profile['testCount'] = profile.ProfileTests ? profile.ProfileTests.length : 0;
      profile['aliasName'] = profile.name;
      this.clickedProfileDetails = [];
      this.clickedProfileTests = [];
      this.clickedProfileName = profile.name;
      this.clickedProfileDetails = profile;
      // this.clickedProfileDetails
      this.clickedProfileTestFirst = [];
      this.clickedProfileTestSecond = [];
      if (profile.ProfileTests) {
        this.clickedProfileTests = profile.ProfileTests;
        if (this.clickedProfileTests.length > 8) {
          if (this.clickedProfileTests.length > 5) {
            this.clickedProfileTestFirst = this.clickedProfileTests.slice(0, parseInt(this.clickedProfileTests.length / 2) + this.clickedProfileTests.length % 2);
            this.clickedProfileTestSecond = this.clickedProfileTests.slice(parseInt(this.clickedProfileTests.length / 2) + this.clickedProfileTests.length % 2, this.clickedProfileTests.length);
          } else {
            this.clickedProfileTestFirst = this.clickedProfileTests;
          }
        } else {
          this.clickedProfileTestFirst = this.clickedProfileTests;
        }
      }
      $('#test-popup').modal('show');
    },
    getLab: function getLab(selectedTestName) {
      this.labContent = false;
      this.ProfileAndTest = [];
      this.labLists = [];
      this.isLabLoading = true;
      var data = {
        'zipCode': this.$localStorage.get('pincode'),
        'locality': this.$localStorage.get('location') ? this.$localStorage.get('location') : null,
        'locationCoordinate': this.$localStorage.get('location') ? this.$localStorage.get('location').locationCoordinate : null,
        'sortBy': this.sortBy,
        'city': this.selectedCity
      };
      var test = [];
      if (this.selectedProfileAndTest.length > 0) {
        this.selectedProfileAndTest.forEach(function (element) {
          if (element.testId > 0) {
            test.push(element.testId);
          }
        }, this);
      }
      data.test = test;

      var profile = [];
      if (this.selectedProfileAndTest.length > 0) {
        this.selectedProfileAndTest.forEach(function (element) {
          if (element.panelId > 0) {
            profile.push(element.panelId);
          }
        }, this);
      }
      data.profile = profile;
      promise_default.a.resolve(this.$POST('patient/getLab', data)).then(function (res) {
        if (res.response_code === 0) {
          this.isLabLoading = false;
          this.s3BucketUrl = this.$_s3BucketUrl;
          this.labContent = true;
          if (res.response.labList.length > 0) {
            this.labLists = res.response.labList;
            this.lowestCost = res.response.lowestCost;
            if (selectedTestName) {
              var description = 'Book ' + selectedTestName + ', Starting from Rs.' + res.response.lowestCost + ' in ' + (this.$localStorage.get('location') ? this.$localStorage.get('location').locationName : this.selectedCity.cityName) + '. Hygienic and top notch home sample collection';
              this.appendMetaTag(description);
            }
          } else {
            this.selectedLab = [];
            this.labSearchContent = 'No labs found in your searched locations.';
            this.$localStorage.remove('sl');
          }
        } else {
          this.isLabLoading = false;
          this.selectedLab = [];
          this.labSearchContent = 'No labs found in your searched locations.';
          this.$localStorage.remove('sl');
        }
        this.$hidePageLoading();
      }.bind(this)).catch(function (err) {
        console.error(err);
      });
    },
    appendMetaTag: function appendMetaTag(description) {
      var metatag = document.head.querySelector("meta[name='description']");
      if (metatag) {
        metatag.content = description;
      }
      var ogmetatag = document.head.querySelector("meta[property='og:description']");
      if (ogmetatag) {
        ogmetatag.content = description;
      }
    },
    getLabDetails: function getLabDetails(lab) {
      try {
        this.labDetails = '';
        if (this.$localStorage.get('access_token') !== '') {
          var data = {
            'labId': lab.labId
          };
          promise_default.a.resolve(this.$POST('patient/getLabDetails', data)).then(function (res) {
            if (res.response_code === 0) {
              this.labDetails = res.response;
            }
          }.bind(this)).catch(function (err) {
            console.error(err);
          });
        }
      } catch (e) {
        console.error(e);
      }
    },
    clearProfileAndTests: function clearProfileAndTests() {
      this.searchContent = {
        test: [],
        profile: []
      };
    },
    getAllProfileAndTests: function getAllProfileAndTests() {
      if (this.searchtext === '') {
        this.isPopularPackages = true;
      } else {
        this.isPopularPackages = false;
      }
      var data = {
        'keyword': '',
        selectedProfileAndTest: this.selectedProfileAndTest
      };
      promise_default.a.resolve(this.$POST('patient/getProfileAndTestList', data)).then(function (res) {
        if (res.response_code === 0) {
          if (!res.response.test || !res.response.profile) {
            this.isSearchLoading = 'No Result';
          } else {
            this.masterTestAndProfile = {
              tests: res.response.test,
              profile: res.response.profile,
              test: res.response.test.concat(res.response.profile)
            };
            if (this.searchtext.length > 0) {
              this.getProfileAndTests();
            }
          }
        }
      }.bind(this)).catch(function (err) {
        console.error(err);
      });
    },
    getProfileAndTests_old: function getProfileAndTests_old() {
      if (this.searchtext === '') {
        this.isPopularPackages = true;
        return;
      } else {
        this.isPopularPackages = false;
      }
      this.isSearchLoading = 'Loading...';
      var data = {
        'keyword': this.searchtext,
        selectedProfileAndTest: this.selectedProfileAndTest
      };
      promise_default.a.resolve(this.$POST('patient/getProfileAndTestList', data)).then(function (res) {
        if (res.response_code === 0) {
          if (!res.response.test || !res.response.profile) {
            this.isSearchLoading = 'No Result';
          } else {
            this.isSearchLoading = false;
            var test = res.response.test.sort(this.testSort);
            var profile = res.response.profile.sort(this.testSort);
            // test = test.sort(this.profileSort)
            // profile = profile.sort(this.profileSort)
            this.searchContent = {
              test: test,
              profile: profile
            };
          }
        }
      }.bind(this)).catch(function (err) {
        console.error(err);
      });
    },
    getProfileAndTests: function getProfileAndTests() {
      if (this.searchtext === '') {
        this.isPopularPackages = true;
        return;
      } else {
        this.isPopularPackages = false;
      }
      this.isSearchLoading = 'Loading...';
      var profileOptions = {
        shouldSort: true,
        threshold: 0.6,
        location: 0,
        // distance: 20,
        maxPatternLength: 32,
        minMatchCharLength: 1,
        keys: ["name", "Keywords", "ProfileTests"]
      };

      var testFuse = new fuse_default.a(this.masterTestAndProfile.test, profileOptions); // "list" is the item array

      this.searchContent = {
        test: testFuse.search(this.searchtext)
      };
      this.isSearchLoading = false;
    },
    testSort: function testSort(a, b) {
      a = a.name.toUpperCase();
      b = b.name.toUpperCase();
      if (a.indexOf(this.searchtext.toUpperCase()) === -1) {
        return 1;
      } else if (b.indexOf(this.searchtext.toUpperCase()) === -1) {
        return -1;
      }
      return a.indexOf(this.searchtext.toUpperCase()) < b.indexOf(this.searchtext.toUpperCase()) ? -1 : 1;
    },
    updateSelectedTest: function updateSelectedTest(test, isTest, isPopular) {
      if (isTest === 1 && isPopular === 1) {
        if (this.popularTests.test && this.popularTests.test.length > 0) {
          this.popularTests.test.forEach(function (testValue, index) {
            if (testValue.testId === test.testId) {
              this.popularTests.test[index].isSelected = 1;
            }
          }.bind(this));
        }
      } else if (isTest === 2 && isPopular === 1) {
        var popularProfile = this.popularTests.profile;
        if (popularProfile && popularProfile.length > 0) {
          popularProfile.forEach(function (profileValue, index) {
            if (profileValue.panelId === test.panelId) {
              popularProfile[index].isSelected = 1;
              this.popularTests.profile = popularProfile;
            }
          }.bind(this));
        }
      } else if (isTest === 1 && isPopular === 2 && test.testId > 0) {
        var testList = this.searchContent.test;
        if (testList && testList.length > 0) {
          testList.forEach(function (profileValue, index) {
            if (profileValue.testId === test.testId) {
              testList[index].isSelected = 1;
              this.searchContent.test = testList;
            }
          }.bind(this));
        }
      } else if (isTest === 1 && isPopular === 2 && test.panelId > 0) {
        var profileList = this.searchContent.profile;
        if (profileList && profileList.length > 0) {
          profileList.forEach(function (profileValue, index) {
            if (test.panelId > 0 && profileValue.panelId === test.panelId) {
              profileList[index].isSelected = 1;
              this.searchContent.profile = profileList;
            }
          }.bind(this));
        }
      }
    },
    addTestFromDropdown: function addTestFromDropdown(event, test, isTest, isPopular) {
      if (test.isSelected === 1) {
        return false;
      }
      if (isTest && isPopular) {
        setTimeout(function () {
          this.updateSelectedTest(test, isTest, isPopular);
        }.bind(this), 100);
      }
      if (test.testId === 0) {
        this.addTestAndProfile(test);
      } else {
        var filterProfile = [];
        underscore_default.a.each(this.selectedProfileAndTest, function (ele, key) {
          if (ele.testId === 0) {
            filterProfile.push(ele);
          }
        });
        if (filterProfile.length > 0) {
          var LabProfileTestsCount = 0;
          var splitArrayCount = 0;
          var isExistsCount = 0;
          var ExistsArray = [];
          underscore_default.a.each(filterProfile, function (value, key) {
            if (value.LabProfileTests && value.LabProfileTests !== '') {
              var splitArray = value.LabProfileTests.split(',').map(function (item) {
                return item.trim().toUpperCase();
              });
              if (splitArray.indexOf(test.name.toUpperCase()) === '-1') {
                splitArrayCount++;
              } else {
                isExistsCount++;
                ExistsArray.push(value.name);
              }
            } else {
              LabProfileTestsCount++;
            }
          });
          if (LabProfileTestsCount === filterProfile.length) {
            this.addTestAndProfile(test);
          } else if (splitArrayCount === filterProfile.length) {
            this.addTestAndProfile(test);
          } else if (isExistsCount > 0) {
            var confirmFn = function () {
              this.addTestAndProfile(test, true);
            }.bind(this);

            this.$Simplert.open({
              title: 'Confirm',
              message: 'The test that you have selected is already included in one of the profile added to the cart\u201D Just have ok button, no need for cancel.',
              type: 'info',
              useConfirmBtn: true,
              onConfirm: confirmFn,
              customConfirmBtnText: 'Ok',
              customCloseBtnText: 'Cancel',
              disableOverlayClick: true
            });
          } else {
            this.addTestAndProfile(test);
          }
        } else {
          this.addTestAndProfile(test);
        }
      }
    },
    addTestAndProfile: function addTestAndProfile(test, isPopup) {
      this.$localStorage.remove('sl');
      this.$localStorage.remove('ct');
      this.$localStorage.remove('cou');
      if (underscore_default.a.pluck(this.selectedProfileAndTest, 'name').indexOf(test.name) === -1) {
        this.selectedProfileAndTest.push(test);
        if (isPopup) {
          this.$apply(function () {
            this.selectedProfileAndTest = underscore_default.a.uniq(this.selectedProfileAndTest);
          });
        } else {
          this.selectedProfileAndTest = underscore_default.a.uniq(this.selectedProfileAndTest);
        }
        var testFB = {
          id: test.testId === 0 ? test.panelId : test.testId,
          isTest: test.testId === 0 ? 0 : 1,
          name: test.name
        };
        if (test.testId === 0) {
          vue_esm["default"].analytics.fbq.event('ViewContent', {
            content_ids: test.testId === 0 ? test.panelId : test.testId,
            content_name: test.name,
            contents: testFB,
            content_type: 'PROFILE'
          });
        } else {
          vue_esm["default"].analytics.fbq.event('ViewContent', {
            content_ids: test.testId === 0 ? test.panelId : test.testId,
            content_name: test.name,
            contents: testFB,
            content_type: 'TEST'
          });
        }
        this.$localStorage.set('st', this.selectedProfileAndTest);
        this.$root.$emit('selectedProfileAndTest', this.selectedProfileAndTest);
      }
      this.searchtext = '';
      // this.getLab()
      // this.getPopularTest()
      $('#popupTest').modal("hide");
      this.$router.push({ path: '/lab' });
    },
    removeSelectedItems: function removeSelectedItems(items) {
      var index = this.selectedProfileAndTest.indexOf(items);
      this.selectedProfileAndTest.splice(index, 1);
      this.$localStorage.set('st', this.selectedProfileAndTest, 0);
      this.$localStorage.remove('cou');
      if (this.selectedProfileAndTest.length === 0) {
        this.$localStorage.remove('sl');
        this.$localStorage.remove('ct');
      }
      var lab = this.$localStorage.get('sl');
      var labTests = [];
      this.$localStorage.remove('sl');
      if (lab) {
        lab.labTestList.forEach(function (labTest) {
          if (!(items.testId === labTest.testId && labTest.testId !== 0 || items.panelId === labTest.panelId && labTest.panelId !== 0)) {
            labTests.push(labTest);
          }
        });
        lab.labTestList = labTests;
      }
      this.$localStorage.set('sl', lab, 30 * 60 * 1000);

      this.$root.$emit('selectedProfileAndTest', this.selectedProfileAndTest);
      // this.getLab()
      // this.getPopularTest()
      $('#popupTest').modal("hide");
      this.$router.push({ path: '/lab' });
    },
    searchLocation: function searchLocation() {
      // this.onBlurKey = true
      this.locality = undefined;
      this.pincode = undefined;
      var pincode = this.$localStorage.get('pincode');
      this.$localStorage.remove('location');
      this.$localStorage.remove('pincode');
      if (pincode) {
        this.getLab();
      }

      // if (this.query.length < 3) {
      //   this.onBlurKey = false
      //   this.locationList = []
      //   return false
      // }
      try {
        if (this.$localStorage.get('access_token') !== '') {
          var data = {
            'keyword': ''
          };
          promise_default.a.resolve(this.$POST('patient/searchLocation', data)).then(function (res) {
            if (res.response_code === 0) {
              this.locationList = res.response;
              this.locationMasterList = res.response;
            }
          }.bind(this)).catch(function (err) {
            console.error(err);
          });
        }
      } catch (e) {
        console.error(e);
      }
    },
    onCityChange: function onCityChange() {
      var localityCheck = undefined;
      this.$localStorage.set('sc', this.selectedCity);
      this.$localStorage.remove('sl');
      this.$localStorage.remove('ct');
      this.$localStorage.remove('cou');
      this.selectBannerAds();
      this.selectedCity.ActiveLocation.forEach(function (location) {
        if (this.locality && this.locality.locationId === location.locationId) {
          localityCheck = location;
        }
      }.bind(this));
      if (!localityCheck) {
        this.locality = undefined;
        this.pincode = '';
        this.query = '';
        this.$localStorage.remove('location');
        this.$localStorage.remove('pincode');
      }
      // this.getLab()
      this.$router.push({ path: '/lab' });
    },
    locationFilterAlphabet: function locationFilterAlphabet(a, b) {
      a = a.locationName;
      b = b.locationName;
      if (a < b) return -1;
      if (a > b) return 1;
      return 0;
    },
    locationFilter: function locationFilter(a, b) {
      a = a.locationName.toUpperCase();
      b = b.locationName.toUpperCase();
      if (a.indexOf(this.query.toUpperCase()) === -1) {
        return 1;
      } else if (b.indexOf(this.query.toUpperCase()) === -1) {
        return -1;
      }
      return a.indexOf(this.query.toUpperCase()) < b.indexOf(this.query.toUpperCase()) ? -1 : 1;
    },
    showHideLocation: function showHideLocation() {
      this.onBlurKey = true;
      if (this.query.length === 0) {
        this.locationList = this.selectedCity.ActiveLocation.sort(this.locationFilterAlphabet);
      } else {
        var locationFilter = this.selectedCity.ActiveLocation.filter(function (locationVal) {
          var locality = locationVal.locationName;
          if (!locality) return false;
          locality = locality.toLowerCase();
          return locality.includes(this.query.toLowerCase());
        }.bind(this));
        this.locationList = locationFilter.sort(this.locationFilter);
      }
    },
    closeBlock: function closeBlock() {
      this.pincodeButton = false;
      // setTimeout(function () {
      //   this.onBlurKey = false
      // }.bind(this), 300)
    },
    closeBlockTest: function closeBlockTest() {
      setTimeout(function () {
        this.searchtext = '';
      }.bind(this), 300);
    },
    selectLocation: function selectLocation(obj) {
      this.locality = undefined;
      this.locality = obj;
      this.pincode = obj.locationZipCode;
      this.query = obj.locationName;
      // this.locationList = []
      this.onBlurKey = false;
      vue_esm["default"].analytics.fbq.event('ViewContent', {
        content_ids: this.locality.locationId,
        content_name: this.locality.locationZipCode,
        contents: { id: this.locality.locationId, location: this.locality.locationName, zipcode: this.locality.locationZipCode },
        content_type: 'PINCODE_ENTERED'
      });
      this.$localStorage.remove('sl');
      this.$localStorage.remove('ct');
      this.$localStorage.remove('cou');
      this.$localStorage.remove('location');
      this.$localStorage.set('location', this.locality, 0);
      this.$localStorage.remove('pincode');
      this.$localStorage.set('pincode', this.locality.locationZipCode, 0);
      // this.getLab()
      $('#popupLocality').modal('hide');
      this.$router.push('/lab');
    },
    selectBannerAds: function selectBannerAds() {
      if (this.selectedCity.cityId === 2) {
        this.sideBannerAds = [{
          url: '/labs/chennai/Women%E2%80%99s_Wellness_Check',
          src: 'static/images/banner/women.jpg'
        }, {
          url: '/labs/chennai/comprehensive_health_checkup',
          src: 'static/images/banner/comprehensive.jpg'
        }, {
          url: '/labs/chennai/General_Health_Checkup',
          src: 'static/images/banner/general.jpg'
        }, {
          url: '/labs/chennai/Hypertension_checkup',
          src: 'static/images/banner/hyper.jpg'
        }];
      } else if (this.selectedCity.cityId === 33) {
        this.sideBannerAds = [{
          url: '/labs/bangaluru/comprehensive_health_checkup',
          src: 'static/images/banner/comprehensive.jpg'
        }, {
          url: '/labs/bangaluru/Women%E2%80%99s_Wellness_Check',
          src: 'static/images/banner/women.jpg'
        }, {
          url: '/labs/bangaluru/General_Health_Checkup',
          src: 'static/images/banner/general.jpg'
        }, {
          url: '/labs/bangaluru/Hypertension_checkup',
          src: 'static/images/banner/hyper.jpg'
        }];
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6c46e34a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/Book/LabLocation.vue
var Book_LabLocation_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"LabDiv"}},[_c('HeaderVue',{attrs:{"isHeader":"true"}}),_vm._v(" "),_c('div',{staticClass:"search-section"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-6 pr-1"},[_c('div',{staticClass:"input-group mb-2"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedCity),expression:"selectedCity"}],staticClass:"form-control",on:{"click":function($event){_vm.onBlurKey=false;},"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedCity=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){_vm.onCityChange()}]}},_vm._l((_vm.locationMasterList),function(city,index){return _c('option',{key:index,domProps:{"value":city}},[_vm._v(_vm._s(city.cityName))])}))])]),_vm._v(" "),_c('div',{staticClass:"col-6 pl-0"},[_c('div',{staticClass:"input-group mb-2"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.query),expression:"query"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Enter Locality","aria-label":"","name":"x","list":"mycarousel","autocomplete":"off","minlength":"3"},domProps:{"value":(_vm.query)},on:{"focus":function($event){_vm.onFocusLocality()},"input":function($event){if($event.target.composing){ return; }_vm.query=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"form-group mb-0"},[_c('div',{staticClass:"input-group mb-0",class:{ 'focused-search': (_vm.searchtext != '') }},[_c('input',{staticClass:"form-control text-left pl-35",attrs:{"type":"text","placeholder":"Search or Add lab tests","aria-label":"","name":"x","list":"mycarousel","autocomplete":"off","minlength":"3"},on:{"focus":function($event){_vm.openSearchModel()}}}),_vm._v(" "),_c('img',{staticClass:"search-img",attrs:{"src":"static/images/search.svg","alt":""}}),_vm._v(" "),(_vm.isSearchLoading)?_c('div',{staticClass:"test-option"},[_vm._v("\n                              "+_vm._s(_vm.isSearchLoading)+"\n                            ")]):_vm._e()])])])])])]),_vm._v(" "),_c('div',{staticClass:"main-content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[(_vm.labContent && _vm.labLists && _vm.labLists.length > 0 && !_vm.isLabLoading)?_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"title float-left title-width"},[_c('p',[_vm._v("\n                          Showing \n                            "),_c('b',{staticClass:"black-color"},[_vm._v("\n                              "+_vm._s(_vm.labLists.length)+" Labs \n                            ")]),_vm._v(" \n                            in \n                            "),_c('b',{staticClass:"black-color"},[_vm._v("\n                              "+_vm._s(_vm.$localStorage.get('location') ? _vm.$localStorage.get('location').locationName : (_vm.selectedCity ? _vm.selectedCity.cityName : ''))+"\n                            ")]),_vm._v("\n                            , starting from "+_vm._s('Rs.'+_vm.lowestCost)+"\n                        ")])]),_vm._v(" "),_vm._m(0,false,false)]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"lab-list"},[(_vm.selectedProfileAndTest && _vm.selectedProfileAndTest.length > 0 && _vm.selectedProfileAndTest[0].info && _vm.selectedProfileAndTest[0].info.length > 0)?_c('div',{staticClass:"lab"},[_c('div',{staticClass:"display-flex"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 collapse-group"},[_c('h5',{staticClass:"capitalize profile_detail fs-14"},[_c('strong',[_vm._v(_vm._s(_vm.selectedProfileAndTest[0].name))])]),_vm._v(" "),_c('p',{staticClass:"p-profile-detail"},[_vm._v("\n                                            "+_vm._s(_vm.selectedProfileAndTest[0].info.length > 0 ? _vm.selectedProfileAndTest[0].info : '')+"\n                                          ")])])])]),_vm._v(" "),_c('div',{staticClass:"clearfix"})]):_vm._e(),_vm._v(" "),_vm._l((_vm.limitBy(_vm.labLists, _vm.labLimit)),function(lab,index){return _c('div',{key:index,staticClass:"lab"},[_c('div',{staticClass:"lab-title"},[_c('div',{staticClass:"lab-logo mr-2"},[(lab.logo && lab.logo.length > 0)?_c('img',{attrs:{"src":lab.logo}}):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"details"},[_c('h5',[_c('strong',[_vm._v("\n                                        "+_vm._s(lab.labName)+"\n                                      ")])]),_vm._v(" "),_c('p',{staticClass:"mb-0"},[_c('span',{staticClass:"mr-1 ft-s-12"},[_c('i',{staticClass:"fa fa-map-marker green-color",attrs:{"aria-hidden":"true"}}),_vm._v("\n                                        "+_vm._s(lab.branch.branchLocation)+"\n                                      ")])]),_vm._v(" "),_vm._m(1,true,false),_vm._v(" "),_c('div',{staticClass:"lab-rating"},[_c('ul',[_vm._l((parseInt(lab.rating)),function(stars){return _c('li',[_c('i',{staticClass:"material-icons"},[_vm._v("star")])])}),_vm._v(" "),_vm._l((5-parseInt(lab.rating)),function(star_borders){return _c('li',[_c('i',{staticClass:"material-icons"},[_vm._v("star_border")])])})],2)])])]),_vm._v(" "),_c('div',{staticClass:"test-list"},[_c('ul',[_c('li',_vm._l((lab.labTestList),function(tl,key){return _c('span',{key:key},[_c('span',{staticClass:"selected-test"},[_vm._v(_vm._s(tl.aliasName))]),_vm._v(" "),(tl.testId === 0)?_c('span',{staticClass:"selected-test"},[(tl.testId === 0)?_c('span',{staticClass:"blue-color list-popup",on:{"click":function($event){_vm.openProfileTestList(tl.aliasName, tl.testInfo, tl)}}},[_vm._v("\n                                                (includes "+_vm._s(_vm.getIncudedTestAndProfile(tl))+")\n                                            ")]):_vm._e()]):_vm._e(),_vm._v(" "),((lab.labTestList.length > 1 && (key) != (lab.labTestList.length-1)))?_c('span',{attrs:{"id":key}},[_vm._v(" | ")]):_vm._e()])}))])]),_vm._v(" "),(lab.certificationList.length > 0)?_c('p',[_vm._v("Lab certified with")]):_c('p'),_vm._v(" "),_c('div',{staticClass:"certified-price clearfix"}),_vm._v(" "),_c('div',{staticClass:"certified-price clearfix"},[_c('div',{staticClass:"certified"},_vm._l((lab.certificationList),function(cert,index){return _c('div',{key:index,staticClass:"certificate"},[((cert.labCertificateImageId == 1))?_c('img',{attrs:{"src":"static/images/certifi01.jpg","alt":""}}):_vm._e(),_vm._v(" "),((cert.labCertificateImageId == 2))?_c('img',{attrs:{"src":"static/images/certifi03.jpg","alt":""}}):_vm._e(),_vm._v(" "),((cert.labCertificateImageId == 3))?_c('img',{attrs:{"src":"static/images/certifi02.jpg","alt":""}}):_vm._e(),_vm._v(" "),((cert.labCertificateImageId == ''))?_c('img',{attrs:{"src":"static/images/certifi02.jpg","alt":""}}):_vm._e()])})),_vm._v(" "),_c('div',{staticClass:"price",staticStyle:{"float":"right"}},[_c('div',{staticClass:"price-detail"},[_c('h5',{staticClass:"clearfix"},[_c('span',{staticClass:"labo-price"},[_vm._v("\n                                              Rs."+_vm._s(lab.ourCost)+"\n                                            ")]),_vm._v(" "),((lab.actualCost > lab.ourCost))?_c('span',{staticClass:"original-price red-color strip-text"},[_vm._v("\n                                              Rs."+_vm._s(lab.actualCost)+"\n                                            ")]):_vm._e()]),_vm._v(" "),_c('a',{staticClass:"float-right blue-color dropdown-toggle price-break-line-hide",attrs:{"data-toggle":"collapse","href":'#priceCollapse1'+lab.labId,"aria-expanded":"true","aria-controls":'#priceCollapse1'+lab.labId}},[_vm._v("\n                                            Price Breakup\n                                        ")])])])]),_vm._v(" "),_c('div',{staticClass:"collapse",attrs:{"id":'priceCollapse1'+lab.labId}},[_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"price-breake fs-13 w-100"},[_vm._l((lab.labTestList),function(tl,key){return _c('tr',{key:key},[_c('td',{},[_vm._v(_vm._s(tl.aliasName))]),_vm._v(" "),_c('td',{staticClass:"text-nowrap"},[((tl.acutalPrice > tl.ourPrice))?_c('span',{staticClass:"red-color strip-text"},[_vm._v("Rs. "+_vm._s(tl.acutalPrice))]):_vm._e()]),_vm._v(" "),_c('td',{staticClass:"text-nowrap"},[_vm._v("Rs. "+_vm._s(tl.ourPrice))])])}),_vm._v(" "),_c('tr',{staticClass:"grey-color border-top"},[_c('td',{staticClass:"text-nowrap bo"},[_vm._v("Sub Total")]),_vm._v(" "),_c('td',{staticClass:"text-nowrap"}),_vm._v(" "),_c('td',{staticClass:"text-nowrap black-color"},[_vm._v("Rs. "+_vm._s(lab.ourCost))])])],2)])]),_vm._v(" "),(_vm.$localStorage.get('sl'))?_c('div',[(_vm.$localStorage.get('sl').labId === lab.labId)?_c('button',{staticClass:"btn btn-primary full-width mt-15",on:{"click":function($event){_vm.goChooseDate(lab)}}},[_vm._v("\n                                  book appointment\n                              ")]):_c('button',{staticClass:"btn btn-primary full-width mt-15",on:{"click":function($event){_vm.goChooseDate(lab)}}},[_vm._v("\n                                  book appointment\n                              ")])]):_c('button',{staticClass:"btn btn-primary full-width mt-15",on:{"click":function($event){_vm.goChooseDate(lab)}}},[_vm._v("\n                                book appointment\n                            ")])])}),_vm._v(" "),(_vm.labLists.length <= 0)?_c('div',{staticClass:"card  mt-3"},[_c('div',{staticClass:"card-body"},[(_vm.labLists.length <= 0 && !_vm.isLabLoading)?_c('div',{staticClass:"no-labs text-center mt-4"},[_c('img',{attrs:{"src":"static/images/lab-flask.png","alt":""}}),_vm._v(" "),_c('p',[_vm._v("No Labs found for your tests in "+_vm._s(_vm.selectedCity ? _vm.selectedCity.cityName : ''))])]):_vm._e(),_vm._v(" "),(_vm.labLists.length <= 0 && _vm.isLabLoading)?_c('div',{staticClass:"no-labs text-center mt-4"},[_c('img',{attrs:{"src":"static/images/lab-flask.png","alt":""}}),_vm._v(" "),_c('p',[_vm._v("Loading...")])]):_vm._e()])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row mt-3"},[_c('div',{staticClass:"col-sm-6"},[(_vm.labLists.length >_vm.labLimit)?_c('button',{staticClass:"btn btn-outline-primary full-width",on:{"click":function($event){_vm.loadMore()}}},[_vm._v("Show more Labs ("+_vm._s(_vm.labLists.length - _vm.labLimit)+")")]):_vm._e()])])],2)])])])]),_vm._v(" "),_c('div',{staticClass:"fixed-footer p-10",class:{ 'display-none': _vm.selectedProfileAndTest.length === 0 , 'display-block':  _vm.selectedProfileAndTest.length > 0},attrs:{"id":"fixed-footer"}},[_c('h4',{staticClass:"fs-14"},[_vm._v("\n          Lab Test Selected \n          "),_c('span',[_vm._v(_vm._s(_vm.selectedProfileAndTest && _vm.selectedProfileAndTest.length > 0 ? '(' + _vm.selectedProfileAndTest.length + ')' : ''))])]),_vm._v(" "),_c('div',{staticClass:"flex-row footer-test"},[(_vm.selectedProfileAndTest.length <= 0)?_c('span',{staticClass:"chips"},[_vm._v("No test or profile selected")]):_vm._e(),_vm._v(" "),_vm._l((_vm.selectedProfileAndTest),function(sel,index){return _c('div',{key:index,staticClass:"flex-column"},[_c('p',{staticClass:"chips"},[_c('span',{staticClass:"float-left mr-2"},[_vm._v(_vm._s(sel.name))]),_vm._v(" "),_c('i',{staticClass:"material-icons",on:{"click":function($event){$event.preventDefault();_vm.removeSelectedItems(sel)}}},[_vm._v("close")])])])})],2)]),_vm._v(" "),_c('div',{staticClass:"modal fade",attrs:{"id":"test-popup","tabindex":"-1","role":"dialog","aria-labelledby":"exampleModalLabel","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"header"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_vm._m(2,false,false),_vm._v(" "),_c('h3',{staticClass:"screen-title mt-13p"},[_vm._v(_vm._s(_vm.clickedProfileDetails.aliasName))])])])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[(_vm.clickedProfileDetails.patientInstruction && _vm.clickedProfileDetails.patientInstruction.length > 0)?_c('p',[_c('b',[_vm._v("Patient Instruction:")])]):_vm._e(),_vm._v(" "),(_vm.clickedProfileDetails.patientInstruction && _vm.clickedProfileDetails.patientInstruction.length > 0)?_c('p',{staticClass:"black-color"},[_vm._v(_vm._s(_vm.clickedProfileDetails.patientInstruction))]):_vm._e(),_vm._v(" "),((_vm.clickedProfileTests && _vm.clickedProfileTests.length > 0) || (_vm.clickedProfileDetails.includedProfiles && _vm.clickedProfileDetails.includedProfiles.count > 0))?_c('p',{class:{'mt-4' : (_vm.clickedProfileDetails.patientInstruction && _vm.clickedProfileDetails.patientInstruction.length > 0 ) }},[_c('b',[_vm._v("Included Tests ("+_vm._s(_vm.getIncudedTestAndProfile(_vm.clickedProfileDetails))+"): ")])]):_vm._e(),_vm._v(" "),((_vm.clickedProfileTests && _vm.clickedProfileTests.length > 0) || (_vm.clickedProfileDetails.includedProfiles && _vm.clickedProfileDetails.includedProfiles.count > 0))?_c('div',{staticClass:"black-color row included-profiles"},[_c('div',{staticClass:"col-sm-12"},[((_vm.clickedProfileDetails.includedProfiles && _vm.clickedProfileDetails.includedProfiles.count > 0))?_c('div',{attrs:{"id":"accordion","role":"tablist"}},_vm._l((_vm.clickedProfileDetails.includedProfiles.data),function(inclProf,index){return _c('div',{key:index,staticClass:"card"},[_c('div',{staticClass:"card-header",attrs:{"role":"tab","id":"headingOne"}},[_c('h5',{staticClass:"mb-0"},[_c('a',{staticClass:"collapsed",attrs:{"data-toggle":"collapse","href":'#collapseOne'+inclProf.panelId,"aria-expanded":"true","aria-controls":"collapseOne"}},[_vm._v("\n                                                "+_vm._s(inclProf.aliasName+' (includes '+ inclProf.ProfileTests.length +'    Tests)')+"\n                                                "),_c('i',{staticClass:"material-icons float-right"})])])]),_vm._v(" "),_c('div',{staticClass:"collapse",attrs:{"id":'collapseOne'+inclProf.panelId,"role":"tabpanel","aria-labelledby":"headingOne","data-parent":"#accordion"}},[_c('div',{staticClass:"pl-4"},_vm._l((inclProf.ProfileTests),function(incTest,index){return _c('span',{key:index,staticClass:"mb-2"},[_vm._v(_vm._s(incTest.testName+((inclProf.ProfileTests.length != (index+1))? ' , ' : ''))),_c('br')])}))])])})):_vm._e(),_vm._v(" "),_c('div',{attrs:{"id":"accordion","role":"tablist"}},_vm._l((_vm.clickedProfileTestFirst),function(cli,index){return _c('div',{key:index,staticClass:"card"},[_c('div',{staticClass:"card-header",attrs:{"role":"tab","id":"headingOne"}},[_c('h5',{staticClass:"mb-0"},[_c('a',{staticClass:"collapsed"},[_vm._v("\n                                              "+_vm._s(cli)+"\n                                          ")])])])])})),_vm._v(" "),_c('div',{attrs:{"id":"accordion","role":"tablist"}},_vm._l((_vm.clickedProfileTestSecond),function(cli,index){return _c('div',{key:index,staticClass:"card"},[_c('div',{staticClass:"card-header",attrs:{"role":"tab","id":"headingOne"}},[_c('h5',{staticClass:"mb-0"},[_c('a',{staticClass:"collapsed"},[_vm._v("\n                                            "+_vm._s(cli)+"\n                                        ")])])])])}))])]):_c('div',{staticClass:"black-color"},[_c('p',[_vm._v(" -- No tests available -- ")])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal fade",attrs:{"id":"popupTest","tabindex":"-1","role":"dialog","aria-labelledby":"popupTest","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"header"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"menu_popup",on:{"click":function($event){$event.preventDefault();_vm.goBackLab()}}},[_c('i',{staticClass:"material-icons"},[_vm._v("arrow_back")])]),_vm._v(" "),_c('h3',{staticClass:"screen-title mt-13p"},[_vm._v("Book Test")])])])])]),_vm._v(" "),_c('div',{staticClass:"modal-body p-0"},[_c('div',{staticClass:"search-section"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"form-group mb-0"},[_c('label',[_vm._v("Search or Add lab tests")]),_vm._v(" "),_c('div',{staticClass:"input-group mb-0",class:{ 'focused-search': (_vm.searchtext != '') }},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchtext),expression:"searchtext"}],ref:"searchtext",staticClass:"form-control text-left pl-35",attrs:{"type":"text","placeholder":"Search or Add","aria-label":"","name":"x","list":"mycarousel","autocomplete":"off","minlength":"3"},domProps:{"value":(_vm.searchtext)},on:{"input":function($event){if($event.target.composing){ return; }_vm.searchtext=$event.target.value}}}),_vm._v(" "),_c('img',{staticClass:"search-img",attrs:{"src":"static/images/search.svg","alt":""}})])])])])])]),_vm._v(" "),(_vm.isPopularPackages)?_c('div',{staticClass:"tabs  test-search-popup"},[_vm._m(3,false,false),_vm._v(" "),_c('div',{staticClass:"tab-content test-option",attrs:{"id":"myTabContent"}},[_c('div',{staticClass:"tab-pane fade show active ",attrs:{"id":"test","role":"tabpanel","aria-labelledby":"test-tab"}},[_c('div',{staticClass:"popular-test"},[_c('ul',_vm._l((_vm.popularTests.profile),function(test,index){return _c('li',{key:index,staticClass:"mb-0",on:{"click":function($event){_vm.addTestFromDropdown($event, test, 1, 1)}}},[_c('div',[_c('p',{staticClass:"m-0"},[_c('i',{staticClass:"fa fa-plus mr-2"}),_vm._v(" "+_vm._s(test.name)+"\n                                              "),(test.isSelected === 1)?_c('i',{staticClass:"fa fa-circle green-color",staticStyle:{"font-size":"11px","margin-left":"3px"}}):_vm._e()]),_vm._v(" "),(test.testId != 0 && test.Keywords)?_c('p',{staticClass:"test-key m-0 pl-4"},[_c('b',[_vm._v("Also known as:")]),_vm._v(" "),_c('span',{staticClass:"capitalize"},[_vm._v(_vm._s(test.Keywords))])]):_vm._e(),_vm._v(" "),(test.panelId != 0 && test.ProfileTests && test.ProfileTests.length > 0)?_c('p',{staticClass:"test-key m-0 pl-4"},[_c('b',[_vm._v("Includes "+_vm._s(_vm.getIncudedTestAndProfilePopular(test)))])]):_vm._e()]),_vm._v(" "),_c('div')])}))])])]),_vm._v(" "),_vm._m(4,false,false),_vm._v(" "),_c('div',{staticClass:"tab-content test-option",attrs:{"id":"myTabContent"}},[_c('div',{staticClass:"tab-pane fade show active ",attrs:{"id":"test","role":"tabpanel","aria-labelledby":"test-tab"}},[_c('div',{staticClass:"popular-test"},[_c('ul',_vm._l((_vm.popularTests.test),function(test,index){return _c('li',{key:index,staticClass:"mb-0",on:{"click":function($event){_vm.addTestFromDropdown($event, test, 1, 1)}}},[_c('div',[_c('p',{staticClass:"m-0"},[_c('i',{staticClass:"fa fa-plus mr-2"}),_vm._v(" "+_vm._s(test.name)+"\n                                              "),(test.isSelected === 1)?_c('i',{staticClass:"fa fa-circle green-color",staticStyle:{"font-size":"11px","margin-left":"3px"}}):_vm._e()]),_vm._v(" "),(test.testId != 0 && test.Keywords)?_c('p',{staticClass:"test-key m-0 pl-4"},[_c('b',[_vm._v("Also known as:")]),_vm._v(" "),_c('span',{staticClass:"capitalize"},[_vm._v(_vm._s(test.Keywords))])]):_vm._e(),_vm._v(" "),(test.panelId != 0 && test.ProfileTests && test.ProfileTests.length > 0)?_c('p',{staticClass:"test-key m-0 pl-4"},[_c('b',[_vm._v("Includes "+_vm._s(_vm.getIncudedTestAndProfilePop(test)))])]):_vm._e()]),_vm._v(" "),_c('div')])}))])])])]):_vm._e(),_vm._v(" "),(!_vm.isPopularPackages)?_c('div',{staticClass:"tabs"},[_c('ul',{staticClass:"nav",attrs:{"id":"myTab","role":"tablist"}},[_c('li',{staticClass:"nav-item mb-0",staticStyle:{"font-size":"15px"}},[_c('a',{staticClass:"nav-link active",attrs:{"id":"test-tab","data-toggle":"tab","href":"#test","role":"tab","aria-controls":"test","aria-selected":"true"},on:{"click":function($event){_vm.ProfileAndTests(1)}}},[_c('b',[_vm._v(_vm._s(_vm.searchContent && _vm.searchContent.test && _vm.searchContent.test.length > 0 ? 'Showing ' + _vm.searchContent.test.length + ' results' : 'No Tests available for your search'))])])])]),_vm._v(" "),_c('div',{staticClass:"tab-content test-option",attrs:{"id":"myTabContent"}},[_c('div',{staticClass:"tab-pane fade show active ",attrs:{"id":"test","role":"tabpanel","aria-labelledby":"test-tab"}},[_c('div',{staticClass:"popular-test"},[_c('ul',_vm._l((_vm.searchContent.test),function(test,index){return _c('li',{key:index,staticClass:"mb-0",on:{"click":function($event){_vm.addTestFromDropdown($event, test, 1, 2)}}},[_c('div',[_c('p',{staticClass:"m-0"},[_c('i',{staticClass:"fa fa-plus mr-2"}),_vm._v(" "+_vm._s(test.name)+"\n                                              "),(test.isSelected === 1)?_c('i',{staticClass:"fa fa-circle green-color",staticStyle:{"font-size":"11px","margin-left":"3px"}}):_vm._e()]),_vm._v(" "),(test.testId != 0 && test.Keywords)?_c('p',{staticClass:"test-key m-0 pl-4"},[_c('b',[_vm._v("Also known as:")]),_vm._v(" "),_c('span',{staticClass:"capitalize"},[_vm._v(_vm._s(test.Keywords))])]):_vm._e(),_vm._v(" "),(test.panelId != 0 && test.ProfileTests && test.ProfileTests.length > 0)?_c('p',{staticClass:"test-key m-0 pl-4"},[_c('b',[_vm._v("Includes "+_vm._s(_vm.getIncudedTestAndProfilePop(test)))])]):_vm._e()]),_vm._v(" "),(test.testId > 0)?_c('div',[_c('span',{staticClass:"badge badge-primary"},[_vm._v("Test")])]):_vm._e(),_vm._v(" "),(test.panelId > 0)?_c('div',[_c('span',{staticClass:"badge badge-primary"},[_vm._v("Package")])]):_vm._e()])}))])])])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"fixed-footer p-0",class:{ 'display-none': _vm.selectedProfileAndTest.length === 0 , 'display-block':  _vm.selectedProfileAndTest.length > 0},attrs:{"id":"fixed-footer-modal"}},[_c('div',{staticClass:"test-details-popover",attrs:{"id":"accordion","role":"tablist"}},[_c('div',{staticClass:"card m-0"},[_c('div',{staticClass:"card-header",attrs:{"role":"tab","id":"headingOne"}},[_c('h5',{staticClass:"mb-0"},[_c('a',{staticClass:"collapsed gray-color",attrs:{"data-toggle":"collapse","href":"#testDetails","aria-expanded":"true","aria-controls":"testDetails"}},[_vm._v("\n                                    Selected Tests \n                                    "),_c('span',[_vm._v(_vm._s(_vm.selectedProfileAndTest && _vm.selectedProfileAndTest.length > 0 ? '(' + _vm.selectedProfileAndTest.length + ')' : ''))]),_vm._v(" "),_c('i',{staticClass:"material-icons float-right"})])])]),_vm._v(" "),_c('div',{staticClass:"collapse",attrs:{"id":"testDetails","role":"tabpanel","aria-labelledby":"headingOne","data-parent":"#accordion"}},[_c('div',{staticClass:"card-body pb-0"},[_c('div',{staticClass:"row scroll-test"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"table-responsive test-conformation"},[_c('table',{staticClass:"table mb-0"},[_c('tbody',{staticClass:"black-color"},_vm._l((_vm.selectedProfileAndTest),function(sel,index){return _c('tr',{key:index},[_c('td',[_vm._v("\n                                                          "+_vm._s(sel.name)+"\n                                                        ")]),_vm._v(" "),_c('td',[_c('button',{staticClass:"btn btn-link remove-btn p-0",on:{"click":function($event){$event.preventDefault();_vm.removeSelectedItems(sel)}}},[_c('img',{attrs:{"src":"static/images/close-black.svg","alt":"delete"}})])])])}))])])])])])])])]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary full-width fixed-button",on:{"click":function($event){_vm.goBackLab()}}},[_vm._v("\n                    Show Labs\n                ")])])])])]),_vm._v(" "),_c('div',{staticClass:"modal fade",attrs:{"id":"popupLocality","tabindex":"-1","role":"dialog","aria-labelledby":"popupTest","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"header"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"menu_popup",on:{"click":function($event){_vm.closeLocalityPopup()}}},[_c('i',{staticClass:"material-icons"},[_vm._v("arrow_back")])]),_vm._v(" "),_c('h3',{staticClass:"screen-title mt-13p"},[_vm._v("Choose Locality")])])])])]),_vm._v(" "),_c('div',{staticClass:"search-section"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"form-group mb-0"},[_c('label',[_vm._v("Select Locality")]),_vm._v(" "),_c('div',{staticClass:"input-group mb-0",class:{ 'focused-search': (_vm.searchtext != '') }},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.query),expression:"query"}],ref:"pincode",staticClass:"form-control text-left",attrs:{"type":"text","placeholder":"Search your nearest locality","aria-label":"","name":"x","list":"mycarousel","autocomplete":"off","minlength":"3"},domProps:{"value":(_vm.query)},on:{"blur":function($event){_vm.closeBlock()},"keyup":[function($event){_vm.showHideLocation()},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }_vm.showHideLocation()}],"input":function($event){if($event.target.composing){ return; }_vm.query=$event.target.value}}})])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-12"},[_c('span',[_vm._v("City/ Locality : "),_c('b',[_vm._v(" "+_vm._s(_vm.selectedCity ? _vm.selectedCity.cityName : '-' + ' / ' + (_vm.$localStorage.get('location') ? _vm.$localStorage.get('location').locationName : '-')))])]),_vm._v(" "),_c('br')])])])]),_vm._v(" "),_c('div',{staticClass:"modal-body locality-search-popup"},[_c('div',[_c('div',{staticClass:"popular-test"},[_c('ul',{staticClass:"p-0 m-0"},[_vm._l((_vm.locationList.slice(0, 150)),function(item,index){return _c('li',{key:index,staticClass:"p-2 location-border",on:{"click":function($event){_vm.selectLocation(item)}}},[_c('span',[_vm._v("\n                                "+_vm._s(item.locationName)+"\n                                "),(_vm.locality && item.locationId === _vm.locality.locationId)?_c('i',{staticClass:"fa fa-check green-color",staticStyle:{"font-size":"13px","margin-left":"3px"}}):_vm._e()])])}),_vm._v(" "),(_vm.locationList.length === 0)?_c('li',{staticClass:"text-center"},[_vm._v(" --- No Locations ---")]):_vm._e()],2)])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal fade",attrs:{"id":"sort-by","tabindex":"-1","role":"dialog","aria-labelledby":"sort-byLabel","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_vm._m(5,false,false),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"form-check"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.sortBy),expression:"sortBy"}],attrs:{"type":"radio","id":"sortByLow","name":"sortBy","value":"1"},domProps:{"checked":_vm._q(_vm.sortBy,"1")},on:{"change":[function($event){_vm.sortBy="1"},function($event){_vm.labSortOrder()}]}}),_vm._v(" "),_c('label',{staticClass:"form-check-label",attrs:{"for":"sortByLow"}},[_vm._v("\n                        Price Low to High\n                      ")])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.sortBy),expression:"sortBy"}],attrs:{"type":"radio","id":"sortByHigh","name":"sortBy","value":"2"},domProps:{"checked":_vm._q(_vm.sortBy,"2")},on:{"change":[function($event){_vm.sortBy="2"},function($event){_vm.labSortOrder()}]}}),_vm._v(" "),_c('label',{staticClass:"form-check-label",attrs:{"for":"sortByHigh"}},[_vm._v("\n                        Price High to Low\n                      ")])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.sortBy),expression:"sortBy"}],attrs:{"type":"radio","id":"sortByRate","name":"sortBy","value":"3"},domProps:{"checked":_vm._q(_vm.sortBy,"3")},on:{"change":[function($event){_vm.sortBy="3"},function($event){_vm.labSortOrder()}]}}),_vm._v(" "),_c('label',{staticClass:"form-check-label",attrs:{"for":"sortByRate"}},[_vm._v("\n                        Ratings\n                      ")])])])])])]),_vm._v(" "),_c('FooterVue')],1)}
var Book_LabLocation_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"filter-section float-right"},[_c('button',{staticClass:"btn btn-link remove-padding",attrs:{"data-toggle":"modal","data-target":"#sort-by"}},[_c('span',{staticClass:"sprites sprite-filter"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h6',{staticClass:"pickup-label"},[_c('span',{staticClass:"badge badge-success"},[_vm._v("Free Home Sample Pickup")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"menu_popup",attrs:{"data-dismiss":"modal","aria-label":"Close"}},[_c('i',{staticClass:"material-icons"},[_vm._v("arrow_back")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"nav",attrs:{"id":"myTab","role":"tablist"}},[_c('li',{staticClass:"nav-item mb-0",staticStyle:{"font-size":"15px"}},[_c('a',{staticClass:"nav-link active",attrs:{"id":"profile-tab","data-toggle":"tab","href":"#test_pop","role":"tab","aria-controls":"test","aria-selected":"true"}},[_c('b',[_vm._v("Popular Packages")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"nav",attrs:{"id":"myTab","role":"tablist"}},[_c('li',{staticClass:"nav-item",staticStyle:{"font-size":"15px"}},[_c('a',{staticClass:"nav-link",attrs:{"id":"test-tab","data-toggle":"tab","href":"#profile_pop","role":"tab","aria-controls":"profile","aria-selected":"false"}},[_c('b',[_vm._v("Popular tests")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"menu_popup",attrs:{"data-dismiss":"modal","aria-label":"Close"}},[_c('i',{staticClass:"material-icons"},[_vm._v("arrow_back")])]),_vm._v(" "),_c('h3',{staticClass:"screen-title mt-13p"},[_vm._v("Sort Lab By")])])])])])}]
var Book_LabLocation_esExports = { render: Book_LabLocation_render, staticRenderFns: Book_LabLocation_staticRenderFns }
/* harmony default export */ var components_mobile_Book_LabLocation = (Book_LabLocation_esExports);
// CONCATENATED MODULE: ./src/components/mobile/Book/LabLocation.vue
function Book_LabLocation_injectStyle (ssrContext) {
  __webpack_require__("pwwO")
}
var Book_LabLocation_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var Book_LabLocation___vue_template_functional__ = false
/* styles */
var Book_LabLocation___vue_styles__ = Book_LabLocation_injectStyle
/* scopeId */
var Book_LabLocation___vue_scopeId__ = "data-v-6c46e34a"
/* moduleIdentifier (server only) */
var Book_LabLocation___vue_module_identifier__ = null
var Book_LabLocation_Component = Book_LabLocation_normalizeComponent(
  mobile_Book_LabLocation,
  components_mobile_Book_LabLocation,
  Book_LabLocation___vue_template_functional__,
  Book_LabLocation___vue_styles__,
  Book_LabLocation___vue_scopeId__,
  Book_LabLocation___vue_module_identifier__
)

/* harmony default export */ var src_components_mobile_Book_LabLocation = (Book_LabLocation_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/Book/Appointment.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









var Appointment_myDate = new Date();

/* harmony default export */ var mobile_Book_Appointment = ({
  name: 'AppointmentDate',
  components: {
    HeaderVue: mobile_Header["a" /* default */],
    FooterVue: mobile_Footer["a" /* default */],
    Datepicker: build_default.a,
    Login: Login["a" /* default */]
  },
  beforeCreate: function beforeCreate() {
    if (!this.$localStorage.get('st')) {
      this.$router.push('/lab');
      return false;
    }
    if (!this.$localStorage.get('sl')) {
      this.$router.push('/lab');
      return false;
    }
    Appointment_myDate = new Date();
    Appointment_myDate.setDate(Appointment_myDate.getDate() - 1);
  },
  data: function data() {
    return {
      isDatePickerOpend: true,
      datepicker: true,
      timepicker: false,
      disabled: {
        to: Appointment_myDate
      },
      language: 'en',
      payinfo: {
        mrpTotal: 0,
        phlebotomistFee: 0,
        subTotal: 0,
        labDiscount: 0,
        phlebotomyFeeWaiver: 0,
        total: 0,
        gst: 0,
        grandTotal: 0
      },
      dt: '',
      timeSelected: '',
      availableTimes: [{ startTime: '06:00', endTime: '07:00', startTimeDisp: '06:00', endTimeDisp: '07:00 am', isEnable: true, isActive: false },
      // { startTime: '06:30', endTime: '07:00', startTimeDisp: '06:30', endTimeDisp: '07:00 am', isEnable: true, isActive: false },
      { startTime: '07:00', endTime: '08:00', startTimeDisp: '07:00', endTimeDisp: '08:00 am', isEnable: true, isActive: false },
      // { startTime: '07:30', endTime: '08:00', startTimeDisp: '07:30', endTimeDisp: '08:00 am', isEnable: true, isActive: false },
      { startTime: '08:00', endTime: '09:00', startTimeDisp: '08:00', endTimeDisp: '09:00 am', isEnable: true, isActive: false },
      // { startTime: '08:30', endTime: '09:00', startTimeDisp: '08:30', endTimeDisp: '09:00 am', isEnable: true, isActive: false },
      { startTime: '09:00', endTime: '10:00', startTimeDisp: '09:00', endTimeDisp: '10:00 am', isEnable: true, isActive: false },
      // { startTime: '09:30', endTime: '10:00', startTimeDisp: '09:30', endTimeDisp: '10:00 am', isEnable: true, isActive: false },
      { startTime: '10:00', endTime: '11:00', startTimeDisp: '10:00', endTimeDisp: '11:00 am', isEnable: true, isActive: false },
      // { startTime: '10:30', endTime: '11:00', startTimeDisp: '10:30', endTimeDisp: '11:00 am', isEnable: true, isActive: false },
      { startTime: '11:00', endTime: '12:00', startTimeDisp: '11:00', endTimeDisp: '12:00 pm', isEnable: true, isActive: false },
      // { startTime: '11:30', endTime: '12:00', startTimeDisp: '11:30', endTimeDisp: '12:00 pm', isEnable: true, isActive: false },
      { startTime: '12:00', endTime: '13:00', startTimeDisp: '12:00', endTimeDisp: '1:00 pm', isEnable: true, isActive: false },
      // { startTime: '12:30', endTime: '13:00', startTimeDisp: '12:30', endTimeDisp: '01:00 pm', isEnable: true, isActive: false },
      { startTime: '13:00', endTime: '14:00', startTimeDisp: '01:00', endTimeDisp: '02:00 pm', isEnable: true, isActive: false },
      // { startTime: '13:30', endTime: '14:00', startTimeDisp: '01:30', endTimeDisp: '02:00 pm', isEnable: true, isActive: false },
      { startTime: '14:00', endTime: '15:00', startTimeDisp: '02:00', endTimeDisp: '03:00 pm', isEnable: true, isActive: false },
      // { startTime: '14:30', endTime: '15:00', startTimeDisp: '02:30', endTimeDisp: '03:00 pm', isEnable: true, isActive: false },
      { startTime: '15:00', endTime: '16:00', startTimeDisp: '03:00', endTimeDisp: '04:00 pm', isEnable: true, isActive: false },
      // { startTime: '15:30', endTime: '16:00', startTimeDisp: '03:30', endTimeDisp: '04:00 pm', isEnable: true, isActive: false },
      { startTime: '16:00', endTime: '17:00', startTimeDisp: '04:00', endTimeDisp: '05:00 pm', isEnable: true, isActive: false },
      // { startTime: '16:30', endTime: '17:00', startTimeDisp: '04:30', endTimeDisp: '05:00 pm', isEnable: true, isActive: false },
      { startTime: '17:00', endTime: '18:00', startTimeDisp: '05:00', endTimeDisp: '06:00 pm', isEnable: true, isActive: false },
      // { startTime: '17:30', endTime: '18:00', startTimeDisp: '05:30', endTimeDisp: '06:00 pm', isEnable: true, isActive: false },
      { startTime: '18:00', endTime: '19:00', startTimeDisp: '06:00', endTimeDisp: '07:00 pm', isEnable: true, isActive: false },
      // { startTime: '18:30', endTime: '19:00', startTimeDisp: '06:30', endTimeDisp: '07:00 pm', isEnable: true, isActive: false },
      { startTime: '19:00', endTime: '20:00', startTimeDisp: '07:00', endTimeDisp: '08:00 pm', isEnable: true, isActive: false },
      // { startTime: '19:30', endTime: '20:00', startTimeDisp: '07:30', endTimeDisp: '08:00 pm', isEnable: true, isActive: false },
      { startTime: '20:00', endTime: '21:00', startTimeDisp: '08:00', endTimeDisp: '09:00 pm', isEnable: true, isActive: false
        // { startTime: '20:30', endTime: '21:00', startTimeDisp: '08:30', endTimeDisp: '09:00 pm', isEnable: true, isActive: false }
      }],
      selectedLab: [],
      selectedProfileAndTest: [],
      isFasting: 0,
      testCosts: [],
      GSTFee: this.$GSTFee,
      isDateAndTimeChoosed: false
    };
  },

  methods: {
    addTest: function addTest() {
      this.$localStorage.set('addTest', true);
      this.$router.push({ path: '/lab' });
    },
    showdtandTime: function showdtandTime() {
      $('#show-time').modal('show');
      this.timepicker = true;
      this.datepicker = false;
    },
    savePopup: function savePopup() {
      $('#show-time').modal('hide');
      $('choose-date').modal('hide');
    },
    goBackPopup: function goBackPopup() {
      this.$router.push({ path: '/lab' });
    },
    openDatePicker: function openDatePicker() {
      this.isDatePickerOpend = !this.isDatePickerOpend;
    },
    removeSelectedItems: function removeSelectedItems(cost, selectedTests, selectedLab) {
      var confirmText = 'Are you sure you want to remove?';
      if (selectedTests.length === 1) {
        confirmText = 'Are you sure you want to remove last one?';
      }
      var confirmFn = function () {
        this.$localStorage.remove('st');
        this.$localStorage.remove('cou');
        var reFetcheditems = [];
        selectedTests.forEach(function (items) {
          console.log(items);
          if (!(items.testId === cost.testId && cost.panelId === items.panelId)) {
            reFetcheditems.push(items);
          }
        });
        console.log(reFetcheditems);
        this.$localStorage.set('st', reFetcheditems, 0);

        var reFetchedLabitems = [];
        if (selectedLab) {
          if (selectedLab.labTestList.length > 0) {
            selectedLab.labTestList.forEach(function (labTest) {
              console.log(labTest);
              if (!(labTest.labProfileId === cost.labProfileId)) {
                reFetchedLabitems.push(labTest);
              }
            });
          }
        }
        selectedLab.labTestList = reFetchedLabitems;
        console.log(selectedLab);
        this.$localStorage.set('sl', selectedLab, 30 * 60 * 1000);

        this.getTestCosts();
        this.getFastingTests();

        if (selectedTests.length === 1) {
          this.$router.push('/lab');
        }
      }.bind(this);

      this.$Simplert.open({
        title: 'Confirm',
        message: confirmText,
        type: 'info',
        useConfirmBtn: true,
        onConfirm: confirmFn,
        customConfirmBtnText: 'Ok',
        customCloseBtnText: 'Cancel',
        disableOverlayClick: true
      });
    },
    saveDateAndTime: function saveDateAndTime() {
      this.isDateAndTimeChoosed = true;
    },
    changeDateAndTime: function changeDateAndTime() {
      $('#choose-date').modal('show');
      this.datepicker = false;
      this.timepicker = true;
      this.isDateAndTimeChoosed = false;
      this.isDatePickerOpend = true;
    },
    showhide: function showhide() {
      //   $('#choose-date').modal('show')
      this.datepicker = true;
      this.timepicker = false;
    },
    formatDate: function formatDate(date) {
      return dateformat_default()(date, 'dd/mm/yyyy');
    },
    goChooseLocation: function goChooseLocation() {
      this.$localStorage.remove('sa');
      this.$localStorage.remove('sm');
      this.$localStorage.remove('cou');
      vue_esm["default"].analytics.fbq.event('ViewContent', {
        content_ids: 0,
        content_name: 'APPOINTMENT DATE',
        contents: '',
        content_type: 'APPOINTMENT_DATE'
      });
      this.$router.push({ path: '/address' });
      return false;
    },
    fbTriggerDate: function fbTriggerDate() {
      if (this.$localStorage.get('ct').fromDateTime) {
        $('.login-box').modal('show');
        // $('.login-box').modal('show')
      }
      vue_esm["default"].analytics.fbq.event('ViewContent', {
        content_ids: 0,
        content_name: this.$localStorage.get('ct').fromDateTime,
        contents: '',
        content_type: 'APPOINTMENT_DATE'
      });
    },
    formatAMPM: function formatAMPM(time) {
      var setDate = new Date('2017-01-01 '.replace(/-/g, '/') + time.toString());
      var hours = setDate.getHours();
      var minutes = setDate.getMinutes();
      var ampm = hours >= 12 ? 'pm' : 'am';
      hours = hours % 12;
      if (hours === 0) {
        hours = 12;
      }
      minutes = minutes < 10 ? '0' + minutes : minutes;
      var strTime = (hours.toString().length === 1 ? '0' : '') + hours + ':' + minutes + ' ' + ampm;
      return strTime;
    },
    getAvailableTime: function getAvailableTime(date) {
      var self = this;
      try {
        var data = {
          'appointmentDate': dateformat_default()(date, 'yyyy/mm/dd'),
          'zipCode': this.$localStorage.get('location') ? this.$localStorage.get('location').locationZipCode : this.$defaultPincode,
          'labId': this.$localStorage.get('sl') ? this.$localStorage.get('sl').labId : '0'
        };
        var availableTimes = [];
        promise_default.a.resolve(this.$GET('patient/getAvailableTime', data)).then(function (res) {
          if (res.response_code === 0) {
            if (res.response.length > 0) {
              underscore_default.a.each(res.response, function (ele, key) {
                var parts = ele.time.split(':');
                var endTime = parseInt(parts[0]) + 1 + ':00:00';
                // if (parseInt(parts[1]) === 0) {
                //   endTime = parts[0] + ':30:01'
                // } else {
                //   endTime = (parseInt(parts[0]) + 1) + ':00:01'
                // }
                var arrayObj = {
                  startTime: ele.time,
                  startTimeDisp: self.formatAMPM(ele.time).replace(' am', '').replace(' pm', ''),
                  endTime: endTime,
                  endTimeDisp: self.formatAMPM(endTime),
                  isEnable: ele.isAvailable === 1,
                  isActive: false
                };
                var endTimeSplitArray = ele.time.split(':');
                if (dateformat_default()(date, 'yyyy/mm/dd') === dateformat_default()(new Date(), 'yyyy/mm/dd')) {
                  if (parseInt(endTimeSplitArray[0]) < parseInt(dateformat_default()(new Date(), 'HH'))) {
                    arrayObj['isEnable'] = false;
                  }
                  if (parseInt(endTimeSplitArray[0]) === parseInt(dateformat_default()(new Date(), 'HH')) && parseInt(endTimeSplitArray[1]) <= parseInt(dateformat_default()(new Date(), 'mm'))) {
                    arrayObj['isEnable'] = false;
                  }
                }
                availableTimes.push(arrayObj);
                endTime = undefined;
                parts = undefined;
              });
              this.availableTimes = availableTimes;
            }
          }
          this.$hidePageLoading();
        }.bind(this)).catch(function (err) {
          console.error(err);
        });
      } catch (e) {
        console.log(e);
      }
    },
    getTestCosts: function getTestCosts(lab) {
      try {
        var labTestCosts = [];
        if (this.$localStorage.get('sl')) {
          if (this.$localStorage.get('sl').labTestList.length > 0) {
            underscore_default.a.each(this.$localStorage.get('sl').labTestList, function (element) {
              labTestCosts.push(element.labProfileId);
            });
          }
        }
        var data = {
          'labId': this.$localStorage.get('sl') ? this.$localStorage.get('sl').labId : '0',
          'labTests': labTestCosts
        };
        promise_default.a.resolve(this.$POST('patient/getTestCosts', data)).then(function (res) {
          if (res.response_code === 0) {
            if (res.response) {
              this.testCosts = res.response;
              this.payinfo.mrpTotal = res.response.mrp;
              this.payinfo.phlebotomistFee = this.$phlebotomistFee;
              this.payinfo.subTotal = this.payinfo.mrpTotal + this.payinfo.phlebotomistFee;
              this.payinfo.labDiscount = res.response.youSaved;
              this.payinfo.phlebotomyFeeWaiver = this.payinfo.mrpTotal - this.payinfo.labDiscount > this.$waiverDiscountApplyFee ? this.$phlebotomyFeeWaiver : 0;
              this.payinfo.total = this.payinfo.subTotal - (this.payinfo.labDiscount + this.payinfo.phlebotomyFeeWaiver);
              this.payinfo.gst = Math.round(this.payinfo.total * this.$GSTFee / 100);
              this.payinfo.grandTotal = this.payinfo.total + this.payinfo.gst;
            }
          }
        }.bind(this)).catch(function (err) {
          console.error(err);
        });
      } catch (e) {
        console.log(e);
      }
    },
    getFastingTests: function getFastingTests() {
      try {
        this.isFasting = 0;
        var data = this.$localStorage.get('st');
        promise_default.a.resolve(this.$POST('patient/getFastingTests', data)).then(function (res) {
          if (res.response_code === 0) {
            if (res.response.isFasting === 1) {
              this.isFasting = 1;
            }
          }
        }.bind(this)).catch(function (err) {
          console.error(err);
        });
      } catch (e) {
        console.log('error', e);
      }
    },
    dateChange: function dateChange(dt) {
      $('#show-time').modal('show');
      this.$parent.$children[0].step = this.step;
      this.$parent.$children[0].current = 'health';
      this.datepicker = false;
      this.timepicker = true;
      this.timeSelected = '';
      this.dt = dt;
      var d = new Date(dt);
      var sDatetime = {
        date: d,
        dateFormat: d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate(),
        dateFormatMoment: dateformat_default()(d, 'yyyy-mm-dd', true),
        time: this.timeSelected,
        fromDateTime: dateformat_default()(d, 'yyyy-mm-dd', true) + ' ' + '00:00:00',
        toDateTime: dateformat_default()(d, 'yyyy-mm-dd', true) + ' ' + '00:00:00',
        tz: new Date().getTimezoneOffset()
      };
      this.$localStorage.set('ct', sDatetime, 30 * 60 * 1000);
      this.isDateAndTimeChoosed = false;
      this.getAvailableTime(dt);
    },
    setTime: function setTime(value) {
      this.timeSelected = value;
      var d = new Date(this.dt);
      var sDatetime = {
        date: d,
        dateFormat: d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate(),
        dateFormatMoment: dateformat_default()(d, 'yyyy-mm-dd'),
        time: this.timeSelected,
        fromDateTime: dateformat_default()(d, 'yyyy-mm-dd') + ' ' + this.timeSelected.startTime,
        toDateTime: dateformat_default()(d, 'yyyy-mm-dd') + ' ' + this.timeSelected.endTime,
        tz: new Date().getTimezoneOffset()
      };
      this.$localStorage.set('ct', sDatetime, 30 * 60 * 1000);
      this.isDateAndTimeChoosed = true;
      $('#choose-date').modal('hide');
      console.log('Selected Date:');
      console.log(this.dt);
      console.log('Selected Time:');
      console.log(this.timeSelected);
    }
  },
  created: function created() {
    console.log('appointment-created');
    console.log(this.$step);
    this.$step = true;
    console.log(this.$step);
    this.selectedLab = [];
    if (this.$localStorage.get('sl')) {
      this.selectedLab = this.$localStorage.get('sl');
    }
    this.selectedProfileAndTest = [];
    if (this.$localStorage.get('st')) {
      this.selectedProfileAndTest = this.$localStorage.get('st');
    }
    this.timeSelected = '';
    if (this.$localStorage.get('ct') && this.$localStorage.get('ct').time && this.$localStorage.get('ct').date) {
      this.dt = this.$localStorage.get('ct').date;
      this.timeSelected = this.$localStorage.get('ct').time;
      this.getAvailableTime(this.dt);
      this.isDateAndTimeChoosed = true;
      this.isDatePickerOpend = false;
    } else {
      var d = new Date();
      var dDatetime = {
        date: d,
        dateFormat: d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate(),
        dateFormatMoment: dateformat_default()(d, 'yyyy-mm-dd', true),
        time: '',
        fromDateTime: dateformat_default()(d, 'yyyy-mm-dd', true) + ' ' + '00:00:00',
        toDateTime: dateformat_default()(d, 'yyyy-mm-dd', true) + ' ' + '00:00:00',
        tz: new Date().getTimezoneOffset()
      };
      this.dt = d;
      this.$localStorage.set('ct', dDatetime, 30 * 60 * 1000);
      this.isDateAndTimeChoosed = false;
      this.availableTimes = [{ startTime: '06:00', endTime: '06:30', startTimeDisp: '06:00', endTimeDisp: '06:30 am', isEnable: true, isActive: false }, { startTime: '06:30', endTime: '07:00', startTimeDisp: '06:30', endTimeDisp: '07:00 am', isEnable: true, isActive: false }, { startTime: '07:00', endTime: '07:30', startTimeDisp: '07:00', endTimeDisp: '07:30 am', isEnable: true, isActive: false }, { startTime: '07:30', endTime: '08:00', startTimeDisp: '07:30', endTimeDisp: '08:00 am', isEnable: true, isActive: false }, { startTime: '08:00', endTime: '08:30', startTimeDisp: '08:00', endTimeDisp: '08:30 am', isEnable: true, isActive: false }, { startTime: '08:30', endTime: '09:00', startTimeDisp: '08:30', endTimeDisp: '09:00 am', isEnable: true, isActive: false }, { startTime: '09:00', endTime: '09:30', startTimeDisp: '09:00', endTimeDisp: '09:30 am', isEnable: true, isActive: false }, { startTime: '09:30', endTime: '10:00', startTimeDisp: '09:30', endTimeDisp: '10:00 am', isEnable: true, isActive: false }, { startTime: '10:00', endTime: '10:30', startTimeDisp: '10:00', endTimeDisp: '10:30 am', isEnable: true, isActive: false }, { startTime: '10:30', endTime: '11:00', startTimeDisp: '10:30', endTimeDisp: '11:00 am', isEnable: true, isActive: false }, { startTime: '11:00', endTime: '11:30', startTimeDisp: '11:00', endTimeDisp: '11:30 am', isEnable: true, isActive: false }, { startTime: '11:30', endTime: '12:00', startTimeDisp: '11:30', endTimeDisp: '12:00 pm', isEnable: true, isActive: false }, { startTime: '12:00', endTime: '12:30', startTimeDisp: '12:00', endTimeDisp: '12:30 pm', isEnable: true, isActive: false }, { startTime: '12:30', endTime: '13:00', startTimeDisp: '12:30', endTimeDisp: '01:00 pm', isEnable: true, isActive: false }, { startTime: '13:00', endTime: '13:30', startTimeDisp: '01:00', endTimeDisp: '01:30 pm', isEnable: true, isActive: false }, { startTime: '13:30', endTime: '14:00', startTimeDisp: '01:30', endTimeDisp: '02:00 pm', isEnable: true, isActive: false }, { startTime: '14:00', endTime: '14:30', startTimeDisp: '02:00', endTimeDisp: '02:30 pm', isEnable: true, isActive: false }, { startTime: '14:30', endTime: '15:00', startTimeDisp: '02:30', endTimeDisp: '03:00 pm', isEnable: true, isActive: false }, { startTime: '15:00', endTime: '15:30', startTimeDisp: '03:00', endTimeDisp: '03:30 pm', isEnable: true, isActive: false }, { startTime: '15:30', endTime: '16:00', startTimeDisp: '03:30', endTimeDisp: '04:00 pm', isEnable: true, isActive: false }, { startTime: '16:00', endTime: '16:30', startTimeDisp: '04:00', endTimeDisp: '04:30 pm', isEnable: true, isActive: false }, { startTime: '16:30', endTime: '17:00', startTimeDisp: '04:30', endTimeDisp: '05:00 pm', isEnable: true, isActive: false }, { startTime: '17:00', endTime: '17:30', startTimeDisp: '05:00', endTimeDisp: '05:30 pm', isEnable: true, isActive: false }, { startTime: '17:30', endTime: '18:00', startTimeDisp: '05:30', endTimeDisp: '06:00 pm', isEnable: true, isActive: false }, { startTime: '18:00', endTime: '18:30', startTimeDisp: '06:00', endTimeDisp: '06:30 pm', isEnable: true, isActive: false }, { startTime: '18:30', endTime: '19:00', startTimeDisp: '06:30', endTimeDisp: '07:00 pm', isEnable: true, isActive: false }, { startTime: '19:00', endTime: '19:30', startTimeDisp: '07:00', endTimeDisp: '07:30 pm', isEnable: true, isActive: false }, { startTime: '19:30', endTime: '20:00', startTimeDisp: '07:30', endTimeDisp: '08:00 pm', isEnable: true, isActive: false }, { startTime: '20:00', endTime: '20:30', startTimeDisp: '08:00', endTimeDisp: '08:30 pm', isEnable: true, isActive: false }, { startTime: '20:30', endTime: '21:00', startTimeDisp: '08:30', endTimeDisp: '09:00 pm', isEnable: true, isActive: false }];
      this.getAvailableTime(d);
    }
    this.getTestCosts();
    this.getFastingTests();
    this.GSTFee = this.$GSTFee;
    if (!this.isDateAndTimeChoosed) {
      setTimeout(function () {
        $('#choose-date').modal('show');
      }, 400);
    }
  },

  mounted: function mounted() {
    this.$parent.$children[0].step = this.step;
    this.$parent.$children[0].current = 'health';
  }

});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3b0a9007","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/Book/Appointment.vue
var Book_Appointment_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"AppointmentDiv"}},[_c('HeaderVue'),_vm._v(" "),_c('div',{staticClass:"header"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"menu"},[_c('a',{staticStyle:{"color":"#9e9e9e"},attrs:{"href":"javascript:void(0)"},on:{"click":function($event){_vm.goBackPopup()}}},[_c('i',{staticClass:"material-icons"},[_vm._v("\n                                arrow_back\n                            ")])])]),_vm._v(" "),_vm._m(0,false,false)])])])]),_vm._v(" "),_c('div',{staticClass:"container-fluid"},[(_vm.isFasting == 1)?_c('div',{staticClass:"alert alert-info"},[_c('strong',[_vm._v("Info:")]),_vm._v(" One or more of the tests ordered would require fasting. Please make sure you choose a convenient time accordingly.\n        ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isDateAndTimeChoosed == true),expression:"isDateAndTimeChoosed == true"}],staticClass:"alert alert-success mb-0 drop-shadow",attrs:{"role":"alert"}},[_vm._v("\n                   "+_vm._s(_vm.formatDate(_vm.$localStorage.get('ct').date))+" BETWEEN "+_vm._s(_vm.timeSelected.startTimeDisp)+" to "+_vm._s(_vm.timeSelected.endTimeDisp)+"\n                    "),_c('a',{staticClass:"pull-right blue-color",on:{"click":function($event){_vm.changeDateAndTime()}}},[_c('i',{staticClass:"fa fa-pencil white-color",attrs:{"aria-hidden":"true"}})])]),_vm._v(" "),(_vm.timeSelected.startTimeDisp && _vm.timeSelected.endTimeDisp && _vm.formatDate(_vm.$localStorage.get('ct').date) && _vm.isDateAndTimeChoosed)?_c('p',{staticClass:"confirm-notification"},[_c('i',{staticClass:"material-icons green-color float-left mr-2"},[_vm._v("check")]),_vm._v(" Our Phlebotomist will visit as per your selected schedule\n                ")]):_vm._e(),_vm._v(" "),(!_vm.formatDate(_vm.$localStorage.get('ct').date) ||  !_vm.timeSelected.startTimeDisp  ||  !_vm.timeSelected.endTimeDisp || !_vm.isDateAndTimeChoosed)?_c('span',[_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.isDateAndTimeChoosed == false),expression:"isDateAndTimeChoosed == false"}],staticClass:"text-center gray-color mt-3 mb-1"},[_vm._v("\n                        Select Sample Pickup Date/Time\n                    ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary full-width",attrs:{"data-toggle":"modal","data-target":"#choose-date"}},[_vm._v("\n                        Choose Date / Time\n                    ")])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-12 mt-4"})])]),_vm._v(" "),_c('div',{staticClass:"container-fluid gray-bg"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"lab display-flex no-border p-0 mt-3 bg-tranparent"},[_c('div',{staticClass:"flex-box"},[_c('div',{staticClass:"lab-logo"},[(_vm.selectedLab.logo && _vm.selectedLab.logo.length > 0)?_c('img',{attrs:{"src":_vm.selectedLab.logo}}):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"flex-box"},[_c('p',{staticClass:"black-color font-weight-bold mb-2"},[_vm._v("\n                           "+_vm._s(_vm.selectedLab.labName)+"\n                        ")]),_vm._v(" "),_c('p',{staticClass:"mt-0 mb-1"},[_vm._v(_vm._s(_vm.selectedLab.branch.branchLocation+', '+_vm.selectedLab.branch.branchCity+' - '+_vm.selectedLab.branch.branchZipCode))]),_vm._v(" "),_c('router-link',{staticClass:"text-uppercase font-weight-bold",attrs:{"to":"/lab"}},[_vm._v("Change Lab")]),_vm._v(" | "),_c('a',{staticClass:"text-uppercase  font-weight-bold link-blue-color",on:{"click":function($event){_vm.addTest()}}},[_vm._v("Add test")])],1)])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"table-responsive test-conformation"},[_c('table',{staticClass:"table"},[_vm._m(1,false,false),_vm._v(" "),(_vm.testCosts.priceDetails)?_c('tbody',{staticClass:"black-color"},_vm._l((_vm.testCosts.priceDetails),function(cost,index){return _c('tr',{key:index},[_c('td',[_vm._v("\n                                    "+_vm._s(cost.aliasName)+"\n                                ")]),_vm._v(" "),_c('td',[_c('p',{staticClass:"float-right mt-1 mb-0 price-tag"},[(cost.actualPrice > cost.ourPrice)?_c('span',{staticClass:"red-color strip-text"},[_vm._v("Rs. "+_vm._s(cost.actualPrice))]):_vm._e(),_vm._v(" Rs. "+_vm._s(cost.ourPrice)+"\n                                    ")])]),_vm._v(" "),_c('td',[_c('button',{staticClass:"btn btn-link remove-btn p-0",on:{"click":function($event){_vm.removeSelectedItems(cost, _vm.$localStorage.get('st'), _vm.$localStorage.get('sl'))}}},[_c('img',{attrs:{"src":"static/images/close-black.svg","alt":"delete"}})])])])})):_vm._e(),_vm._v(" "),_c('tfoot',{staticClass:"border-bottom"},[_c('tr',[_c('td',[_vm._v("Sub Total")]),_vm._v(" "),_c('td',[_c('p',{staticClass:"float-right mt-1 mb-0 price-tag"},[_vm._v("\n                                        Rs. "+_vm._s(_vm.payinfo.total)+"\n                                    ")])]),_vm._v(" "),_c('td')])])])])])])]),_vm._v(" "),_c('div',{staticClass:"fixed-footer p-0",attrs:{"id":"fixed-footer"}},[(!_vm.$localStorage.get('profile'))?_c('button',{staticClass:"btn btn-primary full-width fixed-button",class:{'btn-secondary': (!_vm.dt || !_vm.timeSelected), 'btn-primary' : !(!_vm.dt || !_vm.timeSelected)},attrs:{"disabled":(!_vm.dt || !_vm.timeSelected),"data-toggle":"modal","data-target":".login-box","data-backdrop":"static","data-keyboard":"false"},on:{"click":function($event){_vm.$root.$emit('appointmentLogin',true); _vm.fbTriggerDate()}}},[_vm._v("Proceed to checkout")]):_c('button',{staticClass:"btn btn-primary full-width fixed-button",class:{'btn-secondary': (!_vm.dt || !_vm.timeSelected), 'btn-primary': !(!_vm.dt || !_vm.timeSelected) },attrs:{"disabled":(!_vm.dt || !_vm.timeSelected)},on:{"click":function($event){_vm.goChooseLocation()}}},[_vm._v("Proceed to checkout")])]),_vm._v(" "),_c('FooterVue'),_vm._v(" "),_c('div',{staticClass:"modal fade",attrs:{"id":"choose-date","tabindex":"-1","role":"dialog","aria-labelledby":"choose-dateLabel","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog",attrs:{"role":"document"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isDateAndTimeChoosed == false),expression:"isDateAndTimeChoosed == false"}],staticClass:"modal-content"},[_vm._m(2,false,false),_vm._v(" "),_c('div',{staticClass:"modal-body pt-0"},[_c('div',{staticClass:"row primary-bg pt-3 pb-3"},[_c('div',{staticClass:"col-6"},[_c('a',{staticClass:"white-color",on:{"click":function($event){_vm.showhide()}}},[_c('p',{staticClass:"mb-2"},[_vm._v("Date")]),_vm._v(" "),_c('h5',{staticClass:"mt-0 opacity-50",staticStyle:{"color":"#fbf5f5"}},[_vm._v(_vm._s(_vm.formatDate(_vm.$localStorage.get('ct').date)))])])]),_vm._v(" "),(_vm.timeSelected.startTimeDisp && _vm.timeSelected.endTimeDisp)?_c('div',{staticClass:"col-6"},[_c('a',{staticClass:"white-color",on:{"click":function($event){_vm.timepicker=true; _vm.datepicker=false;}}},[_c('p',{staticClass:"mb-2"},[_vm._v("Time")]),_vm._v(" "),_c('h5',{staticClass:"mt-0 opacity-50",staticStyle:{"color":"#fbf5f5"}},[_vm._v(_vm._s(_vm.timeSelected.startTimeDisp + ' to ' + _vm.timeSelected.endTimeDisp))])])]):_c('div',{staticClass:"col-6"},[_c('a',{staticClass:"white-color",on:{"click":function($event){_vm.timepicker=true; _vm.datepicker=false;}}},[_c('p',{staticClass:"mb-2"},[_vm._v("Time")]),_vm._v(" "),_c('h5',{staticClass:"m-0 opacity-50",staticStyle:{"color":"#fbf5f5"}},[_vm._v("HR:MIN")])])])]),_vm._v(" "),(_vm.isDatePickerOpend)?_c('div',{attrs:{"id":"dateAndTime","role":"tabpanel","aria-labelledby":"headingOne","data-parent":"#accordion"}},[_c('div',{staticClass:"card-body"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.datepicker),expression:"datepicker"}],staticClass:"datepicker-box"},[_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"row",staticStyle:{"padding-top":"10%"}},[_vm._m(3,false,false),_vm._v(" "),_c('div',{staticClass:"col-6"},[_c('p',{staticClass:"text-right",on:{"click":function($event){_vm.timepicker=true; _vm.datepicker=false}}},[_c('span',{staticClass:"mt-2"},[_vm._v(" Edit Time")]),_vm._v("\n                                                 "),_c('i',{staticClass:"material-icons float-right mr-2"},[_vm._v("arrow_forward")])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('datepicker',{attrs:{"inline":true,"value":_vm.dt,"format":'dd/MM/yyyy',"disabled":_vm.disabled},on:{"selected":_vm.dateChange},model:{value:(_vm.dt),callback:function ($$v) {_vm.dt=$$v},expression:"dt"}})],1)])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.timepicker),expression:"timepicker"}],staticClass:"timepicker"},[_c('div',{staticClass:"row mt-3"},[_c('div',{staticClass:"col-6"},[_c('p',{staticClass:"text-left",on:{"click":function($event){_vm.showhide()}}},[_c('i',{staticClass:"material-icons float-left mr-2"},[_vm._v("keyboard_backspace")]),_vm._v(" "),_c('span',{staticClass:"mt-2"},[_vm._v(" Edit Date")])])]),_vm._v(" "),_vm._m(4,false,false)]),_vm._v(" "),_vm._m(5,false,false),_vm._v(" "),(_vm.availableTimes)?_c('div',[_c('ul',{staticClass:"time-list"},_vm._l((_vm.availableTimes),function(value,index){return _c('li',{class:{'active':(_vm.timeSelected.startTime === value.startTime) && (_vm.timeSelected.endTime === value.endTime), 'disabled': (value.isEnable === false)}},[(value.isEnable)?_c('label',{staticClass:"time-chips m-0",on:{"click":function($event){_vm.setTime(value)}}},[_vm._v("\n                                                    "+_vm._s(value.startTimeDisp)+" - "+_vm._s(value.endTimeDisp)+"\n                                                ")]):_vm._e(),_vm._v(" "),(!value.isEnable)?_c('label',{staticClass:"time-chips m-0"},[_vm._v("\n                                                    "+_vm._s(value.startTimeDisp)+" - "+_vm._s(value.endTimeDisp)+"\n                                                ")]):_vm._e()])}))]):_vm._e()])])]):_vm._e()])])])]),_vm._v(" "),_c('Login')],1)}
var Book_Appointment_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h3',{staticClass:"screen-title mt-13p"},[_c('span',{staticClass:"float-left"},[_vm._v("\n                            Health Cart\n                        ")]),_vm._v(" "),_c('span',{staticClass:"float-right gray-color"},[_vm._v("\n                            Step 1 of 3\n                        ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{staticClass:"no-border"},[_vm._v("\n                                    Test Name\n                                ")]),_vm._v(" "),_c('th',{staticClass:"text-right no-border"},[_vm._v("\n                                    Price\n                                ")]),_vm._v(" "),_c('th',{staticClass:"no-border"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"menu_popup",attrs:{"data-dismiss":"modal","aria-label":"Close"}},[_c('i',{staticClass:"material-icons"},[_vm._v("arrow_back")])]),_vm._v(" "),_c('h3',{staticClass:"screen-title mt-13p"},[_vm._v("Choose Date / Time")])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-6"},[_c('p',{staticClass:"text-left"},[_vm._v("Choose Date")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-6"},[_c('p',{staticClass:"text-center gray-color"},[_vm._v("Choose Time Slot")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12 p-0"},[_c('hr',{staticClass:"mt-0"}),_vm._v(" "),_c('ul',{staticClass:"key-points"},[_c('li',[_c('span',{staticClass:"circle-point available"}),_vm._v(" Available")]),_vm._v(" "),_c('li',[_c('span',{staticClass:"circle-point booked"}),_vm._v(" Un-Available")]),_vm._v(" "),_c('li',[_c('span',{staticClass:"circle-point selected"}),_vm._v(" Selected Time")])]),_vm._v(" "),_c('hr')])])}]
var Book_Appointment_esExports = { render: Book_Appointment_render, staticRenderFns: Book_Appointment_staticRenderFns }
/* harmony default export */ var components_mobile_Book_Appointment = (Book_Appointment_esExports);
// CONCATENATED MODULE: ./src/components/mobile/Book/Appointment.vue
function Book_Appointment_injectStyle (ssrContext) {
  __webpack_require__("m6qz")
}
var Book_Appointment_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var Book_Appointment___vue_template_functional__ = false
/* styles */
var Book_Appointment___vue_styles__ = Book_Appointment_injectStyle
/* scopeId */
var Book_Appointment___vue_scopeId__ = "data-v-3b0a9007"
/* moduleIdentifier (server only) */
var Book_Appointment___vue_module_identifier__ = null
var Book_Appointment_Component = Book_Appointment_normalizeComponent(
  mobile_Book_Appointment,
  components_mobile_Book_Appointment,
  Book_Appointment___vue_template_functional__,
  Book_Appointment___vue_styles__,
  Book_Appointment___vue_scopeId__,
  Book_Appointment___vue_module_identifier__
)

/* harmony default export */ var src_components_mobile_Book_Appointment = (Book_Appointment_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/Book/Secure/Address.vue
var mobile_Book_Secure_Address = __webpack_require__("Kqai");

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-614d6e84","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/Book/Secure/Address.vue
var Secure_Address_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"AddressDiv"}},[_c('HeaderVue'),_vm._v(" "),_c('div',{staticClass:"header"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"menu_popup"},[_c('a',{staticStyle:{"color":"#9e9e9e"},on:{"click":function($event){_vm.goBackPopup()}}},[_c('i',{staticClass:"material-icons"},[_vm._v("\n                          arrow_back\n                      ")])])]),_vm._v(" "),_vm._m(0,false,false)])])])]),_vm._v(" "),_c('div',{staticClass:"container-fluid pick-address",class:{'display-block' : _vm.isPage, 'display-none' : !_vm.isPage}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"alert alert-dark rounded-0 clearfix border-0",attrs:{"role":"alert"}},[_c('span',{staticClass:"float-left"},[_vm._v("Patient Details")]),_vm._v(" "),_c('span',{staticClass:"float-right blue-color",on:{"click":function($event){_vm.addMember()}}},[_vm._m(1,false,false),_vm._v("\n                      Add New\n                  ")])]),_vm._v(" "),(_vm.members)?_c('ul',{staticClass:"patient-list mt-4"},[(_vm.members.user)?_c('li',{class:{'selected-address' : (_vm.members.user.userId == _vm.isMemberActiveId && _vm.isMe == true)}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-8",on:{"click":function($event){_vm.isMemberActiveId = _vm.members.user.userId; _vm.setActiveMemberId(_vm.members.user)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("check_circle")])]),_vm._v(" "),_c('div',{staticClass:"col-2"},[_c('button',{staticClass:"btn btn-link edit-btn p-0 float-right",on:{"click":function($event){_vm.editMemberProfile(1)}}},[_c('img',{attrs:{"src":"static/images/pen-blue.svg","alt":""}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('p',{staticClass:"mt-2 mb-0"},[_vm._v(_vm._s(_vm.members.user.firstName + ' ' + _vm.members.user.lastName))]),_vm._v(" "),(_vm.members.user.age || (_vm.members.user.sex && _vm.members.user.sex.length > 0) )?_c('p',{staticClass:"mb-0"},[_vm._v(_vm._s(_vm.members.user.age)+", "+_vm._s((_vm.members.user.sex==='O'?'Other':((_vm.members.user.sex==='M')?'Male':((_vm.members.user.sex==='F')?'Female':'')))))]):_vm._e(),_vm._v(" "),(_vm.members.user.mobile)?_c('p',[_vm._v("M: "+_vm._s(_vm.members.user.mobile))]):_vm._e()])])]):_vm._e(),_vm._v(" "),_vm._l((_vm.members.family),function(family,index){return _c('li',{key:index,class:{'selected-address' : (family.memberId === _vm.isMemberActiveId && _vm.isMe == false)}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-8",on:{"click":function($event){_vm.isMemberActiveId = family.memberId; _vm.setActiveMemberId(family)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("check_circle")])]),_vm._v(" "),_c('div',{staticClass:"col-2"},[_c('button',{staticClass:"btn btn-link edit-btn p-0 float-right",on:{"click":function($event){_vm.editMember(family)}}},[_c('img',{attrs:{"src":"static/images/pen-blue.svg","alt":""}})])]),_vm._v(" "),((family.memberId !== _vm.isMemberActiveId || _vm.isMe))?_c('div',{staticClass:"col-2",on:{"click":function($event){_vm.deleteMember(family)}}},[_vm._m(2,true,false)]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('p',{staticClass:"mt-2 mb-0"},[_vm._v(_vm._s(family.firstName + ' ' + family.lastName))]),_vm._v(" "),(family.age || (family.sex && family.sex.length > 0) )?_c('p',{staticClass:"mb-0"},[_vm._v(_vm._s(family.age)+", "+_vm._s((family.sex==='O'?'Other':((family.sex==='M')?'Male':((family.sex==='F')?'Female':'')))))]):_vm._e(),_vm._v(" "),(family.mobile)?_c('p',[_vm._v("M: "+_vm._s(family.mobile))]):_vm._e()])])])})],2):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"alert alert-dark rounded-0 clearfix border-0",attrs:{"role":"alert"}},[_c('span',{staticClass:"float-left"},[_vm._v("Pickup Address")]),_vm._v(" "),_c('span',{staticClass:"float-right blue-color",on:{"click":function($event){_vm.addAddress()}}},[_vm._m(3,false,false),_vm._v("\n                      Add New\n                  ")])]),_vm._v(" "),(_vm.addresses)?_c('ul',{staticClass:"patient-list mt-4"},_vm._l((_vm.addresses),function(address,index){return _c('li',{key:index,class:{'selected-address' : (address.addressId === _vm.isAddressActiveId)}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-8",on:{"click":function($event){_vm.selectAddress(address)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("check_circle")])]),_vm._v(" "),_c('div',{staticClass:"col-2"},[_c('button',{staticClass:"btn btn-link edit-btn p-0 float-right",on:{"click":function($event){_vm.editAddress(address) }}},[_c('img',{attrs:{"src":"static/images/pen-blue.svg","alt":""}})])]),_vm._v(" "),((address.addressId !== _vm.isAddressActiveId))?_c('div',{staticClass:"col-2",on:{"click":function($event){_vm.deleteAddress(address.addressId)}}},[_vm._m(4,true,false)]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('address',{staticClass:"mt-2"},[_vm._v("\n                                  "+_vm._s(address.flatNo ? address.flatNo +', ' : '')+" "+_vm._s(address.address)+", "+_vm._s(address.landmark ? address.landmark +', ' : '')+" "+_vm._s(address.Location.locationName)+", "),_c('br'),_vm._v(_vm._s(address.City.cityName)+" - "+_vm._s(address.zipCode)+". \n\n                                        ")])])])])})):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-12"})])]),_vm._v(" "),_c('div',{staticClass:"fixed-footer p-0",class:{'display-block' : _vm.isPage, 'display-none' : !_vm.isPage},attrs:{"id":"fixed-footer"}},[_c('div',{staticClass:"test-details-popover",attrs:{"id":"accordion","role":"tablist"}},[_c('div',{staticClass:"card m-0"},[_c('div',{staticClass:"card-header",attrs:{"role":"tab","id":"headingOne"}},[_c('h5',{staticClass:"mb-0"},[_c('a',{staticClass:"collapsed gray-color",attrs:{"data-toggle":"collapse","href":"#testDetails","aria-expanded":"true","aria-controls":"testDetails"}},[_vm._v("\n                          Test Details\n                          "),_c('span',[_vm._v(_vm._s(_vm.$localStorage.get('st') && _vm.$localStorage.get('st').length > 0 ? '(' + _vm.$localStorage.get('st').length + ')' : ''))]),_vm._v(" "),_c('i',{staticClass:"material-icons float-right"})])])]),_vm._v(" "),_c('div',{staticClass:"collapse",attrs:{"id":"testDetails","role":"tabpanel","aria-labelledby":"headingOne","data-parent":"#accordion"}},[_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"lab display-flex no-border p-0 mt-3 bg-tranparent"},[_c('div',{staticClass:"flex-box"},[_c('div',{staticClass:"lab-logo"},[(_vm.selectedLab.logo && _vm.selectedLab.logo.length > 0)?_c('img',{attrs:{"src":_vm.selectedLab.logo}}):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"flex-box"},[_c('p',{staticClass:"black-color font-weight-bold mb-2"},[_vm._v("\n                                          "+_vm._s(_vm.$localStorage.get('sl').labName)+"\n                                      ")]),_vm._v(" "),_c('p',{staticClass:"mt-0 mb-1"},[_vm._v(_vm._s(_vm.$localStorage.get('sl').branch.branchLocation + ', ' + _vm.$localStorage.get('sl').branch.branchCity + '-' + _vm.$localStorage.get('sl').branch.branchZipCode))])])])])]),_vm._v(" "),_c('div',{staticClass:"row scroll-test"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"table-responsive test-conformation"},[_c('table',{staticClass:"table"},[_vm._m(5,false,false),_vm._v(" "),_c('tbody',{staticClass:"black-color"},_vm._l((_vm.testCosts.priceDetails),function(cost,index){return _c('tr',{key:index},[_c('td',[_vm._v("\n                                                "+_vm._s(cost.aliasName)+"\n                                            ")]),_vm._v(" "),_c('td'),_vm._v(" "),_c('td',[_c('p',{staticClass:"float-right mt-1 mb-0 price-tag"},[_vm._v("\n                                                      Rs. "+_vm._s(cost.ourPrice)+"\n                                                ")])])])}))])]),_vm._v(" "),_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table price-table"},[_c('tbody',[_c('tr',[_c('td',[_vm._v("Order Value")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("Rs. "+_vm._s(_vm.payinfo.total))])]),_vm._v(" "),(_vm.payinfo.phlebotomistFee > 0)?_c('tr',{staticClass:"black-color"},[_c('td',[_vm._v("Phlebotomist Fee")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("Rs. "+_vm._s(_vm.payinfo.phlebotomistFee))])]):_vm._e(),_vm._v(" "),(_vm.payinfo.mrpTotal != _vm.payinfo.subTotal)?_c('tr',{staticClass:"black-color"},[_c('td',[_vm._v("Sub Total")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("Rs. "+_vm._s(_vm.payinfo.subTotal))])]):_vm._e(),_vm._v(" "),(_vm.payinfo.couponFee > 0)?_c('tr',{staticClass:"black-color"},[_c('td',[_vm._v("Coupon Discount")]),_vm._v(" "),_c('td',{staticClass:"text-right green-color"},[_vm._v("- Rs. "+_vm._s(_vm.payinfo.couponFee))])]):_vm._e(),_vm._v(" "),(_vm.payinfo.phlebotomyFeeWaiver > 0)?_c('tr',{staticClass:"black-color"},[_c('td',[_vm._v("Coupon Discount")]),_vm._v(" "),_c('td',{staticClass:"text-right green-color"},[_vm._v("-Rs. "+_vm._s(_vm.payinfo.phlebotomyFeeWaiver))])]):_vm._e(),_vm._v(" "),_c('tr',{staticClass:"black-color"},[_c('td',[_vm._v("Amount Payable")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("Rs. "+_vm._s(_vm.payinfo.grandTotal))])])])])])])])])])])]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary full-width fixed-button",on:{"click":function($event){$event.preventDefault();if($event.target !== $event.currentTarget){ return null; }_vm.goPayment()}}},[_vm._v("\n          Proceed to payment\n      ")])]),_vm._v(" "),_c('div',{staticClass:"container-fluid pick-address",class:{'display-block' : _vm.isAddAddressPage, 'display-none' : !_vm.isAddAddressPage}},[_c('form',{attrs:{"data-vv-scope":"addAddress"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_vm._m(6,false,false),_vm._v(" "),_c('div',{staticClass:"clearfix mt-4 line-textbox"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],staticClass:"form-group"},[_c('label',[_vm._v("Full name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.addAddressFields.addressName),expression:"addAddressFields.addressName"},{name:"validate",rawName:"v-validate",value:('required|alpha_spaces'),expression:"'required|alpha_spaces'"}],staticClass:"form-control",attrs:{"type":"text","name":"fullName","id":"fullName","maxlength":"100","data-vv-as":"full name"},domProps:{"value":(_vm.addAddressFields.addressName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.addAddressFields, "addressName", $event.target.value)}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('addAddress.fullName')),expression:"errors.has('addAddress.fullName')"}],staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('addAddress.fullName')))])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Flat No, Floor and Apt Name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.addAddressFields.flatNo),expression:"addAddressFields.flatNo"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"form-control",attrs:{"type":"text","name":"flatNo","id":"flatNo","data-vv-as":"flatNo","maxlength":"500"},domProps:{"value":(_vm.addAddressFields.flatNo)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.addAddressFields, "flatNo", $event.target.value)}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('addAddress.flatNo')),expression:"errors.has('addAddress.flatNo')"}],staticClass:"text-danger"},[_vm._v("Flat No, Floor and Apt Name is required.")])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Street Address")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.addAddressFields.address),expression:"addAddressFields.address"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"form-control",attrs:{"type":"text","name":"address","id":"address","data-vv-as":"address"},domProps:{"value":(_vm.addAddressFields.address)},on:{"blur":function($event){_vm.addressChanged(1)},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.addAddressFields, "address", $event.target.value)}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('addAddress.address')),expression:"errors.has('addAddress.address')"}],staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('addAddress.address')))])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_vm._m(7,false,false),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.addAddressFields.landmark),expression:"addAddressFields.landmark"}],staticClass:"form-control",attrs:{"type":"text","name":"landmark","id":"landmark","data-vv-as":"landmark","maxlength":"300"},domProps:{"value":(_vm.addAddressFields.landmark)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.addAddressFields, "landmark", $event.target.value)}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('addAddress.landmark')),expression:"errors.has('addAddress.landmark')"}],staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('addAddress.landmark')))])]),_vm._v(" "),_c('div',{staticClass:"form-group address-locality-search"},[_vm._m(8,false,false),_vm._v(" "),_c('span',{on:{"click":function($event){_vm.onFocusLocality()}}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.addAddressFields.zipcode),expression:"addAddressFields.zipcode"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Enter Locality","aria-label":"","name":"x","list":"mycarousel","autocomplete":"off","minlength":"3","disabled":"true"},domProps:{"value":(_vm.addAddressFields.zipcode)},on:{"focus":function($event){_vm.onFocusLocality()},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.addAddressFields, "zipcode", $event.target.value)}}})]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('addAddress.zipcode')),expression:"errors.has('addAddress.zipcode')"}],staticClass:"text-danger"},[_vm._v("The Locality/Pincode field is required")]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.isInvalidPincode),expression:"isInvalidPincode"}],staticClass:"text-danger"},[_vm._v("Please choose Locality/Pincode")]),_vm._v(" "),_c('div',{staticClass:"test-option full-width mt-4 scrollbar locality",style:({ display: _vm.onBlurKey})},[_c('div',{staticClass:"popular-test focus-search p-0"},[_c('ul',{staticClass:"p-0 m-0"},[_vm._l((_vm.locationList),function(item,index){return _c('li',{key:index,staticClass:"p-2",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.selectLocation($event, item, 2)}}},[_vm._v("\n                                        "+_vm._s(item.locationName+'-'+item.locationZipCode)+"\n                                    ")])}),_vm._v(" "),(_vm.locationList.length === 0)?_c('li',{staticClass:"text-center"},[_vm._v(" --- No Locations ---")]):_vm._e(),_vm._v(" "),(_vm.locationList.length === 0)?_c('li',{staticClass:"p-2 color-blue text-center",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.selectLocation($event, undefined, 3)}}},[_vm._v("\n                                        + Add Location\n                                    ")]):_vm._e(),_vm._v(" "),(_vm.locationList.length !== 0)?_c('li',{staticClass:"p-2 color-blue ",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.selectLocation($event, undefined, 3)}}},[_vm._v("\n                                        + Add Location\n                                    ")]):_vm._e()],2)])])]),_vm._v(" "),(_vm.showLocOther)?_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("New Pincode")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.addAddressFields.locationPincode),expression:"addAddressFields.locationPincode"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],ref:"newPincodeAdd",staticClass:"form-control",attrs:{"type":"text","name":"locationPincode","id":"locationPincode","maxlength":"6"},domProps:{"value":(_vm.addAddressFields.locationPincode)},on:{"blur":function($event){_vm.addressChanged(1)},"keypress":_vm.isNumberEdit,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.addAddressFields, "locationPincode", $event.target.value)}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('addAddress.locationPincode')),expression:"errors.has('addAddress.locationPincode')"}],staticClass:"text-danger"},[_vm._v("The Pincode field is required.")])]):_vm._e(),_vm._v(" "),(_vm.showLocOther)?_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("New Location")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.addAddressFields.locationOther),expression:"addAddressFields.locationOther"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"form-control",attrs:{"type":"text","name":"locationOther","id":"locationOther"},domProps:{"value":(_vm.addAddressFields.locationOther)},on:{"blur":function($event){_vm.addressChanged(1)},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.addAddressFields, "locationOther", $event.target.value)}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('addAddress.locationOther')),expression:"errors.has('addAddress.locationOther')"}],staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('addAddress.locationOther')))])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('p',{staticClass:"black-color"},[_c('span',[_vm._v(_vm._s(_vm.stateCityDisp))])])])])]),_vm._v(" "),_vm._m(9,false,false)]),_vm._v(" "),_c('div',{staticClass:"row mt-25"},[_c('div',{staticClass:"col-6"},[_c('button',{staticClass:"btn btn-link full-width",on:{"click":function($event){_vm.cancelModalPopup()}}},[_vm._v("Cancel")])]),_vm._v(" "),_c('div',{staticClass:"col-6"},[_c('button',{staticClass:"btn btn-primary full-width",attrs:{"type":"button"},on:{"click":function($event){_vm.saveAddress()}}},[_vm._v("Save")])])])])]),_vm._v(" "),_c('div',{staticClass:"container-fluid pick-address",class:{'display-block' : _vm.isEditAddressPage, 'display-none' : !_vm.isEditAddressPage}},[_c('form',{attrs:{"data-vv-scope":"editAddress"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_vm._m(10,false,false),_vm._v(" "),_c('div',{staticClass:"clearfix mt-4 line-textbox"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],staticClass:"form-group"},[_c('label',[_vm._v("Full name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.editAddressFields.addressName),expression:"editAddressFields.addressName"},{name:"validate",rawName:"v-validate",value:('required|alpha_spaces'),expression:"'required|alpha_spaces'"}],staticClass:"form-control",attrs:{"type":"text","name":"fullName","id":"fullName","maxlength":"100","data-vv-as":"full name"},domProps:{"value":(_vm.editAddressFields.addressName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.editAddressFields, "addressName", $event.target.value)}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('editAddress.fullName')),expression:"errors.has('editAddress.fullName')"}],staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('editAddress.fullName')))])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Flat No, Floor and Apt Name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.editAddressFields.flatNo),expression:"editAddressFields.flatNo"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"form-control",attrs:{"type":"text","name":"flatNo","id":"flatNo","data-vv-as":"flatNo"},domProps:{"value":(_vm.editAddressFields.flatNo)},on:{"blur":function($event){_vm.addressChanged(2)},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.editAddressFields, "flatNo", $event.target.value)}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('editAddress.flatNo')),expression:"errors.has('editAddress.flatNo')"}],staticClass:"text-danger"},[_vm._v("Flat No, Floor and Apt Name is required.")])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Address")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.editAddressFields.address),expression:"editAddressFields.address"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"form-control",attrs:{"type":"text","name":"address","id":"address","data-vv-as":"address"},domProps:{"value":(_vm.editAddressFields.address)},on:{"blur":function($event){_vm.addressChanged(2)},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.editAddressFields, "address", $event.target.value)}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('editAddress.address')),expression:"errors.has('editAddress.address')"}],staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('editAddress.address')))])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_vm._m(11,false,false),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.editAddressFields.landmark),expression:"editAddressFields.landmark"}],staticClass:"form-control",attrs:{"type":"text","name":"landmark","id":"landmark","data-vv-as":"landmark"},domProps:{"value":(_vm.editAddressFields.landmark)},on:{"blur":function($event){_vm.addressChanged(2)},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.editAddressFields, "landmark", $event.target.value)}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('editAddress.landmark')),expression:"errors.has('editAddress.landmark')"}],staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('editAddress.landmark')))])]),_vm._v(" "),_c('div',{staticClass:"form-group address-locality-search"},[_vm._m(12,false,false),_vm._v(" "),_c('span',{on:{"click":function($event){_vm.onFocusLocality()}}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.editAddressFields.zipcode),expression:"editAddressFields.zipcode"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Enter Locality","aria-label":"","name":"x","list":"mycarousel","autocomplete":"off","minlength":"3","disabled":"true"},domProps:{"value":(_vm.editAddressFields.zipcode)},on:{"focus":function($event){_vm.onFocusLocality()},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.editAddressFields, "zipcode", $event.target.value)}}})]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('editAddress.zipcode')),expression:"errors.has('editAddress.zipcode')"}],staticClass:"text-danger"},[_vm._v("The Locality/Pincode field is required")]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.isInvalidPincode),expression:"isInvalidPincode"}],staticClass:"text-danger"},[_vm._v("Please choose Locality/Pincode")])]),_vm._v(" "),(_vm.showLocOther)?_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("New Pincode")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.editAddressFields.locationPincode),expression:"editAddressFields.locationPincode"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],ref:"newPincodeEdit",staticClass:"form-control",attrs:{"type":"text","name":"locationPincode","id":"locationPincode","maxlength":"6"},domProps:{"value":(_vm.editAddressFields.locationPincode)},on:{"blur":function($event){_vm.addressChanged(2)},"keypress":_vm.isNumberEdit,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.editAddressFields, "locationPincode", $event.target.value)}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('editAddress.locationPincode')),expression:"errors.has('editAddress.locationPincode')"}],staticClass:"text-danger"},[_vm._v("The Pincode field is required.")])]):_vm._e(),_vm._v(" "),(_vm.showLocOther)?_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("New Location")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.editAddressFields.locationOther),expression:"editAddressFields.locationOther"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"form-control",attrs:{"type":"text","name":"locationOther","id":"locationOther"},domProps:{"value":(_vm.editAddressFields.locationOther)},on:{"blur":function($event){_vm.addressChanged(2)},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.editAddressFields, "locationOther", $event.target.value)}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('editAddress.locationOther')),expression:"errors.has('editAddress.locationOther')"}],staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('editAddress.locationOther')))])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.stateCityDisp))])])])]),_vm._v(" "),_vm._m(13,false,false)]),_vm._v(" "),_c('div',{staticClass:"row mt-25"},[_c('div',{staticClass:"col-6"},[_c('button',{staticClass:"btn btn-link full-width",on:{"click":function($event){_vm.cancelModalPopup()}}},[_vm._v("Cancel")])]),_vm._v(" "),_c('div',{staticClass:"col-6"},[_c('button',{staticClass:"btn btn-primary full-width",attrs:{"type":"button"},on:{"click":function($event){_vm.updateAddress()}}},[_vm._v("Update")])])])])]),_vm._v(" "),_c('FooterVue'),_vm._v(" "),_c('div',{staticClass:"modal fade",attrs:{"id":"editMemberProfileModal","tabindex":"-1","role":"dialog","aria-labelledby":"exampleModalLabel","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_vm._m(14,false,false),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"form-content line-textbox"},[_c('form',{attrs:{"data-vv-scope":"edit"}},[_c('div',{staticClass:"clearfix"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("First Name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.editMemberObj.firstName),expression:"editMemberObj.firstName"},{name:"validate",rawName:"v-validate",value:('required|alpha_spaces|min:3|max:50'),expression:"'required|alpha_spaces|min:3|max:50'"}],staticClass:"form-control",attrs:{"type":"text","name":"firstName","data-vv-as":"first name","maxlength":"50"},domProps:{"value":(_vm.editMemberObj.firstName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.editMemberObj, "firstName", $event.target.value)}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('edit.firstName')),expression:"errors.has('edit.firstName')"}],staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('edit.firstName')))])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Last Name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.editMemberObj.lastName),expression:"editMemberObj.lastName"},{name:"validate",rawName:"v-validate",value:('required|alpha_spaces|min:3|max:50'),expression:"'required|alpha_spaces|min:3|max:50'"}],staticClass:"form-control",attrs:{"name":"lastName","type":"text","data-vv-as":"last name","maxlength":"50"},domProps:{"value":(_vm.editMemberObj.lastName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.editMemberObj, "lastName", $event.target.value)}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('edit.lastName')),expression:"errors.has('edit.lastName')"}],staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('edit.lastName')))])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Gender")]),_vm._v(" "),_c('div',{staticClass:"form-check form-check-inline",staticStyle:{"margin-top":"15px","margin-bottom":"0px"}},[_c('label',{staticClass:"form-check-label"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.editMemberObj.sex),expression:"editMemberObj.sex"}],staticClass:"form-check-input",attrs:{"type":"radio","name":"gender","id":"inlineRadio1","value":"M"},domProps:{"checked":(_vm.editMemberObj.sex === 'M')?true:false,"checked":_vm._q(_vm.editMemberObj.sex,"M")},on:{"change":function($event){_vm.$set(_vm.editMemberObj, "sex", "M")}}}),_vm._v(" Male\n                                          ")])]),_vm._v(" "),_c('div',{staticClass:"form-check form-check-inline",staticStyle:{"margin-top":"15px","margin-bottom":"0px"}},[_c('label',{staticClass:"form-check-label"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.editMemberObj.sex),expression:"editMemberObj.sex"}],staticClass:"form-check-input",attrs:{"type":"radio","name":"gender","id":"inlineRadio2","value":"F"},domProps:{"checked":(_vm.editMemberObj.sex === 'F')?true:false,"checked":_vm._q(_vm.editMemberObj.sex,"F")},on:{"change":function($event){_vm.$set(_vm.editMemberObj, "sex", "F")}}}),_vm._v(" Female\n                                          ")])]),_vm._v(" "),_c('div',{staticClass:"form-check form-check-inline",staticStyle:{"margin-top":"15px","margin-bottom":"0px"}},[_c('label',{staticClass:"form-check-label"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.editMemberObj.sex),expression:"editMemberObj.sex"}],staticClass:"form-check-input",attrs:{"type":"radio","name":"gender","id":"inlineRadio3","value":"O"},domProps:{"checked":(_vm.editMemberObj.sex === 'O')?true:false,"checked":_vm._q(_vm.editMemberObj.sex,"O")},on:{"change":function($event){_vm.$set(_vm.editMemberObj, "sex", "O")}}}),_vm._v(" Other\n                                          ")])])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Date of birth")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-4"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.year),expression:"year"}],staticClass:"form-control",attrs:{"name":"year","id":"year"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.year=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){_vm.getNumberOfDays()}]}},[_c('option',{staticClass:"dobOptionColor",attrs:{"value":"","disabled":"","selected":""}},[_vm._v("YYYY")]),_vm._v(" "),_vm._l((_vm.dobYears),function(dobYear,index){return _c('option',{key:index,domProps:{"value":dobYear}},[_vm._v(_vm._s(dobYear))])})],2)]),_vm._v(" "),_c('div',{staticClass:"col-4"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.month),expression:"month"}],staticClass:"form-control",attrs:{"name":"month","id":"month"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.month=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){_vm.getNumberOfDays()}]}},[_c('option',{staticClass:"dobOptionColor",attrs:{"value":"","disabled":"","selected":""}},[_vm._v("MMM")]),_vm._v(" "),_c('option',{attrs:{"value":"01"}},[_vm._v("Jan")]),_vm._v(" "),_c('option',{attrs:{"value":"02"}},[_vm._v("Feb")]),_vm._v(" "),_c('option',{attrs:{"value":"03"}},[_vm._v("Mar")]),_vm._v(" "),_c('option',{attrs:{"value":"04"}},[_vm._v("Apr")]),_vm._v(" "),_c('option',{attrs:{"value":"05"}},[_vm._v("May")]),_vm._v(" "),_c('option',{attrs:{"value":"06"}},[_vm._v("Jun")]),_vm._v(" "),_c('option',{attrs:{"value":"07"}},[_vm._v("Jul")]),_vm._v(" "),_c('option',{attrs:{"value":"08"}},[_vm._v("Aug")]),_vm._v(" "),_c('option',{attrs:{"value":"09"}},[_vm._v("Sep")]),_vm._v(" "),_c('option',{attrs:{"value":"10"}},[_vm._v("Oct")]),_vm._v(" "),_c('option',{attrs:{"value":"11"}},[_vm._v("Nov")]),_vm._v(" "),_c('option',{attrs:{"value":"12"}},[_vm._v("Dec")])])]),_vm._v(" "),_c('div',{staticClass:"col-4"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.ddate),expression:"ddate"}],staticClass:"form-control",attrs:{"name":"ddate","id":"ddate"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.ddate=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{staticClass:"dobOptionColor",attrs:{"value":"","disabled":"","selected":""}},[_vm._v("DD")]),_vm._v(" "),_vm._l((_vm.dobDate),function(dobDateVal,index){return _c('option',{key:index,domProps:{"value":dobDateVal ? (parseInt(dobDateVal) < 10 ? '0'+dobDateVal : dobDateVal) : ''}},[_vm._v(_vm._s(dobDateVal ? (parseInt(dobDateVal) < 10 ? '0'+dobDateVal : dobDateVal) : ''))])})],2)]),_vm._v(" "),_c('div',{staticClass:"col-sm-12"},[(_vm.isDobError)?_c('span',{staticClass:"text-danger"},[_vm._v("The date of birth field is required")]):_vm._e()])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Mobile")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.editMemberObj.phone1),expression:"editMemberObj.phone1"},{name:"validate",rawName:"v-validate",value:('required|numeric|min:10|max:10'),expression:"'required|numeric|min:10|max:10'"}],staticClass:"form-control",attrs:{"type":"text","name":"phone1","data-vv-as":"mobile no."},domProps:{"value":(_vm.editMemberObj.phone1)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.editMemberObj, "phone1", $event.target.value)}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('edit.phone1')),expression:"errors.has('edit.phone1')"}],staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('edit.phone1')))])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Alternate Phone No.")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.editMemberObj.phone2),expression:"editMemberObj.phone2"},{name:"validate",rawName:"v-validate",value:('numeric|min:10|max:10'),expression:"'numeric|min:10|max:10'"}],staticClass:"form-control",attrs:{"type":"text","name":"phone2","data-vv-as":"alternate phone no."},domProps:{"value":(_vm.editMemberObj.phone2)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.editMemberObj, "phone2", $event.target.value)}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('edit.phone2')),expression:"errors.has('edit.phone2')"}],staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('edit.phone2')))])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Email")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.editMemberObj.email),expression:"editMemberObj.email"},{name:"validate",rawName:"v-validate",value:('required|email|max:100'),expression:"'required|email|max:100'"}],staticClass:"form-control",staticStyle:{"background-color":"#fff","cursor":"not-allowed"},attrs:{"type":"email","name":"email","data-vv-as":"email address","disabled":true},domProps:{"value":(_vm.editMemberObj.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.editMemberObj, "email", $event.target.value)}}}),_vm._v(" "),_c('i',{staticClass:"fa",staticStyle:{"font-size":"18px","color":"#000","text-align":"right","float":"right","margin-top":"-25px","margin-right":"10px"}},[_vm._v("")]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('edit.email')),expression:"errors.has('edit.email')"}],staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('edit.email')))])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-6"},[_c('button',{staticClass:"btn  btn-link full-width",on:{"click":function($event){_vm.cancelMember(1)}}},[_vm._v("Cancel")])]),_vm._v(" "),_c('div',{staticClass:"col-6"},[_c('button',{staticClass:"btn btn-primary full-width fly-msg",attrs:{"disabled":(_vm.errors.any())},on:{"click":function($event){$event.preventDefault();_vm.saveProfile()}}},[_vm._v("Update")])])])])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal fade",attrs:{"id":"editPatientProfileModal","tabindex":"-1","role":"dialog","aria-labelledby":"exampleModalLabel","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog ",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_vm._m(15,false,false),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('form',{attrs:{"data-vv-scope":"editMember"},on:{"submit":function($event){$event.preventDefault();_vm.updateMember($event)}}},[_c('div',{staticClass:"clearfix line-textbox"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Patient First Name*")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.editMemberFields.firstName),expression:"editMemberFields.firstName"},{name:"validate",rawName:"v-validate",value:('required|alpha_spaces|max:50'),expression:"'required|alpha_spaces|max:50'"}],ref:"editMemberFirstName",staticClass:"form-control",attrs:{"type":"text","name":"firstName","id":"firstName","maxlength":"50","data-vv-as":"first name"},domProps:{"value":(_vm.editMemberFields.firstName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.editMemberFields, "firstName", $event.target.value)}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('editMember.firstName')),expression:"errors.has('editMember.firstName')"}],staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('editMember.firstName')))])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Patient Last Name*")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.editMemberFields.lastName),expression:"editMemberFields.lastName"},{name:"validate",rawName:"v-validate",value:('required|alpha_spaces|max:50'),expression:"'required|alpha_spaces|max:50'"}],staticClass:"form-control",attrs:{"type":"text","name":"lastName","id":"lastName","maxlength":"50","data-vv-as":"last name"},domProps:{"value":(_vm.editMemberFields.lastName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.editMemberFields, "lastName", $event.target.value)}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('editMember.lastName')),expression:"errors.has('editMember.lastName')"}],staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('editMember.lastName')))])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Mobile*")]),_vm._v(" "),_c('input',{directives:[{name:"mask",rawName:"v-mask",value:('##########'),expression:"'##########'"},{name:"model",rawName:"v-model",value:(_vm.editMemberFields.mobile),expression:"editMemberFields.mobile"},{name:"validate",rawName:"v-validate",value:('required|numeric|min:10|max:10'),expression:"'required|numeric|min:10|max:10'"}],staticClass:"form-control",attrs:{"type":"text","name":"mobile","id":"mobile","maxlength":"50","data-vv-as":"last name"},domProps:{"value":(_vm.editMemberFields.mobile)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.editMemberFields, "mobile", $event.target.value)}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('editMember.mobile')),expression:"errors.has('editMember.mobile')"}],staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('editMember.mobile')))])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Gender*")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"form-check form-check-inline"},[_c('label',{staticClass:"form-check-label"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.editMemberFields.sex),expression:"editMemberFields.sex"}],staticClass:"form-check-input",attrs:{"type":"radio","name":"gender","id":"inlineRadio1","value":"M"},domProps:{"checked":_vm._q(_vm.editMemberFields.sex,"M")},on:{"change":function($event){_vm.$set(_vm.editMemberFields, "sex", "M")}}}),_vm._v(" Male\n                                  ")])]),_vm._v(" "),_c('div',{staticClass:"form-check form-check-inline"},[_c('label',{staticClass:"form-check-label"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.editMemberFields.sex),expression:"editMemberFields.sex"}],staticClass:"form-check-input",attrs:{"type":"radio","name":"gender","id":"inlineRadio2","value":"F"},domProps:{"checked":_vm._q(_vm.editMemberFields.sex,"F")},on:{"change":function($event){_vm.$set(_vm.editMemberFields, "sex", "F")}}}),_vm._v(" Female\n                                  ")])]),_vm._v(" "),_c('div',{staticClass:"form-check form-check-inline"},[_c('label',{staticClass:"form-check-label"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.editMemberFields.sex),expression:"editMemberFields.sex"}],staticClass:"form-check-input",attrs:{"type":"radio","name":"gender","id":"inlineRadio2","value":"O"},domProps:{"checked":_vm._q(_vm.editMemberFields.sex,"O")},on:{"change":function($event){_vm.$set(_vm.editMemberFields, "sex", "O")}}}),_vm._v(" Other\n                                  ")])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Age*")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.editMemberFields.age),expression:"editMemberFields.age"},{name:"validate",rawName:"v-validate",value:('required|numeric|max:2'),expression:"'required|numeric|max:2'"}],staticClass:"form-control",attrs:{"type":"text","name":"age","id":"age","data-vv-as":"age"},domProps:{"value":(_vm.editMemberFields.age)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.editMemberFields, "age", $event.target.value)}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('editMember.age')),expression:"errors.has('editMember.age')"}],staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('editMember.age')))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-6"},[_c('button',{staticClass:"btn  btn-link full-width",on:{"click":function($event){_vm.cancelMember(2)}}},[_vm._v("Cancel")])]),_vm._v(" "),_vm._m(16,false,false)])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal fade ",attrs:{"id":"addPatientProfileModal","tabindex":"-1","role":"dialog","aria-labelledby":"exampleModalLabel","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog ",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_vm._m(17,false,false),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('form',{attrs:{"data-vv-scope":"addMember"},on:{"submit":function($event){$event.preventDefault();_vm.saveMember($event)}}},[_c('div',{staticClass:"clearfix mt-4 line-textbox"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Patient First Name*")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.addMemberFields.firstName),expression:"addMemberFields.firstName"},{name:"validate",rawName:"v-validate",value:('required|alpha_spaces|max:50'),expression:"'required|alpha_spaces|max:50'"}],staticClass:"form-control",attrs:{"type":"text","name":"firstName","id":"firstName","maxlength":"50","data-vv-as":"first name"},domProps:{"value":(_vm.addMemberFields.firstName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.addMemberFields, "firstName", $event.target.value)}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('addMember.firstName')),expression:"errors.has('addMember.firstName')"}],staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('addMember.firstName')))])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Patient Last Name*")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.addMemberFields.lastName),expression:"addMemberFields.lastName"},{name:"validate",rawName:"v-validate",value:('required|alpha_spaces|max:50'),expression:"'required|alpha_spaces|max:50'"}],staticClass:"form-control",attrs:{"type":"text","name":"lastName","id":"lastName","maxlength":"50","data-vv-as":"last name"},domProps:{"value":(_vm.addMemberFields.lastName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.addMemberFields, "lastName", $event.target.value)}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('addMember.lastName')),expression:"errors.has('addMember.lastName')"}],staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('addMember.lastName')))])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Mobile*")]),_vm._v(" "),_c('input',{directives:[{name:"mask",rawName:"v-mask",value:('##########'),expression:"'##########'"},{name:"model",rawName:"v-model",value:(_vm.addMemberFields.mobile),expression:"addMemberFields.mobile"},{name:"validate",rawName:"v-validate",value:('required|numeric|min:10|max:10'),expression:"'required|numeric|min:10|max:10'"}],staticClass:"form-control",attrs:{"type":"text","name":"mobile","id":"mobile","maxlength":"50","data-vv-as":"mobile"},domProps:{"value":(_vm.addMemberFields.mobile)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.addMemberFields, "mobile", $event.target.value)}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('addMember.mobile')),expression:"errors.has('addMember.mobile')"}],staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('addMember.mobile')))])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Gender*")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"form-check form-check-inline"},[_c('label',{staticClass:"form-check-label"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.addMemberFields.sex),expression:"addMemberFields.sex"}],staticClass:"form-check-input",attrs:{"type":"radio","name":"gender","id":"inlineRadio1","value":"M"},domProps:{"checked":_vm._q(_vm.addMemberFields.sex,"M")},on:{"change":function($event){_vm.$set(_vm.addMemberFields, "sex", "M")}}}),_vm._v(" Male\n                                    ")])]),_vm._v(" "),_c('div',{staticClass:"form-check form-check-inline"},[_c('label',{staticClass:"form-check-label"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.addMemberFields.sex),expression:"addMemberFields.sex"}],staticClass:"form-check-input",attrs:{"type":"radio","name":"gender","id":"inlineRadio2","value":"F"},domProps:{"checked":_vm._q(_vm.addMemberFields.sex,"F")},on:{"change":function($event){_vm.$set(_vm.addMemberFields, "sex", "F")}}}),_vm._v(" Female\n                                    ")])]),_vm._v(" "),_c('div',{staticClass:"form-check form-check-inline"},[_c('label',{staticClass:"form-check-label"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.addMemberFields.sex),expression:"addMemberFields.sex"}],staticClass:"form-check-input",attrs:{"type":"radio","name":"gender","id":"inlineRadio2","value":"O"},domProps:{"checked":_vm._q(_vm.addMemberFields.sex,"O")},on:{"change":function($event){_vm.$set(_vm.addMemberFields, "sex", "O")}}}),_vm._v(" Other\n                                    ")])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Age*")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.addMemberFields.age),expression:"addMemberFields.age"},{name:"validate",rawName:"v-validate",value:('required|numeric|max:2'),expression:"'required|numeric|max:2'"}],staticClass:"form-control",attrs:{"type":"text","name":"age","id":"age","data-vv-as":"age"},domProps:{"value":(_vm.addMemberFields.age)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.addMemberFields, "age", $event.target.value)}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('addMember.age')),expression:"errors.has('addMember.age')"}],staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('addMember.age')))])])]),_vm._v(" "),_c('div',{staticClass:"row mt-3"},[_c('div',{staticClass:"col-6"},[_c('a',{staticClass:"btn btn-link full-width",on:{"click":function($event){_vm.cancelMember(3)}}},[_vm._v("Cancel")])]),_vm._v(" "),_vm._m(18,false,false)])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal fade",attrs:{"id":"popupAddLocality","tabindex":"-1","role":"dialog","aria-labelledby":"popupTest","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"header"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"menu_popup",on:{"click":function($event){_vm.closeLocalityPopup()}}},[_c('i',{staticClass:"material-icons"},[_vm._v("arrow_back")])]),_vm._v(" "),_c('h3',{staticClass:"screen-title mt-13p"},[_vm._v("Choose Locality")])])])])]),_vm._v(" "),_c('div',{staticClass:"search-section"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"form-group mb-0"},[_c('label',[_vm._v("Choose nearest if exact match not available")]),_vm._v(" "),_c('div',{staticClass:"input-group mb-0"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.addAddressFields.zipcode),expression:"addAddressFields.zipcode"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],ref:"pincodeAdd",staticClass:"form-control",attrs:{"type":"text","name":"zipcode","id":"zipcode","data-vv-as":"zipcode","aria-label":"","list":"mycarousel","autocomplete":"off","minlength":"3"},domProps:{"value":(_vm.addAddressFields.zipcode)},on:{"keyup":[function($event){_vm.searchLocality(2)},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }_vm.searchLocality(2)}],"blur":function($event){_vm.closeBlock()},"focus":function($event){_vm.$refs.pincodeAdd.select();},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.addAddressFields, "zipcode", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-12"},[_c('span',[_vm._v("City/ Locality : "),_c('b',[_vm._v(" "+_vm._s(_vm.$localStorage.get('sc').cityName + ' / ' + (_vm.addAddressFields.locality ? _vm.addAddressFields.locality.locationName : '-')))])]),_vm._v(" "),_c('br')])])])]),_vm._v(" "),_c('div',{staticClass:"modal-body locality-search-popup"},[_c('div',[_c('div',{staticClass:"popular-test"},[_c('ul',{staticClass:"p-0 m-0"},[_vm._l((_vm.locationList),function(item,index){return _c('li',{key:index,staticClass:"p-2 location-border",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.selectLocation($event, item, 2)}}},[_vm._v("\n                              "+_vm._s(item.locationName+'-'+item.locationZipCode)+"\n                              "),(_vm.addAddressFields.locality && item.locationId === _vm.addAddressFields.locality.locationId)?_c('i',{staticClass:"fa fa-check green-color",staticStyle:{"font-size":"13px","margin-left":"3px"}}):_vm._e()])}),_vm._v(" "),(_vm.locationList.length === 0)?_c('li',{staticClass:"p-2 text-center location-border"},[_vm._v(" --- No Locations ---")]):_vm._e(),_vm._v(" "),(_vm.locationList.length === 0)?_c('li',{staticClass:"p-2 color-blue text-center location-border",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.selectLocation($event, undefined, 3)}}},[_vm._v("\n                              + Add Location\n                          ")]):_vm._e(),_vm._v(" "),(_vm.locationList.length !== 0)?_c('li',{staticClass:"p-2 color-blue location-border",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.selectLocation($event, undefined, 3)}}},[_vm._v("\n                              + Add Location\n                          ")]):_vm._e()],2)])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal fade",attrs:{"id":"popupEditLocality","tabindex":"-1","role":"dialog","aria-labelledby":"popupTest","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"header"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"menu_popup",on:{"click":function($event){_vm.closeLocalityPopup()}}},[_c('i',{staticClass:"material-icons"},[_vm._v("arrow_back")])]),_vm._v(" "),_c('h3',{staticClass:"screen-title mt-13p"},[_vm._v("Choose Locality")])])])])]),_vm._v(" "),_c('div',{staticClass:"search-section"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"form-group mb-0"},[_c('label',[_vm._v("Choose nearest if exact match not available")]),_vm._v(" "),_c('div',{staticClass:"input-group mb-0"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.editAddressFields.zipcode),expression:"editAddressFields.zipcode"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],ref:"pincodeEdit",staticClass:"form-control",attrs:{"type":"text","name":"zipcode","id":"zipcode","data-vv-as":"zipcode","aria-label":"","list":"mycarousel","autocomplete":"off","minlength":"3"},domProps:{"value":(_vm.editAddressFields.zipcode)},on:{"keyup":[function($event){_vm.searchLocality(1)},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }_vm.searchLocality(1)}],"blur":function($event){_vm.closeBlock()},"focus":function($event){_vm.$refs.pincodeEdit.select();},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.editAddressFields, "zipcode", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-12"},[_c('span',[_vm._v("City/ Locality : "),_c('b',[_vm._v(" "+_vm._s(_vm.$localStorage.get('sc').cityName + ' / ' + (_vm.editAddressFields.locality ? _vm.editAddressFields.locality.locationName : '-')))])]),_vm._v(" "),_c('br')])])])]),_vm._v(" "),_c('div',{staticClass:"modal-body locality-search-popup"},[_c('div',[_c('div',{staticClass:"popular-test"},[_c('ul',{staticClass:"p-0 m-0"},[_vm._l((_vm.locationList),function(item,index){return _c('li',{key:index,staticClass:"p-2 location-border",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.selectLocation($event, item, 1)}}},[_vm._v("\n                              "+_vm._s(item.locationName+'-'+item.locationZipCode)+"\n                              "),(_vm.editAddressFields.locality && item.locationId === _vm.editAddressFields.locality.locationId)?_c('i',{staticClass:"fa fa-check green-color",staticStyle:{"font-size":"13px","margin-left":"3px"}}):_vm._e()])}),_vm._v(" "),(_vm.locationList.length === 0)?_c('li',{staticClass:"p-2 text-center location-border"},[_vm._v(" --- No Locations ---")]):_vm._e(),_vm._v(" "),(_vm.locationList.length === 0)?_c('li',{staticClass:"p-2 color-blue text-center location-border",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.selectLocation($event, undefined, 3)}}},[_vm._v("\n                              + Add Location\n                          ")]):_vm._e(),_vm._v(" "),(_vm.locationList.length !== 0)?_c('li',{staticClass:"p-2 color-blue location-border",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.selectLocation($event, undefined, 3)}}},[_vm._v("\n                              + Add Location\n                          ")]):_vm._e()],2)])])])])])])],1)}
var Secure_Address_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h3',{staticClass:"screen-title mt-13p"},[_c('span',{staticClass:"float-left"},[_vm._v("\n                          Health Cart\n                      ")]),_vm._v(" "),_c('span',{staticClass:"float-right gray-color"},[_vm._v("\n                          Step 2 of 3\n                      ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"badge add-badge badge-light float-left"},[_c('i',{staticClass:"material-icons"},[_vm._v("add")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-link remove-btn p-0"},[_c('img',{attrs:{"src":"static/images/close-black.svg","alt":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"badge add-badge badge-light float-left"},[_c('i',{staticClass:"material-icons"},[_vm._v("add")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-link remove-btn p-0"},[_c('img',{attrs:{"src":"static/images/close-black.svg","alt":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{staticClass:"no-border"},[_vm._v("\n                                                Test Name\n                                            ")]),_vm._v(" "),_c('th',{staticClass:"text-right no-border"}),_vm._v(" "),_c('th',{staticClass:"no-border text-right"},[_vm._v("\n                                                Price\n                                            ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"alert alert-dark rounded-0 clearfix border-0",attrs:{"role":"alert"}},[_c('span',{staticClass:"float-left"},[_vm._v("Add Address")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_vm._v("Landmark "),_c('span',{staticClass:"locality-message"},[_vm._v("(Optional)")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_vm._v("Location / Pincode "),_c('span',{staticClass:"locality-message"},[_vm._v("(Choose nearest if exact match not available)")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-12"},[_c('div',{staticStyle:{"width":"100%","height":"95%","background":"#ccc"},attrs:{"id":"myMapAdd"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"alert alert-dark rounded-0 clearfix border-0",attrs:{"role":"alert"}},[_c('span',{staticClass:"float-left"},[_vm._v("Edit Address")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_vm._v("Landmark "),_c('span',{staticClass:"locality-message"},[_vm._v("(Optional)")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_vm._v("Location / Pincode "),_c('span',{staticClass:"locality-message"},[_vm._v("(Choose nearest if exact match not available)")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-12"},[_c('div',{staticStyle:{"width":"100%","height":"95%","background":"#ccc"},attrs:{"id":"myMapVal"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"menu_popup",attrs:{"data-dismiss":"modal","aria-label":"Close"}},[_c('i',{staticClass:"material-icons"},[_vm._v("arrow_back")])]),_vm._v(" "),_c('h3',{staticClass:"screen-title mt-13p"},[_vm._v("Edit Profile Details")])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"menu_popup",attrs:{"data-dismiss":"modal","aria-label":"Close"}},[_c('i',{staticClass:"material-icons"},[_vm._v("arrow_back")])]),_vm._v(" "),_c('h3',{staticClass:"screen-title mt-13p"},[_vm._v("Edit Profile Details")])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-6"},[_c('button',{staticClass:"btn btn-primary full-width",attrs:{"type":"submit"}},[_vm._v("Update")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-header"},[_c('div',{staticClass:"menu_popup"},[_c('a',{staticStyle:{"color":"#969696"},attrs:{"href":"javascript:void(0)","data-dismiss":"modal","aria-label":"Close"}},[_c('i',{staticClass:"material-icons"},[_vm._v("\n                              arrow_back\n                          ")])])]),_vm._v(" "),_c('h3',{staticClass:"screen-title mt-13p",attrs:{"id":"exampleModalLabel"}},[_vm._v("Add Patient Details")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-6"},[_c('button',{staticClass:"btn btn-primary full-width",attrs:{"type":"submit"}},[_vm._v("Save")])])}]
var Secure_Address_esExports = { render: Secure_Address_render, staticRenderFns: Secure_Address_staticRenderFns }
/* harmony default export */ var components_mobile_Book_Secure_Address = (Secure_Address_esExports);
// CONCATENATED MODULE: ./src/components/mobile/Book/Secure/Address.vue
function Secure_Address_injectStyle (ssrContext) {
  __webpack_require__("rajZ")
}
var Secure_Address_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var Secure_Address___vue_template_functional__ = false
/* styles */
var Secure_Address___vue_styles__ = Secure_Address_injectStyle
/* scopeId */
var Secure_Address___vue_scopeId__ = "data-v-614d6e84"
/* moduleIdentifier (server only) */
var Secure_Address___vue_module_identifier__ = null
var Secure_Address_Component = Secure_Address_normalizeComponent(
  mobile_Book_Secure_Address["a" /* default */],
  components_mobile_Book_Secure_Address,
  Secure_Address___vue_template_functional__,
  Secure_Address___vue_styles__,
  Secure_Address___vue_scopeId__,
  Secure_Address___vue_module_identifier__
)

/* harmony default export */ var src_components_mobile_Book_Secure_Address = (Secure_Address_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/Book/Secure/Payment.vue
var mobile_Book_Secure_Payment = __webpack_require__("jHY5");

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5794ab96","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/Book/Secure/Payment.vue
var Secure_Payment_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"PaymentDiv"}},[_c('HeaderVue'),_vm._v(" "),_c('div',{staticClass:"header"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"menu"},[_c('a',{staticStyle:{"color":"#9e9e9e"},attrs:{"href":"javascript:void(0)"},on:{"click":function($event){_vm.goBackPopup()}}},[_c('i',{staticClass:"material-icons"},[_vm._v("\n                          arrow_back\n                      ")])])]),_vm._v(" "),_vm._m(0,false,false)])])])]),_vm._v(" "),_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('form',{attrs:{"data-vv-scope":"coupon"},on:{"submit":function($event){$event.preventDefault();_vm.applyCoupon()}}},[(!_vm.isCouponApplied)?_c('div',{staticClass:"input-group mt-0"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.couponCode),expression:"couponCode"},{name:"validate",rawName:"v-validate",value:('required|max:25'),expression:"'required|max:25'"}],staticClass:"form-control text-uppercase",attrs:{"type":"text","name":"couponCode","data-vv-as":"coupon code","placeholder":"Coupon code","aria-label":"Coupon code"},domProps:{"value":(_vm.couponCode)},on:{"keyup":function($event){_vm.couponError='';},"input":function($event){if($event.target.composing){ return; }_vm.couponCode=$event.target.value}}}),_vm._v(" "),_c('span',{staticClass:"input-group-btn"},[_c('button',{staticClass:"btn btn-link",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();_vm.applyCoupon()}}},[_vm._v("Apply")])])]):_vm._e(),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('coupon.couponCode')),expression:"errors.has('coupon.couponCode')"}],staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('coupon.couponCode')))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.errors.has('coupon.couponCode') && _vm.couponError && !_vm.isSuccessCoupon),expression:"!errors.has('coupon.couponCode') && couponError && !isSuccessCoupon"}],class:{'text-danger': !_vm.isSuccessCoupon,'green-color': _vm.isSuccessCoupon}},[_vm._v(_vm._s(_vm.couponError))])]),_vm._v(" "),(_vm.isCouponApplied && _vm.couponData)?_c('div',{staticClass:"input-group mt-0"},[_c('div',{staticClass:"alert alert-success applied-coupon w-100"},[_c('button',{staticClass:"close close-circle",attrs:{"type":"button"},on:{"click":function($event){_vm.removeCoupon()}}},[_c('span',[_vm._v("×")])]),_vm._v(" "),_c('h6',{staticClass:"text-center alert-heading mb-0"},[_vm._v("Applied Coupon :  "),_c('b',[_vm._v(_vm._s(_vm.couponData.coupon_code)+" ")])]),_vm._v(" "),_c('hr',{staticClass:"mt-2 mb-2"}),_vm._v(" "),_c('p',{staticClass:"text-center mb-0"},[_vm._v(_vm._s(_vm.couponError)+" reduced on your order value.")])])]):_vm._e(),_vm._v(" "),(_vm.payinfo.creditPoints && _vm.payinfo.creditPoints > 0)?_c('div',{staticClass:"mt-3",attrs:{"id":"accordion","role":"tablist"}},[_c('div',{staticClass:"card p-3"},[_c('span',{staticClass:"ml-4 green-color"},[_vm._v("Labotist Credits Available = "+_vm._s(_vm.payinfo.creditPoints))]),_vm._v(" "),_c('label',{staticClass:"checkbox_container"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.redeemCredits),expression:"redeemCredits"}],ref:"redeemCredits",attrs:{"type":"checkbox","name":"redeemCredits","id":"redeemCredits","data-vv-as":"redeemCredits"},domProps:{"checked":Array.isArray(_vm.redeemCredits)?_vm._i(_vm.redeemCredits,null)>-1:(_vm.redeemCredits)},on:{"change":[function($event){var $$a=_vm.redeemCredits,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.redeemCredits=$$a.concat([$$v]))}else{$$i>-1&&(_vm.redeemCredits=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.redeemCredits=$$c}},function($event){_vm.termsConditionError=false}]}}),_vm._v(" "),_c('span',{staticClass:"checkbox_checkmark"})]),_vm._v(" "),_c('span',{staticClass:"ml-4"},[_vm._v("I would like to use my Labotist Credits towards this purchase.")])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"mt-3",attrs:{"id":"accordion","role":"tablist"}},[_c('div',{staticClass:"card m-0"},[_vm._m(1,false,false),_vm._v(" "),_c('div',{attrs:{"id":"collapseOne","role":"tabpanel","aria-labelledby":"headingOne","data-parent":"#sideBar"}},[_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"lab display-flex no-border p-0 mt-3 bg-tranparent"},[_c('div',{staticClass:"flex-box"},[_c('div',{staticClass:"lab-logo"},[(_vm.selectedLab.logo && _vm.selectedLab.logo.length > 0)?_c('img',{attrs:{"src":_vm.selectedLab.logo}}):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"flex-box"},[_c('p',{staticClass:"black-color font-weight-bold mb-2"},[_vm._v("\n                                        "+_vm._s(_vm.$localStorage.get('sl').labName)+"\n                                    ")]),_vm._v(" "),_c('p',{staticClass:"mt-0 mb-1"},[_vm._v(_vm._s(_vm.$localStorage.get('sl').branch.branchLocation + ', ' + _vm.$localStorage.get('sl').branch.branchCity + '-' + _vm.$localStorage.get('sl').branch.branchZipCode))])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"table-responsive test-conformation"},[_c('table',{staticClass:"table"},[_vm._m(2,false,false),_vm._v(" "),_c('tbody',{staticClass:"black-color"},_vm._l((_vm.testCosts.priceDetails),function(cost,index){return _c('tr',{key:index},[_c('td',[_vm._v("\n                                              "+_vm._s(cost.aliasName)+"\n                                          ")]),_vm._v(" "),_c('td',[_c('p',{staticClass:"float-right mt-1 mb-0 price-tag"},[(cost.actualPrice > cost.ourPrice )?_c('span',{staticClass:"red-color strip-text"},[_vm._v("Rs."+_vm._s(cost.actualPrice))]):_vm._e(),_vm._v("\n                                                    Rs. "+_vm._s(cost.ourPrice)+"\n                                              ")])])])}))])])])])])]),_vm._v(" "),_c('div',{staticClass:"collapse show",attrs:{"id":"collapseTwo","role":"tabpanel","aria-labelledby":"headingOne","data-parent":"#accordion"}},[_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table price-table payment-table"},[_c('tr',[_c('td',[_vm._v("Order Value")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("Rs. "+_vm._s(_vm.payinfo.total))])]),_vm._v(" "),(_vm.payinfo.couponFee > 0)?_c('tr',{staticClass:"black-color"},[_c('td',[_vm._v("Coupon Discount")]),_vm._v(" "),_c('td',{staticClass:"text-right green-color"},[_vm._v("- Rs. "+_vm._s(_vm.payinfo.couponFee))])]):_vm._e(),_vm._v(" "),(_vm.payinfo.mrpTotal != _vm.payinfo.subTotal)?_c('tr',{staticClass:"black-color"},[_c('td',[_vm._v("Sub Total")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("Rs. "+_vm._s(_vm.payinfo.total - _vm.payinfo.couponFee))])]):_vm._e(),_vm._v(" "),(_vm.payinfo.phlebotomistFee > 0)?_c('tr',{staticClass:"black-color"},[_c('td',[_vm._v("Phlebotomist Fee \n                                        "),_c('i',{staticClass:"fa fa-info-circle",attrs:{"aria-hidden":"true","data-toggle":"tooltip","data-placement":"top","title":'This price is applicable when the order value is below Rs.'+_vm.payinfo.waiverDiscountApplyFee},on:{"click":function($event){_vm.toggleToolTip = !_vm.toggleToolTip}}}),_vm._v(" "),(_vm.toggleToolTip)?_c('p',{staticStyle:{"font-size":"10px","color":"#939393"}},[_vm._v(_vm._s('This price is applicable when the order value is below Rs.'+_vm.payinfo.waiverDiscountApplyFee))]):_vm._e()]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("Rs. "+_vm._s(_vm.payinfo.phlebotomistFee))])]):_vm._e(),_vm._v(" "),(_vm.redeemCreditPoints > 0)?_c('tr',[_c('td',[_vm._v("Labotist Credits Applied")]),_vm._v(" "),_c('td',{staticClass:"text-right green-color"},[_vm._v("- Rs. "+_vm._s(_vm.redeemCreditPoints))])]):_vm._e(),_vm._v(" "),(_vm.payinfo.phlebotomyFeeWaiver > 0)?_c('tr',{staticClass:"black-color"},[_c('td',[_vm._v("Coupon Discount")]),_vm._v(" "),_c('td',{staticClass:"text-right green-color"},[_vm._v("-Rs. "+_vm._s(_vm.payinfo.phlebotomyFeeWaiver))])]):_vm._e(),_vm._v(" "),_c('tr',{staticClass:"black-color"},[_c('td',[_vm._v("Amount Payable")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("Rs. "+_vm._s(_vm.payinfo.grandTotal - _vm.redeemCreditPoints))])])])])])])])])])])]),_vm._v(" "),(_vm.$cashPayment && (_vm.payinfo.grandTotal - _vm.redeemCreditPoints) > 0)?_c('div',{staticClass:"m-3",attrs:{"id":"accordion","role":"tablist"}},[_c('div',{staticClass:"card"},[_vm._m(3,false,false),_vm._v(" "),_c('div',{staticClass:"pl-3 pb-3"},[_c('label',{staticClass:"checkbox_container mr-5"},[_vm._v("Online\n            "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.paymentType),expression:"paymentType"}],ref:"paymentType",attrs:{"type":"radio","name":"paymentType","id":"paymentType","data-vv-as":"paymentType","value":"1"},domProps:{"checked":_vm._q(_vm.paymentType,"1")},on:{"change":function($event){_vm.paymentType="1"}}}),_vm._v(" "),_c('span',{staticClass:"checkbox_checkmark"})]),_vm._v(" "),_c('label',{staticClass:"checkbox_container"},[_vm._v("Cash\n            "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.paymentType),expression:"paymentType"}],ref:"paymentType",attrs:{"type":"radio","name":"paymentType","id":"paymentType","data-vv-as":"paymentType","value":"2"},domProps:{"checked":_vm._q(_vm.paymentType,"2")},on:{"change":function($event){_vm.paymentType="2"}}}),_vm._v(" "),_c('span',{staticClass:"checkbox_checkmark"})])])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"m-3",attrs:{"id":"accordion","role":"tablist"}},[_c('div',{staticClass:"card p-3"},[_c('label',{staticClass:"checkbox_container"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.termsCondition),expression:"termsCondition"}],ref:"termsCondition",attrs:{"type":"checkbox","name":"termsCondition","id":"termsCondition","data-vv-as":"termsCondition"},domProps:{"checked":Array.isArray(_vm.termsCondition)?_vm._i(_vm.termsCondition,null)>-1:(_vm.termsCondition)},on:{"change":[function($event){var $$a=_vm.termsCondition,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.termsCondition=$$a.concat([$$v]))}else{$$i>-1&&(_vm.termsCondition=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.termsCondition=$$c}},function($event){_vm.termsConditionError=false}]}}),_vm._v(" "),_c('span',{staticClass:"checkbox_checkmark"})]),_vm._v(" "),_c('span',{staticClass:"ml-4"},[_vm._v("I have read and agree to the Labotist "),_c('span',{staticClass:"termsCondition",on:{"click":function($event){_vm.termsConditionChanged(2)}}},[_vm._v("Terms of Service")]),_vm._v(" and "),_c('span',{staticClass:"termsCondition",on:{"click":function($event){_vm.termsConditionChanged(3)}}},[_vm._v("Privacy Policy")]),_vm._v("?")]),_vm._v(" "),(_vm.termsConditionError)?_c('span',{staticClass:"text-danger fs-12"},[_vm._v("Please agree terms & condition to complete payment")]):_vm._e()])]),_vm._v(" "),((_vm.payinfo.grandTotal - _vm.redeemCreditPoints) > 0)?_c('div',{staticClass:"fixed-footer p-0",staticStyle:{"background-color":"transparent"},attrs:{"id":"fixed-footer"}},[((_vm.payinfo.grandTotal - _vm.redeemCreditPoints) > 0)?_c('button',{staticClass:"btn btn-primary full-width fixed-button",attrs:{"id":"rzp-button"},on:{"click":function($event){_vm.goPayment()}}},[_vm._v(_vm._s(_vm.paymentType == 2 ? 'Complete Request' : ('Pay Rs.'+(_vm.payinfo.grandTotal - _vm.redeemCreditPoints))))]):_vm._e(),_vm._v(" "),((_vm.payinfo.grandTotal - _vm.redeemCreditPoints) == 0)?_c('button',{staticClass:"btn btn-primary full-width fixed-button",attrs:{"id":"rzp-button"},on:{"click":function($event){_vm.goPayment(true)}}},[_vm._v("Complete Request")]):_vm._e()]):_vm._e(),_vm._v(" "),((_vm.payinfo.grandTotal - _vm.redeemCreditPoints) === 0)?_c('div',{staticClass:"fixed-footer p-0",staticStyle:{"background-color":"transparent"},attrs:{"id":"fixed-footer"}},[_c('button',{staticClass:"btn btn-primary full-width fixed-button",attrs:{"id":"rzp-button"},on:{"click":function($event){_vm.goPayment(true)}}},[_vm._v("\n        Complete Request\n      ")])]):_vm._e(),_vm._v(" "),_c('Razorpay'),_vm._v(" "),_c('FooterVue'),_vm._v(" "),_c('div',{staticClass:"modal fade bd-example-modal-lg",attrs:{"id":"termsAndCondition","tabindex":"-1","role":"dialog","aria-labelledby":"exampleModalLabel","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog modal-lg",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"menu"},[_c('a',{staticStyle:{"color":"#9e9e9e"},on:{"click":function($event){_vm.closePopup()}}},[_c('i',{staticClass:"material-icons"},[_vm._v("\n                            arrow_back\n                        ")])])]),_vm._v(" "),_vm._m(4,false,false)])]),_vm._v(" "),_vm._m(5,false,false),_vm._v(" "),_c('div',{staticClass:"row mt-3"},[_c('div',{staticClass:"col-sm-6"},[_c('a',{staticClass:"btn btn-link full-width",on:{"click":function($event){_vm.termsConditionChanged(0)}}},[_vm._v("Close")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('button',{staticClass:"btn btn-primary full-width",on:{"click":function($event){_vm.termsConditionChanged(0, true)}}},[_vm._v("I Agree")])])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal fade bd-example-modal-lg",attrs:{"id":"privacyPolicy","tabindex":"-1","role":"dialog","aria-labelledby":"exampleModalLabel","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog modal-lg",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"menu"},[_c('a',{staticStyle:{"color":"#9e9e9e"},on:{"click":function($event){_vm.closePopup()}}},[_c('i',{staticClass:"material-icons"},[_vm._v("\n                            arrow_back\n                        ")])])]),_vm._v(" "),_vm._m(6,false,false)])]),_vm._v(" "),_vm._m(7,false,false),_vm._v(" "),_c('div',{staticClass:"row mt-3"},[_c('div',{staticClass:"col-sm-6"},[_c('a',{staticClass:"btn btn-link full-width",on:{"click":function($event){_vm.termsConditionChanged(0)}}},[_vm._v("Close")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('button',{staticClass:"btn btn-primary full-width",on:{"click":function($event){_vm.termsConditionChanged(0, true)}}},[_vm._v("I Agree")])])])])])])])],1)}
var Secure_Payment_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h3',{staticClass:"screen-title mt-13p"},[_c('span',{staticClass:"float-left"},[_vm._v("\n                          Health Cart\n                      ")]),_vm._v(" "),_c('span',{staticClass:"float-right gray-color"},[_vm._v("\n                          Step 3 of 3\n                      ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header",attrs:{"role":"tab","id":"headingOne"}},[_c('h5',{staticClass:"mb-0"},[_c('a',{staticClass:" gray-color collapsed",attrs:{"href":"#collapseOne","aria-expanded":"true","aria-controls":"collapseOne"}},[_vm._v("\n                              Test Details\n                              ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{staticClass:"no-border"},[_vm._v("\n                                              Test Name\n                                          ")]),_vm._v(" "),_c('th',{staticClass:"no-border text-right"},[_vm._v("\n                                              Price\n                                          ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header",attrs:{"role":"tab","id":"headingOne"}},[_c('h5',{staticClass:"pb-2 mb-0 border-bottom fs-14 black-color"},[_vm._v("\n              Choose Payment Option\n            ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h3',{staticClass:"screen-title mt-13p"},[_c('span',[_vm._v("\n                            Terms & Conditions\n                        ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('p',[_vm._v("Welcome to "),_c('b',[_vm._v("www.labotist.com")]),_vm._v(". ")]),_vm._v(" "),_c('p',[_vm._v("The Terms & Conditions (“"),_c('b',[_vm._v("Terms")]),_vm._v("”) of use of www.labotist.com (“"),_c('b',[_vm._v("Website")]),_vm._v("”) are between Labotist Private Limited (“"),_c('b',[_vm._v("Company/We/Us")]),_vm._v("”) and its customers/clients (“"),_c('b',[_vm._v("You/Your/User(s)")]),_vm._v("”).")]),_vm._v(" "),_c('p',[_vm._v("These Terms constitute an electronic record in accordance with the provisions of the Information Technology Act, 2000 and the Information Technology (Intermediaries Guidelines) Rules, 2011 thereunder, as amended from time to time.")]),_vm._v(" "),_c('p',[_vm._v("Please read the Terms and the privacy policy of the Company carefully, available at "),_c('b',[_c('i',[_vm._v("www.labotist.com/privacy-policy")])]),_vm._v(" (“"),_c('b',[_vm._v("Privacy Policy")]),_vm._v("”) before using this Website or availing any Services (as defined below) through the Website. In the event of any discrepancy between the Terms and any other Website policies, the provisions of the Terms shall prevail.")]),_vm._v(" "),_c('p',[_vm._v("If You continue to browse and use our Website, You are agreeing to comply with and be bound by the following Terms. If you disagree with any part of these Terms, please do not use our Website.")]),_vm._v(" "),_c('p',[_vm._v("If You do not agree with the Terms or the Privacy Policy, please do not use the Website or avail the Services provided by this Website.")]),_vm._v(" "),_c('h4',[_vm._v("Introduction")]),_vm._v(" "),_c('p',[_vm._v("Our Website is an Internet based online platform operated by the Company which is a company incorporated under the Companies Act, 2013. Our Website is a convenient, technology driven platform that serves as a one-stop solution for patients to easily choose from, and connect with various laboratories  across the city. It is an online marketplace for lab services, offering patients the convenience of making their choice based on location, cost of test, quality and turnaround time. Patients also enjoy the added luxury of getting their samples collected in the comfort of their home by a trained phlebotomist (“"),_c('b',[_vm._v("Services")]),_vm._v("”).")]),_vm._v(" "),_c('p',[_vm._v("Use of the Website is offered to You on the condition that You accept the same without modification of all the terms, conditions and notices contained in these Terms, as may be posted on the Website from time to time.")]),_vm._v(" "),_c('p',[_vm._v("We reserve the right to amend these Terms from time to time as We deem fit and Your continued usage of the Website and the Services offered shall be deemed to be Your acceptance of the Terms. We recommend that, You keep yourself updated with the Terms. We do not hold the responsibility of informing You of any amendments.")]),_vm._v(" "),_c('p',[_vm._v("Users may not access the Services for the purposes of monitoring their availability, performance or functionality, or for any other benchmarking or competitive purposes.")]),_vm._v(" "),_c('p',[_vm._v("We reserve our right to suspend any User’s ability to use or access the Website at our sole discretion and at any time while We investigate complaints or alleged violations of these Terms, or for any other reason. We have the right to club profiles of the laboratories and diagnostic centres to make them more suitable for package searches on the Website while not amending any of the details provided by the concerned laboratories and diagnostic centres. If the Users find that there is any incorrect information, they can contact Us immediately for such corrections. However, We disclaim all liabilities or responsibilities with respect to any of the information provided by the concerned laboratories and diagnostic centres.")]),_vm._v(" "),_c('h4',[_vm._v("Eligibility Criteria")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v(" The Services offered on the Website are not available to all those individuals who are not qualified to enter into a contract as per the Indian Contract Act, 1872.  By using the Website, You represent and warrant that (a) all registration information You submit is truthful and accurate; (b) You will maintain the accuracy of such information, and any changes thereto by regular updates of any such information; (c) You affirm that You are over 18 years of age and are fully able and competent to enter into the terms, conditions, obligations, affirmations, representations, and warranties set forth in these Terms; and (c) You shall use the Website or such other services provided under the Website only in compliance with these Terms and all applicable local, state, national, and international laws, rules and regulations. Your profile may be deleted and Your membership may be terminated by the Company without warning, or without any notice whatsoever, if We believe that You have violated any of the conditions as mentioned under the Terms or Privacy Policy.\n                      ")]),_vm._v(" "),_c('li',[_vm._v("The Company reserves the right to grant or refuse usage of the Services available on the Website. It can also terminate the usage by an existent User of the Website without assigning any reason. ")]),_vm._v(" "),_c('li',[_vm._v("The Website does not have the responsibility to ensure that You conform to the aforesaid eligibility criteria. It shall be Your sole responsibility to ensure that You meet the required qualification.")])]),_vm._v(" "),_c('h4',[_vm._v("User Account")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v(" You will be required to create an Account, if You wish to avail the Services offered on the Website.")]),_vm._v(" "),_c('li',[_vm._v("In order to access the Services offered on the Website, You shall be required to register yourself with the Website, and maintain an account there (\""),_c('b',[_vm._v("Account")]),_vm._v("\"). You will be required to furnish certain information and details, including Your name, mobile number, e-mail address, residential address, payment information (credit/debit card details) if required, and any other information deemed necessary by the Website (“"),_c('b',[_vm._v("Account Information")]),_vm._v("”).")]),_vm._v(" "),_c('li',[_vm._v("It is Your sole responsibility to ensure that the Account Information provided by You is accurate, complete and latest.")]),_vm._v(" "),_c('li',[_vm._v("The Account Information provided by You, may be shared by the Company with any third party for its internal record keeping purposes, internal procedures and with various laboratories/diagnostic centres to enable them to inform You about any schemes, offers, discounts etc.  Further, by providing the Account Information, you agree and acknowledge that you are also granting your consent for the phlebotomists to visit the address provided by you in order to collect/draw the requite samples, call you on the number provided you for any necessary confirmation, deliver the samples the diagnostic centre chosen by you and do such other acts as necessary. ")]),_vm._v(" "),_c('li',[_vm._v("Upon completing the registration process, You can start availing the Services offered on the Website immediately. You shall be responsible for maintaining the confidentiality of the Account Information and for all activities that occur under Your Account. You agree to (a) ensure that You successfully log out from Your Account at the end of each session; and (b) immediately notify the Company of any unauthorized use of Your Account.  If there is reason to believe that there is likely to be a breach of security or misuse of the Your Account/ Website, We may request You to change the password or We may suspend Your account without any liability to the Company, for such period of time as We deem appropriate in the circumstances. The Website shall not be liable for any loss or damage arising from Your failure to comply with this Clause.")]),_vm._v(" "),_c('li',[_vm._v("You acknowledge that Your ability to use Your Account is dependent upon external factors such as internet service providers and internet network availability and the Company cannot guarantee availability of the Website at all times. In addition to the disclaimers set forth in the Terms, the Company shall not be liable to You for any damages arising from Your inability to log into Your Account and access the services of the Website at any time.")])]),_vm._v(" "),_c('h4',[_vm._v("Use of Website")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("Subject to compliance with the Terms, the Privacy Policy, and all other applicable terms and guidelines, the Company grants You a personal, non-exclusive, limited privilege to access and use this Website and the Services provided thereon.")]),_vm._v(" "),_c('li',[_vm._v("No User shall be permitted to perform any of the following prohibited activities:\n                          "),_c('ul',[_c('li',[_vm._v("Making available any content that is misleading, unlawful, harmful, threatening, abusive, tortious, defamatory, libelous, vulgar, obscene, child-pornographic, lewd, lascivious, profane, invasive of another's privacy, hateful, or racially, ethnically or otherwise objectionable.")]),_vm._v(" "),_c('li',[_vm._v("Stalking, intimidating and/or harassing another and/or inciting other to commit violence.")]),_vm._v(" "),_c('li',[_vm._v("Transmitting material that encourages anyone to commit a criminal offence, that results in civil liability or otherwise breaches any relevant laws, regulations or code of practice.")]),_vm._v(" "),_c('li',[_vm._v("Interfering with any other person's use or enjoyment of the Website.")]),_vm._v(" "),_c('li',[_vm._v("Making, transmitting or storing electronic copies of materials protected by copyright without the permission of the owner, committing any act that amounts to the infringement of intellectual property or making available any material that infringes any intellectual property rights or other proprietary rights of anyone else.")]),_vm._v(" "),_c('li',[_vm._v("Make available any content or material that You do not have a right to make available under any law or contractual or fiduciary relationship, unless You own or control the rights thereto or have received all necessary consents for such use of the content.")]),_vm._v(" "),_c('li',[_vm._v("Impersonate any person or entity, or falsely state or otherwise misrepresent Your affiliation with a person or entity.")]),_vm._v(" "),_c('li',[_vm._v("Use any of the Company’s domain names.")]),_vm._v(" "),_c('li',[_vm._v("Reverse engineer, modify, copy, distribute, transmit, display, perform, reproduce, publish, license, create derivative works from, transfer, or sell any information or software obtained from the Website.")]),_vm._v(" "),_c('li',[_vm._v("Post, transmit or make available any material that contains viruses, trojan horses, worms, spyware, time bombs, cancelbots, or other computer programming routines, code, files or such other programs that may harm the Website/services, interests or rights of other Users or limit the functionality of any computer software, hardware or telecommunications, or that may harvest or collect any data or personal information about other Users without their consent.")]),_vm._v(" "),_c('li',[_vm._v("Access or use the Website in any manner that could damage, disable, overburden or impair any of the Website's servers or the networks connected to any of the servers on which the Website is hosted.")]),_vm._v(" "),_c('li',[_vm._v("Intentionally or unintentionally interfere with or disrupt the Services or violate any applicable laws related to the access to or use of the Website, violate any requirements, procedures, policies or regulations of networks connected to the Website, or engage in any activity prohibited by these Terms.")]),_vm._v(" "),_c('li',[_vm._v("Disrupt or interfere with the security of, or otherwise cause harm to, the Website, materials, systems resources, or gain unauthorized access to user accounts, passwords, servers or networks connected to or accessible through the Website or any affiliated or linked sites.")]),_vm._v(" "),_c('li',[_vm._v("Interfere with, or inhibit any user from using and enjoying access to the Website, or the services, or other affiliated sites, or engage in disruptive attacks such as denial of service attack on the Website.")]),_vm._v(" "),_c('li',[_vm._v("Access the Website through any other means other than through the interface that is provided by the Company.")]),_vm._v(" "),_c('li',[_vm._v("Use deep-links, page-scrape, robot, spider or other automatic device, program, algorithm or methodology, or any similar or equivalent manual process, to increase traffic to the Website, to access, acquire, copy or monitor any portion of the Website, or in any way reproduce or circumvent the navigational structure or presentation of the Website, or any content, to obtain or attempt to obtain any content, documents or information through any means not specifically made available through the Website.")]),_vm._v(" "),_c('li',[_vm._v("Alter or modify any part of the services.")]),_vm._v(" "),_c('li',[_vm._v("Use the services for purposes that are not permitted by: (i) these Terms; and (ii) any applicable law, regulation or generally accepted practices or guidelines in the relevant jurisdiction.")]),_vm._v(" "),_c('li',[_vm._v("Violate any of the terms specified under the Terms for the use of the Website.")])])]),_vm._v(" "),_c('li',[_vm._v("Any violation by You of the terms of this Clause may result in immediate suspension or termination of Your Accounts, apart from any legal remedy that the Company can avail. In such instances, the Company may also disclose Your Account Information if required by any Governmental or legal authority.")]),_vm._v(" "),_c('li',[_vm._v("You acknowledge and agree that by accessing or using the Website, You agree to indemnify and hold the Company, its affiliates, and/or licensors, harmless to the fullest extent allowed by law regarding all matters related to Your use of the Website or any loss/damage that is caused to the Website/the Company as a result of You committing any of the aforesaid prohibited activities.")]),_vm._v(" "),_c('li',[_vm._v("The Company has the right to change modify, suspend, or discontinue and/or eliminate any aspect(s), features or functionality of the Website or the Services as it deems fit at any time without notice. The Company makes no commitment, express or implied, to maintain or continue any aspect of the Website.  You agree that the Company shall not be liable to You or any third party for any modification, suspension or discontinuance of the Website.")]),_vm._v(" "),_c('li',[_vm._v("You acknowledge that the Company does not make any representation or warranty  regarding any of its Users. You are advised to independently verify the bona fides of any particular user that You choose to deal with on the Website.")])]),_vm._v(" "),_c('h4',[_vm._v("Delivery of Reports ")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v(" Sample collection will typically be done on the date and time chosen by the User. The User shall have the option to reschedule subject to the availability of the rescheduled time slot.")]),_vm._v(" "),_c('li',[_vm._v("It is clarified that, certain sample collection procedure may get delayed due to certain unforeseen circumstances beyond the control of the Company. In such an event, We will proactively reach out to You and inform the same. You are expected to check your emails and SMS regularly for any such updates.")]),_vm._v(" "),_c('li',[_vm._v("Reports will be generated within the turnaround time as stipulated by the laboratory/diagnostic centre chosen by the User. The Company is not liable for any delay with respect to the generation of the reports by such laboratory/diagnostic centre . Upon delivery of the reports to Us, We shall verify the User name and other necessary credentials after which the Company shall attach and e-mail a soft copy of the report to Your online account. The User shall be able to view the report only by logging into his/her Account.")]),_vm._v(" "),_c('li',[_vm._v("Reported laboratory results are at best informative to the referring clinician and should not be considered as the sole basis for final diagnosis and treatment decisions. They should always be correlated with other relevant clinical and laboratory findings.")]),_vm._v(" "),_c('li',[_vm._v("The accuracy of the laboratory reports is largely dependent on the quality of the sample as well as the assay procedures used by the laboratory/diagnostic centres chosen by the User.")])]),_vm._v(" "),_c('h4',[_vm._v("Payment, Fees and Taxes ")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("The User agrees to pay all package fees, consulting fees and other fees applicable to the selected Services and the User shall not circumvent the fee structure. The fee is dependent on the package that the User purchases online and not on the actual usage of the Services.")]),_vm._v(" "),_c('li',[_vm._v("Each User is solely responsible for the payment of all taxes. The Company shall be in no way responsible for any of the taxes except for its own tax liabilities.")]),_vm._v(" "),_c('li',[_vm._v("The payment can be made online on the Website through a secured payment gateway provided by a third party. It is hereby clarified that, the Company is not responsible for any loss or damage caused to the User during the payment process as the third parties and their activities are beyond the control of the Company. The payment could also be paid offline and be either collected personally from the User.")]),_vm._v(" "),_c('li',[_vm._v("All fees are exclusive of applicable taxes.")]),_vm._v(" "),_c('li',[_vm._v("The Company reserves the right to modify the fee and such modified fee shall reflect on the Website, which shall be binding.")]),_vm._v(" "),_c('li',[_vm._v("In order to process the payments, the User might be required to provide certain details of the his/her bank account, credit/debit card number and other details as required by the third party vendor to process the transactions. The Company clarifies that it does not own or store any credit/debit card information entered by the User.")]),_vm._v(" "),_c('li',[_vm._v("You understand and acknowledge that the Company shall not be held responsible or assume any liability, whatsoever in respect of any loss or damage arising directly or indirectly to You due to:")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("Lack of authorization for any transaction/s, or")]),_vm._v(" "),_c('li',[_vm._v("Exceeding the preset limit set by your bank, or")]),_vm._v(" "),_c('li',[_vm._v("Delay in processing the transaction; or")]),_vm._v(" "),_c('li',[_vm._v("Any payment issues arising out of the transaction; or")]),_vm._v(" "),_c('li',[_vm._v("Decline of transaction for any reason/s")])]),_vm._v(" "),_c('li',[_vm._v("All payments made against the purchases on the Website by You shall be compulsorily in Indian Rupees acceptable in the Republic of India. The Website will not facilitate transactions with respect to any other form of currency with respect to availing of its services. ")])]),_vm._v(" "),_c('h4',[_vm._v("Cancellation and Refund Policy")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("The User can cancel the test request by calling on the phone number mentioned in the order confirmation notification.")]),_vm._v(" "),_c('li',[_vm._v("All laboratory test requests can be canceled until 12 (twelve) hours prior of the scheduled sample collection appointment to be eligible for a full refund.")]),_vm._v(" "),_c('li',[_vm._v("For any requests cancelled less than 12 (twelve) hours prior to the scheduled sample collection appointment  or after the appointment, the User would incur an administrative charge of INR 100 (Rupees One Hundred). This is primarily to compensate the phlebotomist for a lost opportunity to provide the home sample collection service and earn his/her income.")]),_vm._v(" "),_c('li',[_vm._v("Any requests not cancelled before the scheduled sample collection will NOT receive any refund. All refunds will be processed and credited within 15 (fifteen) business days from the date of the cancellation request into the account of the User.")])]),_vm._v(" "),_c('h4',[_vm._v("Limitation of Liability")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("The Company, its officers, directors, employees, partners or agents shall not be held responsible or held liable to You or any third party for any special, incidental, indirect, consequential or punitive damages whatsoever, including those resulting from loss of use, data or profits or any other claim arising out, of or in connection with, Your use of, or access to, the Website.")]),_vm._v(" "),_c('li',[_vm._v("The Company shall not be held responsible or liable in any manner whatsoever, by the Users for any losses, damage, injuries or expenses incurred by the Users as a result of any lawful disclosures made by the Company, where the User has consented to such disclosures by the Company. The User agrees that the services provided by the Company or any of its affiliates or service providers are provided on an  \"as is,\" basis, and without any warranties or conditions ("),_c('i',[_vm._v("express or implied, including the implied warranties of merchantability, accuracy, fitness for a particular purpose, title and non-infringement, arising by statute or otherwise in law or from a course of dealing or usage or trade")]),_vm._v("). The Company does not provide or make any representation, warranty or guarantee, express or implied about the Website or the Services. The Company does not verify any content or information provided by the Users/User selected laboratories/diagnostic centres on the Website and to the fullest extent permitted by law, disclaims all liability arising out of the User’s use or reliance upon the Website, the Services, representations and warranties made by the laboratories/diagnostic centres or the content or information provided by laboratories/ diagnostic centres on the Website or any loss arising out of the manner in which the Services have been rendered.")]),_vm._v(" "),_c('li',[_vm._v("In no event shall the total aggregate liability of the Protected Entities to a User for all damages, losses, and causes of action ("),_c('i',[_vm._v("whether in contract or tort, including, but not limited to, negligence or otherwise")]),_vm._v(") arising from the terms and conditions or a User’s use of the Website exceed, in the aggregate INR 1,000 (Rupees One Thousand). ")]),_vm._v(" "),_c('li',[_vm._v("Notwithstanding anything to the contrary contained herein, the User alone shall be liable for User’s dealings and interaction with the chosen laboratory/diagnostic centres. ")]),_vm._v(" "),_c('li',[_vm._v("In no event shall the Company be held responsible and liable for failure on the part of the chosen laboratories/ diagnostic centres to provide the agreed Services or to make provisions for the carrying out the Services. In no event shall the Company be liable for any comments or feedback given by any of the Users in relation to the Services provided by any chosen laboratories/diagnostic centres.")]),_vm._v(" "),_c('li',[_vm._v("The listing of the laboratories/diagnostic centres on the Website is based on numerous factors including but not limited to the User’s comments and feedbacks. In no event shall the Company be liable or responsible for the listing order of the laboratories/diagnostic centres on the Website.")]),_vm._v(" "),_c('li',[_vm._v("We shall not be held responsible or liable for, any damages to, or viruses that may infect User’s equipment on account of User’s access to, use of, or browsing the Website or the downloading of any material, data, text, images, video content, or audio content from the Website. If a User is dissatisfied with the Website, User’s sole remedy is to discontinue using the Website.")])]),_vm._v(" "),_c('h4',[_vm._v("Ownership and Intellectual Property Rights")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("The Website and the materials therein including but not limited to all text, graphics, user interfaces, visual interfaces, sounds and music ("),_c('i',[_vm._v("if any")]),_vm._v("), artwork and computer code and any other information or materials of any nature whatsoever on the Website is owned and controlled by the Company and such content is protected by copyright, patent and trademark laws, and various other intellectual property rights and unfair competition laws.")]),_vm._v(" "),_c('li',[_vm._v("The trademarks, logos and service marks displayed on the Website or on the Website (the \""),_c('b',[_vm._v("Marks")]),_vm._v("\") are the property of Company or the respective third parties. You are not permitted to use the Marks without the prior consent of the Company or the third party that may own the Marks.")])]),_vm._v(" "),_c('h4',[_vm._v("Termination of Your Account")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("The Company may at its sole discretion and without prior notice, terminate Your access to the Website and its Services for, including but not limited to, any of the following reasons:")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("Your violation of the Terms as mentioned herein.")]),_vm._v(" "),_c('li',[_vm._v("If the Company is unable to verify or authenticate any information provided to by You.")]),_vm._v(" "),_c('li',[_vm._v("If the Company at its sole discretion believes that Your actions may cause any damage or legal liability for other Users or to  the Company or are contrary to the interests of the Company.")])]),_vm._v(" "),_c('li',[_vm._v("On termination of an Account due to the reasons mentioned herein, such User shall no longer have access to and the reports and other material stored on the Website by such User. The User shall ensure that he/she has continuous backup of the reports.")]),_vm._v(" "),_c('li',[_vm._v("The Company reserves the right, at its sole discretion, to pursue all of its legal remedies, including but not limited to deletion of the User’s content from the Website with or without ability to access the Website and the other services, upon any breach by the User under this Terms or if the Company is unable to verify or authenticate any information provided by the User or if the User fails to provide (or after providing such consent, later revokes) the consents necessary or desirable by the Company to provide the services to the User.")])]),_vm._v(" "),_c('h4',[_vm._v("Indemnification")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("You agree to defend, indemnify and hold harmless the Company, its officers, directors, employees and agents, from and against any and all claims, damages, obligations, losses, liabilities, costs or debt, and expenses (including but not limited to attorney's fees) arising from: (i) Your use of and access of the Website; (ii) Your violation of any term of these Terms or any other policy of the Company; (iii) Your violation of any third party right, including without limitation, any copyright, property, or privacy right; or (iv) any claim that Your use of the Website has caused damage to a third party. The defense and indemnification obligation will survive these Terms.")])]),_vm._v(" "),_c('h4',[_vm._v("Governing Law and Jurisdiction")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("The Website, the Terms, all transactions entered into on or through the Website and the relationship between You and the Company shall be governed by and construed in accordance with the laws of India, without regard to conflict of law principles. The courts of Chennai shall have the jurisdiction to try any dispute between the User and Company.")])]),_vm._v(" "),_c('h4',[_vm._v("General Provisions")]),_vm._v(" "),_c('ul',[_c('li',[_c('b',[_vm._v("Notice:")]),_vm._v(" All notices served by the Company shall be provided via email to Your account or as a general notification on the Website. Any notice to be provided to the Company should be sent to "),_c('b',[_vm._v("[•]")]),_vm._v(".")]),_vm._v(" "),_c('li',[_c('b',[_vm._v("Entire Agreement:")]),_vm._v(" The Terms, along with the Privacy Policy, and any other guidelines made applicable by the Website from time to time, constitute the entire agreement between the Company and You with respect to Your access to or use of the Website and the Services thereof.")]),_vm._v(" "),_c('li',[_c('b',[_vm._v("Assignment:")]),_vm._v(" You cannot assign or otherwise transfer the Terms, or any right granted hereunder to any third party. The Company’s rights under the Terms are freely transferable by the Company to any third parties without the requirement of seeking Your consent. The Company may freely transfer, assign or delegate all or any part of these Terms, any rights and duties hereunder. These Terms will be binding upon and inure to the benefit of the successors and permitted assignees of the parties.")]),_vm._v(" "),_c('li',[_c('b',[_vm._v("Severability:")]),_vm._v(" If, for any reason, a court of competent jurisdiction finds any provision of the Terms, or portion thereof, to be unenforceable, that provision shall be enforced to the maximum extent permissible so as to give effect to the intent of the parties as reflected by that provision, and the remainder of the Terms shall continue in full force and effect.")]),_vm._v(" "),_c('li',[_c('b',[_vm._v("Waiver:")]),_vm._v(" Any failure by the Company to enforce or exercise any provision of the Terms, or any related right, shall not constitute a waiver by the Company of that provision or right.")]),_vm._v(" "),_c('li',[_c('b',[_vm._v("Force Majeure:")]),_vm._v(" The Company shall not be held responsible or liable due to any unavailability caused by circumstances beyond the Company’s reasonable control, including without limitation, Acts of God, acts of Government, flood, fire, earthquakes, civil unrest, acts of terror, strikes or other labour problems such as strikes and lockouts, or internet service provider failures or delays.")]),_vm._v(" "),_c('li',[_c('b',[_vm._v("Relationship:")]),_vm._v(" You acknowledge that Your participation on the Website, does not make You an employee or agency or partnership or joint venture or franchise of the Company. Further, you shall not have the right to enter into any obligation or commitment on behalf of the Company.")]),_vm._v(" "),_c('li',[_vm._v("The Company provides these Terms on the Website so that You are aware of the terms that apply to Your use of the Website. You acknowledge that, the Company has given You a reasonable opportunity to review these Terms and that You have agreed to them.")]),_vm._v(" "),_c('li',[_vm._v("In the event that you participate in any promotional activities through the advertisers on the Website, the Company shall not be held responsible for any loss or damage caused to you in this regard.")])]),_vm._v(" "),_c('h4',[_vm._v("DISCLAIMER")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("WE DO NOT PROVIDE MEDICAL ADVICE:")]),_vm._v(" THE INFORMATION THAT YOU OBTAIN OR RECEIVE FROM THE COMPANY, AND ITS EMPLOYEES, CONTRACTORS, PARTNERS, SPONSORS, ADVERTISERS, LICENSORS OR OTHERWISE ON THE WEBSITE IS FOR INFORMATIONAL AND SCHEDULING PURPOSES ONLY. THE INFORMATION PROVIDED ON THE WEBSITE IS NOT INTENDED AS A SUBSTITUTE FOR, NOR DOES IT REPLACE, PROFESSIONAL MEDICAL ADVICE, DIAGNOSIS, OR TREATMENT. DO NOT DISREGARD, AVOID OR DELAY OBTAINING MEDICAL ADVICE FROM A QUALIFIED HEALTH CARE PROFESSIONAL BECAUSE OF SOMETHING YOU MAY HAVE READ ON THE WEBSITE. DO NOT USE THE WEBSITE FOR EMERGENCY MEDICAL NEEDS. YOUR USE OF INFORMATION PROVIDED ON THE WEBSITE IS SOLELY AT YOUR OWN RISK. NOTHING STATED OR POSTED ON THE WEBSITE OR AVAILABLE THROUGH ANY SERVICES IS INTENDED TO BE, AND MUST NOT BE TAKEN TO BE, THE PRACTICE OF MEDICINE OR THE PROVISION OF MEDICAL CARE. WE DO NOT RECOMMEND OR ENDORSE ANY SPECIFIC TESTS, PHYSICIANS, LABORATORIES, DIAGNOSTIC CENTRES, PROCEDURES, OPINIONS, OR OTHER INFORMATION THAT MAY APPEAR ON THE WEBSITE. IF YOU RELY ON ANY OF THE INFORMATION PROVIDED BY THE WEBSITE, YOU DO SO SOLELY AT YOUR OWN RISK.")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("NO DOCTOR PATIENT RELATIONSHIP:")]),_vm._v(" NO LICENSED MEDICAL PROFESSIONAL/PATIENT RELATIONSHIP IS CREATED BY USING THE INFORMATION PROVIDED BY OR THROUGH THE USE OF THE WEBSITE INCLUDING, BUT NOT LIMITED TO, FIND A TEST FEATURE, LINKS TO OTHER WEBSITES OR ANY ASSISTANCE WE MAY PROVIDE TO HELP YOU FIND AN APPROPRIATE MEDICAL PROFESSIONAL/DIAGNOSTIC CENTER OR SPECIALIST IN ANY FIELD FOR CONDUCTING THE REQUISITE TEST. WE MAKE NO GUARANTEES, REPRESENTATIONS OR WARRANTIES, WHETHER EXPRESSED OR IMPLIED, WITH RESPECT TO PROFESSIONAL QUALIFICATIONS, EXPERTISE, QUALITY OF WORK OR OTHER INFORMATION HEREIN REGARDING THE LABORATORIES/DIAGNOSTIC CENTRE OR THER PHLEBOTOMISTS. IN NO EVENT SHALL WE BE LIABLE TO YOU OR ANYONE ELSE FOR ANY DECISION MADE OR ACTION TAKEN BY YOU IN RELIANCE ON SUCH INFORMATION. WE HAVE NOT CONDUCTED ANY BACKGROUND CHECK ON THE PHLEBOTOMISTS AND WE ARE IN NO WAY LIABLE FOR ANY OF THEIR ACT/OMISSIONS. WE HAVE NO CONTROL OVER, AND CANNOT GUARANTEE THE AVAILABILITY OF ANY DIAGNOSTIC CENTER AT ANY PARTICULAR TIME. WE WILL NOT BE LIABLE FOR CANCELLED OR OTHERWISE UNFULFILLED APPOINTMENTS OR ANY INJURY RESULTING THEREFROM, OR FOR ANY OTHER INJURY RESULTING FROM THE USE OF THE WEBSITE OR SERVICES WHATSOEVER. YOU ARE STRONGLY ADVISED TO PERFORM YOUR OWN INVESTIGATION PRIOR TO SELECTING A HEALTH CARE DIAGNOSTIC CENTRE BY MAKING CONFIRMING TELEPHONE CALLS TO THE RELEVANT DIAGNOSTIC CENTRE. ANY KIND OF AN ENGAGEMENT WITH THE THIRD PARTIES INCLUDING WITH THE DIAGNOSTIC CENTRE WOULD BE ON A PRINCIPAL TO PRINCIPAL BASIS ON THE BEST JUDGEMENT OF YOURSELF.")]),_vm._v(" "),_c('h4',[_vm._v("Feedback")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("Any feedback You provide to this Website shall be deemed to be non-confidential. The Website shall be free to use such information on an unrestricted basis. Further, by submitting the feedback, You represent and warrant that (i) Your feedback does not contain confidential or proprietary information of You or of third parties; (ii) the Company is not under any obligation of confidentiality, express or implied, with respect to the feedback; (iii) the Website may have something similar to the feedback already under consideration or in development; and (iv) You are not entitled to any compensation or reimbursement of any kind from the Company for the feedback under any circumstances, unless specified.")]),_vm._v(" "),_c('li',[_vm._v("Under no circumstances shall the Company be held responsible in any manner for any content provided by other users even such content is offensive, hurtful or offensive. Please exercise caution while accessing the Website.")])]),_vm._v(" "),_c('h4',[_vm._v("Customer Care")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("We make all best endeavors to provide you with a pleasant experience. In the unlikely event that You face any issues, please contact us at "),_c('b',[_vm._v("[•]")])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h3',{staticClass:"screen-title mt-13p"},[_c('span',[_vm._v("\n                            Privacy policy\n                        ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('p',[_vm._v("About Labotist Private Limited ")]),_vm._v(" "),_c('p',[_vm._v("Labotist Private Limited (“"),_c('b',[_vm._v("We")]),_vm._v("” and/or “"),_c('b',[_vm._v("Us")]),_vm._v("” and/or “"),_c('b',[_vm._v("Company")]),_vm._v("”) is a company incorporated under the Companies Act, 2013. Our website is a convenient, technology driven platform that serves as a one stop solution for patients to easily choose from, and connect with various labs across the city. It is an online marketplace for lab services, offering patients the convenience of making their choice based on location, cost of test, quality and turnaround time. Patients also enjoy the added luxury of getting their samples collected in the comforts of their home by a trained phlebotomist.")]),_vm._v(" "),_c('p',[_vm._v("Similarly, our Website also serves as a marketplace for phlebotomists who are registered on our website. Our Company screens the phlebotomist as commercially viable and creates a well-intended marketplace for phlebotomist to serve as micro entrepreneurs.")]),_vm._v(" "),_c('p',[_vm._v("The Company is concerned about the privacy of its users (\""),_c('b',[_vm._v("User(s)")]),_vm._v("\" and/or \""),_c('b',[_vm._v("You")]),_vm._v("\" and/or “"),_c('b',[_vm._v("Your")]),_vm._v("”) accessing its Website. online platform in the name and style of www.labotist.com (the \""),_c('b',[_vm._v("Website")]),_vm._v("\").")]),_vm._v(" "),_c('p',[_vm._v("Please read the Privacy Policy (“"),_c('b',[_vm._v("Policy")]),_vm._v("”) carefully before using the Website, along with the Terms of Use (“"),_c('b',[_vm._v("Terms")]),_vm._v("”) provided on the Website. Your use of the Website or the services provided by the Website shall signify Your acceptance of this Policy and Your agreement to be legally bound by the same.")]),_vm._v(" "),_c('p',[_vm._v("If You do not agree with the terms of this Policy, do not use the Website or avail any of the services offered on this Website.")]),_vm._v(" "),_c('h4',[_vm._v("About the policy")]),_vm._v(" "),_c('p',[_vm._v("When You register with the Website, We may seek and collect certain personal information for Your use of the Website. You consent to the collection, use, and disclosure of the information in accordance with this Policy. Therefore, We request You to read this Policy carefully before using the Website. ")]),_vm._v(" "),_c('p',[_vm._v("Please note that, We respect and value Your privacy and shall strive towards protecting the information that You provide. We shall keep the information provided to Us as confidential to the extent reasonably possible. You understand that, by registering on the Website, your personal information may be collected. If at any time You wish to have Your information deleted, You can write to "),_c('i',[_vm._v("support@labotist.com")]),_vm._v(". We shall do the needful within 5 working days but We may retain certain information for internal purposes if required under applicable law.")]),_vm._v(" "),_c('p',[_vm._v("Your privacy is of utmost importance to us. We shall process and save your information in accordance with the Information Technology Act, 2000 and the Information Technology (Reasonable Security Practices And Procedures And Sensitive Personal Data Or Information) Rules, 2011.")]),_vm._v(" "),_c('h4',[_vm._v("collection of personally identifiable information")]),_vm._v(" "),_c('p',[_vm._v("We collect personally identifiable information (name, phone number, email etc.) from you when you request for a service. We do not for any reason whatsoever sell your Personal Identifiable Information to any third party or otherwise trade on it.")]),_vm._v(" "),_c('p',[_vm._v("The personal information You may provide to Us that We may use is as follows:")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("Registration details: This will include the password provided by You for which We use reasonable security measures for password protection from anyone.")]),_vm._v(" "),_c('li',[_vm._v("Your usage behavior on the Website.")]),_vm._v(" "),_c('li',[_vm._v("The details of the computer system or computer network that You use to visit the Website and any activities undertaken through the usage of the Website.")]),_vm._v(" "),_c('li',[_vm._v("Your first and last name, e-mail address, phone number, billing and shipping address.")])]),_vm._v(" "),_c('p',[_vm._v("The fundamental reason behind collecting Your personal information is to support and facilitate You to enjoy various features and services provided on the Website. ")]),_vm._v(" "),_c('p',[_vm._v("We select and track Your preferences to provide You with a customized Website experience, to notify You of any updated information and new developments/features and other related functions offered by the Website, to otherwise support Your relationship with Us and to prevent fraud and unlawful use.")]),_vm._v(" "),_c('p',[_vm._v("By accepting the terms of this Policy, You understand, agree and recognize that our storage and processing of Your personal information is for a lawful purpose associated with a function or an activity of the Website. You further understand, agree and acknowledge that You may be required to provide personal information that is classified as sensitive personal information as per applicable laws for Us to provide various services. ")]),_vm._v(" "),_c('p',[_vm._v("Please note that, it is entirely up to the discretion of the User to provide this personal information. However, the User would not be able to avail the services provided by Us if this information is denied.")]),_vm._v(" "),_c('p',[_vm._v("We do not sell, trade or rent Your personal information to any third party unless We have been expressly authorized by You either in writing or electronically to do so. We may at times provide aggregate statistics about our customers, traffic patterns, and related site information to reputable third parties, however this information when disclosed will be in an aggregate form and does not contain any of Your personally identifiable information.")]),_vm._v(" "),_c('p',[_vm._v("You may note that, We adopt reasonable security measures to protect Your password from being exposed or disclosed to anyone")]),_vm._v(" "),_c('h4',[_vm._v("information sharing and disclosure:")]),_vm._v(" "),_c('p',[_vm._v("We are the recipient of all the personal information and shall exercise reasonable care to keep Your personal information confidential to the maximum possible extent. We may limit disclosure of the Users' information to our entities, joint ventures, agents, sellers or third parties for the purposes of the services provided by them or for any other marketing related activity undertaken by or on behalf of our entities and/or its joint ventures on a need-to-know basis. We shall not be liable for any unauthorized use or disclosure of the personal information by any sellers participating on our Websites.")]),_vm._v(" "),_c('p',[_vm._v("We may use the information We collect from You when You register, place an order, sign up for our newsletter, respond to a survey or marketing communication, surf the Website, or use certain other site features in the following ways: To personalize your experience and to allow us to deliver the type of content and product offerings in which you are most interested. ")]),_vm._v(" "),_c('h4',[_vm._v("legal compliance")]),_vm._v(" "),_c('p',[_vm._v("We abide by all the applicable laws in force as well as the mandates of government agencies. We will disclose any information about You to government or law enforcement officials or private parties that We, in our sole discretion, believe necessary or appropriate to respond to claims and legal processes, to protect the property and rights of the Company or a third party, to protect the safety of the public or any person, or to prevent or stop any illegal, unethical or legally fraudulent activity. We may also provide Your personal information to various regulatory authorities upon any demand or request from them.")]),_vm._v(" "),_c('p',[_vm._v("We may provide your personal information, in connection with a merger, acquisition, reorganization or sale of assets or in the event of bankruptcy of the Company.")]),_vm._v(" "),_c('p',[_vm._v("We do not use vulnerability scanning and/or scanning for payment transaction. All our scanning with respect to payments is in compliant with Payment Card Industry Data Security Standard (“"),_c('b',[_vm._v("PCI")]),_vm._v("”) standards. An external PCI compliant payment gateway handles all our credit card transactions. We use regular malware scanning. Your personal information is contained behind secured networks and is only accessible by a limited number of persons who have special access rights to such systems, and are required to keep the information confidential. In addition, all sensitive/credit information you supply is encrypted via Secure Socket Layer (“SSL”) technology. We implement a variety of security measures when a user places an order enters, submits, or accesses their information to maintain the safety of your personal information. All transactions are processed through a gateway provider and are not stored or processed on our servers. ")]),_vm._v(" "),_c('h4',[_vm._v("email policies")]),_vm._v(" "),_c('p',[_vm._v("You can choose the type of emails that You wish to receive from Us. If You decide at any time that You no longer wish to receive such communications from Us, please follow the unsubscribe instructions provided in any of the communications. Please note that, once We receive Your request, it may take an additional period of time for Your subscription to become ineffective.")]),_vm._v(" "),_c('h4',[_vm._v("deletion of your information:")]),_vm._v(" "),_c('p',[_vm._v("If You wish to have the personal information that You have provided to us deleted, You can do so by writing to "),_c('i',[_vm._v("support@labotist.com")]),_vm._v(". Please note that deletion of certain personal information may lead to deletion of Your account with the Website and Your access to certain features of the Website.  You understand that under certain circumstances, the request for the deletion of personal information can be denied.")]),_vm._v(" "),_c('h4',[_vm._v("security:")]),_vm._v(" "),_c('p',[_vm._v("We strive to work towards the security, integrity and privacy of Your personal information and to protect Your personal information against unauthorized disclosure, access or destruction to the extent reasonably possible by Us. Notwithstanding anything contained in this Policy or elsewhere, We shall not be held responsible for any loss, damage or misuse of Your personal information, if such loss, damage or misuse takes place as a result of a Force Majeure Event (as defined below).")]),_vm._v(" "),_c('p',[_vm._v("A \""),_c('b',[_vm._v("Force Majeure Event")]),_vm._v("\" shall mean any event that is beyond our reasonable control and shall include, without limitation, fire, flood, explosion, acts of God, civil commotion, strikes, insurrection, war, acts of government, computer hacking, software failure and storage device, computer crashes etc")]),_vm._v(" "),_c('h4',[_vm._v("third-party disclosure")]),_vm._v(" "),_c('p',[_vm._v("We may disclose Your personal information solely in the legitimate conduct of the business to deliver services to meet Your demands. We may also release information when We believe, in good faith, that such release is reasonably necessary to (1) comply with legal or regulatory requirements; (2) enforce or apply terms of use of our Website; or (3) protect our rights, property or safety of the rights of others.")]),_vm._v(" "),_c('p',[_vm._v("Although We do not sell, trade, or otherwise transfer to outside parties your personally identifiable information unless we provide users with advance notice, this does not include website hosting partners and other parties who assist us in operating our website, conducting our business, or serving our users, so long as those parties agree to keep this information confidential. We may also release information when its release is appropriate to comply with the law, enforce our site policies, or protect ours or others' rights, property or safety.")]),_vm._v(" "),_c('p',[_vm._v("However, non-personally identifiable visitor information may be provided to other parties for marketing, advertising, or other uses.")]),_vm._v(" "),_c('h4',[_vm._v("links to other sites")]),_vm._v(" "),_c('p',[_vm._v("The Website may provide third-party advertisements and links to other websites. We do not provide Your personal information to these third-party websites or advertisers.")]),_vm._v(" "),_c('p',[_vm._v("The links to other websites are operated by third parties and are not controlled by, or affiliated to, or associated with Us unless expressly specified on the Website. Therefore, We do not make any claims concerning the privacy practices or policies of such third parties or terms of use of such websites, nor do We control or guarantee or endorse the accuracy, integrity, or quality of the information available on such websites. Any information provided by You to such third party websites shall be governed in accordance with the privacy policies of the respective websites and it is strongly recommended that You review the privacy policy on any such websites prior to using such websites.")]),_vm._v(" "),_c('h4',[_vm._v("google")]),_vm._v(" "),_c('p',[_vm._v("Google's advertising requirements can be summed up by Google's Advertising Principles. They are put in place to provide a positive experience for users. Click here to view We use Google AdSense Advertising on our Website.")]),_vm._v(" "),_c('p',[_vm._v("Google, as a third-party vendor, uses cookies to serve ads on our site. Google's use of the DART cookie enables it to serve ads to our users based on previous visits to our site and other sites on the Internet. Users may opt-out of the use of the DART cookie by visiting the Google Ad and Content Network privacy policy.")]),_vm._v(" "),_c('p',[_vm._v("We have implemented the following:")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("Google Display Network Impression Reporting")]),_vm._v(" "),_c('li',[_vm._v("Demographics and Interests Reporting")])]),_vm._v(" "),_c('p',[_vm._v("We, along with third-party vendors such as Google use first-party cookies (such as the Google Analytics cookies) and third-party cookies (such as the DoubleClick cookie) or other third-party identifiers together to compile data regarding user interactions with ad impressions and other ad service functions as they relate to our website.")]),_vm._v(" "),_c('h4',[_vm._v("how does our website handle do not track signals?")]),_vm._v(" "),_c('p',[_vm._v("We honor Do Not Track signals and Do Not Track, plant cookies, or use advertising when a Do Not Track (DNT) browser mechanism is in place.")]),_vm._v(" "),_c('h4',[_vm._v("research")]),_vm._v(" "),_c('p',[_vm._v("In support of eHealth initiatives, we may use and share your medical information for research. We will only use and share information for research after obtaining your consent or if the used data does not expressly identify you in any way.")]),_vm._v(" "),_c('h4',[_vm._v("studies and reports")]),_vm._v(" "),_c('p',[_vm._v("We may use your information to study results and produce reports. Such information may be shared with Our partners and advertisers under the sole discretion of the Company.")]),_vm._v(" "),_c('h4',[_vm._v("changes to this privacy policy")]),_vm._v(" "),_c('p',[_vm._v("Any changes we may make to our Policy in the future will be posted on this page and, where appropriate, notified to you by e-mail. Please check back frequently to see any updates or changes to our Policy.")]),_vm._v(" "),_c('h4',[_vm._v("phishing")]),_vm._v(" "),_c('p',[_vm._v("Identity theft and the fraudulent practice currently known as \"phishing\" are of great concern to Us. Phishing is an attempt to acquire personal/sensitive information which the legitimate organization already has. Safeguarding information to help protect You from identity theft is a top priority. We do not and will not, at any time, request Your credit card information or national identification numbers in a non-secure or unsolicited e-mail or telephone communication.")]),_vm._v(" "),_c('h4',[_vm._v("cookies")]),_vm._v(" "),_c('p',[_vm._v("Yes. Cookies are small files that a site or its service provider transfers to your computer's hard drive through your Web browser (if you allow) that enables the site's or service provider's systems to recognize your browser and capture and remember certain information. For instance, We use cookies to help us remember the services/packages obtained by you. They are also used to help us understand your preferences based on previous or current site activity, which enables us to provide you with improved services. We also use cookies to help us compile aggregate data about site traffic and site interaction so that we can offer better site experiences and tools in the future.")]),_vm._v(" "),_c('p',[_vm._v("We use cookies to:")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("Understand and save user's preferences for future visits.")]),_vm._v(" "),_c('li',[_vm._v("Compile aggregate data about site traffic and site interactions in order to offer better site experiences and tools in the future. We may also use trusted third-party services that track this information on our behalf.")])]),_vm._v(" "),_c('p',[_vm._v("You can choose to have Your computer warn you each time a cookie is being sent, or You can choose to turn off all cookies. You can do this through Your browser settings by utilizing the "),_c('i',[_vm._v("Help Menu")]),_vm._v(" to learn the correct way to modify your cookies. If You turn cookies off, some of the features that make Your site experience more efficient may not function properly. It won't affect the User's experience that make Your site experience more efficient and may not function properly. ")]),_vm._v(" "),_c('h4',[_vm._v("contact")]),_vm._v(" "),_c('p',[_vm._v("Our Grievance Officer shall undertake all reasonable efforts to address your grievances at the earliest possible opportunity. You may contact us at:")]),_vm._v(" "),_c('p',[_vm._v("Grievance Officer: Jayaprakaash Jayaraman")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Address:")]),_c('br'),_vm._v("\n                        Flat No 8, 2nd Floor, "),_c('br'),_vm._v("\n                        Old No 4, New No 5 Rajachar Street, "),_c('br'),_vm._v("\n                        T.Nagar, Chennai - 600017")]),_vm._v(" "),_c('p',[_vm._v("Reach out to us on "),_c('i',[_vm._v("support@labotist.com")]),_vm._v(", in case of any queries.")])])])}]
var Secure_Payment_esExports = { render: Secure_Payment_render, staticRenderFns: Secure_Payment_staticRenderFns }
/* harmony default export */ var components_mobile_Book_Secure_Payment = (Secure_Payment_esExports);
// CONCATENATED MODULE: ./src/components/mobile/Book/Secure/Payment.vue
function Secure_Payment_injectStyle (ssrContext) {
  __webpack_require__("zzoE")
}
var Secure_Payment_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var Secure_Payment___vue_template_functional__ = false
/* styles */
var Secure_Payment___vue_styles__ = Secure_Payment_injectStyle
/* scopeId */
var Secure_Payment___vue_scopeId__ = "data-v-5794ab96"
/* moduleIdentifier (server only) */
var Secure_Payment___vue_module_identifier__ = null
var Secure_Payment_Component = Secure_Payment_normalizeComponent(
  mobile_Book_Secure_Payment["a" /* default */],
  components_mobile_Book_Secure_Payment,
  Secure_Payment___vue_template_functional__,
  Secure_Payment___vue_styles__,
  Secure_Payment___vue_scopeId__,
  Secure_Payment___vue_module_identifier__
)

/* harmony default export */ var src_components_mobile_Book_Secure_Payment = (Secure_Payment_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/Book/Secure/Success.vue
var mobile_Book_Secure_Success = __webpack_require__("+TPz");

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-67cc7313","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/Book/Secure/Success.vue
var Secure_Success_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"SuccessDiv"}},[_c('HeaderVue',{attrs:{"isHealthCartEnabled":"true","isHeader":"true"}}),_vm._v(" "),_c('div',{staticClass:"search-section"},[_vm._m(0,false,false),_vm._v(" "),_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_vm._m(1,false,false),_vm._v(" "),_vm._m(2,false,false),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('button',{staticClass:"btn btn-light mar-3",on:{"click":function($event){_vm.gomyResult()}}},[_vm._v("\n                        My Result\n                       ")])])])])]),_vm._v(" "),(_vm.requestDetails)?_c('div',{staticClass:"portal-section pt-3 pb-3"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"label-data"},[_c('p',[_vm._v("\n                            Requested ID\n                        ")]),_vm._v(" "),_c('p',[_vm._v("\n                            "+_vm._s('REQ'+_vm.requestDetails.requestId)+"\n                        ")])]),_vm._v(" "),_c('div',{staticClass:"label-data"},[_c('p',[_vm._v("\n                            Patient Name\n                        ")]),_vm._v(" "),_c('p',[_vm._v("\n                           "+_vm._s(_vm.requestDetails.reqPatientFirstName+' '+_vm.requestDetails.reqPatientLastName)+"\n                        ")])]),_vm._v(" "),_c('div',{staticClass:"label-data"},[_c('p',[_vm._v("\n                            Appointment Date & Time\n                        ")]),_vm._v(" "),_c('div',{staticClass:"green-outline"},[_vm._v("\n                            "+_vm._s(_vm.appointmentDate)+"  |  "+_vm._s(_vm.appointmentStartTime)+" to "+_vm._s(_vm.appointmentEndTime)+"\n                        ")])]),_vm._v(" "),_c('div',{staticClass:"label-data"},[_c('p',[_vm._v("\n                            Sample Collection Address\n                        ")]),_vm._v(" "),_c('p',[_vm._v("\n                            "+_vm._s(_vm.requestDetails.pickupAddress)+"\n                            "),_c('br'),_vm._v("M: "+_vm._s(_vm.requestDetails.reqPatientMobile)+"\n                        ")])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"lab display-flex no-border p-0 mt-3 bg-tranparent"},[_c('div',{staticClass:"flex-box"},[_c('div',{staticClass:"lab-logo"},[(_vm.requestDetails.Lab.logo)?_c('img',{attrs:{"src":_vm.$s3BucketUrl + _vm.requestDetails.Lab.logo}}):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"flex-box"},[_c('p',{staticClass:"black-color font-weight-bold mb-2"},[_vm._v("\n                                "+_vm._s(_vm.requestDetails.Lab.labName)+"\n                                "+_vm._s(_vm.requestDetails.Lab.Address.Location.locationName)+", "+_vm._s(_vm.requestDetails.Lab.Address.City.cityName)+", "+_vm._s(_vm.requestDetails.Lab.Address.State.stateName)+" - "+_vm._s(_vm.requestDetails.Lab.Address.zipCode)+"\n                            ")])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 gray-bg"},[_c('div',{staticClass:"table-responsive summary-table test-conformation"},[_c('table',{staticClass:"table mb-0"},[_vm._m(3,false,false),_vm._v(" "),_c('tbody',{staticClass:"black-color"},_vm._l((_vm.requestDetails.RequestTests),function(requestTest,index){return _c('tr',{key:index},[(requestTest)?_c('td',[_c('span',[_vm._v(_vm._s(requestTest.Profile?(requestTest.Profile.panelName):(requestTest.Test.testName)))])]):_vm._e(),_vm._v(" "),_c('td'),_vm._v(" "),_c('td',[_c('p',{staticClass:"float-right mt-1 mb-0 price-tag"},[_vm._v("\n                                            Rs. "+_vm._s(requestTest.testCost)+"\n                                        ")])])])}))])])]),_vm._v(" "),_c('div',{staticClass:"col-12 border-bottom"},[_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table price-table"},[_c('tbody',[(_vm.requestDetails.phlebCost && _vm.requestDetails.phlebCost > 0)?_c('tr',[_c('td',[_vm._v("\n                                        Phlebotomist Fee\n                                    ")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("\n                                       + Rs. "+_vm._s(_vm.requestDetails.phlebCost)+"\n                                    ")])]):_vm._e(),_vm._v(" "),_c('tr',[_c('td',[_vm._v("\n                                      Sub total\n                                    ")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("\n                                        Rs. "+_vm._s((_vm.requestDetails.cost-_vm.requestDetails.discountCost) + (_vm.requestDetails.phlebCost && _vm.requestDetails.phlebCost > 0 ? _vm.requestDetails.phlebCost : 0))+"\n                                    ")])]),_vm._v(" "),(_vm.requestDetails.couponCost)?_c('tr',[_c('td',[_vm._v("\n                                        Coupon Discount\n                                    ")]),_vm._v(" "),_c('td',{staticClass:"green-color text-right"},[_vm._v("\n                                       - Rs."+_vm._s(_vm.requestDetails.couponCost)+"\n                                    ")])]):_vm._e(),_vm._v(" "),(_vm.requestDetails.creditDiscount && _vm.requestDetails.creditDiscount > 0)?_c('tr',[_c('td',[_vm._v("\n                                        Credits Applied\n                                    ")]),_vm._v(" "),_c('td',{staticClass:"green-color text-right"},[_vm._v("\n                                       - Rs."+_vm._s(_vm.requestDetails.creditDiscount)+"\n                                    ")])]):_vm._e(),_vm._v(" "),(_vm.requestDetails.paymentType == 1)?_c('tr',[_c('td',{staticClass:"black-color"},[_vm._v("\n                                        Cash Due\n                                    ")]),_vm._v(" "),_c('td',{staticClass:"text-right black-color"},[_vm._v("\n                                        Rs. "+_vm._s(_vm.requestDetails.totalUnpaidCost)+"\n                                    ")])]):_c('tr',[_c('td',{staticClass:"black-color"},[_vm._v("\n                                        Amount Paid\n                                    ")]),_vm._v(" "),_c('td',{staticClass:"text-right black-color"},[_vm._v("\n                                        Rs. "+_vm._s(_vm.requestDetails.totalPaidCost)+"\n                                    ")])])])])])]),_vm._v(" "),_c('div',{staticClass:"col-12 mt-4"},[_c('button',{staticClass:"btn btn-outline-primary",on:{"click":function($event){_vm.goHome()}}},[_vm._v("\n                        Go to Homepage\n                    ")])])])])]):_vm._e(),_vm._v(" "),_c('FooterVue')],1)}
var Secure_Success_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"alert alert-success alert-dismissable flyover flyover-centered",attrs:{"id":"message1"}},[_c('strong',[_c('i',{staticClass:"fa fa-check mr-2"})]),_vm._v(" Thank you for your Feedback\n        ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12"},[_c('div',{staticClass:"check-box float-left mr-3"},[_c('img',{staticClass:"mt-2",attrs:{"src":"static/images/check.png","alt":""}})]),_vm._v(" "),_c('div',{staticClass:"float-left thank-msg"},[_c('h5',{staticClass:"mb-0 white-color mt-3"},[_vm._v("\n                            Thank you, your order has been placed successfully!\n                           \n                        ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 mt-3"},[_c('p',[_vm._v("\n                        Our phlebotomist will get in touch with you at the phone number that you have provided before\n                        coming to collect the sample at the address mentioned.\n                    ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{staticClass:"no-border"},[_vm._v("\n                                        Test Name\n                                    ")]),_vm._v(" "),_c('th',{staticClass:"text-right no-border"}),_vm._v(" "),_c('th',{staticClass:"no-border text-right"},[_vm._v("\n                                        Price\n                                    ")])])])}]
var Secure_Success_esExports = { render: Secure_Success_render, staticRenderFns: Secure_Success_staticRenderFns }
/* harmony default export */ var components_mobile_Book_Secure_Success = (Secure_Success_esExports);
// CONCATENATED MODULE: ./src/components/mobile/Book/Secure/Success.vue
function Secure_Success_injectStyle (ssrContext) {
  __webpack_require__("v1jw")
}
var Secure_Success_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var Secure_Success___vue_template_functional__ = false
/* styles */
var Secure_Success___vue_styles__ = Secure_Success_injectStyle
/* scopeId */
var Secure_Success___vue_scopeId__ = "data-v-67cc7313"
/* moduleIdentifier (server only) */
var Secure_Success___vue_module_identifier__ = null
var Secure_Success_Component = Secure_Success_normalizeComponent(
  mobile_Book_Secure_Success["a" /* default */],
  components_mobile_Book_Secure_Success,
  Secure_Success___vue_template_functional__,
  Secure_Success___vue_styles__,
  Secure_Success___vue_scopeId__,
  Secure_Success___vue_module_identifier__
)

/* harmony default export */ var src_components_mobile_Book_Secure_Success = (Secure_Success_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/BlogFrame.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var mobile_BlogFrame = ({
  name: 'BlogFrame',
  components: {},
  beforeCreate: function beforeCreate() {
    this.query = this.$localStorage.get('location');
  },
  data: function data() {
    return {
      onBlurKey: 'none',
      address: '',
      query: this.$localStorage.get('location') ? this.$localStorage.get('location').locationName + '-' + this.$localStorage.get('location').locationZipCode : '',
      items: [],
      selectedLocation: this.$localStorage.get('location') ? this.$localStorage.get('location') : undefined,
      selectedPincode: this.$localStorage.get('pincode') ? this.$localStorage.get('pincode') : undefined,
      locationObj: null
    };
  },

  methods: {
    goTest: function goTest() {
      //   this.query = this.selectedLocation ? this.selectedLocation.locationName + '-' + this.selectedLocation.locationZipCode : ''
      //   if (!this.selectedLocation) {
      //     return false
      //   }
      //   this.$localStorage.set('location', this.selectedLocation, 0)
      //   this.$localStorage.set('pincode', this.selectedLocation.locationZipCode, 0)
      //   this.$root.$emit('bookTest', true)
      window.open(this.$blogRedirectUrl, 'myWindow');
    },
    searchLocation: function searchLocation(query) {
      this.onBlurKey = 'block';
      this.selectedLocation = undefined;
      this.$localStorage.remove('location');
      this.$localStorage.remove('pincode');
      if (this.query.length < 3) {
        this.onBlurKey = 'none';
        this.items = [];
        return false;
      }
      try {
        if (this.$localStorage.get('access_token') !== '') {
          var data = {
            'keyword': this.query
          };
          promise_default.a.resolve(this.$POST('patient/searchLocation', data)).then(function (res) {
            console.log(res);
            if (res.response_code === 0) {
              this.items = res.response;
            }
          }.bind(this)).catch(function (err) {
            console.error(err);
          });
        }
      } catch (e) {
        console.error(e);
      }
    },
    closeBlock: function closeBlock() {
      setTimeout(function () {
        this.onBlurKey = 'none';
      }.bind(this), 300);
    },
    selectLocation: function selectLocation(event, obj) {
      this.selectedLocation = undefined;
      this.selectedLocation = obj;
      this.selectedPincode = obj.locationZipCode;
      this.query = obj.locationName + '-' + obj.locationZipCode;
      this.items = [];
      this.onBlurKey = 'none';
    }
  },
  watch: {
    address: function address(val, oldVal) {
      console.log('new: %s, old: %s', val, oldVal);
    }
  },
  mounted: function mounted() {
    this.$hidePageLoading();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1ec6f42d","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/BlogFrame.vue
var mobile_BlogFrame_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"BlogDiv"}},[_c('div',{staticClass:"iframe-view"},[_c('div',{staticClass:"text-center pt-0"},[_c('h2',{staticClass:"black-color font-weight-normal text-center"},[_vm._v("Do any medical test at your home")]),_vm._v(" "),_c('img',{attrs:{"src":"static/images/search-code-img.svg","alt":""}}),_vm._v(" "),_c('p',[_vm._v("Our service is currently in Chennai & Bengaluru only")]),_vm._v(" "),_c('div',{staticClass:"banner-fields"},[_c('button',{ref:"pincodeSubmit",staticClass:"btn btn-lg btn-primary mb-3",attrs:{"type":"button"},on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.goTest()},"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }_vm.goTest()}}},[_vm._v("\n                  Book Test\n              ")])])])])])}
var mobile_BlogFrame_staticRenderFns = []
var mobile_BlogFrame_esExports = { render: mobile_BlogFrame_render, staticRenderFns: mobile_BlogFrame_staticRenderFns }
/* harmony default export */ var components_mobile_BlogFrame = (mobile_BlogFrame_esExports);
// CONCATENATED MODULE: ./src/components/mobile/BlogFrame.vue
function mobile_BlogFrame_injectStyle (ssrContext) {
  __webpack_require__("MXWE")
}
var mobile_BlogFrame_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var mobile_BlogFrame___vue_template_functional__ = false
/* styles */
var mobile_BlogFrame___vue_styles__ = mobile_BlogFrame_injectStyle
/* scopeId */
var mobile_BlogFrame___vue_scopeId__ = "data-v-1ec6f42d"
/* moduleIdentifier (server only) */
var mobile_BlogFrame___vue_module_identifier__ = null
var mobile_BlogFrame_Component = mobile_BlogFrame_normalizeComponent(
  mobile_BlogFrame,
  components_mobile_BlogFrame,
  mobile_BlogFrame___vue_template_functional__,
  mobile_BlogFrame___vue_styles__,
  mobile_BlogFrame___vue_scopeId__,
  mobile_BlogFrame___vue_module_identifier__
)

/* harmony default export */ var src_components_mobile_BlogFrame = (mobile_BlogFrame_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/Public/Redirect.vue
//
//
//
//
//

/* harmony default export */ var mobile_Public_Redirect = ({
  name: 'Redirect',
  components: {},
  beforeCreate: function beforeCreate() {
    document.title = this.$route.params.data + ' - Labotist';
  },
  data: function data() {
    return {};
  },
  mounted: function mounted() {
    setTimeout(function () {
      if (this.$route.params.tests) {
        this.$router.push({ path: '/redirect/labs/' + this.$route.params.tests });
        //   window.location = this.$route.params.tests;
      } else {
        this.$router.push({ path: '/' });
      }
      this.$hidePageLoading();
    }.bind(this), 500);
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-734ae9b8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/Public/Redirect.vue
var Public_Redirect_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"redirectDiv"}})}
var Public_Redirect_staticRenderFns = []
var Public_Redirect_esExports = { render: Public_Redirect_render, staticRenderFns: Public_Redirect_staticRenderFns }
/* harmony default export */ var components_mobile_Public_Redirect = (Public_Redirect_esExports);
// CONCATENATED MODULE: ./src/components/mobile/Public/Redirect.vue
var Public_Redirect_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var Public_Redirect___vue_template_functional__ = false
/* styles */
var Public_Redirect___vue_styles__ = null
/* scopeId */
var Public_Redirect___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Public_Redirect___vue_module_identifier__ = null
var Public_Redirect_Component = Public_Redirect_normalizeComponent(
  mobile_Public_Redirect,
  components_mobile_Public_Redirect,
  Public_Redirect___vue_template_functional__,
  Public_Redirect___vue_styles__,
  Public_Redirect___vue_scopeId__,
  Public_Redirect___vue_module_identifier__
)

/* harmony default export */ var src_components_mobile_Public_Redirect = (Public_Redirect_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/Public/LabRedirect.vue

//
//
//
//
//

/* harmony default export */ var mobile_Public_LabRedirect = ({
  name: 'Redirect',
  components: {},
  beforeCreate: function beforeCreate() {
    document.title = this.$route.params.testdata + ' - Labotist';
  },
  data: function data() {
    return {
      currentLocation: {}
    };
  },
  mounted: function mounted() {},
  created: function created() {
    this.geolocation();
  },

  methods: {
    geolocation: function geolocation() {
      var options = {
        maximumAge: 60000,
        timeout: 5000,
        enableHighAccuracy: true
      };
      navigator.geolocation.getCurrentPosition(function (position) {
        console.log('im tracking you!');
        this.currentLocation = {
          lat: position.coords.latitude,
          lng: position.coords.longitude
        };
        this.changeCityUsingLocation();
        return false;
      }.bind(this), function (error) {
        if (error.code === error.PERMISSION_DENIED) {
          console.log('you denied me :-(');
          setTimeout(function () {
            this.$router.push({ path: '/labs/chennai/' + this.$route.params.testdata });
          }.bind(this), 500);
        }
      }.bind(this)), options;
    },
    changeCityUsingLocation: function changeCityUsingLocation() {
      var data = {
        coordinates: this.currentLocation
      };
      promise_default.a.resolve(this.$POST('patient/getCityUsingLocation', data)).then(function (res) {
        if (res.response_code === 0) {
          if (res.response.cityName) {
            var laburl = '/labs/' + res.response.cityName + '/' + this.$route.params.testdata;
            if (res.response.locationName) {
              laburl = laburl + '/' + res.response.locationName;
            }
            this.$router.push({ path: laburl });
          } else {
            this.$router.push({ path: '/labs/chennai/' + this.$route.params.testdata });
          }
        } else {
          this.$router.push({ path: '/labs/chennai/' + this.$route.params.testdata });
        }
      }.bind(this)).catch(function (err) {
        console.error(err);
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-56350c1e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/Public/LabRedirect.vue
var Public_LabRedirect_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"redirectDiv"}})}
var Public_LabRedirect_staticRenderFns = []
var Public_LabRedirect_esExports = { render: Public_LabRedirect_render, staticRenderFns: Public_LabRedirect_staticRenderFns }
/* harmony default export */ var components_mobile_Public_LabRedirect = (Public_LabRedirect_esExports);
// CONCATENATED MODULE: ./src/components/mobile/Public/LabRedirect.vue
var Public_LabRedirect_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var Public_LabRedirect___vue_template_functional__ = false
/* styles */
var Public_LabRedirect___vue_styles__ = null
/* scopeId */
var Public_LabRedirect___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Public_LabRedirect___vue_module_identifier__ = null
var Public_LabRedirect_Component = Public_LabRedirect_normalizeComponent(
  mobile_Public_LabRedirect,
  components_mobile_Public_LabRedirect,
  Public_LabRedirect___vue_template_functional__,
  Public_LabRedirect___vue_styles__,
  Public_LabRedirect___vue_scopeId__,
  Public_LabRedirect___vue_module_identifier__
)

/* harmony default export */ var src_components_mobile_Public_LabRedirect = (Public_LabRedirect_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/Public/ReferalSignup.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// import FooterVue from '@/components/mobile/Footer'


/* harmony default export */ var mobile_Public_ReferalSignup = ({
  name: 'Privacy',
  components: {
    HeaderVue: mobile_Header["a" /* default */],
    Sidemenu: src_components_mobile_Public_Sidemenu
    // FooterVue
  },
  beforeCreate: function beforeCreate() {},
  created: function created() {
    if (this.$route.params.referal_code) {
      console.log(this.$route.params.referal_code);
      try {
        this.referralCode = this.$decryptString(this.$route.params.referal_code);
        console.log(this.referralCode);
      } catch (err) {
        this.referralCode = '';
        console.log(err);
      }
    } else {
      this.$localStorage.remove('ref_code');
    }
  },
  data: function data() {
    return {
      isDobError: false,
      otherSignup: false,
      loginWithoutBtn: false,
      login: {
        username: '',
        password: '',
        error: false,
        errormsg: '',
        otp_send: 1,
        login_otp: '',
        successmsg: ''
      },
      forgot: {
        username: '',
        otp: '',
        newPassword: '',
        confirmPassword: '',
        error: false,
        errormsg: '',
        success: 1,
        successmsg: '',
        otpType: ''
      },
      otp: {
        username: '',
        error: false,
        errormsg: '',
        success: false,
        successmsg: ''
      },
      signup: {
        email: '',
        mobile: '',
        firstName: '',
        password: '',
        referralCode: '',
        dob: undefined,
        sex: 'M',
        otp: '',
        error: false,
        errormsg: '',
        success: false,
        successmsg: '',
        dobYears: [],
        dobDate: [],
        year: '',
        month: '',
        ddate: ''
      },
      disabled: {
        from: new Date()
      },
      appointmentLogin: false,
      referralCode: '',
      referralCodeDisable: false
    };
  },
  mounted: function mounted() {
    this.$hidePageLoading();
  },

  methods: {
    create_account: function create_account() {

      this.isDobError = false;
      this.signup.error = false;
      this.$validator.validateAll('signup').then(function (result) {
        if (result) {
          // if (this.signup.year.length !== 4 || this.signup.month.length <= 0 || this.signup.ddate.length <= 0) {
          //   this.isDobError = true
          //   return false
          // }
          try {
            if (this.signup.email !== '' && this.signup.mobile !== '' && this.signup.firstName !== '' && this.signup.password !== '') {
              var params = {
                'firstName': this.signup.firstName,
                'lastName': '',
                'phone1': this.signup.mobile,
                'email': this.signup.email,
                'password': this.signup.password,
                'referralCode': this.referralCode,
                // 'sex': this.signup.sex,
                'sex': '',
                // 'dob': this.signup.year + '-' + this.signup.month + '-' + this.signup.ddate,
                'dob': null
                // 'dob': dateFormat(this.signup.dob, 'yyyy-mm-dd', true)
              };
              promise_default.a.resolve(this.$POST('patient/quickSignUp', params)).then(function (response) {
                if (response.response_code === 0) {
                  this.signup.error = false;
                  this.signup.errormsg = '';
                  this.signup.success = true;
                  this.signup.successmsg = 'We have send an authentication code for verifying your account.';
                  Vue.analytics.fbq.event('ViewContent', {
                    content_ids: 0,
                    content_name: 'SIGN UP SUCCESS',
                    contents: '',
                    content_type: 'SIGNUP_SUCCESS'
                  });
                } else {
                  this.signup.success = false;
                  this.signup.error = true;
                  this.signup.errormsg = response.response_message;
                  this.signup.otp = '';
                  if (response.response_code === 3) {
                    this.$refs.signUpEmail.focus();
                  } else if (response.response_code === 4) {
                    this.$refs.signUpMobile.focus();
                  }
                }
              }.bind(this)).catch(function (err) {
                console.log(err);
              });
            } else {
              this.$Simplert.open({
                title: 'Alert',
                message: 'Please enter required fields!',
                type: 'warning',
                disableOverlayClick: true,
                showXclose: true,
                useConfirmBtn: false,
                customCloseBtnText: 'OK'
              });
              // alert('Please enter required fields!')
            }
          } catch (e) {
            console.error(e);
          }
        }
      }.bind(this));
    },
    signup_verify_otp: function signup_verify_otp() {
      var _this = this;

      this.$validator.validateAll('signupOtp').then(function (result) {
        if (result) {
          if (_this.signup.email !== '' && _this.signup.otp !== '') {
            _this.$verifyOTP(_this.signup.email, _this.signup.otp).then(function (response) {
              if (response.error) {
                this.signup.error = true;
                this.signup.errormsg = 'Invalid OTP';
                this.signup.successmsg = '';
                return false;
              } else {
                if (this.appointmentLogin) {
                  this.appointmentLogin = false;
                  this.$root.$emit('isLogin', true);
                  //   $('.signup').modal('hide')
                  this.$router.push('/address');
                  // location.reload()
                  return false;
                } else {
                  this.$root.$emit('isLogin', true);
                  $('.signup').modal('hide');
                  // location.reload()
                  // this.$router.push('/myprofile')
                  this.$router.push({ path: '/referral/landing' });
                }
              }
            }.bind(_this)).catch(function (err) {
              console.error(err);
            });
          }
        }
      });
    },
    signup_resend: function signup_resend() {
      try {
        if (this.signup.email !== '') {
          var data = {
            'email': this.signup.email
          };
          promise_default.a.resolve(this.$POST('patient/resendOTP', data)).then(function (res) {
            if (res.response_code === 0) {
              this.signup.error = false;
              this.signup.errormsg = '';
              this.signup.success = true;
              this.signup.successmsg = 'We have resend an authentication code to your mail id.';
            } else {
              this.signup.success = false;
              this.signup.error = true;
              this.signup.errormsg = res.response_message;
              this.signup.otp = '';
            }
          }.bind(this)).catch(function (err) {
            console.log(err);
          });
        }
      } catch (e) {
        console.error(e);
      }
    },
    bookNowClicked: function bookNowClicked() {
      if (this.referralCode && this.referralCode.length > 0) {
        this.$localStorage.set('ref_code', this.referralCode);
      } else {
        this.$localStorage.remove('ref_code');
      }
      this.$router.push('/lab');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-21d5720b","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/Public/ReferalSignup.vue
var Public_ReferalSignup_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"referalSignupDiv"}},[_c('HeaderVue',{attrs:{"isHeader":"true"}}),_vm._v(" "),_vm._m(0,false,false),_vm._v(" "),_vm._m(1,false,false),_vm._v(" "),_c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"inner-page1 reg-content"},[_c('div',{staticClass:"container"},[_vm._m(2,false,false),_vm._v(" "),_c('div',{staticClass:"row mt-5"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"ref-form align-center p-0"},[_c('img',{staticClass:"img-fluid",attrs:{"src":"static/images/Register_to_get.png","alt":""}}),_vm._v(" "),(_vm.signup.error)?_c('p',{staticClass:"no-mar-top red-color"},[_vm._v(_vm._s(_vm.signup.errormsg))]):_vm._e(),_vm._v(" "),(_vm.signup.success)?_c('p',{staticClass:"no-mar-top green-color"},[_vm._v(_vm._s(_vm.signup.successmsg))]):_vm._e(),_vm._v(" "),_c('form',{directives:[{name:"show",rawName:"v-show",value:(!_vm.signup.success),expression:"!signup.success"}],attrs:{"data-vv-scope":"signup"}},[_c('div',{staticClass:"form-content line-textbox"},[_c('h2',[_vm._v("Create an Account with Labotist")]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.signup.email),expression:"signup.email"},{name:"validate",rawName:"v-validate",value:('required|email|max:100'),expression:"'required|email|max:100'"}],ref:"signUpEmail",staticClass:"form-control",attrs:{"type":"email","id":"signUpEmail","name":"email","data-vv-as":"email address","maxlength":"100","placeholder":"Email address"},domProps:{"value":(_vm.signup.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.signup, "email", $event.target.value)}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('signup.email')),expression:"errors.has('signup.email')"}],staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('signup.email')))])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"mask",rawName:"v-mask",value:('##########'),expression:"'##########'"},{name:"model",rawName:"v-model",value:(_vm.signup.mobile),expression:"signup.mobile"},{name:"validate",rawName:"v-validate",value:('required|numeric|min:10|max:10'),expression:"'required|numeric|min:10|max:10'"}],ref:"signUpMobile",staticClass:"form-control",attrs:{"type":"text","name":"mobile","data-vv-as":"mobile no.","placeholder":"Mobile number"},domProps:{"value":(_vm.signup.mobile)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.signup, "mobile", $event.target.value)}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('signup.mobile')),expression:"errors.has('signup.mobile')"}],staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('signup.mobile')))])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.signup.firstName),expression:"signup.firstName"},{name:"validate",rawName:"v-validate",value:('required|alpha_spaces|max:50'),expression:"'required|alpha_spaces|max:50'"}],staticClass:"form-control",attrs:{"type":"text","name":"signupFirstName","data-vv-as":"first name","maxlength":"50","placeholder":"Name"},domProps:{"value":(_vm.signup.firstName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.signup, "firstName", $event.target.value)}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('signup.signupFirstName')),expression:"errors.has('signup.signupFirstName')"}],staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('signup.signupFirstName')))])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.signup.password),expression:"signup.password"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"form-control",attrs:{"type":"password","name":"password","data-vv-as":"password","placeholder":"Password"},domProps:{"value":(_vm.signup.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.signup, "password", $event.target.value)}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('signup.password')),expression:"errors.has('signup.password')"}],staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('signup.password')))])]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary w-100",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();_vm.create_account()}}},[_vm._v("Register")])])]),_vm._v(" "),_c('form',{directives:[{name:"show",rawName:"v-show",value:(_vm.signup.success),expression:"signup.success"}],attrs:{"data-vv-scope":"signupOtp"}},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"signUpEmail"}},[_vm._v("Enter OTP")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.signup.otp),expression:"signup.otp"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"form-control",attrs:{"type":"text","name":"sotp","data-vv-as":"signup otp","placeholder":"Enter OTP"},domProps:{"value":(_vm.signup.otp)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.signup, "otp", $event.target.value)}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('signupOtp.sotp')),expression:"errors.has('signupOtp.sotp')"}],staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('signupOtp.sotp')))])]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary full-width mar-b-15",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();_vm.signup_verify_otp()}}},[_vm._v("Verify")]),_vm._v(" "),_c('a',{staticClass:"text-center signup-link display-block",on:{"click":function($event){$event.preventDefault();_vm.signup_resend()}}},[_vm._v("Resend?")])])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"small-box"},[_c('p',[_vm._v("Use credit to book blood test now")]),_vm._v(" "),_c('button',{staticClass:"btn btn-warning w-100",on:{"click":function($event){_vm.bookNowClicked()}}},[_vm._v("Book Now")])]),_vm._v(" "),_vm._m(3,false,false)])])])]),_vm._v(" "),_vm._m(4,false,false)])],1)}
var Public_ReferalSignup_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading"},[_c('div',{staticClass:"loading-img"},[_c('img',{attrs:{"src":"static/images/loading.gif","alt":""}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"reg-header"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('img',{staticClass:"img-fluid at-home",attrs:{"src":"static/images/at-home.png","alt":""}})]),_vm._v(" "),_c('div',{staticClass:"col-sm-6 sec3"},[_c('p',[_vm._v("Free Home Blood Sample Collection")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('p',[_vm._v("Search Prescribed Test")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('p',[_vm._v("No Minimum value Order")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('p',[_vm._v("Access Report Online")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('p',[_vm._v("Pay Online or By Cash")]),_vm._v(" "),_c('hr')])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('h4',[_vm._v("\n                            Labotist is an online marketplace for lab services, offering patients the convenience of\n                            picking labs for their medical tests based on location, cost and turnover time. Using its\n                            technology powered phlebotomy\n                            kit and highly trained Phlebotomist, patients are assured safe, sophisticated and accurate\n                            sample collection\n                            process.\n                        ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"test-features"},[_c('li',{staticClass:"clearfix"},[_c('img',{attrs:{"src":"static/images/icon/blood-test.png","alt":""}}),_vm._v("\n                                Pick from over 1000+ blood tests\n                            ")]),_vm._v(" "),_c('li',{staticClass:"clearfix"},[_c('img',{attrs:{"src":"static/images/icon/compare-cost.png","alt":""}}),_vm._v("\n                                Compare cost of tests across partner labs\n                            ")]),_vm._v(" "),_c('li',{staticClass:"clearfix"},[_c('img',{attrs:{"src":"static/images/icon/confort-your.png","alt":""}}),_vm._v("\n                                Get blood test done from the comfort of your home\n                            ")]),_vm._v(" "),_c('li',{staticClass:"clearfix"},[_c('img',{attrs:{"src":"static/images/icon/online-dashboard.png","alt":""}}),_vm._v("\n                                Access to reports on an online dashboard\n                            ")]),_vm._v(" "),_c('li',{staticClass:"clearfix"},[_c('img',{attrs:{"src":"static/images/icon/blood-test.png","alt":""}}),_vm._v("\n                                Temperature controlled phlebotomy kit\n                            ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ignition"},[_c('div',{staticClass:"flex-container"},[_c('div',{staticStyle:{"background-color":"#8cc751"}},[_vm._v("Hygienic")]),_vm._v(" "),_c('div',{staticStyle:{"background-color":"#d7df21"}},[_vm._v("Convenient")]),_vm._v(" "),_c('div',{staticStyle:{"background-color":"#ffcb08"}},[_vm._v("Hygienic")])]),_vm._v(" "),_c('div',{staticClass:"ign-route"},[_c('h2',[_vm._v("How To Book")]),_vm._v(" "),_c('img',{attrs:{"src":"static/images/ignition.png","alt":""}})])])}]
var Public_ReferalSignup_esExports = { render: Public_ReferalSignup_render, staticRenderFns: Public_ReferalSignup_staticRenderFns }
/* harmony default export */ var components_mobile_Public_ReferalSignup = (Public_ReferalSignup_esExports);
// CONCATENATED MODULE: ./src/components/mobile/Public/ReferalSignup.vue
function Public_ReferalSignup_injectStyle (ssrContext) {
  __webpack_require__("22mO")
}
var Public_ReferalSignup_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var Public_ReferalSignup___vue_template_functional__ = false
/* styles */
var Public_ReferalSignup___vue_styles__ = Public_ReferalSignup_injectStyle
/* scopeId */
var Public_ReferalSignup___vue_scopeId__ = "data-v-21d5720b"
/* moduleIdentifier (server only) */
var Public_ReferalSignup___vue_module_identifier__ = null
var Public_ReferalSignup_Component = Public_ReferalSignup_normalizeComponent(
  mobile_Public_ReferalSignup,
  components_mobile_Public_ReferalSignup,
  Public_ReferalSignup___vue_template_functional__,
  Public_ReferalSignup___vue_styles__,
  Public_ReferalSignup___vue_scopeId__,
  Public_ReferalSignup___vue_module_identifier__
)

/* harmony default export */ var src_components_mobile_Public_ReferalSignup = (Public_ReferalSignup_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/Public/ReferalLogin.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



// import FooterVue from '@/components/mobile/Footer'


/* harmony default export */ var mobile_Public_ReferalLogin = ({
  name: 'ReferalLogin',
  components: {
    HeaderVue: mobile_Header["a" /* default */],
    Sidemenu: src_components_mobile_Public_Sidemenu
    // FooterVue
  },
  data: function data() {
    return {
      isDobError: false,
      otherSignup: false,
      loginWithoutBtn: false,
      login: {
        username: '',
        password: '',
        error: false,
        errormsg: '',
        otp_send: 1,
        login_otp: '',
        successmsg: ''
      },
      forgot: {
        username: '',
        otp: '',
        newPassword: '',
        confirmPassword: '',
        error: false,
        errormsg: '',
        success: 1,
        successmsg: '',
        otpType: ''
      },
      otp: {
        username: '',
        error: false,
        errormsg: '',
        success: false,
        successmsg: ''
      },
      signup: {
        email: '',
        mobile: '',
        name: '',
        password: '',
        referralCode: '',
        dob: undefined,
        sex: 'M',
        otp: '',
        error: false,
        errormsg: '',
        success: false,
        successmsg: '',
        dobYears: [],
        dobDate: [],
        year: '',
        month: '',
        ddate: ''
      },
      disabled: {
        from: new Date()
      },
      appointmentLogin: false,
      referralCodeDisable: false
    };
  },
  beforeCreate: function beforeCreate() {
    if (this.$localStorage.get('loggedIn') && this.$localStorage.get('loggedIn')) {
      console.log(this.$localStorage.get('loggedIn'));
      this.$router.push({ path: '/referral/invite' });
      // this.$router.push({ path: '/' })
    }
  },
  mounted: function mounted() {
    this.$hidePageLoading();
  },

  methods: {
    loginWithOtpChanged: function loginWithOtpChanged(resend) {
      var _this = this;

      if (this.login.username === '') {
        this.$refs.login_username.focus();
      }
      this.login.error = false;
      this.$validator.validateAll('login').then(function (result) {
        if (result) {
          if (_this.login.username !== '') {
            var data = {
              'mobile': _this.login.username
            };
            promise_default.a.resolve(_this.$POST('patient/sendOTP', data)).then(function (res) {
              if (res.response_code === 0) {
                this.login['otp_send'] = 2;
                this.login['error'] = false;
                this.login['errormsg'] = '';
                if (resend) {
                  this.login['successmsg'] = 'We have resend an OTP to your mobile number.';
                } else {
                  this.login['successmsg'] = 'We have send an OTP to your mobile number.';
                }

                this.login['login_otp'] = '';
                console.log(this.login);
              } else {
                this.login['otp_send'] = 1;
                this.login['error'] = true;
                this.login['errormsg'] = res.response_message;
                this.login['successmsg'] = '';
                this.login['login_otp'] = '';
              }
            }.bind(_this)).catch(function (err) {
              console.log('METHOD:forgetPassword', err);
            });
          }
        }
      });
    },
    loginClicked: function loginClicked() {
      this.login.error = false;
      if (this.login.login_with_otp) {
        this.loginWithOtpChanged();
      } else {
        this.logon();
      }
    },
    logon: function logon() {
      var _this2 = this;

      if (this.login.username === '') {
        this.$refs.login_username.focus();
      } else if (this.login.password === '') {
        this.$refs.login_password.focus();
      }
      this.login.error = false;
      this.$validator.validateAll('login').then(function (result) {
        if (result) {
          if (_this2.login.username !== '' && _this2.login.password !== '') {
            _this2.$logon(_this2.login.username, _this2.login.password).then(function (response) {
              if (response.error) {
                this.login.error = true;
                this.login.errormsg = response.error;
                return false;
              } else {
                vue_esm["default"].analytics.fbq.event('ViewContent', {
                  content_ids: 0,
                  content_name: 'LOGIN SUCCESS',
                  contents: '',
                  content_type: 'LOGIN_SUCCESS'
                });
                if (response.data && response.data.isFirst === 1) {
                  $('.login-box').modal('hide');
                  $('.forgot').modal('show');
                  this.forgot.error = false;
                  this.forgot.success = 3;
                  return false;
                }
                if (this.appointmentLogin) {
                  this.appointmentLogin = false;
                  this.$root.$emit('isLogin', true);
                  $('.login-box').modal('hide');
                  this.$router.push('/address');
                  return false;
                } else {
                  this.$root.$emit('isLogin', true);
                  this.$router.push({ path: '/referral/invite' });
                }
              }
            }.bind(_this2)).catch(function (err) {
              console.error(err);
            });
          }
        }
      });
    },
    verifyLoginOTP: function verifyLoginOTP() {
      var _this3 = this;

      if (this.login.login_otp === '') {
        this.$refs.login_otp.focus();
      }
      this.login.error = false;
      this.$validator.validateAll('login-wt-otp').then(function (result) {
        if (result) {
          if (_this3.login.username !== '' && _this3.login.login_otp !== '') {
            _this3.$verifyLoginOTP(_this3.login.username, _this3.login.login_otp).then(function (response) {
              console.log(response);
              if (response.error) {
                this.login.error = true;
                this.login.errormsg = 'Invalid OTP';
                this.login.successmsg = '';
                return false;
              } else {
                this.login.error = false;
                vue_esm["default"].analytics.fbq.event('ViewContent', {
                  content_ids: 0,
                  content_name: 'LOGIN SUCCESS',
                  contents: '',
                  content_type: 'LOGIN_SUCCESS'
                });
                if (response.data && response.data.isFirst === 1) {
                  $('.login-box').modal('hide');
                  $('.forgot').modal('show');
                  this.forgot.error = false;
                  this.forgot.success = 3;
                  return false;
                }
                if (this.appointmentLogin) {
                  this.appointmentLogin = false;
                  this.$root.$emit('isLogin', true);
                  $('.login-box').modal('hide');
                  this.$router.push('/address');
                  return false;
                } else {
                  this.$root.$emit('isLogin', true);
                  this.$router.push({ path: '/referral/invite' });
                }
                return false;
              }
            }.bind(_this3)).catch(function (err) {
              console.error(err);
            });
          }
        }
      });
    },
    clearFields: function clearFields(type) {
      this.login = {
        username: '',
        password: '',
        error: false,
        errormsg: '',
        otp_send: 1,
        login_otp: '',
        successmsg: ''
      }, this.forgot = {
        username: '',
        otp: '',
        newPassword: '',
        confirmPassword: '',
        error: false,
        errormsg: '',
        success: 1,
        successmsg: ''
      };
      setTimeout(function () {
        this.errors.items = [];
      }.bind(this), 200);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-06e2f3c6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/Public/ReferalLogin.vue
var Public_ReferalLogin_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"referalLoginDiv"}},[_c('HeaderVue',{attrs:{"isHeader":"true"}}),_vm._v(" "),_vm._m(0,false,false),_vm._v(" "),_c('header',{staticClass:"reg-header passon-header"}),_vm._v(" "),_c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"pass-on"},[_c('div',{staticClass:"inner-page1 reg-content"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_vm._m(1,false,false),_vm._v(" "),_c('div',{staticClass:"col-sm-5"},[_vm._m(2,false,false),_vm._v(" "),_c('div',{staticClass:"ref-form align-center"},[(_vm.login.error)?_c('p',{staticClass:"no-mar-top red-color fs-14"},[_vm._v(_vm._s(_vm.login.errormsg))]):_vm._e(),_vm._v(" "),(_vm.login.successmsg)?_c('p',{staticClass:"no-mar-top green-color fs-14"},[_vm._v(_vm._s(_vm.login.successmsg))]):_vm._e(),_vm._v(" "),_c('form',{directives:[{name:"show",rawName:"v-show",value:(_vm.login.otp_send === 1),expression:"login.otp_send === 1"}],attrs:{"data-vv-scope":"login"}},[(!_vm.login.login_with_otp)?_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.login.username),expression:"login.username"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],ref:"login_username",staticClass:"form-control",attrs:{"type":"text","name":"username","id":"username","data-vv-as":"email or mobile","placeholder":"Email or Mobile Number"},domProps:{"value":(_vm.login.username)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.login, "username", $event.target.value)}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('login.username')),expression:"errors.has('login.username')"}],staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('login.username')))])]):_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"mask",rawName:"v-mask",value:('##########'),expression:"'##########'"},{name:"model",rawName:"v-model",value:(_vm.login.username),expression:"login.username"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],ref:"login_username",staticClass:"form-control",attrs:{"type":"text","name":"username","id":"username","data-vv-as":"mobile","placeholder":"Mobile Number"},domProps:{"value":(_vm.login.username)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.login, "username", $event.target.value)}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('login.username')),expression:"errors.has('login.username')"}],staticClass:"text-danger"},[_vm._v("The mobile number field is required.")])]),_vm._v(" "),(!_vm.login.login_with_otp)?_c('div',{staticClass:"form-group  mb-2"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.login.password),expression:"login.password"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],ref:"login_password",staticClass:"form-control",attrs:{"type":"password","name":"password","id":"password","data-vv-as":"password","placeholder":"Password"},domProps:{"value":(_vm.login.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.login, "password", $event.target.value)}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('login.password')),expression:"errors.has('login.password')"}],staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('login.password')))])]):_c('div',{staticClass:"form-group  mb-2"},[_c('input',{staticClass:"form-control",attrs:{"type":"password","placeholder":"Password","disabled":""}})]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('a',{staticClass:"mb-3 text-center signup-link float-right display-block",attrs:{"data-dismiss":"modal","data-toggle":"modal","href":"#lost","data-target":".forgot","data-backdrop":"static","data-keyboard":"false"},on:{"click":function($event){_vm.clearFields()}}},[_vm._v("\n                                            Forgot Password?\n                                        ")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-12 mb-3"},[_c('label',{staticClass:"checkbox_container"},[_vm._v("Login With OTP?\n                                        "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.login.login_with_otp),expression:"login.login_with_otp"}],ref:"login_with_otp",attrs:{"type":"checkbox","name":"login_with_otp","id":"login_with_otp","data-vv-as":"login_with_otp"},domProps:{"checked":Array.isArray(_vm.login.login_with_otp)?_vm._i(_vm.login.login_with_otp,null)>-1:(_vm.login.login_with_otp)},on:{"change":function($event){var $$a=_vm.login.login_with_otp,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.login.login_with_otp=$$a.concat([$$v]))}else{$$i>-1&&(_vm.login.login_with_otp=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.$set(_vm.login, "login_with_otp", $$c)}}}}),_vm._v(" "),_c('span',{staticClass:"checkbox_checkmark"})])])]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary full-width",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();_vm.loginClicked()}}},[_vm._v(_vm._s(!_vm.login.login_with_otp ? 'Login' : 'Send OTP'))])]),_vm._v(" "),_c('form',{directives:[{name:"show",rawName:"v-show",value:(_vm.login.otp_send === 2),expression:"login.otp_send === 2"}],attrs:{"data-vv-scope":"login-wt-otp"}},[_c('div',{staticClass:"form-group  mb-2"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.login.login_otp),expression:"login.login_otp"},{name:"mask",rawName:"v-mask",value:('##########'),expression:"'##########'"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],ref:"login_otp",staticClass:"form-control",attrs:{"type":"text","name":"login_otp","id":"login_otp","maxlength":"6","data-vv-as":"OTP","placeholder":"Enter your OTP"},domProps:{"value":(_vm.login.login_otp)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.login, "login_otp", $event.target.value)}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('login-wt-otp.login_otp')),expression:"errors.has('login-wt-otp.login_otp')"}],staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('login-wt-otp.login_otp')))])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('a',{staticClass:"mb-3 text-center signup-link blue-color",on:{"click":function($event){_vm.clearFields()}}},[_vm._v("\n                                        Back to Login?\n                                    ")]),_vm._v(" "),_c('a',{staticClass:"mb-3 text-center signup-link float-right display-block resent_otp",on:{"click":function($event){_vm.loginWithOtpChanged(true)}}},[_vm._v("Resend OTP?")])])]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary full-width mar-b-15",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();_vm.verifyLoginOTP()}}},[_vm._v("Verify OTP")])])])])])])])])])],1)}
var Public_ReferalLogin_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading"},[_c('div',{staticClass:"loading-img"},[_c('img',{attrs:{"src":"static/images/walk.gif","alt":""}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-7"},[_c('h1',{staticClass:"red-color"},[_vm._v("It's time to pass on the goodness")]),_vm._v(" "),_c('p',[_vm._v("Thank you for being our esteemed customer. You know it’s convenient to get a home blood test\n                          done through Labotist. Now your friends and family can benefit too. We have made it easy\n                          for you to refer a friend to avail our home blood test services.")]),_vm._v(" "),_c('p',[_vm._v("\n                          You get a credit of INR.100 in your Labotist account when your friend books a blood test\n                          with us. Of course, we won't leave your friend behind! They get an instant credit of\n                          INR.150 as soon as they register with us!\n                      ")]),_vm._v(" "),_c('h3',[_vm._v("Steps to refer:")]),_vm._v(" "),_c('ul',[_c('li',{staticClass:"steps"},[_vm._v("\n                              Login using your Labotist login credentials\n                          ")]),_vm._v(" "),_c('li',{staticClass:"steps"},[_vm._v("\n                              You will see the message with referral link\n                          ")]),_vm._v(" "),_c('li',{staticClass:"steps"},[_vm._v("\n                              Share the message and link via your preferred mode - facebook, whatsapp, Instagram,\n                              email, etc\n                          ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row icon-thr"},[_c('div',{staticClass:"col-sm-1"}),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('img',{attrs:{"src":"static/images/Vector Smart Object1.png","alt":"","width":"50px"}}),_vm._v(" "),_c('h2',[_vm._v("login")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('img',{attrs:{"src":"static/images/document.png","alt":"","width":"50px"}}),_vm._v(" "),_c('h2',[_vm._v("Copy Referral message")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('img',{attrs:{"src":"static/images/share.png","alt":"","width":"50px"}}),_vm._v(" "),_c('h2',[_vm._v("Share with Friends")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-1"})])}]
var Public_ReferalLogin_esExports = { render: Public_ReferalLogin_render, staticRenderFns: Public_ReferalLogin_staticRenderFns }
/* harmony default export */ var components_mobile_Public_ReferalLogin = (Public_ReferalLogin_esExports);
// CONCATENATED MODULE: ./src/components/mobile/Public/ReferalLogin.vue
function Public_ReferalLogin_injectStyle (ssrContext) {
  __webpack_require__("o2nh")
}
var Public_ReferalLogin_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var Public_ReferalLogin___vue_template_functional__ = false
/* styles */
var Public_ReferalLogin___vue_styles__ = Public_ReferalLogin_injectStyle
/* scopeId */
var Public_ReferalLogin___vue_scopeId__ = "data-v-06e2f3c6"
/* moduleIdentifier (server only) */
var Public_ReferalLogin___vue_module_identifier__ = null
var Public_ReferalLogin_Component = Public_ReferalLogin_normalizeComponent(
  mobile_Public_ReferalLogin,
  components_mobile_Public_ReferalLogin,
  Public_ReferalLogin___vue_template_functional__,
  Public_ReferalLogin___vue_styles__,
  Public_ReferalLogin___vue_scopeId__,
  Public_ReferalLogin___vue_module_identifier__
)

/* harmony default export */ var src_components_mobile_Public_ReferalLogin = (Public_ReferalLogin_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/Public/ReferalInvite.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// import FooterVue from '@/components/mobile/Footer'


/* harmony default export */ var mobile_Public_ReferalInvite = ({
  name: 'ReferalLogin',
  components: {
    HeaderVue: mobile_Header["a" /* default */],
    Sidemenu: src_components_mobile_Public_Sidemenu
    // FooterVue
  },
  data: function data() {
    return {
      referralCode: '',
      referralUrl: 'https://labotist.com/',
      title: 'Labotist - Referral Program',
      quote: 'Hi, \r\n Here is the referral link to register with Labotist.com. They provide home blood test service and on registering you will get a credit of Rs 150 which you can use against your bookings with them, for blood test at home. \r\n   Labotists offers over 1000+ tests in partnership with 50 labs in Bengaluru and Chennai.\n ',
      description: 'Hi, \r\n Here is the referral link to register with Labotist.com. They provide home blood test service and on registering you will get a credit of Rs 150 which you can use against your bookings with them, for blood test at home. \r\n   Labotists offers over 1000+ tests in partnership with 50 labs in Bengaluru and Chennai.\n ',
      hashtags: 'homebloodtest, chennai, bengaluru',
      twitterUser: 'labotist',
      isWebViewIos: this.$IsWebViewIos
    };
  },
  beforeCreate: function beforeCreate() {},
  created: function created() {
    if (!this.$localStorage.get('loggedIn') || this.$localStorage.get('loggedIn') == null) {
      this.$router.push({ path: '/referral/login' });
    } else {
      this.getProfile();
    }
    this.isWebViewIos = this.$IsWebViewIos;
  },
  mounted: function mounted() {
    this.$hidePageLoading();
    $('input[data-toggle="tooltip"]').tooltip({
      animated: 'fade',
      placement: 'top',
      trigger: 'manual'
    });
  },

  methods: {
    shareLinkThroughWebbridge: function shareLinkThroughWebbridge(type) {
      var data = {
        title: this.title,
        description: this.description,
        quote: this.description,
        hashtags: this.hashtags,
        'twitter-user': this.twitterUser,
        url: this.referralUrl
      };
      switch (type) {
        case 1:
          if (this.$WebView && this.$WebViewBridge) {
            data['type'] = 'shareEmail';
            this.$WebViewBridge.send(stringify_default()(data));
          } else {
            console.log('Web bridge not found');
          }
          break;
        case 2:
          if (this.$WebView && this.$WebViewBridge) {
            data['type'] = 'shareFaceBook';
            this.$WebViewBridge.send(stringify_default()(data));
          } else {
            console.log('Web bridge not found');
          }
          break;
        case 3:
          if (this.$WebView && this.$WebViewBridge) {
            data['type'] = 'shareWhatsApp';
            this.$WebViewBridge.send(stringify_default()(data));
          } else {
            console.log('Web bridge not found');
          }
          break;
        case 4:
          if (this.$WebView && this.$WebViewBridge) {
            data['type'] = 'shareInstagram';
            this.$WebViewBridge.send(stringify_default()(data));
          } else {
            console.log('Web bridge not found');
          }
          break;
        default:
          console.log('Sorry something went wrong');
      }
    },

    getProfile: function getProfile() {
      try {
        if (this.$localStorage.get('loggedIn') && this.$localStorage.get('access_token') && this.$localStorage.get('access_token') !== null) {
          var data = {};
          promise_default.a.resolve(this.$GET('patient/getProfile', data)).then(function (res) {
            if (res.response_code === 0) {
              this.referralCode = res.response.Patient.referralCode;
              this.referralUrl = this.$signupUrl + this.$encryptString(res.response.Patient.referralCode);
            }
            this.$hidePageLoading();
          }.bind(this)).catch(function (err) {
            console.error(err);
          });
        }
      } catch (e) {
        console.error('method:getProfile', e);
      }
    },
    copyReferralCodeUrl: function copyReferralCodeUrl() {
      var referralUrl = document.getElementById('referralUrl');
      setTimeout(function () {
        referralUrl.setSelectionRange(0, referralUrl.value.length);
        document.execCommand("copy");
        $('input[data-toggle="tooltip"]').tooltip("show");
      }, 1);

      setTimeout(function () {
        $('input[data-toggle="tooltip"]').tooltip("hide");
      }, 1000);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f0a06108","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/Public/ReferalInvite.vue
var Public_ReferalInvite_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"referalInviteDiv"}},[_c('HeaderVue',{attrs:{"isHeader":"true"}}),_vm._v(" "),_vm._m(0,false,false),_vm._v(" "),_c('header',{staticClass:"reg-header passon-header"}),_vm._v(" "),_c('div',{staticClass:"wrapper "},[_c('div',{staticClass:"pass-on"},[_c('div',{staticClass:"inner-page1 reg-content"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_vm._m(1,false,false),_vm._v(" "),_c('div',{staticClass:"col-sm-5"},[_c('div',{staticClass:"ref-form align-center"},[_c('h1',[_vm._v("Refer Now")]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.referralCode),expression:"referralCode"}],staticClass:"form-control",attrs:{"type":"text","id":"referralCode","name":"referralCode","aria-describedby":"emailHelp","placeholder":"Referral Code","disabled":""},domProps:{"value":(_vm.referralCode)},on:{"input":function($event){if($event.target.composing){ return; }_vm.referralCode=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.description),expression:"description"}],staticClass:"form-control",attrs:{"name":"","cols":"30","rows":"10"},domProps:{"value":(_vm.description)},on:{"input":function($event){if($event.target.composing){ return; }_vm.description=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.referralUrl),expression:"referralUrl"}],ref:"copyReferralText",staticClass:"form-control",attrs:{"type":"text","id":"referralUrl","name":"referralUrl","aria-describedby":"emailHelp","data-toggle":"tooltip","data-placement":"top","title":"Copied","placeholder":"Link"},domProps:{"value":(_vm.referralUrl)},on:{"focus":function($event){_vm.copyReferralCodeUrl()},"click":function($event){_vm.copyReferralCodeUrl()},"input":function($event){if($event.target.composing){ return; }_vm.referralUrl=$event.target.value}}})]),_vm._v(" "),(!_vm.$WebView || !_vm.$WebViewBridge)?_c('social-sharing',{attrs:{"title":_vm.title,"description":_vm.description,"quote":_vm.description,"hashtags":_vm.hashtags,"twitter-user":_vm.twitterUser,"url":_vm.referralUrl},inlineTemplate:{render:function(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"share-btn text-right mt-3"},[_vm._v("\n                                        Share Via :\n                                        "),_c('network',{attrs:{"network":"email"}},[_c('i',{staticClass:"fa fa-envelope"})]),_vm._v(" "),_c('network',{attrs:{"network":"facebook"}},[_c('i',{staticClass:"fa fa-facebook-square"})]),_vm._v(" "),_c('network',{attrs:{"network":"whatsapp"}},[_c('i',{staticClass:"fa fa-whatsapp"})])],1)},staticRenderFns:[]}}):_c('div',{staticClass:"share-btn text-right mt-3"},[_vm._v("\n                                    Share Via :\n                                    "),_c('span',{on:{"click":function($event){_vm.shareLinkThroughWebbridge(1)}}},[_c('i',{staticClass:"fa fa-envelope"})]),_vm._v(" "),_c('span',{on:{"click":function($event){_vm.shareLinkThroughWebbridge(2)}}},[_c('i',{staticClass:"fa fa-facebook-square"})]),_vm._v(" "),_c('span',{on:{"click":function($event){_vm.shareLinkThroughWebbridge(3)}}},[_c('i',{staticClass:"fa fa-whatsapp"})])])],1)])])])])])])],1)}
var Public_ReferalInvite_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading"},[_c('div',{staticClass:"loading-img"},[_c('img',{attrs:{"src":"static/images/walk.gif","alt":""}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-7"},[_c('h1',{staticClass:"red-color"},[_vm._v("It's time to pass on the goodness")]),_vm._v(" "),_c('p',[_vm._v("Thank you for being our esteemed customer. You know it’s convenient to get a home blood test\n                                done through Labotist. Now your friends and family can benefit too. We have made it easy\n                                for you to refer a friend to avail our home blood test services.")]),_vm._v(" "),_c('p',[_vm._v("\n                                You get a credit of INR.100 in your Labotist account when your friend books a blood test\n                                with us. Of course, we won't leave your friend behind! They get an instant credit of\n                                INR.150 as soon as they register with us!\n                            ")]),_vm._v(" "),_c('h3',[_vm._v("Steps to refer:")]),_vm._v(" "),_c('ul',[_c('li',{staticClass:"steps"},[_vm._v("\n                                    Login using your Labotist login credentials\n                                ")]),_vm._v(" "),_c('li',{staticClass:"steps"},[_vm._v("\n                                    You will see the message with referral link\n                                ")]),_vm._v(" "),_c('li',{staticClass:"steps"},[_vm._v("\n                                    Share the message and link via your preferred mode - facebook, whatsapp, Instagram,\n                                    email, etc\n                                ")])])])}]
var Public_ReferalInvite_esExports = { render: Public_ReferalInvite_render, staticRenderFns: Public_ReferalInvite_staticRenderFns }
/* harmony default export */ var components_mobile_Public_ReferalInvite = (Public_ReferalInvite_esExports);
// CONCATENATED MODULE: ./src/components/mobile/Public/ReferalInvite.vue
function Public_ReferalInvite_injectStyle (ssrContext) {
  __webpack_require__("2WCr")
}
var Public_ReferalInvite_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var Public_ReferalInvite___vue_template_functional__ = false
/* styles */
var Public_ReferalInvite___vue_styles__ = Public_ReferalInvite_injectStyle
/* scopeId */
var Public_ReferalInvite___vue_scopeId__ = "data-v-f0a06108"
/* moduleIdentifier (server only) */
var Public_ReferalInvite___vue_module_identifier__ = null
var Public_ReferalInvite_Component = Public_ReferalInvite_normalizeComponent(
  mobile_Public_ReferalInvite,
  components_mobile_Public_ReferalInvite,
  Public_ReferalInvite___vue_template_functional__,
  Public_ReferalInvite___vue_styles__,
  Public_ReferalInvite___vue_scopeId__,
  Public_ReferalInvite___vue_module_identifier__
)

/* harmony default export */ var src_components_mobile_Public_ReferalInvite = (Public_ReferalInvite_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/Public/ReferralLanding.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import Vue from "vue";

// import FooterVue from "@/components/web/Footer";

/* harmony default export */ var mobile_Public_ReferralLanding = ({
    name: "ReferralLanding",
    components: {
        HeaderVue: mobile_Header["a" /* default */]
        // FooterVue
    },
    mounted: function mounted() {
        this.getProfile();
    },
    beforeCreate: function beforeCreate() {},
    created: function created() {
        // this.getProfile()
        setTimeout(function () {
            $('.slider').bxSlider({
                slideWidth: 'auto',
                minSlides: 1,
                maxSlides: 6,
                moveSlides: 6,
                slideMargin: 10,
                auto: true,
                autoControls: true
            });
            $("#carouselExampleControls").carousel();
            var footHeight = $('.fixed-footer').outerHeight();
            $('body').css('margin-bottom', footHeight);
        }, 100);
    },
    data: function data() {
        return {
            referralCode: '',
            referralUrl: 'https://labotist.com/',
            title: 'Labotist - Referral Program',
            quote: 'Hi, \r\n Here is the referral link to register with Labotist.com. They provide home blood test service and on registering you will get a credit of Rs 150 which you can use against your bookings with them, for blood test at home. \r\n   Labotists offers over 1000+ tests in partnership with 50 labs in Bengaluru and Chennai.',
            description: 'Hi,  \r\n  Here is the referral link to register with Labotist.com. They provide home blood test service and on registering you will get a credit of Rs 150 which you can use against your bookings with them, for blood test at home. \r\n   Labotists offers over 1000+ tests in partnership with 50 labs in Bengaluru and Chennai.',
            hashtags: 'Labotist,free blood sample collection,',
            twitterUser: 'Labotist.com'
        };
    },

    methods: {
        getProfile: function getProfile() {
            try {
                if (this.$localStorage.get('loggedIn') && this.$localStorage.get('access_token') && this.$localStorage.get('access_token') !== null) {
                    var data = {};
                    promise_default.a.resolve(this.$GET('patient/getProfile', data)).then(function (res) {
                        if (res.response_code === 0) {
                            if (res.response) {
                                underscore_default.a.each(res.response.Addresses, function (item) {
                                    if (item.isDefault === 1) {
                                        this.address = item.address;
                                    }
                                });
                            }
                            console.log("inside the process");
                            console.log(res.response);
                            this.firstName = res.response.Patient.firstName;
                            this.lastName = res.response.Patient.lastName;
                            this.email = res.response.email;
                            this.phone1 = res.response.Patient.phone1;
                            this.phone2 = res.response.Patient.phone2;
                            this.dob = res.response.Patient.dob ? res.response.Patient.dob : '';
                            this.sex = res.response.Patient.sex;
                            this.creditPoint = res.response.Patient.creditPoint;
                            this.referralCode = res.response.Patient.referralCode;
                            console.log(this.referralCode);
                            this.referralUrl = this.$signupUrl + this.$encryptString(this.referralCode);
                            this.credits = res.response.credits;
                        }
                        this.$hidePageLoading();
                    }.bind(this)).catch(function (err) {
                        console.error(err);
                    });
                }
            } catch (e) {
                console.error('method:getProfile', e);
            }
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-01d4a6bc","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/Public/ReferralLanding.vue
var Public_ReferralLanding_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"referalLandingDiv"}},[_c('HeaderVue',{attrs:{"isHeader":"true"}}),_vm._v(" "),_vm._m(0,false,false),_vm._v(" "),_c('div',{staticClass:"credit-section"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-4  cr-left"},[_c('h3',[_vm._v("Your Credit")]),_vm._v(" "),_c('h2',[_vm._v("Rs."+_vm._s(_vm.creditPoint))]),_vm._v(" "),_c('router-link',{attrs:{"to":"/lab"}},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"}},[_vm._v("USE NOW")])])],1),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('div',{staticClass:"cr-content"},[_c('h2',[_vm._v("Refer Now ")]),_vm._v(" "),_c('div',{staticClass:"cr-code"},[( this.referralCode)?_c('h5',[_vm._v(_vm._s(_vm.referralCode))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"cr-cod-con"},[_c('p',[_vm._v(_vm._s(_vm.description))])])])])])])]),_vm._v(" "),_c('div',{staticClass:"wraper-mob"},[_c('h2',[_c('router-link',{attrs:{"to":"/referral/invite"}},[_vm._v("Refer Now")])],1),_vm._v(" "),_vm._m(1,false,false)]),_vm._v(" "),_vm._m(2,false,false)],1)}
var Public_ReferralLanding_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading"},[_c('div',{staticClass:"loading-img"},[_c('img',{attrs:{"src":"static/images/walk.gif","alt":""}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"cr-mob"},[_c('div',{staticClass:"col-sm-12 "},[_c('a',{attrs:{"href":"/redirect/labs/Dengue_Profile"}},[_c('img',{attrs:{"src":"static/images/book-mob3.png","alt":""}})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-12 "},[_c('img',{attrs:{"src":"static/images/book-mob4.png","alt":""}})])]),_vm._v(" "),_c('div',{staticClass:"cr-mob"},[_c('div',{staticClass:"col-sm-12 "},[_c('a',{attrs:{"href":"/redirect/labs/Mega_Health_Checkup"}},[_c('img',{attrs:{"src":"static/images/book-mob1.png","alt":""}})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-12 "},[_c('img',{attrs:{"src":"static/images/book-mob2.png","alt":""}})])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"row mt-3"},[_c('div',{staticClass:"col-sm-12"},[_c('h2',{staticClass:"section-title text-center"},[_vm._v("Our Lab Partners")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"carousel slide",attrs:{"id":"carouselLabPartners","data-ride":"carousel"}},[_c('div',{staticClass:"carousel-inner"},[_c('div',{staticClass:"carousel-item active"},[_c('img',{staticClass:"d-block w-75 align-center",attrs:{"src":"static/images/client/medall.jpg","alt":"Medall Health Care Pvt Ltd"}})]),_vm._v(" "),_c('div',{staticClass:"carousel-item"},[_c('img',{staticClass:"d-block w-75 align-center",attrs:{"src":"static/images/client/metroplis.png","alt":"Lister Metropolis Healthcare Limited"}})]),_vm._v(" "),_c('div',{staticClass:"carousel-item"},[_c('img',{staticClass:"d-block w-75 align-center",attrs:{"src":"static/images/client/bioline.jpg","alt":"Bio Line Laboratory"}})]),_vm._v(" "),_c('div',{staticClass:"carousel-item"},[_c('img',{staticClass:"d-block w-75 align-center",attrs:{"src":"static/images/client/techmed.jpg","alt":"Techmed Health Centre & Diagnostic"}})]),_vm._v(" "),_c('div',{staticClass:"carousel-item"},[_c('img',{staticClass:"d-block w-75 align-center",attrs:{"src":"static/images/client/srl.png","alt":"Specialtys Medical Diagnostic(SRL Diagnostics)"}})]),_vm._v(" "),_c('div',{staticClass:"carousel-item"},[_c('img',{staticClass:"d-block w-75 align-center",attrs:{"src":"static/images/client/vrr.jpg","alt":"VRR Diagnostics"}})]),_vm._v(" "),_c('div',{staticClass:"carousel-item"},[_c('img',{staticClass:"d-block w-75 align-center",attrs:{"src":"static/images/client/medcis.png","alt":"Medcis Pathlabs India Pvt. Ltd"}})]),_vm._v(" "),_c('div',{staticClass:"carousel-item"},[_c('img',{staticClass:"d-block w-75 align-center",attrs:{"src":"static/images/client/pathcare.jpg","alt":"Path Care Labs Pvt. Ltd"}})]),_vm._v(" "),_c('div',{staticClass:"carousel-item"},[_c('img',{staticClass:"d-block w-75 align-center",attrs:{"src":"static/images/client/aarthi.jpg","alt":"Aarthi Scans And Labs"}})]),_vm._v(" "),_c('div',{staticClass:"carousel-item"},[_c('img',{staticClass:"d-block w-75 align-center",attrs:{"src":"static/images/client/primex.png","alt":"Primex Scans and Labs"}})]),_vm._v(" "),_c('div',{staticClass:"carousel-item"},[_c('img',{staticClass:"d-block w-75 align-center",attrs:{"src":"static/images/client/microbiological.jpg","alt":"Microbiological Laboratory"}})]),_vm._v(" "),_c('div',{staticClass:"carousel-item"},[_c('img',{staticClass:"d-block w-75 align-center",attrs:{"src":"static/images/client/hitech.jpg","alt":"Hitech Diagnostic Centre"}})]),_vm._v(" "),_c('div',{staticClass:"carousel-item"},[_c('img',{staticClass:"d-block w-75 align-center",attrs:{"src":"static/images/client/asian.jpg","alt":"Asian Diagnostics"}})]),_vm._v(" "),_c('div',{staticClass:"carousel-item"},[_c('img',{staticClass:"d-block w-75 align-center",attrs:{"src":"static/images/client/diagnolabs.jpg","alt":"Diagno labs Pvt Ltd"}})])]),_vm._v(" "),_c('a',{staticClass:"carousel-control-prev",attrs:{"href":"#carouselLabPartners","role":"button","data-slide":"prev"}},[_c('span',{staticClass:"carousel-control-prev-icon",attrs:{"aria-hidden":"true"}},[_c('i',{staticClass:"fa fa-angle-double-left"})]),_vm._v(" "),_c('span',{staticClass:"sr-only"},[_vm._v("Previous")])]),_vm._v(" "),_c('a',{staticClass:"carousel-control-next",attrs:{"href":"#carouselLabPartners","role":"button","data-slide":"next"}},[_c('span',{staticClass:"carousel-control-next-icon",attrs:{"aria-hidden":"true"}},[_c('i',{staticClass:"fa fa-angle-double-right"})]),_vm._v(" "),_c('span',{staticClass:"sr-only"},[_vm._v("Next")])])])])])])}]
var Public_ReferralLanding_esExports = { render: Public_ReferralLanding_render, staticRenderFns: Public_ReferralLanding_staticRenderFns }
/* harmony default export */ var components_mobile_Public_ReferralLanding = (Public_ReferralLanding_esExports);
// CONCATENATED MODULE: ./src/components/mobile/Public/ReferralLanding.vue
function Public_ReferralLanding_injectStyle (ssrContext) {
  __webpack_require__("ElPk")
}
var Public_ReferralLanding_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var Public_ReferralLanding___vue_template_functional__ = false
/* styles */
var Public_ReferralLanding___vue_styles__ = Public_ReferralLanding_injectStyle
/* scopeId */
var Public_ReferralLanding___vue_scopeId__ = "data-v-01d4a6bc"
/* moduleIdentifier (server only) */
var Public_ReferralLanding___vue_module_identifier__ = null
var Public_ReferralLanding_Component = Public_ReferralLanding_normalizeComponent(
  mobile_Public_ReferralLanding,
  components_mobile_Public_ReferralLanding,
  Public_ReferralLanding___vue_template_functional__,
  Public_ReferralLanding___vue_styles__,
  Public_ReferralLanding___vue_scopeId__,
  Public_ReferralLanding___vue_module_identifier__
)

/* harmony default export */ var src_components_mobile_Public_ReferralLanding = (Public_ReferralLanding_Component.exports);

// CONCATENATED MODULE: ./src/router/MobileRouter.js







// Public Components







// Secure Login Components





// Public Booking Components





// Secure Booking Components












/* harmony default export */ var MobileRouter = ({
  routes: [{
    path: '*',
    component: src_components_mobile_404,
    meta: {
      title: '404:Page Not Found - Labotist'
    }
  }, {
    path: '/',
    name: 'Home',
    components: { default: src_components_mobile_Home, 'HeaderVue': mobile_Header["a" /* default */], 'FooterVue': mobile_Footer["a" /* default */] },
    meta: {
      title: 'Home - Labotist',
      metaTags: [{
        name: 'description',
        content: 'Pick a test, Pick a Lab, Pick a time. We will take care of the rest. Hygienic and top notch home sample collection for free'
      }, {
        property: 'og:description',
        content: 'Pick a test, Pick a Lab, Pick a time. We will take care of the rest. Hygienic and top notch home sample collection for free'
      }]
    }
  }, {
    path: '/dashboard',
    name: 'Dashboard',
    component: src_components_mobile_Dashboard,
    meta: {
      title: 'Home - Labotist',
      metaTags: [{
        name: 'description',
        content: 'Pick a test, Pick a Lab, Pick a time. We will take care of the rest | Book Test or View Results'
      }, {
        property: 'og:description',
        content: 'Pick a test, Pick a Lab, Pick a time. We will take care of the rest | Book Test or View Results'
      }]
    }
  }, {
    path: '/login',
    name: 'Login',
    component: Login["a" /* default */],
    meta: {
      title: 'Login - Labotist',
      metaTags: [{
        name: 'description',
        content: 'Pick a test, Pick a Lab, Pick a time. We will take care of the rest. Hygienic and top notch home sample collection for free'
      }, {
        property: 'og:description',
        content: 'Pick a test, Pick a Lab, Pick a time. We will take care of the rest. Hygienic and top notch home sample collection for free'
      }]
    }
  }, {
    path: '/signup/:referralCode',
    name: 'Login',
    component: src_components_mobile_Home,
    meta: {
      title: 'Login - Labotist',
      metaTags: [{
        name: 'description',
        content: 'Pick a test, Pick a Lab, Pick a time. We will take care of the rest. Hygienic and top notch home sample collection for free'
      }, {
        property: 'og:description',
        content: 'Pick a test, Pick a Lab, Pick a time. We will take care of the rest. Hygienic and top notch home sample collection for free'
      }]
    }
  }, {
    path: '/about-us',
    name: 'Aboutus',
    component: src_components_mobile_Public_Aboutus,
    meta: {
      title: 'About Us - Labotist',
      metaTags: [{
        name: 'description',
        content: 'Top notch home sample collection service provider, technology driven, temperature controlled sample tracking & monitoring.'
      }, {
        property: 'og:description',
        content: 'Top notch home sample collection service provider, technology driven, temperature controlled sample tracking & monitoring.'
      }]
    }
  }, {
    path: '/contact-us',
    name: 'Contactus',
    component: src_components_mobile_Public_Contactus,
    meta: {
      title: 'Contact Us - Labotist',
      metaTags: [{
        name: 'description',
        content: 'Call us at 90256 62566 to book any lab test or learn more about services.'
      }, {
        property: 'og:description',
        content: 'Call us at 90256 62566 to book any lab test or learn more about services.'
      }]
    }
  }, {
    path: '/privacy-policy',
    name: 'Privacy',
    component: src_components_mobile_Public_Privacy,
    meta: {
      title: 'Privacy - Labotist',
      metaTags: [{
        name: 'description',
        content: 'Privacy policy and terms & conditions'
      }, {
        property: 'og:description',
        content: 'Privacy policy and terms & conditions'
      }]
    }
  }, {
    path: '/terms',
    name: 'Terms',
    component: src_components_mobile_Public_Terms,
    meta: {
      title: 'Terms - Labotist',
      metaTags: [{
        name: 'description',
        content: 'Privacy policy and terms & conditions'
      }, {
        property: 'og:description',
        content: 'Privacy policy and terms & conditions'
      }]
    }
  }, {
    path: '/lab-signup',
    name: 'Labsignup',
    component: src_components_mobile_Public_Labsignup,
    meta: {
      title: 'Lab Sign Up - Labotist',
      metaTags: [{
        name: 'description',
        content: 'Partner with us for home sample collection services while you focus on your core business. In addition Improve your brand visibility, reach and revenue. Reduce the headache and cost of managing phlebotomy operations.'
      }, {
        property: 'og:description',
        content: 'Partner with us for home sample collection services while you focus on your core business. In addition Improve your brand visibility, reach and revenue. Reduce the headache and cost of managing phlebotomy operations.'
      }]
    }
  }, {
    path: '/phlebotomist-signup',
    name: 'Phlebsignup',
    component: src_components_mobile_Public_Phlebsignup,
    meta: {
      title: 'Phlebotomist Sign Up - Labotist',
      metaTags: [{
        name: 'description',
        content: 'Partner with us full-time or part-time to earn more, work flexible hours and provide exceptional service to Patients. Become the experts through advanced training and use of technology.'
      }, {
        property: 'og:description',
        content: 'Partner with us full-time or part-time to earn more, work flexible hours and provide exceptional service to Patients. Become the experts through advanced training and use of technology.'
      }]
    }
  }, {
    path: '/myresult',
    name: 'MyResult',
    component: src_components_mobile_Secure_MyResult,
    meta: {
      title: 'My Result - Labotist',
      metaTags: [{
        name: 'description',
        content: 'View results from any labs, share it easily to your doctor or family member'
      }, {
        property: 'og:description',
        content: 'View results from any labs, share it easily to your doctor or family member'
      }]
    }
  }, {
    path: '/myprofile',
    name: 'MyProfile',
    component: src_components_mobile_Secure_MyProfile,
    meta: {
      title: 'My Profile - Labotist',
      metaTags: [{
        name: 'description',
        content: 'Complete your profile for timely service, accurate status notifications, reminders and customized packages. '
      }, {
        property: 'og:description',
        content: 'Complete your profile for timely service, accurate status notifications, reminders and customized packages. '
      }]
    }
  }, {
    path: '/editprofile',
    name: 'EditProfile',
    component: src_components_mobile_Secure_EditProfile,
    meta: {
      title: 'Edit Profile - Labotist',
      metaTags: [{
        name: 'description',
        content: 'Complete your profile for timely service, accurate status notifications, reminders and customized packages. '
      }, {
        property: 'og:description',
        content: 'Complete your profile for timely service, accurate status notifications, reminders and customized packages. '
      }]
    }
  }, {
    path: '/changepassword',
    name: 'ChangePassword',
    component: src_components_mobile_Secure_ChangePassword,
    meta: {
      title: 'Change Password - Labotist',
      metaTags: [{
        name: 'description',
        content: 'Complete your profile for timely service, accurate status notifications, reminders and customized packages. '
      }, {
        property: 'og:description',
        content: 'Complete your profile for timely service, accurate status notifications, reminders and customized packages. '
      }]
    }
  }, {
    path: '/test',
    name: 'Test',
    component: src_components_mobile_Book_Test,
    meta: {
      title: 'Find Your Test | Labotist',
      metaTags: [{
        name: 'description',
        content: 'Search for tests and pick your favorite lab in the city to get your blood test done. Free home sample collection.'
      }, {
        property: 'og:description',
        content: 'Search for tests and pick your favorite lab in the city to get your blood test done. Free home sample collection.'
      }]
    }
  }, {
    path: '/lab',
    name: 'Lab',
    component: src_components_mobile_Book_Lab,
    meta: {
      title: 'Choose Lab - Labotist',
      metaTags: [{
        name: 'description',
        content: 'Search for tests and pick your favorite lab in the city to get your blood test done. Free home sample collection.'
      }, {
        property: 'og:description',
        content: 'Search for tests and pick your favorite lab in the city to get your blood test done. Free home sample collection.'
      }]
    }
  }, {
    path: '/appointment',
    name: 'Appointment',
    component: src_components_mobile_Book_Appointment,
    meta: {
      title: 'Appointment Date|Time - Labotist',
      metaTags: [{
        name: 'description',
        content: 'Book a convenient date and time for home sample collection. Our trained phlebotomist will take care of the rest. '
      }, {
        property: 'og:description',
        content: 'Book a convenient date and time for home sample collection. Our trained phlebotomist will take care of the rest. '
      }]
    }
  }, {
    path: '/address',
    name: 'Address',
    component: src_components_mobile_Book_Secure_Address,
    meta: {
      title: 'Select Address - Labotist',
      metaTags: [{
        name: 'description',
        content: 'Choose a convenient location for sample collection. At home or at work. We will be there. '
      }, {
        property: 'og:description',
        content: 'Choose a convenient location for sample collection. At home or at work. We will be there. '
      }]
    }
  }, {
    path: '/payment',
    name: 'Payment',
    component: src_components_mobile_Book_Secure_Payment,
    meta: {
      title: 'Payment - Labotist',
      metaTags: [{
        name: 'description',
        content: 'Choose a convenient location for sample collection. At home or at work. Make payment and create an order.  '
      }, {
        property: 'og:description',
        content: 'Choose a convenient location for sample collection. At home or at work. Make payment and create an order.  '
      }]
    }
  }, {
    path: '/success',
    name: 'Success',
    component: src_components_mobile_Book_Secure_Success,
    meta: {
      title: 'Success - Labotist',
      metaTags: [{
        name: 'description',
        content: 'Thanks for placing order with Labotist.'
      }, {
        property: 'og:description',
        content: 'Thanks for placing order with Labotist.'
      }]
    },
    props: true
  }, {
    path: '/blog_iframe',
    name: 'BlogFrame',
    component: src_components_mobile_BlogFrame,
    meta: {
      title: 'Labotist'
    }
  }, {
    path: '/labs/:city/:test',
    name: 'LabLocation',
    component: src_components_mobile_Book_LabLocation,
    meta: {
      title: 'Choose Lab - Labotist',
      metaTags: [{
        name: 'description',
        content: ''
      }, {
        property: 'og:description',
        content: ''
      }]
    }
  }, {
    path: '/labs/:city/:test/:location',
    name: 'LabLocation',
    component: src_components_mobile_Book_LabLocation,
    meta: {
      title: 'Choose Lab - Labotist',
      metaTags: [{
        name: 'description',
        content: ''
      }, {
        property: 'og:description',
        content: ''
      }]
    }
  }, {
    path: '/redirect/:data',
    name: 'Redirect',
    component: src_components_mobile_Public_Redirect,
    meta: {
      title: 'Labotist'
    }
  }, {
    path: '/redirect/:data/url/:tests',
    name: 'Redirect',
    component: src_components_mobile_Public_Redirect,
    meta: {
      title: 'Labotist'
    }
  }, {
    path: '/redirect/labs/:testdata',
    name: 'LabRedirect',
    component: src_components_mobile_Public_LabRedirect,
    meta: {
      title: 'Choose Lab - Labotist'
    }
  }, {
    path: '/referral/signup',
    name: 'ReferalSignup',
    component: src_components_mobile_Public_ReferalSignup,
    meta: {
      title: 'Choose Lab - Labotist'
    }
  }, {
    path: '/referral/signup/:referal_code',
    name: 'ReferalSignup',
    component: src_components_mobile_Public_ReferalSignup,
    meta: {
      title: 'Choose Lab - Labotist'
    }
  }, {
    path: '/referral/login',
    name: 'ReferalLogin',
    component: src_components_mobile_Public_ReferalLogin,
    meta: {
      title: 'Choose Lab - Labotist'
    }
  }, {
    path: '/referral/invite',
    name: 'ReferalInvite',
    component: src_components_mobile_Public_ReferalInvite,
    meta: {
      title: 'Choose Lab - Labotist'
    }
  }, {
    path: '/referral/landing',
    name: 'ReferralLanding',
    component: src_components_mobile_Public_ReferralLanding,
    meta: {
      title: 'Choose Lab - Labotist'
    }
  }]
});
// EXTERNAL MODULE: ./src/config.js
var config = __webpack_require__("QmSG");

// CONCATENATED MODULE: ./src/router/index.js







vue_esm["default"].use(vue_router_esm["a" /* default */]);
var router = [];

if (config["a" /* default */].IsMobile) {
  router = MobileRouter.routes;
} else {
  router = WebRouter.routes;
}

/* harmony default export */ var src_router = (new vue_router_esm["a" /* default */]({
  mode: 'history',
  // base: __dirname,
  routes: router,
  scrollBehavior: function scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
  }
}));
// EXTERNAL MODULE: ./src/webservice.js
var webservice = __webpack_require__("AYSK");

// CONCATENATED MODULE: ./src/util.js


var Cryptr = __webpack_require__("tk5M");
var cryptr = new Cryptr('lAbSeCrEtDaTaEnCrYpT');

vue_esm["default"].prototype.$encryptString = function (data) {
  return cryptr.encrypt(data);
};

vue_esm["default"].prototype.$decryptString = function (data) {
  return cryptr.decrypt(data);
};
// EXTERNAL MODULE: ./node_modules/vue2-simplert-plugin/dist/vue2-simplert-plugin.js
var vue2_simplert_plugin = __webpack_require__("+mr5");
var vue2_simplert_plugin_default = /*#__PURE__*/__webpack_require__.n(vue2_simplert_plugin);

// EXTERNAL MODULE: ./node_modules/vue-analytics/dist/vue-analytics.js
var vue_analytics = __webpack_require__("AYPi");
var vue_analytics_default = /*#__PURE__*/__webpack_require__.n(vue_analytics);

// EXTERNAL MODULE: ./node_modules/vue-analytics-facebook-pixel/dist/vue-analytics-facebook-pixel.js
var vue_analytics_facebook_pixel = __webpack_require__("zG4D");
var vue_analytics_facebook_pixel_default = /*#__PURE__*/__webpack_require__.n(vue_analytics_facebook_pixel);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/Internet.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var Internet = ({
  name: 'PageNotFound',
  components: {
    HeaderVue: Header["a" /* default */],
    FooterVue: Footer["a" /* default */]
  },
  data: function data() {
    return {};
  },
  beforeCreate: function beforeCreate() {},
  mounted: function mounted() {
    this.$hidePageLoading();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4aa5a89b","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/Internet.vue
var Internet_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0,false,false)}
var Internet_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"section"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"text-center noInternet"},[_c('img',{attrs:{"src":"static/images/noInternet.png","alt":""}}),_vm._v(" "),_c('h2',{staticClass:"red-color"},[_vm._v("Oops!")]),_vm._v(" "),_c('p',{staticClass:"theme-lineheight"},[_vm._v("\n                          No Internet connection found. Check your connection or try again.\n                        ")])])])])])])])}]
var Internet_esExports = { render: Internet_render, staticRenderFns: Internet_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_Internet = (Internet_esExports);
// CONCATENATED MODULE: ./src/Internet.vue
function Internet_injectStyle (ssrContext) {
  __webpack_require__("ZzA+")
}
var Internet_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var Internet___vue_template_functional__ = false
/* styles */
var Internet___vue_styles__ = Internet_injectStyle
/* scopeId */
var Internet___vue_scopeId__ = "data-v-4aa5a89b"
/* moduleIdentifier (server only) */
var Internet___vue_module_identifier__ = null
var Internet_Component = Internet_normalizeComponent(
  Internet,
  selectortype_template_index_0_src_Internet,
  Internet___vue_template_functional__,
  Internet___vue_styles__,
  Internet___vue_scopeId__,
  Internet___vue_module_identifier__
)

/* harmony default export */ var src_Internet = (Internet_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




if (config["a" /* default */].IsMobile) {
  __webpack_require__("b1zr");
} else {
  __webpack_require__("qv8e");
}
/* harmony default export */ var App = ({
  name: 'app',
  data: function data() {
    return {
      msg: 'Welcome to Your Vue.js App',
      isInternet: true
    };
  },
  beforeCreate: function beforeCreate() {},
  mounted: function mounted() {
    var _this = this;

    window.addEventListener('offline', function (event) {
      this.isInternet = false;
    }.bind(this));
    window.addEventListener('online', function (event) {
      this.isInternet = true;
    }.bind(this));
    var i = 0;
    var j = false;
    var tmt = setInterval(function () {
      if (this.$WebViewBridge && !j) {
        this.$WebViewBridge.onMessage = function (data) {
          var response = JSON.parse(data);
          if (response.type === 'paymentSuccess') {
            this.$root.$emit('paymentSuccess', response.data);
          }
          j = true;
          clearInterval(tmt);
        }.bind(this);
      }
      if (i > 31) {
        clearInterval(tmt);
      }
      i++;
    }.bind(this), 1000);

    this.$root.$on('isOffline', function (bookTest) {
      _this.isInternet = false;
    });
  },
  created: function created() {
    // if(!this.$localStorage.get('cookieAlert')) {
    //   setTimeout(function () {
    //     $('.use-cookies').css('bottom', '0%');
    //     this.$localStorage.set('cookieAlert', true, 1000*60*24)
    //   }.bind(this), 3000);
    // }
  },

  components: {
    Internet: src_Internet
  },
  methods: {
    closeCookieAlert: function closeCookieAlert() {
      $('.use-cookies').css('bottom', '-100%');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-537c7bb7","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var App_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('simplert'),_vm._v(" "),_c('router-view',{directives:[{name:"show",rawName:"v-show",value:(_vm.isInternet),expression:"isInternet"}]}),_vm._v(" "),_c('Internet',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isInternet),expression:"!isInternet"}]}),_vm._v(" "),_c('div',{staticClass:"use-cookies"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_vm._m(0,false,false),_vm._v(" "),_c('div',{staticClass:"col-sm-4 text-center"},[_c('button',{staticClass:"btn btn-primary cookies-btn",on:{"click":function($event){_vm.closeCookieAlert()}}},[_vm._v("Ok")])])])])])],1)}
var App_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-8"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-4"},[_c('img',{staticClass:"img-fluid mt-4",attrs:{"src":"static/images/logo-svg.svg","alt":""}})]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('h5',[_vm._v("This website uses cookies")]),_vm._v(" "),_c('p',[_vm._v("We use cookies to personalize content and ads, to provide social media features and to analyze\n                                our traffic. You consent to our cookies if you continue to use our website. ")])])])])}]
var App_esExports = { render: App_render, staticRenderFns: App_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (App_esExports);
// CONCATENATED MODULE: ./src/App.vue
function App_injectStyle (ssrContext) {
  __webpack_require__("chxB")
}
var App_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var App___vue_template_functional__ = false
/* styles */
var App___vue_styles__ = App_injectStyle
/* scopeId */
var App___vue_scopeId__ = "data-v-537c7bb7"
/* moduleIdentifier (server only) */
var App___vue_module_identifier__ = null
var App_Component = App_normalizeComponent(
  App,
  selectortype_template_index_0_src_App,
  App___vue_template_functional__,
  App___vue_styles__,
  App___vue_scopeId__,
  App___vue_module_identifier__
)

/* harmony default export */ var src_App = (App_Component.exports);

// EXTERNAL MODULE: ./node_modules/v-mask/dist/v-mask.esm.js
var v_mask_esm = __webpack_require__("1I9z");

// CONCATENATED MODULE: ./src/main.js





















var SocialSharing = __webpack_require__("VK1f");

vue_esm["default"].use(SocialSharing);

vue_esm["default"].use(v_mask_esm["a" /* default */]);

vue_esm["default"].config.productionTip = true;

vue_esm["default"].use(vue_cookie_default.a);
vue_esm["default"].use(dist_default.a);
vue_esm["default"].use(vee_validate_esm["a" /* default */]);
vue_esm["default"].use(vue2_filters_default.a);
vue_esm["default"].use(config["a" /* default */]);
vue_esm["default"].use(webservice["a" /* default */]);
vue_esm["default"].use(vue2_simplert_plugin_default.a);

if (location.hostname === 'labotist.com') {
  vue_esm["default"].use(vue_analytics_default.a, {
    id: 'UA-110171773-1',
    router: src_router
  });
} else if (location.hostname === 'stage.labotist.com') {
  vue_esm["default"].use(vue_analytics_default.a, {
    id: 'UA-118689077-1',
    router: src_router
  });
} else if (location.hostname === 'dev.labotist.com') {
  vue_esm["default"].use(vue_analytics_default.a, {
    id: 'UA-118672795-1',
    router: src_router
  });
}
vue_esm["default"].use(vue_analytics_facebook_pixel_default.a);
// Vue.analytics.fbq.init('162958627765177',{
//   em: 'kabildev12@gmail.com'
// })

src_router.beforeEach(function (to, from, next) {

  var nearestWithTitle = to.matched.slice().reverse().find(function (r) {
    return r.meta && r.meta.title;
  });

  var nearestWithMeta = to.matched.slice().reverse().find(function (r) {
    return r.meta && r.meta.metaTags;
  });
  var previousNearestWithMeta = from.matched.slice().reverse().find(function (r) {
    return r.meta && r.meta.metaTags;
  });

  if (nearestWithTitle) document.title = nearestWithTitle.meta.title;

  from_default()(document.querySelectorAll('[data-vue-router-controlled]')).map(function (el) {
    return el.parentNode.removeChild(el);
  });

  if (!nearestWithMeta) return next();

  nearestWithMeta.meta.metaTags.map(function (tagDef) {
    var tag = document.createElement('meta');

    keys_default()(tagDef).forEach(function (key) {
      tag.setAttribute(key, tagDef[key]);
    });

    tag.setAttribute('data-vue-router-controlled', '');

    return tag;
  }).forEach(function (tag) {
    return document.head.appendChild(tag);
  });

  next();
});
var LoadingComponent = config["a" /* default */].IsMobile ? { template: '<div class="loading">\n            <div class="loading-img">\n                <img src="static/images/icon/loading.gif" alt="">\n            </div>\n        </div>' } : { template: '<div class="loading">\n            <div class="loading-img">\n                <img src="static/images/walk.gif" alt="">\n            </div>\n        </div>' };
var main_AsyncApp = function AsyncApp() {
  return {
    component: new promise_default.a(function (resolve) {
      setTimeout(function () {
        resolve(src_App);
      }, 1000);
    }),
    loading: LoadingComponent
  };
};
/* harmony default export */ var main = __webpack_exports__["default"] = (new vue_esm["default"]({
  el: '#app',
  router: src_router,
  template: '<App/>',
  components: {
    'App': main_AsyncApp
  },
  beforeCreate: function beforeCreate() {
    var _this = this;

    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
      return regenerator_default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.$clientToken().then(function () {
                this.$root.$emit('isLogin', true);
              }.bind(_this));

            case 2:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
}));

/***/ }),

/***/ "NNgi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NVx5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NmNP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "QDfD":
/***/ (function(module, exports) {

module.exports = {"1.3.132.0.10":"secp256k1","1.3.132.0.33":"p224","1.2.840.10045.3.1.1":"p192","1.2.840.10045.3.1.7":"p256","1.3.132.0.34":"p384","1.3.132.0.35":"p521"}

/***/ }),

/***/ "QHB8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/promise.js
var promise = __webpack_require__("//Fk");
var promise_default = /*#__PURE__*/__webpack_require__.n(promise);

// EXTERNAL MODULE: ./node_modules/vuejs-datepicker/dist/build.js
var build = __webpack_require__("XILU");
var build_default = /*#__PURE__*/__webpack_require__.n(build);

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/Login.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var Login = ({
  name: 'Login',
  components: {
    Datepicker: build_default.a
  },
  data: function data() {
    return {
      isDobError: false,
      otherSignup: false,
      loginWithoutBtn: false,
      login: {
        username: '',
        password: '',
        error: false,
        errormsg: '',
        otp_send: 1,
        login_otp: '',
        successmsg: ''
      },
      forgot: {
        username: '',
        otp: '',
        newPassword: '',
        confirmPassword: '',
        error: false,
        errormsg: '',
        success: 1,
        successmsg: '',
        otpType: ''
      },
      otp: {
        username: '',
        error: false,
        errormsg: '',
        success: false,
        successmsg: ''
      },
      signup: {
        email: '',
        mobile: '',
        name: '',
        password: '',
        referralCode: this.$localStorage.get('ref_code') ? this.$localStorage.get('ref_code') : '',
        dob: undefined,
        sex: 'M',
        otp: '',
        error: false,
        errormsg: '',
        success: false,
        successmsg: '',
        dobYears: [],
        dobDate: [],
        year: '',
        month: '',
        ddate: ''
      },
      disabled: {
        from: new Date()
      },
      appointmentLogin: false,
      referralCodeDisable: false
    };
  },
  beforeCreate: function beforeCreate() {
    this.appointmentLogin = false;
  },
  created: function created() {
    if (this.$route.params.referralCode) {
      this.signup.referralCode = this.$route.params.referralCode.toUpperCase();
      setTimeout(function () {
        $('.signup').modal('show');
        this.referralCodeDisable = true;
      }.bind(this), 1000);
    }
    if (this.$route.fullPath === '/login') {
      if (this.$localStorage.get('profile') && this.$localStorage.get('profile') !== null) {
        this.$router.push({ path: '/dashboard' });
        return false;
      }
      setTimeout(function () {
        $('.login-box').modal('show');
      }, 1000);
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.$root.$on('appointmentLogin', function (isAppointment) {
      _this.appointmentLogin = true;
    });
    this.$root.$on('loginClicked', function (isAppointment) {
      _this.errors.items = [];
      _this.appointmentLogin = false;
      _this.myresultLogin = false;
      _this.myprofileLogin = false;
      $('.login-box').modal('show');
    });
    this.$root.$on('myresultLogin', function (isAppointment) {
      _this.myresultLogin = true;
      _this.myprofileLogin = false;
      $('.login-box').modal('show');
    });
    this.$root.$on('myprofileLogin', function (isAppointment) {
      _this.myprofileLogin = true;
      _this.myresultLogin = false;
      $('.login-box').modal('show');
    });
  },
  watch: {
    'signup.referralCode': function signupReferralCode() {
      this.signup.referralCode = this.signup.referralCode.toUpperCase();
    }
  },
  methods: {
    loginWithOtpChanged: function loginWithOtpChanged(resend) {
      var _this2 = this;

      if (this.login.username === '') {
        this.$refs.login_username.focus();
      }
      this.login.error = false;
      this.$validator.validateAll('login').then(function (result) {
        if (result) {
          if (_this2.login.username !== '') {
            var data = {
              'mobile': _this2.login.username
            };
            promise_default.a.resolve(_this2.$POST('patient/sendOTP', data)).then(function (res) {
              if (res.response_code === 0) {
                this.login['otp_send'] = 2;
                this.login['error'] = false;
                this.login['errormsg'] = '';
                if (resend) {
                  this.login['successmsg'] = 'We have resend an OTP to your mobile number.';
                } else {
                  this.login['successmsg'] = 'We have send an OTP to your mobile number.';
                }

                this.login['login_otp'] = '';
                console.log(this.login);
              } else {
                this.login['otp_send'] = 1;
                this.login['error'] = true;
                this.login['errormsg'] = res.response_message;
                this.login['successmsg'] = '';
                this.login['login_otp'] = '';
              }
            }.bind(_this2)).catch(function (err) {
              console.log('METHOD:forgetPassword', err);
            });
          }
        }
      });
    },
    verifyLoginOTP: function verifyLoginOTP() {
      var _this3 = this;

      if (this.login.login_otp === '') {
        this.$refs.login_otp.focus();
      }
      this.login.error = false;
      this.$validator.validateAll('login-wt-otp').then(function (result) {
        if (result) {
          if (_this3.login.username !== '' && _this3.login.login_otp !== '') {
            _this3.$verifyLoginOTP(_this3.login.username, _this3.login.login_otp).then(function (response) {
              console.log(response);
              if (response.error) {
                this.login.error = true;
                this.login.errormsg = 'Invalid OTP';
                this.login.successmsg = '';
                return false;
              } else {
                this.login.error = false;
                vue_esm["default"].analytics.fbq.event('ViewContent', {
                  content_ids: 0,
                  content_name: 'LOGIN SUCCESS',
                  contents: '',
                  content_type: 'LOGIN_SUCCESS'
                });
                if (response.data && response.data.isFirst === 1) {
                  $('.login-box').modal('hide');
                  $('.forgot').modal('show');
                  this.forgot.error = false;
                  this.forgot.success = 3;
                  return false;
                }
                if (this.appointmentLogin) {
                  this.appointmentLogin = false;
                  this.$root.$emit('isLogin', true);
                  $('.login-box').modal('hide');
                  this.$router.push('/address');
                  return false;
                } else {
                  this.$root.$emit('isLogin', true);
                  $('.login-box').modal('hide');
                  if (this.$route.fullPath === '/login' || this.$route.fullPath === '/') {
                    this.$router.push({ path: '/myresult' });
                  }
                }
                return false;
              }
            }.bind(_this3)).catch(function (err) {
              console.error(err);
            });
          }
        }
      });
    },
    closePopup: function closePopup(value) {
      if (this.$route.fullPath === '/login') {
        this.$router.push({ path: '/' });
      }
    },
    getNumberOfDays: function getNumberOfDays() {
      if (this.signup.year && this.signup.year !== '' && this.signup.month && this.signup.month !== '') {
        var noOfDays = new Date(this.signup.year, this.signup.month, 0).getDate();
        var dobDate = [];
        for (var j = 1; j <= noOfDays; j++) {
          dobDate.push(j.toString());
        }
        this.signup['dobDate'] = dobDate;

        if (this.signup.ddate) {
          var res = true;
          dobDate.forEach(function (dataV) {
            if (parseInt(dataV) === parseInt(this.signup.ddate)) {
              res = false;
            }
          }.bind(this));
          if (res) {
            this.signup.ddate = '';
          }
        }
      }
      return false;
    },
    loginClicked: function loginClicked() {
      this.login.error = false;
      if (this.login.login_with_otp) {
        this.loginWithOtpChanged();
      } else {
        this.logon();
      }
    },
    logon: function logon() {
      var _this4 = this;

      if (this.login.username === '') {
        this.$refs.login_username.focus();
      } else if (this.login.password === '') {
        this.$refs.login_password.focus();
      }
      this.login.error = false;
      this.$validator.validateAll('login').then(function (result) {
        if (result) {
          if (_this4.login.username !== '' && _this4.login.password !== '') {
            _this4.$logon(_this4.login.username, _this4.login.password).then(function (response) {
              if (response.error) {
                this.login.error = true;
                this.login.errormsg = response.error;
                return false;
              } else {
                vue_esm["default"].analytics.fbq.event('ViewContent', {
                  content_ids: 0,
                  content_name: 'LOGIN SUCCESS',
                  contents: '',
                  content_type: 'LOGIN_SUCCESS'
                });
                if (response.data && response.data.isFirst == 1) {
                  $('.login-box').modal('hide');
                  $('.forgot').modal('show');
                  this.forgot.error = false;
                  this.forgot.success = 3;
                  return false;
                }
                if (this.appointmentLogin) {
                  this.appointmentLogin = false;
                  this.$root.$emit('isLogin', true);
                  $('.login-box').modal('hide');
                  this.$router.push('/address');
                  // location.reload()
                  return false;
                } else if (this.myprofileLogin) {
                  this.myprofileLogin = false;
                  this.$root.$emit('isLogin', true);
                  $('.login-box').modal('hide');
                  this.$router.push('/myprofile');
                  // location.reload()
                  return false;
                } else if (this.myresultLogin) {
                  this.myresultLogin = false;
                  this.$root.$emit('isLogin', true);
                  $('.login-box').modal('hide');
                  this.$router.push('/myresult');
                  // location.reload()
                  return false;
                } else {
                  this.$root.$emit('isLogin', true);
                  $('.login-box').modal('hide');
                  if (this.$route.fullPath === '/login' || this.$route.fullPath === '/') {
                    // this.$router.push({ path: '/myresult' })
                    this.$router.push({ path: '/dashboard' });
                  }
                  // location.reload()
                }
              }
            }.bind(_this4)).catch(function (err) {
              console.error(err);
            });
          }
        }
      });
    },
    forgetPassword: function forgetPassword() {
      var _this5 = this;

      this.forgot.error = false;
      this.$validator.validateAll('forgot').then(function (result) {
        if (result) {
          try {
            if (_this5.forgot.username !== '') {
              var data = {};
              if (_this5.forgot.otpType == 2) {
                data = {
                  mobile: _this5.forgot.username,
                  otpType: _this5.forgot.otpType
                };
              } else {
                data = {
                  email: _this5.forgot.username,
                  otpType: _this5.forgot.otpType
                };
              }
              promise_default.a.resolve(_this5.$POST('patient/forgetPassword', data)).then(function (res) {
                if (res.response_code === 0) {
                  this.forgot.error = false;
                  this.forgot.errormsg = '';
                  this.forgot.success = 2;
                  if (this.forgot.otpType == 2) {
                    this.forgot.successmsg = 'We have send an OTP to your mobile number.';
                  } else {
                    this.forgot.successmsg = 'We have send an authentication code to your mail id.';
                  }
                } else {
                  this.forgot.success = 1;
                  this.forgot.error = true;
                  this.forgot.errormsg = res.response_message;
                  this.forgot.otp = '';
                }
              }.bind(_this5)).catch(function (err) {
                console.log('METHOD:forgetPassword', err);
              });
            }
          } catch (e) {
            console.error(e);
          }
        }
      });
    },
    verify_otp: function verify_otp() {
      var _this6 = this;

      this.$validator.validateAll('forgotOtp').then(function (result) {
        if (result) {
          if (_this6.forgot.otpType == 2) {
            if (_this6.forgot.username !== '' && _this6.forgot.otp !== '') {
              _this6.$verifyLoginOTP(_this6.forgot.username, _this6.forgot.otp).then(function (response) {
                if (response.error) {
                  this.forgot.error = true;
                  this.forgot.errormsg = 'Invalid OTP';
                  this.forgot.successmsg = '';
                  return false;
                } else {
                  this.forgot.error = false;
                  this.forgot.success = 3;
                  return false;
                }
              }.bind(_this6)).catch(function (err) {
                console.error(err);
              });
            }
          } else {
            if (_this6.forgot.username !== '' && _this6.forgot.otp !== '') {
              _this6.$verifyOTP(_this6.forgot.username, _this6.forgot.otp).then(function (response) {
                if (response.error) {
                  this.forgot.error = true;
                  this.forgot.errormsg = 'Invalid OTP';
                  this.forgot.successmsg = '';
                  return false;
                } else {
                  this.forgot.error = false;
                  this.forgot.success = 3;
                  return false;
                }
              }.bind(_this6)).catch(function (err) {
                console.error(err);
              });
            }
          }
        }
      });
    },
    reset_password: function reset_password() {
      var _this7 = this;

      if (this.forgot.newPassword !== this.forgot.confirmPassword) {
        return false;
      }
      this.$validator.validateAll('resetPassword').then(function (result) {
        if (result) {
          if (_this7.forgot.newPassword !== '' && _this7.forgot.confirmPassword !== '') {
            _this7.$resetPassword(_this7.forgot.newPassword).then(function (response) {
              if (response.error) {
                this.forgot.error = true;
                this.forgot.errormsg = 'Invalid User';
                this.forgot.successmsg = '';
                return false;
              } else {
                if (this.$route.fullPath === '/referral/login') {
                  $('.forgot').modal('hide');
                  this.$router.push('/referral/invite');
                  return false;
                }
                if (this.appointmentLogin) {
                  this.appointmentLogin = false;
                  this.$root.$emit('isLogin', true);
                  $('.forgot').modal('hide');
                  this.$router.push('/address');
                  // location.reload()
                  return false;
                } else if (this.myprofileLogin) {
                  this.myprofileLogin = false;
                  this.$root.$emit('isLogin', true);
                  $('.forgot').modal('hide');
                  this.$router.push('/myprofile');
                  // location.reload()
                  return false;
                } else if (this.myresultLogin) {
                  this.myresultLogin = false;
                  this.$root.$emit('isLogin', true);
                  $('.forgot').modal('hide');
                  this.$router.push('/myresult');
                  // location.reload()
                  return false;
                } else {
                  this.$root.$emit('isLogin', true);
                  $('.forgot').modal('hide');
                  return false;
                  // location.reload()
                }
              }
            }.bind(_this7)).catch(function (err) {
              console.error(err);
            });
          }
        }
      });
    },
    resend: function resend() {
      try {
        if (this.forgot.username !== '') {
          var data = {
            'email': this.forgot.username,
            otpType: this.forgot.otpType
          };
          promise_default.a.resolve(this.$POST('patient/resendOTP', data)).then(function (res) {
            if (res.response_code === 0) {
              this.forgot.error = false;
              this.forgot.errormsg = '';
              this.forgot.success = 2;
              if (this.forgot.otpType == 2) {
                this.forgot.successmsg = 'We have resend an OTP to your mobile number.';
              } else {
                this.forgot.successmsg = 'We have resend an authentication code to your mail id.';
              }
            } else {
              this.forgot.success = 1;
              this.forgot.error = true;
              this.forgot.errormsg = res.response_message;
              this.forgot.otp = '';
            }
          }.bind(this)).catch(function (err) {
            console.log('METHOD:forgetPassword', err);
          });
        }
      } catch (e) {
        console.error(e);
      }
    },
    clearFields: function clearFields(type) {
      if (type === 1) {
        vue_esm["default"].analytics.fbq.event('ViewContent', {
          content_ids: 0,
          content_name: 'SIGN UP CLICKED',
          contents: '',
          content_type: 'SIGNUP_CLICK'
        });
      }
      this.isDobError = false;
      this.signup = {
        email: '',
        mobile: '',
        name: '',
        password: '',
        referralCode: this.$localStorage.get('ref_code') ? this.$decryptString(this.$localStorage.get('ref_code')) : '',
        dob: undefined,
        sex: 'M',
        otp: '',
        error: false,
        errormsg: '',
        success: false,
        successmsg: '',
        dobYears: [],
        dobDate: [],
        year: '',
        month: '',
        ddate: ''
      };
      this.referralCodeDisable = false;
      this.login = {
        username: '',
        password: '',
        error: false,
        errormsg: '',
        otp_send: 1,
        login_otp: '',
        successmsg: ''
      }, this.forgot = {
        username: '',
        otp: '',
        newPassword: '',
        confirmPassword: '',
        error: false,
        errormsg: '',
        success: 1,
        successmsg: ''
      };
      var year = new Date().getFullYear();
      var endYear = year - 120;
      var dobYears = [];
      for (var i = year; i > endYear; i--) {
        dobYears.push(i.toString());
      }
      this.signup['dobYears'] = dobYears;

      setTimeout(function () {
        this.errors.items = [];
      }.bind(this), 200);
      setTimeout(function () {
        document.body.classList.add("modal-open");
      }, 1000);
    },
    create_account: function create_account() {
      this.isDobError = false;
      this.signup.error = false;
      this.$validator.validateAll('signup').then(function (result) {
        if (result) {
          // if(this.signup.year.length !== 4 || this.signup.month.length <= 0 || this.signup.ddate.length <= 0){
          //   this.isDobError = true
          //   return false
          // }
          try {
            if (this.signup.email !== '' && this.signup.mobile !== '' && this.signup.firstName !== '' && this.signup.password !== '') {
              var params = {
                'firstName': this.signup.firstName,
                // 'lastName': this.signup.lastName,
                'lastName': '',
                'phone1': this.signup.mobile,
                'email': this.signup.email,
                'password': this.signup.password,
                'referralCode': this.signup.referralCode,
                // 'sex': this.signup.sex,
                'sex': '',
                // 'dob': this.signup.year+'-'+this.signup.month+'-'+this.signup.ddate,
                'dob': null
              };
              console.log(params);
              promise_default.a.resolve(this.$POST('patient/quickSignUp', params)).then(function (response) {
                if (response.response_code === 0) {
                  this.signup.error = false;
                  this.signup.errormsg = '';
                  this.signup.success = true;
                  this.signup.successmsg = 'We have send an authentication code for verifying your account.';
                  vue_esm["default"].analytics.fbq.event('ViewContent', {
                    content_ids: 0,
                    content_name: 'SIGN UP SUCCESS',
                    contents: '',
                    content_type: 'SIGNUP_SUCCESS'
                  });
                } else {
                  this.signup.success = false;
                  this.signup.error = true;
                  this.signup.errormsg = response.response_message;
                  this.signup.otp = '';
                  if (response.response_code === 3) {
                    this.$refs.signUpEmail.focus();
                  } else if (response.response_code === 4) {
                    this.$refs.signUpMobile.focus();
                  }
                }
              }.bind(this)).catch(function (err) {
                console.log(err);
              });
            } else {
              this.$Simplert.open({
                title: 'Alert',
                message: 'Please enter required fields!',
                type: 'warning',
                disableOverlayClick: true,
                showXclose: true,
                useConfirmBtn: false,
                customCloseBtnText: 'OK'
              });
              // alert('Please enter required fields!')
            }
          } catch (e) {
            console.error(e);
          }
        }
      }.bind(this));
    },
    signup_verify_otp: function signup_verify_otp() {
      var _this8 = this;

      this.$validator.validateAll('signupOtp').then(function (result) {
        if (result) {
          if (_this8.signup.email !== '' && _this8.signup.otp !== '') {
            _this8.$verifyOTP(_this8.signup.email, _this8.signup.otp).then(function (response) {
              if (response.error) {
                this.signup.error = true;
                this.signup.errormsg = 'Invalid OTP';
                this.signup.successmsg = '';
                return false;
              } else {
                if (this.appointmentLogin) {
                  this.appointmentLogin = false;
                  this.$root.$emit('isLogin', true);
                  $('.signup').modal('hide');
                  this.$router.push('/address');
                  // location.reload()
                  return false;
                } else if (this.myprofileLogin) {
                  this.myprofileLogin = false;
                  this.$root.$emit('isLogin', true);
                  $('.signup').modal('hide');
                  this.$router.push('/myprofile');
                  // location.reload()
                  return false;
                } else if (this.myresultLogin) {
                  this.myresultLogin = false;
                  this.$root.$emit('isLogin', true);
                  $('.signup').modal('hide');
                  this.$router.push('/myresult');
                  // location.reload()
                  return false;
                } else {
                  this.$root.$emit('isLogin', true);
                  $('.signup').modal('hide');
                  // location.reload()
                }
              }
            }.bind(_this8)).catch(function (err) {
              console.error(err);
            });
          }
        }
      });
    },
    signup_resend: function signup_resend() {
      try {
        if (this.signup.email !== '') {
          var data = {
            'email': this.signup.email
          };
          promise_default.a.resolve(this.$POST('patient/resendOTP', data)).then(function (res) {
            if (res.response_code === 0) {
              this.signup.error = false;
              this.signup.errormsg = '';
              this.signup.success = true;
              this.signup.successmsg = 'We have resend an authentication code to your mail id.';
            } else {
              this.signup.success = false;
              this.signup.error = true;
              this.signup.errormsg = res.response_message;
              this.signup.otp = '';
            }
          }.bind(this)).catch(function (err) {
            console.log(err);
          });
        }
      } catch (e) {
        console.error(e);
      }
    },
    logout: function logout() {
      this.$clearLocalStorage();
      location.reload();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d121caaa","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/Login.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"loginDiv"}},[_c('div',{ref:"loginModel",staticClass:"modal fade login-box",attrs:{"tabindex":"-1","role":"dialog","aria-labelledby":"mySmallModalLabel","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog modal-sm"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"menu_popup"},[_c('i',{staticClass:"material-icons",attrs:{"data-dismiss":"modal","aria-label":"Close"},on:{"click":function($event){_vm.closePopup(1)}}},[_vm._v("arrow_back")])]),_vm._v(" "),_vm._m(0,false,false)])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('h3',[_vm._v("Login / Sign Up")]),_vm._v(" "),_c('p',[_vm._v("Login an account on labotist")]),_vm._v(" "),(_vm.login.error)?_c('p',{staticClass:"no-mar-top red-color"},[_vm._v(_vm._s(_vm.login.errormsg))]):_vm._e(),_vm._v(" "),(_vm.login.successmsg)?_c('p',{staticClass:"no-mar-top green-color"},[_vm._v(_vm._s(_vm.login.successmsg))]):_vm._e(),_vm._v(" "),(_vm.login.otp_send === 2)?_c('h4',{staticClass:"no-mar-top green-color"},[_vm._v(_vm._s(_vm.login.username))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-content line-textbox"},[_c('form',{directives:[{name:"show",rawName:"v-show",value:(_vm.login.otp_send === 1),expression:"login.otp_send === 1"}],attrs:{"data-vv-scope":"login"}},[(!_vm.login.login_with_otp)?_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.login.username),expression:"login.username"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],ref:"login_username",staticClass:"form-control",attrs:{"type":"text","name":"username","id":"username","data-vv-as":"email or mobile","placeholder":"Email or Mobile Number"},domProps:{"value":(_vm.login.username)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.login, "username", $event.target.value)}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('login.username')),expression:"errors.has('login.username')"}],staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('login.username')))])]):_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"mask",rawName:"v-mask",value:('##########'),expression:"'##########'"},{name:"model",rawName:"v-model",value:(_vm.login.username),expression:"login.username"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],ref:"login_username",staticClass:"form-control",attrs:{"type":"text","name":"username","id":"username","data-vv-as":"mobile","placeholder":"Mobile Number"},domProps:{"value":(_vm.login.username)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.login, "username", $event.target.value)}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('login.username')),expression:"errors.has('login.username')"}],staticClass:"text-danger"},[_vm._v("The mobile number field is required.")])]),_vm._v(" "),(!_vm.login.login_with_otp)?_c('div',{staticClass:"form-group  mb-2"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.login.password),expression:"login.password"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],ref:"login_password",staticClass:"form-control",attrs:{"type":"password","name":"password","id":"password","data-vv-as":"password","placeholder":"Password"},domProps:{"value":(_vm.login.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.login, "password", $event.target.value)}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('login.password')),expression:"errors.has('login.password')"}],staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('login.password')))])]):_c('div',{staticClass:"form-group  mb-2"},[_c('input',{staticClass:"form-control",attrs:{"type":"password","placeholder":"Password","disabled":""}})]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('a',{staticClass:"mb-3 text-center signup-link float-right display-block",attrs:{"data-dismiss":"modal","data-toggle":"modal","href":"#lost","data-target":".forgot","data-backdrop":"static","data-keyboard":"false"},on:{"click":function($event){_vm.clearFields()}}},[_vm._v("\n                                    Forgot Password?\n                                ")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-12 mb-3"},[_c('label',{staticClass:"checkbox_container"},[_vm._v("Login With OTP?\n                                  "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.login.login_with_otp),expression:"login.login_with_otp"}],ref:"login_with_otp",attrs:{"type":"checkbox","name":"login_with_otp","id":"login_with_otp","data-vv-as":"login_with_otp"},domProps:{"checked":Array.isArray(_vm.login.login_with_otp)?_vm._i(_vm.login.login_with_otp,null)>-1:(_vm.login.login_with_otp)},on:{"change":function($event){var $$a=_vm.login.login_with_otp,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.login.login_with_otp=$$a.concat([$$v]))}else{$$i>-1&&(_vm.login.login_with_otp=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.$set(_vm.login, "login_with_otp", $$c)}}}}),_vm._v(" "),_c('span',{staticClass:"checkbox_checkmark"})])])]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary full-width mar-b-15",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();_vm.loginClicked()}}},[_vm._v(_vm._s(!_vm.login.login_with_otp ? 'Login' : 'Send OTP'))]),_vm._v(" "),_c('div',{staticClass:"blue-border rounded p-2 text-center full-width f-14 mb-3"},[_vm._v("\n                              New User?\n                              "),_c('a',{staticClass:"blue-color",attrs:{"data-dismiss":"modal","data-toggle":"modal","href":"#lost","data-target":".signup","data-backdrop":"static","data-keyboard":"false"},on:{"click":function($event){_vm.clearFields(1)}}},[_vm._v("\n                                  Signup\n                              ")])])]),_vm._v(" "),_c('form',{directives:[{name:"show",rawName:"v-show",value:(_vm.login.otp_send === 2),expression:"login.otp_send === 2"}],attrs:{"data-vv-scope":"login-wt-otp"}},[_c('div',{staticClass:"form-group  mb-2"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.login.login_otp),expression:"login.login_otp"},{name:"mask",rawName:"v-mask",value:('##########'),expression:"'##########'"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],ref:"login_otp",staticClass:"form-control",attrs:{"type":"text","name":"login_otp","id":"login_otp","maxlength":"6","data-vv-as":"OTP","placeholder":"Enter your OTP"},domProps:{"value":(_vm.login.login_otp)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.login, "login_otp", $event.target.value)}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('login-wt-otp.login_otp')),expression:"errors.has('login-wt-otp.login_otp')"}],staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('login-wt-otp.login_otp')))])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('a',{staticClass:"mb-3 text-center signup-link blue-color",on:{"click":function($event){_vm.clearFields()}}},[_vm._v("\n                                    Back to Login?\n                                ")]),_vm._v(" "),_c('a',{staticClass:"mb-3 text-center signup-link float-right display-block resent_otp",on:{"click":function($event){_vm.loginWithOtpChanged(true)}}},[_vm._v("Resend OTP?")])])]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary full-width mar-b-15",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();_vm.verifyLoginOTP()}}},[_vm._v("Verify OTP")])]),_vm._v(" "),(_vm.otherSignup)?_c('div',[_c('p',[_vm._v("Or Login Using")]),_vm._v(" "),_vm._m(1,false,false)]):_vm._e()])])])])]),_vm._v(" "),_c('div',{staticClass:"modal fade signup",attrs:{"tabindex":"-1","role":"dialog","aria-labelledby":"mySmallModalLabel","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog modal-sm"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header",attrs:{"id":"signup-error-msg"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"menu_popup"},[_c('i',{staticClass:"material-icons",attrs:{"data-dismiss":"modal","aria-label":"Close"},on:{"click":function($event){_vm.closePopup(2)}}},[_vm._v("arrow_back")])]),_vm._v(" "),_vm._m(2,false,false)])])]),_vm._v(" "),_c('div',{staticClass:"modal-body pt-0"},[_c('h3',{staticStyle:{"padding-top":"10px"}},[_vm._v("Sign Up")]),_vm._v(" "),_c('p',{staticClass:"no-mar-top"},[_vm._v("Create an account on Labotist")]),_vm._v(" "),(_vm.signup.error)?_c('p',{staticClass:"no-mar-top red-color"},[_vm._v(_vm._s(_vm.signup.errormsg))]):_vm._e(),_vm._v(" "),(_vm.signup.success)?_c('p',{staticClass:"no-mar-top green-color"},[_vm._v(_vm._s(_vm.signup.successmsg))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-content line-textbox"},[_c('form',{directives:[{name:"show",rawName:"v-show",value:(!_vm.signup.success),expression:"!signup.success"}],attrs:{"data-vv-scope":"signup"}},[_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.signup.email),expression:"signup.email"},{name:"validate",rawName:"v-validate",value:('required|email|max:100'),expression:"'required|email|max:100'"}],ref:"signUpEmail",staticClass:"form-control",attrs:{"type":"email","name":"email","data-vv-as":"email address","maxlength":"100","placeholder":"Email address"},domProps:{"value":(_vm.signup.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.signup, "email", $event.target.value)}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('signup.email')),expression:"errors.has('signup.email')"}],staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('signup.email')))])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"mask",rawName:"v-mask",value:('##########'),expression:"'##########'"},{name:"model",rawName:"v-model",value:(_vm.signup.mobile),expression:"signup.mobile"},{name:"validate",rawName:"v-validate",value:('required|numeric|min:10|max:10'),expression:"'required|numeric|min:10|max:10'"}],ref:"signUpMobile",staticClass:"form-control",attrs:{"type":"text","name":"mobile","data-vv-as":"mobile no.","placeholder":"Mobile number"},domProps:{"value":(_vm.signup.mobile)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.signup, "mobile", $event.target.value)}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('signup.mobile')),expression:"errors.has('signup.mobile')"}],staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('signup.mobile')))])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.signup.firstName),expression:"signup.firstName"},{name:"validate",rawName:"v-validate",value:('required|alpha_spaces|max:50'),expression:"'required|alpha_spaces|max:50'"}],staticClass:"form-control",attrs:{"type":"text","name":"firstName","data-vv-as":"first name","maxlength":"50","placeholder":"Name"},domProps:{"value":(_vm.signup.firstName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.signup, "firstName", $event.target.value)}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('signup.firstName')),expression:"errors.has('signup.firstName')"}],staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('signup.firstName')))])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.signup.password),expression:"signup.password"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"form-control",attrs:{"type":"password","name":"password","data-vv-as":"password","placeholder":"Password"},domProps:{"value":(_vm.signup.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.signup, "password", $event.target.value)}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('signup.password')),expression:"errors.has('signup.password')"}],staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('signup.password')))])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.signup.referralCode),expression:"signup.referralCode"},{name:"validate",rawName:"v-validate",value:('alpha_num|max:8'),expression:"'alpha_num|max:8'"}],ref:"referralCode",staticClass:"form-control",attrs:{"type":"text","name":"referralCode","data-vv-as":"referralCode","placeholder":"Referral Code(Optional)","disabled":_vm.referralCodeDisable},domProps:{"value":(_vm.signup.referralCode)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.signup, "referralCode", $event.target.value)}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('signup.referralCode')),expression:"errors.has('signup.referralCode')"}],staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('signup.referralCode')))])]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary mar-t-15 full-width",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();_vm.create_account()}}},[_vm._v("Continue")])]),_vm._v(" "),_c('form',{directives:[{name:"show",rawName:"v-show",value:(_vm.signup.success),expression:"signup.success"}],attrs:{"data-vv-scope":"signupOtp"}},[_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.signup.otp),expression:"signup.otp"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"form-control",attrs:{"type":"text","name":"sotp","data-vv-as":"signup otp","placeholder":"Enter OTP"},domProps:{"value":(_vm.signup.otp)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.signup, "otp", $event.target.value)}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('signupOtp.sotp')),expression:"errors.has('signupOtp.sotp')"}],staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('signupOtp.sotp')))])]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary full-width mar-b-15",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();_vm.signup_verify_otp()}}},[_vm._v("Verify")]),_vm._v(" "),_c('a',{staticClass:"text-center signup-link display-block",on:{"click":function($event){$event.preventDefault();_vm.signup_resend()}}},[_vm._v("Resend?")])]),_vm._v(" "),_c('a',{staticClass:"mar-t-15 text-center signup-link display-block",attrs:{"data-dismiss":"modal","data-toggle":"modal","href":"#lost","data-target":".login-box","data-backdrop":"static","data-keyboard":"false"},on:{"click":function($event){_vm.clearFields()}}},[_vm._v("Continue to login?")]),_vm._v(" "),(_vm.otherSignup)?_c('div',[_c('p',[_vm._v("Or Signup Using")]),_vm._v(" "),_vm._m(3,false,false)]):_vm._e()])])])])]),_vm._v(" "),_c('div',{staticClass:"modal fade forgot",attrs:{"tabindex":"-1","role":"dialog","aria-labelledby":"mySmallModalLabel","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog modal-sm"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"menu_popup"},[_c('i',{staticClass:"material-icons",attrs:{"data-dismiss":"modal","aria-label":"Close"},on:{"click":function($event){_vm.closePopup(2)}}},[_vm._v("arrow_back")])]),_vm._v(" "),_vm._m(4,false,false)])])]),_vm._v(" "),_c('div',{staticClass:"modal-body pt-0"},[(_vm.forgot.success === 1 || _vm.forgot.success === 2)?_c('h3',[_vm._v("Forgot Password")]):_vm._e(),_vm._v(" "),(_vm.forgot.success === 3)?_c('h3',[_vm._v("Change Password")]):_vm._e(),_vm._v(" "),(_vm.forgot.success === 1 || _vm.forgot.success === 2)?_c('p',{staticClass:"no-mar-top"},[_vm._v("Reset password through Email/Mobile")]):_vm._e(),_vm._v(" "),(_vm.forgot.success === 3)?_c('p',{staticClass:"no-mar-top"},[_vm._v("Reset your Password")]):_vm._e(),_vm._v(" "),(_vm.forgot.error)?_c('p',{staticClass:"no-mar-top red-color"},[_vm._v(_vm._s(_vm.forgot.errormsg))]):_vm._e(),_vm._v(" "),(_vm.forgot.success === 2)?_c('p',{staticClass:"no-mar-top green-color"},[_vm._v(_vm._s(_vm.forgot.successmsg))]):_vm._e(),_vm._v(" "),(_vm.forgot.success === 2)?_c('h4',{staticClass:"no-mar-top green-color otp-mobile"},[_vm._v(_vm._s(_vm.forgot.username))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-content line-textbox"},[_c('form',{directives:[{name:"show",rawName:"v-show",value:(_vm.forgot.success === 1),expression:"forgot.success === 1"}],attrs:{"data-vv-scope":"forgot"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-2"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.forgot.otpType),expression:"forgot.otpType"}],staticClass:"mr-3",attrs:{"type":"radio","name":"otp_type","id":"otp_type_email","value":"1"},domProps:{"checked":_vm._q(_vm.forgot.otpType,"1")},on:{"change":function($event){_vm.$set(_vm.forgot, "otpType", "1")}}}),_c('label',{staticClass:"mr-3",attrs:{"for":"otp_type_email"}},[_vm._v("Email")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.forgot.otpType),expression:"forgot.otpType"}],staticClass:"mr-3",attrs:{"type":"radio","name":"otp_type","id":"otp_type_sms","value":"2"},domProps:{"checked":_vm._q(_vm.forgot.otpType,"2")},on:{"change":function($event){_vm.$set(_vm.forgot, "otpType", "2")}}}),_c('label',{attrs:{"for":"otp_type_sms"}},[_vm._v("Sms")])])]),_vm._v(" "),(_vm.forgot.otpType == 1)?_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.forgot.username),expression:"forgot.username"},{name:"validate",rawName:"v-validate",value:('required|email'),expression:"'required|email'"}],staticClass:"form-control",attrs:{"type":"email","name":"fusername","data-vv-as":"email address","placeholder":"Email Address"},domProps:{"value":(_vm.forgot.username)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.forgot, "username", $event.target.value)}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('forgot.fusername')),expression:"errors.has('forgot.fusername')"}],staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('forgot.fusername')))])]):_vm._e(),_vm._v(" "),(_vm.forgot.otpType == 2)?_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"mask",rawName:"v-mask",value:('##########'),expression:"'##########'"},{name:"model",rawName:"v-model",value:(_vm.forgot.username),expression:"forgot.username"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"form-control",attrs:{"type":"text","name":"fusername","data-vv-as":"email address","placeholder":"Mobile Number"},domProps:{"value":(_vm.forgot.username)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.forgot, "username", $event.target.value)}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('forgot.fusername')),expression:"errors.has('forgot.fusername')"}],staticClass:"text-danger"},[_vm._v("Mobile number field is required.")])]):_vm._e(),_vm._v(" "),(!_vm.forgot.otpType)?_c('div',{staticClass:"form-group"}):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn btn-primary full-width mt-3 mar-b-15",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();_vm.forgetPassword()}}},[_vm._v("Send")])]),_vm._v(" "),_c('form',{directives:[{name:"show",rawName:"v-show",value:(_vm.forgot.success === 2),expression:"forgot.success === 2"}],attrs:{"data-vv-scope":"forgotOtp"}},[_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"mask",rawName:"v-mask",value:('######'),expression:"'######'"},{name:"model",rawName:"v-model",value:(_vm.forgot.otp),expression:"forgot.otp"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"form-control",attrs:{"type":"text","name":"fotp","data-vv-as":"verify otp","placeholder":"Enter OTP"},domProps:{"value":(_vm.forgot.otp)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.forgot, "otp", $event.target.value)}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('forgotOtp.fotp')),expression:"errors.has('forgotOtp.fotp')"}],staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('forgotOtp.fotp')))])]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary full-width mar-b-15",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();_vm.verify_otp($event)}}},[_vm._v("Verify")]),_vm._v(" "),_c('a',{staticClass:"text-center signup-link display-block",on:{"click":function($event){_vm.resend()}}},[_vm._v("\n                                Resend?\n                            ")])]),_vm._v(" "),_c('form',{directives:[{name:"show",rawName:"v-show",value:(_vm.forgot.success === 3),expression:"forgot.success === 3"}],attrs:{"data-vv-scope":"resetPassword"}},[_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.forgot.newPassword),expression:"forgot.newPassword"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"form-control",attrs:{"type":"password","name":"newPassword","data-vv-as":"new password","placeholder":"New Password"},domProps:{"value":(_vm.forgot.newPassword)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.forgot, "newPassword", $event.target.value)}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('resetPassword.newPassword')),expression:"errors.has('resetPassword.newPassword')"}],staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('resetPassword.newPassword')))])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.forgot.confirmPassword),expression:"forgot.confirmPassword"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"form-control",attrs:{"type":"password","name":"confirmPassword","data-vv-as":"password","placeholder":"Confirm Password"},domProps:{"value":(_vm.forgot.confirmPassword)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.forgot, "confirmPassword", $event.target.value)}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('resetPassword.confirmPassword')),expression:"errors.has('resetPassword.confirmPassword')"}],staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('resetPassword.confirmPassword')))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.forgot.confirmPassword !== '' && _vm.forgot.newPassword != _vm.forgot.confirmPassword),expression:"forgot.confirmPassword !== '' && forgot.newPassword != forgot.confirmPassword"}],staticClass:"text-danger"},[_vm._v("Confirm password doesn't match")])]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary full-width mar-b-15",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();_vm.reset_password($event)}}},[_vm._v("Submit")])]),_vm._v(" "),_c('a',{staticClass:"mar-t-15 text-center signup-link display-block",attrs:{"data-dismiss":"modal","data-toggle":"modal","href":"#lost","data-target":".login-box","data-backdrop":"static","data-keyboard":"false"},on:{"click":function($event){_vm.clearFields()}}},[_vm._v("\n                            Continue to login?\n                        ")])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal fade login-otp",attrs:{"tabindex":"-1","role":"dialog","aria-labelledby":"mySmallModalLabel","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog modal-sm"},[_c('div',{staticClass:"modal-content"},[_vm._m(5,false,false),_vm._v(" "),_c('div',{staticClass:"modal-body pt-0"},[_c('p',{staticClass:"no-mar-top"},[_vm._v("Login with otp")]),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],staticClass:"no-mar-top green-color"},[_vm._v("Welcome back")]),_vm._v(" "),_c('div',{staticClass:"form-content line-textbox"},[_vm._m(6,false,false),_vm._v(" "),_c('button',{staticClass:"btn btn-primary full-width mt-3 "},[_vm._v("Send")]),_vm._v(" "),_c('a',{staticClass:"mar-t-15 text-center signup-link display-block",attrs:{"data-dismiss":"modal","data-toggle":"modal","href":"#lost","data-target":".login-box","data-backdrop":"static","data-keyboard":"false"},on:{"click":function($event){_vm.clearFields()}}},[_vm._v("\n                            Continue to login?\n                        ")])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"logo"},[_c('img',{attrs:{"src":"static/images/logo-svg.svg","alt":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('button',{staticClass:"btn full-width facebook-btn mar-b-15"},[_c('span',{staticClass:"fa fa-facebook-official"}),_vm._v(" Facebook\n                                    ")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('button',{staticClass:"btn full-width google-btn"},[_c('span',{staticClass:"fa fa-google-plus-square"}),_vm._v(" Google+\n                                    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"logo"},[_c('img',{attrs:{"src":"static/images/logo-svg.svg","alt":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('button',{staticClass:"btn full-width facebook-btn mar-b-15"},[_c('span',{staticClass:"fa fa-facebook-official"}),_vm._v(" Facebook\n                                    ")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('button',{staticClass:"btn full-width google-btn"},[_c('span',{staticClass:"fa fa-google-plus-square"}),_vm._v(" Google+\n                                    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"logo"},[_c('img',{attrs:{"src":"static/images/logo-svg.svg","alt":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-header"},[_c('h5',{staticClass:"modal-title",attrs:{"id":"exampleModalLabel"}},[_vm._v("Login with OTP")]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group"},[_c('input',{staticClass:"form-control",attrs:{"type":"text","placeholder":"Email Address/Mobile No."}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var mobile_Login = (esExports);
// CONCATENATED MODULE: ./src/components/mobile/Login.vue
function injectStyle (ssrContext) {
  __webpack_require__("dVo2")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d121caaa"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  Login,
  mobile_Login,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_mobile_Login = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "QmSG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_is_mobile__ = __webpack_require__("6VvU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_is_mobile___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_is_mobile__);




__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$appName = 'Labotist Web Application';
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$timezone = new Date().getTimezoneOffset();

if (location.hostname === 'labotist.com') {
  __WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$apiUrl = 'https://webapi.labotist.com/';
  __WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$s3BucketUrl = 'https://s3-ap-southeast-1.amazonaws.com/labotist-prod/';
  __WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$payment_mode = 'LIVE';
  __WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$razorpay_key = 'rzp_live_iBU7RZx7cl20N9';
  __WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$blogRedirectUrl = 'https://labotist.com/lab';
  __WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$signupUrl = 'https://labotist.com/referral/signup/';
} else if (location.hostname === 'stage.labotist.com') {
  __WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$apiUrl = 'https://webapi-stage.labotist.com/';
  __WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$s3BucketUrl = 'https://s3-ap-southeast-1.amazonaws.com/labotist-stage/';
  __WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$payment_mode = 'TEST';
  __WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$razorpay_key = 'rzp_test_3D5exVpKm54qdc';
  __WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$blogRedirectUrl = 'https://stage.labotist.com/lab';
  __WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$signupUrl = 'https://stage.labotist.com/referral/signup/';
} else if (location.hostname === 'dev.labotist.com') {
  __WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$apiUrl = 'https://dev-webapi.labotist.com/';
  __WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$s3BucketUrl = 'https://s3-us-west-2.amazonaws.com/devlab/';
  __WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$payment_mode = 'TEST';
  __WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$razorpay_key = 'rzp_test_3D5exVpKm54qdc';
  __WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$blogRedirectUrl = 'https://dev.labotist.com/lab';
  __WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$signupUrl = 'https://dev.labotist.com/referral/signup/';
} else {
  __WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$apiUrl = 'http://13.201.212.41:3000/';
  __WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$s3BucketUrl = 'https://s3-us-west-2.amazonaws.com/devlab/';
  __WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$payment_mode = 'TEST';
  __WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$razorpay_key = 'rzp_test_3D5exVpKm54qdc';
  __WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$blogRedirectUrl = 'http://13.201.212.41:3000/lab';
  __WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$signupUrl = 'http://13.201.212.41:3000/referral/signup/';
}

// Payment Charges
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$phlebotomistFee = 0; // 100
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$labotistDiscount = 150;
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$phlebotomyFeeWaiver = 0; // 100
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$waiverDiscountApplyFee = 0; // 1000
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$GSTFee = '0'; // 18 percentage
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$defaultPincode = '600017'; // 18 percentage
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$cashPayment = false;
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$fuzzyDistance = 100;

global.successId = 0;

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$IsMobile = __WEBPACK_IMPORTED_MODULE_1_is_mobile___default()();
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$WebView = false;
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$WebViewBridge = undefined;
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$IsWebViewIos = false;
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$IsWebViewAndroid = false;
if (__WEBPACK_IMPORTED_MODULE_1_is_mobile___default()()) {
  try {
    if (WebViewBridge) {
      __WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$WebView = true;
      __WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$WebViewBridge = WebViewBridge;
      var standalone = window.navigator.standalone,
          userAgent = window.navigator.userAgent.toLowerCase(),
          safari = /safari/.test(userAgent),
          ios = /iphone|ipod|ipad/.test(userAgent);
      if (ios) {
        if (!standalone && !safari) {
          __WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$IsWebViewIos = true;
        } else {
          __WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$IsWebViewAndroid = true;
        }
      } else {
        __WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$IsWebViewAndroid = true;
      }
    }
  } catch (err) {
    console.log('Browser');
    var i = 0,
        j = false;
    var tmt = setInterval(function () {
      try {
        if (i >= 30) {
          clearInterval(tmt);
        }
        if (WebViewBridge && !j) {
          // alert(i)
          __WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$WebView = true;
          __WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$WebViewBridge = WebViewBridge;
          var standalone = window.navigator.standalone,
              userAgent = window.navigator.userAgent.toLowerCase(),
              safari = /safari/.test(userAgent),
              ios = /iphone|ipod|ipad/.test(userAgent);
          if (ios) {
            if (!standalone && !safari) {
              __WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$IsWebViewIos = true;
            }
          } else {
            __WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$IsWebViewAndroid = true;
          }
          j = true;
          clearInterval(tmt);
        }
      } catch (er) {
        // console.log('Checking browser type')
      }
      i++;
    }, 1000);
  }
}

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Config',
  data: function data() {},

  mixins: {
    created: function created() {
      this.$config = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype;
    }
  },
  IsMobile: __WEBPACK_IMPORTED_MODULE_1_is_mobile___default()()
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("DuR2")))

/***/ }),

/***/ "S3ap":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "S9p6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "SN8v":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/promise.js
var promise = __webpack_require__("//Fk");
var promise_default = /*#__PURE__*/__webpack_require__.n(promise);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/Footer.vue

//
//
//
//
//
//
//
//

/* harmony default export */ var Footer = ({
  name: 'FooterVue',
  props: ['foot'],
  beforeCreate: function beforeCreate() {},
  data: function data() {
    return {
      newsLetterEmail: '',
      isApp: this.$WebView
    };
  },

  methods: {
    saveNewsLetter: function saveNewsLetter() {
      var _this = this;

      this.$validator.validateAll('newsletter').then(function (result) {
        if (result) {
          try {
            var data = {
              email: _this.newsLetterEmail
            };
            promise_default.a.resolve(_this.$POST('patient/newsSubscriber', data)).then(function (res) {
              if (res.response_code === 0) {
                this.$Simplert.open({
                  title: 'Success',
                  message: 'Thanks for signup newsletter',
                  type: 'success',
                  disableOverlayClick: true,
                  showXclose: true,
                  useConfirmBtn: false
                });
                // alert('Thanks for signup newsletter')
              } else {
                this.$Simplert.open({
                  message: res.response_message,
                  type: 'success',
                  disableOverlayClick: true,
                  showXclose: true,
                  useConfirmBtn: false
                });
              }
            }.bind(_this)).catch(function (err) {
              console.error(err);
            });
          } catch (e) {
            console.error(e);
          }
        }
      }).catch(function () {
        console.log('error exist while save news letter', _this.errors);
      });
    }
  },
  created: function created() {
    setTimeout(function () {
      if (this.$WebView) {
        this.isApp = this.$WebView;
      } else {
        setTimeout(function () {
          this.isApp = this.$WebView;
        }.bind(this), 2000);
      }
    }.bind(this), 2000);
    var rootpath = this.$route.fullPath.split('/');
    if (rootpath[1] === 'appointment' || rootpath[1] === 'address' || rootpath[1] === 'lab' || rootpath[1] === 'labs' || rootpath[1] === 'payment') {
      setTimeout(function () {
        var footerHeight = $('#fixed-footer').outerHeight();
        $('body').css('padding-bottom', footerHeight + 15);
        if (rootpath[1] === 'lab' || rootpath[1] === 'labs') {
          var footerHeightPopup = $('#fixed-footer').outerHeight();
          $('.test-search-popup').css('padding-bottom', footerHeightPopup - 15);
        }
      }, 500);
    } else {
      setTimeout(function () {
        $('body').css('padding-bottom', '');
        $('.test-search-popup').css('padding-bottom', '');
      }, 500);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-15eb72c9","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/Footer.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return ((_vm.foot))?_c('div',{attrs:{"id":"footerDiv"}},[(!_vm.isApp)?_c('div',{staticClass:"copy-rights text-center pt-2 pb-2"},[_c('p',{staticClass:"m-0"},[_vm._v("2017 labotist . All rights reserved.")])]):_vm._e()]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var mobile_Footer = (esExports);
// CONCATENATED MODULE: ./src/components/mobile/Footer.vue
function injectStyle (ssrContext) {
  __webpack_require__("5MS7")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-15eb72c9"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  Footer,
  mobile_Footer,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_mobile_Footer = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "TACJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "TL0T":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "TUxi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "UGDT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Ucjp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/promise.js
var promise = __webpack_require__("//Fk");
var promise_default = /*#__PURE__*/__webpack_require__.n(promise);

// EXTERNAL MODULE: ./src/components/mobile/Login.vue + 2 modules
var Login = __webpack_require__("QHB8");

// EXTERNAL MODULE: ./static/images/close-black.svg
var close_black = __webpack_require__("YZfp");
var close_black_default = /*#__PURE__*/__webpack_require__.n(close_black);

// EXTERNAL MODULE: ./node_modules/underscore/underscore.js
var underscore = __webpack_require__("rdLu");
var underscore_default = /*#__PURE__*/__webpack_require__.n(underscore);

// EXTERNAL MODULE: ./node_modules/dateformat/lib/dateformat.js
var dateformat = __webpack_require__("CqLJ");
var dateformat_default = /*#__PURE__*/__webpack_require__.n(dateformat);

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/Header.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ var Header = ({
    name: 'HeaderVue',
    props: ['step', 'tab', 'isHealthCartEnabled', 'isHeader'],
    components: {
        Login: Login["a" /* default */]
    },
    data: function data() {
        return {
            loggedin_username: '',
            locality: undefined,
            lab: undefined,
            selectedProfileAndTest: undefined,
            selectedDatetime: undefined,
            closeImg: close_black_default.a,
            testCosts: [],
            cartCount: 0,
            payinfo: {},
            profile: undefined,
            cartDispaly: false,
            isApp: this.$WebView
        };
    },

    mounted: function mounted() {
        var _this = this;

        this.$root.$on('selectedProfileAndTest', function (selectedProfileAndTest) {
            _this.selectedProfileAndTest = selectedProfileAndTest;
            _this.cartCount = selectedProfileAndTest.length;
            _this.refreshContent();
        });
        this.$root.$on('bookTest', function (bookTest) {
            location.reload();
        });
        this.$root.$on('isLogin', function (isLoggin) {
            _this.refreshContent();
        });
        // $('body').click(function (e) {
        //   if (e.target.id === 'HealthCartDropDownClicks' || $(e.target).parents('#HealthCartDropDownClicks').length) {
        //     this.cartDispaly = true
        //   } else {
        //     this.cartDispaly = false
        //   }
        // }.bind(this))
    },
    created: function created() {
        setTimeout(function () {
            if (this.$WebView) {
                this.isApp = this.$WebView;
                this.profile = this.$localStorage.get('profile');
            } else {
                setTimeout(function () {
                    this.isApp = this.$WebView;
                    this.profile = this.$localStorage.get('profile');
                }.bind(this), 2000);
            }
        }.bind(this), 2000);

        if (this.$route.fullPath === '/login') {
            // this.$localStorage.remove('profile')
            // this.$localStorage.remove('userid')
            // this.$localStorage.remove('email')
            // this.$localStorage.remove('refresh_token')
            // this.$localStorage.remove('scope')
            // this.$localStorage.remove('profile')
        }
        if (this.$localStorage.get('profile')) {
            this.loggedin_username = this.$localStorage.get('profile').username;
        }
        this.locality = this.$localStorage.get('location');
        this.lab = this.$localStorage.get('sl');
        this.selectedProfileAndTest = this.$localStorage.get('st');
        this.selectedDatetime = this.$localStorage.get('ct');
        this.profile = this.$localStorage.get('profile');
        this.cartCount = this.selectedProfileAndTest ? this.selectedProfileAndTest.length : 0;
        if (this.lab) {
            this.getTestCosts();
        }
        setTimeout(function () {
            $('.black-layout').hide();
            $('.menu').click(function () {
                $('.black-layout').show();
                $('.hamburger-menu').addClass('show-menu');
                $('body').css('overflow', 'hidden');
            });
            $('.close-hamburger').click(function () {
                $('.black-layout').hide();
                $('.hamburger-menu').removeClass('show-menu');
                $('body').css('overflow', 'auto');
            }), 300;
        });
    },

    methods: {
        closepopup: function closepopup() {
            $('.hamburger-menu').removeClass('show-menu');
            $('body').css('overflow', 'auto');
            $('.black-layout').hide();
        },
        healthCartClicked: function healthCartClicked() {
            if (this.cartCount <= 0) {
                var rootpath = this.$route.fullPath.split('/');
                if (rootpath[1] === 'lab') {
                    $('#popupTest').modal('show');
                } else {
                    this.$router.push({ path: '/lab' });
                }
                return false;
            } else {
                $('#Health-cartpopup').modal('show');
            }
        },
        addTest: function addTest() {
            this.$localStorage.set('addTest', true);
            this.$router.push({ path: '/lab' });
        },
        goToLab: function goToLab() {
            this.$router.push({ path: '/lab' });
        },
        backTest: function backTest() {
            // $('#Health-cartpopup').on('hidden', function () {
            //         console.log('lllllllllllllllllllll')
            //     $('.modal-open').modal('show')
            // })
            $('#popupTest').modal('hide');
            $('#Health-cartpopup').modal('hide');
            if (this.$route.fullPath === '/lab') {
                setTimeout(function () {
                    $('#popupTest').modal('show');
                }, 300);
            } else {
                this.$router.push({ path: '/lab' });
                this.addTest();
            }
        },
        selectLab: function selectLab() {
            this.$router.push({ path: '/lab' });
        },
        loginClicked: function loginClicked() {
            $('.black-layout').hide();
            $('.hamburger-menu').removeClass('show-menu');
            $('body').css('overflow', 'auto');
            vue_esm["default"].analytics.fbq.event('ViewContent', {
                content_ids: 0,
                content_name: 'LOGIN CLICKED',
                contents: '',
                content_type: 'LOGIN_CLICK'
            });
            this.$root.$emit('loginClicked', true);
        },
        proccedtoHealthCart: function proccedtoHealthCart() {
            this.$localStorage.remove('ct');
            this.$localStorage.remove('sa');
            this.$localStorage.remove('sm');
            this.$localStorage.remove('cou');
            $('#Health-cartpopup').modal('hide');
            this.$router.push({ path: '/appointment' });
        },
        openHealthCart: function openHealthCart() {
            console.log('inside the Process');
            $('#Health-cartpopup').modal('show');
            // this.$router.push({path:'/health'})
            //   this.cartDispaly = true
        },
        logout: function logout() {
            this.$router.push({ path: '/' });
            this.profile = undefined;
            this.$clearLocalStorageForLogout();
            //   this.$clienttokenForLogout()
            setTimeout(function () {
                this.refreshContent();
                location.reload();
            }.bind(this), 300);
        },
        getTestCosts: function getTestCosts(lab) {
            try {
                var labTestCosts = [];
                if (this.lab) {
                    if (this.lab.labTestList.length > 0) {
                        underscore_default.a.each(this.lab.labTestList, function (element) {
                            labTestCosts.push(element.labProfileId);
                        });
                    }
                }
                if (labTestCosts.length === 0) {
                    $('#Health-cartpopup').modal('hide');
                    this.$router.push('/lab');
                }
                var data = {
                    'labId': this.lab ? this.lab.labId : '0',
                    'labTests': labTestCosts
                };
                promise_default.a.resolve(this.$POST('patient/getTestCosts', data)).then(function (res) {
                    if (res.response_code === 0) {
                        if (res.response) {
                            this.testCosts = res.response;
                            this.payinfo.mrptotal = res.response.mrp;
                            this.payinfo.phlebotomistFee = this.$phlebotomistFee;
                            this.payinfo.subtotal = this.payinfo.mrptotal + this.payinfo.phlebotomistFee;
                            this.payinfo.labDiscount = res.response.youSaved;
                            this.payinfo.phlebotomyFeeWaiver = this.payinfo.mrptotal - this.payinfo.labDiscount > this.$waiverDiscountApplyFee ? this.$phlebotomyFeeWaiver : 0;
                            this.payinfo.total = this.payinfo.subtotal - (this.payinfo.labDiscount + this.payinfo.phlebotomyFeeWaiver);
                            this.payinfo.gst = Math.round(this.payinfo.total * this.$GSTFee / 100);
                            this.payinfo.grandtotal = this.payinfo.total + this.payinfo.gst;
                        }
                    }
                }.bind(this)).catch(function (err) {
                    console.error(err);
                });
            } catch (e) {
                console.log(e);
            }
        },
        removeSelectedItems: function removeSelectedItems(items) {
            this.$localStorage.remove('st');
            this.$localStorage.remove('cou');
            var index = this.selectedProfileAndTest.indexOf(items);
            this.selectedProfileAndTest.splice(index, 1);
            this.$localStorage.set('st', this.selectedProfileAndTest, 0);
            this.cartCount = this.selectedProfileAndTest ? this.selectedProfileAndTest.length : 0;
            if (this.selectedProfileAndTest.length === 0) {
                this.$localStorage.remove('sl');
                this.$localStorage.remove('ct');
                this.lab = undefined;
                this.testCosts = [];
                $('#Health-cartpopup').modal('hide');
                this.$router.push('/lab');
            }
            this.$root.$emit('removeProfileAndTest', this.selectedProfileAndTest);
        },
        removeSelectedItemsInLab: function removeSelectedItemsInLab(items) {
            this.$localStorage.remove('cou');
            this.$localStorage.remove('st');
            this.$localStorage.remove('ct');
            var tests = {};
            this.selectedProfileAndTest.forEach(function (item) {
                if (items.testId === item.testId && item.testId !== 0 || items.panelId === item.panelId && item.panelId !== 0) {
                    tests = item;
                }
            });
            var labTests = [];
            this.lab.labTestList.forEach(function (labTest) {
                if (!(items.testId === labTest.testId && labTest.testId !== 0 || items.panelId === labTest.panelId && labTest.panelId !== 0)) {
                    labTests.push(labTest);
                }
            });
            this.$localStorage.remove('sl');
            this.lab.labTestList = labTests;
            this.$localStorage.set('sl', this.lab, 30 * 60 * 1000);
            this.selectedDatetime = undefined;
            var index = this.selectedProfileAndTest.indexOf(tests);
            this.selectedProfileAndTest.splice(index, 1);
            this.$localStorage.set('st', this.selectedProfileAndTest, 0);
            this.cartCount = this.selectedProfileAndTest ? this.selectedProfileAndTest.length : 0;
            if (this.selectedProfileAndTest.length === 0) {
                this.$localStorage.remove('sl');
                this.$localStorage.remove('ct');
                this.lab = undefined;
                this.testCosts = [];
                $('#Health-cartpopup').modal('hide');
                this.$router.push('/lab');
            }
            this.$root.$emit('removeProfileAndTest', this.selectedProfileAndTest);
            this.getTestCosts();
        },
        refreshContent: function refreshContent() {
            this.profile = this.$localStorage.get('profile');
            this.locality = this.$localStorage.get('location');
            this.lab = this.$localStorage.get('sl');
            this.selectedProfileAndTest = this.$localStorage.get('st');
            this.selectedDatetime = this.$localStorage.get('ct');
            this.cartCount = this.selectedProfileAndTest ? this.selectedProfileAndTest.length : 0;
            if (this.lab) {
                this.getTestCosts();
            }
        },
        formatDate: function formatDate(date, format) {
            return dateformat_default()(date, format, true);
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-371dd6bb","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/Header.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"headerDiv"}},[_vm._m(0,false,false),_vm._v(" "),(_vm.isHeader)?_c('span',[_c('div',{staticClass:"black-layout",on:{"click":function($event){_vm.closepopup()}}}),_vm._v(" "),_c('div',{staticClass:"hamburger-menu"},[_c('div',{staticClass:"menu-content"},[_vm._m(1,false,false),_vm._v(" "),_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('ul',{staticClass:"menu-list sidebar"},[_c('li',[_c('router-link',{attrs:{"to":"/"}},[_c('i',{staticClass:"fa fa-home icon-change",attrs:{"aria-hidden":"true"}}),_vm._v("Home")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/dashboard"}},[_c('i',{staticClass:"fa fa-tachometer icon-change",attrs:{"aria-hidden":"true"}}),_vm._v("Dashboard")])],1),_vm._v(" "),_c('li',{staticClass:"border-bottom"},[_c('router-link',{attrs:{"to":"/lab"}},[_c('i',{staticClass:"fa fa-flask icon-change",attrs:{"aria-hidden":"true"}}),_vm._v("Book Test ")])],1),_vm._v(" "),(_vm.profile)?_c('li',[_c('router-link',{attrs:{"to":"/myprofile"}},[_c('i',{staticClass:"fa fa-user-o icon-change",attrs:{"aria-hidden":"true"}}),_vm._v("My Profile")])],1):_vm._e(),_vm._v(" "),(_vm.profile)?_c('li',[_c('router-link',{attrs:{"to":"/referral/invite"}},[_c('i',{staticClass:"fa fa-money icon-change",attrs:{"aria-hidden":"true"}}),_vm._v("Refer & Earn")])],1):_vm._e(),_vm._v(" "),(_vm.profile)?_c('li',[_c('router-link',{attrs:{"to":"/myresult"}},[_c('i',{staticClass:"fa fa-file-pdf-o icon-change",attrs:{"aria-hidden":"true"}}),_vm._v("My Result")])],1):_vm._e(),_vm._v(" "),(_vm.profile)?_c('li',{staticClass:"border-bottom"},[_c('a',{staticClass:"red-color",on:{"click":function($event){_vm.logout()}}},[_c('i',{staticClass:"fa fa-power-off icon-change",attrs:{"aria-hidden":"true"}}),_vm._v("\n                                            Logout\n                                            "),_c('span',{staticClass:"user-name"},[_vm._v("Hi, "+_vm._s(_vm.profile.firstName))])])]):_vm._e(),_vm._v(" "),(!_vm.profile)?_c('li',{staticClass:"border-bottom"},[_c('a',{attrs:{"href":"#","data-toggle":"modal","data-target":".login-box","data-backdrop":"static","data-keyboard":"false"},on:{"click":function($event){_vm.loginClicked()}}},[_c('i',{staticClass:"fa fa-sign-out  icon-change",attrs:{"aria-hidden":"true"}}),_vm._v("Login / Sign Up")])]):_vm._e(),_vm._v(" "),(!_vm.isApp)?_c('li',[_c('router-link',{attrs:{"to":"/phlebotomist-signup"}},[_c('i',{staticClass:"fa fa-user-md icon-change",attrs:{"aria-hidden":"true"}}),_vm._v("Phlebotomist Sign Up")])],1):_vm._e(),_vm._v(" "),(!_vm.isApp)?_c('li',[_c('router-link',{attrs:{"to":"/lab-signup"}},[_c('i',{staticClass:"fa fa-medkit icon-change",attrs:{"aria-hidden":"true"}}),_vm._v("Lab Sign Up")])],1):_vm._e(),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/contact-us"}},[_c('i',{staticClass:"fa fa-address-book-o icon-change",attrs:{"aria-hidden":"true"}}),_vm._v("Contact Us")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/about-us"}},[_c('i',{staticClass:"fa fa-address-card-o icon-change",attrs:{"aria-hidden":"true"}}),_vm._v("About Us ")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/terms"}},[_c('i',{staticClass:"fa fa-pencil-square-o icon-change",attrs:{"aria-hidden":"true"}}),_vm._v("Terms and Conditions")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/privacy-policy"}},[_c('i',{staticClass:"fa fa-file-text-o icon-change",attrs:{"aria-hidden":"true"}}),_vm._v("Privacy Policy")])],1)])])])])])]),_vm._v(" "),_c('div',{staticClass:"header"},[(!(_vm.step))?_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_vm._m(2,false,false),_vm._v(" "),_c('div',{staticClass:"logo float-left"},[_c('router-link',{attrs:{"to":"/"}},[_c('img',{attrs:{"src":"static/images/logo-svg.svg","alt":""}})])],1),_vm._v(" "),_c('ul',{staticClass:"text-center top-menu float-right"},[(_vm.cartCount <= 0 && !_vm.isHealthCartEnabled)?_c('li',{staticClass:"dropdown"},[_c('a',{on:{"click":function($event){_vm.healthCartClicked()}}},[_c('span',[_c('span',{staticClass:"sprites sprite-care"}),_vm._v(" "),_c('span',{staticClass:"menu-label"},[_vm._v("Health Cart")]),_vm._v(" "),(_vm.cartCount > 0)?_c('span',{staticClass:"count-cart"},[_vm._v(_vm._s(_vm.cartCount))]):_vm._e()])])]):_vm._e(),_vm._v(" "),(_vm.cartCount > 0 && !_vm.isHealthCartEnabled)?_c('li',[_c('a',{on:{"click":function($event){_vm.healthCartClicked()}}},[_c('span',{staticClass:"sprites sprite-care"}),_vm._v(" "),_c('span',{staticClass:"menu-label"},[_vm._v("Health Cart")]),_vm._v(" "),(_vm.cartCount > 0)?_c('span',{staticClass:"count-cart"},[_vm._v(_vm._s(_vm.cartCount))]):_vm._e()])]):_vm._e()])])])]):_vm._e(),_vm._v(" "),((_vm.step))?_c('div',{staticClass:"container-fluid"}):_vm._e(),_vm._v(" "),_c('Login')],1),_vm._v(" "),_c('div',{staticClass:"modal fade",attrs:{"id":"Health-cartpopup","tabindex":"-1","role":"dialog","aria-labelledby":"Health-cartpopups","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_vm._m(3,false,false),_vm._v(" "),_c('div',{staticClass:"modal-body health-cart-popup"},[_c('div',{staticClass:"container-fluid"},[(_vm.selectedProfileAndTest && _vm.selectedProfileAndTest.length > 0)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[(_vm.lab && _vm.testCosts)?_c('div',[(_vm.selectedProfileAndTest && _vm.selectedProfileAndTest.length > 0)?_c('div',{staticClass:"alert alert-success mb-0 drop-shadow"},[_vm._v("\n                                    Test(s) and/or Panel(s) and Lab added to health cart\n                                ")]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.lab && _vm.testCosts)?_c('div',{staticClass:"lab display-flex no-border p-0 mt-3 bg-tranparent"},[_c('div',{staticClass:"flex-box"},[_c('div',{staticClass:"lab-logo"},[(_vm.lab.logo && _vm.lab.logo.length > 0)?_c('img',{attrs:{"src":_vm.lab.logo}}):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"flex-box"},[_c('p',{staticClass:"black-color font-weight-bold mb-2"},[_vm._v("\n                                        "+_vm._s(_vm.lab.labName)+" "+_vm._s(_vm.lab.branch.branchLocation+', '+_vm.lab.branch.branchCity+' - '+_vm.lab.branch.branchZipCode)+"\n                                    ")]),_vm._v(" "),_c('a',{staticClass:"text-uppercase font-weight-bold",attrs:{"href":"javascript:void(0)","data-dismiss":"modal"},on:{"click":function($event){_vm.goToLab()}}},[_vm._v("Change Lab")])])]):_vm._e(),_vm._v(" "),(_vm.lab && _vm.testCosts && _vm.testCosts.priceDetails && _vm.testCosts.priceDetails.length > 0)?_c('div',{staticClass:"table-responsive test-conformation"},[_c('table',{staticClass:"table"},[_c('tbody',{staticClass:"black-color"},_vm._l((_vm.testCosts.priceDetails),function(testProfile,index){return _c('tr',{key:index},[_c('td',[_vm._v(_vm._s(testProfile.aliasName))]),_vm._v(" "),_c('td',[(parseInt(testProfile.actualPrice) > parseInt(testProfile.ourPrice))?_c('p',{staticClass:"red-color  mt-1 mb-0 strip-text text-nowrap"},[_vm._v("Rs. "+_vm._s(testProfile.actualPrice))]):_vm._e()]),_vm._v(" "),_c('td',[_c('p',{staticClass:"float-right mt-1 mb-0 price-tag"},[_vm._v("\n                                                    Rs. "+_vm._s(testProfile.ourPrice)+"\n                                                ")])]),_vm._v(" "),_c('td',[_c('button',{staticClass:"btn btn-link remove-btn p-0",on:{"click":function($event){$event.preventDefault();_vm.removeSelectedItemsInLab(testProfile)}}},[_c('img',{attrs:{"src":_vm.closeImg,"alt":""}})])])])})),_vm._v(" "),_c('tfoot',{staticClass:"border-bottom"},[_c('tr',[_c('td',[_vm._v("Sub total")]),_vm._v(" "),_c('td'),_vm._v(" "),_c('td',[_c('p',{staticClass:"float-right mt-1 mb-0 price-tag"},[_vm._v("\n                                                    Rs. "+_vm._s(_vm.testCosts.ourPrice)+"\n                                                ")])])])])])]):_vm._e(),_vm._v(" "),(!_vm.lab && _vm.selectedProfileAndTest)?_c('div',[(_vm.selectedProfileAndTest && _vm.selectedProfileAndTest.length > 0)?_c('div',{staticClass:"alert alert-success mb-0 drop-shadow"},[_vm._m(4,false,false),_vm._v(" Test(s) and/or Panel(s)\n                                    added to health cart\n                                ")]):_vm._e()]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-12"},[(!_vm.lab && _vm.selectedProfileAndTest)?_c('div',{staticClass:"table-responsive test-conformation"},[_c('table',{staticClass:"table"},[_c('tbody',{staticClass:"black-color"},_vm._l((_vm.selectedProfileAndTest),function(testProfile,index){return _c('tr',{key:index},[_c('td',[_vm._v("\n                                                "+_vm._s(testProfile.name)+"\n                                            ")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_c('button',{staticClass:"btn btn-link remove-btn p-0",on:{"click":function($event){$event.preventDefault();_vm.removeSelectedItems(testProfile)}}},[_c('img',{attrs:{"src":"static/images/close-black.svg","alt":""}})])])])}))])]):_vm._e(),_vm._v(" "),_c('a',{staticClass:"btn btn-outline-primary",attrs:{"href":"javascript:void(0)"},on:{"click":function($event){_vm.backTest()}}},[_vm._v(" \n                                            Add Test\n                                        ")])])]):_vm._e()])])])]),_vm._v(" "),_c('div',{staticClass:"fixed-footer p-0",attrs:{"id":"fixed-footer-cart"}},[(!_vm.lab)?_c('button',{staticClass:"btn btn-primary full-width fixed-button",attrs:{"data-dismiss":"modal"},on:{"click":function($event){_vm.selectLab()}}},[_vm._v("\n                        Select Lab\n                    ")]):_vm._e(),_vm._v(" "),(_vm.lab)?_c('button',{staticClass:"btn btn-primary full-width fixed-button",on:{"click":function($event){_vm.proccedtoHealthCart()}}},[_vm._v("Proceed to health cart")]):_vm._e()])])]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading"},[_c('div',{staticClass:"loading-img"},[_c('img',{attrs:{"src":"static/images/icon/loading.gif","alt":""}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid pt-3"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"close-hamburger"},[_c('i',{staticClass:"material-icons"},[_vm._v("close")])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"menu",staticStyle:{"cursor":"pointer"}},[_c('i',{staticClass:"material-icons"},[_vm._v("menu")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"menu_popup",attrs:{"data-dismiss":"modal","aria-label":"Close"}},[_c('i',{staticClass:"material-icons"},[_vm._v("arrow_back")])]),_vm._v(" "),_c('h3',{staticClass:"screen-title mt-13p"},[_vm._v("Health Cart")])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('strong',[_c('i',{staticClass:"material-icons float-left mr-2"},[_vm._v("check")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var mobile_Header = (esExports);
// CONCATENATED MODULE: ./src/components/mobile/Header.vue
function injectStyle (ssrContext) {
  __webpack_require__("nPLH")
  __webpack_require__("EEKS")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-371dd6bb"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  Header,
  mobile_Header,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_mobile_Header = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Wycz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YA2l":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YZfp":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "Ymwl":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ZgSQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ZrO4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ZzA+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "b1zr":
/***/ (function(module, exports) {

$(document).ready(function(){
  var footerHeight = $('.fixed-footer').outerHeight();
  $('body').css('padding-bottom', footerHeight + 15);
});
$(document).ready(function(){
  $('.black-layout').hide();
  $('.menu').click(function(){
    $('.black-layout').show();
    $('.hamburger-menu').addClass('show-menu');
    $('body').css('overflow', 'hidden');
  });
  $('.close-hamburger').click(function(){
    $('.black-layout').hide();
    $('.hamburger-menu').removeClass('show-menu');
    $('body').css('overflow', 'auto');
  });
  $('.fly-msg').click(function(){
    $('#message1').toggleClass('in');
    setTimeout(function() {$('#message1').toggleClass('in');}, 3000);
  });
});

// $(document).ready(function() {
//   $('.menu-list>li>router-link').click(function(){
//       $('.black-layout').show();
//   });
// })

/***/ }),

/***/ "cepg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "chxB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "d0wn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "dVo2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "dyeu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ejIc":
/***/ (function(module, exports) {

module.exports = {"sha224WithRSAEncryption":{"sign":"rsa","hash":"sha224","id":"302d300d06096086480165030402040500041c"},"RSA-SHA224":{"sign":"ecdsa/rsa","hash":"sha224","id":"302d300d06096086480165030402040500041c"},"sha256WithRSAEncryption":{"sign":"rsa","hash":"sha256","id":"3031300d060960864801650304020105000420"},"RSA-SHA256":{"sign":"ecdsa/rsa","hash":"sha256","id":"3031300d060960864801650304020105000420"},"sha384WithRSAEncryption":{"sign":"rsa","hash":"sha384","id":"3041300d060960864801650304020205000430"},"RSA-SHA384":{"sign":"ecdsa/rsa","hash":"sha384","id":"3041300d060960864801650304020205000430"},"sha512WithRSAEncryption":{"sign":"rsa","hash":"sha512","id":"3051300d060960864801650304020305000440"},"RSA-SHA512":{"sign":"ecdsa/rsa","hash":"sha512","id":"3051300d060960864801650304020305000440"},"RSA-SHA1":{"sign":"rsa","hash":"sha1","id":"3021300906052b0e03021a05000414"},"ecdsa-with-SHA1":{"sign":"ecdsa","hash":"sha1","id":""},"sha256":{"sign":"ecdsa","hash":"sha256","id":""},"sha224":{"sign":"ecdsa","hash":"sha224","id":""},"sha384":{"sign":"ecdsa","hash":"sha384","id":""},"sha512":{"sign":"ecdsa","hash":"sha512","id":""},"DSA-SHA":{"sign":"dsa","hash":"sha1","id":""},"DSA-SHA1":{"sign":"dsa","hash":"sha1","id":""},"DSA":{"sign":"dsa","hash":"sha1","id":""},"DSA-WITH-SHA224":{"sign":"dsa","hash":"sha224","id":""},"DSA-SHA224":{"sign":"dsa","hash":"sha224","id":""},"DSA-WITH-SHA256":{"sign":"dsa","hash":"sha256","id":""},"DSA-SHA256":{"sign":"dsa","hash":"sha256","id":""},"DSA-WITH-SHA384":{"sign":"dsa","hash":"sha384","id":""},"DSA-SHA384":{"sign":"dsa","hash":"sha384","id":""},"DSA-WITH-SHA512":{"sign":"dsa","hash":"sha512","id":""},"DSA-SHA512":{"sign":"dsa","hash":"sha512","id":""},"DSA-RIPEMD160":{"sign":"dsa","hash":"rmd160","id":""},"ripemd160WithRSA":{"sign":"rsa","hash":"rmd160","id":"3021300906052b2403020105000414"},"RSA-RIPEMD160":{"sign":"rsa","hash":"rmd160","id":"3021300906052b2403020105000414"},"md5WithRSAEncryption":{"sign":"rsa","hash":"md5","id":"3020300c06082a864886f70d020505000410"},"RSA-MD5":{"sign":"rsa","hash":"md5","id":"3020300c06082a864886f70d020505000410"}}

/***/ }),

/***/ "h04o":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "h91p":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_web_Header__ = __webpack_require__("sSzK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_web_Footer__ = __webpack_require__("uTOX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_underscore__ = __webpack_require__("rdLu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_underscore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_underscore__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_dateformat__ = __webpack_require__("CqLJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_dateformat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_dateformat__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuejs_datepicker__ = __webpack_require__("XILU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuejs_datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vuejs_datepicker__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







__webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, "mTrH"));
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'SelectAddress',
  beforeCreate: function beforeCreate() {
    if (!this.$localStorage.get('loggedIn') || this.$localStorage.get('loggedIn') === null) {
      this.$router.push({ path: '/' });
    }
    if (!this.$localStorage.get('location') || !this.$localStorage.get('st')) {
      this.$router.push({ path: '/lab' });
    } else if (!this.$localStorage.get('sl')) {
      this.$router.push({ path: '/lab' });
    } else if (!this.$localStorage.get('ct')) {
      this.$router.push({ path: '/appointment' });
    } else if (!this.$localStorage.get('sa')) {
      this.$router.push({ path: '/address' });
    } else if (!this.$localStorage.get('sm')) {
      this.$router.push({ path: '/address' });
    }
  },

  components: {
    HeaderVue: __WEBPACK_IMPORTED_MODULE_2__components_web_Header__["a" /* default */],
    FooterVue: __WEBPACK_IMPORTED_MODULE_3__components_web_Footer__["a" /* default */],
    Datepicker: __WEBPACK_IMPORTED_MODULE_6_vuejs_datepicker___default.a
  },
  data: function data() {
    return {
      selectedLab: [],
      selectedProfileAndTest: [],
      activeAddress: [],
      activeMembers: [],
      testCosts: {},
      payinfo: {
        creditPoints: 0
      },
      addresses: {},
      members: {},
      isAddressActiveId: 0,
      isMemberActiveId: 0,
      isMe: true,
      addMemberForm: false,
      editMemberForm: false,
      addMemberFields: {
        firstName: '',
        lastName: '',
        sex: 'M',
        age: ''
      },
      editMemberFields: {},
      addAddressForm: false,
      editAddressForm: false,
      locationList: [],
      addAddressFields: {},
      editAddressFields: {},
      stateCityDisp: '',
      showLocOther: false,
      couponCode: '',
      couponData: undefined,
      couponError: '',
      isSuccessCoupon: false,
      profileDetails: {},
      map: undefined,
      marker: undefined,
      mapCoordinates: undefined,
      editMemberObj: {
        firstName: '',
        lastName: '',
        email: '',
        phone1: '',
        phone2: '',
        dob: undefined,
        sex: '',
        photo: '',
        address: {},
        disabled: {
          from: new Date()
        }
      },
      isDobError: false,
      dobYears: [],
      dobDate: [],
      year: '',
      month: '',
      ddate: '',
      addressZipCode: '',
      isInvalidPincode: false,
      onBlurKey: 'none',
      isCouponApplied: false,
      selectedLocality: undefined,
      termsCondition: false,
      termsConditionError: false,
      paymentType: '1',
      redeemCredits: false,
      redeemCreditPoints: '',
      toolCostExeeds: false
    };
  },

  watch: {
    redeemCredits: function redeemCredits() {
      if (this.redeemCredits) {
        this.redeemCreditPoints = this.payinfo.creditPoints;
        this.creditPointChanged();
      } else {
        this.redeemCreditPoints = 0;
        this.creditPointChanged();
      }
    }
  },
  methods: {
    creditPointChanged: function creditPointChanged() {
      if (this.payinfo.creditPoints && this.payinfo.creditPoints > 0) {
        if (this.payinfo.creditPoints < this.redeemCreditPoints) {
          this.redeemCreditPoints = this.payinfo.creditPoints;
        } else {
          if (this.redeemCreditPoints > this.payinfo.grandTotal) {
            this.toolCostExeeds = true;
            setTimeout(function () {
              this.toolCostExeeds = false;
            }.bind(this), 2000);
            this.redeemCreditPoints = this.payinfo.grandTotal;
          }
        }
      }
    },
    termsConditionChanged: function termsConditionChanged(type, data) {
      this.termsConditionError = false;
      if (type == 1) {
        if (this.termsCondition) {
          $('#termsAndCondition').modal('show');
        }
      } else if (type == 0) {
        if (data) {
          this.termsCondition = true;
        }
        $('#termsAndCondition').modal('hide');
        $('#privacyPolicy').modal('hide');
      } else if (type == 2) {
        $('#termsAndCondition').modal('show');
      } else if (type == 3) {
        $('#privacyPolicy').modal('show');
      }
    },
    getNumberOfDays: function getNumberOfDays(dateVal) {
      if (this.year && this.year !== '' && this.month && this.month !== '') {
        var noOfDays = new Date(this.year, this.month, 0).getDate();
        this.dobDate = [];
        for (var j = 1; j <= noOfDays; j++) {
          this.dobDate.push(j.toString());
        }
        if (dateVal) {
          this.ddate = dateVal;
        } else {
          if (this.ddate) {
            var res = true;
            this.dobDate.forEach(function (dataV) {
              if (parseInt(dataV) === parseInt(this.ddate)) {
                res = false;
              }
            }.bind(this));
            if (res) {
              this.ddate = '';
            }
          }
        }
      }
      return false;
    },
    goPayment: function goPayment(zeroPayment) {
      this.termsConditionError = false;
      if (!this.$localStorage.get('st')) {
        this.$Simplert.open({
          title: 'Alert',
          message: 'Please select a test or profile',
          type: 'warning',
          disableOverlayClick: true,
          showXclose: true,
          useConfirmBtn: false,
          customCloseBtnText: 'OK'
        });
        return false;
      } else if (!this.$localStorage.get('sl')) {
        this.$Simplert.open({
          title: 'Alert',
          message: 'Please select a lab',
          type: 'warning',
          disableOverlayClick: true,
          showXclose: true,
          useConfirmBtn: false,
          customCloseBtnText: 'OK'
        });
        return false;
      } else if (!this.$localStorage.get('ct')) {
        this.$Simplert.open({
          title: 'Alert',
          message: 'Please select your apoointment date and time',
          type: 'warning',
          disableOverlayClick: true,
          showXclose: true,
          useConfirmBtn: false,
          customCloseBtnText: 'OK'
        });
        return false;
      } else if (!this.$localStorage.get('sa')) {
        this.$Simplert.open({
          title: 'Alert',
          message: 'Please select or add your address',
          type: 'warning',
          disableOverlayClick: true,
          showXclose: true,
          useConfirmBtn: false,
          customCloseBtnText: 'OK'
        });
        return false;
      } else if (!this.$localStorage.get('sm')) {
        this.$Simplert.open({
          title: 'Alert',
          message: 'Please select your member',
          type: 'warning',
          disableOverlayClick: true,
          showXclose: true,
          useConfirmBtn: false,
          customCloseBtnText: 'OK'
        });
        return false;
      } else {
        __WEBPACK_IMPORTED_MODULE_1_vue__["default"].analytics.fbq.event('ViewContent', {
          content_ids: 0,
          content_name: 'PAYMENT INITIATED',
          contents: '',
          content_type: 'PAYMENT_INITIATED'
        });
        if (!this.termsCondition) {
          this.termsConditionError = true;
          return false;
        }
        if (this.paymentType == '2' || zeroPayment) {
          if (!zeroPayment) {
            this.$Simplert.open({
              title: 'Information',
              message: '\n                  <div style="text-align: left; line-height: 20px;">\n                    <p>Please make arrangements to pay <b>Rs.' + (this.payinfo.grandTotal - this.redeemCreditPoints) + '</b> as cash to the Phlebotomist when he/she visits to collect sample. </p>\n                    <p>If there are any changes to your schedule, please call ahead to reschedule. Uninformed cancelation will result in loss of time & money for our Phlebotomists.</p>\n                    <p>Thanks for understanding. </p>\n                  </div>',
              type: 'info',
              useConfirmBtn: true,
              onConfirm: function () {
                this.saveRequestCash();
              }.bind(this),
              customConfirmBtnText: 'Ok',
              customCloseBtnText: 'Cancel',
              disableOverlayClick: true
            });
          } else {
            this.saveRequestCash(zeroPayment);
          }
        } else {
          this.saveRequestFirst();
        }
        return false;
      }
    },
    calculateAge: function calculateAge(birthday) {
      // birthday is a date
      var ageDifMs = Date.now() - birthday.getTime();
      var ageDate = new Date(ageDifMs); // miliseconds from epoch
      return Math.abs(ageDate.getUTCFullYear() - 1970);
    },
    getProfileOld: function getProfileOld() {
      try {
        this.profileDetails = {};
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(this.$GET('patient/getProfile', {})).then(function (res) {
          if (res.response_code === 0) {
            this.profileDetails['username'] = res.response.Patient.firstName + ' ' + res.response.Patient.lastName;
            this.profileDetails['firstName'] = res.response.Patient.firstName;
            this.profileDetails['lastName'] = res.response.Patient.lastName;
            this.profileDetails['photo'] = res.response.Patient.photo;
            this.profileDetails['dob'] = __WEBPACK_IMPORTED_MODULE_5_dateformat___default()(res.response.Patient.dob, 'dd-mm-yyyy');
            this.profileDetails['phone1'] = res.response.Patient.phone1;
            this.profileDetails['phone2'] = res.response.Patient.phone2;
            this.profileDetails['sex'] = res.response.Patient.sex;
            this.profileDetails['email'] = res.response.email;
            if (res.response.Patient.dob) {
              this.profileDetails['age'] = this.calculateAge(new Date(res.response.Patient.dob));
            } else {
              this.profileDetails['age'] = 0;
            }
          }
        }.bind(this)).catch(function (err) {
          console.log(err);
        });
      } catch (e) {
        console.log(e);
      }
    },
    searchLocation: function searchLocation(pincode) {
      try {
        if (this.$localStorage.get('access_token') && this.$localStorage.get('access_token') !== null) {
          var data = {
            'zipcode': pincode
          };
          __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(this.$GET('patient/getAddressByPincode', data)).then(function (res) {
            if (res.response_code === 0) {
              this.locationList = res.response;
            }
          }.bind(this)).catch(function (err) {
            console.error(err);
          });
        }
      } catch (e) {
        console.error(e);
      }
    },
    searchLocality: function searchLocality(type) {
      this.isInvalidPincode = false;
      if (type === 1) {
        if (!this.editAddressFields.locality || this.editAddressFields.zipcode !== this.editAddressFields.locality.locationName + '-' + this.editAddressFields.locality.locationZipCode) {
          this.onBlurKey = 'block';
          this.editAddressFields.locality = undefined;
          try {
            if (this.$localStorage.get('access_token') && this.$localStorage.get('access_token') !== null) {
              var data = {
                'keyword': this.editAddressFields.zipcode,
                'city': this.$localStorage.get('sc') ? this.$localStorage.get('sc').cityId : 0
              };
              __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(this.$POST('patient/searchLocation', data)).then(function (res) {
                if (res.response_code === 0) {
                  this.locationList = res.response;
                } else {
                  this.locationList = [];
                }
              }.bind(this)).catch(function (err) {
                console.error(err);
              });
            }
          } catch (e) {
            console.error(e);
          }
        }
      } else if (type === 2) {
        if (!this.addAddressFields.locality || this.addAddressFields.zipcode !== this.addAddressFields.locality.locationName + '-' + this.addAddressFields.locality.locationZipCode) {
          this.onBlurKey = 'block';
          this.addAddressFields.locality = undefined;
          try {
            if (this.$localStorage.get('access_token') && this.$localStorage.get('access_token') !== null) {
              var _data = {
                'keyword': this.addAddressFields.zipcode,
                'city': this.$localStorage.get('sc') ? this.$localStorage.get('sc').cityId : 0
              };
              __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(this.$POST('patient/searchLocation', _data)).then(function (res) {
                if (res.response_code === 0) {
                  this.locationList = res.response;
                } else {
                  this.locationList = [];
                }
              }.bind(this)).catch(function (err) {
                console.error(err);
              });
            }
          } catch (e) {
            console.error(e);
          }
        }
      }
    },
    closeBlock: function closeBlock() {
      setTimeout(function () {
        this.onBlurKey = 'none';
      }.bind(this), 300);
    },
    selectLocation: function selectLocation(event, obj, type) {
      this.isInvalidPincode = false;
      if (type === 1) {
        this.showLocOther = false;
        this.editAddressFields.locality = obj;
        this.editAddressFields.zipcode = obj.locationName + '-' + obj.locationZipCode;
        this.locationList = [];
        this.stateCityDisp = obj.City.cityName + ', ' + obj.State.stateName;
        this.mapWithAddressEdit(this.editAddressFields, 2);
      } else if (type === 2) {
        this.showLocOther = false;
        this.addAddressFields.locality = obj;
        this.addAddressFields.zipcode = obj.locationName + '-' + obj.locationZipCode;
        this.locationList = [];
        this.stateCityDisp = obj.City.cityName + ', ' + obj.State.stateName;
        this.mapWithAddressAdd(this.addAddressFields, 2);
      } else if (type === 3) {
        this.addAddressFields.locality = 'OTHER';
        this.addAddressFields.zipcode = 'OTHER';
        this.editAddressFields.locality = 'OTHER';
        this.editAddressFields.zipcode = 'OTHER';
        this.showLocOther = true;
        this.stateCityDisp = this.selectedLocality.City.cityName + ',' + this.selectedLocality.State.stateName;
      }
    },
    getTestCosts: function getTestCosts(lab) {
      try {
        var labTestCosts = [];
        if (this.$localStorage.get('sl')) {
          if (this.$localStorage.get('sl').labTestList.length > 0) {
            __WEBPACK_IMPORTED_MODULE_4_underscore___default.a.each(this.$localStorage.get('sl').labTestList, function (element) {
              labTestCosts.push(element.labProfileId);
            });
          }
        }
        var data = {
          'labId': this.$localStorage.get('sl') ? this.$localStorage.get('sl').labId : '0',
          'labTests': labTestCosts
        };
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(this.$POST('patient/getTestCosts', data)).then(function (res) {
          if (res.response_code === 0) {
            if (res.response) {
              this.testCosts = res.response;
              // let payinfo = {}
              // payinfo['mrpTotal'] = res.response.mrp
              // payinfo['phlebotomistFee'] = this.$phlebotomistFee
              // payinfo['subTotal'] = (payinfo.mrpTotal + payinfo.phlebotomistFee)
              // payinfo['labDiscount'] = res.response.youSaved
              // payinfo['phlebotomyFeeWaiver'] = ((payinfo.mrpTotal - payinfo.labDiscount) > this.$waiverDiscountApplyFee) ? this.$phlebotomyFeeWaiver : 0
              // payinfo['total'] = payinfo.subTotal - (payinfo.labDiscount + payinfo.phlebotomyFeeWaiver)
              // payinfo['gst'] = Math.round(((payinfo.total) * this.$GSTFee) / 100)
              // payinfo['grandTotal'] = (payinfo.total + payinfo.gst)
              // this.payinfo = payinfo
            }
          }
        }.bind(this)).catch(function (err) {
          console.error(err);
        });
      } catch (e) {
        console.log(e);
      }
    },
    getAddress: function getAddress() {
      try {
        var data = {};
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(this.$GET('patient/getAddress', data)).then(function (res) {
          if (res.response.length > 0) {
            this.addresses = res.response;
            if (this.isAddressActiveId === 0) {
              __WEBPACK_IMPORTED_MODULE_4_underscore___default.a.each(res.response, function (addresses) {
                if (this.selectedLocality.locationId === addresses.Location.locationId) {
                  if (this.isAddressActiveId > 0) {
                    return false;
                  }
                  this.activeAddress = addresses;
                  this.$localStorage.set('sa', addresses, 30 * 60 * 1000);
                  this.isAddressActiveId = addresses.addressId;
                }
              }, this);
              return false;
            }
            __WEBPACK_IMPORTED_MODULE_4_underscore___default.a.each(res.response, function (element) {
              if (element.addressId === this.isAddressActiveId) {
                if (element.Location.CityControl.cityId === this.$localStorage.get('sc').cityId) {
                  this.activeAddress = element;
                  this.$localStorage.set('sa', element, 30 * 60 * 1000);
                  this.isAddressActiveId = element.addressId;
                } else {
                  this.activeAddress = undefined;
                  this.$localStorage.remove('sa');
                  this.isAddressActiveId = 0;
                }
              }
            }, this);
          }
        }.bind(this)).catch(function (err) {
          console.error(err);
        });
      } catch (e) {
        console.log(e);
      }
    },
    getMembers: function getMembers() {
      try {
        var data = {};
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(this.$GET('patient/getUserAndFamily', data)).then(function (res) {
          this.members = res.response;
          if (res.response.user) {
            if (this.$localStorage.get('sm')) {
              if (this.$localStorage.get('sm').userId === undefined) {
                this.isMemberActiveId = this.$localStorage.get('sm').memberId;
                this.isMe = false;
              } else {
                this.isMemberActiveId = this.$localStorage.get('sm').userId;
                this.isMe = true;
              }
            } else {
              this.isMemberActiveId = res.response.user.userId;
              this.$localStorage.set('sm', res.response.user, 30 * 60 * 1000);
              this.isMe = true;
            }
          }
        }.bind(this)).catch(function (err) {
          console.error(err);
        });
      } catch (e) {
        console.log(e);
      }
    },
    addMember: function addMember() {
      this.addMemberFields = {
        firstName: '',
        lastName: '',
        sex: 'M',
        age: '',
        mobile: ''
      };
      setTimeout(function () {
        this.errors.items = [];
      }.bind(this), 200);
      this.editMemberForm = false;
      this.addAddressForm = false;
      this.editAddressForm = false;
      $('#addPatientProfileModal').modal('show');
    },
    editMemberProfile: function editMemberProfile(type) {
      if (type === 1) {
        $('#editMemberProfileModal').modal('show');
        this.getProfile();
      }
    },
    getProfile: function getProfile() {
      try {
        if (this.$localStorage.get('loggedIn') && this.$localStorage.get('access_token') !== '') {
          var data = {};
          __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(this.$GET('patient/getProfile', data)).then(function (res) {
            if (res.response_code === 0) {
              if (res.response) {
                __WEBPACK_IMPORTED_MODULE_4_underscore___default.a.each(res.response.Addresses, function (item) {
                  if (item.isDefault === 1) {
                    this.address = item.address;
                  }
                });
              }
              this.editMemberObj['firstName'] = res.response.Patient.firstName;
              this.editMemberObj['lastName'] = res.response.Patient.lastName;
              this.editMemberObj['email'] = res.response.email;
              this.editMemberObj['phone1'] = res.response.Patient.phone1;
              this.editMemberObj['phone2'] = res.response.Patient.phone2;
              this.editMemberObj['dob'] = res.response.Patient.dob ? res.response.Patient.dob : undefined;
              this.editMemberObj['sex'] = res.response.Patient.sex;

              this.profileDetails['username'] = res.response.Patient.firstName + ' ' + res.response.Patient.lastName;
              this.profileDetails['firstName'] = res.response.Patient.firstName;
              this.profileDetails['lastName'] = res.response.Patient.lastName;
              this.profileDetails['photo'] = res.response.Patient.photo;
              this.profileDetails['dob'] = __WEBPACK_IMPORTED_MODULE_5_dateformat___default()(res.response.Patient.dob, 'dd-mm-yyyy');
              this.profileDetails['phone1'] = res.response.Patient.phone1;
              this.profileDetails['phone2'] = res.response.Patient.phone2;
              this.profileDetails['sex'] = res.response.Patient.sex;
              this.profileDetails['email'] = res.response.email;
              if (res.response.Patient.dob) {
                this.profileDetails['age'] = this.calculateAge(new Date(res.response.Patient.dob));
              } else {
                this.profileDetails['age'] = 0;
              }
              if (res.response.Patient.dob && res.response.Patient.dob !== null) {
                var dob = res.response.Patient.dob.split('T');
                var dobDate = dob[0].split('-');
                this.year = dobDate[0];
                this.month = dobDate[1];
                this.getNumberOfDays(dobDate[2]);
              }
            }
            this.$hidePageLoading();
          }.bind(this)).catch(function (err) {
            console.error(err);
          });
        }
      } catch (e) {
        console.error('method:getProfile', e);
      }
    },
    saveProfile: function saveProfile() {
      var _this = this;

      this.isDobError = false;
      this.$validator.validateAll('edit').then(function (result) {
        if (result) {
          if (_this.year.length !== 4 || _this.month.length <= 0 || _this.ddate.length <= 0) {
            _this.isDobError = true;
            return false;
          }
          try {
            var data = {
              'firstName': _this.editMemberObj.firstName,
              'lastName': _this.editMemberObj.lastName,
              'phone1': _this.editMemberObj.phone1,
              'phone2': _this.editMemberObj.phone2,
              'photo': '',
              'sex': _this.editMemberObj.sex,
              'dob': _this.year + '-' + _this.month + '-' + _this.ddate,
              'panNo': '',
              'aadharNo': '',
              'drivingLicenceNo': ''
            };
            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(_this.$POST('patient/updateProfile', data)).then(function (res) {
              if (res.response_code === 0) {
                this.$localStorage.remove('profile');
                var userDetails = {
                  'username': this.editMemberObj.firstName + ' ' + this.editMemberObj.lastName,
                  'firstName': this.editMemberObj.firstName,
                  'lastName': this.editMemberObj.lastName,
                  'phone1': this.editMemberObj.phone1,
                  'dob': __WEBPACK_IMPORTED_MODULE_5_dateformat___default()(this.editMemberObj.dob, 'yyyy-mm-dd', true),
                  'photo': ''
                };
                this.$localStorage.set('profile', userDetails, 0);
                this.getMembers();
                $('#editMemberProfileModal').modal('hide');
              }
            }.bind(_this)).catch(function (err) {
              console.error(err);
            });
          } catch (e) {
            console.error('method:saveProfile', e);
          }
        }
      });
    },
    editMember: function editMember(family) {
      this.addAddressForm = false;
      this.editAddressForm = false;
      this.addMemberForm = false;
      this.editMemberFields = family;
      $('#editPatientProfileModal').modal('show');
    },
    cancelMember: function cancelMember(type) {
      if (type === 1) {
        $('#editMemberProfileModal').modal('hide');
      } else if (type === 2) {
        $('#editPatientProfileModal').modal('hide');
        this.editMemberFields = {};
      } else if (type === 3) {
        $('#addPatientProfileModal').modal('hide');
        this.addMemberFields = {
          firstName: '',
          lastName: '',
          sex: 'M',
          age: ''
        };
      }
      this.errors.items = [];
      return false;
    },
    saveMember: function saveMember() {
      var _this2 = this;

      try {
        this.$validator.validateAll('addMember').then(function (result) {
          if (result) {
            if (_this2.$localStorage.get('access_token') && _this2.$localStorage.get('access_token') !== null) {
              var data = {
                firstName: _this2.addMemberFields.firstName,
                lastName: _this2.addMemberFields.lastName,
                sex: _this2.addMemberFields.sex,
                mobile: _this2.addMemberFields.mobile,
                age: _this2.addMemberFields.age
              };
              __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(_this2.$POST('patient/saveFamilyMember', data)).then(function (res) {
                if (res.response_code === 0) {
                  this.$localStorage.set('sm', res.response, 30 * 60 * 1000);
                  this.isMe = false;
                  this.getMembers();
                  this.addMemberForm = false;
                  this.editMemberForm = false;
                  this.addAddressForm = false;
                  this.editAddressForm = false;
                  this.addMemberFields = {};
                  this.errors.items = [];
                  $('#addPatientProfileModal').modal('hide');
                }
              }.bind(_this2)).catch(function (err) {
                console.error(err);
              });
            }
          }
        });
      } catch (e) {
        console.log(e);
      }
    },
    setActiveMemberId: function setActiveMemberId(member) {
      if (member.userId) {
        this.isMe = true;
      } else {
        this.isMe = false;
      }
      this.$localStorage.set('sm', member, 30 * 60 * 1000);
    },
    deleteMember: function deleteMember(member) {
      try {
        var confirmMemberFn = function () {
          if (this.$localStorage.get('access_token') && this.$localStorage.get('access_token') !== null) {
            var data = {
              memberId: member.memberId
            };
            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(this.$POST('patient/deleteFamilyMember', data)).then(function (res) {
              if (res.response_code === 0) {
                this.getMembers();
              }
            }.bind(this)).catch(function (err) {
              console.error(err);
            });
          }
        }.bind(this);
        this.$Simplert.open({
          title: 'Confirm',
          message: 'Are you sure confirm, you want to delete this member?',
          type: 'info',
          useConfirmBtn: true,
          onConfirm: confirmMemberFn,
          customConfirmBtnText: 'Ok',
          customCloseBtnText: 'Cancel',
          disableOverlayClick: true
        });
      } catch (e) {
        console.log(e);
      }
    },
    updateMember: function updateMember() {
      var _this3 = this;

      try {
        this.$validator.validateAll('editMember').then(function (result) {
          if (result) {
            if (_this3.$localStorage.get('access_token') && _this3.$localStorage.get('access_token') !== null) {
              var data = {
                memberId: _this3.editMemberFields.memberId,
                firstName: _this3.editMemberFields.firstName,
                lastName: _this3.editMemberFields.lastName,
                sex: _this3.editMemberFields.sex,
                mobile: _this3.editMemberFields.mobile,
                age: _this3.editMemberFields.age
              };
              __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(_this3.$POST('patient/updateFamilyMember', data)).then(function (res) {
                if (res.response_code === 0) {
                  this.$localStorage.set('sm', res.response, 30 * 60 * 1000);
                  this.isMemberActiveId = this.$localStorage.get('sm').memberId;
                  this.isMe = false;
                  this.getMembers();
                  this.addMemberForm = false;
                  this.editMemberForm = false;
                  this.addAddressForm = false;
                  this.editAddressForm = false;
                  this.editMemberFields = {};
                  $('#editPatientProfileModal').modal('hide');
                }
              }.bind(_this3)).catch(function (err) {
                console.error(err);
              });
            }
          }
        });
      } catch (e) {
        console.log(e);
      }
    },
    selectAddress: function selectAddress(address) {
      if (address.Location.CityControl.cityId === this.$localStorage.get('location').CityControl.cityId) {
        this.isAddressActiveId = address.addressId;
        this.$localStorage.set('sa', address, 30 * 60 * 1000);
      } else {
        var SecAlertObj = {};
        SecAlertObj = {
          title: 'Alert',
          message: 'The selected pickup address city (' + address.Location.CityControl.cityName + ') is not within the searched city (' + this.$localStorage.get('location').CityControl.cityName + '). Kindly provide the correct address.',
          type: 'warning',
          disableOverlayClick: true,
          showXclose: true,
          useConfirmBtn: false,
          customCloseBtnText: 'OK'
        };
        this.$Simplert.open(SecAlertObj);
      }
    },
    saveAddress: function saveAddress() {
      var _this4 = this;

      try {
        this.isInvalidPincode = false;
        this.$validator.validateAll('addAddress').then(function (result) {
          if (result) {
            if (_this4.addAddressFields.zipcode && _this4.addAddressFields.zipcode.length > 0 && !_this4.addAddressFields.locality && _this4.addAddressFields.locality !== 'OTHER') {
              _this4.isInvalidPincode = true;
              return false;
            }
            if (_this4.$localStorage.get('access_token') && _this4.$localStorage.get('access_token') !== null) {
              var data = {
                'addressName': _this4.addAddressFields.addressName,
                'flatNo': _this4.addAddressFields.flatNo,
                'address': _this4.addAddressFields.address,
                'landmark': _this4.addAddressFields.landmark,
                'locationOther': _this4.addAddressFields.locationOther ? _this4.addAddressFields.locationOther : '',
                'mobile': _this4.addAddressFields.mobile,
                'isDefault': 0,
                'coordinates': _this4.mapCoordinates
              };
              if (_this4.addAddressFields.locality === 'OTHER') {
                data['locationId'] = 0;
                data['cityId'] = _this4.$localStorage.get('sc') ? _this4.$localStorage.get('sc').cityId : 2;
                data['stateId'] = _this4.$localStorage.get('sc') ? _this4.$localStorage.get('sc').State ? _this4.$localStorage.get('sc').State.stateId : 2 : 2;
                data['zipCode'] = _this4.addAddressFields.locationPincode;
                if (isNaN(_this4.addAddressFields.locationPincode)) {
                  _this4.otherPincodeError = true;
                  return false;
                }
              } else {
                data['locationId'] = _this4.addAddressFields.locality.locationId;
                data['cityId'] = _this4.addAddressFields.locality.City.cityId;
                data['stateId'] = _this4.addAddressFields.locality.State.stateId;
                data['zipCode'] = _this4.addAddressFields.locality.locationZipCode;
              }
              __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(_this4.$POST('patient/saveAddress', data)).then(function (res) {
                if (res.response_code === 0) {
                  this.activeAddress = res.response;
                  this.$localStorage.set('sa', res.response, 30 * 60 * 1000);
                  this.isAddressActiveId = res.response.addressId;
                  this.getAddress();
                  this.addAddressFields = {};
                  $('#addAddressModal').modal('hide');
                } else {
                  this.$Simplert.open({
                    title: 'Information',
                    message: '<div style="text-align: left; line-height: 20px;">\n                              <p>' + res.response_message + '</p>\n                            </div>',
                    type: 'info',
                    useConfirmBtn: false,
                    customCloseBtnText: 'Ok',
                    disableOverlayClick: true
                  });
                }
              }.bind(_this4)).catch(function (err) {
                console.error(err);
              });
            }
          }
        });
      } catch (e) {
        console.log(e);
      }
    },
    updateAddress: function updateAddress() {
      var _this5 = this;

      try {
        this.isInvalidPincode = false;
        this.$validator.validateAll('editAddress').then(function (result) {
          if (result) {
            if (_this5.editAddressFields.zipcode && _this5.editAddressFields.zipcode.length > 0 && !_this5.editAddressFields.locality && _this5.editAddressFields.locality !== 'OTHER') {
              _this5.isInvalidPincode = true;
              return false;
            }
            if (_this5.$localStorage.get('access_token') && _this5.$localStorage.get('access_token') !== null) {
              var data = {
                'addressId': _this5.editAddressFields.addressId,
                'addressName': _this5.editAddressFields.addressName,
                'address': _this5.editAddressFields.address,
                'flatNo': _this5.editAddressFields.flatNo,
                'landmark': _this5.editAddressFields.landmark,
                'locationOther': _this5.editAddressFields.locationOther ? _this5.editAddressFields.locationOther : '',
                'mobile': _this5.editAddressFields.mobile,
                'isDefault': 0,
                'coordinates': _this5.mapCoordinates
              };
              if (_this5.editAddressFields.locality === 'OTHER') {
                data['locationId'] = 0;
                data['cityId'] = _this5.$localStorage.get('sc') ? _this5.$localStorage.get('sc').cityId : 0;
                data['stateId'] = _this5.$localStorage.get('sc') ? _this5.$localStorage.get('sc').State ? _this5.$localStorage.get('sc').State.stateId : 2 : 2;
                data['zipCode'] = _this5.editAddressFields.locationPincode;
              } else {
                data['locationId'] = _this5.editAddressFields.locality.locationId;
                data['cityId'] = _this5.editAddressFields.locality.City.cityId;
                data['stateId'] = _this5.editAddressFields.locality.State.stateId;
                data['zipCode'] = _this5.editAddressFields.locality.locationZipCode;
              }
              __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(_this5.$POST('patient/updateAddress', data)).then(function (res) {
                if (res.response_code === 0) {
                  this.isAddressActiveId = this.editAddressFields.addressId;
                  this.getAddress();
                  this.addAddressForm = false;
                  this.editAddressForm = false;
                  this.editAddressFields = {};
                  $('#editAddressModal').modal('hide');
                } else {
                  this.$Simplert.open({
                    title: 'Information',
                    message: '<div style="text-align: left; line-height: 20px;">\n                              <p>' + res.response_message + '</p>\n                            </div>',
                    type: 'info',
                    useConfirmBtn: false,
                    customCloseBtnText: 'Ok',
                    disableOverlayClick: true
                  });
                }
              }.bind(_this5)).catch(function (err) {
                console.error(err);
              });
            }
          }
        });
      } catch (e) {
        console.log('error', e);
      }
    },
    addAddress: function addAddress(value) {
      this.isInvalidPincode = false;
      this.addMemberForm = false;
      this.editMemberForm = false;
      this.addAddressForm = false;
      this.editAddressForm = false;
      this.showLocOther = false;
      var addFields = [];
      this.addressZipCode = '';
      addFields['addressId'] = '';
      addFields['addressName'] = this.$localStorage.get('profile').username;
      addFields['address'] = '';
      addFields['zipcode'] = this.$localStorage.get('location') ? this.$localStorage.get('location').locationName + '-' + this.$localStorage.get('location').locationZipCode : '';
      addFields['locationOther'] = '';
      addFields['mobile'] = this.$localStorage.get('profile').phone1;
      addFields['isDefault'] = 0;
      addFields['coordinates'] = '';
      addFields['state'] = undefined;

      if (this.$localStorage.get('location') && this.$localStorage.get('location').City && this.$localStorage.get('location').State) {
        addFields['cityId'] = this.$localStorage.get('location') ? this.$localStorage.get('location').City.cityId : 2;
        addFields['stateId'] = this.$localStorage.get('location') ? this.$localStorage.get('location').State.stateId : 2;
        addFields['locationId'] = this.$localStorage.get('location') ? this.$localStorage.get('location').locationId : 0;
        addFields['stateCityDisp'] = this.$localStorage.get('location').City.cityName + ', ' + this.$localStorage.get('location').State.stateName;
        addFields['locality'] = this.$localStorage.get('location');
        this.stateCityDisp = addFields['stateCityDisp'];
      } else {
        addFields['locality'] = '';
      }
      this.addAddressFields = addFields;
      this.mapWithAddressAdd(this.addAddressFields, 2);
      setTimeout(function () {
        $('#addAddressModal').modal('show');
      }, 300);
    },
    isNumber: function isNumber(evt) {
      if (!evt) {
        evt = window.event;
      }
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
        evt.preventDefault();
      } else {
        setTimeout(function () {
          this.onchangePincode();
        }.bind(this), 300);
        return true;
      }
    },
    onchangePincode: function onchangePincode() {
      if (this.addAddressFields.zipcode.length !== 6) {
        return false;
      }
      var data = {
        'pincode': this.addAddressFields.zipcode
      };
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(this.$GET('patient/getAddressByPincode', data)).then(function (res) {
        if (res.response.length > 0) {
          this.locationList = res.response;
        } else {
          this.locationList = [];
          this.addAddressFields.locality = '';
        }
      }.bind(this));
    },
    isNumberEdit: function isNumberEdit(evt) {
      if (!evt) {
        evt = window.event;
      }
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    onchangePincodeEdit: function onchangePincodeEdit() {
      if (this.editAddressFields.zipcode.length !== 6) {
        return false;
      }
      var data = {
        'pincode': this.editAddressFields.zipcode
      };
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(this.$GET('patient/getAddressByPincode', data)).then(function (res) {
        if (res.response.length > 0) {
          this.locationList = res.response;
        } else {
          this.locationList = [];
          this.editAddressFields.locality = '';
        }
      }.bind(this));
    },
    cancelModalPopup: function cancelModalPopup() {
      $('#addAddressModal').modal('hide');
      $('#editAddressModal').modal('hide');
      this.errors.items = [];
      this.addAddressFields = {};
      this.editAddressFields = {};
      this.addAddressForm = false;
      this.editAddressForm = false;
    },
    addressChanged: function addressChanged(type) {
      if (type === 1) {
        this.mapWithAddressAdd(this.addAddressFields, 2);
      } else {
        this.mapWithAddressEdit(this.editAddressFields, 2);
      }
    },
    editAddress: function editAddress(value) {
      try {
        // if (value.Location.CityControl.cityId !== this.$localStorage.get('sc').cityId) {
        //     let SecAlertObj = {
        //       title: 'Alert',
        //       message: `This address belongs to ${value.Location.CityControl.cityName} city. Please choose another or add new address.`,
        //       type: 'warning',
        //       disableOverlayClick: true,
        //       showXclose: true,
        //       useConfirmBtn: false,
        //       customCloseBtnText: 'OK'
        //     }
        //     this.$Simplert.open(SecAlertObj)
        //     return false
        // }
        this.isInvalidPincode = false;
        this.addMemberForm = false;
        this.editMemberForm = false;
        this.addAddressForm = false;
        this.editAddressForm = false;
        this.showLocOther = false;
        var editFields = [];
        editFields['addressId'] = value.addressId;
        editFields['addressName'] = value.addressName;
        editFields['address'] = value.address;
        editFields['flatNo'] = value.flatNo;
        editFields['landmark'] = value.landmark;
        editFields['zipcode'] = value.Location.locationName + '-' + value.Location.locationZipCode;
        editFields['locationOther'] = '';
        editFields['mobile'] = value.mobile;
        editFields['isDefault'] = 0;
        editFields['coordinates'] = value.coordinates;
        editFields['state'] = undefined;
        editFields['locality'] = value.Location;
        this.mapWithAddressEdit(value, 1);
        setTimeout(function () {
          $('#editAddressModal').modal('show');
        }, 500);
        editFields['cityId'] = value.Location ? value.Location.City.cityId : 2;
        editFields['stateId'] = value.Location ? value.Location.State.stateId : 2;
        editFields['locationId'] = value.Location ? value.Location.locationId : 0;
        editFields['stateCityDisp'] = value.Location.City.cityName + ', ' + value.Location.State.stateName;
        this.editAddressFields = editFields;
        this.stateCityDisp = editFields['stateCityDisp'];
        // var data = {
        //   'pincode': value.zipCode
        // }
        // Promise.resolve(this.$GET('patient/getAddressByPincode', data)).then(function (res) {
        //   if (res.response.length > 0) {
        //     this.locationList = res.response
        //     _.each(res.response, function (element) {
        //       if (element.locationId === value.Location.locationId) {
        //         editFields['cityId'] = (element) ? element.City.cityId : 2
        //         editFields['stateId'] = (element) ? element.State.stateId : 2
        //         editFields['locationId'] = (element) ? element.locationId : 0
        //         editFields['stateCityDisp'] = element.City.cityName + ', ' + element.State.stateName
        //         // myMap(undefined, 'map', 'coordinates_popup', this.editAddressFields.coordinates)
        //         if (element) {
        //           editFields['locality'] = element
        //         } else {
        //           editFields['locality'] = ''
        //         }
        //       }
        //     }, this)
        //     // this.editAddressForm = true
        //     this.editAddressFields = editFields
        //     this.stateCityDisp = editFields['stateCityDisp']
        //   }
        // }.bind(this)).catch(function (err) {
        //   console.error(err)
        // })
      } catch (e) {
        console.log('error', e);
      }
    },
    mapWithAddressAdd: function mapWithAddressAdd(value, type) {
      this.mapCoordinates = undefined;
      var address = '';
      var location = '';
      var stateCity = value.stateCityDisp;
      this.map = new google.maps.Map(document.getElementById('myMapAdd'), {
        zoom: 15,
        mapTypeId: google.maps.MapTypeId.ROADMAP
      });
      if (type === 2) {
        address = value.address;
        if (value.locality === 'OTHER') {
          location = value.locationOther;
        } else {
          location = value.locality.locationName;
        }
        this.map = new google.maps.Map(document.getElementById('myMapAdd'), {
          zoom: 17,
          mapTypeId: google.maps.MapTypeId.ROADMAP
        });
        var geocoder = new google.maps.Geocoder();
        geocoder.geocode({
          'address': address && location ? address + ' , ' + location + ', ' + stateCity : address && !location ? address + ', ' + stateCity : !address && location ? location + ', ' + stateCity : ''
        }, function (results, status) {
          if (status === 'OK') {
            this.marker = new google.maps.Marker({
              map: this.map,
              position: results[0].geometry.location
            });
            var latitude = results[0].geometry.location.lat();
            var longitude = results[0].geometry.location.lng();
            var latlng = new google.maps.LatLng(latitude, longitude);
            this.mapCoordinates = latitude + ',' + longitude;
            setTimeout(function () {
              google.maps.event.trigger(this.map, 'resize');
              this.map.setCenter(latlng);
              google.maps.event.trigger(this.map, 'resize');
            }.bind(this), 1000);
          } else {
            this.map = new google.maps.Map(document.getElementById('myMapAdd'), {
              zoom: 15,
              mapTypeId: google.maps.MapTypeId.ROADMAP
            });
            geocoder.geocode({ 'address': location + ', ' + stateCity }, function (resp, status) {
              if (status === 'OK') {
                this.map.setCenter(resp[0].geometry.location);
                this.marker = new google.maps.Marker({
                  map: this.map,
                  position: resp[0].geometry.location
                });
                var latitude = resp[0].geometry.location.lat();
                var longitude = resp[0].geometry.location.lng();
                var latlng = new google.maps.LatLng(latitude, longitude);
                setTimeout(function () {
                  google.maps.event.trigger(this.map, 'resize');
                  this.map.setCenter(latlng);
                  google.maps.event.trigger(this.map, 'resize');
                }.bind(this), 1000);
                this.mapCoordinates = this.map.center.lat() + ',' + this.map.center.lng();
              } else {
                geocoder.geocode({
                  'address': stateCity
                }, function (resp, status) {
                  if (status === 'OK') {
                    this.map.setCenter(resp[0].geometry.location);
                    this.marker = new google.maps.Marker({
                      map: this.map,
                      position: resp[0].geometry.location
                    });
                    var latitude = resp[0].geometry.location.lat();
                    var longitude = resp[0].geometry.location.lng();
                    var latlng = new google.maps.LatLng(latitude, longitude);
                    setTimeout(function () {
                      google.maps.event.trigger(this.map, 'resize');
                      this.map.setCenter(latlng);
                      google.maps.event.trigger(this.map, 'resize');
                    }.bind(this), 1000);
                    this.mapCoordinates = this.map.center.lat() + ',' + this.map.center.lng();
                  } else {
                    console.log('Geocode was not successful for the following reason: ' + status);
                  }
                }.bind(this));
              }
            }.bind(this));
          }
        }.bind(this));
      } else {
        var geocoder = new google.maps.Geocoder();
        geocoder.geocode({
          'address': stateCity
        }, function (resp, status) {
          if (status === 'OK') {
            this.map.setCenter(resp[0].geometry.location);
            this.marker = new google.maps.Marker({
              map: this.map,
              position: resp[0].geometry.location
            });
            var latitude = resp[0].geometry.location.lat();
            var longitude = resp[0].geometry.location.lng();
            var latlng = new google.maps.LatLng(latitude, longitude);
            setTimeout(function () {
              google.maps.event.trigger(this.map, 'resize');
              this.map.setCenter(latlng);
              google.maps.event.trigger(this.map, 'resize');
            }.bind(this), 1000);
            this.mapCoordinates = this.map.center.lat() + ',' + this.map.center.lng();
          } else {
            console.log('Geocode was not successful for the following reason: ' + status);
          }
        }.bind(this));
      }
      google.maps.event.addListener(this.map, 'click', function (event) {
        this.marker.setMap(null);
        this.marker = new google.maps.Marker({
          position: event.latLng
        });
        this.marker.setMap(this.map);
        this.mapCoordinates = event.latLng.lat() + ',' + event.latLng.lng();
      }.bind(this));
    },
    mapWithAddressEdit: function mapWithAddressEdit(value, type) {
      this.mapCoordinates = undefined;
      var address = '';
      var location = '';
      var city = value.City ? value.City.cityName : '';
      var state = value.State ? value.State.stateName : '';
      var stateCity = city + ', ' + state;
      if (type === 1) {
        address = value.address;
        location = value.Location.locationName;
        this.mapCoordinates = value.coordinates;
      } else {
        address = value.address;
        if (value.locality === 'OTHER') {
          location = value.locationOther;
        } else {
          location = value.locality.locationName;
        }
      }
      if (this.mapCoordinates && this.mapCoordinates.length > 0) {
        var cordinatesArray = this.mapCoordinates.split(',');
        this.map = new google.maps.Map(document.getElementById('myMapVal'), {
          zoom: 17,
          mapTypeId: google.maps.MapTypeId.ROADMAP
        });
        var latitude = parseFloat(cordinatesArray[0], 8);
        var longitude = parseFloat(cordinatesArray[1], 8);
        var latlng = new google.maps.LatLng(latitude, longitude);
        this.marker = new google.maps.Marker({
          map: this.map,
          position: latlng
        });
        setTimeout(function () {
          this.map.setCenter(latlng);
          google.maps.event.trigger(this.map, 'resize');
          this.map.setCenter(latlng);
          google.maps.event.trigger(this.map, 'resize');
        }.bind(this), 1000);
      } else {
        this.map = new google.maps.Map(document.getElementById('myMapVal'), {
          zoom: 17,
          mapTypeId: google.maps.MapTypeId.ROADMAP
        });
        var geocoder = new google.maps.Geocoder();

        geocoder.geocode({
          'address': address + ' , ' + location + ', ' + stateCity
        }, function (results, status) {
          if (status === 'OK') {
            this.marker = new google.maps.Marker({
              map: this.map,
              position: results[0].geometry.location
            });
            var latitude = results[0].geometry.location.lat();
            var longitude = results[0].geometry.location.lng();
            var latlng = new google.maps.LatLng(latitude, longitude);
            this.mapCoordinates = latitude + ',' + longitude;
            setTimeout(function () {
              google.maps.event.trigger(this.map, 'resize');
              this.map.setCenter(latlng);
              google.maps.event.trigger(this.map, 'resize');
            }.bind(this), 1000);
          } else {
            geocoder.geocode({ 'address': location + ', ' + stateCity }, function (resp, status) {
              if (status === 'OK') {
                this.map.setCenter(resp[0].geometry.location);
                this.marker = new google.maps.Marker({
                  map: this.map,
                  position: resp[0].geometry.location
                });
                var latitude = resp[0].geometry.location.lat();
                var longitude = resp[0].geometry.location.lng();
                var latlng = new google.maps.LatLng(latitude, longitude);
                setTimeout(function () {
                  google.maps.event.trigger(this.map, 'resize');
                  this.map.setCenter(latlng);
                  google.maps.event.trigger(this.map, 'resize');
                }.bind(this), 1000);
                this.mapCoordinates = this.map.center.lat() + ',' + this.map.center.lng();
              } else {
                geocoder.geocode({ 'address': stateCity }, function (resp, status) {
                  if (status === 'OK') {
                    this.map.setCenter(resp[0].geometry.location);
                    this.marker = new google.maps.Marker({
                      map: this.map,
                      position: resp[0].geometry.location
                    });
                    var latitude = resp[0].geometry.location.lat();
                    var longitude = resp[0].geometry.location.lng();
                    var latlng = new google.maps.LatLng(latitude, longitude);
                    setTimeout(function () {
                      google.maps.event.trigger(this.map, 'resize');
                      this.map.setCenter(latlng);
                      google.maps.event.trigger(this.map, 'resize');
                    }.bind(this), 1000);
                    this.mapCoordinates = this.map.center.lat() + ',' + this.map.center.lng();
                  } else {
                    console.log('Geocode was not successful for the following reason: ' + status);
                  }
                }.bind(this));
              }
            }.bind(this));
          }
        }.bind(this));
      }
      google.maps.event.addListener(this.map, 'click', function (event) {
        this.marker.setMap(null);
        this.marker = new google.maps.Marker({
          position: event.latLng
        });
        this.marker.setMap(this.map);
        this.mapCoordinates = event.latLng.lat() + ',' + event.latLng.lng();
      }.bind(this));
    },
    showAddOtherLocation: function showAddOtherLocation() {
      this.showLocOther = false;
      if (this.addAddressFields.locality === 'OTHER') {
        this.showLocOther = true;
        this.stateCityDisp = this.$localStorage.get('sc').cityName + ', ' + this.$localStorage.get('sc').State.stateName;
      } else {
        var jsonLocality = this.addAddressFields.locality;
        this.stateCityDisp = jsonLocality.City.cityName + ', ' + jsonLocality.State.stateName;
      }
      this.mapWithAddressAdd(this.addAddressFields, 2);
    },
    showEditOtherLocation: function showEditOtherLocation() {
      this.showLocOther = false;
      if (this.editAddressFields.locality === 'OTHER') {
        this.showLocOther = true;
        this.stateCityDisp = this.stateCityDisp;
      } else {
        var jsonLocality = this.editAddressFields.locality;
        this.stateCityDisp = jsonLocality.City.cityName + ', ' + jsonLocality.State.stateName;
      }
      this.mapWithAddressEdit(this.editAddressFields, 2);
    },
    deleteAddress: function deleteAddress(addressId) {
      var confirmFn = function () {
        var data = {
          addressId: addressId
        };
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(this.$POST('patient/deleteAddress', data)).then(function (res) {
          if (res.response.length > 0) {
            this.getAddress();
          }
        }.bind(this)).catch(function (err) {
          console.error(err);
        });
      }.bind(this);
      var obj = {};
      obj = {
        title: 'Confirm',
        message: 'Are you sure confirm, you want to delete this address?',
        type: 'info',
        useConfirmBtn: true,
        onConfirm: confirmFn,
        customConfirmBtnText: 'Ok',
        customCloseBtnText: 'Cancel',
        disableOverlayClick: true
      };
      this.$Simplert.open(obj);
    },
    applyCoupon: function applyCoupon() {
      var _this6 = this;

      this.$validator.validateAll('coupon').then(function (result) {
        if (result) {
          try {
            _this6.couponError = '';
            _this6.isSuccessCoupon = false;
            if (_this6.couponCode === '') {
              _this6.couponError = 'Please enter coupon code';
              return false;
            }
            var data = {
              'coupon_code': _this6.couponCode.toUpperCase()
            };

            if (_this6.$localStorage.get('sl')) {
              data['labId'] = _this6.$localStorage.get('sl').labId;
              var labProfileIds = [];
              if (_this6.$localStorage.get('sl') && _this6.$localStorage.get('sl').labTestList.length > 0) {
                _this6.$localStorage.get('sl').labTestList.forEach(function (element) {
                  if (element.labProfileId > 0) {
                    labProfileIds.push(element.labProfileId);
                  }
                });
              }
              data['labProfileIds'] = labProfileIds;
            } else {
              data['labId'] = 0;
              data['labProfileIds'] = [];
            }

            if (_this6.$localStorage.get('profile')) {
              data['email'] = _this6.$localStorage.get('profile').email;
            } else {
              data['email'] = '';
            }
            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(_this6.$POST('patient/applyCoupon', data)).then(function (res) {
              if (res.response_code === 0) {
                this.$localStorage.set('cou', res.response, 30 * 60 * 1000);
                this.isCouponApplied = true;
                this.couponData = res.response;
                this.couponError = '';
                if (res.response.coupon_percentage > 0) {
                  this.isSuccessCoupon = true;
                  this.couponError = res.response.coupon_percentage + '% ';
                } else {
                  this.isSuccessCoupon = true;
                  this.couponError = 'Rs.' + res.response.coupon_price + ' ';
                }
                this.getCartPaymentDetails();
              } else {
                this.$localStorage.remove('cou');
                if (res.response_code === 4) {
                  this.couponError = res.response_message + ' (Rs.' + res.response.coupon_range + ')';
                } else {
                  this.couponError = res.response_message;
                }
                this.getCartPaymentDetails();
              }
            }.bind(_this6)).catch(function (err) {
              console.error(err);
            });
          } catch (e) {
            console.log('error', e);
          }
        }
      });
    },
    removeCoupon: function removeCoupon() {
      this.$localStorage.remove('cou');

      if (this.redeemCredits) this.redeemCreditPoints = this.payinfo.creditPoints;else this.redeemCreditPoints = 0;

      this.getCartPaymentDetails();
      this.isCouponApplied = false;
      this.couponData = undefined;
      this.couponCode = '';
    },
    getCartPaymentDetails: function getCartPaymentDetails(isFirst) {
      try {
        var labTestCosts = [];
        if (this.$localStorage.get('sl')) {
          if (this.$localStorage.get('sl').labTestList.length > 0) {
            __WEBPACK_IMPORTED_MODULE_4_underscore___default.a.each(this.$localStorage.get('sl').labTestList, function (element) {
              labTestCosts.push(element.labProfileId);
            });
          }
        }
        var data = {
          'labId': this.$localStorage.get('sl') ? this.$localStorage.get('sl').labId : '0',
          'labTests': labTestCosts,
          'couponCode': this.$localStorage.get('cou') ? this.$localStorage.get('cou').coupon_code : '',
          'couponId': this.$localStorage.get('cou') ? this.$localStorage.get('cou').couponId : '0'
        };
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(this.$POST('patient/cartPaymentDetails', data)).then(function (res) {
          if (res.response_code === 0) {
            if (res.response) {
              var payinfo = {};
              payinfo['mrpTotal'] = res.response.mrpTotal;
              payinfo['phlebotomistFee'] = res.response.phlebotomistFee;
              payinfo['subTotal'] = res.response.subTotal;
              payinfo['labDiscount'] = res.response.labDiscount;
              payinfo['waiverDiscountApplyFee'] = res.response.waiverDiscountApplyFee;
              payinfo['phlebotomyFeeWaiver'] = res.response.phlebotomyFeeWaiver;
              payinfo['total'] = res.response.mrpTotal - res.response.labDiscount; // res.response.total
              payinfo['gst'] = res.response.gst;
              payinfo['couponFee'] = res.response.couponFee;
              payinfo['grandTotal'] = res.response.grandTotal;
              payinfo['grandTotalStrike'] = res.response.grandTotalStrike;
              payinfo['couponCode'] = res.response.couponCode;
              payinfo['couponId'] = res.response.couponId;
              payinfo['ourPrice'] = res.response.ourPrice;
              if (res.response.grandTotal <= 0) {
                this.payinfo.grandTotal = 0;
                payinfo['grandTotal'] = 0;
              }
              payinfo['priceDetails'] = res.response.priceDetails;
              payinfo['creditPoints'] = res.response.creditPoints;
              this.payinfo = payinfo;
              if (isFirst && this.payinfo.creditPoints && this.payinfo.creditPoints > 0) {
                this.redeemCredits = true;
              }
            }
          }
          this.$hidePageLoading();
          this.creditPointChanged();
        }.bind(this)).catch(function (err) {
          console.error(err);
        });
      } catch (e) {
        console.log(e);
      }
    },
    razorPayAssign: function razorPayAssign(data) {
      var self = this;
      var options = {
        'key': this.$razorpay_key,
        'amount': Math.ceil(data.request.totalCost) * 100, // 2000 paise = INR 20
        'name': 'Labotist Private Limited',
        'description': 'Health & Fitness',
        'image': 'https://labotist.com/dist/images/logo-svg.svg',
        'handler': function handler(response) {
          // alert(response.razorpay_payment_id)
          self.updateRequest(response);
        },
        'prefill': {
          'name': data.request.reqPatientFirstName + ' ' + data.request.reqPatientLastName,
          'email': data.request.reqPatientEmail,
          'contact': data.request.reqPatientMobile
        },
        'notes': {
          'address': data.request.pickupAddress,
          'requestId': data.request.requestId
        },
        'theme': {
          'color': '#057dc2',
          'emi_mode': false
        },
        order_id: data.order.id
      };
      Razorpay(options).open();
    },
    saveRequest: function saveRequest(paymentId) {
      this.$showPageLoading();
      try {
        var paymentData = {
          paymentId: paymentId
        };
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(this.$GET('payment/fetch', paymentData)).then(function (rzpInfo) {
          if (rzpInfo.response_code === 0) {
            var totalPaidCost = 0;
            if (rzpInfo) {
              totalPaidCost = rzpInfo.response.amount / 100;
            }
            var timezone = new Date().getTimezoneOffset();
            var appointmentDate = this.$localStorage.get('ct').dateFormatMoment;
            var appointmentTimeFrom = this.$localStorage.get('ct').startTime;
            var appointmentTimeTo = this.$localStorage.get('ct').endTime;
            var appointmentDateTimeFrom = this.$localStorage.get('ct').fromDateTime;
            var appointmentDateTimeTo = this.$localStorage.get('ct').toDateTime;
            var addressForRequest = '';
            if (this.$localStorage.get('sa').flatNo) {
              addressForRequest = addressForRequest + this.$localStorage.get('sa').flatNo + ', ';
            }

            addressForRequest = addressForRequest + this.$localStorage.get('sa').address + ', ';

            if (this.$localStorage.get('sa').landmark) {
              addressForRequest = addressForRequest + ', ' + this.$localStorage.get('sa').landmark + ', ';
            }

            var data = {
              'paymentId': paymentId,
              'labId': this.$localStorage.get('sl').labId,
              'branchId': this.$localStorage.get('sl').branchId,
              'appointmentDate': appointmentDate,
              'appointmentTimeFrom': appointmentTimeFrom,
              'appointmentTimeTo': appointmentTimeTo,
              'appointmentDateTimeFrom': appointmentDateTimeFrom,
              'appointmentDateTimeTo': appointmentDateTimeTo,
              'timezone': timezone,
              'pickupAddressId': this.$localStorage.get('sa').addressId,
              'pickupLocation': this.$localStorage.get('sa').Location.locationName,
              'pickupZipcode': this.$localStorage.get('sa').zipCode,
              'totalPaidCost': totalPaidCost,
              'actualCost': this.payinfo.subTotal,
              'discountCost': this.payinfo.labDiscount + this.payinfo.phlebotomyFeeWaiver,
              'gstCost': this.payinfo.gstCost,
              'couponCost': this.payinfo.couponFee,
              'couponCode': this.payinfo.couponCode,
              'couponId': this.payinfo.couponId,
              'totalCost': this.payinfo.grandTotal,
              'memberId': this.$localStorage.get('sm').memberId ? this.$localStorage.get('sm').memberId : 0,
              'reqPatientFirstName': this.$localStorage.get('sm').firstName,
              'reqPatientLastName': this.$localStorage.get('sm').lastName,
              'reqPatientSex': this.$localStorage.get('sm').sex,
              'reqPatientAge': this.$localStorage.get('sm').age,
              'reqPatientEmail': this.profileDetails.email,
              'reqPatientMobile': this.$localStorage.get('sa').mobile,
              'pickupAddress': addressForRequest + this.$localStorage.get('sa').Location.locationName + ', ' + this.$localStorage.get('sa').City.cityName + ', ' + this.$localStorage.get('sa').State.stateName + ' - ' + this.$localStorage.get('sa').zipCode,
              'pickupCoordinates': this.$localStorage.get('sa').coordinates
            };

            var labTests = [];
            var labProfiles = [];
            if (this.$localStorage.get('st').length > 0) {
              __WEBPACK_IMPORTED_MODULE_4_underscore___default.a.each(this.$localStorage.get('st'), function (element) {
                if (element.panelId > 0) {
                  labProfiles.push(element.panelId);
                } else {
                  labTests.push(element.testId);
                }
              });
            }
            data.test = labTests;
            data.profile = labProfiles;
            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(this.$POST('patient/saveRequest', data)).then(function (res) {
              if (res.response_code === 0) {
                this.clearRequestSessions();
                global.successId = res.response.requestId;
                __WEBPACK_IMPORTED_MODULE_1_vue__["default"].analytics.fbq.event('ViewContent', {
                  content_ids: 0,
                  content_name: 'PAYMENT COMPLETED',
                  contents: '',
                  content_type: 'PAYMENT_COMPLETED'
                });
                this.$router.push({ path: '/success', params: { sample: 'hi' } });
              }
            }.bind(this)).catch(function (err) {
              console.log('METHOD:saveRequest', err);
            });
          }
        }.bind(this)).catch(function (err) {
          console.log('METHOD:saveRequest', err);
        });
      } catch (err) {
        console.log('METHOD:saveRequest', err);
      }
    },
    updateRequest: function updateRequest(payment) {
      this.$showPageLoading();
      try {
        var data = {
          orderId: payment.razorpay_order_id,
          paymentId: payment.razorpay_payment_id
        };
        setTimeout(function () {
          __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(this.$POST('patient/updateRequest', data)).then(function (res) {
            if (res.response_code === 0) {
              global.successId = res.response.requestId;
              try {
                __WEBPACK_IMPORTED_MODULE_1_vue__["default"].analytics.fbq.event('ViewContent', {
                  content_ids: 0,
                  content_name: 'PAYMENT COMPLETED',
                  contents: '',
                  content_type: 'PAYMENT_COMPLETED'
                });
              } catch (err) {
                console.log(err);
              }
              this.$router.push({ path: '/success', params: { sample: 'hi' } });
            }
          }.bind(this)).catch(function (err) {
            console.log('METHOD:saveRequest', err);
          });
        }.bind(this), 2000);
      } catch (err) {
        console.log('METHOD:saveRequest', err);
      }
    },
    saveRequestFirst: function saveRequestFirst() {
      this.$showPageLoading();
      try {
        var timezone = new Date().getTimezoneOffset();
        var appointmentDate = this.$localStorage.get('ct').dateFormatMoment;
        var appointmentTimeFrom = this.$localStorage.get('ct').startTime;
        var appointmentTimeTo = this.$localStorage.get('ct').endTime;
        var appointmentDateTimeFrom = this.$localStorage.get('ct').fromDateTime;
        var appointmentDateTimeTo = this.$localStorage.get('ct').toDateTime;
        var addressForRequest = '';
        if (this.$localStorage.get('sa').flatNo) {
          addressForRequest = addressForRequest + this.$localStorage.get('sa').flatNo + ', ';
        }

        addressForRequest = addressForRequest + this.$localStorage.get('sa').address + ', ';

        if (this.$localStorage.get('sa').landmark) {
          addressForRequest = addressForRequest + this.$localStorage.get('sa').landmark + ', ';
        }
        var data = {
          'labId': this.$localStorage.get('sl').labId,
          'branchId': this.$localStorage.get('sl').branchId,
          'appointmentDate': appointmentDate,
          'appointmentTimeFrom': appointmentTimeFrom,
          'appointmentTimeTo': appointmentTimeTo,
          'appointmentDateTimeFrom': appointmentDateTimeFrom,
          'appointmentDateTimeTo': appointmentDateTimeTo,
          'timezone': timezone,
          'pickupAddressId': this.$localStorage.get('sa').addressId,
          'pickupLocation': this.$localStorage.get('sa').Location.locationName,
          'pickupZipcode': this.$localStorage.get('sa').zipCode,
          'totalPaidCost': 0,
          'actualCost': this.payinfo.subTotal,
          'discountCost': this.payinfo.labDiscount + this.payinfo.phlebotomyFeeWaiver,
          'gstCost': this.payinfo.gstCost,
          'couponCost': this.payinfo.couponFee,
          'couponCode': this.payinfo.couponCode,
          'couponId': this.payinfo.couponId,
          'totalCost': this.payinfo.grandTotal,
          'memberId': this.$localStorage.get('sm').memberId ? this.$localStorage.get('sm').memberId : 0,
          'reqPatientFirstName': this.$localStorage.get('sm').firstName,
          'reqPatientLastName': this.$localStorage.get('sm').lastName,
          'reqPatientSex': this.$localStorage.get('sm').sex,
          'reqPatientAge': this.$localStorage.get('sm').age,
          'reqPatientEmail': this.profileDetails.email,
          'reqPatientMobile': this.$localStorage.get('sm').mobile,
          'pickupAddress': addressForRequest + this.$localStorage.get('sa').Location.locationName + ', ' + this.$localStorage.get('sa').City.cityName + ', ' + this.$localStorage.get('sa').State.stateName + ' - ' + this.$localStorage.get('sa').zipCode,
          'pickupCoordinates': this.$localStorage.get('sa').coordinates,
          'redeemCredits': this.redeemCredits,
          'redeemCreditPoints': this.redeemCreditPoints
        };

        var labTests = [];
        var labProfiles = [];
        if (this.$localStorage.get('st').length > 0) {
          __WEBPACK_IMPORTED_MODULE_4_underscore___default.a.each(this.$localStorage.get('st'), function (element) {
            if (element.panelId > 0) {
              labProfiles.push(element.panelId);
            } else {
              labTests.push(element.testId);
            }
          });
        }
        data.test = labTests;
        data.profile = labProfiles;
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(this.$POST('patient/saveRequestBeforePayment', data)).then(function (res) {
          if (res.response_code === 0) {
            this.$hidePageLoading();
            this.razorPayAssign(res.response);
          } else if (res.response_code === 4) {
            this.$hidePageLoading();
            this.$Simplert.open({
              title: 'Information',
              message: '<div style="text-align: left; line-height: 20px;">\n                            <p>' + res.response_message + '</p>\n                          </div>',
              type: 'info',
              useConfirmBtn: false,
              customCloseBtnText: 'Ok',
              disableOverlayClick: true
            });
            this.getCartPaymentDetails();
          }
        }.bind(this)).catch(function (err) {
          console.log('METHOD:saveRequest', err);
        });
      } catch (err) {}
    },
    saveRequestCash: function saveRequestCash(zeroPayment) {
      this.$showPageLoading();
      try {
        var timezone = new Date().getTimezoneOffset();
        var appointmentDate = this.$localStorage.get('ct').dateFormatMoment;
        var appointmentTimeFrom = this.$localStorage.get('ct').startTime;
        var appointmentTimeTo = this.$localStorage.get('ct').endTime;
        var appointmentDateTimeFrom = this.$localStorage.get('ct').fromDateTime;
        var appointmentDateTimeTo = this.$localStorage.get('ct').toDateTime;
        var addressForRequest = '';
        if (this.$localStorage.get('sa').flatNo) {
          addressForRequest = addressForRequest + this.$localStorage.get('sa').flatNo + ', ';
        }

        addressForRequest = addressForRequest + this.$localStorage.get('sa').address + ', ';

        if (this.$localStorage.get('sa').landmark) {
          addressForRequest = addressForRequest + ', ' + this.$localStorage.get('sa').landmark + ', ';
        }
        var data = {
          'labId': this.$localStorage.get('sl').labId,
          'branchId': this.$localStorage.get('sl').branchId,
          'appointmentDate': appointmentDate,
          'appointmentTimeFrom': appointmentTimeFrom,
          'appointmentTimeTo': appointmentTimeTo,
          'appointmentDateTimeFrom': appointmentDateTimeFrom,
          'appointmentDateTimeTo': appointmentDateTimeTo,
          'timezone': timezone,
          'pickupAddressId': this.$localStorage.get('sa').addressId,
          'pickupLocation': this.$localStorage.get('sa').Location.locationName,
          'pickupZipcode': this.$localStorage.get('sa').zipCode,
          'totalPaidCost': 0,
          'actualCost': this.payinfo.subTotal,
          'discountCost': this.payinfo.labDiscount + this.payinfo.phlebotomyFeeWaiver,
          'gstCost': this.payinfo.gstCost,
          'couponCost': this.payinfo.couponFee,
          'couponCode': this.payinfo.couponCode,
          'couponId': this.payinfo.couponId,
          'totalCost': this.payinfo.grandTotal,
          'memberId': this.$localStorage.get('sm').memberId ? this.$localStorage.get('sm').memberId : 0,
          'reqPatientFirstName': this.$localStorage.get('sm').firstName,
          'reqPatientLastName': this.$localStorage.get('sm').lastName,
          'reqPatientSex': this.$localStorage.get('sm').sex,
          'reqPatientAge': this.$localStorage.get('sm').age,
          'reqPatientEmail': this.profileDetails.email,
          'reqPatientMobile': this.$localStorage.get('sm').mobile,
          // 'pickupAddress': this.$localStorage.get('sa').address + ', ' + this.$localStorage.get('sa').Location.locationName + ', ' + this.$localStorage.get('sa').City.cityName + ', ' + this.$localStorage.get('sa').State.stateName + ' - ' + this.$localStorage.get('sa').zipCode,
          'pickupAddress': addressForRequest + this.$localStorage.get('sa').Location.locationName + ', ' + this.$localStorage.get('sa').City.cityName + ', ' + this.$localStorage.get('sa').State.stateName + ' - ' + this.$localStorage.get('sa').zipCode,
          'pickupCoordinates': this.$localStorage.get('sa').coordinates,
          'paymentType': zeroPayment ? 0 : 1,
          'redeemCredits': this.redeemCredits,
          'redeemCreditPoints': this.redeemCreditPoints
        };

        var labTests = [];
        var labProfiles = [];
        if (this.$localStorage.get('st').length > 0) {
          __WEBPACK_IMPORTED_MODULE_4_underscore___default.a.each(this.$localStorage.get('st'), function (element) {
            if (element.panelId > 0) {
              labProfiles.push(element.panelId);
            } else {
              labTests.push(element.testId);
            }
          });
        }
        data.test = labTests;
        data.profile = labProfiles;
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(this.$POST('patient/saveRequestCash', data)).then(function (res) {
          if (res.response_code === 0) {
            global.successId = res.response.requestId;
            try {
              __WEBPACK_IMPORTED_MODULE_1_vue__["default"].analytics.fbq.event('ViewContent', {
                content_ids: 0,
                content_name: 'PAYMENT COMPLETED',
                contents: '',
                content_type: 'PAYMENT_COMPLETED'
              });
            } catch (err) {
              console.log(err);
            }
            this.$router.push({ path: '/success', params: { sample: 'hi' } });
          } else if (res.response_code === 4) {
            this.$hidePageLoading();
            this.$Simplert.open({
              title: 'Information',
              message: '<div style="text-align: left; line-height: 20px;">\n                            <p>' + res.response_message + '</p>\n                          </div>',
              type: 'info',
              useConfirmBtn: false,
              customCloseBtnText: 'Ok',
              disableOverlayClick: true
            });
            this.getCartPaymentDetails();
          }
        }.bind(this)).catch(function (err) {
          console.log('METHOD:saveRequest', err);
        });
      } catch (err) {}
    },
    clearRequestSessions: function clearRequestSessions() {
      this.$localStorage.remove('location');
      this.$localStorage.remove('st');
      this.$localStorage.remove('sl');
      this.$localStorage.remove('ct');
      this.$localStorage.remove('sa');
      this.$localStorage.remove('step');
      this.$localStorage.remove('cou');
    }
  },
  created: function created() {
    this.selectedLab = [];
    if (this.$localStorage.get('sl')) {
      this.selectedLab = this.$localStorage.get('sl');
    }
    if (this.$localStorage.get('location')) {
      this.selectedLocality = this.$localStorage.get('location');
    }

    this.selectedProfileAndTest = [];
    if (this.$localStorage.get('st')) {
      this.selectedProfileAndTest = this.$localStorage.get('st');
    }

    this.activeAddress = [];
    if (this.$localStorage.get('sa')) {
      this.activeAddress = this.$localStorage.get('sa');
      this.isAddressActiveId = this.$localStorage.get('sa').addressId;
    }

    this.activeMembers = [];
    if (this.$localStorage.get('sm')) {
      this.activeMembers = this.$localStorage.get('sm');
      if (this.$localStorage.get('sm').userId === undefined) {
        this.isMemberActiveId = this.$localStorage.get('sm').memberId;
      } else {
        this.isMemberActiveId = this.$localStorage.get('sm').userId;
      }
    }
    if (this.$localStorage.get('cou')) {
      this.isCouponApplied = true;
      this.couponData = this.$localStorage.get('cou');
      if (this.$localStorage.get('cou').coupon_percentage > 0) {
        this.isSuccessCoupon = true;
        this.couponError = this.$localStorage.get('cou').coupon_percentage + '% ';
      } else {
        this.isSuccessCoupon = true;
        this.couponError = 'Rs.' + this.$localStorage.get('cou').coupon_price + ' ';
      }
    }
    this.getProfile();
    this.getTestCosts();
    this.getAddress();
    this.getMembers();
    this.searchLocation(this.$localStorage.get('pincode'));
    this.getCartPaymentDetails(true);
    var year = new Date().getFullYear();
    var endYear = year - 120;
    for (var i = year; i > endYear; i--) {
      this.dobYears.push(i.toString());
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("DuR2")))

/***/ }),

/***/ "hPLD":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "jD0P":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "jHY5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_mobile_Header__ = __webpack_require__("Ucjp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_mobile_Footer__ = __webpack_require__("SN8v");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_underscore__ = __webpack_require__("rdLu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_underscore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_underscore__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_dateformat__ = __webpack_require__("CqLJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_dateformat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_dateformat__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





// import moment from 'moment'

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'PaymentSection',
  props: [],
  components: {
    HeaderVue: __WEBPACK_IMPORTED_MODULE_3__components_mobile_Header__["a" /* default */],
    FooterVue: __WEBPACK_IMPORTED_MODULE_4__components_mobile_Footer__["a" /* default */],
    'Razorpay': function Razorpay() {
      return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, "UnxO"));
    }
  },
  beforeCreate: function beforeCreate() {
    if (!this.$localStorage.get('loggedIn') || this.$localStorage.get('loggedIn') === null) {
      this.$router.push({ path: '/' });
    }
    if (!this.$localStorage.get('st')) {
      this.$router.push({ path: '/' });
      return false;
    }
    if (!this.$localStorage.get('sl')) {
      this.$router.push({ path: '/lab' });
      return false;
    }
    if (!this.$localStorage.get('ct')) {
      this.$router.push({ path: '/appointment' });
      return false;
    }
    if (!this.$localStorage.get('sa')) {
      this.$router.push({ path: '/address' });
      return false;
    }
    if (!this.$localStorage.get('sm')) {
      this.$router.push({ path: '/address' });
      return false;
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.$root.$off('paymentSuccess');
    this.$root.$on('paymentSuccess', function (data) {
      _this.updateRequest(data);
    });
  },
  data: function data() {
    return {
      selectedLab: [],
      selectedProfileAndTest: [],
      selectedAddress: [],
      selectedMembers: [],
      selectedCoupons: [],
      payinfo: {
        creditPoints: 0
      },
      profileDetails: {},
      couponCode: '',
      couponError: '',
      couponData: undefined,
      isSuccessCoupon: false,
      testCosts: [],
      isCouponApplied: false,
      termsCondition: false,
      termsConditionError: false,
      paymentType: '1',
      redeemCredits: false,
      redeemCreditPoints: '',
      toolCostExeeds: false,
      toggleToolTip: false
    };
  },

  watch: {
    redeemCredits: function redeemCredits() {
      if (this.redeemCredits) {
        this.redeemCreditPoints = this.payinfo.creditPoints;
        this.creditPointChanged();
      } else {
        this.redeemCreditPoints = 0;
        this.creditPointChanged();
      }
    }
  },
  methods: {
    creditPointChanged: function creditPointChanged() {
      if (this.payinfo.creditPoints && this.payinfo.creditPoints > 0) {
        if (this.payinfo.creditPoints < this.redeemCreditPoints) {
          this.redeemCreditPoints = this.payinfo.creditPoints;
        } else {
          if (this.redeemCreditPoints > this.payinfo.grandTotal) {
            this.toolCostExeeds = true;
            setTimeout(function () {
              this.toolCostExeeds = false;
            }.bind(this), 2000);
            this.redeemCreditPoints = this.payinfo.grandTotal;
          }
        }
      }
    },
    closePopup: function closePopup() {
      $('#termsAndCondition').modal('hide');
      $('#privacyPolicy').modal('hide');
      setTimeout(function () {
        document.body.style.overflow = "visible";
      }, 500);
    },
    termsConditionChanged: function termsConditionChanged(type, data) {
      this.termsConditionError = false;
      if (type == 1) {
        if (this.termsCondition) {
          $('#termsAndCondition').modal('show');
        }
      } else if (type == 0) {
        if (data) {
          this.termsCondition = true;
        }
        $('#termsAndCondition').modal('hide');
        $('#privacyPolicy').modal('hide');
      } else if (type == 2) {
        $('#termsAndCondition').modal('show');
      } else if (type == 3) {
        $('#privacyPolicy').modal('show');
      }
    },
    goBackPopup: function goBackPopup() {
      this.$router.go(-1);
    },
    getCartPaymentDetails: function getCartPaymentDetails(isFirst) {
      try {
        var labTestCosts = [];
        if (this.$localStorage.get('sl')) {
          if (this.$localStorage.get('sl').labTestList.length > 0) {
            __WEBPACK_IMPORTED_MODULE_5_underscore___default.a.each(this.$localStorage.get('sl').labTestList, function (element) {
              labTestCosts.push(element.labProfileId);
            });
          }
        }
        var data = {
          'labId': this.$localStorage.get('sl') ? this.$localStorage.get('sl').labId : '0',
          'labTests': labTestCosts,
          'couponCode': this.$localStorage.get('cou') ? this.$localStorage.get('cou').coupon_code : '',
          'couponId': this.$localStorage.get('cou') ? this.$localStorage.get('cou').couponId : 0
        };
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(this.$POST('patient/cartPaymentDetails', data)).then(function (res) {
          if (res.response_code === 0) {
            if (res.response) {
              this.payinfo = { creditPoints: 0 };
              var payinfo = {};
              payinfo['mrpTotal'] = res.response.mrpTotal;
              payinfo['phlebotomistFee'] = res.response.phlebotomistFee;
              payinfo['subTotal'] = res.response.subTotal;
              payinfo['labDiscount'] = res.response.labDiscount;
              payinfo['waiverDiscountApplyFee'] = res.response.waiverDiscountApplyFee;
              payinfo['phlebotomyFeeWaiver'] = res.response.phlebotomyFeeWaiver;
              payinfo['total'] = res.response.mrpTotal - res.response.labDiscount; // res.response.total
              payinfo['gst'] = res.response.gst;
              payinfo['couponFee'] = res.response.couponFee;
              payinfo['grandTotal'] = res.response.grandTotal;
              payinfo['couponCode'] = res.response.couponCode;
              payinfo['couponId'] = res.response.couponId;
              if (res.response.grandTotal <= 0) {
                this.payinfo.grandTotal = 0;
                payinfo['grandTotal'] = 0;
              }
              payinfo['priceDetails'] = res.response.priceDetails;
              payinfo['creditPoints'] = res.response.creditPoints;
              payinfo['ourPrice'] = res.response.ourPrice;
              this.payinfo = payinfo;
              // this.getTestCosts()
              // this.razorPayAssign()
              this.creditPointChanged();
              if (isFirst && this.payinfo.creditPoints && this.payinfo.creditPoints > 0) {
                this.redeemCredits = true;
              }
            }
          }
        }.bind(this)).catch(function (err) {
          console.error(err);
        });
        this.$hidePageLoading();
      } catch (e) {
        console.log(e);
      }
    },
    calculateAge: function calculateAge(birthday) {
      var ageDifMs = new Date() - birthday.getTime();
      var ageDate = new Date(ageDifMs);
      return Math.abs(ageDate.getUTCFullYear() - 1970);
    },
    getProfile: function getProfile() {
      try {
        this.profileDetails = {};
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(this.$GET('patient/getProfile', {})).then(function (res) {
          if (res.response_code === 0) {
            this.profileDetails['username'] = res.response.Patient.firstName + ' ' + res.response.Patient.lastName;
            this.profileDetails['firstName'] = res.response.Patient.firstName;
            this.profileDetails['lastName'] = res.response.Patient.lastName;
            this.profileDetails['photo'] = res.response.Patient.photo;
            this.profileDetails['dob'] = __WEBPACK_IMPORTED_MODULE_6_dateformat___default()(res.response.Patient.dob, 'dd-mm-yyyy');
            this.profileDetails['phone1'] = res.response.Patient.phone1;
            this.profileDetails['phone2'] = res.response.Patient.phone2;
            this.profileDetails['sex'] = res.response.Patient.sex;
            this.profileDetails['email'] = res.response.email;
            if (res.response.Patient.dob) {
              this.profileDetails['age'] = this.calculateAge(new Date(res.response.Patient.dob));
            } else {
              this.profileDetails['age'] = 0;
            }
            this.getCartPaymentDetails(true);
          }
        }.bind(this)).catch(function (err) {
          console.log(err);
        });
      } catch (e) {
        console.log(e);
      }
    },
    razorPayAssign: function razorPayAssign(data) {
      var self = this;
      var options = {
        'key': this.$razorpay_key,
        'amount': Math.ceil(data.request.totalCost) * 100, // 2000 paise = INR 20
        'name': 'Labotist Private Limited',
        'description': 'Health & Fitness',
        'image': 'https://labotist.com/dist/images/logo-svg.svg',
        'handler': function handler(response) {
          // alert(response.razorpay_payment_id)
          self.updateRequest(response);
        },
        'prefill': {
          'name': data.request.reqPatientFirstName + ' ' + data.request.reqPatientLastName,
          'email': data.request.reqPatientEmail,
          'contact': data.request.reqPatientMobile
        },
        'notes': {
          'address': data.request.pickupAddress,
          'requestId': data.request.requestId
        },
        'theme': {
          'color': '#057dc2',
          'emi_mode': false
        },
        order_id: data.order.id
      };
      if (this.$WebView && this.$WebViewBridge) {
        var _data = {
          type: 'makePayment',
          options: options
        };
        this.$WebViewBridge.send(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_data));
      } else {
        Razorpay(options).open();
      }
    },
    saveRequest: function saveRequest(paymentId) {
      try {
        var paymentData = {
          paymentId: paymentId
        };
        this.$showPageLoading();
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(this.$GET('payment/fetch', paymentData)).then(function (rzpInfo) {
          if (rzpInfo.response_code === 0) {
            try {
              var totalPaidCost = 0;
              if (rzpInfo) {
                totalPaidCost = rzpInfo.response.amount / 100;
              }
              var timezone = new Date().getTimezoneOffset();
              var appointmentDate = this.$localStorage.get('ct').dateFormatMoment;
              var appointmentTimeFrom = this.$localStorage.get('ct').startTime;
              var appointmentTimeTo = this.$localStorage.get('ct').endTime;
              var appointmentDateTimeFrom = this.$localStorage.get('ct').fromDateTime;
              var appointmentDateTimeTo = this.$localStorage.get('ct').toDateTime;
              // let appointmentTimeFromTimeZone = dateFormat(this.$localStorage.get('ct').fromDateTime, 'hh:MM:ss', true)
              // let appointmentTimeToTimeZone = dateFormat(this.$localStorage.get('ct').toDateTime, 'hh:MM:ss', true)
              var appointmentDateTimeFromTimeZone = this.$localStorage.get('ct').fromDateTime;
              var appointmentDateTimeToTimeZone = this.$localStorage.get('ct').toDateTime;
              var addressForRequest = '';
              if (this.$localStorage.get('sa').flatNo) {
                addressForRequest = addressForRequest + this.$localStorage.get('sa').flatNo + ', ';
              }

              addressForRequest = addressForRequest + this.$localStorage.get('sa').address + ', ';

              if (this.$localStorage.get('sa').landmark) {
                addressForRequest = addressForRequest + ', ' + this.$localStorage.get('sa').landmark + ', ';
              }

              var data = {
                'paymentId': paymentId,
                'labId': this.$localStorage.get('sl').labId,
                'branchId': this.$localStorage.get('sl').branchId,
                'appointmentDate': appointmentDate,
                'appointmentTimeFrom': appointmentTimeFrom,
                'appointmentTimeTo': appointmentTimeTo,
                'appointmentDateTimeFrom': appointmentDateTimeFrom,
                'appointmentDateTimeTo': appointmentDateTimeTo,
                'timezone': timezone,
                'appointmentDateTimeFromTimeZone': appointmentDateTimeFromTimeZone,
                'appointmentDateTimeToTimeZone': appointmentDateTimeToTimeZone,
                // 'appointmentTimeFromTimeZone': appointmentTimeFromTimeZone,
                // 'appointmentTimeToTimeZone': appointmentTimeToTimeZone,
                'pickupAddressId': this.$localStorage.get('sa').addressId,
                'pickupLocation': this.$localStorage.get('sa').Location.locationName,
                'pickupZipcode': this.$localStorage.get('sa').zipCode,
                'totalPaidCost': totalPaidCost,
                'actualCost': this.payinfo.subTotal,
                'discountCost': this.payinfo.labDiscount + this.payinfo.phlebotomyFeeWaiver,
                'gstCost': this.payinfo.gstCost,
                'couponCost': this.payinfo.couponFee,
                'couponCode': this.payinfo.couponCode,
                'couponId': this.payinfo.couponId,
                'totalCost': this.payinfo.grandTotal,
                'memberId': this.$localStorage.get('sm').memberId ? this.$localStorage.get('sm').memberId : 0,
                'reqPatientFirstName': this.$localStorage.get('sm').firstName,
                'reqPatientLastName': this.$localStorage.get('sm').lastName,
                'reqPatientSex': this.$localStorage.get('sm').sex,
                'reqPatientAge': this.$localStorage.get('sm').age,
                'reqPatientEmail': this.profileDetails.email,
                'reqPatientMobile': this.$localStorage.get('sm').mobile,
                'pickupAddress': addressForRequest + this.$localStorage.get('sa').Location.locationName + ', ' + this.$localStorage.get('sa').City.cityName + ', ' + this.$localStorage.get('sa').State.stateName + ' - ' + this.$localStorage.get('sa').zipCode,
                'pickupCoordinates': this.$localStorage.get('sa').coordinates,
                'redeemCredits': this.redeemCredits,
                'redeemCreditPoints': this.redeemCreditPoints
              };
              var labTests = [];
              var labProfiles = [];
              if (this.$localStorage.get('st').length > 0) {
                __WEBPACK_IMPORTED_MODULE_5_underscore___default.a.each(this.$localStorage.get('st'), function (element) {
                  if (element.panelId > 0) {
                    labProfiles.push(element.panelId);
                  } else {
                    labTests.push(element.testId);
                  }
                });
              }
              data.test = labTests;
              data.profile = labProfiles;
              __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(this.$POST('patient/saveRequest', data)).then(function (res) {
                if (res.response_code === 0) {
                  this.$localStorage.remove('cou');
                  global.successId = res.response.requestId;
                  this.$router.push({ path: '/success', params: { sample: 'hi' } });
                } else {
                  this.$router.push({ path: '/' });
                }
              }.bind(this)).catch(function (err) {
                console.log('METHOD:saveRequest', err);
              });
            } catch (err) {
              console.log(err);
            }
          } else {
            alert('Unable to fetch');
          }
        }.bind(this)).catch(function (err) {
          console.log('METHOD:saveRequest', err);
          alert('METHOD:saveRequest', err);
        });
      } catch (err) {
        console.log('METHOD:saveRequest', err);
      }
    },
    updateRequest: function updateRequest(payment) {
      this.$showPageLoading();
      try {
        var data = {
          orderId: payment.razorpay_order_id,
          paymentId: payment.razorpay_payment_id
        };
        setTimeout(function () {
          __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(this.$POST('patient/updateRequest', data)).then(function (res) {
            if (res.response_code === 0) {
              global.successId = res.response.requestId;
              try {
                __WEBPACK_IMPORTED_MODULE_2_vue__["default"].analytics.fbq.event('ViewContent', {
                  content_ids: 0,
                  content_name: 'PAYMENT COMPLETED',
                  contents: '',
                  content_type: 'PAYMENT_COMPLETED'
                });
              } catch (err) {
                console.log(err);
              }
              this.$router.push({ path: '/success', params: { sample: 'hi' } });
            }
          }.bind(this)).catch(function (err) {
            console.log('METHOD:saveRequest', err);
          });
        }.bind(this), 2000);
      } catch (err) {
        // alert(JSON.stringify(err))
        console.log('METHOD:saveRequest', err);
      }
    },
    saveRequestFirst: function saveRequestFirst() {
      this.$showPageLoading();
      try {
        var timezone = new Date().getTimezoneOffset();
        var appointmentDate = this.$localStorage.get('ct').dateFormatMoment;
        var appointmentTimeFrom = this.$localStorage.get('ct').startTime;
        var appointmentTimeTo = this.$localStorage.get('ct').endTime;
        var appointmentDateTimeFrom = this.$localStorage.get('ct').fromDateTime;
        var appointmentDateTimeTo = this.$localStorage.get('ct').toDateTime;
        var addressForRequest = '';
        if (this.$localStorage.get('sa').flatNo) {
          addressForRequest = addressForRequest + this.$localStorage.get('sa').flatNo + ', ';
        }

        addressForRequest = addressForRequest + this.$localStorage.get('sa').address + ', ';

        if (this.$localStorage.get('sa').landmark) {
          addressForRequest = addressForRequest + ', ' + this.$localStorage.get('sa').landmark + ', ';
        }

        var data = {
          'labId': this.$localStorage.get('sl').labId,
          'branchId': this.$localStorage.get('sl').branchId,
          'appointmentDate': appointmentDate,
          'appointmentTimeFrom': appointmentTimeFrom,
          'appointmentTimeTo': appointmentTimeTo,
          'appointmentDateTimeFrom': appointmentDateTimeFrom,
          'appointmentDateTimeTo': appointmentDateTimeTo,
          'timezone': timezone,
          'pickupAddressId': this.$localStorage.get('sa').addressId,
          'pickupLocation': this.$localStorage.get('sa').Location.locationName,
          'pickupZipcode': this.$localStorage.get('sa').zipCode,
          'totalPaidCost': 0,
          'actualCost': this.payinfo.subTotal,
          'discountCost': this.payinfo.labDiscount + this.payinfo.phlebotomyFeeWaiver,
          'gstCost': this.payinfo.gstCost,
          'couponCost': this.payinfo.couponFee,
          'couponCode': this.payinfo.couponCode,
          'couponId': this.payinfo.couponId,
          'totalCost': this.payinfo.grandTotal,
          'memberId': this.$localStorage.get('sm').memberId ? this.$localStorage.get('sm').memberId : 0,
          'reqPatientFirstName': this.$localStorage.get('sm').firstName,
          'reqPatientLastName': this.$localStorage.get('sm').lastName,
          'reqPatientSex': this.$localStorage.get('sm').sex,
          'reqPatientAge': this.$localStorage.get('sm').age,
          'reqPatientEmail': this.profileDetails.email,
          'reqPatientMobile': this.$localStorage.get('sm').mobile,
          'pickupAddress': addressForRequest + this.$localStorage.get('sa').Location.locationName + ', ' + this.$localStorage.get('sa').City.cityName + ', ' + this.$localStorage.get('sa').State.stateName + ' - ' + this.$localStorage.get('sa').zipCode,
          'pickupCoordinates': this.$localStorage.get('sa').coordinates,
          'redeemCredits': this.redeemCredits,
          'redeemCreditPoints': this.redeemCreditPoints
        };

        var labTests = [];
        var labProfiles = [];
        if (this.$localStorage.get('st').length > 0) {
          __WEBPACK_IMPORTED_MODULE_5_underscore___default.a.each(this.$localStorage.get('st'), function (element) {
            if (element.panelId > 0) {
              labProfiles.push(element.panelId);
            } else {
              labTests.push(element.testId);
            }
          });
        }
        data.test = labTests;
        data.profile = labProfiles;
        // alert(JSON.stringify(data))
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(this.$POST('patient/saveRequestBeforePayment', data)).then(function (res) {
          if (res.response_code === 0) {
            this.$hidePageLoading();
            this.razorPayAssign(res.response);
            // this.$router.push({ path: '/success', params: { sample: 'hi' } })
          } else if (res.response_code === 4) {
            this.$hidePageLoading();
            this.$Simplert.open({
              title: 'Information',
              message: '<div style="text-align: left; line-height: 20px;">\n                            <p>' + res.response_message + '</p>\n                          </div>',
              type: 'info',
              useConfirmBtn: false,
              customCloseBtnText: 'Ok',
              disableOverlayClick: true
            });
            this.getCartPaymentDetails();
          }
        }.bind(this)).catch(function (err) {
          console.log('METHOD:saveRequest', err);
        });
      } catch (err) {}
    },
    saveRequestCash: function saveRequestCash(zeroPayment) {
      this.$showPageLoading();
      try {
        var timezone = new Date().getTimezoneOffset();
        var appointmentDate = this.$localStorage.get('ct').dateFormatMoment;
        var appointmentTimeFrom = this.$localStorage.get('ct').startTime;
        var appointmentTimeTo = this.$localStorage.get('ct').endTime;
        var appointmentDateTimeFrom = this.$localStorage.get('ct').fromDateTime;
        var appointmentDateTimeTo = this.$localStorage.get('ct').toDateTime;
        var addressForRequest = '';
        if (this.$localStorage.get('sa').flatNo) {
          addressForRequest = addressForRequest + this.$localStorage.get('sa').flatNo + ', ';
        }

        addressForRequest = addressForRequest + this.$localStorage.get('sa').address + ', ';

        if (this.$localStorage.get('sa').landmark) {
          addressForRequest = addressForRequest + ', ' + this.$localStorage.get('sa').landmark + ', ';
        }

        var data = {
          'labId': this.$localStorage.get('sl').labId,
          'branchId': this.$localStorage.get('sl').branchId,
          'appointmentDate': appointmentDate,
          'appointmentTimeFrom': appointmentTimeFrom,
          'appointmentTimeTo': appointmentTimeTo,
          'appointmentDateTimeFrom': appointmentDateTimeFrom,
          'appointmentDateTimeTo': appointmentDateTimeTo,
          'timezone': timezone,
          'pickupAddressId': this.$localStorage.get('sa').addressId,
          'pickupLocation': this.$localStorage.get('sa').Location.locationName,
          'pickupZipcode': this.$localStorage.get('sa').zipCode,
          'totalPaidCost': 0,
          'actualCost': this.payinfo.subTotal,
          'discountCost': this.payinfo.labDiscount + this.payinfo.phlebotomyFeeWaiver,
          'gstCost': this.payinfo.gstCost,
          'couponCost': this.payinfo.couponFee,
          'couponCode': this.payinfo.couponCode,
          'couponId': this.payinfo.couponId,
          'totalCost': this.payinfo.grandTotal,
          'memberId': this.$localStorage.get('sm').memberId ? this.$localStorage.get('sm').memberId : 0,
          'reqPatientFirstName': this.$localStorage.get('sm').firstName,
          'reqPatientLastName': this.$localStorage.get('sm').lastName,
          'reqPatientSex': this.$localStorage.get('sm').sex,
          'reqPatientAge': this.$localStorage.get('sm').age,
          'reqPatientEmail': this.profileDetails.email,
          'reqPatientMobile': this.$localStorage.get('sm').mobile,
          'pickupAddress': addressForRequest + this.$localStorage.get('sa').Location.locationName + ', ' + this.$localStorage.get('sa').City.cityName + ', ' + this.$localStorage.get('sa').State.stateName + ' - ' + this.$localStorage.get('sa').zipCode,
          'pickupCoordinates': this.$localStorage.get('sa').coordinates,
          'paymentType': zeroPayment ? 0 : 1,
          'redeemCredits': this.redeemCredits,
          'redeemCreditPoints': this.redeemCreditPoints
        };

        var labTests = [];
        var labProfiles = [];
        if (this.$localStorage.get('st').length > 0) {
          __WEBPACK_IMPORTED_MODULE_5_underscore___default.a.each(this.$localStorage.get('st'), function (element) {
            if (element.panelId > 0) {
              labProfiles.push(element.panelId);
            } else {
              labTests.push(element.testId);
            }
          });
        }
        data.test = labTests;
        data.profile = labProfiles;
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(this.$POST('patient/saveRequestCash', data)).then(function (res) {
          if (res.response_code === 0) {
            global.successId = res.response.requestId;
            try {
              __WEBPACK_IMPORTED_MODULE_2_vue__["default"].analytics.fbq.event('ViewContent', {
                content_ids: 0,
                content_name: 'PAYMENT COMPLETED',
                contents: '',
                content_type: 'PAYMENT_COMPLETED'
              });
            } catch (err) {
              console.log(err);
            }
            this.$router.push({ path: '/success', params: { sample: 'hi' } });
          } else if (res.response_code === 4) {
            this.$hidePageLoading();
            this.$Simplert.open({
              title: 'Information',
              message: '<div style="text-align: left; line-height: 20px;">\n                            <p>' + res.response_message + '</p>\n                          </div>',
              type: 'info',
              useConfirmBtn: false,
              customCloseBtnText: 'Ok',
              disableOverlayClick: true
            });
            this.getCartPaymentDetails();
          }
        }.bind(this)).catch(function (err) {
          console.log('METHOD:saveRequest', err);
        });
      } catch (err) {}
    },
    clearRequestSessions: function clearRequestSessions() {
      this.$localStorage.remove('location');
      this.$localStorage.remove('st');
      this.$localStorage.remove('sl');
      this.$localStorage.remove('ct');
      this.$localStorage.remove('sa');
      this.$localStorage.remove('step');
      this.$localStorage.remove('cou');
    },
    payNow: function payNow() {
      // if (!this.$localStorage.get('location')) {
      //   this.$router.push({ path: '/' })
      //   return false
      // }
      if (!this.$localStorage.get('st')) {
        this.$router.push({ path: '/' });
        return false;
      }
      if (!this.$localStorage.get('sl')) {
        this.$router.push({ path: '/lab' });
        return false;
      }
      if (!this.$localStorage.get('ct')) {
        this.$router.push({ path: '/appointment' });
        return false;
      }
      if (!this.$localStorage.get('sa')) {
        this.$router.push({ path: '/address' });
        return false;
      }
      if (!this.$localStorage.get('sm')) {
        this.$router.push({ path: '/address' });
        return false;
      }
      if (this.payinfo.grandTotal > 0) {
        // this.razorPayAssign()
        this.saveRequestFirst();
      }
    },
    goPayment: function goPayment(zeroPayment) {
      this.termsConditionError = false;
      if (!this.$localStorage.get('st')) {
        this.$Simplert.open({
          title: 'Alert',
          message: 'Please select a test or profile',
          type: 'warning',
          disableOverlayClick: true,
          showXclose: true,
          useConfirmBtn: false,
          customCloseBtnText: 'OK'
        });
        return false;
      } else if (!this.$localStorage.get('sl')) {
        this.$Simplert.open({
          title: 'Alert',
          message: 'Please select a lab',
          type: 'warning',
          disableOverlayClick: true,
          showXclose: true,
          useConfirmBtn: false,
          customCloseBtnText: 'OK'
        });
        return false;
      } else if (!this.$localStorage.get('ct')) {
        this.$Simplert.open({
          title: 'Alert',
          message: 'Please select your apoointment date and time',
          type: 'warning',
          disableOverlayClick: true,
          showXclose: true,
          useConfirmBtn: false,
          customCloseBtnText: 'OK'
        });
        return false;
      } else if (!this.$localStorage.get('sa')) {
        this.$Simplert.open({
          title: 'Alert',
          message: 'Please select or add your address',
          type: 'warning',
          disableOverlayClick: true,
          showXclose: true,
          useConfirmBtn: false,
          customCloseBtnText: 'OK'
        });
        return false;
      } else if (!this.$localStorage.get('sm')) {
        this.$Simplert.open({
          title: 'Alert',
          message: 'Please select your member',
          type: 'warning',
          disableOverlayClick: true,
          showXclose: true,
          useConfirmBtn: false,
          customCloseBtnText: 'OK'
        });
        return false;
      } else {
        __WEBPACK_IMPORTED_MODULE_2_vue__["default"].analytics.fbq.event('ViewContent', {
          content_ids: 0,
          content_name: 'PAYMENT INITIATED',
          contents: '',
          content_type: 'PAYMENT_INITIATED'
        });
        if (!this.termsCondition) {
          this.termsConditionError = true;
          return false;
        }
        if (this.paymentType == '2' || zeroPayment) {
          if (!zeroPayment) {
            this.$Simplert.open({
              title: 'Information',
              message: '\n                  <div style="text-align: left; line-height: 20px;">\n                    <p>Please make arrangements to pay <b>Rs.' + (this.payinfo.grandTotal - this.redeemCreditPoints) + '</b> as cash to the Phlebotomist when he/she visits to collect sample. </p>\n                    <p>If there are any changes to your schedule, please call ahead to reschedule. Uninformed cancelation will result in loss of time & money for our Phlebotomists.</p>\n                    <p>Thanks for understanding. </p>\n                  </div>',
              type: 'info',
              useConfirmBtn: true,
              onConfirm: function () {
                this.saveRequestCash();
              }.bind(this),
              customConfirmBtnText: 'Ok',
              customCloseBtnText: 'Cancel',
              disableOverlayClick: true
            });
          } else {
            this.saveRequestCash(zeroPayment);
          }
          // this.saveRequestCash()
        } else {
          this.saveRequestFirst();
        }
        return false;
      }
    },
    // applyCoupon: function () {
    //   this.$validator.validateAll('coupon').then((result) => {
    //     if (result) {
    //       try {
    //         this.couponError = ''
    //         this.isSuccessCoupon = false
    //         if (this.couponCode === '') {
    //           this.couponError = 'Please enter coupon code'
    //           return false
    //         }
    //         let data = {
    //           'coupon_code': (this.couponCode).toUpperCase()
    //         }

    //         if (this.$localStorage.get('sl')) {
    //           data['labId'] = this.$localStorage.get('sl').labId
    //           let labProfileIds = []
    //           if (this.$localStorage.get('sl') && this.$localStorage.get('sl').labTestList.length > 0) {
    //             this.$localStorage.get('sl').labTestList.forEach(function (element) {
    //               if (element.labProfileId > 0) {
    //                 labProfileIds.push(element.labProfileId)
    //               }
    //             })
    //           }
    //           data['labProfileIds'] = labProfileIds
    //         } else {
    //           data['labId'] = 0
    //           data['labProfileIds'] = []
    //         }

    //         if (this.$localStorage.get('profile')) {
    //           data['email'] = this.$localStorage.get('profile').email
    //         } else {
    //           data['email'] = ''
    //         }
    //         Promise.resolve(this.$POST('patient/applyCoupon', data)).then(function (res) {
    //           if (res.response_code === 0) {
    //             this.$localStorage.set('cou', res.response, 30 * 60 * 1000)
    //             if (res.response.coupon_percentage > 0) {
    //               this.isSuccessCoupon = true
    //               this.couponError = res.response_message + ' (' + res.response.coupon_percentage + '% )'
    //             } else {
    //               this.isSuccessCoupon = true
    //               this.couponError = res.response_message + ' (Rs.' + res.response.coupon_price + ')'
    //             }
    //             this.getCartPaymentDetails()
    //           } else {
    //             this.$localStorage.remove('cou')
    //             if (res.response_code === 4) {
    //               this.couponError = res.response_message + ' (Rs.' + res.response.coupon_range + ')'
    //             } else {
    //               this.couponError = res.response_message
    //             }
    //             this.getCartPaymentDetails()
    //           }
    //         }.bind(this)).catch(function (err) {
    //           console.error(err)
    //         })
    //       } catch (e) {
    //         console.log('error', e)
    //       }
    //     }
    //   })
    // },
    applyCoupon: function applyCoupon() {
      var _this2 = this;

      this.$validator.validateAll('coupon').then(function (result) {
        if (result) {
          try {
            _this2.couponError = '';
            _this2.isSuccessCoupon = false;
            if (_this2.couponCode === '') {
              _this2.couponError = 'Please enter coupon code';
              return false;
            }
            var data = {
              'coupon_code': _this2.couponCode.toUpperCase()
            };

            if (_this2.$localStorage.get('sl')) {
              data['labId'] = _this2.$localStorage.get('sl').labId;
              var labProfileIds = [];
              if (_this2.$localStorage.get('sl') && _this2.$localStorage.get('sl').labTestList.length > 0) {
                _this2.$localStorage.get('sl').labTestList.forEach(function (element) {
                  if (element.labProfileId > 0) {
                    labProfileIds.push(element.labProfileId);
                  }
                });
              }
              data['labProfileIds'] = labProfileIds;
            } else {
              data['labId'] = 0;
              data['labProfileIds'] = [];
            }

            if (_this2.$localStorage.get('profile')) {
              data['email'] = _this2.$localStorage.get('profile').email;
            } else {
              data['email'] = '';
            }
            __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(_this2.$POST('patient/applyCoupon', data)).then(function (res) {
              if (res.response_code === 0) {
                this.$localStorage.set('cou', res.response, 30 * 60 * 1000);
                this.isCouponApplied = true;
                this.couponData = res.response;
                this.couponError = '';
                if (res.response.coupon_percentage > 0) {
                  this.isSuccessCoupon = true;
                  this.couponError = res.response.coupon_percentage + '% ';
                } else {
                  this.isSuccessCoupon = true;
                  this.couponError = 'Rs.' + res.response.coupon_price + ' ';
                }
                this.getCartPaymentDetails();
              } else {
                this.$localStorage.remove('cou');
                if (res.response_code === 4) {
                  this.couponError = res.response_message + ' (Rs.' + res.response.coupon_range + ')';
                } else {
                  this.couponError = res.response_message;
                }
                this.getCartPaymentDetails();
              }
            }.bind(_this2)).catch(function (err) {
              console.error(err);
            });
          } catch (e) {
            console.log('error', e);
          }
        }
      });
    },
    removeCoupon: function removeCoupon() {
      this.$localStorage.remove('cou');
      if (this.redeemCredits) this.redeemCreditPoints = this.payinfo.creditPoints;else this.redeemCreditPoints = 0;
      this.getCartPaymentDetails();
      this.isCouponApplied = false;
      this.couponData = undefined;
      this.couponCode = '';
    },
    getTestCosts: function getTestCosts(lab) {
      try {
        var labTestCosts = [];
        if (this.$localStorage.get('sl')) {
          if (this.$localStorage.get('sl').labTestList.length > 0) {
            __WEBPACK_IMPORTED_MODULE_5_underscore___default.a.each(this.$localStorage.get('sl').labTestList, function (element) {
              labTestCosts.push(element.labProfileId);
            });
          }
        }
        var data = {
          'labId': this.$localStorage.get('sl') ? this.$localStorage.get('sl').labId : '0',
          'labTests': labTestCosts
        };
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(this.$POST('patient/getTestCosts', data)).then(function (res) {
          if (res.response_code === 0) {
            if (res.response) {
              this.testCosts = res.response;
              // let payinfo = []
              // payinfo['mrpTotal'] = res.response.mrp
              // payinfo['phlebotomistFee'] = this.$phlebotomistFee
              // payinfo['subTotal'] = (payinfo.mrpTotal + payinfo.phlebotomistFee)
              // payinfo['labDiscount'] = res.response.youSaved
              // payinfo['phlebotomyFeeWaiver'] = ((payinfo.mrpTotal - payinfo.labDiscount) > this.$waiverDiscountApplyFee) ? this.$phlebotomyFeeWaiver : 0
              // payinfo['total'] = payinfo.subTotal - (payinfo.labDiscount + payinfo.phlebotomyFeeWaiver)
              // payinfo['gst'] = Math.round(((payinfo.total) * this.$GSTFee) / 100)
              // payinfo['grandTotal'] = (payinfo.total + payinfo.gst)
              // payinfo['priceDetails'] = res.response.priceDetails
              // payinfo['creditPoints'] = res.response.creditPoints
              // this.payinfo = payinfo
            }
          }
        }.bind(this)).catch(function (err) {
          console.error(err);
        });
      } catch (e) {
        console.log(e);
      }
    }
  },
  created: function created() {
    //  this.getCartPaymentDetails()
    this.getTestCosts();
    this.selectedLab = [];
    if (this.$localStorage.get('sl')) {
      this.selectedLab = this.$localStorage.get('sl');
    }

    this.selectedProfileAndTest = [];
    if (this.$localStorage.get('st')) {
      this.selectedProfileAndTest = this.$localStorage.get('st');
    }

    this.selectedCoupons = [];
    if (this.$localStorage.get('cou')) {
      this.selectedCoupons = this.$localStorage.get('cou');
    }

    this.selectedAddress = [];
    if (this.$localStorage.get('sa')) {
      this.selectedAddress = this.$localStorage.get('sa');
    }

    this.selectedMembers = [];
    if (this.$localStorage.get('sa')) {
      this.selectedMembers = this.$localStorage.get('sm');
    }
    if (this.$localStorage.get('cou')) {
      this.isCouponApplied = true;
      this.couponData = this.$localStorage.get('cou');
      if (this.couponData.coupon_percentage > 0) {
        this.isSuccessCoupon = true;
        this.couponError = this.couponData.coupon_percentage + '% ';
      } else {
        this.isSuccessCoupon = true;
        this.couponError = 'Rs.' + this.couponData.coupon_price + ' ';
      }
    }
    this.getProfile();
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("DuR2")))

/***/ }),

/***/ "m6qz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "nPLH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ncd9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "o2nh":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pHF6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pcMA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pwwO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qv8e":
/***/ (function(module, exports) {

$(function () {
  $('[data-toggle="tooltip"]').tooltip()
});



/***/ }),

/***/ "rajZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "rji4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "sSzK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/promise.js
var promise = __webpack_require__("//Fk");
var promise_default = /*#__PURE__*/__webpack_require__.n(promise);

// EXTERNAL MODULE: ./node_modules/vuejs-datepicker/dist/build.js
var build = __webpack_require__("XILU");
var build_default = /*#__PURE__*/__webpack_require__.n(build);

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/web/Login.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var Login = ({
  name: 'Login',
  components: {
    Datepicker: build_default.a
  },
  data: function data() {
    return {
      isDobError: false,
      otherSignup: false,
      loginWithoutBtn: false,
      login: {
        username: '',
        password: '',
        error: false,
        errormsg: '',
        otp_send: 1,
        login_otp: '',
        successmsg: ''
      },
      forgot: {
        username: '',
        otp: '',
        newPassword: '',
        confirmPassword: '',
        error: false,
        errormsg: '',
        success: 1,
        successmsg: '',
        otpType: ''
      },
      otp: {
        username: '',
        error: false,
        errormsg: '',
        success: false,
        successmsg: ''
      },
      signup: {
        email: '',
        mobile: '',
        name: '',
        password: '',
        referralCode: this.$localStorage.get('ref_code') ? this.$localStorage.get('ref_code') : '',
        dob: undefined,
        sex: 'M',
        otp: '',
        error: false,
        errormsg: '',
        success: false,
        successmsg: '',
        dobYears: [],
        dobDate: [],
        year: '',
        month: '',
        ddate: ''
      },
      disabled: {
        from: new Date()
      },
      appointmentLogin: false,
      referralCodeDisable: false
    };
  },
  beforeCreate: function beforeCreate() {
    this.appointmentLogin = false;
  },
  created: function created() {
    if (this.$route.params.referralCode) {
      try {
        this.signup.referralCode = this.$route.params.referralCode.toUpperCase();
        setTimeout(function () {
          $('.signup').modal('show');
          this.referralCodeDisable = true;
        }.bind(this), 1000);
      } catch (err) {
        this.signup.referralCode = '';
        setTimeout(function () {
          $('.signup').modal('show');
        }.bind(this), 1000);
      }
    }
    if (this.$route.fullPath === '/login') {
      if (this.$localStorage.get('profile') && this.$localStorage.get('profile') !== null) {
        this.$router.push({ path: '/myresult' });
        return false;
      }
      setTimeout(function () {
        $('.login-box').modal('show');
      }, 1000);
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.$root.$on('appointmentLogin', function (isAppointment) {
      _this.appointmentLogin = true;
    });
    this.$root.$on('loginClicked', function (isAppointment) {
      _this.clearFields();
      _this.errors.items = [];
    });
  },
  watch: {
    'signup.referralCode': function signupReferralCode() {
      this.signup.referralCode = this.signup.referralCode.toUpperCase();
    }
  },
  methods: {
    loginWithOtpChanged: function loginWithOtpChanged(resend) {
      var _this2 = this;

      if (this.login.username === '') {
        this.$refs.login_username.focus();
      }
      this.login.error = false;
      this.$validator.validateAll('login').then(function (result) {
        if (result) {
          if (_this2.login.username !== '') {
            var data = {
              'mobile': _this2.login.username
            };
            promise_default.a.resolve(_this2.$POST('patient/sendOTP', data)).then(function (res) {
              if (res.response_code === 0) {
                this.login['otp_send'] = 2;
                this.login['error'] = false;
                this.login['errormsg'] = '';
                if (resend) {
                  this.login['successmsg'] = 'We have resend an OTP to your mobile number.';
                } else {
                  this.login['successmsg'] = 'We have send an OTP to your mobile number.';
                }

                this.login['login_otp'] = '';
                console.log(this.login);
              } else {
                this.login['otp_send'] = 1;
                this.login['error'] = true;
                this.login['errormsg'] = res.response_message;
                this.login['successmsg'] = '';
                this.login['login_otp'] = '';
              }
            }.bind(_this2)).catch(function (err) {
              console.log('METHOD:forgetPassword', err);
            });
          }
        }
      });
    },
    verifyLoginOTP: function verifyLoginOTP() {
      var _this3 = this;

      if (this.login.login_otp === '') {
        this.$refs.login_otp.focus();
      }
      this.login.error = false;
      this.$validator.validateAll('login-wt-otp').then(function (result) {
        if (result) {
          if (_this3.login.username !== '' && _this3.login.login_otp !== '') {
            _this3.$verifyLoginOTP(_this3.login.username, _this3.login.login_otp).then(function (response) {
              console.log(response);
              if (response.error) {
                this.login.error = true;
                this.login.errormsg = 'Invalid OTP';
                this.login.successmsg = '';
                return false;
              } else {
                this.login.error = false;
                vue_esm["default"].analytics.fbq.event('ViewContent', {
                  content_ids: 0,
                  content_name: 'LOGIN SUCCESS',
                  contents: '',
                  content_type: 'LOGIN_SUCCESS'
                });
                if (response.data && response.data.isFirst === 1) {
                  $('.login-box').modal('hide');
                  $('.forgot').modal('show');
                  this.forgot.error = false;
                  this.forgot.success = 3;
                  return false;
                }
                if (this.appointmentLogin) {
                  this.appointmentLogin = false;
                  this.$root.$emit('isLogin', true);
                  $('.login-box').modal('hide');
                  this.$router.push('/address');
                  return false;
                } else {
                  this.$root.$emit('isLogin', true);
                  $('.login-box').modal('hide');
                  if (this.$route.fullPath === '/login' || this.$route.fullPath === '/') {
                    this.$router.push({ path: '/myresult' });
                  }
                }
                return false;
              }
            }.bind(_this3)).catch(function (err) {
              console.error(err);
            });
          }
        }
      });
    },
    getNumberOfDays: function getNumberOfDays() {
      if (this.signup.year && this.signup.year !== '' && this.signup.month && this.signup.month !== '') {
        var noOfDays = new Date(this.signup.year, this.signup.month, 0).getDate();
        var dobDate = [];
        for (var j = 1; j <= noOfDays; j++) {
          dobDate.push(j.toString());
        }
        this.signup['dobDate'] = dobDate;

        if (this.signup.ddate) {
          var res = true;
          dobDate.forEach(function (dataV) {
            if (parseInt(dataV) === parseInt(this.signup.ddate)) {
              res = false;
            }
          }.bind(this));
          if (res) {
            this.signup.ddate = '';
          }
        }
      }
      return false;
    },
    loginClicked: function loginClicked() {
      this.login.error = false;
      if (this.login.login_with_otp) {
        this.loginWithOtpChanged();
      } else {
        this.logon();
      }
    },
    logon: function logon() {
      var _this4 = this;

      if (this.login.username === '') {
        this.$refs.login_username.focus();
      } else if (this.login.password === '') {
        this.$refs.login_password.focus();
      }
      this.login.error = false;
      this.$validator.validateAll('login').then(function (result) {
        if (result) {
          if (_this4.login.username !== '' && _this4.login.password !== '') {
            _this4.$logon(_this4.login.username, _this4.login.password).then(function (response) {
              if (response.error) {
                this.login.error = true;
                this.login.errormsg = response.error;
                return false;
              } else {
                vue_esm["default"].analytics.fbq.event('ViewContent', {
                  content_ids: 0,
                  content_name: 'LOGIN SUCCESS',
                  contents: '',
                  content_type: 'LOGIN_SUCCESS'
                });
                if (response.data && response.data.isFirst === 1) {
                  $('.login-box').modal('hide');
                  $('.forgot').modal('show');
                  this.forgot.error = false;
                  this.forgot.success = 3;
                  return false;
                }
                if (this.appointmentLogin) {
                  this.appointmentLogin = false;
                  this.$root.$emit('isLogin', true);
                  $('.login-box').modal('hide');
                  this.$router.push('/address');
                  return false;
                } else {
                  this.$root.$emit('isLogin', true);
                  $('.login-box').modal('hide');
                  if (this.$route.fullPath === '/login' || this.$route.fullPath === '/') {
                    this.$router.push({ path: '/myresult' });
                  }
                }
              }
            }.bind(_this4)).catch(function (err) {
              console.error(err);
            });
          }
        }
      });
    },
    forgetPassword: function forgetPassword() {
      var _this5 = this;

      this.forgot.error = false;
      this.$validator.validateAll('forgot').then(function (result) {
        if (result) {
          try {
            if (_this5.forgot.username !== '') {
              var data = {};
              if (_this5.forgot.otpType == 2) {
                data = {
                  mobile: _this5.forgot.username,
                  otpType: _this5.forgot.otpType
                };
              } else {
                data = {
                  email: _this5.forgot.username,
                  otpType: _this5.forgot.otpType
                };
              }
              promise_default.a.resolve(_this5.$POST('patient/forgetPassword', data)).then(function (res) {
                if (res.response_code === 0) {
                  this.forgot.error = false;
                  this.forgot.errormsg = '';
                  this.forgot.success = 2;
                  if (this.forgot.otpType == 2) {
                    this.forgot.successmsg = 'We have send an OTP to your mobile number.';
                  } else {
                    this.forgot.successmsg = 'We have send an authentication code to your mail id.';
                  }
                } else {
                  this.forgot.success = 1;
                  this.forgot.error = true;
                  this.forgot.errormsg = res.response_message;
                  this.forgot.otp = '';
                }
              }.bind(_this5)).catch(function (err) {
                console.log('METHOD:forgetPassword', err);
              });
            }
          } catch (e) {
            console.error(e);
          }
        }
      });
    },
    verify_otp: function verify_otp() {
      var _this6 = this;

      this.$validator.validateAll('forgotOtp').then(function (result) {
        if (result) {
          if (_this6.forgot.otpType == 2) {
            if (_this6.forgot.username !== '' && _this6.forgot.otp !== '') {
              _this6.$verifyLoginOTP(_this6.forgot.username, _this6.forgot.otp).then(function (response) {
                if (response.error) {
                  this.forgot.error = true;
                  this.forgot.errormsg = 'Invalid OTP';
                  this.forgot.successmsg = '';
                  return false;
                } else {
                  this.forgot.error = false;
                  this.forgot.success = 3;
                  return false;
                }
              }.bind(_this6)).catch(function (err) {
                console.error(err);
              });
            }
          } else {
            if (_this6.forgot.username !== '' && _this6.forgot.otp !== '') {
              _this6.$verifyOTP(_this6.forgot.username, _this6.forgot.otp).then(function (response) {
                if (response.error) {
                  this.forgot.error = true;
                  this.forgot.errormsg = 'Invalid OTP';
                  this.forgot.successmsg = '';
                  return false;
                } else {
                  this.forgot.error = false;
                  this.forgot.success = 3;
                  return false;
                }
              }.bind(_this6)).catch(function (err) {
                console.error(err);
              });
            }
          }
        }
      });
    },
    reset_password: function reset_password() {
      var _this7 = this;

      if (this.forgot.newPassword !== this.forgot.confirmPassword) {
        return false;
      }
      this.$validator.validateAll('resetPassword').then(function (result) {
        if (result) {
          if (_this7.forgot.newPassword !== '' && _this7.forgot.confirmPassword !== '') {
            _this7.$resetPassword(_this7.forgot.newPassword).then(function (response) {
              if (response.error) {
                this.forgot.error = true;
                this.forgot.errormsg = 'Invalid User';
                this.forgot.successmsg = '';
                return false;
              } else {
                if (this.$route.fullPath === '/referral/login') {
                  $('.forgot').modal('hide');
                  this.$router.push('/referral/invite');
                  return false;
                }
                if (this.appointmentLogin) {
                  this.appointmentLogin = false;
                  this.$root.$emit('isLogin', true);
                  $('.forgot').modal('hide');
                  this.$router.push('/address');
                  return false;
                } else {
                  this.$root.$emit('isLogin', true);
                  $('.forgot').modal('hide');
                  return false;
                }
              }
            }.bind(_this7)).catch(function (err) {
              console.error(err);
            });
          }
        }
      });
    },
    resend: function resend() {
      try {
        if (this.forgot.username !== '') {
          var data = {
            'email': this.forgot.username,
            otpType: this.forgot.otpType
          };
          promise_default.a.resolve(this.$POST('patient/resendOTP', data)).then(function (res) {
            if (res.response_code === 0) {
              this.forgot.error = false;
              this.forgot.errormsg = '';
              this.forgot.success = 2;
              if (this.forgot.otpType == 2) {
                this.forgot.successmsg = 'We have resend an OTP to your mobile number.';
              } else {
                this.forgot.successmsg = 'We have resend an authentication code to your mail id.';
              }
            } else {
              this.forgot.success = 1;
              this.forgot.error = true;
              this.forgot.errormsg = res.response_message;
              this.forgot.otp = '';
            }
          }.bind(this)).catch(function (err) {
            console.log('METHOD:forgetPassword', err);
          });
        }
      } catch (e) {
        console.error(e);
      }
    },
    clearFields: function clearFields(type) {
      if (type === 1) {
        vue_esm["default"].analytics.fbq.event('ViewContent', {
          content_ids: 0,
          content_name: 'SIGN UP CLICKED',
          contents: '',
          content_type: 'SIGNUP_CLICK'
        });
      }
      this.isDobError = false;
      this.signup = {
        email: '',
        mobile: '',
        name: '',
        password: '',
        referralCode: this.$localStorage.get('ref_code') ? this.$decryptString(this.$localStorage.get('ref_code')) : '',
        dob: undefined,
        sex: 'M',
        otp: '',
        error: false,
        errormsg: '',
        success: false,
        successmsg: '',
        dobYears: [],
        dobDate: [],
        year: '',
        month: '',
        ddate: ''
      };
      this.referralCodeDisable = false;
      this.login = {
        username: '',
        password: '',
        error: false,
        errormsg: '',
        otp_send: 1,
        login_otp: '',
        successmsg: ''
      }, this.forgot = {
        username: '',
        otp: '',
        newPassword: '',
        confirmPassword: '',
        error: false,
        errormsg: '',
        success: 1,
        successmsg: ''
      };
      var year = new Date().getFullYear();
      var endYear = year - 120;
      var dobYears = [];
      for (var i = year; i > endYear; i--) {
        dobYears.push(i.toString());
      }
      this.signup['dobYears'] = dobYears;

      setTimeout(function () {
        this.errors.items = [];
      }.bind(this), 200);
      setTimeout(function () {
        document.body.classList.add('modal-open');
      }, 1000);
    },
    create_account: function create_account() {
      this.isDobError = false;
      this.signup.error = false;
      this.$validator.validateAll('signup').then(function (result) {
        if (result) {
          // if (this.signup.year.length !== 4 || this.signup.month.length <= 0 || this.signup.ddate.length <= 0) {
          //   this.isDobError = true
          //   return false
          // }
          try {
            if (this.signup.email !== '' && this.signup.mobile !== '' && this.signup.firstName !== '' && this.signup.password !== '') {
              var params = {
                'firstName': this.signup.firstName,
                'lastName': '',
                'phone1': this.signup.mobile,
                'email': this.signup.email,
                'password': this.signup.password,
                'referralCode': this.signup.referralCode,
                // 'sex': this.signup.sex,
                'sex': '',
                // 'dob': this.signup.year + '-' + this.signup.month + '-' + this.signup.ddate,
                'dob': null
                // 'dob': dateFormat(this.signup.dob, 'yyyy-mm-dd', true)
              };
              promise_default.a.resolve(this.$POST('patient/quickSignUp', params)).then(function (response) {
                if (response.response_code === 0) {
                  this.signup.error = false;
                  this.signup.errormsg = '';
                  this.signup.success = true;
                  this.signup.successmsg = 'We have send an authentication code for verifying your account.';
                  vue_esm["default"].analytics.fbq.event('ViewContent', {
                    content_ids: 0,
                    content_name: 'SIGN UP SUCCESS',
                    contents: '',
                    content_type: 'SIGNUP_SUCCESS'
                  });
                } else {
                  this.signup.success = false;
                  this.signup.error = true;
                  this.signup.errormsg = response.response_message;
                  this.signup.otp = '';
                  if (response.response_code === 3) {
                    this.$refs.signUpEmail.focus();
                  } else if (response.response_code === 4) {
                    this.$refs.signUpMobile.focus();
                  }
                }
              }.bind(this)).catch(function (err) {
                console.log(err);
              });
            } else {
              this.$Simplert.open({
                title: 'Alert',
                message: 'Please enter required fields!',
                type: 'warning',
                disableOverlayClick: true,
                showXclose: true,
                useConfirmBtn: false,
                customCloseBtnText: 'OK'
              });
              // alert('Please enter required fields!')
            }
          } catch (e) {
            console.error(e);
          }
        }
      }.bind(this));
    },
    signup_verify_otp: function signup_verify_otp() {
      var _this8 = this;

      this.$validator.validateAll('signupOtp').then(function (result) {
        if (result) {
          if (_this8.signup.email !== '' && _this8.signup.otp !== '') {
            _this8.$verifyOTP(_this8.signup.email, _this8.signup.otp).then(function (response) {
              if (response.error) {
                this.signup.error = true;
                this.signup.errormsg = 'Invalid OTP';
                this.signup.successmsg = '';
                return false;
              } else {
                if (this.appointmentLogin) {
                  this.appointmentLogin = false;
                  this.$root.$emit('isLogin', true);
                  $('.signup').modal('hide');
                  this.$router.push('/address');
                  // location.reload()
                  return false;
                } else {
                  this.$root.$emit('isLogin', true);
                  $('.signup').modal('hide');
                  // location.reload()
                }
              }
            }.bind(_this8)).catch(function (err) {
              console.error(err);
            });
          }
        }
      });
    },
    signup_resend: function signup_resend() {
      try {
        if (this.signup.email !== '') {
          var data = {
            'email': this.signup.email
          };
          promise_default.a.resolve(this.$POST('patient/resendOTP', data)).then(function (res) {
            if (res.response_code === 0) {
              this.signup.error = false;
              this.signup.errormsg = '';
              this.signup.success = true;
              this.signup.successmsg = 'We have resend an authentication code to your mail id.';
            } else {
              this.signup.success = false;
              this.signup.error = true;
              this.signup.errormsg = res.response_message;
              this.signup.otp = '';
            }
          }.bind(this)).catch(function (err) {
            console.log(err);
          });
        }
      } catch (e) {
        console.error(e);
      }
    },
    logout: function logout() {
      this.$clearLocalStorage();
      location.reload();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c9ecf562","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/web/Login.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"loginDiv"}},[_c('div',{ref:"loginModel",staticClass:"modal fade login-box",attrs:{"tabindex":"-1","role":"dialog","aria-labelledby":"mySmallModalLabel","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog modal-sm"},[_c('div',{staticClass:"modal-content"},[_vm._m(0,false,false),_vm._v(" "),_c('div',{staticClass:"modal-body"},[(_vm.login.error)?_c('p',{staticClass:"no-mar-top red-color"},[_vm._v(_vm._s(_vm.login.errormsg))]):_vm._e(),_vm._v(" "),(_vm.login.successmsg)?_c('p',{staticClass:"no-mar-top green-color"},[_vm._v(_vm._s(_vm.login.successmsg))]):_vm._e(),_vm._v(" "),(_vm.login.otp_send === 2)?_c('h4',{staticClass:"no-mar-top green-color"},[_vm._v(_vm._s(_vm.login.username))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-content line-textbox"},[_c('form',{directives:[{name:"show",rawName:"v-show",value:(_vm.login.otp_send === 1),expression:"login.otp_send === 1"}],attrs:{"data-vv-scope":"login"}},[(!_vm.login.login_with_otp)?_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.login.username),expression:"login.username"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],ref:"login_username",staticClass:"form-control",attrs:{"type":"text","name":"username","id":"username","data-vv-as":"email or mobile","placeholder":"Email or Mobile Number"},domProps:{"value":(_vm.login.username)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.login, "username", $event.target.value)}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('login.username')),expression:"errors.has('login.username')"}],staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('login.username')))])]):_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"mask",rawName:"v-mask",value:('##########'),expression:"'##########'"},{name:"model",rawName:"v-model",value:(_vm.login.username),expression:"login.username"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],ref:"login_username",staticClass:"form-control",attrs:{"type":"text","name":"username","id":"username","data-vv-as":"mobile","placeholder":"Mobile Number"},domProps:{"value":(_vm.login.username)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.login, "username", $event.target.value)}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('login.username')),expression:"errors.has('login.username')"}],staticClass:"text-danger"},[_vm._v("The mobile number field is required.")])]),_vm._v(" "),(!_vm.login.login_with_otp)?_c('div',{staticClass:"form-group  mb-2"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.login.password),expression:"login.password"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],ref:"login_password",staticClass:"form-control",attrs:{"type":"password","name":"password","id":"password","data-vv-as":"password","placeholder":"Password"},domProps:{"value":(_vm.login.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.login, "password", $event.target.value)}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('login.password')),expression:"errors.has('login.password')"}],staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('login.password')))])]):_c('div',{staticClass:"form-group  mb-2"},[_c('input',{staticClass:"form-control",attrs:{"type":"password","placeholder":"Password","disabled":""}})]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('a',{staticClass:"mb-3 text-center signup-link float-right display-block",attrs:{"data-dismiss":"modal","data-toggle":"modal","href":"#lost","data-target":".forgot","data-backdrop":"static","data-keyboard":"false"},on:{"click":function($event){_vm.clearFields()}}},[_vm._v("\n                                    Forgot Password?\n                                ")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-12 mb-3"},[_c('label',{staticClass:"checkbox_container"},[_vm._v("Login With OTP?\n                                  "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.login.login_with_otp),expression:"login.login_with_otp"}],ref:"login_with_otp",attrs:{"type":"checkbox","name":"login_with_otp","id":"login_with_otp","data-vv-as":"login_with_otp"},domProps:{"checked":Array.isArray(_vm.login.login_with_otp)?_vm._i(_vm.login.login_with_otp,null)>-1:(_vm.login.login_with_otp)},on:{"change":function($event){var $$a=_vm.login.login_with_otp,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.login.login_with_otp=$$a.concat([$$v]))}else{$$i>-1&&(_vm.login.login_with_otp=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.$set(_vm.login, "login_with_otp", $$c)}}}}),_vm._v(" "),_c('span',{staticClass:"checkbox_checkmark"})])])]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary full-width mar-b-15",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();_vm.loginClicked()}}},[_vm._v(_vm._s(!_vm.login.login_with_otp ? 'Login' : 'Send OTP'))]),_vm._v(" "),_c('div',{staticClass:"blue-border rounded p-2 text-center full-width f-14 mb-3"},[_vm._v("\n                              New User?\n                              "),_c('a',{staticClass:"blue-color",attrs:{"data-dismiss":"modal","data-toggle":"modal","href":"#lost","data-target":".signup","data-backdrop":"static","data-keyboard":"false"},on:{"click":function($event){_vm.clearFields(1)}}},[_vm._v("\n                                  Signup\n                              ")])])]),_vm._v(" "),_c('form',{directives:[{name:"show",rawName:"v-show",value:(_vm.login.otp_send === 2),expression:"login.otp_send === 2"}],attrs:{"data-vv-scope":"login-wt-otp"}},[_c('div',{staticClass:"form-group  mb-2"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.login.login_otp),expression:"login.login_otp"},{name:"mask",rawName:"v-mask",value:('##########'),expression:"'##########'"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],ref:"login_otp",staticClass:"form-control",attrs:{"type":"text","name":"login_otp","id":"login_otp","maxlength":"6","data-vv-as":"OTP","placeholder":"Enter your OTP"},domProps:{"value":(_vm.login.login_otp)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.login, "login_otp", $event.target.value)}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('login-wt-otp.login_otp')),expression:"errors.has('login-wt-otp.login_otp')"}],staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('login-wt-otp.login_otp')))])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('a',{staticClass:"mb-3 text-center signup-link blue-color",on:{"click":function($event){_vm.clearFields()}}},[_vm._v("\n                                    Back to Login?\n                                ")]),_vm._v(" "),_c('a',{staticClass:"mb-3 text-center signup-link float-right display-block resent_otp",on:{"click":function($event){_vm.loginWithOtpChanged(true)}}},[_vm._v("Resend OTP?")])])]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary full-width mar-b-15",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();_vm.verifyLoginOTP()}}},[_vm._v("Verify OTP")])]),_vm._v(" "),(_vm.otherSignup)?_c('div',[_c('p',[_vm._v("Or Login Using")]),_vm._v(" "),_vm._m(1,false,false)]):_vm._e()])])])])]),_vm._v(" "),_c('div',{staticClass:"modal fade signup",attrs:{"tabindex":"-1","role":"dialog","aria-labelledby":"mySmallModalLabel","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog modal-sm"},[_c('div',{staticClass:"modal-content"},[_vm._m(2,false,false),_vm._v(" "),_c('div',{staticClass:"modal-body pt-0"},[_c('p',{staticClass:"no-mar-top"},[_vm._v("Create an account on Labotist")]),_vm._v(" "),(_vm.signup.error)?_c('p',{staticClass:"no-mar-top red-color"},[_vm._v(_vm._s(_vm.signup.errormsg))]):_vm._e(),_vm._v(" "),(_vm.signup.success)?_c('p',{staticClass:"no-mar-top green-color"},[_vm._v(_vm._s(_vm.signup.successmsg))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-content line-textbox"},[_c('form',{directives:[{name:"show",rawName:"v-show",value:(!_vm.signup.success),expression:"!signup.success"}],attrs:{"data-vv-scope":"signup"}},[_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.signup.email),expression:"signup.email"},{name:"validate",rawName:"v-validate",value:('required|email|max:100'),expression:"'required|email|max:100'"}],ref:"signUpEmail",staticClass:"form-control",attrs:{"type":"email","name":"email","data-vv-as":"email address","maxlength":"100","placeholder":"Email address"},domProps:{"value":(_vm.signup.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.signup, "email", $event.target.value)}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('signup.email')),expression:"errors.has('signup.email')"}],staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('signup.email')))])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"mask",rawName:"v-mask",value:('##########'),expression:"'##########'"},{name:"model",rawName:"v-model",value:(_vm.signup.mobile),expression:"signup.mobile"},{name:"validate",rawName:"v-validate",value:('required|numeric|min:10|max:10'),expression:"'required|numeric|min:10|max:10'"}],ref:"signUpMobile",staticClass:"form-control",attrs:{"type":"text","name":"mobile","data-vv-as":"mobile no.","placeholder":"Mobile number"},domProps:{"value":(_vm.signup.mobile)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.signup, "mobile", $event.target.value)}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('signup.mobile')),expression:"errors.has('signup.mobile')"}],staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('signup.mobile')))])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.signup.firstName),expression:"signup.firstName"},{name:"validate",rawName:"v-validate",value:('required|alpha_spaces|max:50'),expression:"'required|alpha_spaces|max:50'"}],staticClass:"form-control",attrs:{"type":"text","name":"firstName","data-vv-as":"first name","maxlength":"50","placeholder":"Name"},domProps:{"value":(_vm.signup.firstName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.signup, "firstName", $event.target.value)}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('signup.firstName')),expression:"errors.has('signup.firstName')"}],staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('signup.firstName')))])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.signup.password),expression:"signup.password"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"form-control",attrs:{"type":"password","name":"password","data-vv-as":"password","placeholder":"Password"},domProps:{"value":(_vm.signup.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.signup, "password", $event.target.value)}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('signup.password')),expression:"errors.has('signup.password')"}],staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('signup.password')))])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.signup.referralCode),expression:"signup.referralCode"},{name:"validate",rawName:"v-validate",value:('alpha_num|max:8'),expression:"'alpha_num|max:8'"}],ref:"referralCode",staticClass:"form-control",attrs:{"type":"text","name":"referralCode","data-vv-as":"referralCode","placeholder":"Referral Code(Optional)","disabled":_vm.referralCodeDisable},domProps:{"value":(_vm.signup.referralCode)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.signup, "referralCode", $event.target.value)}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('signup.referralCode')),expression:"errors.has('signup.referralCode')"}],staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('signup.referralCode')))])]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary full-width",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();_vm.create_account()}}},[_vm._v("Continue")])]),_vm._v(" "),_c('form',{directives:[{name:"show",rawName:"v-show",value:(_vm.signup.success),expression:"signup.success"}],attrs:{"data-vv-scope":"signupOtp"}},[_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.signup.otp),expression:"signup.otp"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"form-control",attrs:{"type":"text","name":"sotp","data-vv-as":"signup otp","placeholder":"Enter OTP"},domProps:{"value":(_vm.signup.otp)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.signup, "otp", $event.target.value)}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('signupOtp.sotp')),expression:"errors.has('signupOtp.sotp')"}],staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('signupOtp.sotp')))])]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary full-width mar-b-15",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();_vm.signup_verify_otp()}}},[_vm._v("Verify")]),_vm._v(" "),_c('a',{staticClass:"text-center signup-link display-block",on:{"click":function($event){$event.preventDefault();_vm.signup_resend()}}},[_vm._v("Resend?")])]),_vm._v(" "),_c('a',{staticClass:"mar-t-15 text-center signup-link display-block",attrs:{"data-dismiss":"modal","data-toggle":"modal","href":"#lost","data-target":".login-box","data-backdrop":"static","data-keyboard":"false"},on:{"click":function($event){_vm.clearFields()}}},[_vm._v("Back to login?")]),_vm._v(" "),(_vm.otherSignup)?_c('div',[_c('p',[_vm._v("Or Signup Using")]),_vm._v(" "),_vm._m(3,false,false)]):_vm._e()])])])])]),_vm._v(" "),_c('div',{staticClass:"modal fade forgot",attrs:{"tabindex":"-1","role":"dialog","aria-labelledby":"mySmallModalLabel","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog modal-sm"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[(_vm.forgot.success === 1 || _vm.forgot.success === 2)?_c('h5',{staticClass:"modal-title",attrs:{"id":"exampleModalLabel"}},[_vm._v("Forgot Password")]):_vm._e(),_vm._v(" "),(_vm.forgot.success === 3)?_c('h5',{staticClass:"modal-title",attrs:{"id":"exampleModalLabel"}},[_vm._v("Change Password")]):_vm._e(),_vm._v(" "),_vm._m(4,false,false)]),_vm._v(" "),_c('div',{staticClass:"modal-body pt-0"},[(_vm.forgot.success === 1 || _vm.forgot.success === 2)?_c('p',{staticClass:"no-mar-top"},[_vm._v("Reset password through Email/Mobile")]):_vm._e(),_vm._v(" "),(_vm.forgot.success === 3)?_c('p',{staticClass:"no-mar-top"},[_vm._v("Reset your Password")]):_vm._e(),_vm._v(" "),(_vm.forgot.error)?_c('p',{staticClass:"no-mar-top red-color"},[_vm._v(_vm._s(_vm.forgot.errormsg))]):_vm._e(),_vm._v(" "),(_vm.forgot.success === 2)?_c('p',{staticClass:"no-mar-top green-color"},[_vm._v(_vm._s(_vm.forgot.successmsg))]):_vm._e(),_vm._v(" "),(_vm.forgot.success === 2)?_c('h4',{staticClass:"no-mar-top green-color"},[_vm._v(_vm._s(_vm.forgot.username))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-content line-textbox"},[_c('form',{directives:[{name:"show",rawName:"v-show",value:(_vm.forgot.success === 1),expression:"forgot.success === 1"}],attrs:{"data-vv-scope":"forgot"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-4"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.forgot.otpType),expression:"forgot.otpType"}],staticClass:"mr-3",attrs:{"type":"radio","name":"otp_type","id":"otp_type_email","value":"1"},domProps:{"checked":_vm._q(_vm.forgot.otpType,"1")},on:{"change":function($event){_vm.$set(_vm.forgot, "otpType", "1")}}}),_c('label',{attrs:{"for":"otp_type_email"}},[_vm._v("Email")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.forgot.otpType),expression:"forgot.otpType"}],staticClass:"mr-3",attrs:{"type":"radio","name":"otp_type","id":"otp_type_sms","value":"2"},domProps:{"checked":_vm._q(_vm.forgot.otpType,"2")},on:{"change":function($event){_vm.$set(_vm.forgot, "otpType", "2")}}}),_c('label',{attrs:{"for":"otp_type_sms"}},[_vm._v("Sms")])])]),_vm._v(" "),(_vm.forgot.otpType == 1)?_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.forgot.username),expression:"forgot.username"},{name:"validate",rawName:"v-validate",value:('required|email'),expression:"'required|email'"}],staticClass:"form-control",attrs:{"type":"email","name":"fusername","data-vv-as":"email address","placeholder":"Email Address"},domProps:{"value":(_vm.forgot.username)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.forgot, "username", $event.target.value)}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('forgot.fusername')),expression:"errors.has('forgot.fusername')"}],staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('forgot.fusername')))])]):_vm._e(),_vm._v(" "),(_vm.forgot.otpType == 2)?_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"mask",rawName:"v-mask",value:('##########'),expression:"'##########'"},{name:"model",rawName:"v-model",value:(_vm.forgot.username),expression:"forgot.username"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"form-control",attrs:{"type":"text","name":"fusername","data-vv-as":"email address","placeholder":"Mobile Number"},domProps:{"value":(_vm.forgot.username)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.forgot, "username", $event.target.value)}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('forgot.fusername')),expression:"errors.has('forgot.fusername')"}],staticClass:"text-danger"},[_vm._v("Mobile number field is required.")])]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn btn-primary full-width mt-3 mar-b-15",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();_vm.forgetPassword()}}},[_vm._v("Send")])]),_vm._v(" "),_c('form',{directives:[{name:"show",rawName:"v-show",value:(_vm.forgot.success === 2),expression:"forgot.success === 2"}],attrs:{"data-vv-scope":"forgotOtp"}},[_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"mask",rawName:"v-mask",value:('######'),expression:"'######'"},{name:"model",rawName:"v-model",value:(_vm.forgot.otp),expression:"forgot.otp"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"form-control",attrs:{"type":"text","name":"fotp","data-vv-as":"verify otp","placeholder":"Enter OTP"},domProps:{"value":(_vm.forgot.otp)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.forgot, "otp", $event.target.value)}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('forgotOtp.fotp')),expression:"errors.has('forgotOtp.fotp')"}],staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('forgotOtp.fotp')))])]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary full-width mar-b-15",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();_vm.verify_otp($event)}}},[_vm._v("Verify")]),_vm._v(" "),_c('a',{staticClass:"text-center signup-link display-block",on:{"click":function($event){_vm.resend()}}},[_vm._v("\n                                Resend?\n                            ")])]),_vm._v(" "),_c('form',{directives:[{name:"show",rawName:"v-show",value:(_vm.forgot.success === 3),expression:"forgot.success === 3"}],attrs:{"data-vv-scope":"resetPassword"}},[_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.forgot.newPassword),expression:"forgot.newPassword"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"form-control",attrs:{"type":"password","name":"newPassword","data-vv-as":"new password","placeholder":"New Password"},domProps:{"value":(_vm.forgot.newPassword)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.forgot, "newPassword", $event.target.value)}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('resetPassword.newPassword')),expression:"errors.has('resetPassword.newPassword')"}],staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('resetPassword.newPassword')))])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.forgot.confirmPassword),expression:"forgot.confirmPassword"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"form-control",attrs:{"type":"password","name":"confirmPassword","data-vv-as":"password","placeholder":"Confirm Password"},domProps:{"value":(_vm.forgot.confirmPassword)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.forgot, "confirmPassword", $event.target.value)}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('resetPassword.confirmPassword')),expression:"errors.has('resetPassword.confirmPassword')"}],staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('resetPassword.confirmPassword')))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.forgot.confirmPassword !== '' && _vm.forgot.newPassword != _vm.forgot.confirmPassword),expression:"forgot.confirmPassword !== '' && forgot.newPassword != forgot.confirmPassword"}],staticClass:"text-danger"},[_vm._v("Confirm password doesn't match")])]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary full-width mar-b-15",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();_vm.reset_password($event)}}},[_vm._v("Submit")])]),_vm._v(" "),_c('a',{staticClass:"mar-t-15 text-center signup-link display-block",attrs:{"data-dismiss":"modal","data-toggle":"modal","href":"#lost","data-target":".login-box","data-backdrop":"static","data-keyboard":"false"},on:{"click":function($event){_vm.clearFields()}}},[_vm._v("\n                            Back to login?\n                        ")])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal fade login-otp",attrs:{"tabindex":"-1","role":"dialog","aria-labelledby":"mySmallModalLabel","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog modal-sm"},[_c('div',{staticClass:"modal-content"},[_vm._m(5,false,false),_vm._v(" "),_c('div',{staticClass:"modal-body pt-0"},[_c('p',{staticClass:"no-mar-top"},[_vm._v("Login with otp")]),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],staticClass:"no-mar-top green-color"},[_vm._v("Welcome back")]),_vm._v(" "),_c('div',{staticClass:"form-content line-textbox"},[_vm._m(6,false,false),_vm._v(" "),_c('button',{staticClass:"btn btn-primary full-width mt-3 "},[_vm._v("Send")]),_vm._v(" "),_c('a',{staticClass:"mar-t-15 text-center signup-link display-block",attrs:{"data-dismiss":"modal","data-toggle":"modal","href":"#lost","data-target":".login-box","data-backdrop":"static","data-keyboard":"false"},on:{"click":function($event){_vm.clearFields()}}},[_vm._v("\n                            Continue to login?\n                        ")])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-header"},[_c('h5',{staticClass:"modal-title",attrs:{"id":"exampleModalLabel"}},[_vm._v("Login")]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('button',{staticClass:"btn full-width facebook-btn mar-b-15"},[_c('span',{staticClass:"fa fa-facebook-official"}),_vm._v(" Facebook\n                                    ")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('button',{staticClass:"btn full-width google-btn"},[_c('span',{staticClass:"fa fa-google-plus-square"}),_vm._v(" Google+\n                                    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-header"},[_c('h5',{staticClass:"modal-title",attrs:{"id":"exampleModalLabel"}},[_vm._v("Sign Up")]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('button',{staticClass:"btn full-width facebook-btn mar-b-15"},[_c('span',{staticClass:"fa fa-facebook-official"}),_vm._v(" Facebook\n                                    ")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('button',{staticClass:"btn full-width google-btn"},[_c('span',{staticClass:"fa fa-google-plus-square"}),_vm._v(" Google+\n                                    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-header"},[_c('h5',{staticClass:"modal-title",attrs:{"id":"exampleModalLabel"}},[_vm._v("Login with OTP")]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group"},[_c('input',{staticClass:"form-control",attrs:{"type":"text","placeholder":"Email Address/Mobile No."}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var web_Login = (esExports);
// CONCATENATED MODULE: ./src/components/web/Login.vue
function injectStyle (ssrContext) {
  __webpack_require__("ZrO4")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-c9ecf562"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  Login,
  web_Login,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_web_Login = (Component.exports);

// EXTERNAL MODULE: ./static/images/close-black.svg
var close_black = __webpack_require__("YZfp");
var close_black_default = /*#__PURE__*/__webpack_require__.n(close_black);

// EXTERNAL MODULE: ./node_modules/underscore/underscore.js
var underscore = __webpack_require__("rdLu");
var underscore_default = /*#__PURE__*/__webpack_require__.n(underscore);

// EXTERNAL MODULE: ./node_modules/dateformat/lib/dateformat.js
var dateformat = __webpack_require__("CqLJ");
var dateformat_default = /*#__PURE__*/__webpack_require__.n(dateformat);

// EXTERNAL MODULE: ./node_modules/jquery/dist/jquery.js
var jquery = __webpack_require__("7t+N");
var jquery_default = /*#__PURE__*/__webpack_require__.n(jquery);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/web/Header.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ var Header = ({
  name: 'HeaderVue',
  props: ['step', 'tab', 'isHealthCartEnabled'],
  components: {
    Login: components_web_Login
  },
  data: function data() {
    return {
      loggedin_username: '',
      locality: undefined,
      lab: undefined,
      selectedProfileAndTest: undefined,
      selectedDatetime: undefined,
      closeImg: close_black_default.a,
      testCosts: [],
      cartCount: 0,
      payinfo: {},
      profile: undefined,
      cartDispaly: false
    };
  },

  mounted: function mounted() {
    var _this = this;

    this.$root.$on('selectedProfileAndTest', function (selectedProfileAndTest) {
      _this.selectedProfileAndTest = selectedProfileAndTest;
      _this.cartCount = selectedProfileAndTest.length;
      _this.refreshContent();
    });
    this.$root.$on('profileUpdated', function (profileUpdateStatus) {
      _this.profile = _this.$localStorage.get('profile');
    });
    this.$root.$on('bookTest', function (bookTest) {
      location.reload();
    });
    this.$root.$on('isLogin', function (isLoggin) {
      _this.refreshContent();
    });
    jquery_default()('body').click(function (e) {
      if (e.target.id === 'HealthCartDropDownClicks' || jquery_default()(e.target).parents('#HealthCartDropDownClicks').length) {
        this.cartDispaly = true;
      } else {
        this.cartDispaly = false;
      }
    }.bind(this));
  },
  created: function created() {
    if (this.$route.fullPath === '/login') {
      //   this.$localStorage.remove('profile')
    }
    if (this.$localStorage.get('profile')) {
      this.loggedin_username = this.$localStorage.get('profile').username;
    }
    this.locality = this.$localStorage.get('location');
    this.lab = this.$localStorage.get('sl');
    this.selectedProfileAndTest = this.$localStorage.get('st');
    this.selectedDatetime = this.$localStorage.get('ct');
    this.profile = this.$localStorage.get('profile');
    this.cartCount = this.selectedProfileAndTest ? this.selectedProfileAndTest.length : 0;
    if (this.lab) {
      this.getTestCosts();
    }
    if (this.$route.fullPath !== '/' && this.$route.fullPath !== '/login') {
      setTimeout(function () {
        var footerHeight = jquery_default()('#footerDiv').outerHeight();
        jquery_default()('body').css('margin-bottom', footerHeight);
      }, 100);
    }
  },

  methods: {
    goToProfile: function goToProfile() {
      this.$router.push('/myprofile');
    },
    loginClicked: function loginClicked() {
      vue_esm["default"].analytics.fbq.event('ViewContent', {
        content_ids: 0,
        content_name: 'LOGIN CLICKED',
        contents: '',
        content_type: 'LOGIN_CLICK'
      });
      this.$root.$emit('loginClicked', true);
    },
    proccedtoHealthCart: function proccedtoHealthCart() {
      this.$localStorage.remove('ct');
      this.$localStorage.remove('sa');
      this.$localStorage.remove('sm');
      this.$localStorage.remove('cou');
      this.$router.push('/appointment');
    },
    openHealthCart: function openHealthCart() {
      this.cartDispaly = true;
    },
    logout: function logout() {
      this.profile = undefined;
      this.$clearLocalStorageForLogout();
      //   this.$clientTokenForLogout()
      setTimeout(function () {
        this.refreshContent();
        location.reload();
      }.bind(this), 300);
    },
    getTestCosts: function getTestCosts(lab) {
      try {
        var labTestCosts = [];
        if (this.lab) {
          if (this.lab.labTestList.length > 0) {
            underscore_default.a.each(this.lab.labTestList, function (element) {
              labTestCosts.push(element.labProfileId);
            });
          }
        }
        if (labTestCosts.length === 0) {
          //   this.$router.push('/test')
          this.$router.push('/lab');
        }
        var data = {
          'labId': this.lab ? this.lab.labId : '0',
          'labTests': labTestCosts
        };
        promise_default.a.resolve(this.$POST('patient/getTestCosts', data)).then(function (res) {
          if (res.response_code === 0) {
            if (res.response) {
              this.testCosts = res.response;
              this.payinfo.mrpTotal = res.response.mrp;
              this.payinfo.phlebotomistFee = this.$phlebotomistFee;
              this.payinfo.subTotal = this.payinfo.mrpTotal + this.payinfo.phlebotomistFee;
              this.payinfo.labDiscount = res.response.youSaved;
              this.payinfo.phlebotomyFeeWaiver = this.payinfo.mrpTotal - this.payinfo.labDiscount > this.$waiverDiscountApplyFee ? this.$phlebotomyFeeWaiver : 0;
              this.payinfo.total = this.payinfo.subTotal - (this.payinfo.labDiscount + this.payinfo.phlebotomyFeeWaiver);
              this.payinfo.gst = Math.round(this.payinfo.total * this.$GSTFee / 100);
              this.payinfo.grandTotal = this.payinfo.total + this.payinfo.gst;
            }
          }
        }.bind(this)).catch(function (err) {
          console.error(err);
        });
      } catch (e) {
        console.log(e);
      }
    },
    removeSelectedItems: function removeSelectedItems(items) {
      this.$localStorage.remove('st');
      this.$localStorage.remove('cou');
      var index = this.selectedProfileAndTest.indexOf(items);
      this.selectedProfileAndTest.splice(index, 1);
      this.$localStorage.set('st', this.selectedProfileAndTest, 0);
      this.cartCount = this.selectedProfileAndTest ? this.selectedProfileAndTest.length : 0;
      if (this.selectedProfileAndTest.length === 0) {
        this.$localStorage.remove('sl');
        this.$localStorage.remove('ct');
        this.lab = undefined;
        this.testCosts = [];
        // this.$router.push('/test')
        this.$router.push('/lab');
      }
      this.$root.$emit('removeProfileAndTest', this.selectedProfileAndTest);
    },
    removeSelectedItemsInLab: function removeSelectedItemsInLab(items) {
      this.$localStorage.remove('cou');
      this.$localStorage.remove('st');
      this.$localStorage.remove('ct');
      var tests = {};
      this.selectedProfileAndTest.forEach(function (item) {
        if (items.testId === item.testId && item.testId !== 0 || items.panelId === item.panelId && item.panelId !== 0) {
          tests = item;
        }
      });
      var labTests = [];
      this.lab.labTestList.forEach(function (labTest) {
        if (!(items.testId === labTest.testId && labTest.testId !== 0 || items.panelId === labTest.panelId && labTest.panelId !== 0)) {
          labTests.push(labTest);
        }
      });
      this.$localStorage.remove('sl');
      this.lab.labTestList = labTests;
      this.$localStorage.set('sl', this.lab, 30 * 60 * 1000);
      this.selectedDatetime = undefined;
      var index = this.selectedProfileAndTest.indexOf(tests);
      this.selectedProfileAndTest.splice(index, 1);
      this.$localStorage.set('st', this.selectedProfileAndTest, 0);
      this.cartCount = this.selectedProfileAndTest ? this.selectedProfileAndTest.length : 0;
      if (this.selectedProfileAndTest.length === 0) {
        this.$localStorage.remove('sl');
        this.$localStorage.remove('ct');
        this.lab = undefined;
        this.testCosts = [];
        // this.$router.push('/test')
        this.$router.push('/lab');
      }
      this.$root.$emit('removeProfileAndTest', this.selectedProfileAndTest);
      this.getTestCosts();
    },
    refreshContent: function refreshContent() {
      this.profile = this.$localStorage.get('profile');
      this.locality = this.$localStorage.get('location');
      this.lab = this.$localStorage.get('sl');
      this.selectedProfileAndTest = this.$localStorage.get('st');
      this.selectedDatetime = this.$localStorage.get('ct');
      this.cartCount = this.selectedProfileAndTest ? this.selectedProfileAndTest.length : 0;
      if (this.lab) {
        this.getTestCosts();
      }
    },
    formatDate: function formatDate(date, format) {
      return dateformat_default()(date, format, true);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b25e7ed2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/web/Header.vue
var Header_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"headerDiv"}},[_vm._m(0,false,false),_vm._v(" "),_c('header',[(!(_vm.step))?_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"logo"},[_c('router-link',{attrs:{"to":"/"}},[_c('img',{staticClass:"img-fluid",attrs:{"src":"static/images/logo-svg.svg","alt":""}})])],1)]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('ul',{staticClass:"text-center top-menu float-sm-right"},[(_vm.profile)?_c('li',[_c('div',{staticClass:"book-tr",on:{"click":function($event){_vm.goToProfile()}}},[_vm._m(1,false,false),_vm._v(" "),_c('h3',{staticClass:"your-credit-header-2"},[_vm._v("Rs "+_vm._s(_vm.profile.credits)+" ")])])]):_vm._e(),_vm._v(" "),(_vm.$route.fullPath === '/' || _vm.$route.fullPath === '/login')?_c('li',[_c('router-link',{attrs:{"to":"/lab"}},[_c('span',{staticClass:"sprites sprite-flask"}),_vm._v("Book Test\n                          ")])],1):_vm._e(),_vm._v(" "),(!(_vm.profile) || _vm.profile === false || _vm.profile === null)?_c('li',[_c('a',{attrs:{"href":"#","data-toggle":"modal","data-target":".login-box","data-backdrop":"static","data-keyboard":"false"},on:{"click":function($event){_vm.loginClicked()}}},[_c('span',{staticClass:"sprites sprite-login"}),_vm._v("\n                                Login/ Sign Up\n                            ")])]):_c('li',[_c('a',{attrs:{"href":"#","data-toggle":"dropdown","aria-haspopup":"true","aria-expanded":"false"}},[_c('span',{staticClass:"sprites sprite-login"}),_vm._v(" "),_c('span',{staticClass:"text-eclipse"},[_vm._v(" Hi, "+_vm._s(_vm.profile.firstName))]),_vm._v(" "),_c('div',{staticClass:"dropdown-menu dropdown-menu-right",attrs:{"aria-labelledby":"dropdownMenuButton"}},[_c('router-link',{staticClass:"dropdown-item",attrs:{"to":"/myprofile"}},[_vm._v("My Profile")]),_vm._v(" "),_c('router-link',{staticClass:"dropdown-item",attrs:{"to":"/referral/invite"}},[_vm._v("Refer & Earn")]),_vm._v(" "),_c('router-link',{staticClass:"dropdown-item",attrs:{"to":"/myresult"}},[_vm._v("My Result")]),_vm._v(" "),_c('a',{staticClass:"dropdown-item red",on:{"click":function($event){_vm.logout()}}},[_vm._v("Log Out")])],1)])]),_vm._v(" "),(_vm.cartCount <= 0 && !_vm.isHealthCartEnabled)?_c('li',{staticClass:"dropdown"},[_c('router-link',{attrs:{"to":"/lab","id":"dropdownMenu2","data-toggle":"dropdown"}},[_c('span',[_c('span',{staticClass:"sprites sprite-care"}),_vm._v(" "),_c('span',[_vm._v("Health Cart")]),_vm._v(" "),(_vm.cartCount > 0)?_c('span',{staticClass:"count-cart"},[_vm._v(_vm._s(_vm.cartCount))]):_vm._e()])])],1):_vm._e(),_vm._v(" "),(_vm.cartCount > 0 && !_vm.isHealthCartEnabled)?_c('li',{staticClass:"dropdown",attrs:{"id":"HealthCartDropDownClicks"}},[_c('a',{attrs:{"id":"dropdownMenu2"},on:{"click":function($event){_vm.openHealthCart()}}},[_c('span',[_c('span',{staticClass:"sprites sprite-care"}),_vm._v(" "),_c('span',[_vm._v("Health Cart")]),_vm._v(" "),(_vm.cartCount > 0)?_c('span',{staticClass:"count-cart"},[_vm._v(_vm._s(_vm.cartCount))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"dropdown-menu dropdown-menu-right caret-up top-cart p-0 healthCartDropdown",class:_vm.cartDispaly ? 'show' : '',attrs:{"aria-labelledby":"dropdownMenu2"}},[(_vm.selectedProfileAndTest && _vm.selectedProfileAndTest.length > 0)?_c('div',[(_vm.lab && _vm.testCosts)?_c('div',[(_vm.selectedProfileAndTest && _vm.selectedProfileAndTest.length > 0)?_c('div',{staticClass:"alert alert-success mb-0 drop-shadow"},[_vm._v("\n                                            Test(s) and/or Panel(s) and Lab added to health cart\n                                        ")]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.lab && _vm.testCosts)?_c('div',{staticClass:"lab display-flex no-border p-3 mt-2 mb-0"},[_c('div',{staticClass:"flex-box"},[_c('div',{staticClass:"lab-logo"},[(_vm.lab.logo && _vm.lab.logo.length > 0)?_c('img',{attrs:{"src":_vm.lab.logo}}):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"flex-box"},[_c('h6',{staticClass:"black-color"},[_vm._v(_vm._s(_vm.lab.labName))]),_vm._v(" "),_c('p',{staticClass:"mt-0 mb-1 grey-color"},[_vm._v(_vm._s(_vm.lab.branch.branchLocation+', '+_vm.lab.branch.branchCity+' - '+_vm.lab.branch.branchZipCode))]),_vm._v(" "),_c('router-link',{staticClass:"text-uppercase mt-2 blue-color",attrs:{"to":"/lab"}},[_vm._v("Change Lab")])],1)]):_vm._e(),_vm._v(" "),(_vm.lab && _vm.testCosts && _vm.testCosts.priceDetails && _vm.testCosts.priceDetails.length > 0)?_c('div',{staticClass:"table-responsive test-conformation p-3"},[_c('table',{staticClass:"table"},[_c('tbody',{staticClass:"black-color health-cart"},_vm._l((_vm.testCosts.priceDetails),function(testProfile,index){return _c('tr',{key:index},[_c('td',[_vm._v(_vm._s(testProfile.aliasName))]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_c('h5',{staticClass:"float-right mt-1 mb-0 price-tags "},[(parseInt(testProfile.actualPrice) > parseInt(testProfile.ourPrice))?_c('span',{staticClass:"red-color strip-text"},[_vm._v("Rs. "+_vm._s(testProfile.actualPrice))]):_vm._e()])]),_vm._v(" "),_c('td',{staticClass:"text-right "},[_c('h5',{staticClass:"float-right mt-1 mb-0 price-tags "},[_vm._v("\n                                                            Rs. "+_vm._s(testProfile.ourPrice)+"\n                                                        ")])]),_vm._v(" "),_c('td',[_c('button',{staticClass:"btn btn-link remove-btn p-0",on:{"click":function($event){$event.preventDefault();_vm.removeSelectedItemsInLab(testProfile)}}},[_c('img',{attrs:{"src":_vm.closeImg,"alt":""}})])])])})),_vm._v(" "),_c('tfoot',{staticClass:"border-bottom"},[_c('tr',[_c('td',{staticClass:"grey-color",attrs:{"colspan":"2"}},[_vm._v("Sub Total")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_c('h5',{staticClass:"float-right mt-1 mb-0 price-tags "},[_vm._v("\n                                                            Rs. "+_vm._s(_vm.testCosts.ourPrice)+"\n                                                        ")])]),_vm._v(" "),_c('td')])])])]):_vm._e(),_vm._v(" "),(!_vm.lab && _vm.selectedProfileAndTest)?_c('div',[(_vm.selectedProfileAndTest && _vm.selectedProfileAndTest.length > 0)?_c('div',{staticClass:"alert alert-success mb-0 drop-shadow"},[_vm._m(2,false,false),_vm._v(" Test(s) and/or Panel(s) added to health cart\n                                        ")]):_vm._e()]):_vm._e(),_vm._v(" "),(!_vm.lab && _vm.selectedProfileAndTest)?_c('div',{staticClass:"table-responsive test-conformation p-3",attrs:{"id":"healthCartTestTable"}},[_c('table',{staticClass:"table"},[_c('tbody',{staticClass:"black-color"},_vm._l((_vm.selectedProfileAndTest),function(testProfile,index){return _c('tr',{key:index,staticClass:"border-bottom"},[_c('td',{staticClass:"text-left"},[_vm._v(_vm._s(testProfile.name))]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_c('button',{staticClass:"btn btn-link remove-btn p-0",on:{"click":function($event){$event.preventDefault();_vm.removeSelectedItems(testProfile)}}},[_c('img',{attrs:{"src":_vm.closeImg,"alt":""}})])])])}))])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row p-0 m-0 mb-3"},[_c('div',{staticClass:"col-sm-3"}),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('router-link',{attrs:{"to":"/lab"}},[_c('button',{staticClass:"btn btn-link full-width text-uppercase"},[_vm._v("Add Test")])])],1),_vm._v(" "),(!_vm.lab)?_c('div',{staticClass:"col-sm-6"},[_c('router-link',{attrs:{"to":"/lab"}},[_c('button',{staticClass:"btn btn-primary full-width text-uppercase"},[_vm._v("Select Lab")])])],1):_vm._e(),_vm._v(" "),(_vm.lab)?_c('div',{staticClass:"col-sm-6"},[_c('button',{staticClass:"btn btn-primary full-width text-uppercase",on:{"click":function($event){_vm.proccedtoHealthCart()}}},[_vm._v("Proceed to health cart")])]):_vm._e()])]):_vm._e()])]):_vm._e()])])])]):_vm._e(),_vm._v(" "),((_vm.step))?_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-5"},[_c('div',{staticClass:"logo"},[_c('router-link',{attrs:{"to":"/"}},[_c('img',{staticClass:"img-fluid",attrs:{"src":"static/images/logo-svg.svg","alt":""}})])],1)]),_vm._v(" "),_c('div',{staticClass:"col-sm-5"},[_c('ul',{staticClass:"stepper"},[_c('li',{class:{'active': (_vm.tab=='health')}},[_vm._v("\n                            Health Cart\n                        ")]),_vm._v(" "),_vm._m(3,false,false),_vm._v(" "),_c('li',{class:{'active': (_vm.tab=='patient')}},[_vm._v("\n                            Patient Details & Pay\n                        ")])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-2"},[(!_vm.profile || _vm.profile === 'false' || _vm.profile === null)?_c('a',{staticClass:"float-right mt-4 user-text",attrs:{"href":"#","data-toggle":"modal","data-target":".login-box","data-backdrop":"static","data-keyboard":"false"},on:{"click":function($event){_vm.loginClicked()}}},[_vm._v("Login/ Sign Up")]):_c('div',{staticClass:"dropdown"},[_c('a',{staticClass:"float-right mt-4 user-text dropdown-toggle",attrs:{"href":"#","id":"dropdownMenuButton","data-toggle":"dropdown","aria-haspopup":"true","aria-expanded":"false"}},[_vm._v("Hi, "+_vm._s(_vm.profile.firstName))]),_vm._v(" "),_c('div',{staticClass:"dropdown-menu dropdown-menu-right",attrs:{"aria-labelledby":"dropdownMenuButton"}},[_c('router-link',{staticClass:"dropdown-item",attrs:{"to":"/myprofile"}},[_vm._v("My Profile")]),_vm._v(" "),_c('router-link',{staticClass:"dropdown-item",attrs:{"to":"/myprofile"}},[_vm._v("Refer & Earn")]),_vm._v(" "),_c('router-link',{staticClass:"dropdown-item",attrs:{"to":"/myresult"}},[_vm._v("My Result")]),_vm._v(" "),_c('a',{staticClass:"dropdown-item red",on:{"click":function($event){_vm.logout()}}},[_vm._v("Log Out")])],1)])])])]):_vm._e(),_vm._v(" "),_c('Login')],1)])}
var Header_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading"},[_c('div',{staticClass:"loading-img"},[_c('img',{attrs:{"src":"static/images/walk.gif","alt":""}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h4',{staticClass:"your-credit-header-1"},[_c('b',[_vm._v("Your Credit")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('strong',[_c('i',{staticClass:"material-icons float-left mr-2"},[_vm._v("check")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',[_c('i',{staticClass:"material-icons grey-color"},[_vm._v("keyboard_arrow_right")])])}]
var Header_esExports = { render: Header_render, staticRenderFns: Header_staticRenderFns }
/* harmony default export */ var web_Header = (Header_esExports);
// CONCATENATED MODULE: ./src/components/web/Header.vue
function Header_injectStyle (ssrContext) {
  __webpack_require__("TL0T")
}
var Header_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var Header___vue_template_functional__ = false
/* styles */
var Header___vue_styles__ = Header_injectStyle
/* scopeId */
var Header___vue_scopeId__ = "data-v-b25e7ed2"
/* moduleIdentifier (server only) */
var Header___vue_module_identifier__ = null
var Header_Component = Header_normalizeComponent(
  Header,
  web_Header,
  Header___vue_template_functional__,
  Header___vue_styles__,
  Header___vue_scopeId__,
  Header___vue_module_identifier__
)

/* harmony default export */ var components_web_Header = __webpack_exports__["a"] = (Header_Component.exports);


/***/ }),

/***/ "tJme":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uTOX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/promise.js
var promise = __webpack_require__("//Fk");
var promise_default = /*#__PURE__*/__webpack_require__.n(promise);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/web/Footer.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var Footer = ({
  name: 'FooterVue',
  beforeCreate: function beforeCreate() {},
  data: function data() {
    return {
      newsLetterEmail: ''
    };
  },

  methods: {
    saveNewsLetter: function saveNewsLetter() {
      var _this = this;

      this.$validator.validateAll('newsletter').then(function (result) {
        if (result) {
          try {
            var data = {
              email: _this.newsLetterEmail
            };
            promise_default.a.resolve(_this.$POST('patient/newsSubscriber', data)).then(function (res) {
              if (res.response_code === 0) {
                this.$Simplert.open({
                  title: 'Success',
                  message: 'Thanks for signup newsletter',
                  type: 'success',
                  disableOverlayClick: true,
                  showXclose: true,
                  useConfirmBtn: false
                });
                // alert('Thanks for signup newsletter')
              } else {
                this.$Simplert.open({
                  message: res.response_message,
                  type: 'success',
                  disableOverlayClick: true,
                  showXclose: true,
                  useConfirmBtn: false
                });
              }
            }.bind(_this)).catch(function (err) {
              console.error(err);
            });
          } catch (e) {
            console.error(e);
          }
        }
      }).catch(function () {
        console.log('error exist while save news letter', _this.errors);
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f4c346b6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/web/Footer.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"footerDiv"}},[_c('div',{staticClass:"grey-section"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-3"},[_c('p',[_vm._v("ABOUT LABOTIST")]),_vm._v(" "),_c('ul',[_c('li',[_c('router-link',{attrs:{"to":"/about-us"}},[_vm._v("About Us ")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/contact-us"}},[_vm._v("Contact Us")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/privacy-policy"}},[_vm._v("Privacy Policy")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/terms"}},[_vm._v("Terms & Conditions")])],1)])]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('p',[_vm._v("JOIN US")]),_vm._v(" "),_c('ul',[_c('li',[_c('router-link',{attrs:{"to":"/lab-signup"}},[_vm._v("Lab Sign Up")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/phlebotomist-signup"}},[_vm._v("Phlebotomist Sign Up")])],1)])]),_vm._v(" "),_vm._m(0,false,false),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('p',[_vm._v("Newsletter Sign Up")]),_vm._v(" "),_c('div',{staticClass:"subscribe"},[_c('form',{attrs:{"data-vv-scope":"newsletter"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.newsLetterEmail),expression:"newsLetterEmail"},{name:"validate",rawName:"v-validate",value:('required|email|max:200'),expression:"'required|email|max:200'"}],staticClass:"form-control",attrs:{"type":"email","name":"email","data-vv-as":"email address","placeholder":"Enter your email address"},domProps:{"value":(_vm.newsLetterEmail)},on:{"input":function($event){if($event.target.composing){ return; }_vm.newsLetterEmail=$event.target.value}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('newsletter.email')),expression:"errors.has('newsletter.email')"}],staticClass:"help is-danger"},[_vm._v(_vm._s(_vm.errors.first('newsletter.email')))]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",attrs:{"disabled":_vm.errors.has('newsletter.email')},on:{"click":function($event){$event.preventDefault();_vm.saveNewsLetter()}}},[_vm._v("SUBSCRIBE")])])])])])])]),_vm._v(" "),_vm._m(1,false,false)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-3"},[_c('p',[_vm._v("FOLLOW US")]),_vm._v(" "),_c('ul',{staticClass:"social-link"},[_c('li',[_c('a',{attrs:{"href":"https://www.facebook.com/labotist","onclick":"window.open(this.href); return false;","onkeypress":"window.open(this.href); return false;"}},[_c('span',{staticClass:"sprites sprite-facebook"})])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"https://twitter.com/labotist","onclick":"window.open(this.href); return false;","onkeypress":"window.open(this.href); return false;"}},[_c('span',{staticClass:"sprites sprite-twitter"})])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"https://www.instagram.com/labotist/?hl=en","onclick":"window.open(this.href); return false;","onkeypress":"window.open(this.href); return false;"}},[_c('span',{staticClass:"sprites sprite-instagram"})])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"copy-right text-center"},[_c('p',[_vm._v("2017 labotist . All rights reserved.")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var web_Footer = (esExports);
// CONCATENATED MODULE: ./src/components/web/Footer.vue
function injectStyle (ssrContext) {
  __webpack_require__("YA2l")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-f4c346b6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  Footer,
  web_Footer,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_web_Footer = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "v1jw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "vcnv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "w+9O":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xKcD":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "yst5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "z4O+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "zzoE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.b44a75f86a30e6b388e4.js